import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
  HTML: any;
  JSON: any;
}

/** List of accordions with title */
export interface IAccordions extends IElement {
  __typename?: 'Accordions';
  accordions?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  title?: Maybe<Scalars['String']>;
}

export interface IAdvantage extends IElement {
  __typename?: 'Advantage';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  image?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
}

export interface IAdvantagesList extends IElement {
  __typename?: 'AdvantagesList';
  advantages?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  template?: Maybe<Scalars['String']>;
}

/** Article for CGV */
export interface IArticle extends IElement {
  __typename?: 'Article';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface IArtistService extends IContent, ICoverVideoCmp, IElement {
  __typename?: 'ArtistService';
  /** The ancestors. */
  ancestors: IContentConnection;
  button?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pageBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IArtistServiceAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IArtistServiceButtonArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IArtistServiceDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IArtistServiceNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServicePageBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ArtistService`. */
export interface IArtistServiceConnection {
  __typename?: 'ArtistServiceConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IArtistServiceEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IArtistService>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ArtistService`. */
export interface IArtistServiceEdge {
  __typename?: 'ArtistServiceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IArtistService>;
}

/** A filter input for the type `ArtistService`. */
export interface IArtistServiceFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IArtistServiceFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IArtistServiceFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IArtistServiceFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

export interface IArtistServiceFolder extends IContent, IElement {
  __typename?: 'ArtistServiceFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IArtistServiceFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IArtistServiceFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IArtistServiceFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IArtistServiceFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IArtistServiceFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ArtistServiceFolder`. */
export interface IArtistServiceFolderConnection {
  __typename?: 'ArtistServiceFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IArtistServiceFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IArtistServiceFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ArtistServiceFolder`. */
export interface IArtistServiceFolderEdge {
  __typename?: 'ArtistServiceFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IArtistServiceFolder>;
}

/** A filter input for the type `ArtistServiceFolder`. */
export interface IArtistServiceFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IArtistServiceFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IArtistServiceFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IArtistServiceFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ArtistServiceFolder`. */
export enum IArtistServiceFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `ArtistService`. */
export enum IArtistServiceOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Artist Services Page */
export interface IArtistServicesPage extends IContent, ICoverVideoCmp, IElement {
  __typename?: 'ArtistServicesPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  button?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pageBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  services?: Maybe<Array<Maybe<IContent>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** Artist Services Page */
export interface IArtistServicesPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Artist Services Page */
export interface IArtistServicesPageButtonArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Artist Services Page */
export interface IArtistServicesPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Artist Services Page */
export interface IArtistServicesPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Artist Services Page */
export interface IArtistServicesPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Artist Services Page */
export interface IArtistServicesPagePageBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Artist Services Page */
export interface IArtistServicesPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Artist Services Page */
export interface IArtistServicesPageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Artist Services Page */
export interface IArtistServicesPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Artist Services Page */
export interface IArtistServicesPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Artist Services Page */
export interface IArtistServicesPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ArtistServicesPage`. */
export interface IArtistServicesPageConnection {
  __typename?: 'ArtistServicesPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IArtistServicesPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IArtistServicesPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ArtistServicesPage`. */
export interface IArtistServicesPageEdge {
  __typename?: 'ArtistServicesPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IArtistServicesPage>;
}

/** A filter input for the type `ArtistServicesPage`. */
export interface IArtistServicesPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IArtistServicesPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IArtistServicesPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IArtistServicesPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  services_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  services_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ArtistServicesPage`. */
export enum IArtistServicesPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IAuthor extends IElement {
  __typename?: 'Author';
  /** authorDescription */
  authorDescription?: Maybe<Scalars['String']>;
  authorImage?: Maybe<IMediaWithCrops>;
  authorName?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  role?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export interface IAwardCategoryPage extends IContent, IElement {
  __typename?: 'AwardCategoryPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** can be different from the category name. Will be used for decoration */
  categTitle?: Maybe<Scalars['String']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  footerBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  menu?: Maybe<IContent>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * first will be blank
   * second will be highlighted
   */
  title?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  urlRewrite?: Maybe<Scalars['String']>;
}


export interface IAwardCategoryPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardCategoryPageCategTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardCategoryPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardCategoryPageDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageFooterBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageMetaDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageMetaTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardCategoryPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `AwardCategoryPage`. */
export interface IAwardCategoryPageConnection {
  __typename?: 'AwardCategoryPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IAwardCategoryPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IAwardCategoryPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `AwardCategoryPage`. */
export interface IAwardCategoryPageEdge {
  __typename?: 'AwardCategoryPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IAwardCategoryPage>;
}

/** A filter input for the type `AwardCategoryPage`. */
export interface IAwardCategoryPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IAwardCategoryPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IAwardCategoryPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IAwardCategoryPageFilterInput>>>;
  /** Field must equal value. */
  categTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  categTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  categTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  categTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  categTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  menu?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  metaDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  metaDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  metaDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  metaDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  metaDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  metaTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  metaTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  metaTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  metaTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  metaTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  subtitle_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  subtitle_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match all of the values. */
  title_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  title_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  urlRewrite?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  urlRewrite_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  urlRewrite_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  urlRewrite_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  urlRewrite_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `AwardCategoryPage`. */
export enum IAwardCategoryPageOrderByInput {
  /** Order by `categTitle` in ascending order. */
  CategTitleAsc = 'categTitle_ASC',
  /** Order by `categTitle` in descending order. */
  CategTitleDesc = 'categTitle_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `menu` in ascending order. */
  MenuAsc = 'menu_ASC',
  /** Order by `menu` in descending order. */
  MenuDesc = 'menu_DESC',
  /** Order by `metaDescription` in ascending order. */
  MetaDescriptionAsc = 'metaDescription_ASC',
  /** Order by `metaDescription` in descending order. */
  MetaDescriptionDesc = 'metaDescription_DESC',
  /** Order by `metaTitle` in ascending order. */
  MetaTitleAsc = 'metaTitle_ASC',
  /** Order by `metaTitle` in descending order. */
  MetaTitleDesc = 'metaTitle_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `urlRewrite` in ascending order. */
  UrlRewriteAsc = 'urlRewrite_ASC',
  /** Order by `urlRewrite` in descending order. */
  UrlRewriteDesc = 'urlRewrite_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IAwardsArtist extends IContent, IElement {
  __typename?: 'AwardsArtist';
  /** The ancestors. */
  ancestors: IContentConnection;
  button?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** ID used to identify vote in the export */
  exportID?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IAwardsArtistAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsArtistButtonArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsArtistChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsArtistDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsArtistDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsArtistNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsArtistParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsArtistSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsArtistTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsArtistUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsArtistUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `AwardsArtist`. */
export interface IAwardsArtistConnection {
  __typename?: 'AwardsArtistConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IAwardsArtistEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IAwardsArtist>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `AwardsArtist`. */
export interface IAwardsArtistEdge {
  __typename?: 'AwardsArtistEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IAwardsArtist>;
}

/** A filter input for the type `AwardsArtist`. */
export interface IAwardsArtistFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IAwardsArtistFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IAwardsArtistFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IAwardsArtistFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  exportID?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  exportID_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  exportID_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  exportID_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  exportID_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `AwardsArtist`. */
export enum IAwardsArtistOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `exportID` in ascending order. */
  ExportIdAsc = 'exportID_ASC',
  /** Order by `exportID` in descending order. */
  ExportIdDesc = 'exportID_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IAwardsCategoryMenu extends IContent, IElement {
  __typename?: 'AwardsCategoryMenu';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  menu?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `AwardsCategoryMenu`. */
export interface IAwardsCategoryMenuConnection {
  __typename?: 'AwardsCategoryMenuConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IAwardsCategoryMenuEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IAwardsCategoryMenu>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

export interface IAwardsCategoryMenuDev extends IContent, IElement {
  __typename?: 'AwardsCategoryMenuDev';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  menu?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuDevAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuDevChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuDevDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuDevMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuDevNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuDevParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuDevTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuDevUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuDevUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `AwardsCategoryMenuDev`. */
export interface IAwardsCategoryMenuDevConnection {
  __typename?: 'AwardsCategoryMenuDevConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IAwardsCategoryMenuDevEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IAwardsCategoryMenuDev>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `AwardsCategoryMenuDev`. */
export interface IAwardsCategoryMenuDevEdge {
  __typename?: 'AwardsCategoryMenuDevEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IAwardsCategoryMenuDev>;
}

/** A filter input for the type `AwardsCategoryMenuDev`. */
export interface IAwardsCategoryMenuDevFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuDevFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuDevFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuDevFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `AwardsCategoryMenuDev`. */
export enum IAwardsCategoryMenuDevOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An edge in a connection from an object to another object of type `AwardsCategoryMenu`. */
export interface IAwardsCategoryMenuEdge {
  __typename?: 'AwardsCategoryMenuEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IAwardsCategoryMenu>;
}

/** A filter input for the type `AwardsCategoryMenu`. */
export interface IAwardsCategoryMenuFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

export interface IAwardsCategoryMenuFolder extends IContent, IElement {
  __typename?: 'AwardsCategoryMenuFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `AwardsCategoryMenuFolder`. */
export interface IAwardsCategoryMenuFolderConnection {
  __typename?: 'AwardsCategoryMenuFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IAwardsCategoryMenuFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IAwardsCategoryMenuFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

export interface IAwardsCategoryMenuFolderDev extends IContent, IElement {
  __typename?: 'AwardsCategoryMenuFolderDev';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuFolderDevAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuFolderDevChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuFolderDevDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IAwardsCategoryMenuFolderDevNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuFolderDevParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuFolderDevUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IAwardsCategoryMenuFolderDevUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `AwardsCategoryMenuFolderDev`. */
export interface IAwardsCategoryMenuFolderDevConnection {
  __typename?: 'AwardsCategoryMenuFolderDevConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IAwardsCategoryMenuFolderDevEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IAwardsCategoryMenuFolderDev>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `AwardsCategoryMenuFolderDev`. */
export interface IAwardsCategoryMenuFolderDevEdge {
  __typename?: 'AwardsCategoryMenuFolderDevEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IAwardsCategoryMenuFolderDev>;
}

/** A filter input for the type `AwardsCategoryMenuFolderDev`. */
export interface IAwardsCategoryMenuFolderDevFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFolderDevFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFolderDevFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFolderDevFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `AwardsCategoryMenuFolderDev`. */
export enum IAwardsCategoryMenuFolderDevOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An edge in a connection from an object to another object of type `AwardsCategoryMenuFolder`. */
export interface IAwardsCategoryMenuFolderEdge {
  __typename?: 'AwardsCategoryMenuFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IAwardsCategoryMenuFolder>;
}

/** A filter input for the type `AwardsCategoryMenuFolder`. */
export interface IAwardsCategoryMenuFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `AwardsCategoryMenuFolder`. */
export enum IAwardsCategoryMenuFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `AwardsCategoryMenu`. */
export enum IAwardsCategoryMenuOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** awards website homepage */
export interface IAwardsHomepage extends IContent, ICoverVideoCmp, IElement {
  __typename?: 'AwardsHomepage';
  /** The ancestors. */
  ancestors: IContentConnection;
  backgroundImage?: Maybe<IMediaWithCrops>;
  cTA?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  comingSoonPage?: Maybe<IContent>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** Don't forget to add the thank you page or message in the WORKFLOW setting ! */
  form?: Maybe<Scalars['JSON']>;
  formIntroduction?: Maybe<Scalars['String']>;
  formLabel?: Maybe<Scalars['String']>;
  formTitle?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  introduction?: Maybe<Scalars['String']>;
  /** The level. */
  level: Scalars['Int'];
  logo?: Maybe<IMediaWithCrops>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pageBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  urlRewrite?: Maybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** awards website homepage */
export interface IAwardsHomepageCTaArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** awards website homepage */
export interface IAwardsHomepageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** awards website homepage */
export interface IAwardsHomepageFormArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageFormIntroductionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageFormLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageFormTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageIntroductionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageLogoArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageMetaDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageMetaTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepagePageBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** awards website homepage */
export interface IAwardsHomepageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `AwardsHomepage`. */
export interface IAwardsHomepageConnection {
  __typename?: 'AwardsHomepageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IAwardsHomepageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IAwardsHomepage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `AwardsHomepage`. */
export interface IAwardsHomepageEdge {
  __typename?: 'AwardsHomepageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IAwardsHomepage>;
}

/** A filter input for the type `AwardsHomepage`. */
export interface IAwardsHomepageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IAwardsHomepageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IAwardsHomepageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IAwardsHomepageFilterInput>>>;
  /** Field must equal value. */
  comingSoonPage?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  formIntroduction?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  formIntroduction_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  formIntroduction_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  formIntroduction_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  formIntroduction_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  formLabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  formLabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  formLabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  formLabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  formLabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  formTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  formTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  formTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  formTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  formTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  introduction?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  introduction_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  introduction_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  introduction_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  introduction_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  metaDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  metaDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  metaDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  metaDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  metaDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  metaTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  metaTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  metaTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  metaTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  metaTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  urlRewrite?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  urlRewrite_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  urlRewrite_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  urlRewrite_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  urlRewrite_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `AwardsHomepage`. */
export enum IAwardsHomepageOrderByInput {
  /** Order by `comingSoonPage` in ascending order. */
  ComingSoonPageAsc = 'comingSoonPage_ASC',
  /** Order by `comingSoonPage` in descending order. */
  ComingSoonPageDesc = 'comingSoonPage_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `formIntroduction` in ascending order. */
  FormIntroductionAsc = 'formIntroduction_ASC',
  /** Order by `formIntroduction` in descending order. */
  FormIntroductionDesc = 'formIntroduction_DESC',
  /** Order by `formLabel` in ascending order. */
  FormLabelAsc = 'formLabel_ASC',
  /** Order by `formLabel` in descending order. */
  FormLabelDesc = 'formLabel_DESC',
  /** Order by `formTitle` in ascending order. */
  FormTitleAsc = 'formTitle_ASC',
  /** Order by `formTitle` in descending order. */
  FormTitleDesc = 'formTitle_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `introduction` in ascending order. */
  IntroductionAsc = 'introduction_ASC',
  /** Order by `introduction` in descending order. */
  IntroductionDesc = 'introduction_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `metaDescription` in ascending order. */
  MetaDescriptionAsc = 'metaDescription_ASC',
  /** Order by `metaDescription` in descending order. */
  MetaDescriptionDesc = 'metaDescription_DESC',
  /** Order by `metaTitle` in ascending order. */
  MetaTitleAsc = 'metaTitle_ASC',
  /** Order by `metaTitle` in descending order. */
  MetaTitleDesc = 'metaTitle_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `urlRewrite` in ascending order. */
  UrlRewriteAsc = 'urlRewrite_ASC',
  /** Order by `urlRewrite` in descending order. */
  UrlRewriteDesc = 'urlRewrite_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Wrapper for the BlockGrid elements */
export interface IBlockGrid {
  __typename?: 'BlockGrid';
  /** The grid columns of the BlockGrid */
  gridColumns?: Maybe<Scalars['Int']>;
  /** The items in the BlockGrid */
  items: Array<Maybe<IBlockGridItem>>;
}

/** Wrapper for the BlockGrid areas */
export interface IBlockGridArea {
  __typename?: 'BlockGridArea';
  /** The alias of the BlockGrid area */
  alias: Scalars['String'];
  /** The column span of the BlockGrid area */
  columnSpan?: Maybe<Scalars['Int']>;
  /** The items in the BlockGrid area */
  items?: Maybe<Array<Maybe<IBlockGridItem>>>;
  /** The row span of the BlockGrid area */
  rowSpan?: Maybe<Scalars['Int']>;
}

/** An item in a BlockGrid items list */
export interface IBlockGridItem {
  __typename?: 'BlockGridItem';
  /** The area grid columns of the item in the BlockGrid */
  areaGridColumns?: Maybe<Scalars['Int']>;
  /** The areas of the item in the BlockGrid */
  areas: Array<Maybe<IBlockGridArea>>;
  /** The column span of the item in the BlockGrid */
  columnSpan?: Maybe<Scalars['Int']>;
  /** A content to the content. */
  content: IElement;
  /** The grid columns of the BlockGrid */
  gridColumns?: Maybe<Scalars['Int']>;
  /** The row span of the item in the BlockGrid */
  rowSpan?: Maybe<Scalars['Int']>;
  /** A reference to the settings. */
  settings?: Maybe<IElement>;
}

/** An item in a BlockList */
export interface IBlockListItem {
  __typename?: 'BlockListItem';
  /** A reference to the content. */
  content: IElement;
  /** A reference to the settings. */
  settings?: Maybe<IElement>;
}

export interface IButton extends IElement {
  __typename?: 'Button';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  link_to?: Maybe<Array<Maybe<IBlockListItem>>>;
  size?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
}


export interface IButtonTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A fully customisable page with a cover and a content builder */
export interface ICmsPage extends IContent, ICoverVideoCmp, IElement, IPage, ITopMenuComp {
  __typename?: 'CMSPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  button?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pageBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPagePageBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageTopMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A fully customisable page with a cover and a content builder */
export interface ICmsPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CMSPage`. */
export interface ICmsPageConnection {
  __typename?: 'CMSPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICmsPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICmsPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CMSPage`. */
export interface ICmsPageEdge {
  __typename?: 'CMSPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICmsPage>;
}

/** A filter input for the type `CMSPage`. */
export interface ICmsPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICmsPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICmsPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICmsPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CMSPage`. */
export enum ICmsPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ICtaSlide extends IElement {
  __typename?: 'CTASlide';
  button?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


export interface ICtaSlideButtonArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICtaSlideDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICtaSlideTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ICtaSlider extends IElement {
  __typename?: 'CTASlider';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  slides?: Maybe<Array<Maybe<IBlockListItem>>>;
}

export interface ICard extends IElement {
  __typename?: 'Card';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  image?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
}

export interface ICardIcon extends IElement {
  __typename?: 'CardIcon';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** Card with links - DEV */
export interface ICardLink extends IElement {
  __typename?: 'CardLink';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  image?: Maybe<IMediaWithCrops>;
  links?: Maybe<Array<Maybe<IBlockListItem>>>;
  title?: Maybe<Scalars['String']>;
}

export interface ICardList extends IElement {
  __typename?: 'CardList';
  cards?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
}

export interface ICategBgColor extends IContent, IElement {
  __typename?: 'CategBgColor';
  /** The ancestors. */
  ancestors: IContentConnection;
  backgroundColor?: Maybe<Scalars['String']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ICategBgColorAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICategBgColorChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICategBgColorDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICategBgColorNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICategBgColorParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICategBgColorUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICategBgColorUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CategBgColor`. */
export interface ICategBgColorConnection {
  __typename?: 'CategBgColorConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICategBgColorEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICategBgColor>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CategBgColor`. */
export interface ICategBgColorEdge {
  __typename?: 'CategBgColorEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICategBgColor>;
}

/** A filter input for the type `CategBgColor`. */
export interface ICategBgColorFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICategBgColorFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICategBgColorFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICategBgColorFilterInput>>>;
  /** Field must equal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  backgroundColor_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  backgroundColor_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  backgroundColor_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CategBgColor`. */
export enum ICategBgColorOrderByInput {
  /** Order by `backgroundColor` in ascending order. */
  BackgroundColorAsc = 'backgroundColor_ASC',
  /** Order by `backgroundColor` in descending order. */
  BackgroundColorDesc = 'backgroundColor_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ICategoriesSlider {
  category?: Maybe<IContent>;
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  isLink?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  /** If not set the content title will be used as title for the slider */
  title?: Maybe<Scalars['String']>;
}

export interface ICategoryPage extends IContent, IElement, IPage {
  __typename?: 'CategoryPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  backgroundColor?: Maybe<Scalars['String']>;
  categoryContent?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ICategoryPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICategoryPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICategoryPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICategoryPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICategoryPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICategoryPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICategoryPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CategoryPage`. */
export interface ICategoryPageConnection {
  __typename?: 'CategoryPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICategoryPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICategoryPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CategoryPage`. */
export interface ICategoryPageEdge {
  __typename?: 'CategoryPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICategoryPage>;
}

/** A filter input for the type `CategoryPage`. */
export interface ICategoryPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICategoryPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICategoryPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICategoryPageFilterInput>>>;
  /** Field must equal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  backgroundColor_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  backgroundColor_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  backgroundColor_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  categoryContent_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  categoryContent_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CategoryPage`. */
export enum ICategoryPageOrderByInput {
  /** Order by `backgroundColor` in ascending order. */
  BackgroundColorAsc = 'backgroundColor_ASC',
  /** Order by `backgroundColor` in descending order. */
  BackgroundColorDesc = 'backgroundColor_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Picket category to display as content slider */
export interface ICategorySlider extends IElement, ISliderThumbnailSettings {
  __typename?: 'CategorySlider';
  category?: Maybe<IContent>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  isLink?: Maybe<Scalars['Boolean']>;
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** Picket category to display as content slider */
export interface ICategorySliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Category slider with background image */
export interface ICategorySliderHighlight extends ICategoriesSlider, IElement, ISliderHighlight, ISliderThumbnailSettings {
  __typename?: 'CategorySliderHighlight';
  background?: Maybe<IMediaWithCrops>;
  backgroundDesktop?: Maybe<IMediaWithCrops>;
  category?: Maybe<IContent>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isLink?: Maybe<Scalars['Boolean']>;
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  surtitle?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  /** If not set the content title will be used as title for the slider */
  title?: Maybe<Scalars['String']>;
}


/** Category slider with background image */
export interface ICategorySliderHighlightBackgroundDesktopArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Category slider with background image */
export interface ICategorySliderHighlightDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Category slider with background image */
export interface ICategorySliderHighlightSurtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IChannel extends IContent, IContentTagsComp, ICoverThumbnailCmp, IElement {
  __typename?: 'Channel';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** URL to the EPG file */
  epg?: Maybe<Scalars['String']>;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  interests?: Maybe<Array<Maybe<IContent>>>;
  /** The level. */
  level: Scalars['Int'];
  /** Live event ID or Vimeo Video ID */
  liveEventID?: Maybe<Scalars['Int']>;
  logo?: Maybe<IMediaWithCrops>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Other video source */
  sourceUrl?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  /** New channel vimeo id */
  vimeoEventId?: Maybe<Scalars['Int']>;
}


export interface IChannelAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IChannelChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IChannelDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IChannelLiveEventIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelLogoArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelVimeoEventIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Channel`. */
export interface IChannelConnection {
  __typename?: 'ChannelConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IChannelEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IChannel>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Channel`. */
export interface IChannelEdge {
  __typename?: 'ChannelEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IChannel>;
}

/** A filter input for the type `Channel`. */
export interface IChannelFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IChannelFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IChannelFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IChannelFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  epg?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  epg_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  epg_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  epg_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  epg_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  liveEventID?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  liveEventID_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  liveEventID_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  liveEventID_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  liveEventID_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  liveEventID_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  musicGenre_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  musicGenre_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  regions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  regions_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  sourceUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  sourceUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  vimeoEventId?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  vimeoEventId_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  vimeoEventId_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  vimeoEventId_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  vimeoEventId_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  vimeoEventId_lte?: InputMaybe<Scalars['Int']>;
}

export interface IChannelFolder extends IContent, IElement {
  __typename?: 'ChannelFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IChannelFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IChannelFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IChannelFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IChannelFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IChannelFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ChannelFolder`. */
export interface IChannelFolderConnection {
  __typename?: 'ChannelFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IChannelFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IChannelFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ChannelFolder`. */
export interface IChannelFolderEdge {
  __typename?: 'ChannelFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IChannelFolder>;
}

/** A filter input for the type `ChannelFolder`. */
export interface IChannelFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IChannelFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IChannelFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IChannelFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ChannelFolder`. */
export enum IChannelFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `Channel`. */
export enum IChannelOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `epg` in ascending order. */
  EpgAsc = 'epg_ASC',
  /** Order by `epg` in descending order. */
  EpgDesc = 'epg_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `liveEventID` in ascending order. */
  LiveEventIdAsc = 'liveEventID_ASC',
  /** Order by `liveEventID` in descending order. */
  LiveEventIdDesc = 'liveEventID_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `sourceUrl` in ascending order. */
  SourceUrlAsc = 'sourceUrl_ASC',
  /** Order by `sourceUrl` in descending order. */
  SourceUrlDesc = 'sourceUrl_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `vimeoEventId` in ascending order. */
  VimeoEventIdAsc = 'vimeoEventId_ASC',
  /** Order by `vimeoEventId` in descending order. */
  VimeoEventIdDesc = 'vimeoEventId_DESC'
}

export interface IChoiceNuggerAnswer extends IElement {
  __typename?: 'ChoiceNuggerAnswer';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** To display when selected */
  feedback?: Maybe<Scalars['String']>;
  image?: Maybe<IMediaWithCrops>;
  /** Check if is a valid answer */
  isCorrect?: Maybe<Scalars['Boolean']>;
  /** Will be displayed as choice to the user */
  value?: Maybe<Scalars['String']>;
}

/** Nugget with a question and mutliple possible answers */
export interface IChoiceNugget extends IContent, IElement, INuggetFeedbackCmp {
  __typename?: 'ChoiceNugget';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  /** Tick to use the feedbacks below for empty choices' feebacks */
  genericFeedback?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  negativeFeedback?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  positiveFeedback?: Maybe<Scalars['String']>;
  question?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetNegativeFeedbackArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetOptionsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetPositiveFeedbackArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetQuestionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface IChoiceNuggetUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IChoiceNuggetAnswerGroup extends IElement {
  __typename?: 'ChoiceNuggetAnswerGroup';
  answersList?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
}

/** A connection from an object to a list of objects of type `ChoiceNugget`. */
export interface IChoiceNuggetConnection {
  __typename?: 'ChoiceNuggetConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IChoiceNuggetEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IChoiceNugget>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ChoiceNugget`. */
export interface IChoiceNuggetEdge {
  __typename?: 'ChoiceNuggetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IChoiceNugget>;
}

/** A filter input for the type `ChoiceNugget`. */
export interface IChoiceNuggetFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IChoiceNuggetFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IChoiceNuggetFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IChoiceNuggetFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  genericFeedback?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  negativeFeedback?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  negativeFeedback_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  negativeFeedback_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  negativeFeedback_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  negativeFeedback_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  positiveFeedback?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  positiveFeedback_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  positiveFeedback_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  positiveFeedback_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  positiveFeedback_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ChoiceNugget`. */
export enum IChoiceNuggetOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `genericFeedback` in ascending order. */
  GenericFeedbackAsc = 'genericFeedback_ASC',
  /** Order by `genericFeedback` in descending order. */
  GenericFeedbackDesc = 'genericFeedback_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `negativeFeedback` in ascending order. */
  NegativeFeedbackAsc = 'negativeFeedback_ASC',
  /** Order by `negativeFeedback` in descending order. */
  NegativeFeedbackDesc = 'negativeFeedback_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `positiveFeedback` in ascending order. */
  PositiveFeedbackAsc = 'positiveFeedback_ASC',
  /** Order by `positiveFeedback` in descending order. */
  PositiveFeedbackDesc = 'positiveFeedback_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IChoiceNuggetQuestion extends IElement {
  __typename?: 'ChoiceNuggetQuestion';
  answers?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  question?: Maybe<Array<Maybe<IBlockListItem>>>;
}

export interface ICollection extends IContent, IContentDescriptionCmp, IContentItems, IElement, IMetasVideosCmp {
  __typename?: 'Collection';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** Color for the "Season and Episodes" panel */
  colorscheme?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  countryOfProduction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  imageFormat?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<IContent>>>;
  /** in seconds */
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  linkedJobs?: Maybe<Scalars['String']>;
  mogadorProductKey?: Maybe<Scalars['String']>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  personality?: Maybe<Array<Maybe<Scalars['String']>>>;
  public?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** 300 char. max. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
  subtitle?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** Vimeo ID for trailer video */
  trailer?: Maybe<Scalars['Int']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ICollectionAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICollectionChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICollectionDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICollectionDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionTrailerArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICollectionUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Collection`. */
export interface ICollectionConnection {
  __typename?: 'CollectionConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICollectionEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICollection>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Collection`. */
export interface ICollectionEdge {
  __typename?: 'CollectionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICollection>;
}

/** A filter input for the type `Collection`. */
export interface ICollectionFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICollectionFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICollectionFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICollectionFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  colorscheme?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  colorscheme_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  colorscheme_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  colorscheme_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  colorscheme_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match all of the values. */
  countryOfProduction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countryOfProduction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  imageFormat?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  imageFormat_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  imageFormat_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  imageFormat_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  imageFormat_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  linkedJobs?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  linkedJobs_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  linkedJobs_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  linkedJobs_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  linkedJobs_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  mogadorProductKey?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  mogadorProductKey_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  mogadorProductKey_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  mogadorProductKey_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  mogadorProductKey_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  musicGenre_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  musicGenre_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  personality_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  personality_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  public?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  public_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  public_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  public_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  public_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  regions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  regions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  releaseDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  releaseDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  releaseDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  releaseDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  releaseDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  trailer?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  trailer_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  trailer_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  trailer_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  trailer_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  trailer_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Collection`. */
export enum ICollectionOrderByInput {
  /** Order by `colorscheme` in ascending order. */
  ColorschemeAsc = 'colorscheme_ASC',
  /** Order by `colorscheme` in descending order. */
  ColorschemeDesc = 'colorscheme_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `imageFormat` in ascending order. */
  ImageFormatAsc = 'imageFormat_ASC',
  /** Order by `imageFormat` in descending order. */
  ImageFormatDesc = 'imageFormat_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `linkedJobs` in ascending order. */
  LinkedJobsAsc = 'linkedJobs_ASC',
  /** Order by `linkedJobs` in descending order. */
  LinkedJobsDesc = 'linkedJobs_DESC',
  /** Order by `mogadorProductKey` in ascending order. */
  MogadorProductKeyAsc = 'mogadorProductKey_ASC',
  /** Order by `mogadorProductKey` in descending order. */
  MogadorProductKeyDesc = 'mogadorProductKey_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `public` in ascending order. */
  PublicAsc = 'public_ASC',
  /** Order by `public` in descending order. */
  PublicDesc = 'public_DESC',
  /** Order by `releaseDate` in ascending order. */
  ReleaseDateAsc = 'releaseDate_ASC',
  /** Order by `releaseDate` in descending order. */
  ReleaseDateDesc = 'releaseDate_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `trailer` in ascending order. */
  TrailerAsc = 'trailer_ASC',
  /** Order by `trailer` in descending order. */
  TrailerDesc = 'trailer_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IColorTag extends IElement {
  __typename?: 'ColorTag';
  color?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  value?: Maybe<Scalars['String']>;
}

/** The Content interface. */
export interface IContent {
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** The Content interface. */
export interface IContentAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** The Content interface. */
export interface IContentChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** The Content interface. */
export interface IContentDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** The Content interface. */
export interface IContentNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** The Content interface. */
export interface IContentParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** The Content interface. */
export interface IContentUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** The Content interface. */
export interface IContentUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IContentAudioFileCmp extends IElement {
  __typename?: 'ContentAudioFileCmp';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** URL to the HLS file */
  hls?: Maybe<Scalars['String']>;
}

export interface IContentAudioVimeoCmp extends IElement {
  __typename?: 'ContentAudioVimeoCmp';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** URL to the MP4 file from Vimeo */
  source?: Maybe<Scalars['String']>;
}

export interface IContentCategCmp extends IElement {
  __typename?: 'ContentCategCmp';
  backgroundColor?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  isExpand?: Maybe<Scalars['Boolean']>;
  thumbnail?: Maybe<IMediaWithCrops>;
}

/** A connection from an object to a list of objects of type `Content`. */
export interface IContentConnection {
  __typename?: 'ContentConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IContentEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IContent>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

export interface IContentDescriptionCmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** 300 char. max. */
  shortDescription?: Maybe<Scalars['String']>;
}


export interface IContentDescriptionCmpDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentDescriptionCmpShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IContentEpgProgramFileCmp extends IElement {
  __typename?: 'ContentEPGProgramFileCmp';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** URL to the EPG file */
  epg?: Maybe<Scalars['String']>;
}

/** An edge in a connection from an object to another object of type `Content`. */
export interface IContentEdge {
  __typename?: 'ContentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IContent>;
}

export interface IContentEditorFolder extends IContent, IElement {
  __typename?: 'ContentEditorFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IContentEditorFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentEditorFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentEditorFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentEditorFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentEditorFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentEditorFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentEditorFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ContentEditorFolder`. */
export interface IContentEditorFolderConnection {
  __typename?: 'ContentEditorFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IContentEditorFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IContentEditorFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ContentEditorFolder`. */
export interface IContentEditorFolderEdge {
  __typename?: 'ContentEditorFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IContentEditorFolder>;
}

/** A filter input for the type `ContentEditorFolder`. */
export interface IContentEditorFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IContentEditorFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IContentEditorFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IContentEditorFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ContentEditorFolder`. */
export enum IContentEditorFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A filter input for the type `Content`. */
export interface IContentFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IContentFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IContentFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IContentFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

export interface IContentItems {
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  imageFormat?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<IContent>>>;
  linkedJobs?: Maybe<Scalars['String']>;
  mogadorProductKey?: Maybe<Scalars['String']>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  personality?: Maybe<Array<Maybe<Scalars['String']>>>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtitle?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
}


export interface IContentItemsSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentItemsSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentItemsTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IContentLink extends IElement {
  __typename?: 'ContentLink';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  link?: Maybe<IContent>;
}

export interface IContentLiveVideoCmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  /** Live event ID or Vimeo Video ID */
  liveEventID?: Maybe<Scalars['Int']>;
  /** Other video source */
  sourceUrl?: Maybe<Scalars['String']>;
}


export interface IContentLiveVideoCmpLiveEventIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Content`. */
export enum IContentOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Pick your own content from multiple category to create a custom slider */
export interface IContentSlider extends IElement, ISliderThumbnailSettings {
  __typename?: 'ContentSlider';
  contentItems?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** Pick your own content from multiple category to create a custom slider */
export interface IContentSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Content Slider with Background image */
export interface IContentSliderHighlight extends IContentsSlider, IElement, ISliderHighlight, ISliderThumbnailSettings {
  __typename?: 'ContentSliderHighlight';
  background?: Maybe<IMediaWithCrops>;
  backgroundDesktop?: Maybe<IMediaWithCrops>;
  contentItems?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  surtitle?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  /** If not set the content title will be used as title for the slider */
  title?: Maybe<Scalars['String']>;
}


/** Content Slider with Background image */
export interface IContentSliderHighlightBackgroundDesktopArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Content Slider with Background image */
export interface IContentSliderHighlightDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Content Slider with Background image */
export interface IContentSliderHighlightSurtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Content Slider with Background image */
export interface IContentSliderHighlightTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IContentTag extends IContent, IElement {
  __typename?: 'ContentTag';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  color?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IContentTagAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ContentTag`. */
export interface IContentTagConnection {
  __typename?: 'ContentTagConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IContentTagEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IContentTag>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ContentTag`. */
export interface IContentTagEdge {
  __typename?: 'ContentTagEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IContentTag>;
}

/** A filter input for the type `ContentTag`. */
export interface IContentTagFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IContentTagFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IContentTagFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IContentTagFilterInput>>>;
  /** Field must equal value. */
  color?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  color_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  color_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  color_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  color_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ContentTag`. */
export enum IContentTagOrderByInput {
  /** Order by `color` in ascending order. */
  ColorAsc = 'color_ASC',
  /** Order by `color` in descending order. */
  ColorDesc = 'color_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IContentTags extends IContent, IElement {
  __typename?: 'ContentTags';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IContentTagsAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagsChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagsDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagsNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagsParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagsUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagsUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IContentTagsCateg extends IContent, IElement {
  __typename?: 'ContentTagsCateg';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IContentTagsCategAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagsCategChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagsCategDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IContentTagsCategNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagsCategParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagsCategUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IContentTagsCategUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ContentTagsCateg`. */
export interface IContentTagsCategConnection {
  __typename?: 'ContentTagsCategConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IContentTagsCategEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IContentTagsCateg>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ContentTagsCateg`. */
export interface IContentTagsCategEdge {
  __typename?: 'ContentTagsCategEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IContentTagsCateg>;
}

/** A filter input for the type `ContentTagsCateg`. */
export interface IContentTagsCategFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IContentTagsCategFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IContentTagsCategFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IContentTagsCategFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ContentTagsCateg`. */
export enum IContentTagsCategOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IContentTagsComp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  interests?: Maybe<Array<Maybe<IContent>>>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  themes?: Maybe<Array<Maybe<IContent>>>;
}

/** A connection from an object to a list of objects of type `ContentTags`. */
export interface IContentTagsConnection {
  __typename?: 'ContentTagsConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IContentTagsEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IContentTags>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ContentTags`. */
export interface IContentTagsEdge {
  __typename?: 'ContentTagsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IContentTags>;
}

/** A filter input for the type `ContentTags`. */
export interface IContentTagsFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IContentTagsFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IContentTagsFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IContentTagsFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ContentTags`. */
export enum IContentTagsOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IContentsSlider {
  contentItems?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  template?: Maybe<Scalars['String']>;
  /** If not set the content title will be used as title for the slider */
  title?: Maybe<Scalars['String']>;
}


export interface IContentsSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Content Slider with content from the member activities */
export interface IContextualContentSlider extends IElement, ISliderThumbnailSettings {
  __typename?: 'ContextualContentSlider';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
}

/** Course content */
export interface ICourse extends IContent, ICoverThumbnailCmp, IElement {
  __typename?: 'Course';
  ageRestriction?: Maybe<Scalars['Int']>;
  /** The ancestors. */
  ancestors: IContentConnection;
  certificate?: Maybe<Scalars['Boolean']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280px */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  externalTags?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  interests?: Maybe<Array<Maybe<IContent>>>;
  lastUpdate?: Maybe<Scalars['DateTime']>;
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  linkedPartners?: Maybe<Array<Maybe<IContent>>>;
  linkedPersonalities?: Maybe<Array<Maybe<IContent>>>;
  multimediaUnits?: Maybe<Scalars['Int']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  quizz?: Maybe<Scalars['Boolean']>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** Vimeo ID for trailer video */
  trailer?: Maybe<Scalars['Int']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  videosCount?: Maybe<Scalars['Int']>;
}


/** Course content */
export interface ICourseAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Course content */
export interface ICourseChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Course content */
export interface ICourseCoverArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Course content */
export interface ICourseDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseExternalTagsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseLengthArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseTrailerArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Course content */
export interface ICourseUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ICourseCategoriesFolder extends IContent, IElement {
  __typename?: 'CourseCategoriesFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ICourseCategoriesFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseCategoriesFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseCategoriesFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseCategoriesFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseCategoriesFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseCategoriesFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseCategoriesFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CourseCategoriesFolder`. */
export interface ICourseCategoriesFolderConnection {
  __typename?: 'CourseCategoriesFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICourseCategoriesFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICourseCategoriesFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CourseCategoriesFolder`. */
export interface ICourseCategoriesFolderEdge {
  __typename?: 'CourseCategoriesFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICourseCategoriesFolder>;
}

/** A filter input for the type `CourseCategoriesFolder`. */
export interface ICourseCategoriesFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICourseCategoriesFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICourseCategoriesFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICourseCategoriesFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CourseCategoriesFolder`. */
export enum ICourseCategoriesFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Category to group courses together */
export interface ICourseCategory extends IContent, IElement {
  __typename?: 'CourseCategory';
  /** The ancestors. */
  ancestors: IContentConnection;
  backgroundColor?: Maybe<Scalars['String']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  isExpand?: Maybe<Scalars['Boolean']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** Category to group courses together */
export interface ICourseCategoryAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Category to group courses together */
export interface ICourseCategoryChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Category to group courses together */
export interface ICourseCategoryDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Category to group courses together */
export interface ICourseCategoryNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Category to group courses together */
export interface ICourseCategoryParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Category to group courses together */
export interface ICourseCategoryUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Category to group courses together */
export interface ICourseCategoryUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CourseCategory`. */
export interface ICourseCategoryConnection {
  __typename?: 'CourseCategoryConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICourseCategoryEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICourseCategory>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CourseCategory`. */
export interface ICourseCategoryEdge {
  __typename?: 'CourseCategoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICourseCategory>;
}

/** A filter input for the type `CourseCategory`. */
export interface ICourseCategoryFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICourseCategoryFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICourseCategoryFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICourseCategoryFilterInput>>>;
  /** Field must equal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  backgroundColor_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  backgroundColor_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  backgroundColor_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  isExpand?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CourseCategory`. */
export enum ICourseCategoryOrderByInput {
  /** Order by `backgroundColor` in ascending order. */
  BackgroundColorAsc = 'backgroundColor_ASC',
  /** Order by `backgroundColor` in descending order. */
  BackgroundColorDesc = 'backgroundColor_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `isExpand` in ascending order. */
  IsExpandAsc = 'isExpand_ASC',
  /** Order by `isExpand` in descending order. */
  IsExpandDesc = 'isExpand_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Pick a course category to display as content slider */
export interface ICourseCategorySlider extends IElement, ISliderThumbnailSettings {
  __typename?: 'CourseCategorySlider';
  category?: Maybe<IContent>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  isLink?: Maybe<Scalars['Boolean']>;
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** Pick a course category to display as content slider */
export interface ICourseCategorySliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Course`. */
export interface ICourseConnection {
  __typename?: 'CourseConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICourseEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICourse>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Course`. */
export interface ICourseEdge {
  __typename?: 'CourseEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICourse>;
}

export interface ICourseExam extends IContent, IElement {
  __typename?: 'CourseExam';
  /** Number of attempts if LimitedAttempts is ON */
  allowedAttempts?: Maybe<Scalars['Int']>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** minimum time required for the user to re-take a failed exam (in min.) */
  attemptDelay?: Maybe<Scalars['Int']>;
  /** Pages to be displayed before the exam */
  before?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  conclusionPages?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  examNuggets?: Maybe<Array<Maybe<IContent>>>;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  /** Minimum required correct answer */
  gradingPolicy?: Maybe<Scalars['Decimal']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** in min. */
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  /** Turn ON if you want to limit the number of Attempt */
  limitedAttempts?: Maybe<Scalars['Boolean']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  negativeResult?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  positiveResult?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ICourseExamAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseExamBeforeArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseExamChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseExamConclusionPagesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseExamDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseExamNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseExamNegativeResultArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseExamParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseExamPositiveResultArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseExamUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseExamUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CourseExam`. */
export interface ICourseExamConnection {
  __typename?: 'CourseExamConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICourseExamEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICourseExam>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CourseExam`. */
export interface ICourseExamEdge {
  __typename?: 'CourseExamEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICourseExam>;
}

/** A filter input for the type `CourseExam`. */
export interface ICourseExamFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICourseExamFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICourseExamFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICourseExamFilterInput>>>;
  /** Field must equal value. */
  allowedAttempts?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  allowedAttempts_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  allowedAttempts_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  allowedAttempts_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  allowedAttempts_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  allowedAttempts_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  attemptDelay?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  attemptDelay_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  attemptDelay_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  attemptDelay_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  attemptDelay_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  attemptDelay_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  examNuggets_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  examNuggets_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  gradingPolicy?: InputMaybe<Scalars['Decimal']>;
  /** Field must match any of the values. */
  gradingPolicy_any?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  /** Field must be greater than the value. */
  gradingPolicy_gt?: InputMaybe<Scalars['Decimal']>;
  /** Field must be greater than or equal the value. */
  gradingPolicy_gte?: InputMaybe<Scalars['Decimal']>;
  /** Field must be less than the value. */
  gradingPolicy_lt?: InputMaybe<Scalars['Decimal']>;
  /** Field must be less than or equal the value. */
  gradingPolicy_lte?: InputMaybe<Scalars['Decimal']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  limitedAttempts?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CourseExam`. */
export enum ICourseExamOrderByInput {
  /** Order by `allowedAttempts` in ascending order. */
  AllowedAttemptsAsc = 'allowedAttempts_ASC',
  /** Order by `allowedAttempts` in descending order. */
  AllowedAttemptsDesc = 'allowedAttempts_DESC',
  /** Order by `attemptDelay` in ascending order. */
  AttemptDelayAsc = 'attemptDelay_ASC',
  /** Order by `attemptDelay` in descending order. */
  AttemptDelayDesc = 'attemptDelay_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `gradingPolicy` in ascending order. */
  GradingPolicyAsc = 'gradingPolicy_ASC',
  /** Order by `gradingPolicy` in descending order. */
  GradingPolicyDesc = 'gradingPolicy_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `limitedAttempts` in ascending order. */
  LimitedAttemptsAsc = 'limitedAttempts_ASC',
  /** Order by `limitedAttempts` in descending order. */
  LimitedAttemptsDesc = 'limitedAttempts_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A filter input for the type `Course`. */
export interface ICourseFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICourseFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICourseFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICourseFilterInput>>>;
  /** Field must equal value. */
  ageRestriction?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  ageRestriction_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  ageRestriction_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  ageRestriction_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  ageRestriction_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  ageRestriction_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  certificate?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  externalTags?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalTags_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalTags_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalTags_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalTags_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  lastUpdate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  lastUpdate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  lastUpdate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  lastUpdate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  linkedPartners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  linkedPartners_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  linkedPersonalities_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  linkedPersonalities_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  multimediaUnits?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  multimediaUnits_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  multimediaUnits_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  multimediaUnits_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  multimediaUnits_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  multimediaUnits_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  quizz?: InputMaybe<Scalars['Boolean']>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  trailer?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  trailer_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  trailer_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  trailer_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  trailer_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  trailer_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  videosCount?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  videosCount_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  videosCount_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  videosCount_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  videosCount_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  videosCount_lte?: InputMaybe<Scalars['Int']>;
}

/** Pick your own Course content from multiple categories to create a custom slider */
export interface ICourseItemsSlider extends IElement, ISliderThumbnailSettings {
  __typename?: 'CourseItemsSlider';
  contentItems?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** Pick your own Course content from multiple categories to create a custom slider */
export interface ICourseItemsSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Select nuggets (nuggets must be created before as unit child) */
export interface ICourseNugget extends IElement {
  __typename?: 'CourseNugget';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  nuggets?: Maybe<Array<Maybe<IContent>>>;
}

/** An order input for the type `Course`. */
export enum ICourseOrderByInput {
  /** Order by `ageRestriction` in ascending order. */
  AgeRestrictionAsc = 'ageRestriction_ASC',
  /** Order by `ageRestriction` in descending order. */
  AgeRestrictionDesc = 'ageRestriction_DESC',
  /** Order by `certificate` in ascending order. */
  CertificateAsc = 'certificate_ASC',
  /** Order by `certificate` in descending order. */
  CertificateDesc = 'certificate_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `externalTags` in ascending order. */
  ExternalTagsAsc = 'externalTags_ASC',
  /** Order by `externalTags` in descending order. */
  ExternalTagsDesc = 'externalTags_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `lastUpdate` in ascending order. */
  LastUpdateAsc = 'lastUpdate_ASC',
  /** Order by `lastUpdate` in descending order. */
  LastUpdateDesc = 'lastUpdate_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `multimediaUnits` in ascending order. */
  MultimediaUnitsAsc = 'multimediaUnits_ASC',
  /** Order by `multimediaUnits` in descending order. */
  MultimediaUnitsDesc = 'multimediaUnits_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `quizz` in ascending order. */
  QuizzAsc = 'quizz_ASC',
  /** Order by `quizz` in descending order. */
  QuizzDesc = 'quizz_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `trailer` in ascending order. */
  TrailerAsc = 'trailer_ASC',
  /** Order by `trailer` in descending order. */
  TrailerDesc = 'trailer_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `videosCount` in ascending order. */
  VideosCountAsc = 'videosCount_ASC',
  /** Order by `videosCount` in descending order. */
  VideosCountDesc = 'videosCount_DESC'
}

/** Content Page for courses */
export interface ICoursePage extends IElement {
  __typename?: 'CoursePage';
  announce?: Maybe<Array<Maybe<IBlockListItem>>>;
  blocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** to display in the back office only */
  internalName?: Maybe<Scalars['String']>;
  /** Banner message to show on this page */
  navMessage?: Maybe<IContent>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface ICourseShare extends IContent, IElement {
  __typename?: 'CourseShare';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  course?: Maybe<IContent>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  totalShares?: Maybe<Scalars['Int']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ICourseShareAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseShareChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseShareDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseShareNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseShareParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseShareUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseShareUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CourseShare`. */
export interface ICourseShareConnection {
  __typename?: 'CourseShareConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICourseShareEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICourseShare>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CourseShare`. */
export interface ICourseShareEdge {
  __typename?: 'CourseShareEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICourseShare>;
}

/** A filter input for the type `CourseShare`. */
export interface ICourseShareFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICourseShareFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICourseShareFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICourseShareFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  course?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  totalShares?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  totalShares_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  totalShares_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  totalShares_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  totalShares_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  totalShares_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CourseShare`. */
export enum ICourseShareOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `course` in ascending order. */
  CourseAsc = 'course_ASC',
  /** Order by `course` in descending order. */
  CourseDesc = 'course_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `totalShares` in ascending order. */
  TotalSharesAsc = 'totalShares_ASC',
  /** Order by `totalShares` in descending order. */
  TotalSharesDesc = 'totalShares_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ICourseStatus extends IContent, IElement {
  __typename?: 'CourseStatus';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  course?: Maybe<IContent>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  finished?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ICourseStatusAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseStatusChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseStatusDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseStatusNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseStatusParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseStatusUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseStatusUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CourseStatus`. */
export interface ICourseStatusConnection {
  __typename?: 'CourseStatusConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICourseStatusEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICourseStatus>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CourseStatus`. */
export interface ICourseStatusEdge {
  __typename?: 'CourseStatusEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICourseStatus>;
}

/** A filter input for the type `CourseStatus`. */
export interface ICourseStatusFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICourseStatusFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICourseStatusFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICourseStatusFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  course?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  finished?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CourseStatus`. */
export enum ICourseStatusOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `course` in ascending order. */
  CourseAsc = 'course_ASC',
  /** Order by `course` in descending order. */
  CourseDesc = 'course_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `finished` in ascending order. */
  FinishedAsc = 'finished_ASC',
  /** Order by `finished` in descending order. */
  FinishedDesc = 'finished_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ICourseTestProgression extends IContent, IElement {
  __typename?: 'CourseTestProgression';
  /** The ancestors. */
  ancestors: IContentConnection;
  attempt?: Maybe<Scalars['Int']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  finished?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** last answer */
  json?: Maybe<Scalars['String']>;
  lastAttempt?: Maybe<Scalars['DateTime']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ICourseTestProgressionAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseTestProgressionChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseTestProgressionDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ICourseTestProgressionNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseTestProgressionParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseTestProgressionUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICourseTestProgressionUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CourseTestProgression`. */
export interface ICourseTestProgressionConnection {
  __typename?: 'CourseTestProgressionConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICourseTestProgressionEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICourseTestProgression>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CourseTestProgression`. */
export interface ICourseTestProgressionEdge {
  __typename?: 'CourseTestProgressionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICourseTestProgression>;
}

/** A filter input for the type `CourseTestProgression`. */
export interface ICourseTestProgressionFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICourseTestProgressionFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICourseTestProgressionFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICourseTestProgressionFilterInput>>>;
  /** Field must equal value. */
  attempt?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  attempt_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  attempt_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  attempt_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  attempt_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  attempt_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  finished?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  json?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  json_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  json_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  json_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  json_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  lastAttempt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  lastAttempt_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  lastAttempt_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  lastAttempt_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  lastAttempt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CourseTestProgression`. */
export enum ICourseTestProgressionOrderByInput {
  /** Order by `attempt` in ascending order. */
  AttemptAsc = 'attempt_ASC',
  /** Order by `attempt` in descending order. */
  AttemptDesc = 'attempt_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `finished` in ascending order. */
  FinishedAsc = 'finished_ASC',
  /** Order by `finished` in descending order. */
  FinishedDesc = 'finished_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `json` in ascending order. */
  JsonAsc = 'json_ASC',
  /** Order by `json` in descending order. */
  JsonDesc = 'json_DESC',
  /** Order by `lastAttempt` in ascending order. */
  LastAttemptAsc = 'lastAttempt_ASC',
  /** Order by `lastAttempt` in descending order. */
  LastAttemptDesc = 'lastAttempt_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** chapter for the course */
export interface ICourseUnit extends IContent, IElement {
  __typename?: 'CourseUnit';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<IMediaWithCrops>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pages?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** chapter for the course */
export interface ICourseUnitAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** chapter for the course */
export interface ICourseUnitChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** chapter for the course */
export interface ICourseUnitDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** chapter for the course */
export interface ICourseUnitDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** chapter for the course */
export interface ICourseUnitNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** chapter for the course */
export interface ICourseUnitPagesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** chapter for the course */
export interface ICourseUnitParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** chapter for the course */
export interface ICourseUnitUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** chapter for the course */
export interface ICourseUnitUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `CourseUnit`. */
export interface ICourseUnitConnection {
  __typename?: 'CourseUnitConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ICourseUnitEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ICourseUnit>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `CourseUnit`. */
export interface ICourseUnitEdge {
  __typename?: 'CourseUnitEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ICourseUnit>;
}

/** A filter input for the type `CourseUnit`. */
export interface ICourseUnitFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ICourseUnitFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ICourseUnitFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ICourseUnitFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `CourseUnit`. */
export enum ICourseUnitOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ICoverImageCmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<IMediaWithCrops>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


export interface ICoverImageCmpSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICoverImageCmpTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ICoverThumbnailCmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  thumbnail?: Maybe<IMediaWithCrops>;
}

export interface ICoverVideoCmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


export interface ICoverVideoCmpSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ICoverVideoCmpTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Represents a range of decimals. */
export interface IDecimalRange {
  __typename?: 'DecimalRange';
  /** Maximum value of the range. */
  maximum: Scalars['Decimal'];
  /** Minimum value of the range. */
  minimum: Scalars['Decimal'];
}

export interface IDescriptionBlockCmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  descriptionTitle?: Maybe<Scalars['String']>;
}


export interface IDescriptionBlockCmpDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDescriptionBlockCmpDescriptionTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IDiscovery extends IContent, IElement {
  __typename?: 'Discovery';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IDiscoveryAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IDiscoveryChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IDiscoveryDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IDiscoveryNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoveryParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoveryUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoveryUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Discovery`. */
export interface IDiscoveryConnection {
  __typename?: 'DiscoveryConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IDiscoveryEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IDiscovery>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Discovery`. */
export interface IDiscoveryEdge {
  __typename?: 'DiscoveryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IDiscovery>;
}

/** A filter input for the type `Discovery`. */
export interface IDiscoveryFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IDiscoveryFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IDiscoveryFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IDiscoveryFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Discovery`. */
export enum IDiscoveryOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IDiscoverySlide extends IElement {
  __typename?: 'DiscoverySlide';
  button_label?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /**
   * If left empty, content cover will be used
   * recommended size : 1000 x 1280
   */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** if left empty, content short description will be used */
  shortDescription?: Maybe<Scalars['String']>;
  slideContent?: Maybe<IContent>;
  /** If left empty content title will be used */
  title?: Maybe<Scalars['String']>;
}


export interface IDiscoverySlideButton_LabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlideCoverArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlideShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlideTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IDiscoverySlide1 extends IContent, IElement {
  __typename?: 'DiscoverySlide1';
  /** The ancestors. */
  ancestors: IContentConnection;
  button_label?: Maybe<Scalars['String']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** this will not automatically unpublish the slide, you'll still need to do this manually */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** this is only used for clarification on the list view */
  previewForAdministrator?: Maybe<Scalars['String']>;
  /** if left empty, content short description will be used */
  shortDescription?: Maybe<Scalars['String']>;
  slideContent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** this will not automatically publish the slide, you'll still need to do this manually */
  startDate?: Maybe<Scalars['DateTime']>;
  /** If left empty content title will be used */
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IDiscoverySlide1AncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IDiscoverySlide1Button_LabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlide1ChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IDiscoverySlide1CoverArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlide1DescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IDiscoverySlide1NameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlide1ParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlide1ShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlide1TitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlide1UpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IDiscoverySlide1UrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `DiscoverySlide1`. */
export interface IDiscoverySlide1Connection {
  __typename?: 'DiscoverySlide1Connection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IDiscoverySlide1Edge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IDiscoverySlide1>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `DiscoverySlide1`. */
export interface IDiscoverySlide1Edge {
  __typename?: 'DiscoverySlide1Edge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IDiscoverySlide1>;
}

/** A filter input for the type `DiscoverySlide1`. */
export interface IDiscoverySlide1FilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IDiscoverySlide1FilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IDiscoverySlide1FilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IDiscoverySlide1FilterInput>>>;
  /** Field must equal value. */
  button_label?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  button_label_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  button_label_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  button_label_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  button_label_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  previewForAdministrator?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewForAdministrator_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewForAdministrator_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewForAdministrator_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewForAdministrator_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  slideContent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `DiscoverySlide1`. */
export enum IDiscoverySlide1OrderByInput {
  /** Order by `button_label` in ascending order. */
  ButtonLabelAsc = 'button_label_ASC',
  /** Order by `button_label` in descending order. */
  ButtonLabelDesc = 'button_label_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `previewForAdministrator` in ascending order. */
  PreviewForAdministratorAsc = 'previewForAdministrator_ASC',
  /** Order by `previewForAdministrator` in descending order. */
  PreviewForAdministratorDesc = 'previewForAdministrator_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `slideContent` in ascending order. */
  SlideContentAsc = 'slideContent_ASC',
  /** Order by `slideContent` in descending order. */
  SlideContentDesc = 'slideContent_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** slider with a title and basic slides */
export interface IEditoSlider extends IElement {
  __typename?: 'EditoSlider';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  slides?: Maybe<Array<Maybe<IBlockListItem>>>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** slider with a title and basic slides */
export interface IEditoSliderSlidesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** slider with a title and basic slides */
export interface IEditoSliderSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** slider with a title and basic slides */
export interface IEditoSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** The Element interface. */
export interface IElement {
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
}

export interface IEntrepreunarialHub extends IContent, IElement {
  __typename?: 'EntrepreunarialHub';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  hubCourses?: Maybe<IContent>;
  hubTitle?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  tips?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IEntrepreunarialHubAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IEntrepreunarialHubChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IEntrepreunarialHubDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IEntrepreunarialHubHubCoursesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IEntrepreunarialHubHubTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IEntrepreunarialHubNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IEntrepreunarialHubParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IEntrepreunarialHubTipsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IEntrepreunarialHubUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IEntrepreunarialHubUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `EntrepreunarialHub`. */
export interface IEntrepreunarialHubConnection {
  __typename?: 'EntrepreunarialHubConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IEntrepreunarialHubEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IEntrepreunarialHub>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `EntrepreunarialHub`. */
export interface IEntrepreunarialHubEdge {
  __typename?: 'EntrepreunarialHubEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IEntrepreunarialHub>;
}

/** A filter input for the type `EntrepreunarialHub`. */
export interface IEntrepreunarialHubFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IEntrepreunarialHubFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IEntrepreunarialHubFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IEntrepreunarialHubFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  hubCourses?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  hubTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  hubTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  hubTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  hubTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  hubTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `EntrepreunarialHub`. */
export enum IEntrepreunarialHubOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `hubCourses` in ascending order. */
  HubCoursesAsc = 'hubCourses_ASC',
  /** Order by `hubCourses` in descending order. */
  HubCoursesDesc = 'hubCourses_DESC',
  /** Order by `hubTitle` in ascending order. */
  HubTitleAsc = 'hubTitle_ASC',
  /** Order by `hubTitle` in descending order. */
  HubTitleDesc = 'hubTitle_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IExpandMenu extends IElement {
  __typename?: 'ExpandMenu';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  links?: Maybe<Array<Maybe<IBlockListItem>>>;
  title?: Maybe<Scalars['String']>;
}


export interface IExpandMenuLinksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IExpandMenuTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IExternalLink extends IElement {
  __typename?: 'ExternalLink';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  externalUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


export interface IExternalLinkExternalUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IExternalLinkTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** for FAQ Items */
export interface IFaqItem extends IElement {
  __typename?: 'FaqItem';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  htmlContent?: Maybe<Scalars['HTML']>;
  showForm?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
}


/** for FAQ Items */
export interface IFaqItemHtmlContentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for FAQ Items */
export interface IFaqItemShowFormArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for FAQ Items */
export interface IFaqItemTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IFaqPageLink extends IElement {
  __typename?: 'FaqPageLink';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  helpdeskCategoriesPicker?: Maybe<Array<Maybe<IContent>>>;
  title?: Maybe<Scalars['String']>;
}

export interface IFile extends IMedia {
  __typename?: 'File';
  /** The ancestors. */
  ancestors: IMediaConnection;
  /** The children. */
  children: IMediaConnection;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IMediaConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The Media Type alias. */
  mediaTypeAlias: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
  /** The parent Media, can be null if Media is at root. */
  parent?: Maybe<IMedia>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** in bytes */
  umbracoBytes?: Maybe<Scalars['String']>;
  umbracoExtension?: Maybe<Scalars['String']>;
  umbracoFile?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate: Scalars['DateTime'];
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IFileAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IFileChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IFileDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IFileUmbracoFileArgs {
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}


export interface IFileUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IFileUrlArgs {
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  culture?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface IFolder extends IMedia {
  __typename?: 'Folder';
  /** The ancestors. */
  ancestors: IMediaConnection;
  /** The children. */
  children: IMediaConnection;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IMediaConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The Media Type alias. */
  mediaTypeAlias: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
  /** The parent Media, can be null if Media is at root. */
  parent?: Maybe<IMedia>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate: Scalars['DateTime'];
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IFolderUrlArgs {
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  culture?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface IFormFolder extends IContent, IElement {
  __typename?: 'FormFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IFormFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IFormFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IFormFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IFormFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IFormFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IFormFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IFormFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `FormFolder`. */
export interface IFormFolderConnection {
  __typename?: 'FormFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IFormFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IFormFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `FormFolder`. */
export interface IFormFolderEdge {
  __typename?: 'FormFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IFormFolder>;
}

/** A filter input for the type `FormFolder`. */
export interface IFormFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IFormFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IFormFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IFormFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `FormFolder`. */
export enum IFormFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A Page to display a form, the form should be created by an admin first */
export interface IFormPage extends IContent, IElement, IPage {
  __typename?: 'FormPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  form?: Maybe<Scalars['JSON']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageFormArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A Page to display a form, the form should be created by an admin first */
export interface IFormPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `FormPage`. */
export interface IFormPageConnection {
  __typename?: 'FormPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IFormPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IFormPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `FormPage`. */
export interface IFormPageEdge {
  __typename?: 'FormPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IFormPage>;
}

/** A filter input for the type `FormPage`. */
export interface IFormPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IFormPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IFormPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IFormPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `FormPage`. */
export enum IFormPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IGallery extends IElement {
  __typename?: 'Gallery';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  gallery?: Maybe<Array<Maybe<IMediaWithCrops>>>;
  intro?: Maybe<Scalars['String']>;
  overTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** Gap Fill nugget answer */
export interface IGapFillNuggetAnswer extends IElement {
  __typename?: 'GapFillNuggetAnswer';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  negativeFeedback?: Maybe<Scalars['String']>;
  positiveFeedback?: Maybe<Scalars['String']>;
  /**
   * type in the code you use in the question part (ie: [REPONSE])
   *
   * Leave blank for incorrect answers
   */
  reference?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<IBlockListItem>>>;
}

/** Gap Fill nugget answer */
export interface IGapFillNuggetImageAnswer extends IElement {
  __typename?: 'GapFillNuggetImageAnswer';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  negativeFeedback?: Maybe<Scalars['String']>;
  positiveFeedback?: Maybe<Scalars['String']>;
  /**
   * type in the code you use in the question part (ie: [REPONSE])
   *
   * Leave blank for incorrect answers
   */
  reference?: Maybe<Scalars['String']>;
  referenceImage?: Maybe<IMediaWithCrops>;
  values?: Maybe<Array<Maybe<IBlockListItem>>>;
}

/** Nugget with Text references */
export interface IGapfillNugget extends IContent, IElement, INuggetFeedbackCmp {
  __typename?: 'GapfillNugget';
  /** The ancestors. */
  ancestors: IContentConnection;
  body?: Maybe<Scalars['HTML']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  /** Tick to use the feedbacks below for empty choices' feebacks */
  genericFeedback?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  negativeFeedback?: Maybe<Scalars['String']>;
  /** create the options values. Each [REPONSE] shortcode in the Question should have a referenced option here. */
  options?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  positiveFeedback?: Maybe<Scalars['String']>;
  /**
   * use [QUESTION] format to insert a gap to fill
   *
   * Leave empty for Tap To Match
   */
  question?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with Text references */
export interface IGapfillNuggetBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with Text references */
export interface IGapfillNuggetDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with Text references */
export interface IGapfillNuggetNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetNegativeFeedbackArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetOptionsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetPositiveFeedbackArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetQuestionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with Text references */
export interface IGapfillNuggetUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `GapfillNugget`. */
export interface IGapfillNuggetConnection {
  __typename?: 'GapfillNuggetConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IGapfillNuggetEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IGapfillNugget>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `GapfillNugget`. */
export interface IGapfillNuggetEdge {
  __typename?: 'GapfillNuggetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IGapfillNugget>;
}

/** A filter input for the type `GapfillNugget`. */
export interface IGapfillNuggetFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IGapfillNuggetFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IGapfillNuggetFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IGapfillNuggetFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  genericFeedback?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  negativeFeedback?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  negativeFeedback_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  negativeFeedback_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  negativeFeedback_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  negativeFeedback_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  positiveFeedback?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  positiveFeedback_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  positiveFeedback_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  positiveFeedback_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  positiveFeedback_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  question?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  question_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  question_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  question_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  question_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `GapfillNugget`. */
export enum IGapfillNuggetOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `genericFeedback` in ascending order. */
  GenericFeedbackAsc = 'genericFeedback_ASC',
  /** Order by `genericFeedback` in descending order. */
  GenericFeedbackDesc = 'genericFeedback_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `negativeFeedback` in ascending order. */
  NegativeFeedbackAsc = 'negativeFeedback_ASC',
  /** Order by `negativeFeedback` in descending order. */
  NegativeFeedbackDesc = 'negativeFeedback_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `positiveFeedback` in ascending order. */
  PositiveFeedbackAsc = 'positiveFeedback_ASC',
  /** Order by `positiveFeedback` in descending order. */
  PositiveFeedbackDesc = 'positiveFeedback_DESC',
  /** Order by `question` in ascending order. */
  QuestionAsc = 'question_ASC',
  /** Order by `question` in descending order. */
  QuestionDesc = 'question_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IHelpdeskCateg extends IContent, IElement {
  __typename?: 'HelpdeskCateg';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  faqItems?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IHelpdeskCategAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IHelpdeskCategChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IHelpdeskCategDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IHelpdeskCategFaqItemsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskCategNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskCategParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskCategTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskCategUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskCategUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `HelpdeskCateg`. */
export interface IHelpdeskCategConnection {
  __typename?: 'HelpdeskCategConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IHelpdeskCategEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IHelpdeskCateg>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `HelpdeskCateg`. */
export interface IHelpdeskCategEdge {
  __typename?: 'HelpdeskCategEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IHelpdeskCateg>;
}

/** A filter input for the type `HelpdeskCateg`. */
export interface IHelpdeskCategFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IHelpdeskCategFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IHelpdeskCategFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IHelpdeskCategFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `HelpdeskCateg`. */
export enum IHelpdeskCategOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IHelpdeskFolder extends IContent, IElement {
  __typename?: 'HelpdeskFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  zendeskForm?: Maybe<Scalars['JSON']>;
}


export interface IHelpdeskFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IHelpdeskFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IHelpdeskFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IHelpdeskFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHelpdeskFolderZendeskFormArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `HelpdeskFolder`. */
export interface IHelpdeskFolderConnection {
  __typename?: 'HelpdeskFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IHelpdeskFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IHelpdeskFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `HelpdeskFolder`. */
export interface IHelpdeskFolderEdge {
  __typename?: 'HelpdeskFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IHelpdeskFolder>;
}

/** A filter input for the type `HelpdeskFolder`. */
export interface IHelpdeskFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IHelpdeskFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IHelpdeskFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IHelpdeskFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `HelpdeskFolder`. */
export enum IHelpdeskFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPage extends IContent, IElement, IPage {
  __typename?: 'HelpdeskPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  push?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  topics?: Maybe<Array<Maybe<IContent>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPagePushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPageTopicsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** A page that lists some Helpdesk Categories */
export interface IHelpdeskPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `HelpdeskPage`. */
export interface IHelpdeskPageConnection {
  __typename?: 'HelpdeskPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IHelpdeskPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IHelpdeskPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `HelpdeskPage`. */
export interface IHelpdeskPageEdge {
  __typename?: 'HelpdeskPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IHelpdeskPage>;
}

/** A filter input for the type `HelpdeskPage`. */
export interface IHelpdeskPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IHelpdeskPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IHelpdeskPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IHelpdeskPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  topics_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  topics_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `HelpdeskPage`. */
export enum IHelpdeskPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IHeroBanner extends IElement {
  __typename?: 'HeroBanner';
  /** recommanded : 1920x823 */
  backgroundImage?: Maybe<IMediaWithCrops>;
  /**
   * Desktop will be cropped if not set
   * recommanded : 1000x1280
   */
  backgroundImageMobile?: Maybe<IMediaWithCrops>;
  cTA?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface IHeroBanner1 extends IElement {
  __typename?: 'HeroBanner1';
  /** (21:9) */
  backgroundImage?: Maybe<IMediaWithCrops>;
  /** (3:4) */
  backgroundImageMobile?: Maybe<IMediaWithCrops>;
  cTA?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  /** content alignement */
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface IHeroServices extends IElement {
  __typename?: 'HeroServices';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cta?: Maybe<Array<Maybe<IBlockListItem>>>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<IMediaWithCrops>;
  /** if Show in menu is thicked */
  navigationIcon?: Maybe<Scalars['String']>;
  /** if Show in menu is thicked */
  navigationTitle?: Maybe<Scalars['String']>;
  overtitle?: Maybe<Scalars['String']>;
  services?: Maybe<Array<Maybe<IBlockListItem>>>;
  showInMenu?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
}

export interface IHeroSlide extends IElement {
  __typename?: 'HeroSlide';
  button?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  highlights?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
}


export interface IHeroSlideHighlightsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IHeroSlideTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IHeroSliderCmp {
  autoloop?: Maybe<Scalars['Boolean']>;
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  heroSlider?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** (milli seconds) */
  loopDelay?: Maybe<Scalars['Int']>;
}


export interface IHeroSliderCmpHeroSliderArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IHeroVideoCover extends IElement {
  __typename?: 'HeroVideoCover';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /**
   * if not set mobile image will be cropped for Desktop
   * recommanded : 1920x823
   */
  desktopImage?: Maybe<IMediaWithCrops>;
  /**
   * will be used as video cover if video is set
   * recommanded : 1000 x 1280
   */
  image?: Maybe<IMediaWithCrops>;
  /** edit this value to re-center the video in the cover */
  videoCenter?: Maybe<Scalars['Decimal']>;
  /** 🛑 Do not edit ! This is automatically calculated at first play. */
  vimeoHlsUrl?: Maybe<Scalars['String']>;
  vimeoVideoId?: Maybe<Scalars['Int']>;
}

/** The main Page for a Region with Discovery slider */
export interface IHomePage extends IContent, IElement, IPage {
  __typename?: 'HomePage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** depreceated */
  autoloop?: Maybe<Scalars['Boolean']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** depreceated */
  discoverySlider?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** depreceated */
  loopDelay?: Maybe<Scalars['Int']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** The main Page for a Region with Discovery slider */
export interface IHomePageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** The main Page for a Region with Discovery slider */
export interface IHomePageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** The main Page for a Region with Discovery slider */
export interface IHomePageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** The main Page for a Region with Discovery slider */
export interface IHomePageDiscoverySliderArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** The main Page for a Region with Discovery slider */
export interface IHomePageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** The main Page for a Region with Discovery slider */
export interface IHomePageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** The main Page for a Region with Discovery slider */
export interface IHomePageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** The main Page for a Region with Discovery slider */
export interface IHomePageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `HomePage`. */
export interface IHomePageConnection {
  __typename?: 'HomePageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IHomePageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IHomePage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `HomePage`. */
export interface IHomePageEdge {
  __typename?: 'HomePageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IHomePage>;
}

/** A filter input for the type `HomePage`. */
export interface IHomePageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IHomePageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IHomePageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IHomePageFilterInput>>>;
  /** Field must equal value. */
  autoloop?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  loopDelay?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  loopDelay_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  loopDelay_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  loopDelay_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  loopDelay_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  loopDelay_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `HomePage`. */
export enum IHomePageOrderByInput {
  /** Order by `autoloop` in ascending order. */
  AutoloopAsc = 'autoloop_ASC',
  /** Order by `autoloop` in descending order. */
  AutoloopDesc = 'autoloop_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `loopDelay` in ascending order. */
  LoopDelayAsc = 'loopDelay_ASC',
  /** Order by `loopDelay` in descending order. */
  LoopDelayDesc = 'loopDelay_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** a slide with title overtitle, text and background cover */
export interface IIconSlide extends IElement {
  __typename?: 'IconSlide';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  icon?: Maybe<IMediaWithCrops>;
  overtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** a slide with title overtitle, text and background cover */
export interface IIconSlideOvertitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** a slide with title overtitle, text and background cover */
export interface IIconSlideTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IImage extends IMedia {
  __typename?: 'Image';
  /** The ancestors. */
  ancestors: IMediaConnection;
  /** The children. */
  children: IMediaConnection;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IMediaConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The Media Type alias. */
  mediaTypeAlias: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
  /** The parent Media, can be null if Media is at root. */
  parent?: Maybe<IMedia>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** in bytes */
  umbracoBytes?: Maybe<Scalars['String']>;
  umbracoExtension?: Maybe<Scalars['String']>;
  umbracoFile?: Maybe<IImageCropper>;
  /** in pixels */
  umbracoHeight?: Maybe<Scalars['String']>;
  /** in pixels */
  umbracoWidth?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate: Scalars['DateTime'];
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IImageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IImageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IImageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IImageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IImageUrlArgs {
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  culture?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export enum IImageCropAnchor {
  /** Anchors the position of the image to the bottom of it's bounding container. */
  Bottom = 'BOTTOM',
  /** Anchors the position of the image to the bottom left side of it's bounding container. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Anchors the position of the image to the bottom right side of it's bounding container. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Anchors the position of the image to the center of it's bounding container. */
  Center = 'CENTER',
  /** Anchors the position of the image to the left of it's bounding container. */
  Left = 'LEFT',
  /** Anchors the position of the image to the right of it's bounding container. */
  Right = 'RIGHT',
  /** Anchors the position of the image to the top of it's bounding container. */
  Top = 'TOP',
  /** Anchors the position of the image to the top left side of it's bounding container. */
  TopLeft = 'TOP_LEFT',
  /** Anchors the position of the image to the top right side of it's bounding container. */
  TopRight = 'TOP_RIGHT'
}

export enum IImageCropFormat {
  Gif = 'GIF',
  Jpg = 'JPG',
  Png = 'PNG',
  Webp = 'WEBP'
}

export enum IImageCropMode {
  /** When upscaling an image the image pixels themselves are not resized, rather the image is padded to fit the given dimensions. */
  BoxPad = 'BOX_PAD',
  /** Resizes the image to the given dimensions. If the set dimensions do not match the aspect ratio of the original image then the output is cropped to match the new aspect ratio. */
  Crop = 'CROP',
  /** Resizes the image to the given dimensions. If the set dimensions do not match the aspect ratio of the original image then the output is resized to the maximum possible value in each direction while maintaining the original aspect ratio. */
  Max = 'MAX',
  /** Resizes the image until the shortest side reaches the set given dimension. This will maintain the aspect ratio of the original image. Upscaling is disabled in this mode and the original image will be returned if attempted. */
  Min = 'MIN',
  /** Passing a single dimension will automatically preserve the aspect ratio of the original image. If the requested aspect ratio is different then the image will be padded to fit. */
  Pad = 'PAD',
  /** Resizes the image to the given dimensions. If the set dimensions do not match the aspect ratio of the original image then the output is stretched to match the new aspect ratio. */
  Stretch = 'STRETCH'
}

export enum IImageCropRatioMode {
  /** Calculate the image ratio based on the height. */
  Height = 'HEIGHT',
  /** Calculate the image ratio based on the width. */
  Width = 'WIDTH'
}

export interface IImageCropper {
  __typename?: 'ImageCropper';
  /** The image url with crop parameters. */
  cropUrl?: Maybe<Scalars['String']>;
  /** The predefined crops. */
  crops: Array<Maybe<IImageCropperCrop>>;
  /** The focal point position. */
  focalPoint: IImageCropperFocalPoint;
  /** The focal point url template. */
  focalPointUrlTemplate: Scalars['String'];
  /** The image url. */
  url?: Maybe<Scalars['String']>;
}


export interface IImageCropperCropUrlArgs {
  alias?: InputMaybe<Scalars['String']>;
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  preferFocalPoint?: InputMaybe<Scalars['Boolean']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface IImageCropperCrop {
  __typename?: 'ImageCropperCrop';
  /** The crop alias. */
  alias: Scalars['String'];
  /** The crop coordinates. */
  coordinates?: Maybe<IImageCropperCropCoordinates>;
  /** The crop height. */
  height: Scalars['Int'];
  /** The crop width. */
  width: Scalars['Int'];
}

export interface IImageCropperCropCoordinates {
  __typename?: 'ImageCropperCropCoordinates';
  x1: Scalars['Decimal'];
  x2: Scalars['Decimal'];
  y1: Scalars['Decimal'];
  y2: Scalars['Decimal'];
}

export interface IImageCropperFocalPoint {
  __typename?: 'ImageCropperFocalPoint';
  /** The left position. */
  left: Scalars['Decimal'];
  /** The top position. */
  top: Scalars['Decimal'];
}

export interface IInternalLink extends IElement {
  __typename?: 'InternalLink';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** fix */
  link?: Maybe<IContent>;
}

export interface IJobBoardPage extends IContent, IElement, IHeroSliderCmp, IPage, ITopMenuComp {
  __typename?: 'JobBoardPage';
  /** Highlighted opportunities */
  activeOppotunities?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  autoloop?: Maybe<Scalars['Boolean']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  heroSlider?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** Highlighted job hubs */
  jobHubs?: Maybe<Array<Maybe<IContent>>>;
  /** Highlighted vacancies */
  jobVancancies?: Maybe<Array<Maybe<IContent>>>;
  /** The level. */
  level: Scalars['Int'];
  /** (milli seconds) */
  loopDelay?: Maybe<Scalars['Int']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** Highlighted partners */
  partners?: Maybe<Array<Maybe<IContent>>>;
  push?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  tipsSlides?: Maybe<Array<Maybe<IBlockListItem>>>;
  topMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IJobBoardPageActiveOppotunitiesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobBoardPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobBoardPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobBoardPageHeroSliderArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageJobHubsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageJobVancanciesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPagePartnersArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPagePushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageTipsSlidesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageTopMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobBoardPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobBoardPage`. */
export interface IJobBoardPageConnection {
  __typename?: 'JobBoardPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobBoardPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobBoardPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobBoardPage`. */
export interface IJobBoardPageEdge {
  __typename?: 'JobBoardPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobBoardPage>;
}

/** A filter input for the type `JobBoardPage`. */
export interface IJobBoardPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobBoardPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobBoardPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobBoardPageFilterInput>>>;
  /** Field must match all of the values. */
  activeOppotunities_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  activeOppotunities_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  autoloop?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must match all of the values. */
  jobHubs_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  jobHubs_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  jobVancancies_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  jobVancancies_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  loopDelay?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  loopDelay_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  loopDelay_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  loopDelay_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  loopDelay_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  loopDelay_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `JobBoardPage`. */
export enum IJobBoardPageOrderByInput {
  /** Order by `autoloop` in ascending order. */
  AutoloopAsc = 'autoloop_ASC',
  /** Order by `autoloop` in descending order. */
  AutoloopDesc = 'autoloop_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `loopDelay` in ascending order. */
  LoopDelayAsc = 'loopDelay_ASC',
  /** Order by `loopDelay` in descending order. */
  LoopDelayDesc = 'loopDelay_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IJobHub extends IContent, IElement {
  __typename?: 'JobHub';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** Link to the platform */
  link?: Maybe<Scalars['String']>;
  longDescription?: Maybe<Scalars['String']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IJobHubAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobHubChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobHubDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobHubLinkArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubLongDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobHub`. */
export interface IJobHubConnection {
  __typename?: 'JobHubConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobHubEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobHub>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobHub`. */
export interface IJobHubEdge {
  __typename?: 'JobHubEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobHub>;
}

/** A filter input for the type `JobHub`. */
export interface IJobHubFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobHubFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobHubFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobHubFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  country?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  country_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  country_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  country_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  country_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  link?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  link_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  link_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  link_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  link_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  longDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  longDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  longDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  longDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  longDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `JobHub`. */
export enum IJobHubOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `country` in ascending order. */
  CountryAsc = 'country_ASC',
  /** Order by `country` in descending order. */
  CountryDesc = 'country_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `link` in ascending order. */
  LinkAsc = 'link_ASC',
  /** Order by `link` in descending order. */
  LinkDesc = 'link_DESC',
  /** Order by `longDescription` in ascending order. */
  LongDescriptionAsc = 'longDescription_ASC',
  /** Order by `longDescription` in descending order. */
  LongDescriptionDesc = 'longDescription_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IJobHubsFolder extends IContent, IElement {
  __typename?: 'JobHubsFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IJobHubsFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobHubsFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobHubsFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobHubsFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubsFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubsFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobHubsFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobHubsFolder`. */
export interface IJobHubsFolderConnection {
  __typename?: 'JobHubsFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobHubsFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobHubsFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobHubsFolder`. */
export interface IJobHubsFolderEdge {
  __typename?: 'JobHubsFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobHubsFolder>;
}

/** A filter input for the type `JobHubsFolder`. */
export interface IJobHubsFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobHubsFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobHubsFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobHubsFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `JobHubsFolder`. */
export enum IJobHubsFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IJobProgress extends IContent, IElement {
  __typename?: 'JobProgress';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  dateCompleted?: Maybe<Scalars['DateTime']>;
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  job?: Maybe<IContent>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IJobProgressAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobProgressChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobProgressDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobProgressNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobProgressParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobProgressUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobProgressUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobProgress`. */
export interface IJobProgressConnection {
  __typename?: 'JobProgressConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobProgressEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobProgress>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobProgress`. */
export interface IJobProgressEdge {
  __typename?: 'JobProgressEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobProgress>;
}

/** A filter input for the type `JobProgress`. */
export interface IJobProgressFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobProgressFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobProgressFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobProgressFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  dateCompleted_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  dateCompleted_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  dateCompleted_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  dateCompleted_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  job?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  status?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  status_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  status_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  status_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  status_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `JobProgress`. */
export enum IJobProgressOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `dateCompleted` in ascending order. */
  DateCompletedAsc = 'dateCompleted_ASC',
  /** Order by `dateCompleted` in descending order. */
  DateCompletedDesc = 'dateCompleted_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `job` in ascending order. */
  JobAsc = 'job_ASC',
  /** Order by `job` in descending order. */
  JobDesc = 'job_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `status` in ascending order. */
  StatusAsc = 'status_ASC',
  /** Order by `status` in descending order. */
  StatusDesc = 'status_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** formerly Job share */
export interface IJobShare extends IContent, IElement {
  __typename?: 'JobShare';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  course?: Maybe<IContent>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  totalShares?: Maybe<Scalars['Int']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** formerly Job share */
export interface IJobShareAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** formerly Job share */
export interface IJobShareChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** formerly Job share */
export interface IJobShareDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** formerly Job share */
export interface IJobShareNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** formerly Job share */
export interface IJobShareParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** formerly Job share */
export interface IJobShareUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** formerly Job share */
export interface IJobShareUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobShare`. */
export interface IJobShareConnection {
  __typename?: 'JobShareConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobShareEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobShare>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobShare`. */
export interface IJobShareEdge {
  __typename?: 'JobShareEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobShare>;
}

/** A filter input for the type `JobShare`. */
export interface IJobShareFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobShareFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobShareFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobShareFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  course?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  totalShares?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  totalShares_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  totalShares_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  totalShares_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  totalShares_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  totalShares_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `JobShare`. */
export enum IJobShareOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `course` in ascending order. */
  CourseAsc = 'course_ASC',
  /** Order by `course` in descending order. */
  CourseDesc = 'course_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `totalShares` in ascending order. */
  TotalSharesAsc = 'totalShares_ASC',
  /** Order by `totalShares` in descending order. */
  TotalSharesDesc = 'totalShares_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Certificates (job training) */
export interface IJobTraining extends IContent, IElement {
  __typename?: 'JobTraining';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  courses?: Maybe<Array<Maybe<IContent>>>;
  coursesCertificates?: Maybe<Scalars['Int']>;
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  externalTags?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  lastUpdate?: Maybe<Scalars['DateTime']>;
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  multimediaUnits?: Maybe<Scalars['Int']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  quizzes?: Maybe<Scalars['Boolean']>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** Vimeo ID for trailer video */
  trailer?: Maybe<Scalars['Int']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  videosCount?: Maybe<Scalars['Int']>;
}


/** Certificates (job training) */
export interface IJobTrainingAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Certificates (job training) */
export interface IJobTrainingChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Certificates (job training) */
export interface IJobTrainingDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Certificates (job training) */
export interface IJobTrainingDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingExternalTagsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingLengthArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingTrailerArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Certificates (job training) */
export interface IJobTrainingUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobTraining`. */
export interface IJobTrainingConnection {
  __typename?: 'JobTrainingConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobTrainingEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobTraining>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobTraining`. */
export interface IJobTrainingEdge {
  __typename?: 'JobTrainingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobTraining>;
}

/** A filter input for the type `JobTraining`. */
export interface IJobTrainingFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobTrainingFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobTrainingFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobTrainingFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  coursesCertificates?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  coursesCertificates_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  coursesCertificates_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  coursesCertificates_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  coursesCertificates_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  coursesCertificates_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  courses_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  courses_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  externalTags?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalTags_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalTags_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalTags_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalTags_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  lastUpdate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  lastUpdate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  lastUpdate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  lastUpdate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  multimediaUnits?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  multimediaUnits_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  multimediaUnits_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  multimediaUnits_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  multimediaUnits_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  multimediaUnits_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  quizzes?: InputMaybe<Scalars['Boolean']>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  trailer?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  trailer_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  trailer_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  trailer_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  trailer_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  trailer_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  videosCount?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  videosCount_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  videosCount_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  videosCount_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  videosCount_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  videosCount_lte?: InputMaybe<Scalars['Int']>;
}

export interface IJobTrainingFolder extends IContent, IElement {
  __typename?: 'JobTrainingFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IJobTrainingFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobTrainingFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobTrainingFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobTrainingFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobTrainingFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobTrainingFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobTrainingFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobTrainingFolder`. */
export interface IJobTrainingFolderConnection {
  __typename?: 'JobTrainingFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobTrainingFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobTrainingFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobTrainingFolder`. */
export interface IJobTrainingFolderEdge {
  __typename?: 'JobTrainingFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobTrainingFolder>;
}

/** A filter input for the type `JobTrainingFolder`. */
export interface IJobTrainingFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobTrainingFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobTrainingFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobTrainingFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `JobTrainingFolder`. */
export enum IJobTrainingFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `JobTraining`. */
export enum IJobTrainingOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `coursesCertificates` in ascending order. */
  CoursesCertificatesAsc = 'coursesCertificates_ASC',
  /** Order by `coursesCertificates` in descending order. */
  CoursesCertificatesDesc = 'coursesCertificates_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `externalTags` in ascending order. */
  ExternalTagsAsc = 'externalTags_ASC',
  /** Order by `externalTags` in descending order. */
  ExternalTagsDesc = 'externalTags_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `lastUpdate` in ascending order. */
  LastUpdateAsc = 'lastUpdate_ASC',
  /** Order by `lastUpdate` in descending order. */
  LastUpdateDesc = 'lastUpdate_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `multimediaUnits` in ascending order. */
  MultimediaUnitsAsc = 'multimediaUnits_ASC',
  /** Order by `multimediaUnits` in descending order. */
  MultimediaUnitsDesc = 'multimediaUnits_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `quizzes` in ascending order. */
  QuizzesAsc = 'quizzes_ASC',
  /** Order by `quizzes` in descending order. */
  QuizzesDesc = 'quizzes_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `trailer` in ascending order. */
  TrailerAsc = 'trailer_ASC',
  /** Order by `trailer` in descending order. */
  TrailerDesc = 'trailer_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `videosCount` in ascending order. */
  VideosCountAsc = 'videosCount_ASC',
  /** Order by `videosCount` in descending order. */
  VideosCountDesc = 'videosCount_DESC'
}

export interface IJobVacanciesFolder extends IContent, IElement {
  __typename?: 'JobVacanciesFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IJobVacanciesFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobVacanciesFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobVacanciesFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IJobVacanciesFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobVacanciesFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobVacanciesFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IJobVacanciesFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobVacanciesFolder`. */
export interface IJobVacanciesFolderConnection {
  __typename?: 'JobVacanciesFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobVacanciesFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobVacanciesFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobVacanciesFolder`. */
export interface IJobVacanciesFolderEdge {
  __typename?: 'JobVacanciesFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobVacanciesFolder>;
}

/** A filter input for the type `JobVacanciesFolder`. */
export interface IJobVacanciesFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobVacanciesFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobVacanciesFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobVacanciesFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `JobVacanciesFolder`. */
export enum IJobVacanciesFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Job opportunities */
export interface IJobVacancy extends IContent, IElement {
  __typename?: 'JobVacancy';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** Mandatory Certificate to access this opportunity (leave empty if the opportunity is free) */
  certificate?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** use this field if you leave Partners empty */
  companyName?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  contractType?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  courses?: Maybe<Array<Maybe<IContent>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  interests?: Maybe<Array<Maybe<IContent>>>;
  /** The level. */
  level: Scalars['Int'];
  /** Leave empty if you want to create an opportunity page */
  link?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  personalities?: Maybe<Array<Maybe<IContent>>>;
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Job opportunities */
export interface IJobVacancyCertificateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Job opportunities */
export interface IJobVacancyCompanyNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyContractTypeArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyCoursesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Job opportunities */
export interface IJobVacancyLinkArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyLocationArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyPartnersArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunities */
export interface IJobVacancyUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `JobVacancy`. */
export interface IJobVacancyConnection {
  __typename?: 'JobVacancyConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IJobVacancyEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IJobVacancy>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `JobVacancy`. */
export interface IJobVacancyEdge {
  __typename?: 'JobVacancyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IJobVacancy>;
}

/** A filter input for the type `JobVacancy`. */
export interface IJobVacancyFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IJobVacancyFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IJobVacancyFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IJobVacancyFilterInput>>>;
  /** Field must match all of the values. */
  certificate_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  certificate_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  companyName?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  companyName_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  companyName_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  companyName_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  companyName_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contractType?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contractType_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contractType_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contractType_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contractType_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  country?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  country_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  country_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  country_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  country_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  courses_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  courses_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  link?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  link_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  link_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  link_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  link_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  location?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  location_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  location_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  location_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  location_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  personalities_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  personalities_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `JobVacancy`. */
export enum IJobVacancyOrderByInput {
  /** Order by `companyName` in ascending order. */
  CompanyNameAsc = 'companyName_ASC',
  /** Order by `companyName` in descending order. */
  CompanyNameDesc = 'companyName_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `contractType` in ascending order. */
  ContractTypeAsc = 'contractType_ASC',
  /** Order by `contractType` in descending order. */
  ContractTypeDesc = 'contractType_DESC',
  /** Order by `country` in ascending order. */
  CountryAsc = 'country_ASC',
  /** Order by `country` in descending order. */
  CountryDesc = 'country_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `link` in ascending order. */
  LinkAsc = 'link_ASC',
  /** Order by `link` in descending order. */
  LinkDesc = 'link_DESC',
  /** Order by `location` in ascending order. */
  LocationAsc = 'location_ASC',
  /** Order by `location` in descending order. */
  LocationDesc = 'location_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IKeyFigure extends IElement {
  __typename?: 'KeyFigure';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  figure?: Maybe<Scalars['String']>;
}


export interface IKeyFigureDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IKeyFigureFigureArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IKeyFigures extends IElement {
  __typename?: 'KeyFigures';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  list?: Maybe<Array<Maybe<IBlockListItem>>>;
}


export interface IKeyFiguresListArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ILandingAbout extends IElement {
  __typename?: 'LandingAbout';
  cTA?: Maybe<Array<Maybe<IBlockListItem>>>;
  cards?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

export interface ILandingPage extends IContent, ICoverVideoCmp, IElement {
  __typename?: 'LandingPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  cTA?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  fixing?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pageBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  urlRewrite?: Maybe<Scalars['String']>;
}


export interface ILandingPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILandingPageCTaArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILandingPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILandingPageMetaDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPageMetaTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPagePageBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILandingPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `LandingPage`. */
export interface ILandingPageConnection {
  __typename?: 'LandingPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ILandingPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ILandingPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `LandingPage`. */
export interface ILandingPageEdge {
  __typename?: 'LandingPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ILandingPage>;
}

/** A filter input for the type `LandingPage`. */
export interface ILandingPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ILandingPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ILandingPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ILandingPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  fixing?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  fixing_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  fixing_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  fixing_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  fixing_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  metaDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  metaDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  metaDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  metaDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  metaDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  metaTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  metaTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  metaTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  metaTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  metaTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  urlRewrite?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  urlRewrite_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  urlRewrite_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  urlRewrite_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  urlRewrite_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `LandingPage`. */
export enum ILandingPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `fixing` in ascending order. */
  FixingAsc = 'fixing_ASC',
  /** Order by `fixing` in descending order. */
  FixingDesc = 'fixing_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `metaDescription` in ascending order. */
  MetaDescriptionAsc = 'metaDescription_ASC',
  /** Order by `metaDescription` in descending order. */
  MetaDescriptionDesc = 'metaDescription_DESC',
  /** Order by `metaTitle` in ascending order. */
  MetaTitleAsc = 'metaTitle_ASC',
  /** Order by `metaTitle` in descending order. */
  MetaTitleDesc = 'metaTitle_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `urlRewrite` in ascending order. */
  UrlRewriteAsc = 'urlRewrite_ASC',
  /** Order by `urlRewrite` in descending order. */
  UrlRewriteDesc = 'urlRewrite_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Hero Slider with partners logo */
export interface ILearnHeroSlide extends IElement {
  __typename?: 'LearnHeroSlide';
  button?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  title?: Maybe<Scalars['String']>;
}


/** Hero Slider with partners logo */
export interface ILearnHeroSlideTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ILearnMenu extends IContent, IElement {
  __typename?: 'LearnMenu';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  negativeResult?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** use {{course}} to display the course name */
  pageContent?: Maybe<Scalars['HTML']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  positiveResult?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** use {{course}} to display the course name */
  subtitle?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ILearnMenuAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILearnMenuChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILearnMenuCoverArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILearnMenuDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILearnMenuNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILearnMenuNegativeResultArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILearnMenuPageContentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILearnMenuParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILearnMenuPositiveResultArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILearnMenuSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILearnMenuUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILearnMenuUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `LearnMenu`. */
export interface ILearnMenuConnection {
  __typename?: 'LearnMenuConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ILearnMenuEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ILearnMenu>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `LearnMenu`. */
export interface ILearnMenuEdge {
  __typename?: 'LearnMenuEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ILearnMenu>;
}

/** A filter input for the type `LearnMenu`. */
export interface ILearnMenuFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ILearnMenuFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ILearnMenuFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ILearnMenuFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `LearnMenu`. */
export enum ILearnMenuOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ILegalPageLink extends IElement {
  __typename?: 'LegalPageLink';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  link?: Maybe<IContent>;
  title?: Maybe<Scalars['String']>;
}

export interface ILegalsFolder extends IContent, IElement {
  __typename?: 'LegalsFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ILegalsFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILegalsFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILegalsFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILegalsFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILegalsFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILegalsFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILegalsFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `LegalsFolder`. */
export interface ILegalsFolderConnection {
  __typename?: 'LegalsFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ILegalsFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ILegalsFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `LegalsFolder`. */
export interface ILegalsFolderEdge {
  __typename?: 'LegalsFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ILegalsFolder>;
}

/** A filter input for the type `LegalsFolder`. */
export interface ILegalsFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ILegalsFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ILegalsFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ILegalsFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `LegalsFolder`. */
export enum ILegalsFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ILink {
  __typename?: 'Link';
  /** The name of the Link. */
  name: Scalars['String'];
  /** The link target. */
  target?: Maybe<Scalars['String']>;
  /** The link type. */
  type: ILinkType;
  /** The link udi if type is CONTENT or MEDIA. */
  udi?: Maybe<Scalars['String']>;
  /** The url. */
  url: Scalars['String'];
}

export interface ILinkIcon extends IElement {
  __typename?: 'LinkIcon';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  link?: Maybe<Array<Maybe<IBlockListItem>>>;
  title?: Maybe<Scalars['String']>;
}


export interface ILinkIconTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ILinkPicker extends IElement {
  __typename?: 'LinkPicker';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  link?: Maybe<Array<Maybe<IBlockListItem>>>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


export interface ILinkPickerLinkArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILinkPickerSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILinkPickerTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export enum ILinkType {
  /** The link is a Content link. */
  Content = 'CONTENT',
  /** The link is an external link. */
  External = 'EXTERNAL',
  /** The link is a media link. */
  Media = 'MEDIA'
}

export interface IListenCateg extends IContent, IElement {
  __typename?: 'ListenCateg';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IListenCategAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IListenCategChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IListenCategDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IListenCategNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IListenCategParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IListenCategUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IListenCategUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ListenCateg`. */
export interface IListenCategConnection {
  __typename?: 'ListenCategConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IListenCategEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IListenCateg>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ListenCateg`. */
export interface IListenCategEdge {
  __typename?: 'ListenCategEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IListenCateg>;
}

/** A filter input for the type `ListenCateg`. */
export interface IListenCategFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IListenCategFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IListenCategFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IListenCategFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ListenCateg`. */
export enum IListenCategOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IListenMenu {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
}

export interface ILiveEvent extends IContent, IContentDescriptionCmp, IContentItems, IElement {
  __typename?: 'LiveEvent';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  channel?: Maybe<IContent>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  imageFormat?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<IContent>>>;
  /** The level. */
  level: Scalars['Int'];
  linkedJobs?: Maybe<Scalars['String']>;
  /** Live event ID or Vimeo Video ID */
  liveEventID?: Maybe<Scalars['Int']>;
  mogadorProductKey?: Maybe<Scalars['String']>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  personality?: Maybe<Array<Maybe<Scalars['String']>>>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** 300 char. max. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Other video source */
  sourceUrl?: Maybe<Scalars['String']>;
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
  subtitle?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ILiveEventAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventChannelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventLiveEventIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `LiveEvent`. */
export interface ILiveEventConnection {
  __typename?: 'LiveEventConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ILiveEventEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ILiveEvent>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `LiveEvent`. */
export interface ILiveEventEdge {
  __typename?: 'LiveEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ILiveEvent>;
}

/** A filter input for the type `LiveEvent`. */
export interface ILiveEventFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ILiveEventFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ILiveEventFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ILiveEventFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  channel?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  imageFormat?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  imageFormat_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  imageFormat_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  imageFormat_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  imageFormat_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  linkedJobs?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  linkedJobs_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  linkedJobs_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  linkedJobs_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  linkedJobs_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  liveEventID?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  liveEventID_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  liveEventID_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  liveEventID_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  liveEventID_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  liveEventID_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  mogadorProductKey?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  mogadorProductKey_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  mogadorProductKey_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  mogadorProductKey_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  mogadorProductKey_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  musicGenre_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  musicGenre_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  personality_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  personality_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match all of the values. */
  regions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  regions_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  sourceUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  sourceUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `LiveEvent`. */
export enum ILiveEventOrderByInput {
  /** Order by `channel` in ascending order. */
  ChannelAsc = 'channel_ASC',
  /** Order by `channel` in descending order. */
  ChannelDesc = 'channel_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `imageFormat` in ascending order. */
  ImageFormatAsc = 'imageFormat_ASC',
  /** Order by `imageFormat` in descending order. */
  ImageFormatDesc = 'imageFormat_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `linkedJobs` in ascending order. */
  LinkedJobsAsc = 'linkedJobs_ASC',
  /** Order by `linkedJobs` in descending order. */
  LinkedJobsDesc = 'linkedJobs_DESC',
  /** Order by `liveEventID` in ascending order. */
  LiveEventIdAsc = 'liveEventID_ASC',
  /** Order by `liveEventID` in descending order. */
  LiveEventIdDesc = 'liveEventID_DESC',
  /** Order by `mogadorProductKey` in ascending order. */
  MogadorProductKeyAsc = 'mogadorProductKey_ASC',
  /** Order by `mogadorProductKey` in descending order. */
  MogadorProductKeyDesc = 'mogadorProductKey_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `sourceUrl` in ascending order. */
  SourceUrlAsc = 'sourceUrl_ASC',
  /** Order by `sourceUrl` in descending order. */
  SourceUrlDesc = 'sourceUrl_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ILiveEventsMenu extends IContent, IElement, IWatchMenu {
  __typename?: 'LiveEventsMenu';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ILiveEventsMenuAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventsMenuChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventsMenuDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventsMenuNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventsMenuParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventsMenuUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventsMenuUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `LiveEventsMenu`. */
export interface ILiveEventsMenuConnection {
  __typename?: 'LiveEventsMenuConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ILiveEventsMenuEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ILiveEventsMenu>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `LiveEventsMenu`. */
export interface ILiveEventsMenuEdge {
  __typename?: 'LiveEventsMenuEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ILiveEventsMenu>;
}

/** A filter input for the type `LiveEventsMenu`. */
export interface ILiveEventsMenuFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ILiveEventsMenuFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ILiveEventsMenuFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ILiveEventsMenuFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `LiveEventsMenu`. */
export enum ILiveEventsMenuOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ILiveEventsPage extends IContent, IElement, IPage {
  __typename?: 'LiveEventsPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  liveEventsContent?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ILiveEventsPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventsPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventsPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveEventsPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventsPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventsPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveEventsPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `LiveEventsPage`. */
export interface ILiveEventsPageConnection {
  __typename?: 'LiveEventsPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ILiveEventsPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ILiveEventsPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `LiveEventsPage`. */
export interface ILiveEventsPageEdge {
  __typename?: 'LiveEventsPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ILiveEventsPage>;
}

/** A filter input for the type `LiveEventsPage`. */
export interface ILiveEventsPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ILiveEventsPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ILiveEventsPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ILiveEventsPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  liveEventsContent_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  liveEventsContent_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `LiveEventsPage`. */
export enum ILiveEventsPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ILiveTvPage extends IContent, IElement, IPage {
  __typename?: 'LiveTVPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  backgroundDesktop?: Maybe<IMediaWithCrops>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  liveTVContent?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ILiveTvPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveTvPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveTvPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ILiveTvPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveTvPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveTvPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILiveTvPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `LiveTVPage`. */
export interface ILiveTvPageConnection {
  __typename?: 'LiveTVPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ILiveTvPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ILiveTvPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `LiveTVPage`. */
export interface ILiveTvPageEdge {
  __typename?: 'LiveTVPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ILiveTvPage>;
}

/** A filter input for the type `LiveTVPage`. */
export interface ILiveTvPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ILiveTvPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ILiveTvPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ILiveTvPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  liveTVContent_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  liveTVContent_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `LiveTVPage`. */
export enum ILiveTvPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ILogoLink extends IElement {
  __typename?: 'LogoLink';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  link_to?: Maybe<Array<Maybe<IBlockListItem>>>;
  logo?: Maybe<IMediaWithCrops>;
}


export interface ILogoLinkLink_ToArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ILogoLinkLogoArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A slider to display linkable logos */
export interface ILogoSlider extends IElement {
  __typename?: 'LogoSlider';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  slides?: Maybe<Array<Maybe<IBlockListItem>>>;
  title?: Maybe<Scalars['String']>;
}


/** A slider to display linkable logos */
export interface ILogoSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** The Media interface. */
export interface IMedia {
  /** The ancestors. */
  ancestors: IMediaConnection;
  /** The children. */
  children: IMediaConnection;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IMediaConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The Media Type alias. */
  mediaTypeAlias: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
  /** The parent Media, can be null if Media is at root. */
  parent?: Maybe<IMedia>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate: Scalars['DateTime'];
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** The Media interface. */
export interface IMediaAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


/** The Media interface. */
export interface IMediaChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


/** The Media interface. */
export interface IMediaDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


/** The Media interface. */
export interface IMediaUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** The Media interface. */
export interface IMediaUrlArgs {
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  culture?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

/** A connection from an object to a list of objects of type `Media`. */
export interface IMediaConnection {
  __typename?: 'MediaConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMediaEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMedia>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Media`. */
export interface IMediaEdge {
  __typename?: 'MediaEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMedia>;
}

/** A filter input for the type `Media`. */
export interface IMediaFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMediaFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMediaFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMediaFilterInput>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  mediaTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  mediaTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  mediaTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  mediaTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  mediaTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Media`. */
export enum IMediaOrderByInput {
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `mediaTypeAlias` in ascending order. */
  MediaTypeAliasAsc = 'mediaTypeAlias_ASC',
  /** Order by `mediaTypeAlias` in descending order. */
  MediaTypeAliasDesc = 'mediaTypeAlias_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IMediaWithCrops {
  __typename?: 'MediaWithCrops';
  /** The image url with crop parameters. */
  cropUrl?: Maybe<Scalars['String']>;
  /** The predefined crops. */
  crops: Array<Maybe<IImageCropperCrop>>;
  /** The focal point position. */
  focalPoint: IImageCropperFocalPoint;
  /** The focal point url template. */
  focalPointUrlTemplate: Scalars['String'];
  /** The media */
  media?: Maybe<IMedia>;
  /** The image url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMediaWithCropsCropUrlArgs {
  alias?: InputMaybe<Scalars['String']>;
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  preferFocalPoint?: InputMaybe<Scalars['Boolean']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface IMemberContentTemplate {
  contentLink?: Maybe<IContent>;
  contentSource?: Maybe<Scalars['String']>;
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
}

export interface IMemberContentTypesLink extends IContent, IElement {
  __typename?: 'MemberContentTypesLink';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  contentLink?: Maybe<IContent>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  watchedTimestamp?: Maybe<Scalars['Int']>;
}


export interface IMemberContentTypesLinkAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberContentTypesLinkChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberContentTypesLinkDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberContentTypesLinkNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberContentTypesLinkParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberContentTypesLinkUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberContentTypesLinkUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberContentTypesLink`. */
export interface IMemberContentTypesLinkConnection {
  __typename?: 'MemberContentTypesLinkConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberContentTypesLinkEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberContentTypesLink>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberContentTypesLink`. */
export interface IMemberContentTypesLinkEdge {
  __typename?: 'MemberContentTypesLinkEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberContentTypesLink>;
}

/** A filter input for the type `MemberContentTypesLink`. */
export interface IMemberContentTypesLinkFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberContentTypesLinkFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberContentTypesLinkFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberContentTypesLinkFilterInput>>>;
  /** Field must equal value. */
  contentLink?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  type?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  type_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  type_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  type_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  type_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  watchedTimestamp?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  watchedTimestamp_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  watchedTimestamp_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  watchedTimestamp_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  watchedTimestamp_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  watchedTimestamp_lte?: InputMaybe<Scalars['Int']>;
}

/** An order input for the type `MemberContentTypesLink`. */
export enum IMemberContentTypesLinkOrderByInput {
  /** Order by `contentLink` in ascending order. */
  ContentLinkAsc = 'contentLink_ASC',
  /** Order by `contentLink` in descending order. */
  ContentLinkDesc = 'contentLink_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `type` in ascending order. */
  TypeAsc = 'type_ASC',
  /** Order by `type` in descending order. */
  TypeDesc = 'type_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `watchedTimestamp` in ascending order. */
  WatchedTimestampAsc = 'watchedTimestamp_ASC',
  /** Order by `watchedTimestamp` in descending order. */
  WatchedTimestampDesc = 'watchedTimestamp_DESC'
}

export interface IMemberDatas extends IContent, IElement {
  __typename?: 'MemberDatas';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMemberDatasAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberDatasChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberDatasDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberDatasNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberDatasParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberDatasUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberDatasUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberDatas`. */
export interface IMemberDatasConnection {
  __typename?: 'MemberDatasConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberDatasEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberDatas>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberDatas`. */
export interface IMemberDatasEdge {
  __typename?: 'MemberDatasEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberDatas>;
}

/** A filter input for the type `MemberDatas`. */
export interface IMemberDatasFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberDatasFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberDatasFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberDatasFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MemberDatas`. */
export enum IMemberDatasOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IMemberDownloaded extends IContent, IElement, IMemberContentTemplate {
  __typename?: 'MemberDownloaded';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  contentLink?: Maybe<IContent>;
  contentSource?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMemberDownloadedAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberDownloadedChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberDownloadedDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberDownloadedNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberDownloadedParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberDownloadedUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberDownloadedUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberDownloaded`. */
export interface IMemberDownloadedConnection {
  __typename?: 'MemberDownloadedConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberDownloadedEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberDownloaded>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberDownloaded`. */
export interface IMemberDownloadedEdge {
  __typename?: 'MemberDownloadedEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberDownloaded>;
}

/** A filter input for the type `MemberDownloaded`. */
export interface IMemberDownloadedFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberDownloadedFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberDownloadedFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberDownloadedFilterInput>>>;
  /** Field must equal value. */
  contentLink?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentSource?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentSource_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentSource_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentSource_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentSource_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MemberDownloaded`. */
export enum IMemberDownloadedOrderByInput {
  /** Order by `contentLink` in ascending order. */
  ContentLinkAsc = 'contentLink_ASC',
  /** Order by `contentLink` in descending order. */
  ContentLinkDesc = 'contentLink_DESC',
  /** Order by `contentSource` in ascending order. */
  ContentSourceAsc = 'contentSource_ASC',
  /** Order by `contentSource` in descending order. */
  ContentSourceDesc = 'contentSource_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IMemberMessage extends IContent, IElement {
  __typename?: 'MemberMessage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  read?: Maybe<Scalars['Boolean']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMemberMessageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberMessageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberMessageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberMessageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberMessageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberMessageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberMessageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberMessage`. */
export interface IMemberMessageConnection {
  __typename?: 'MemberMessageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberMessageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberMessage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberMessage`. */
export interface IMemberMessageEdge {
  __typename?: 'MemberMessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberMessage>;
}

/** A filter input for the type `MemberMessage`. */
export interface IMemberMessageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberMessageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberMessageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberMessageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  message?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  message_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  message_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  message_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  message_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MemberMessage`. */
export enum IMemberMessageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `message` in ascending order. */
  MessageAsc = 'message_ASC',
  /** Order by `message` in descending order. */
  MessageDesc = 'message_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `read` in ascending order. */
  ReadAsc = 'read_ASC',
  /** Order by `read` in descending order. */
  ReadDesc = 'read_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IMemberNotify extends IContent, IElement, IMemberContentTemplate {
  __typename?: 'MemberNotify';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  contentLink?: Maybe<IContent>;
  contentSource?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  read?: Maybe<Scalars['Boolean']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMemberNotifyAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberNotifyChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberNotifyDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberNotifyNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberNotifyParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberNotifyUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberNotifyUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberNotify`. */
export interface IMemberNotifyConnection {
  __typename?: 'MemberNotifyConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberNotifyEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberNotify>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberNotify`. */
export interface IMemberNotifyEdge {
  __typename?: 'MemberNotifyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberNotify>;
}

/** A filter input for the type `MemberNotify`. */
export interface IMemberNotifyFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberNotifyFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberNotifyFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberNotifyFilterInput>>>;
  /** Field must equal value. */
  contentLink?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentSource?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentSource_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentSource_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentSource_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentSource_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MemberNotify`. */
export enum IMemberNotifyOrderByInput {
  /** Order by `contentLink` in ascending order. */
  ContentLinkAsc = 'contentLink_ASC',
  /** Order by `contentLink` in descending order. */
  ContentLinkDesc = 'contentLink_DESC',
  /** Order by `contentSource` in ascending order. */
  ContentSourceAsc = 'contentSource_ASC',
  /** Order by `contentSource` in descending order. */
  ContentSourceDesc = 'contentSource_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `read` in ascending order. */
  ReadAsc = 'read_ASC',
  /** Order by `read` in descending order. */
  ReadDesc = 'read_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IMemberOpportunity extends IContent, IElement {
  __typename?: 'MemberOpportunity';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  contentLink?: Maybe<IContent>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  read?: Maybe<Scalars['Boolean']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMemberOpportunityAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberOpportunityChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberOpportunityDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberOpportunityNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberOpportunityParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberOpportunityUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberOpportunityUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberOpportunity`. */
export interface IMemberOpportunityConnection {
  __typename?: 'MemberOpportunityConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberOpportunityEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberOpportunity>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberOpportunity`. */
export interface IMemberOpportunityEdge {
  __typename?: 'MemberOpportunityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberOpportunity>;
}

/** A filter input for the type `MemberOpportunity`. */
export interface IMemberOpportunityFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberOpportunityFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberOpportunityFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberOpportunityFilterInput>>>;
  /** Field must equal value. */
  contentLink?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MemberOpportunity`. */
export enum IMemberOpportunityOrderByInput {
  /** Order by `contentLink` in ascending order. */
  ContentLinkAsc = 'contentLink_ASC',
  /** Order by `contentLink` in descending order. */
  ContentLinkDesc = 'contentLink_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `read` in ascending order. */
  ReadAsc = 'read_ASC',
  /** Order by `read` in descending order. */
  ReadDesc = 'read_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IMemberSaved extends IContent, IElement, IMemberContentTemplate {
  __typename?: 'MemberSaved';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  contentLink?: Maybe<IContent>;
  contentSource?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMemberSavedAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberSavedChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberSavedDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberSavedNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberSavedParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberSavedUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberSavedUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberSaved`. */
export interface IMemberSavedConnection {
  __typename?: 'MemberSavedConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberSavedEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberSaved>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberSaved`. */
export interface IMemberSavedEdge {
  __typename?: 'MemberSavedEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberSaved>;
}

/** A filter input for the type `MemberSaved`. */
export interface IMemberSavedFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberSavedFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberSavedFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberSavedFilterInput>>>;
  /** Field must equal value. */
  contentLink?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentSource?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentSource_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentSource_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentSource_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentSource_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MemberSaved`. */
export enum IMemberSavedOrderByInput {
  /** Order by `contentLink` in ascending order. */
  ContentLinkAsc = 'contentLink_ASC',
  /** Order by `contentLink` in descending order. */
  ContentLinkDesc = 'contentLink_DESC',
  /** Order by `contentSource` in ascending order. */
  ContentSourceAsc = 'contentSource_ASC',
  /** Order by `contentSource` in descending order. */
  ContentSourceDesc = 'contentSource_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IMemberSearch extends IContent, IElement {
  __typename?: 'MemberSearch';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  text?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMemberSearchAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberSearchChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberSearchDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberSearchNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberSearchParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberSearchUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberSearchUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberSearch`. */
export interface IMemberSearchConnection {
  __typename?: 'MemberSearchConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberSearchEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberSearch>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberSearch`. */
export interface IMemberSearchEdge {
  __typename?: 'MemberSearchEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberSearch>;
}

/** A filter input for the type `MemberSearch`. */
export interface IMemberSearchFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberSearchFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberSearchFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberSearchFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  text?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  text_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  text_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  text_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  text_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MemberSearch`. */
export enum IMemberSearchOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `text` in ascending order. */
  TextAsc = 'text_ASC',
  /** Order by `text` in descending order. */
  TextDesc = 'text_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IMemberWatched extends IContent, IElement, IMemberContentTemplate {
  __typename?: 'MemberWatched';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  contentLink?: Maybe<IContent>;
  contentSource?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** length in second */
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  watchedTimestamp?: Maybe<Scalars['Int']>;
}


export interface IMemberWatchedAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberWatchedChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberWatchedDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMemberWatchedNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberWatchedParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberWatchedUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMemberWatchedUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MemberWatched`. */
export interface IMemberWatchedConnection {
  __typename?: 'MemberWatchedConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMemberWatchedEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMemberWatched>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MemberWatched`. */
export interface IMemberWatchedEdge {
  __typename?: 'MemberWatchedEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMemberWatched>;
}

/** A filter input for the type `MemberWatched`. */
export interface IMemberWatchedFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMemberWatchedFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMemberWatchedFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMemberWatchedFilterInput>>>;
  /** Field must equal value. */
  contentLink?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentSource?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentSource_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentSource_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentSource_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentSource_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  watchedTimestamp?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  watchedTimestamp_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  watchedTimestamp_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  watchedTimestamp_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  watchedTimestamp_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  watchedTimestamp_lte?: InputMaybe<Scalars['Int']>;
}

/** An order input for the type `MemberWatched`. */
export enum IMemberWatchedOrderByInput {
  /** Order by `contentLink` in ascending order. */
  ContentLinkAsc = 'contentLink_ASC',
  /** Order by `contentLink` in descending order. */
  ContentLinkDesc = 'contentLink_DESC',
  /** Order by `contentSource` in ascending order. */
  ContentSourceAsc = 'contentSource_ASC',
  /** Order by `contentSource` in descending order. */
  ContentSourceDesc = 'contentSource_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `watchedTimestamp` in ascending order. */
  WatchedTimestampAsc = 'watchedTimestamp_ASC',
  /** Order by `watchedTimestamp` in descending order. */
  WatchedTimestampDesc = 'watchedTimestamp_DESC'
}

export interface IMembersDatas extends IContent, IElement {
  __typename?: 'MembersDatas';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMembersDatasAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMembersDatasChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMembersDatasDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMembersDatasNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMembersDatasParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMembersDatasUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMembersDatasUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MembersDatas`. */
export interface IMembersDatasConnection {
  __typename?: 'MembersDatasConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMembersDatasEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMembersDatas>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MembersDatas`. */
export interface IMembersDatasEdge {
  __typename?: 'MembersDatasEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMembersDatas>;
}

/** A filter input for the type `MembersDatas`. */
export interface IMembersDatasFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMembersDatasFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMembersDatasFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMembersDatasFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MembersDatas`. */
export enum IMembersDatasOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Titled link list */
export interface IMenuColumn extends IElement {
  __typename?: 'MenuColumn';
  column?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  titleLink?: Maybe<Array<Maybe<IBlockListItem>>>;
}

export interface IMetadatasLanguages extends IElement {
  __typename?: 'MetadatasLanguages';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  languages?: Maybe<Scalars['String']>;
}


export interface IMetadatasLanguagesLanguagesArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IMetadatasVodLanguage extends IElement {
  __typename?: 'MetadatasVODLanguage';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  subtitlesLanguage?: Maybe<Scalars['String']>;
  voiceOverLanguage?: Maybe<Scalars['String']>;
}


export interface IMetadatasVodLanguageSubtitlesLanguageArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMetadatasVodLanguageVoiceOverLanguageArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IMetasAuthorCmp {
  /** You can add all sort of featured people (including hosts, guests, technical crew, etc.) */
  author?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
}

export interface IMetasExclusives extends IElement {
  __typename?: 'MetasExclusives';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  exclusives?: Maybe<Scalars['Boolean']>;
}

export interface IMetasPublicationDate extends IElement {
  __typename?: 'MetasPublicationDate';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  pubDate?: Maybe<Scalars['DateTime']>;
}

export interface IMetasTrailerCmp extends IElement {
  __typename?: 'MetasTrailerCmp';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Vimeo ID for trailer video */
  trailer?: Maybe<Scalars['Int']>;
}


export interface IMetasTrailerCmpTrailerArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IMetasVideosCmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  /** in seconds */
  length?: Maybe<Scalars['Int']>;
  public?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
}

export interface IMiniSitesFolder extends IContent, IElement {
  __typename?: 'MiniSitesFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IMiniSitesFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMiniSitesFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMiniSitesFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IMiniSitesFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMiniSitesFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMiniSitesFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IMiniSitesFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `MiniSitesFolder`. */
export interface IMiniSitesFolderConnection {
  __typename?: 'MiniSitesFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IMiniSitesFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IMiniSitesFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `MiniSitesFolder`. */
export interface IMiniSitesFolderEdge {
  __typename?: 'MiniSitesFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IMiniSitesFolder>;
}

/** A filter input for the type `MiniSitesFolder`. */
export interface IMiniSitesFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IMiniSitesFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IMiniSitesFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IMiniSitesFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `MiniSitesFolder`. */
export enum IMiniSitesFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** a slider composed of title sliders */
export interface IMultiSlider extends IElement {
  __typename?: 'MultiSlider';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /** List of label and their slides */
  sliders?: Maybe<Array<Maybe<IBlockListItem>>>;
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** a slider composed of title sliders */
export interface IMultiSliderDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** a slider composed of title sliders */
export interface IMultiSliderSlidersArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** a slider composed of title sliders */
export interface IMultiSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Pick a list of categories to display as a slider */
export interface IMulticategoriesSlider extends IElement, ISliderThumbnailSettings {
  __typename?: 'MulticategoriesSlider';
  categories?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  /** If not set the content title will be used as title for the slider */
  title?: Maybe<Scalars['String']>;
}


/** Pick a list of categories to display as a slider */
export interface IMulticategoriesSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface INavMessage extends IContent, IElement {
  __typename?: 'NavMessage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  image?: Maybe<IMediaWithCrops>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface INavMessageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INavMessageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INavMessageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INavMessageDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INavMessageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INavMessageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INavMessageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INavMessageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INavMessageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `NavMessage`. */
export interface INavMessageConnection {
  __typename?: 'NavMessageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<INavMessageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<INavMessage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `NavMessage`. */
export interface INavMessageEdge {
  __typename?: 'NavMessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<INavMessage>;
}

/** A filter input for the type `NavMessage`. */
export interface INavMessageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<INavMessageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<INavMessageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<INavMessageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `NavMessage`. */
export enum INavMessageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface INavigationMessagesFolder extends IContent, IElement {
  __typename?: 'NavigationMessagesFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface INavigationMessagesFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INavigationMessagesFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INavigationMessagesFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INavigationMessagesFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INavigationMessagesFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INavigationMessagesFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INavigationMessagesFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `NavigationMessagesFolder`. */
export interface INavigationMessagesFolderConnection {
  __typename?: 'NavigationMessagesFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<INavigationMessagesFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<INavigationMessagesFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `NavigationMessagesFolder`. */
export interface INavigationMessagesFolderEdge {
  __typename?: 'NavigationMessagesFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<INavigationMessagesFolder>;
}

/** A filter input for the type `NavigationMessagesFolder`. */
export interface INavigationMessagesFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<INavigationMessagesFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<INavigationMessagesFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<INavigationMessagesFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `NavigationMessagesFolder`. */
export enum INavigationMessagesFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface INetlifyDeploy extends IContent, IElement {
  __typename?: 'NetlifyDeploy';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface INetlifyDeployAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INetlifyDeployChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INetlifyDeployDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INetlifyDeployNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INetlifyDeployParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INetlifyDeployUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INetlifyDeployUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `NetlifyDeploy`. */
export interface INetlifyDeployConnection {
  __typename?: 'NetlifyDeployConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<INetlifyDeployEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<INetlifyDeploy>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `NetlifyDeploy`. */
export interface INetlifyDeployEdge {
  __typename?: 'NetlifyDeployEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<INetlifyDeploy>;
}

/** A filter input for the type `NetlifyDeploy`. */
export interface INetlifyDeployFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<INetlifyDeployFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<INetlifyDeployFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<INetlifyDeployFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `NetlifyDeploy`. */
export enum INetlifyDeployOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface INews extends IContent, IContentTagsComp, IElement, IMetasAuthorCmp {
  __typename?: 'News';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** You can add all sort of featured people (including hosts, guests, technical crew, etc.) */
  author?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  exclusives?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  interests?: Maybe<Array<Maybe<IContent>>>;
  languages?: Maybe<Scalars['String']>;
  /** The level. */
  level: Scalars['Int'];
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  pubDate?: Maybe<Scalars['DateTime']>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  sourceUrl?: Maybe<Scalars['String']>;
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
  subtitlesLanguage?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  /** Vimeo HLS URL */
  vimeoHlsUrl?: Maybe<Scalars['String']>;
  vimeoId?: Maybe<Scalars['Int']>;
  voiceOverLanguage?: Maybe<Scalars['String']>;
}


export interface INewsAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsLanguagesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsSubtitlesLanguageArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsVideoArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsVimeoHlsUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsVimeoIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsVoiceOverLanguageArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface INewsCateg extends IContent, IElement {
  __typename?: 'NewsCateg';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface INewsCategAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsCategChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsCategDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsCategNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsCategParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsCategUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsCategUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `NewsCateg`. */
export interface INewsCategConnection {
  __typename?: 'NewsCategConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<INewsCategEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<INewsCateg>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `NewsCateg`. */
export interface INewsCategEdge {
  __typename?: 'NewsCategEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<INewsCateg>;
}

/** A filter input for the type `NewsCateg`. */
export interface INewsCategFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<INewsCategFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<INewsCategFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<INewsCategFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `NewsCateg`. */
export enum INewsCategOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A connection from an object to a list of objects of type `News`. */
export interface INewsConnection {
  __typename?: 'NewsConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<INewsEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<INews>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `News`. */
export interface INewsEdge {
  __typename?: 'NewsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<INews>;
}

/** A filter input for the type `News`. */
export interface INewsFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<INewsFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<INewsFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<INewsFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  exclusives?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  languages?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  languages_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  languages_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  languages_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  languages_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  musicGenre_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  musicGenre_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  pubDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  pubDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  pubDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  pubDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  pubDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must match all of the values. */
  regions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  regions_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  sourceUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  sourceUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subtitlesLanguage?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitlesLanguage_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitlesLanguage_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitlesLanguage_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitlesLanguage_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  video?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  video_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  video_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  video_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  video_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  vimeoHlsUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  vimeoHlsUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  vimeoHlsUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  vimeoHlsUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  vimeoHlsUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  vimeoId?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  vimeoId_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  vimeoId_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  vimeoId_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  vimeoId_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  vimeoId_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  voiceOverLanguage?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  voiceOverLanguage_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  voiceOverLanguage_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  voiceOverLanguage_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  voiceOverLanguage_starts_with?: InputMaybe<Scalars['String']>;
}

export interface INewsFolder extends IContent, IElement {
  __typename?: 'NewsFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface INewsFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `NewsFolder`. */
export interface INewsFolderConnection {
  __typename?: 'NewsFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<INewsFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<INewsFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `NewsFolder`. */
export interface INewsFolderEdge {
  __typename?: 'NewsFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<INewsFolder>;
}

/** A filter input for the type `NewsFolder`. */
export interface INewsFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<INewsFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<INewsFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<INewsFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `NewsFolder`. */
export enum INewsFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `News`. */
export enum INewsOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `exclusives` in ascending order. */
  ExclusivesAsc = 'exclusives_ASC',
  /** Order by `exclusives` in descending order. */
  ExclusivesDesc = 'exclusives_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `languages` in ascending order. */
  LanguagesAsc = 'languages_ASC',
  /** Order by `languages` in descending order. */
  LanguagesDesc = 'languages_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `pubDate` in ascending order. */
  PubDateAsc = 'pubDate_ASC',
  /** Order by `pubDate` in descending order. */
  PubDateDesc = 'pubDate_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `sourceUrl` in ascending order. */
  SourceUrlAsc = 'sourceUrl_ASC',
  /** Order by `sourceUrl` in descending order. */
  SourceUrlDesc = 'sourceUrl_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `subtitlesLanguage` in ascending order. */
  SubtitlesLanguageAsc = 'subtitlesLanguage_ASC',
  /** Order by `subtitlesLanguage` in descending order. */
  SubtitlesLanguageDesc = 'subtitlesLanguage_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `video` in ascending order. */
  VideoAsc = 'video_ASC',
  /** Order by `video` in descending order. */
  VideoDesc = 'video_DESC',
  /** Order by `vimeoHlsUrl` in ascending order. */
  VimeoHlsUrlAsc = 'vimeoHlsUrl_ASC',
  /** Order by `vimeoHlsUrl` in descending order. */
  VimeoHlsUrlDesc = 'vimeoHlsUrl_DESC',
  /** Order by `vimeoId` in ascending order. */
  VimeoIdAsc = 'vimeoId_ASC',
  /** Order by `vimeoId` in descending order. */
  VimeoIdDesc = 'vimeoId_DESC',
  /** Order by `voiceOverLanguage` in ascending order. */
  VoiceOverLanguageAsc = 'voiceOverLanguage_ASC',
  /** Order by `voiceOverLanguage` in descending order. */
  VoiceOverLanguageDesc = 'voiceOverLanguage_DESC'
}

export interface INewsPage extends IContent, IElement, IPage {
  __typename?: 'NewsPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  topics?: Maybe<Array<Maybe<IContent>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface INewsPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface INewsPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INewsPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `NewsPage`. */
export interface INewsPageConnection {
  __typename?: 'NewsPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<INewsPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<INewsPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `NewsPage`. */
export interface INewsPageEdge {
  __typename?: 'NewsPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<INewsPage>;
}

/** A filter input for the type `NewsPage`. */
export interface INewsPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<INewsPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<INewsPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<INewsPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  topics_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  topics_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `NewsPage`. */
export enum INewsPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface INuggetFeedbackCmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  /** Tick to use the feedbacks below for empty choices' feebacks */
  genericFeedback?: Maybe<Scalars['Boolean']>;
  negativeFeedback?: Maybe<Scalars['String']>;
  positiveFeedback?: Maybe<Scalars['String']>;
}


export interface INuggetFeedbackCmpNegativeFeedbackArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface INuggetFeedbackCmpPositiveFeedbackArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Possible value for a gap-fill nugget */
export interface INuggetsTextAnswerOption extends IElement {
  __typename?: 'NuggetsTextAnswerOption';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  image?: Maybe<IMediaWithCrops>;
  isCorrect?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
}

export interface IObtainedJob extends IContent, IElement {
  __typename?: 'ObtainedJob';
  /** The ancestors. */
  ancestors: IContentConnection;
  certificate?: Maybe<IContent>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IObtainedJobAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IObtainedJobChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IObtainedJobDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IObtainedJobNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IObtainedJobParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IObtainedJobUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IObtainedJobUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ObtainedJob`. */
export interface IObtainedJobConnection {
  __typename?: 'ObtainedJobConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IObtainedJobEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IObtainedJob>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ObtainedJob`. */
export interface IObtainedJobEdge {
  __typename?: 'ObtainedJobEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IObtainedJob>;
}

/** A filter input for the type `ObtainedJob`. */
export interface IObtainedJobFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IObtainedJobFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IObtainedJobFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IObtainedJobFilterInput>>>;
  /** Field must equal value. */
  certificate?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ObtainedJob`. */
export enum IObtainedJobOrderByInput {
  /** Order by `certificate` in ascending order. */
  CertificateAsc = 'certificate_ASC',
  /** Order by `certificate` in descending order. */
  CertificateDesc = 'certificate_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Job opportunity */
export interface IOpportunity extends IContent, IElement {
  __typename?: 'Opportunity';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** imported but not used */
  bannerBody?: Maybe<Scalars['String']>;
  /** imported but not used */
  bannerTitle?: Maybe<Scalars['String']>;
  /** Mandatory Certificate to access this opportunity (leave empty if the opportunity is free) */
  certificate?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** imported but not used */
  contactEmail?: Maybe<Scalars['String']>;
  /** imported but not used */
  contactName?: Maybe<Scalars['String']>;
  /** imported but not used */
  contactPhone?: Maybe<Scalars['String']>;
  /** imported but not used */
  contactRemark?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  contractType?: Maybe<Scalars['String']>;
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** imported but not used */
  daysToAccept?: Maybe<Scalars['Int']>;
  /** The descendants. */
  descendants: IContentConnection;
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Leave empty if you want to create an opportunity page */
  external?: Maybe<Scalars['String']>;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  interests?: Maybe<Array<Maybe<IContent>>>;
  /** The level. */
  level: Scalars['Int'];
  location?: Maybe<Scalars['String']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pageContent?: Maybe<Scalars['HTML']>;
  pageCover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  personalities?: Maybe<Array<Maybe<IContent>>>;
  /** imported but not used */
  reminderInterval?: Maybe<Scalars['Int']>;
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
  /** imported but not used */
  termsAndConditions?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  /** imported but not used */
  winnerBody?: Maybe<Scalars['String']>;
  /** imported but not used */
  winnerCount?: Maybe<Scalars['Int']>;
  /** imported but not used */
  winnerTitle?: Maybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Job opportunity */
export interface IOpportunityBannerBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityBannerTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Job opportunity */
export interface IOpportunityContactEmailArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityContactNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityContactPhoneArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityContactRemarkArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityDaysToAcceptArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Job opportunity */
export interface IOpportunityExternalArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityLocationArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityPageContentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityPartnersArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityReminderIntervalArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityTermsAndConditionsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityWinnerBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityWinnerCountArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Job opportunity */
export interface IOpportunityWinnerTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IOpportunityCenter extends IContent, IElement {
  __typename?: 'OpportunityCenter';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  opportunitySubtitle?: Maybe<Scalars['String']>;
  opportunityTitle?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IOpportunityCenterAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IOpportunityCenterChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IOpportunityCenterDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IOpportunityCenterNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IOpportunityCenterOpportunitySubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IOpportunityCenterOpportunityTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IOpportunityCenterParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IOpportunityCenterUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IOpportunityCenterUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `OpportunityCenter`. */
export interface IOpportunityCenterConnection {
  __typename?: 'OpportunityCenterConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IOpportunityCenterEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IOpportunityCenter>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `OpportunityCenter`. */
export interface IOpportunityCenterEdge {
  __typename?: 'OpportunityCenterEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IOpportunityCenter>;
}

/** A filter input for the type `OpportunityCenter`. */
export interface IOpportunityCenterFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IOpportunityCenterFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IOpportunityCenterFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IOpportunityCenterFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  opportunitySubtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  opportunitySubtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  opportunitySubtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  opportunitySubtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  opportunitySubtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  opportunityTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  opportunityTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  opportunityTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  opportunityTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  opportunityTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `OpportunityCenter`. */
export enum IOpportunityCenterOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `opportunitySubtitle` in ascending order. */
  OpportunitySubtitleAsc = 'opportunitySubtitle_ASC',
  /** Order by `opportunitySubtitle` in descending order. */
  OpportunitySubtitleDesc = 'opportunitySubtitle_DESC',
  /** Order by `opportunityTitle` in ascending order. */
  OpportunityTitleAsc = 'opportunityTitle_ASC',
  /** Order by `opportunityTitle` in descending order. */
  OpportunityTitleDesc = 'opportunityTitle_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A connection from an object to a list of objects of type `Opportunity`. */
export interface IOpportunityConnection {
  __typename?: 'OpportunityConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IOpportunityEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IOpportunity>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Opportunity`. */
export interface IOpportunityEdge {
  __typename?: 'OpportunityEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IOpportunity>;
}

/** A filter input for the type `Opportunity`. */
export interface IOpportunityFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IOpportunityFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IOpportunityFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IOpportunityFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  bannerBody?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  bannerBody_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  bannerBody_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  bannerBody_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  bannerBody_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  bannerTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  bannerTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  bannerTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  bannerTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  bannerTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  certificate_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  certificate_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contactEmail?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contactEmail_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contactEmail_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contactEmail_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contactEmail_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contactName?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contactName_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contactName_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contactName_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contactName_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contactPhone?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contactPhone_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contactPhone_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contactPhone_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contactPhone_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contactRemark?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contactRemark_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contactRemark_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contactRemark_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contactRemark_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contractType?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contractType_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contractType_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contractType_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contractType_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  daysToAccept?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  daysToAccept_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  daysToAccept_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  daysToAccept_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  daysToAccept_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  daysToAccept_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  external?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  external_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  external_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  external_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  external_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  location?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  location_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  location_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  location_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  location_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  personalities_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  personalities_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  reminderInterval?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  reminderInterval_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  reminderInterval_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  reminderInterval_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  reminderInterval_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  reminderInterval_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  termsAndConditions?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  termsAndConditions_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  termsAndConditions_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  termsAndConditions_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  termsAndConditions_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  winnerBody?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  winnerBody_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  winnerBody_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  winnerBody_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  winnerBody_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  winnerCount?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  winnerCount_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  winnerCount_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  winnerCount_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  winnerCount_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  winnerCount_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  winnerTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  winnerTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  winnerTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  winnerTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  winnerTitle_starts_with?: InputMaybe<Scalars['String']>;
}

export interface IOpportunityFolder extends IContent, IElement {
  __typename?: 'OpportunityFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IOpportunityFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IOpportunityFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IOpportunityFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IOpportunityFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IOpportunityFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IOpportunityFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IOpportunityFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `OpportunityFolder`. */
export interface IOpportunityFolderConnection {
  __typename?: 'OpportunityFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IOpportunityFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IOpportunityFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `OpportunityFolder`. */
export interface IOpportunityFolderEdge {
  __typename?: 'OpportunityFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IOpportunityFolder>;
}

/** A filter input for the type `OpportunityFolder`. */
export interface IOpportunityFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IOpportunityFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IOpportunityFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IOpportunityFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `OpportunityFolder`. */
export enum IOpportunityFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `Opportunity`. */
export enum IOpportunityOrderByInput {
  /** Order by `bannerBody` in ascending order. */
  BannerBodyAsc = 'bannerBody_ASC',
  /** Order by `bannerBody` in descending order. */
  BannerBodyDesc = 'bannerBody_DESC',
  /** Order by `bannerTitle` in ascending order. */
  BannerTitleAsc = 'bannerTitle_ASC',
  /** Order by `bannerTitle` in descending order. */
  BannerTitleDesc = 'bannerTitle_DESC',
  /** Order by `contactEmail` in ascending order. */
  ContactEmailAsc = 'contactEmail_ASC',
  /** Order by `contactEmail` in descending order. */
  ContactEmailDesc = 'contactEmail_DESC',
  /** Order by `contactName` in ascending order. */
  ContactNameAsc = 'contactName_ASC',
  /** Order by `contactName` in descending order. */
  ContactNameDesc = 'contactName_DESC',
  /** Order by `contactPhone` in ascending order. */
  ContactPhoneAsc = 'contactPhone_ASC',
  /** Order by `contactPhone` in descending order. */
  ContactPhoneDesc = 'contactPhone_DESC',
  /** Order by `contactRemark` in ascending order. */
  ContactRemarkAsc = 'contactRemark_ASC',
  /** Order by `contactRemark` in descending order. */
  ContactRemarkDesc = 'contactRemark_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `contractType` in ascending order. */
  ContractTypeAsc = 'contractType_ASC',
  /** Order by `contractType` in descending order. */
  ContractTypeDesc = 'contractType_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `daysToAccept` in ascending order. */
  DaysToAcceptAsc = 'daysToAccept_ASC',
  /** Order by `daysToAccept` in descending order. */
  DaysToAcceptDesc = 'daysToAccept_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `external` in ascending order. */
  ExternalAsc = 'external_ASC',
  /** Order by `external` in descending order. */
  ExternalDesc = 'external_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `location` in ascending order. */
  LocationAsc = 'location_ASC',
  /** Order by `location` in descending order. */
  LocationDesc = 'location_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `reminderInterval` in ascending order. */
  ReminderIntervalAsc = 'reminderInterval_ASC',
  /** Order by `reminderInterval` in descending order. */
  ReminderIntervalDesc = 'reminderInterval_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `termsAndConditions` in ascending order. */
  TermsAndConditionsAsc = 'termsAndConditions_ASC',
  /** Order by `termsAndConditions` in descending order. */
  TermsAndConditionsDesc = 'termsAndConditions_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `winnerBody` in ascending order. */
  WinnerBodyAsc = 'winnerBody_ASC',
  /** Order by `winnerBody` in descending order. */
  WinnerBodyDesc = 'winnerBody_DESC',
  /** Order by `winnerCount` in ascending order. */
  WinnerCountAsc = 'winnerCount_ASC',
  /** Order by `winnerCount` in descending order. */
  WinnerCountDesc = 'winnerCount_DESC',
  /** Order by `winnerTitle` in ascending order. */
  WinnerTitleAsc = 'winnerTitle_ASC',
  /** Order by `winnerTitle` in descending order. */
  WinnerTitleDesc = 'winnerTitle_DESC'
}

export interface IOurUmbracoGMaps {
  __typename?: 'OurUmbracoGMaps';
  /** The address. */
  address?: Maybe<IOurUmbracoGMapsAddress>;
  /** The map configuration. */
  mapconfig?: Maybe<IOurUmbracoGMapsConfig>;
}

export interface IOurUmbracoGMapsAddress {
  __typename?: 'OurUmbracoGMapsAddress';
  /** The name of the city. */
  city?: Maybe<Scalars['String']>;
  /** The coordinates. */
  coordinates?: Maybe<IOurUmbracoGMapsCoordinate>;
  /** The name of the country. */
  country?: Maybe<Scalars['String']>;
  /** The full address. */
  full_address?: Maybe<Scalars['String']>;
  /** The postal code. */
  postalcode?: Maybe<Scalars['String']>;
  /** The name of the state. */
  state?: Maybe<Scalars['String']>;
  /** The name of the street. */
  street?: Maybe<Scalars['String']>;
  /** The street number. */
  streetNumber?: Maybe<Scalars['String']>;
}

export interface IOurUmbracoGMapsConfig {
  __typename?: 'OurUmbracoGMapsConfig';
  /** The api key */
  apikey?: Maybe<Scalars['String']>;
  /** The center coordinates. */
  centerCoordinates?: Maybe<IOurUmbracoGMapsCoordinate>;
  /** The map style. */
  mapstyle?: Maybe<Scalars['String']>;
  /** The map type. */
  maptype?: Maybe<IOurUmbracoGMapsMapType>;
  /** The map zoom. */
  zoom?: Maybe<Scalars['Int']>;
}

export interface IOurUmbracoGMapsCoordinate {
  __typename?: 'OurUmbracoGMapsCoordinate';
  /** The coordinates. */
  coordinates?: Maybe<Scalars['String']>;
  /** Specifies wether the coordinates are empty or not. */
  isEmpty?: Maybe<Scalars['Boolean']>;
  /** The latitude. */
  lat?: Maybe<Scalars['Decimal']>;
  /** The longitude. */
  lng?: Maybe<Scalars['Decimal']>;
}

/** The map type. */
export enum IOurUmbracoGMapsMapType {
  Hybrid = 'HYBRID',
  Roadmap = 'ROADMAP',
  Satellite = 'SATELLITE',
  StyledMap = 'STYLED_MAP',
  Terrain = 'TERRAIN'
}

export interface IPage {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
}

/** Information about pagination in a connection. */
export interface IPageInfo {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
}

export interface IPageSeo extends IElement {
  __typename?: 'PageSEO';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  urlRewrite?: Maybe<Scalars['String']>;
}


export interface IPageSeoMetaDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPageSeoMetaTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Pick a Live Event or TV Channel page to display as a content slider */
export interface IPagecontentSlider extends IElement, ISliderThumbnailSettings {
  __typename?: 'PagecontentSlider';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  isLink?: Maybe<Scalars['Boolean']>;
  page?: Maybe<IContent>;
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** Pick a Live Event or TV Channel page to display as a content slider */
export interface IPagecontentSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IPartner extends IContent, IContentDescriptionCmp, ICoverImageCmp, IElement {
  __typename?: 'Partner';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<IMediaWithCrops>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  logo?: Maybe<IMediaWithCrops>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partnerName?: Maybe<Scalars['String']>;
  /** Link to corporate / job page */
  partnerUrl?: Maybe<Scalars['String']>;
  /** 300 char. max. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPartnerAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnerChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnerDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnerDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerLogoArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerPartnerNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnerUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Partner`. */
export interface IPartnerConnection {
  __typename?: 'PartnerConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPartnerEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPartner>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Partner`. */
export interface IPartnerEdge {
  __typename?: 'PartnerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPartner>;
}

/** A filter input for the type `Partner`. */
export interface IPartnerFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPartnerFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPartnerFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPartnerFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  partnerName?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  partnerName_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  partnerName_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  partnerName_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  partnerName_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  partnerUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  partnerUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  partnerUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  partnerUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  partnerUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Partner`. */
export enum IPartnerOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `partnerName` in ascending order. */
  PartnerNameAsc = 'partnerName_ASC',
  /** Order by `partnerName` in descending order. */
  PartnerNameDesc = 'partnerName_DESC',
  /** Order by `partnerUrl` in ascending order. */
  PartnerUrlAsc = 'partnerUrl_ASC',
  /** Order by `partnerUrl` in descending order. */
  PartnerUrlDesc = 'partnerUrl_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Display a slider with picked partners logo */
export interface IPartnerSlider extends IElement {
  __typename?: 'PartnerSlider';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** left empty to not show link */
  isLink?: Maybe<IContent>;
  slider?: Maybe<Array<Maybe<IContent>>>;
  title?: Maybe<Scalars['String']>;
}

export interface IPartners extends IContent, IElement {
  __typename?: 'Partners';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPartnersAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnersChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnersDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnersNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnersParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnersUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnersUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Partners`. */
export interface IPartnersConnection {
  __typename?: 'PartnersConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPartnersEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPartners>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Partners`. */
export interface IPartnersEdge {
  __typename?: 'PartnersEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPartners>;
}

/** A filter input for the type `Partners`. */
export interface IPartnersFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPartnersFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPartnersFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPartnersFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Partners`. */
export enum IPartnersOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IPartnersPage extends IContent, ICoverVideoCmp, IElement, IPage {
  __typename?: 'PartnersPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  list?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPartnersPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnersPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnersPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPartnersPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnersPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnersPageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnersPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnersPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPartnersPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PartnersPage`. */
export interface IPartnersPageConnection {
  __typename?: 'PartnersPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPartnersPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPartnersPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PartnersPage`. */
export interface IPartnersPageEdge {
  __typename?: 'PartnersPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPartnersPage>;
}

/** A filter input for the type `PartnersPage`. */
export interface IPartnersPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPartnersPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPartnersPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPartnersPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  list_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  list_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PartnersPage`. */
export enum IPartnersPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Set up a precise paywall for this content */
export interface IPaywall extends IContent, ICoverVideoCmp, IElement {
  __typename?: 'Paywall';
  /** The ancestors. */
  ancestors: IContentConnection;
  cTAs?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  disabledPreview?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  mentionLegalLabel?: Maybe<Scalars['String']>;
  mentionLegalLink?: Maybe<Array<Maybe<IBlockListItem>>>;
  /**
   * This field is not used anymore, terms and conditions from settings pages are display
   * instead of this one !
   */
  mentionLegalLink2?: Maybe<IContent>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pageBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** Deprecated */
  playerPremiumText?: Maybe<Scalars['String']>;
  /** text */
  premiumPreviewTvStep1?: Maybe<Scalars['String']>;
  /** text */
  premiumPreviewTvStep2?: Maybe<Scalars['String']>;
  /** text */
  premiumPreviewTvStep3?: Maybe<Scalars['String']>;
  previewAnimatedTitle?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** In millisecond (ms) */
  previewAnimationDuration?: Maybe<Scalars['Int']>;
  previewCancelMention?: Maybe<Scalars['String']>;
  previewCoverDesktop?: Maybe<IMediaWithCrops>;
  previewCoverMobile?: Maybe<IMediaWithCrops>;
  /** Duration in min */
  previewDurationTv?: Maybe<Scalars['Int']>;
  /** Duration in min */
  previewDurationVod?: Maybe<Scalars['Int']>;
  /** Enter part of subtitle to be highlighted */
  previewHighlightedSubtitle?: Maybe<Scalars['String']>;
  previewIcon?: Maybe<IMediaWithCrops>;
  previewLabelCta?: Maybe<Scalars['String']>;
  previewMentionFooter?: Maybe<Scalars['String']>;
  previewSubscribeDescription?: Maybe<Scalars['String']>;
  previewSubscribeTitle?: Maybe<Scalars['String']>;
  previewSubtitle?: Maybe<Scalars['String']>;
  previewTitle?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Set up a precise paywall for this content */
export interface IPaywallCtAsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Set up a precise paywall for this content */
export interface IPaywallDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Set up a precise paywall for this content */
export interface IPaywallMentionLegalLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallMentionLegalLinkArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallMentionLegalLink2Args {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPageBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPlayerPremiumTextArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPremiumPreviewTvStep1Args {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPremiumPreviewTvStep2Args {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPremiumPreviewTvStep3Args {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewAnimatedTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewCancelMentionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewHighlightedSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewLabelCtaArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewMentionFooterArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewSubscribeDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewSubscribeTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallPreviewTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Set up a precise paywall for this content */
export interface IPaywallUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Paywall`. */
export interface IPaywallConnection {
  __typename?: 'PaywallConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPaywallEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPaywall>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Paywall`. */
export interface IPaywallEdge {
  __typename?: 'PaywallEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPaywall>;
}

/** A filter input for the type `Paywall`. */
export interface IPaywallFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPaywallFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPaywallFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPaywallFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  disabledPreview?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  mentionLegalLabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  mentionLegalLabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  mentionLegalLabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  mentionLegalLabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  mentionLegalLabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  mentionLegalLink2?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  playerPremiumText?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  playerPremiumText_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  playerPremiumText_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  playerPremiumText_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  playerPremiumText_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  premiumPreviewTvStep1?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  premiumPreviewTvStep1_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  premiumPreviewTvStep1_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  premiumPreviewTvStep1_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  premiumPreviewTvStep1_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  premiumPreviewTvStep2?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  premiumPreviewTvStep2_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  premiumPreviewTvStep2_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  premiumPreviewTvStep2_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  premiumPreviewTvStep2_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  premiumPreviewTvStep3?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  premiumPreviewTvStep3_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  premiumPreviewTvStep3_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  premiumPreviewTvStep3_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  premiumPreviewTvStep3_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  previewAnimatedTitle_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  previewAnimatedTitle_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  previewAnimationDuration?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  previewAnimationDuration_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  previewAnimationDuration_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  previewAnimationDuration_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  previewAnimationDuration_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  previewAnimationDuration_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  previewCancelMention?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewCancelMention_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewCancelMention_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewCancelMention_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewCancelMention_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  previewDurationTv?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  previewDurationTv_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  previewDurationTv_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  previewDurationTv_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  previewDurationTv_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  previewDurationTv_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  previewDurationVod?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  previewDurationVod_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  previewDurationVod_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  previewDurationVod_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  previewDurationVod_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  previewDurationVod_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  previewHighlightedSubtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewHighlightedSubtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewHighlightedSubtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewHighlightedSubtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewHighlightedSubtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  previewLabelCta?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewLabelCta_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewLabelCta_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewLabelCta_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewLabelCta_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  previewMentionFooter?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewMentionFooter_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewMentionFooter_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewMentionFooter_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewMentionFooter_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  previewSubscribeDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewSubscribeDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewSubscribeDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewSubscribeDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewSubscribeDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  previewSubscribeTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewSubscribeTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewSubscribeTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewSubscribeTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewSubscribeTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  previewSubtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewSubtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewSubtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewSubtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewSubtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  previewTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  previewTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  previewTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  previewTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  previewTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

export interface IPaywallFolder extends IContent, IElement {
  __typename?: 'PaywallFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPaywallFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPaywallFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPaywallFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPaywallFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPaywallFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPaywallFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPaywallFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PaywallFolder`. */
export interface IPaywallFolderConnection {
  __typename?: 'PaywallFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPaywallFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPaywallFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PaywallFolder`. */
export interface IPaywallFolderEdge {
  __typename?: 'PaywallFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPaywallFolder>;
}

/** A filter input for the type `PaywallFolder`. */
export interface IPaywallFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPaywallFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPaywallFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPaywallFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PaywallFolder`. */
export enum IPaywallFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `Paywall`. */
export enum IPaywallOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `disabledPreview` in ascending order. */
  DisabledPreviewAsc = 'disabledPreview_ASC',
  /** Order by `disabledPreview` in descending order. */
  DisabledPreviewDesc = 'disabledPreview_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `mentionLegalLabel` in ascending order. */
  MentionLegalLabelAsc = 'mentionLegalLabel_ASC',
  /** Order by `mentionLegalLabel` in descending order. */
  MentionLegalLabelDesc = 'mentionLegalLabel_DESC',
  /** Order by `mentionLegalLink2` in ascending order. */
  MentionLegalLink2Asc = 'mentionLegalLink2_ASC',
  /** Order by `mentionLegalLink2` in descending order. */
  MentionLegalLink2Desc = 'mentionLegalLink2_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `playerPremiumText` in ascending order. */
  PlayerPremiumTextAsc = 'playerPremiumText_ASC',
  /** Order by `playerPremiumText` in descending order. */
  PlayerPremiumTextDesc = 'playerPremiumText_DESC',
  /** Order by `premiumPreviewTvStep1` in ascending order. */
  PremiumPreviewTvStep1Asc = 'premiumPreviewTvStep1_ASC',
  /** Order by `premiumPreviewTvStep1` in descending order. */
  PremiumPreviewTvStep1Desc = 'premiumPreviewTvStep1_DESC',
  /** Order by `premiumPreviewTvStep2` in ascending order. */
  PremiumPreviewTvStep2Asc = 'premiumPreviewTvStep2_ASC',
  /** Order by `premiumPreviewTvStep2` in descending order. */
  PremiumPreviewTvStep2Desc = 'premiumPreviewTvStep2_DESC',
  /** Order by `premiumPreviewTvStep3` in ascending order. */
  PremiumPreviewTvStep3Asc = 'premiumPreviewTvStep3_ASC',
  /** Order by `premiumPreviewTvStep3` in descending order. */
  PremiumPreviewTvStep3Desc = 'premiumPreviewTvStep3_DESC',
  /** Order by `previewAnimationDuration` in ascending order. */
  PreviewAnimationDurationAsc = 'previewAnimationDuration_ASC',
  /** Order by `previewAnimationDuration` in descending order. */
  PreviewAnimationDurationDesc = 'previewAnimationDuration_DESC',
  /** Order by `previewCancelMention` in ascending order. */
  PreviewCancelMentionAsc = 'previewCancelMention_ASC',
  /** Order by `previewCancelMention` in descending order. */
  PreviewCancelMentionDesc = 'previewCancelMention_DESC',
  /** Order by `previewDurationTv` in ascending order. */
  PreviewDurationTvAsc = 'previewDurationTv_ASC',
  /** Order by `previewDurationTv` in descending order. */
  PreviewDurationTvDesc = 'previewDurationTv_DESC',
  /** Order by `previewDurationVod` in ascending order. */
  PreviewDurationVodAsc = 'previewDurationVod_ASC',
  /** Order by `previewDurationVod` in descending order. */
  PreviewDurationVodDesc = 'previewDurationVod_DESC',
  /** Order by `previewHighlightedSubtitle` in ascending order. */
  PreviewHighlightedSubtitleAsc = 'previewHighlightedSubtitle_ASC',
  /** Order by `previewHighlightedSubtitle` in descending order. */
  PreviewHighlightedSubtitleDesc = 'previewHighlightedSubtitle_DESC',
  /** Order by `previewLabelCta` in ascending order. */
  PreviewLabelCtaAsc = 'previewLabelCta_ASC',
  /** Order by `previewLabelCta` in descending order. */
  PreviewLabelCtaDesc = 'previewLabelCta_DESC',
  /** Order by `previewMentionFooter` in ascending order. */
  PreviewMentionFooterAsc = 'previewMentionFooter_ASC',
  /** Order by `previewMentionFooter` in descending order. */
  PreviewMentionFooterDesc = 'previewMentionFooter_DESC',
  /** Order by `previewSubscribeDescription` in ascending order. */
  PreviewSubscribeDescriptionAsc = 'previewSubscribeDescription_ASC',
  /** Order by `previewSubscribeDescription` in descending order. */
  PreviewSubscribeDescriptionDesc = 'previewSubscribeDescription_DESC',
  /** Order by `previewSubscribeTitle` in ascending order. */
  PreviewSubscribeTitleAsc = 'previewSubscribeTitle_ASC',
  /** Order by `previewSubscribeTitle` in descending order. */
  PreviewSubscribeTitleDesc = 'previewSubscribeTitle_DESC',
  /** Order by `previewSubtitle` in ascending order. */
  PreviewSubtitleAsc = 'previewSubtitle_ASC',
  /** Order by `previewSubtitle` in descending order. */
  PreviewSubtitleDesc = 'previewSubtitle_DESC',
  /** Order by `previewTitle` in ascending order. */
  PreviewTitleAsc = 'previewTitle_ASC',
  /** Order by `previewTitle` in descending order. */
  PreviewTitleDesc = 'previewTitle_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IPersonalityPages extends IContent, ICoverVideoCmp, IElement {
  __typename?: 'PersonalityPages';
  /** The ancestors. */
  ancestors: IContentConnection;
  body?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  icon?: Maybe<IMediaWithCrops>;
  /** The unique identifier. */
  id: Scalars['ID'];
  introduction?: Maybe<Scalars['String']>;
  /** The level. */
  level: Scalars['Int'];
  linkedTag?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPersonalityPagesAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityPagesBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityPagesChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityPagesDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityPagesIntroductionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityPagesNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityPagesParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityPagesSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityPagesTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityPagesUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityPagesUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PersonalityPages`. */
export interface IPersonalityPagesConnection {
  __typename?: 'PersonalityPagesConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPersonalityPagesEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPersonalityPages>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PersonalityPages`. */
export interface IPersonalityPagesEdge {
  __typename?: 'PersonalityPagesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPersonalityPages>;
}

/** A filter input for the type `PersonalityPages`. */
export interface IPersonalityPagesFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPersonalityPagesFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPersonalityPagesFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPersonalityPagesFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  introduction?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  introduction_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  introduction_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  introduction_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  introduction_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  linkedTag_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  linkedTag_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PersonalityPages`. */
export enum IPersonalityPagesOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `introduction` in ascending order. */
  IntroductionAsc = 'introduction_ASC',
  /** Order by `introduction` in descending order. */
  IntroductionDesc = 'introduction_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IPersonalityPush extends IElement {
  __typename?: 'PersonalityPush';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
}

export interface IPersonalityQuiz extends IContent, ICoverVideoCmp, IElement {
  __typename?: 'PersonalityQuiz';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  ctaLabel?: Maybe<Scalars['String']>;
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  methodBody?: Maybe<Array<Maybe<IBlockListItem>>>;
  methodCover?: Maybe<Array<Maybe<IBlockListItem>>>;
  methodHighlightedCourses?: Maybe<IContent>;
  methodIntro?: Maybe<Scalars['String']>;
  methodTitle?: Maybe<Scalars['String']>;
  methodologyPush?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  personalitiesCTALabel?: Maybe<Scalars['String']>;
  personalitiesCover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** will link to personality index page */
  personalitiesPush?: Maybe<Array<Maybe<IBlockListItem>>>;
  personalitiesSubtitle?: Maybe<Scalars['String']>;
  personalitiesTitle?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<IBlockListItem>>>;
  resultSubtitle?: Maybe<Scalars['String']>;
  resultTitle?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPersonalityQuizAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityQuizChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityQuizCtaLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityQuizMethodBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizMethodIntroArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizMethodTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizMethodologyPushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizPersonalitiesCtaLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizPersonalitiesCoverArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizPersonalitiesPushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizPersonalitiesSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizPersonalitiesTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizQuestionsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuizUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IPersonalityQuiz1 extends IContent, IElement {
  __typename?: 'PersonalityQuiz1';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  questions?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPersonalityQuiz1AncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityQuiz1ChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityQuiz1DescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityQuiz1NameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuiz1ParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuiz1QuestionsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuiz1UpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityQuiz1UrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PersonalityQuiz1`. */
export interface IPersonalityQuiz1Connection {
  __typename?: 'PersonalityQuiz1Connection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPersonalityQuiz1Edge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPersonalityQuiz1>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PersonalityQuiz1`. */
export interface IPersonalityQuiz1Edge {
  __typename?: 'PersonalityQuiz1Edge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPersonalityQuiz1>;
}

/** A filter input for the type `PersonalityQuiz1`. */
export interface IPersonalityQuiz1FilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPersonalityQuiz1FilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPersonalityQuiz1FilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPersonalityQuiz1FilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PersonalityQuiz1`. */
export enum IPersonalityQuiz1OrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A connection from an object to a list of objects of type `PersonalityQuiz`. */
export interface IPersonalityQuizConnection {
  __typename?: 'PersonalityQuizConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPersonalityQuizEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPersonalityQuiz>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PersonalityQuiz`. */
export interface IPersonalityQuizEdge {
  __typename?: 'PersonalityQuizEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPersonalityQuiz>;
}

/** A filter input for the type `PersonalityQuiz`. */
export interface IPersonalityQuizFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPersonalityQuizFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPersonalityQuizFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPersonalityQuizFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  ctaLabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  ctaLabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  ctaLabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  ctaLabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  ctaLabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  methodHighlightedCourses?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  methodIntro?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  methodIntro_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  methodIntro_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  methodIntro_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  methodIntro_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  methodTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  methodTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  methodTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  methodTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  methodTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  personalitiesCTALabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  personalitiesCTALabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  personalitiesCTALabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  personalitiesCTALabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  personalitiesCTALabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  personalitiesSubtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  personalitiesSubtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  personalitiesSubtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  personalitiesSubtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  personalitiesSubtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  personalitiesTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  personalitiesTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  personalitiesTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  personalitiesTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  personalitiesTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  resultSubtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  resultSubtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  resultSubtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  resultSubtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  resultSubtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  resultTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  resultTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  resultTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  resultTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  resultTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PersonalityQuiz`. */
export enum IPersonalityQuizOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `ctaLabel` in ascending order. */
  CtaLabelAsc = 'ctaLabel_ASC',
  /** Order by `ctaLabel` in descending order. */
  CtaLabelDesc = 'ctaLabel_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `methodHighlightedCourses` in ascending order. */
  MethodHighlightedCoursesAsc = 'methodHighlightedCourses_ASC',
  /** Order by `methodHighlightedCourses` in descending order. */
  MethodHighlightedCoursesDesc = 'methodHighlightedCourses_DESC',
  /** Order by `methodIntro` in ascending order. */
  MethodIntroAsc = 'methodIntro_ASC',
  /** Order by `methodIntro` in descending order. */
  MethodIntroDesc = 'methodIntro_DESC',
  /** Order by `methodTitle` in ascending order. */
  MethodTitleAsc = 'methodTitle_ASC',
  /** Order by `methodTitle` in descending order. */
  MethodTitleDesc = 'methodTitle_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `personalitiesCTALabel` in ascending order. */
  PersonalitiesCtaLabelAsc = 'personalitiesCTALabel_ASC',
  /** Order by `personalitiesCTALabel` in descending order. */
  PersonalitiesCtaLabelDesc = 'personalitiesCTALabel_DESC',
  /** Order by `personalitiesSubtitle` in ascending order. */
  PersonalitiesSubtitleAsc = 'personalitiesSubtitle_ASC',
  /** Order by `personalitiesSubtitle` in descending order. */
  PersonalitiesSubtitleDesc = 'personalitiesSubtitle_DESC',
  /** Order by `personalitiesTitle` in ascending order. */
  PersonalitiesTitleAsc = 'personalitiesTitle_ASC',
  /** Order by `personalitiesTitle` in descending order. */
  PersonalitiesTitleDesc = 'personalitiesTitle_DESC',
  /** Order by `resultSubtitle` in ascending order. */
  ResultSubtitleAsc = 'resultSubtitle_ASC',
  /** Order by `resultSubtitle` in descending order. */
  ResultSubtitleDesc = 'resultSubtitle_DESC',
  /** Order by `resultTitle` in ascending order. */
  ResultTitleAsc = 'resultTitle_ASC',
  /** Order by `resultTitle` in descending order. */
  ResultTitleDesc = 'resultTitle_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IPersonalityQuizQuestion extends IElement {
  __typename?: 'PersonalityQuizQuestion';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  linkedPersonalities?: Maybe<Array<Maybe<IContent>>>;
  /** Weight of the answer on the user profile */
  weight?: Maybe<Scalars['Int']>;
}

export interface IPersonalityType extends IContent, IElement {
  __typename?: 'PersonalityType';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  personality?: Maybe<IContent>;
  score?: Maybe<Scalars['Decimal']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPersonalityTypeAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityTypeChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityTypeDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPersonalityTypeNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityTypeParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityTypeUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPersonalityTypeUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PersonalityType`. */
export interface IPersonalityTypeConnection {
  __typename?: 'PersonalityTypeConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPersonalityTypeEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPersonalityType>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PersonalityType`. */
export interface IPersonalityTypeEdge {
  __typename?: 'PersonalityTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPersonalityType>;
}

/** A filter input for the type `PersonalityType`. */
export interface IPersonalityTypeFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPersonalityTypeFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPersonalityTypeFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPersonalityTypeFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  personality?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  score?: InputMaybe<Scalars['Decimal']>;
  /** Field must match any of the values. */
  score_any?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  /** Field must be greater than the value. */
  score_gt?: InputMaybe<Scalars['Decimal']>;
  /** Field must be greater than or equal the value. */
  score_gte?: InputMaybe<Scalars['Decimal']>;
  /** Field must be less than the value. */
  score_lt?: InputMaybe<Scalars['Decimal']>;
  /** Field must be less than or equal the value. */
  score_lte?: InputMaybe<Scalars['Decimal']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PersonalityType`. */
export enum IPersonalityTypeOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `personality` in ascending order. */
  PersonalityAsc = 'personality_ASC',
  /** Order by `personality` in descending order. */
  PersonalityDesc = 'personality_DESC',
  /** Order by `score` in ascending order. */
  ScoreAsc = 'score_ASC',
  /** Order by `score` in descending order. */
  ScoreDesc = 'score_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IPickedColor {
  __typename?: 'PickedColor';
  /** The color. */
  color: Scalars['String'];
  /** The label. */
  label: Scalars['String'];
}

export interface IPlaylist extends IContent, IContentItems, IDescriptionBlockCmp, IElement, IMetasAuthorCmp, ITop10Cmp {
  __typename?: 'Playlist';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** You can add all sort of featured people (including hosts, guests, technical crew, etc.) */
  author?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  descriptionTitle?: Maybe<Scalars['String']>;
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** URL to the EPG file */
  epg?: Maybe<Scalars['String']>;
  exclusives?: Maybe<Scalars['Boolean']>;
  /** URL to the HLS file */
  hls?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  imageFormat?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<IContent>>>;
  /** The level. */
  level: Scalars['Int'];
  linkedJobs?: Maybe<Scalars['String']>;
  mogadorProductKey?: Maybe<Scalars['String']>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  personality?: Maybe<Array<Maybe<Scalars['String']>>>;
  pubDate?: Maybe<Scalars['DateTime']>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
  subtitle?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  top10?: Maybe<Array<Maybe<IBlockListItem>>>;
  top10Title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPlaylistAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPlaylistChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPlaylistDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPlaylistDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistDescriptionTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistTop10Args {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistTop10TitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Playlist`. */
export interface IPlaylistConnection {
  __typename?: 'PlaylistConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPlaylistEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPlaylist>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Playlist`. */
export interface IPlaylistEdge {
  __typename?: 'PlaylistEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPlaylist>;
}

/** A filter input for the type `Playlist`. */
export interface IPlaylistFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPlaylistFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPlaylistFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPlaylistFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  descriptionTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  descriptionTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  descriptionTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  descriptionTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  descriptionTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  epg?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  epg_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  epg_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  epg_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  epg_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  exclusives?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  hls?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  hls_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  hls_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  hls_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  hls_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  imageFormat?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  imageFormat_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  imageFormat_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  imageFormat_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  imageFormat_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  linkedJobs?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  linkedJobs_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  linkedJobs_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  linkedJobs_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  linkedJobs_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  mogadorProductKey?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  mogadorProductKey_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  mogadorProductKey_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  mogadorProductKey_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  mogadorProductKey_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  musicGenre_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  musicGenre_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  personality_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  personality_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  pubDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  pubDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  pubDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  pubDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  pubDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must match all of the values. */
  regions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  regions_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  top10Title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  top10Title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  top10Title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  top10Title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  top10Title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Playlist`. */
export enum IPlaylistOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `descriptionTitle` in ascending order. */
  DescriptionTitleAsc = 'descriptionTitle_ASC',
  /** Order by `descriptionTitle` in descending order. */
  DescriptionTitleDesc = 'descriptionTitle_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `epg` in ascending order. */
  EpgAsc = 'epg_ASC',
  /** Order by `epg` in descending order. */
  EpgDesc = 'epg_DESC',
  /** Order by `exclusives` in ascending order. */
  ExclusivesAsc = 'exclusives_ASC',
  /** Order by `exclusives` in descending order. */
  ExclusivesDesc = 'exclusives_DESC',
  /** Order by `hls` in ascending order. */
  HlsAsc = 'hls_ASC',
  /** Order by `hls` in descending order. */
  HlsDesc = 'hls_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `imageFormat` in ascending order. */
  ImageFormatAsc = 'imageFormat_ASC',
  /** Order by `imageFormat` in descending order. */
  ImageFormatDesc = 'imageFormat_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `linkedJobs` in ascending order. */
  LinkedJobsAsc = 'linkedJobs_ASC',
  /** Order by `linkedJobs` in descending order. */
  LinkedJobsDesc = 'linkedJobs_DESC',
  /** Order by `mogadorProductKey` in ascending order. */
  MogadorProductKeyAsc = 'mogadorProductKey_ASC',
  /** Order by `mogadorProductKey` in descending order. */
  MogadorProductKeyDesc = 'mogadorProductKey_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `pubDate` in ascending order. */
  PubDateAsc = 'pubDate_ASC',
  /** Order by `pubDate` in descending order. */
  PubDateDesc = 'pubDate_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `top10Title` in ascending order. */
  Top10TitleAsc = 'top10Title_ASC',
  /** Order by `top10Title` in descending order. */
  Top10TitleDesc = 'top10Title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IPlaylistRadioMenu extends IContent, IElement, IListenMenu {
  __typename?: 'PlaylistRadioMenu';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPlaylistRadioMenuAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPlaylistRadioMenuChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPlaylistRadioMenuDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPlaylistRadioMenuNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistRadioMenuParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistRadioMenuUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPlaylistRadioMenuUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PlaylistRadioMenu`. */
export interface IPlaylistRadioMenuConnection {
  __typename?: 'PlaylistRadioMenuConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPlaylistRadioMenuEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPlaylistRadioMenu>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PlaylistRadioMenu`. */
export interface IPlaylistRadioMenuEdge {
  __typename?: 'PlaylistRadioMenuEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPlaylistRadioMenu>;
}

/** A filter input for the type `PlaylistRadioMenu`. */
export interface IPlaylistRadioMenuFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPlaylistRadioMenuFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPlaylistRadioMenuFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPlaylistRadioMenuFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PlaylistRadioMenu`. */
export enum IPlaylistRadioMenuOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IPodcast extends IContent, IContentDescriptionCmp, IContentItems, IElement, IMetasAuthorCmp, IMetasVideosCmp {
  __typename?: 'Podcast';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** You can add all sort of featured people (including hosts, guests, technical crew, etc.) */
  author?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  episodesCount?: Maybe<Scalars['Int']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  imageFormat?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<IContent>>>;
  /** in seconds */
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  linkedJobs?: Maybe<Scalars['String']>;
  mogadorProductKey?: Maybe<Scalars['String']>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  personality?: Maybe<Array<Maybe<Scalars['String']>>>;
  public?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  seasonsCount?: Maybe<Scalars['Int']>;
  /** 300 char. max. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
  subtitle?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** Vimeo ID for trailer video */
  trailer?: Maybe<Scalars['Int']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPodcastAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastTrailerArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IPodcastCateg extends IContent, IElement {
  __typename?: 'PodcastCateg';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPodcastCategAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastCategChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastCategDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastCategNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastCategParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastCategUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastCategUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PodcastCateg`. */
export interface IPodcastCategConnection {
  __typename?: 'PodcastCategConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPodcastCategEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPodcastCateg>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PodcastCateg`. */
export interface IPodcastCategEdge {
  __typename?: 'PodcastCategEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPodcastCateg>;
}

/** A filter input for the type `PodcastCateg`. */
export interface IPodcastCategFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPodcastCategFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPodcastCategFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPodcastCategFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PodcastCateg`. */
export enum IPodcastCategOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A connection from an object to a list of objects of type `Podcast`. */
export interface IPodcastConnection {
  __typename?: 'PodcastConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPodcastEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPodcast>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Podcast`. */
export interface IPodcastEdge {
  __typename?: 'PodcastEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPodcast>;
}

/** A filter input for the type `Podcast`. */
export interface IPodcastFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPodcastFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPodcastFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPodcastFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  episodesCount?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  episodesCount_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  episodesCount_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  episodesCount_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  episodesCount_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  episodesCount_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  imageFormat?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  imageFormat_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  imageFormat_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  imageFormat_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  imageFormat_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  linkedJobs?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  linkedJobs_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  linkedJobs_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  linkedJobs_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  linkedJobs_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  mogadorProductKey?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  mogadorProductKey_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  mogadorProductKey_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  mogadorProductKey_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  mogadorProductKey_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  musicGenre_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  musicGenre_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  personality_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  personality_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  public?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  public_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  public_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  public_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  public_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  regions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  regions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  releaseDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  releaseDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  releaseDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  releaseDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  releaseDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  seasonsCount?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  seasonsCount_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  seasonsCount_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  seasonsCount_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  seasonsCount_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  seasonsCount_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  trailer?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  trailer_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  trailer_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  trailer_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  trailer_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  trailer_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

export interface IPodcastItem extends IContent, IContentDescriptionCmp, ICoverThumbnailCmp, IElement, IMetasVideosCmp {
  __typename?: 'PodcastItem';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** URL to the HLS file */
  hls?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** in seconds */
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  public?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  /** 300 char. max. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  /** This is an auto filled field */
  vimeoHlsUrl?: Maybe<Scalars['String']>;
  vimeoId?: Maybe<Scalars['Int']>;
}


export interface IPodcastItemAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastItemChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastItemDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastItemDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastItemNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastItemParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastItemShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastItemTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastItemUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastItemUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PodcastItem`. */
export interface IPodcastItemConnection {
  __typename?: 'PodcastItemConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPodcastItemEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPodcastItem>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PodcastItem`. */
export interface IPodcastItemEdge {
  __typename?: 'PodcastItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPodcastItem>;
}

/** A filter input for the type `PodcastItem`. */
export interface IPodcastItemFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPodcastItemFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPodcastItemFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPodcastItemFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  hls?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  hls_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  hls_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  hls_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  hls_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  public?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  public_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  public_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  public_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  public_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  releaseDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  releaseDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  releaseDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  releaseDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  releaseDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  vimeoHlsUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  vimeoHlsUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  vimeoHlsUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  vimeoHlsUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  vimeoHlsUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  vimeoId?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  vimeoId_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  vimeoId_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  vimeoId_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  vimeoId_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  vimeoId_lte?: InputMaybe<Scalars['Int']>;
}

/** An order input for the type `PodcastItem`. */
export enum IPodcastItemOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `hls` in ascending order. */
  HlsAsc = 'hls_ASC',
  /** Order by `hls` in descending order. */
  HlsDesc = 'hls_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `public` in ascending order. */
  PublicAsc = 'public_ASC',
  /** Order by `public` in descending order. */
  PublicDesc = 'public_DESC',
  /** Order by `releaseDate` in ascending order. */
  ReleaseDateAsc = 'releaseDate_ASC',
  /** Order by `releaseDate` in descending order. */
  ReleaseDateDesc = 'releaseDate_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `vimeoHlsUrl` in ascending order. */
  VimeoHlsUrlAsc = 'vimeoHlsUrl_ASC',
  /** Order by `vimeoHlsUrl` in descending order. */
  VimeoHlsUrlDesc = 'vimeoHlsUrl_DESC',
  /** Order by `vimeoId` in ascending order. */
  VimeoIdAsc = 'vimeoId_ASC',
  /** Order by `vimeoId` in descending order. */
  VimeoIdDesc = 'vimeoId_DESC'
}

export interface IPodcastMenu extends IContent, IElement, IListenMenu {
  __typename?: 'PodcastMenu';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IPodcastMenuAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastMenuChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastMenuDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPodcastMenuNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastMenuParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastMenuUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPodcastMenuUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PodcastMenu`. */
export interface IPodcastMenuConnection {
  __typename?: 'PodcastMenuConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPodcastMenuEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPodcastMenu>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PodcastMenu`. */
export interface IPodcastMenuEdge {
  __typename?: 'PodcastMenuEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPodcastMenu>;
}

/** A filter input for the type `PodcastMenu`. */
export interface IPodcastMenuFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPodcastMenuFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPodcastMenuFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPodcastMenuFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PodcastMenu`. */
export enum IPodcastMenuOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `Podcast`. */
export enum IPodcastOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `episodesCount` in ascending order. */
  EpisodesCountAsc = 'episodesCount_ASC',
  /** Order by `episodesCount` in descending order. */
  EpisodesCountDesc = 'episodesCount_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `imageFormat` in ascending order. */
  ImageFormatAsc = 'imageFormat_ASC',
  /** Order by `imageFormat` in descending order. */
  ImageFormatDesc = 'imageFormat_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `linkedJobs` in ascending order. */
  LinkedJobsAsc = 'linkedJobs_ASC',
  /** Order by `linkedJobs` in descending order. */
  LinkedJobsDesc = 'linkedJobs_DESC',
  /** Order by `mogadorProductKey` in ascending order. */
  MogadorProductKeyAsc = 'mogadorProductKey_ASC',
  /** Order by `mogadorProductKey` in descending order. */
  MogadorProductKeyDesc = 'mogadorProductKey_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `public` in ascending order. */
  PublicAsc = 'public_ASC',
  /** Order by `public` in descending order. */
  PublicDesc = 'public_DESC',
  /** Order by `releaseDate` in ascending order. */
  ReleaseDateAsc = 'releaseDate_ASC',
  /** Order by `releaseDate` in descending order. */
  ReleaseDateDesc = 'releaseDate_DESC',
  /** Order by `seasonsCount` in ascending order. */
  SeasonsCountAsc = 'seasonsCount_ASC',
  /** Order by `seasonsCount` in descending order. */
  SeasonsCountDesc = 'seasonsCount_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `trailer` in ascending order. */
  TrailerAsc = 'trailer_ASC',
  /** Order by `trailer` in descending order. */
  TrailerDesc = 'trailer_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Grant access to Membership for a given number of day */
export interface IPromoCode extends IContent, IElement {
  __typename?: 'PromoCode';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** to redeem in the app */
  code?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** in days */
  duration?: Maybe<Scalars['Int']>;
  /**
   * of validity for the promo code
   * [Leave empty for unlimited]
   */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** of validity for the promo code */
  startDate?: Maybe<Scalars['DateTime']>;
  /** [Leave empty for unlimited] */
  stock?: Maybe<Scalars['Int']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** Grant access to Membership for a given number of day */
export interface IPromoCodeAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Grant access to Membership for a given number of day */
export interface IPromoCodeChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Grant access to Membership for a given number of day */
export interface IPromoCodeDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Grant access to Membership for a given number of day */
export interface IPromoCodeNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Grant access to Membership for a given number of day */
export interface IPromoCodeParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Grant access to Membership for a given number of day */
export interface IPromoCodeUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Grant access to Membership for a given number of day */
export interface IPromoCodeUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PromoCode`. */
export interface IPromoCodeConnection {
  __typename?: 'PromoCodeConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPromoCodeEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPromoCode>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PromoCode`. */
export interface IPromoCodeEdge {
  __typename?: 'PromoCodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPromoCode>;
}

/** A filter input for the type `PromoCode`. */
export interface IPromoCodeFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPromoCodeFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPromoCodeFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPromoCodeFilterInput>>>;
  /** Field must equal value. */
  code?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  code_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  code_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  code_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  code_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  duration?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  duration_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  duration_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  duration_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  duration_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  duration_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  stock?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  stock_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  stock_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  stock_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  stock_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  stock_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

export interface IPromoCodeFolder extends IContent, IElement {
  __typename?: 'PromoCodeFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  footerImage?: Maybe<IMediaWithCrops>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subscriptionDescription?: Maybe<Scalars['String']>;
  subscriptionTitle?: Maybe<Scalars['String']>;
  /** Body */
  thankYouBody?: Maybe<Scalars['String']>;
  /** Cover */
  thankYouCover?: Maybe<Array<Maybe<IBlockListItem>>>;
  thankYouTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  variantCover?: Maybe<IMediaWithCrops>;
  variantCtaLabel?: Maybe<Scalars['String']>;
  variantDescription?: Maybe<Scalars['String']>;
  /** Mention text in orange */
  variantHighlightedMention?: Maybe<Scalars['String']>;
  variantHighlightedTitle?: Maybe<Scalars['String']>;
  variantMention?: Maybe<Scalars['String']>;
  variantSurtitle?: Maybe<Scalars['String']>;
  variantTitle?: Maybe<Scalars['String']>;
}


export interface IPromoCodeFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPromoCodeFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPromoCodeFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IPromoCodeFolderDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderFooterImageArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderSubscriptionDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderSubscriptionTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderThankYouBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderThankYouTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderVariantCtaLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderVariantDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderVariantHighlightedMentionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderVariantHighlightedTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderVariantMentionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderVariantSurtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IPromoCodeFolderVariantTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `PromoCodeFolder`. */
export interface IPromoCodeFolderConnection {
  __typename?: 'PromoCodeFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IPromoCodeFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IPromoCodeFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `PromoCodeFolder`. */
export interface IPromoCodeFolderEdge {
  __typename?: 'PromoCodeFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IPromoCodeFolder>;
}

/** A filter input for the type `PromoCodeFolder`. */
export interface IPromoCodeFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IPromoCodeFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IPromoCodeFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IPromoCodeFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subscriptionDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subscriptionDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subscriptionDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subscriptionDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subscriptionDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  subscriptionTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subscriptionTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subscriptionTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subscriptionTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subscriptionTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  thankYouBody?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  thankYouBody_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  thankYouBody_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  thankYouBody_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  thankYouBody_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  thankYouTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  thankYouTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  thankYouTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  thankYouTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  thankYouTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  variantCtaLabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  variantCtaLabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  variantCtaLabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  variantCtaLabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  variantCtaLabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  variantDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  variantDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  variantDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  variantDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  variantDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  variantHighlightedMention?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  variantHighlightedMention_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  variantHighlightedMention_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  variantHighlightedMention_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  variantHighlightedMention_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  variantHighlightedTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  variantHighlightedTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  variantHighlightedTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  variantHighlightedTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  variantHighlightedTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  variantMention?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  variantMention_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  variantMention_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  variantMention_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  variantMention_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  variantSurtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  variantSurtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  variantSurtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  variantSurtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  variantSurtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  variantTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  variantTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  variantTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  variantTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  variantTitle_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `PromoCodeFolder`. */
export enum IPromoCodeFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subscriptionDescription` in ascending order. */
  SubscriptionDescriptionAsc = 'subscriptionDescription_ASC',
  /** Order by `subscriptionDescription` in descending order. */
  SubscriptionDescriptionDesc = 'subscriptionDescription_DESC',
  /** Order by `subscriptionTitle` in ascending order. */
  SubscriptionTitleAsc = 'subscriptionTitle_ASC',
  /** Order by `subscriptionTitle` in descending order. */
  SubscriptionTitleDesc = 'subscriptionTitle_DESC',
  /** Order by `thankYouBody` in ascending order. */
  ThankYouBodyAsc = 'thankYouBody_ASC',
  /** Order by `thankYouBody` in descending order. */
  ThankYouBodyDesc = 'thankYouBody_DESC',
  /** Order by `thankYouTitle` in ascending order. */
  ThankYouTitleAsc = 'thankYouTitle_ASC',
  /** Order by `thankYouTitle` in descending order. */
  ThankYouTitleDesc = 'thankYouTitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `variantCtaLabel` in ascending order. */
  VariantCtaLabelAsc = 'variantCtaLabel_ASC',
  /** Order by `variantCtaLabel` in descending order. */
  VariantCtaLabelDesc = 'variantCtaLabel_DESC',
  /** Order by `variantDescription` in ascending order. */
  VariantDescriptionAsc = 'variantDescription_ASC',
  /** Order by `variantDescription` in descending order. */
  VariantDescriptionDesc = 'variantDescription_DESC',
  /** Order by `variantHighlightedMention` in ascending order. */
  VariantHighlightedMentionAsc = 'variantHighlightedMention_ASC',
  /** Order by `variantHighlightedMention` in descending order. */
  VariantHighlightedMentionDesc = 'variantHighlightedMention_DESC',
  /** Order by `variantHighlightedTitle` in ascending order. */
  VariantHighlightedTitleAsc = 'variantHighlightedTitle_ASC',
  /** Order by `variantHighlightedTitle` in descending order. */
  VariantHighlightedTitleDesc = 'variantHighlightedTitle_DESC',
  /** Order by `variantMention` in ascending order. */
  VariantMentionAsc = 'variantMention_ASC',
  /** Order by `variantMention` in descending order. */
  VariantMentionDesc = 'variantMention_DESC',
  /** Order by `variantSurtitle` in ascending order. */
  VariantSurtitleAsc = 'variantSurtitle_ASC',
  /** Order by `variantSurtitle` in descending order. */
  VariantSurtitleDesc = 'variantSurtitle_DESC',
  /** Order by `variantTitle` in ascending order. */
  VariantTitleAsc = 'variantTitle_ASC',
  /** Order by `variantTitle` in descending order. */
  VariantTitleDesc = 'variantTitle_DESC'
}

/** An order input for the type `PromoCode`. */
export enum IPromoCodeOrderByInput {
  /** Order by `code` in ascending order. */
  CodeAsc = 'code_ASC',
  /** Order by `code` in descending order. */
  CodeDesc = 'code_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `duration` in ascending order. */
  DurationAsc = 'duration_ASC',
  /** Order by `duration` in descending order. */
  DurationDesc = 'duration_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `stock` in ascending order. */
  StockAsc = 'stock_ASC',
  /** Order by `stock` in descending order. */
  StockDesc = 'stock_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Push block to highlight a content with icon */
export interface IPush extends IElement {
  __typename?: 'Push';
  background?: Maybe<IMediaWithCrops>;
  backgroundDesktop?: Maybe<IMediaWithCrops>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<IMediaWithCrops>;
  isPremium?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Array<Maybe<IBlockListItem>>>;
  style?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topTitle?: Maybe<Scalars['String']>;
}


/** Push block to highlight a content with icon */
export interface IPushDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Push block to highlight a content with icon */
export interface IPushIsPremiumArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Push block to highlight a content with icon */
export interface IPushTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Push block to highlight a content with icon */
export interface IPushTopTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IQuery {
  __typename?: 'Query';
  /** Get all ArtistService */
  allArtistService: IArtistServiceConnection;
  /** Get all ArtistServiceFolder */
  allArtistServiceFolder: IArtistServiceFolderConnection;
  /** Get all ArtistServicesPage */
  allArtistServicesPage: IArtistServicesPageConnection;
  /** Get all AwardCategoryPage */
  allAwardCategoryPage: IAwardCategoryPageConnection;
  /** Get all AwardsArtist */
  allAwardsArtist: IAwardsArtistConnection;
  /** Get all AwardsCategoryMenu */
  allAwardsCategoryMenu: IAwardsCategoryMenuConnection;
  /** Get all AwardsCategoryMenuDev */
  allAwardsCategoryMenuDev: IAwardsCategoryMenuDevConnection;
  /** Get all AwardsCategoryMenuFolder */
  allAwardsCategoryMenuFolder: IAwardsCategoryMenuFolderConnection;
  /** Get all AwardsCategoryMenuFolderDev */
  allAwardsCategoryMenuFolderDev: IAwardsCategoryMenuFolderDevConnection;
  /** Get all AwardsHomepage */
  allAwardsHomepage: IAwardsHomepageConnection;
  /** Get all CMSPage */
  allCMSPage: ICmsPageConnection;
  /** Get all CategBgColor */
  allCategBgColor: ICategBgColorConnection;
  /** Get all CategoryPage */
  allCategoryPage: ICategoryPageConnection;
  /** Get all Channel */
  allChannel: IChannelConnection;
  /** Get all ChannelFolder */
  allChannelFolder: IChannelFolderConnection;
  /** Get all ChoiceNugget */
  allChoiceNugget: IChoiceNuggetConnection;
  /** Get all Collection */
  allCollection: ICollectionConnection;
  /** Fetch all Content */
  allContent: IContentConnection;
  /** Get all ContentEditorFolder */
  allContentEditorFolder: IContentEditorFolderConnection;
  /** Get all ContentTag */
  allContentTag: IContentTagConnection;
  /** Get all ContentTags */
  allContentTags: IContentTagsConnection;
  /** Get all ContentTagsCateg */
  allContentTagsCateg: IContentTagsCategConnection;
  /** Get all Course */
  allCourse: ICourseConnection;
  /** Get all CourseCategoriesFolder */
  allCourseCategoriesFolder: ICourseCategoriesFolderConnection;
  /** Get all CourseCategory */
  allCourseCategory: ICourseCategoryConnection;
  /** Get all CourseExam */
  allCourseExam: ICourseExamConnection;
  /** Get all CourseShare */
  allCourseShare: ICourseShareConnection;
  /** Get all CourseStatus */
  allCourseStatus: ICourseStatusConnection;
  /** Get all CourseTestProgression */
  allCourseTestProgression: ICourseTestProgressionConnection;
  /** Get all CourseUnit */
  allCourseUnit: ICourseUnitConnection;
  /** Get all Discovery */
  allDiscovery: IDiscoveryConnection;
  /** Get all DiscoverySlide1 */
  allDiscoverySlide1: IDiscoverySlide1Connection;
  /** Get all EntrepreunarialHub */
  allEntrepreunarialHub: IEntrepreunarialHubConnection;
  /** Get all FormFolder */
  allFormFolder: IFormFolderConnection;
  /** Get all FormPage */
  allFormPage: IFormPageConnection;
  /** Get all GapfillNugget */
  allGapfillNugget: IGapfillNuggetConnection;
  /** Get all HelpdeskCateg */
  allHelpdeskCateg: IHelpdeskCategConnection;
  /** Get all HelpdeskFolder */
  allHelpdeskFolder: IHelpdeskFolderConnection;
  /** Get all HelpdeskPage */
  allHelpdeskPage: IHelpdeskPageConnection;
  /** Get all HomePage */
  allHomePage: IHomePageConnection;
  /** Get all JobBoardPage */
  allJobBoardPage: IJobBoardPageConnection;
  /** Get all JobHub */
  allJobHub: IJobHubConnection;
  /** Get all JobHubsFolder */
  allJobHubsFolder: IJobHubsFolderConnection;
  /** Get all JobProgress */
  allJobProgress: IJobProgressConnection;
  /** Get all JobShare */
  allJobShare: IJobShareConnection;
  /** Get all JobTraining */
  allJobTraining: IJobTrainingConnection;
  /** Get all JobTrainingFolder */
  allJobTrainingFolder: IJobTrainingFolderConnection;
  /** Get all JobVacanciesFolder */
  allJobVacanciesFolder: IJobVacanciesFolderConnection;
  /** Get all JobVacancy */
  allJobVacancy: IJobVacancyConnection;
  /** Get all LandingPage */
  allLandingPage: ILandingPageConnection;
  /** Get all LearnMenu */
  allLearnMenu: ILearnMenuConnection;
  /** Get all LegalsFolder */
  allLegalsFolder: ILegalsFolderConnection;
  /** Get all ListenCateg */
  allListenCateg: IListenCategConnection;
  /** Get all LiveEvent */
  allLiveEvent: ILiveEventConnection;
  /** Get all LiveEventsMenu */
  allLiveEventsMenu: ILiveEventsMenuConnection;
  /** Get all LiveEventsPage */
  allLiveEventsPage: ILiveEventsPageConnection;
  /** Get all LiveTVPage */
  allLiveTVPage: ILiveTvPageConnection;
  /** Get all MemberContentTypesLink */
  allMemberContentTypesLink: IMemberContentTypesLinkConnection;
  /** Get all MemberDatas */
  allMemberDatas: IMemberDatasConnection;
  /** Get all MemberDownloaded */
  allMemberDownloaded: IMemberDownloadedConnection;
  /** Get all MemberMessage */
  allMemberMessage: IMemberMessageConnection;
  /** Get all MemberNotify */
  allMemberNotify: IMemberNotifyConnection;
  /** Get all MemberOpportunity */
  allMemberOpportunity: IMemberOpportunityConnection;
  /** Get all MemberSaved */
  allMemberSaved: IMemberSavedConnection;
  /** Get all MemberSearch */
  allMemberSearch: IMemberSearchConnection;
  /** Get all MemberWatched */
  allMemberWatched: IMemberWatchedConnection;
  /** Get all MembersDatas */
  allMembersDatas: IMembersDatasConnection;
  /** Get all MiniSitesFolder */
  allMiniSitesFolder: IMiniSitesFolderConnection;
  /** Get all NavMessage */
  allNavMessage: INavMessageConnection;
  /** Get all NavigationMessagesFolder */
  allNavigationMessagesFolder: INavigationMessagesFolderConnection;
  /** Get all NetlifyDeploy */
  allNetlifyDeploy: INetlifyDeployConnection;
  /** Get all News */
  allNews: INewsConnection;
  /** Get all NewsCateg */
  allNewsCateg: INewsCategConnection;
  /** Get all NewsFolder */
  allNewsFolder: INewsFolderConnection;
  /** Get all NewsPage */
  allNewsPage: INewsPageConnection;
  /** Get all ObtainedJob */
  allObtainedJob: IObtainedJobConnection;
  /** Get all Opportunity */
  allOpportunity: IOpportunityConnection;
  /** Get all OpportunityCenter */
  allOpportunityCenter: IOpportunityCenterConnection;
  /** Get all OpportunityFolder */
  allOpportunityFolder: IOpportunityFolderConnection;
  /** Get all Partner */
  allPartner: IPartnerConnection;
  /** Get all Partners */
  allPartners: IPartnersConnection;
  /** Get all PartnersPage */
  allPartnersPage: IPartnersPageConnection;
  /** Get all Paywall */
  allPaywall: IPaywallConnection;
  /** Get all PaywallFolder */
  allPaywallFolder: IPaywallFolderConnection;
  /** Get all PersonalityPages */
  allPersonalityPages: IPersonalityPagesConnection;
  /** Get all PersonalityQuiz */
  allPersonalityQuiz: IPersonalityQuizConnection;
  /** Get all PersonalityQuiz1 */
  allPersonalityQuiz1: IPersonalityQuiz1Connection;
  /** Get all PersonalityType */
  allPersonalityType: IPersonalityTypeConnection;
  /** Get all Playlist */
  allPlaylist: IPlaylistConnection;
  /** Get all PlaylistRadioMenu */
  allPlaylistRadioMenu: IPlaylistRadioMenuConnection;
  /** Get all Podcast */
  allPodcast: IPodcastConnection;
  /** Get all PodcastCateg */
  allPodcastCateg: IPodcastCategConnection;
  /** Get all PodcastItem */
  allPodcastItem: IPodcastItemConnection;
  /** Get all PodcastMenu */
  allPodcastMenu: IPodcastMenuConnection;
  /** Get all PromoCode */
  allPromoCode: IPromoCodeConnection;
  /** Get all PromoCodeFolder */
  allPromoCodeFolder: IPromoCodeFolderConnection;
  /** Get all QuizPage */
  allQuizPage: IQuizPageConnection;
  /** Get all QuizzSurvey */
  allQuizzSurvey: IQuizzSurveyConnection;
  /** Get all QuizzSurveyCategory */
  allQuizzSurveyCategory: IQuizzSurveyCategoryConnection;
  /** Get all QuizzSurveyCollection */
  allQuizzSurveyCollection: IQuizzSurveyCollectionConnection;
  /** Get all Radio */
  allRadio: IRadioConnection;
  /** Get all RadioCateg */
  allRadioCateg: IRadioCategConnection;
  /** Get all Region */
  allRegion: IRegionConnection;
  /** Get all SectionPage */
  allSectionPage: ISectionPageConnection;
  /** Get all Settings */
  allSettings: ISettingsConnection;
  /** Get all Space */
  allSpace: ISpaceConnection;
  /** Get all Subscription */
  allSubscription: ISubscriptionConnection;
  /** Get all SubscriptionData */
  allSubscriptionData: ISubscriptionDataConnection;
  /** Get all SubscriptionDataFolder */
  allSubscriptionDataFolder: ISubscriptionDataFolderConnection;
  /** Get all SubscriptionsFolder */
  allSubscriptionsFolder: ISubscriptionsFolderConnection;
  /** Get all SumaryNugget */
  allSumaryNugget: ISumaryNuggetConnection;
  /** Get all SurveyQuizzFolder */
  allSurveyQuizzFolder: ISurveyQuizzFolderConnection;
  /** Get all TextPage */
  allTextPage: ITextPageConnection;
  /** Get all ThankYouPage */
  allThankYouPage: IThankYouPageConnection;
  /** Get all TranslationContext */
  allTranslationContext: ITranslationContextConnection;
  /** Get all TranslationFolder */
  allTranslationFolder: ITranslationFolderConnection;
  /** Get all TranslationItem */
  allTranslationItem: ITranslationItemConnection;
  /** Get all UmbracoTest */
  allUmbracoTest: IUmbracoTestConnection;
  /** Get all UnitNuggetAnswer */
  allUnitNuggetAnswer: IUnitNuggetAnswerConnection;
  /** Get all UnitNuggetGapFillAnswer */
  allUnitNuggetGapFillAnswer: IUnitNuggetGapFillAnswerConnection;
  /** Get all UnitProgression */
  allUnitProgression: IUnitProgressionConnection;
  /** Get all VODItem */
  allVODItem: IVodItemConnection;
  /** Get all VODMenu */
  allVODMenu: IVodMenuConnection;
  /** Get all VotingFolder */
  allVotingFolder: IVotingFolderConnection;
  /** Get all VotingRecord */
  allVotingRecord: IVotingRecordConnection;
  /** Get all WatchCateg */
  allWatchCateg: IWatchCategConnection;
  /** Get `ArtistService` by its unique id or url. Either id or url must be specified but not both. */
  artistService?: Maybe<IArtistService>;
  /** Get `ArtistServiceFolder` by its unique id or url. Either id or url must be specified but not both. */
  artistServiceFolder?: Maybe<IArtistServiceFolder>;
  /** Get `ArtistServicesPage` by its unique id or url. Either id or url must be specified but not both. */
  artistServicesPage?: Maybe<IArtistServicesPage>;
  /** Get `AwardCategoryPage` by its unique id or url. Either id or url must be specified but not both. */
  awardCategoryPage?: Maybe<IAwardCategoryPage>;
  /** Get `AwardsArtist` by its unique id or url. Either id or url must be specified but not both. */
  awardsArtist?: Maybe<IAwardsArtist>;
  /** Get `AwardsCategoryMenu` by its unique id or url. Either id or url must be specified but not both. */
  awardsCategoryMenu?: Maybe<IAwardsCategoryMenu>;
  /** Get `AwardsCategoryMenuDev` by its unique id or url. Either id or url must be specified but not both. */
  awardsCategoryMenuDev?: Maybe<IAwardsCategoryMenuDev>;
  /** Get `AwardsCategoryMenuFolder` by its unique id or url. Either id or url must be specified but not both. */
  awardsCategoryMenuFolder?: Maybe<IAwardsCategoryMenuFolder>;
  /** Get `AwardsCategoryMenuFolderDev` by its unique id or url. Either id or url must be specified but not both. */
  awardsCategoryMenuFolderDev?: Maybe<IAwardsCategoryMenuFolderDev>;
  /** Get `AwardsHomepage` by its unique id or url. Either id or url must be specified but not both. */
  awardsHomepage?: Maybe<IAwardsHomepage>;
  /** Get `CMSPage` by its unique id or url. Either id or url must be specified but not both. */
  cMSPage?: Maybe<ICmsPage>;
  /** Get `CategBgColor` by its unique id or url. Either id or url must be specified but not both. */
  categBgColor?: Maybe<ICategBgColor>;
  /** Get `CategoryPage` by its unique id or url. Either id or url must be specified but not both. */
  categoryPage?: Maybe<ICategoryPage>;
  /** Get `Channel` by its unique id or url. Either id or url must be specified but not both. */
  channel?: Maybe<IChannel>;
  /** Get `ChannelFolder` by its unique id or url. Either id or url must be specified but not both. */
  channelFolder?: Maybe<IChannelFolder>;
  /** Get `ChoiceNugget` by its unique id or url. Either id or url must be specified but not both. */
  choiceNugget?: Maybe<IChoiceNugget>;
  /** Get `Collection` by its unique id or url. Either id or url must be specified but not both. */
  collection?: Maybe<ICollection>;
  /** Get Content by its unique identifier or url. Either id or url must be specified but not both. */
  content?: Maybe<IContent>;
  /** Get `ContentEditorFolder` by its unique id or url. Either id or url must be specified but not both. */
  contentEditorFolder?: Maybe<IContentEditorFolder>;
  /** Get `ContentTag` by its unique id or url. Either id or url must be specified but not both. */
  contentTag?: Maybe<IContentTag>;
  /** Get `ContentTags` by its unique id or url. Either id or url must be specified but not both. */
  contentTags?: Maybe<IContentTags>;
  /** Get `ContentTagsCateg` by its unique id or url. Either id or url must be specified but not both. */
  contentTagsCateg?: Maybe<IContentTagsCateg>;
  /** Get `Course` by its unique id or url. Either id or url must be specified but not both. */
  course?: Maybe<ICourse>;
  /** Get `CourseCategoriesFolder` by its unique id or url. Either id or url must be specified but not both. */
  courseCategoriesFolder?: Maybe<ICourseCategoriesFolder>;
  /** Get `CourseCategory` by its unique id or url. Either id or url must be specified but not both. */
  courseCategory?: Maybe<ICourseCategory>;
  /** Get `CourseExam` by its unique id or url. Either id or url must be specified but not both. */
  courseExam?: Maybe<ICourseExam>;
  /** Get `CourseShare` by its unique id or url. Either id or url must be specified but not both. */
  courseShare?: Maybe<ICourseShare>;
  /** Get `CourseStatus` by its unique id or url. Either id or url must be specified but not both. */
  courseStatus?: Maybe<ICourseStatus>;
  /** Get `CourseTestProgression` by its unique id or url. Either id or url must be specified but not both. */
  courseTestProgression?: Maybe<ICourseTestProgression>;
  /** Get `CourseUnit` by its unique id or url. Either id or url must be specified but not both. */
  courseUnit?: Maybe<ICourseUnit>;
  /** Get `Discovery` by its unique id or url. Either id or url must be specified but not both. */
  discovery?: Maybe<IDiscovery>;
  /** Get `DiscoverySlide1` by its unique id or url. Either id or url must be specified but not both. */
  discoverySlide1?: Maybe<IDiscoverySlide1>;
  /** Get `EntrepreunarialHub` by its unique id or url. Either id or url must be specified but not both. */
  entrepreunarialHub?: Maybe<IEntrepreunarialHub>;
  /** Get `FormFolder` by its unique id or url. Either id or url must be specified but not both. */
  formFolder?: Maybe<IFormFolder>;
  /** Get `FormPage` by its unique id or url. Either id or url must be specified but not both. */
  formPage?: Maybe<IFormPage>;
  /** Get `GapfillNugget` by its unique id or url. Either id or url must be specified but not both. */
  gapfillNugget?: Maybe<IGapfillNugget>;
  /** Get `HelpdeskCateg` by its unique id or url. Either id or url must be specified but not both. */
  helpdeskCateg?: Maybe<IHelpdeskCateg>;
  /** Get `HelpdeskFolder` by its unique id or url. Either id or url must be specified but not both. */
  helpdeskFolder?: Maybe<IHelpdeskFolder>;
  /** Get `HelpdeskPage` by its unique id or url. Either id or url must be specified but not both. */
  helpdeskPage?: Maybe<IHelpdeskPage>;
  /** Get `HomePage` by its unique id or url. Either id or url must be specified but not both. */
  homePage?: Maybe<IHomePage>;
  /** Get `JobBoardPage` by its unique id or url. Either id or url must be specified but not both. */
  jobBoardPage?: Maybe<IJobBoardPage>;
  /** Get `JobHub` by its unique id or url. Either id or url must be specified but not both. */
  jobHub?: Maybe<IJobHub>;
  /** Get `JobHubsFolder` by its unique id or url. Either id or url must be specified but not both. */
  jobHubsFolder?: Maybe<IJobHubsFolder>;
  /** Get `JobProgress` by its unique id or url. Either id or url must be specified but not both. */
  jobProgress?: Maybe<IJobProgress>;
  /** Get `JobShare` by its unique id or url. Either id or url must be specified but not both. */
  jobShare?: Maybe<IJobShare>;
  /** Get `JobTraining` by its unique id or url. Either id or url must be specified but not both. */
  jobTraining?: Maybe<IJobTraining>;
  /** Get `JobTrainingFolder` by its unique id or url. Either id or url must be specified but not both. */
  jobTrainingFolder?: Maybe<IJobTrainingFolder>;
  /** Get `JobVacanciesFolder` by its unique id or url. Either id or url must be specified but not both. */
  jobVacanciesFolder?: Maybe<IJobVacanciesFolder>;
  /** Get `JobVacancy` by its unique id or url. Either id or url must be specified but not both. */
  jobVacancy?: Maybe<IJobVacancy>;
  /** Get `LandingPage` by its unique id or url. Either id or url must be specified but not both. */
  landingPage?: Maybe<ILandingPage>;
  /** Get `LearnMenu` by its unique id or url. Either id or url must be specified but not both. */
  learnMenu?: Maybe<ILearnMenu>;
  /** Get `LegalsFolder` by its unique id or url. Either id or url must be specified but not both. */
  legalsFolder?: Maybe<ILegalsFolder>;
  /** Get `ListenCateg` by its unique id or url. Either id or url must be specified but not both. */
  listenCateg?: Maybe<IListenCateg>;
  /** Get `LiveEvent` by its unique id or url. Either id or url must be specified but not both. */
  liveEvent?: Maybe<ILiveEvent>;
  /** Get `LiveEventsMenu` by its unique id or url. Either id or url must be specified but not both. */
  liveEventsMenu?: Maybe<ILiveEventsMenu>;
  /** Get `LiveEventsPage` by its unique id or url. Either id or url must be specified but not both. */
  liveEventsPage?: Maybe<ILiveEventsPage>;
  /** Get `LiveTVPage` by its unique id or url. Either id or url must be specified but not both. */
  liveTVPage?: Maybe<ILiveTvPage>;
  /** Get `MemberContentTypesLink` by its unique id or url. Either id or url must be specified but not both. */
  memberContentTypesLink?: Maybe<IMemberContentTypesLink>;
  /** Get `MemberDatas` by its unique id or url. Either id or url must be specified but not both. */
  memberDatas?: Maybe<IMemberDatas>;
  /** Get `MemberDownloaded` by its unique id or url. Either id or url must be specified but not both. */
  memberDownloaded?: Maybe<IMemberDownloaded>;
  /** Get `MemberMessage` by its unique id or url. Either id or url must be specified but not both. */
  memberMessage?: Maybe<IMemberMessage>;
  /** Get `MemberNotify` by its unique id or url. Either id or url must be specified but not both. */
  memberNotify?: Maybe<IMemberNotify>;
  /** Get `MemberOpportunity` by its unique id or url. Either id or url must be specified but not both. */
  memberOpportunity?: Maybe<IMemberOpportunity>;
  /** Get `MemberSaved` by its unique id or url. Either id or url must be specified but not both. */
  memberSaved?: Maybe<IMemberSaved>;
  /** Get `MemberSearch` by its unique id or url. Either id or url must be specified but not both. */
  memberSearch?: Maybe<IMemberSearch>;
  /** Get `MemberWatched` by its unique id or url. Either id or url must be specified but not both. */
  memberWatched?: Maybe<IMemberWatched>;
  /** Get `MembersDatas` by its unique id or url. Either id or url must be specified but not both. */
  membersDatas?: Maybe<IMembersDatas>;
  /** Get `MiniSitesFolder` by its unique id or url. Either id or url must be specified but not both. */
  miniSitesFolder?: Maybe<IMiniSitesFolder>;
  /** Get `NavMessage` by its unique id or url. Either id or url must be specified but not both. */
  navMessage?: Maybe<INavMessage>;
  /** Get `NavigationMessagesFolder` by its unique id or url. Either id or url must be specified but not both. */
  navigationMessagesFolder?: Maybe<INavigationMessagesFolder>;
  /** Get `NetlifyDeploy` by its unique id or url. Either id or url must be specified but not both. */
  netlifyDeploy?: Maybe<INetlifyDeploy>;
  /** Get `News` by its unique id or url. Either id or url must be specified but not both. */
  news?: Maybe<INews>;
  /** Get `NewsCateg` by its unique id or url. Either id or url must be specified but not both. */
  newsCateg?: Maybe<INewsCateg>;
  /** Get `NewsFolder` by its unique id or url. Either id or url must be specified but not both. */
  newsFolder?: Maybe<INewsFolder>;
  /** Get `NewsPage` by its unique id or url. Either id or url must be specified but not both. */
  newsPage?: Maybe<INewsPage>;
  /** Get `ObtainedJob` by its unique id or url. Either id or url must be specified but not both. */
  obtainedJob?: Maybe<IObtainedJob>;
  /** Get `Opportunity` by its unique id or url. Either id or url must be specified but not both. */
  opportunity?: Maybe<IOpportunity>;
  /** Get `OpportunityCenter` by its unique id or url. Either id or url must be specified but not both. */
  opportunityCenter?: Maybe<IOpportunityCenter>;
  /** Get `OpportunityFolder` by its unique id or url. Either id or url must be specified but not both. */
  opportunityFolder?: Maybe<IOpportunityFolder>;
  /** Get `Partner` by its unique id or url. Either id or url must be specified but not both. */
  partner?: Maybe<IPartner>;
  /** Get `Partners` by its unique id or url. Either id or url must be specified but not both. */
  partners?: Maybe<IPartners>;
  /** Get `PartnersPage` by its unique id or url. Either id or url must be specified but not both. */
  partnersPage?: Maybe<IPartnersPage>;
  /** Get `Paywall` by its unique id or url. Either id or url must be specified but not both. */
  paywall?: Maybe<IPaywall>;
  /** Get `PaywallFolder` by its unique id or url. Either id or url must be specified but not both. */
  paywallFolder?: Maybe<IPaywallFolder>;
  /** Get `PersonalityPages` by its unique id or url. Either id or url must be specified but not both. */
  personalityPages?: Maybe<IPersonalityPages>;
  /** Get `PersonalityQuiz` by its unique id or url. Either id or url must be specified but not both. */
  personalityQuiz?: Maybe<IPersonalityQuiz>;
  /** Get `PersonalityQuiz1` by its unique id or url. Either id or url must be specified but not both. */
  personalityQuiz1?: Maybe<IPersonalityQuiz1>;
  /** Get `PersonalityType` by its unique id or url. Either id or url must be specified but not both. */
  personalityType?: Maybe<IPersonalityType>;
  /** Get `Playlist` by its unique id or url. Either id or url must be specified but not both. */
  playlist?: Maybe<IPlaylist>;
  /** Get `PlaylistRadioMenu` by its unique id or url. Either id or url must be specified but not both. */
  playlistRadioMenu?: Maybe<IPlaylistRadioMenu>;
  /** Get `Podcast` by its unique id or url. Either id or url must be specified but not both. */
  podcast?: Maybe<IPodcast>;
  /** Get `PodcastCateg` by its unique id or url. Either id or url must be specified but not both. */
  podcastCateg?: Maybe<IPodcastCateg>;
  /** Get `PodcastItem` by its unique id or url. Either id or url must be specified but not both. */
  podcastItem?: Maybe<IPodcastItem>;
  /** Get `PodcastMenu` by its unique id or url. Either id or url must be specified but not both. */
  podcastMenu?: Maybe<IPodcastMenu>;
  /** Get `PromoCode` by its unique id or url. Either id or url must be specified but not both. */
  promoCode?: Maybe<IPromoCode>;
  /** Get `PromoCodeFolder` by its unique id or url. Either id or url must be specified but not both. */
  promoCodeFolder?: Maybe<IPromoCodeFolder>;
  /** Get `QuizPage` by its unique id or url. Either id or url must be specified but not both. */
  quizPage?: Maybe<IQuizPage>;
  /** Get `QuizzSurvey` by its unique id or url. Either id or url must be specified but not both. */
  quizzSurvey?: Maybe<IQuizzSurvey>;
  /** Get `QuizzSurveyCategory` by its unique id or url. Either id or url must be specified but not both. */
  quizzSurveyCategory?: Maybe<IQuizzSurveyCategory>;
  /** Get `QuizzSurveyCollection` by its unique id or url. Either id or url must be specified but not both. */
  quizzSurveyCollection?: Maybe<IQuizzSurveyCollection>;
  /** Get `Radio` by its unique id or url. Either id or url must be specified but not both. */
  radio?: Maybe<IRadio>;
  /** Get `RadioCateg` by its unique id or url. Either id or url must be specified but not both. */
  radioCateg?: Maybe<IRadioCateg>;
  /** Get `Region` by its unique id or url. Either id or url must be specified but not both. */
  region?: Maybe<IRegion>;
  /** Get `SectionPage` by its unique id or url. Either id or url must be specified but not both. */
  sectionPage?: Maybe<ISectionPage>;
  /** Get `Settings` by its unique id or url. Either id or url must be specified but not both. */
  settings?: Maybe<ISettings>;
  /** Get `Space` by its unique id or url. Either id or url must be specified but not both. */
  space?: Maybe<ISpace>;
  /** Get `Subscription` by its unique id or url. Either id or url must be specified but not both. */
  subscription?: Maybe<ISubscription>;
  /** Get `SubscriptionData` by its unique id or url. Either id or url must be specified but not both. */
  subscriptionData?: Maybe<ISubscriptionData>;
  /** Get `SubscriptionDataFolder` by its unique id or url. Either id or url must be specified but not both. */
  subscriptionDataFolder?: Maybe<ISubscriptionDataFolder>;
  /** Get `SubscriptionsFolder` by its unique id or url. Either id or url must be specified but not both. */
  subscriptionsFolder?: Maybe<ISubscriptionsFolder>;
  /** Get `SumaryNugget` by its unique id or url. Either id or url must be specified but not both. */
  sumaryNugget?: Maybe<ISumaryNugget>;
  /** Get `SurveyQuizzFolder` by its unique id or url. Either id or url must be specified but not both. */
  surveyQuizzFolder?: Maybe<ISurveyQuizzFolder>;
  /** Get `TextPage` by its unique id or url. Either id or url must be specified but not both. */
  textPage?: Maybe<ITextPage>;
  /** Get `ThankYouPage` by its unique id or url. Either id or url must be specified but not both. */
  thankYouPage?: Maybe<IThankYouPage>;
  /** Get `TranslationContext` by its unique id or url. Either id or url must be specified but not both. */
  translationContext?: Maybe<ITranslationContext>;
  /** Get `TranslationFolder` by its unique id or url. Either id or url must be specified but not both. */
  translationFolder?: Maybe<ITranslationFolder>;
  /** Get `TranslationItem` by its unique id or url. Either id or url must be specified but not both. */
  translationItem?: Maybe<ITranslationItem>;
  /** Get `UmbracoTest` by its unique id or url. Either id or url must be specified but not both. */
  umbracoTest?: Maybe<IUmbracoTest>;
  /** Get `UnitNuggetAnswer` by its unique id or url. Either id or url must be specified but not both. */
  unitNuggetAnswer?: Maybe<IUnitNuggetAnswer>;
  /** Get `UnitNuggetGapFillAnswer` by its unique id or url. Either id or url must be specified but not both. */
  unitNuggetGapFillAnswer?: Maybe<IUnitNuggetGapFillAnswer>;
  /** Get `UnitProgression` by its unique id or url. Either id or url must be specified but not both. */
  unitProgression?: Maybe<IUnitProgression>;
  /** Get `VODItem` by its unique id or url. Either id or url must be specified but not both. */
  vODItem?: Maybe<IVodItem>;
  /** Get `VODMenu` by its unique id or url. Either id or url must be specified but not both. */
  vODMenu?: Maybe<IVodMenu>;
  /** Get `VotingFolder` by its unique id or url. Either id or url must be specified but not both. */
  votingFolder?: Maybe<IVotingFolder>;
  /** Get `VotingRecord` by its unique id or url. Either id or url must be specified but not both. */
  votingRecord?: Maybe<IVotingRecord>;
  /** Get `WatchCateg` by its unique id or url. Either id or url must be specified but not both. */
  watchCateg?: Maybe<IWatchCateg>;
}


export interface IQueryAllArtistServiceArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IArtistServiceOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IArtistServiceFilterInput>;
}


export interface IQueryAllArtistServiceFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IArtistServiceFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IArtistServiceFolderFilterInput>;
}


export interface IQueryAllArtistServicesPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IArtistServicesPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IArtistServicesPageFilterInput>;
}


export interface IQueryAllAwardCategoryPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IAwardCategoryPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IAwardCategoryPageFilterInput>;
}


export interface IQueryAllAwardsArtistArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IAwardsArtistOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IAwardsArtistFilterInput>;
}


export interface IQueryAllAwardsCategoryMenuArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IAwardsCategoryMenuFilterInput>;
}


export interface IQueryAllAwardsCategoryMenuDevArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuDevOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IAwardsCategoryMenuDevFilterInput>;
}


export interface IQueryAllAwardsCategoryMenuFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IAwardsCategoryMenuFolderFilterInput>;
}


export interface IQueryAllAwardsCategoryMenuFolderDevArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IAwardsCategoryMenuFolderDevOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IAwardsCategoryMenuFolderDevFilterInput>;
}


export interface IQueryAllAwardsHomepageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IAwardsHomepageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IAwardsHomepageFilterInput>;
}


export interface IQueryAllCmsPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICmsPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICmsPageFilterInput>;
}


export interface IQueryAllCategBgColorArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICategBgColorOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICategBgColorFilterInput>;
}


export interface IQueryAllCategoryPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICategoryPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICategoryPageFilterInput>;
}


export interface IQueryAllChannelArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IChannelOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IChannelFilterInput>;
}


export interface IQueryAllChannelFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IChannelFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IChannelFolderFilterInput>;
}


export interface IQueryAllChoiceNuggetArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IChoiceNuggetOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IChoiceNuggetFilterInput>;
}


export interface IQueryAllCollectionArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICollectionOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICollectionFilterInput>;
}


export interface IQueryAllContentArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQueryAllContentEditorFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentEditorFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IContentEditorFolderFilterInput>;
}


export interface IQueryAllContentTagArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentTagOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IContentTagFilterInput>;
}


export interface IQueryAllContentTagsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentTagsOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IContentTagsFilterInput>;
}


export interface IQueryAllContentTagsCategArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentTagsCategOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IContentTagsCategFilterInput>;
}


export interface IQueryAllCourseArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICourseOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICourseFilterInput>;
}


export interface IQueryAllCourseCategoriesFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICourseCategoriesFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICourseCategoriesFolderFilterInput>;
}


export interface IQueryAllCourseCategoryArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICourseCategoryOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICourseCategoryFilterInput>;
}


export interface IQueryAllCourseExamArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICourseExamOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICourseExamFilterInput>;
}


export interface IQueryAllCourseShareArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICourseShareOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICourseShareFilterInput>;
}


export interface IQueryAllCourseStatusArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICourseStatusOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICourseStatusFilterInput>;
}


export interface IQueryAllCourseTestProgressionArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICourseTestProgressionOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICourseTestProgressionFilterInput>;
}


export interface IQueryAllCourseUnitArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ICourseUnitOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ICourseUnitFilterInput>;
}


export interface IQueryAllDiscoveryArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IDiscoveryOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IDiscoveryFilterInput>;
}


export interface IQueryAllDiscoverySlide1Args {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IDiscoverySlide1OrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IDiscoverySlide1FilterInput>;
}


export interface IQueryAllEntrepreunarialHubArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IEntrepreunarialHubOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IEntrepreunarialHubFilterInput>;
}


export interface IQueryAllFormFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IFormFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IFormFolderFilterInput>;
}


export interface IQueryAllFormPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IFormPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IFormPageFilterInput>;
}


export interface IQueryAllGapfillNuggetArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IGapfillNuggetOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IGapfillNuggetFilterInput>;
}


export interface IQueryAllHelpdeskCategArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IHelpdeskCategOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IHelpdeskCategFilterInput>;
}


export interface IQueryAllHelpdeskFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IHelpdeskFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IHelpdeskFolderFilterInput>;
}


export interface IQueryAllHelpdeskPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IHelpdeskPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IHelpdeskPageFilterInput>;
}


export interface IQueryAllHomePageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IHomePageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IHomePageFilterInput>;
}


export interface IQueryAllJobBoardPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobBoardPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobBoardPageFilterInput>;
}


export interface IQueryAllJobHubArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobHubOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobHubFilterInput>;
}


export interface IQueryAllJobHubsFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobHubsFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobHubsFolderFilterInput>;
}


export interface IQueryAllJobProgressArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobProgressOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobProgressFilterInput>;
}


export interface IQueryAllJobShareArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobShareOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobShareFilterInput>;
}


export interface IQueryAllJobTrainingArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobTrainingOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobTrainingFilterInput>;
}


export interface IQueryAllJobTrainingFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobTrainingFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobTrainingFolderFilterInput>;
}


export interface IQueryAllJobVacanciesFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobVacanciesFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobVacanciesFolderFilterInput>;
}


export interface IQueryAllJobVacancyArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobVacancyOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IJobVacancyFilterInput>;
}


export interface IQueryAllLandingPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ILandingPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ILandingPageFilterInput>;
}


export interface IQueryAllLearnMenuArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ILearnMenuOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ILearnMenuFilterInput>;
}


export interface IQueryAllLegalsFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ILegalsFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ILegalsFolderFilterInput>;
}


export interface IQueryAllListenCategArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IListenCategOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IListenCategFilterInput>;
}


export interface IQueryAllLiveEventArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ILiveEventOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ILiveEventFilterInput>;
}


export interface IQueryAllLiveEventsMenuArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ILiveEventsMenuOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ILiveEventsMenuFilterInput>;
}


export interface IQueryAllLiveEventsPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ILiveEventsPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ILiveEventsPageFilterInput>;
}


export interface IQueryAllLiveTvPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ILiveTvPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ILiveTvPageFilterInput>;
}


export interface IQueryAllMemberContentTypesLinkArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberContentTypesLinkOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberContentTypesLinkFilterInput>;
}


export interface IQueryAllMemberDatasArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberDatasOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberDatasFilterInput>;
}


export interface IQueryAllMemberDownloadedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberDownloadedOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberDownloadedFilterInput>;
}


export interface IQueryAllMemberMessageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberMessageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberMessageFilterInput>;
}


export interface IQueryAllMemberNotifyArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberNotifyOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberNotifyFilterInput>;
}


export interface IQueryAllMemberOpportunityArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberOpportunityOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberOpportunityFilterInput>;
}


export interface IQueryAllMemberSavedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberSavedOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberSavedFilterInput>;
}


export interface IQueryAllMemberSearchArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberSearchOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberSearchFilterInput>;
}


export interface IQueryAllMemberWatchedArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMemberWatchedOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMemberWatchedFilterInput>;
}


export interface IQueryAllMembersDatasArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMembersDatasOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMembersDatasFilterInput>;
}


export interface IQueryAllMiniSitesFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IMiniSitesFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IMiniSitesFolderFilterInput>;
}


export interface IQueryAllNavMessageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<INavMessageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<INavMessageFilterInput>;
}


export interface IQueryAllNavigationMessagesFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<INavigationMessagesFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<INavigationMessagesFolderFilterInput>;
}


export interface IQueryAllNetlifyDeployArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<INetlifyDeployOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<INetlifyDeployFilterInput>;
}


export interface IQueryAllNewsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<INewsOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<INewsFilterInput>;
}


export interface IQueryAllNewsCategArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<INewsCategOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<INewsCategFilterInput>;
}


export interface IQueryAllNewsFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<INewsFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<INewsFolderFilterInput>;
}


export interface IQueryAllNewsPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<INewsPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<INewsPageFilterInput>;
}


export interface IQueryAllObtainedJobArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IObtainedJobOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IObtainedJobFilterInput>;
}


export interface IQueryAllOpportunityArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IOpportunityOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IOpportunityFilterInput>;
}


export interface IQueryAllOpportunityCenterArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IOpportunityCenterOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IOpportunityCenterFilterInput>;
}


export interface IQueryAllOpportunityFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IOpportunityFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IOpportunityFolderFilterInput>;
}


export interface IQueryAllPartnerArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPartnerOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPartnerFilterInput>;
}


export interface IQueryAllPartnersArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPartnersOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPartnersFilterInput>;
}


export interface IQueryAllPartnersPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPartnersPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPartnersPageFilterInput>;
}


export interface IQueryAllPaywallArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPaywallOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPaywallFilterInput>;
}


export interface IQueryAllPaywallFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPaywallFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPaywallFolderFilterInput>;
}


export interface IQueryAllPersonalityPagesArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPersonalityPagesOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPersonalityPagesFilterInput>;
}


export interface IQueryAllPersonalityQuizArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPersonalityQuizOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPersonalityQuizFilterInput>;
}


export interface IQueryAllPersonalityQuiz1Args {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPersonalityQuiz1OrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPersonalityQuiz1FilterInput>;
}


export interface IQueryAllPersonalityTypeArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPersonalityTypeOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPersonalityTypeFilterInput>;
}


export interface IQueryAllPlaylistArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPlaylistOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPlaylistFilterInput>;
}


export interface IQueryAllPlaylistRadioMenuArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPlaylistRadioMenuOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPlaylistRadioMenuFilterInput>;
}


export interface IQueryAllPodcastArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPodcastOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPodcastFilterInput>;
}


export interface IQueryAllPodcastCategArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPodcastCategOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPodcastCategFilterInput>;
}


export interface IQueryAllPodcastItemArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPodcastItemOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPodcastItemFilterInput>;
}


export interface IQueryAllPodcastMenuArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPodcastMenuOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPodcastMenuFilterInput>;
}


export interface IQueryAllPromoCodeArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPromoCodeOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPromoCodeFilterInput>;
}


export interface IQueryAllPromoCodeFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IPromoCodeFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IPromoCodeFolderFilterInput>;
}


export interface IQueryAllQuizPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IQuizPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IQuizPageFilterInput>;
}


export interface IQueryAllQuizzSurveyArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IQuizzSurveyOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IQuizzSurveyFilterInput>;
}


export interface IQueryAllQuizzSurveyCategoryArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IQuizzSurveyCategoryOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IQuizzSurveyCategoryFilterInput>;
}


export interface IQueryAllQuizzSurveyCollectionArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IQuizzSurveyCollectionOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IQuizzSurveyCollectionFilterInput>;
}


export interface IQueryAllRadioArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IRadioOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IRadioFilterInput>;
}


export interface IQueryAllRadioCategArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IRadioCategOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IRadioCategFilterInput>;
}


export interface IQueryAllRegionArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IRegionOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IRegionFilterInput>;
}


export interface IQueryAllSectionPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISectionPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISectionPageFilterInput>;
}


export interface IQueryAllSettingsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISettingsOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISettingsFilterInput>;
}


export interface IQueryAllSpaceArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISpaceOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISpaceFilterInput>;
}


export interface IQueryAllSubscriptionArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISubscriptionOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISubscriptionFilterInput>;
}


export interface IQueryAllSubscriptionDataArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISubscriptionDataOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISubscriptionDataFilterInput>;
}


export interface IQueryAllSubscriptionDataFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISubscriptionDataFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISubscriptionDataFolderFilterInput>;
}


export interface IQueryAllSubscriptionsFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISubscriptionsFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISubscriptionsFolderFilterInput>;
}


export interface IQueryAllSumaryNuggetArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISumaryNuggetOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISumaryNuggetFilterInput>;
}


export interface IQueryAllSurveyQuizzFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ISurveyQuizzFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ISurveyQuizzFolderFilterInput>;
}


export interface IQueryAllTextPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ITextPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ITextPageFilterInput>;
}


export interface IQueryAllThankYouPageArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IThankYouPageOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IThankYouPageFilterInput>;
}


export interface IQueryAllTranslationContextArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ITranslationContextOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ITranslationContextFilterInput>;
}


export interface IQueryAllTranslationFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ITranslationFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ITranslationFolderFilterInput>;
}


export interface IQueryAllTranslationItemArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<ITranslationItemOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ITranslationItemFilterInput>;
}


export interface IQueryAllUmbracoTestArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IUmbracoTestOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IUmbracoTestFilterInput>;
}


export interface IQueryAllUnitNuggetAnswerArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IUnitNuggetAnswerOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IUnitNuggetAnswerFilterInput>;
}


export interface IQueryAllUnitNuggetGapFillAnswerArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IUnitNuggetGapFillAnswerOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IUnitNuggetGapFillAnswerFilterInput>;
}


export interface IQueryAllUnitProgressionArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IUnitProgressionOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IUnitProgressionFilterInput>;
}


export interface IQueryAllVodItemArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IVodItemOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IVodItemFilterInput>;
}


export interface IQueryAllVodMenuArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IVodMenuOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IVodMenuFilterInput>;
}


export interface IQueryAllVotingFolderArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IVotingFolderOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IVotingFolderFilterInput>;
}


export interface IQueryAllVotingRecordArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IVotingRecordOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IVotingRecordFilterInput>;
}


export interface IQueryAllWatchCategArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IWatchCategOrderByInput>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<IWatchCategFilterInput>;
}


export interface IQueryArtistServiceArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryArtistServiceFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryArtistServicesPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryAwardCategoryPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryAwardsArtistArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryAwardsCategoryMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryAwardsCategoryMenuDevArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryAwardsCategoryMenuFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryAwardsCategoryMenuFolderDevArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryAwardsHomepageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCMsPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCategBgColorArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCategoryPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryChannelArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryChannelFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryChoiceNuggetArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCollectionArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryContentArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryContentEditorFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryContentTagArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryContentTagsArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryContentTagsCategArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCourseArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCourseCategoriesFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCourseCategoryArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCourseExamArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCourseShareArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCourseStatusArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCourseTestProgressionArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryCourseUnitArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryDiscoveryArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryDiscoverySlide1Args {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryEntrepreunarialHubArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryFormFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryFormPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryGapfillNuggetArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryHelpdeskCategArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryHelpdeskFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryHelpdeskPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryHomePageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobBoardPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobHubArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobHubsFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobProgressArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobShareArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobTrainingArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobTrainingFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobVacanciesFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryJobVacancyArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryLandingPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryLearnMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryLegalsFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryListenCategArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryLiveEventArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryLiveEventsMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryLiveEventsPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryLiveTvPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberContentTypesLinkArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberDatasArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberDownloadedArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberMessageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberNotifyArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberOpportunityArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberSavedArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberSearchArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMemberWatchedArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMembersDatasArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryMiniSitesFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryNavMessageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryNavigationMessagesFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryNetlifyDeployArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryNewsArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryNewsCategArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryNewsFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryNewsPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryObtainedJobArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryOpportunityArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryOpportunityCenterArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryOpportunityFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPartnerArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPartnersArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPartnersPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPaywallArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPaywallFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPersonalityPagesArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPersonalityQuizArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPersonalityQuiz1Args {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPersonalityTypeArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPlaylistArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPlaylistRadioMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPodcastArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPodcastCategArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPodcastItemArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPodcastMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPromoCodeArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryPromoCodeFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryQuizPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryQuizzSurveyArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryQuizzSurveyCategoryArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryQuizzSurveyCollectionArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryRadioArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryRadioCategArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryRegionArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySectionPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySettingsArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySpaceArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySubscriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySubscriptionDataArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySubscriptionDataFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySubscriptionsFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySumaryNuggetArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQuerySurveyQuizzFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryTextPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryThankYouPageArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryTranslationContextArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryTranslationFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryTranslationItemArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryUmbracoTestArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryUnitNuggetAnswerArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryUnitNuggetGapFillAnswerArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryUnitProgressionArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryVOdItemArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryVOdMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryVotingFolderArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryVotingRecordArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}


export interface IQueryWatchCategArgs {
  culture?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
}

/** Pick your own Course content from multiple categories to create a custom slider */
export interface IQuizItemsSlider extends IElement, ISliderThumbnailSettings {
  __typename?: 'QuizItemsSlider';
  contentItems?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
  template?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** Pick your own Course content from multiple categories to create a custom slider */
export interface IQuizItemsSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** for personality quizz / results etc. */
export interface IQuizPage extends IContent, ICoverVideoCmp, IElement {
  __typename?: 'QuizPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  ctaLabel?: Maybe<Scalars['String']>;
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  methodBody?: Maybe<Array<Maybe<IBlockListItem>>>;
  methodCover?: Maybe<Array<Maybe<IBlockListItem>>>;
  methodHighlightedCourses?: Maybe<IContent>;
  methodIntro?: Maybe<Scalars['String']>;
  methodTitle?: Maybe<Scalars['String']>;
  methodologyPush?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  personalitiesCTALabel?: Maybe<Scalars['String']>;
  personalitiesCover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** will link to personality index page */
  personalitiesPush?: Maybe<Array<Maybe<IBlockListItem>>>;
  personalitiesSubtitle?: Maybe<Scalars['String']>;
  personalitiesTitle?: Maybe<Scalars['String']>;
  quizz?: Maybe<Array<Maybe<IContent>>>;
  resultSubtitle?: Maybe<Scalars['String']>;
  resultTitle?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** for personality quizz / results etc. */
export interface IQuizPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** for personality quizz / results etc. */
export interface IQuizPageCtaLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** for personality quizz / results etc. */
export interface IQuizPageMethodBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageMethodIntroArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageMethodTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageMethodologyPushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPagePersonalitiesCtaLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPagePersonalitiesCoverArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPagePersonalitiesPushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPagePersonalitiesSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPagePersonalitiesTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageResultSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageResultTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for personality quizz / results etc. */
export interface IQuizPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `QuizPage`. */
export interface IQuizPageConnection {
  __typename?: 'QuizPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IQuizPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IQuizPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `QuizPage`. */
export interface IQuizPageEdge {
  __typename?: 'QuizPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IQuizPage>;
}

/** A filter input for the type `QuizPage`. */
export interface IQuizPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IQuizPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IQuizPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IQuizPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  ctaLabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  ctaLabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  ctaLabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  ctaLabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  ctaLabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  methodHighlightedCourses?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  methodIntro?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  methodIntro_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  methodIntro_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  methodIntro_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  methodIntro_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  methodTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  methodTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  methodTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  methodTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  methodTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  personalitiesCTALabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  personalitiesCTALabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  personalitiesCTALabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  personalitiesCTALabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  personalitiesCTALabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  personalitiesSubtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  personalitiesSubtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  personalitiesSubtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  personalitiesSubtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  personalitiesSubtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  personalitiesTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  personalitiesTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  personalitiesTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  personalitiesTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  personalitiesTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  quizz_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  quizz_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  resultSubtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  resultSubtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  resultSubtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  resultSubtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  resultSubtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  resultTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  resultTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  resultTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  resultTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  resultTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `QuizPage`. */
export enum IQuizPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `ctaLabel` in ascending order. */
  CtaLabelAsc = 'ctaLabel_ASC',
  /** Order by `ctaLabel` in descending order. */
  CtaLabelDesc = 'ctaLabel_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `methodHighlightedCourses` in ascending order. */
  MethodHighlightedCoursesAsc = 'methodHighlightedCourses_ASC',
  /** Order by `methodHighlightedCourses` in descending order. */
  MethodHighlightedCoursesDesc = 'methodHighlightedCourses_DESC',
  /** Order by `methodIntro` in ascending order. */
  MethodIntroAsc = 'methodIntro_ASC',
  /** Order by `methodIntro` in descending order. */
  MethodIntroDesc = 'methodIntro_DESC',
  /** Order by `methodTitle` in ascending order. */
  MethodTitleAsc = 'methodTitle_ASC',
  /** Order by `methodTitle` in descending order. */
  MethodTitleDesc = 'methodTitle_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `personalitiesCTALabel` in ascending order. */
  PersonalitiesCtaLabelAsc = 'personalitiesCTALabel_ASC',
  /** Order by `personalitiesCTALabel` in descending order. */
  PersonalitiesCtaLabelDesc = 'personalitiesCTALabel_DESC',
  /** Order by `personalitiesSubtitle` in ascending order. */
  PersonalitiesSubtitleAsc = 'personalitiesSubtitle_ASC',
  /** Order by `personalitiesSubtitle` in descending order. */
  PersonalitiesSubtitleDesc = 'personalitiesSubtitle_DESC',
  /** Order by `personalitiesTitle` in ascending order. */
  PersonalitiesTitleAsc = 'personalitiesTitle_ASC',
  /** Order by `personalitiesTitle` in descending order. */
  PersonalitiesTitleDesc = 'personalitiesTitle_DESC',
  /** Order by `resultSubtitle` in ascending order. */
  ResultSubtitleAsc = 'resultSubtitle_ASC',
  /** Order by `resultSubtitle` in descending order. */
  ResultSubtitleDesc = 'resultSubtitle_DESC',
  /** Order by `resultTitle` in ascending order. */
  ResultTitleAsc = 'resultTitle_ASC',
  /** Order by `resultTitle` in descending order. */
  ResultTitleDesc = 'resultTitle_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IQuizzSurvey extends IContent, IElement {
  __typename?: 'QuizzSurvey';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** CTA label to launch the quizz */
  ctaLabel?: Maybe<Scalars['String']>;
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** Live event ID or Vimeo Video ID */
  liveEventID?: Maybe<Scalars['Int']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  questions?: Maybe<Array<Maybe<IContent>>>;
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Other video source */
  sourceUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  /** Do not edit ! */
  vimeoHlsUrl?: Maybe<Scalars['String']>;
}


export interface IQuizzSurveyAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyLiveEventIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyQuestionsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IQuizzSurveyCategory extends IContent, IElement {
  __typename?: 'QuizzSurveyCategory';
  /** The ancestors. */
  ancestors: IContentConnection;
  backgroundColor?: Maybe<Scalars['String']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  isExpand?: Maybe<Scalars['Boolean']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IQuizzSurveyCategoryAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyCategoryChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyCategoryDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyCategoryNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCategoryParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCategoryUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCategoryUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `QuizzSurveyCategory`. */
export interface IQuizzSurveyCategoryConnection {
  __typename?: 'QuizzSurveyCategoryConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IQuizzSurveyCategoryEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IQuizzSurveyCategory>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `QuizzSurveyCategory`. */
export interface IQuizzSurveyCategoryEdge {
  __typename?: 'QuizzSurveyCategoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IQuizzSurveyCategory>;
}

/** A filter input for the type `QuizzSurveyCategory`. */
export interface IQuizzSurveyCategoryFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IQuizzSurveyCategoryFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IQuizzSurveyCategoryFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IQuizzSurveyCategoryFilterInput>>>;
  /** Field must equal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  backgroundColor_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  backgroundColor_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  backgroundColor_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  isExpand?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `QuizzSurveyCategory`. */
export enum IQuizzSurveyCategoryOrderByInput {
  /** Order by `backgroundColor` in ascending order. */
  BackgroundColorAsc = 'backgroundColor_ASC',
  /** Order by `backgroundColor` in descending order. */
  BackgroundColorDesc = 'backgroundColor_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `isExpand` in ascending order. */
  IsExpandAsc = 'isExpand_ASC',
  /** Order by `isExpand` in descending order. */
  IsExpandDesc = 'isExpand_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IQuizzSurveyCollection extends IContent, ICoverThumbnailCmp, ICoverVideoCmp, IElement {
  __typename?: 'QuizzSurveyCollection';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** Label use for the child items player */
  playerCTALabel?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<IContent>>>;
  /** Label used for starting the quizz */
  quizzCTALabel?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyCollectionChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyCollectionDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IQuizzSurveyCollectionNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionPlayerCtaLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionQuestionsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionQuizzCtaLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IQuizzSurveyCollectionUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `QuizzSurveyCollection`. */
export interface IQuizzSurveyCollectionConnection {
  __typename?: 'QuizzSurveyCollectionConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IQuizzSurveyCollectionEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IQuizzSurveyCollection>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `QuizzSurveyCollection`. */
export interface IQuizzSurveyCollectionEdge {
  __typename?: 'QuizzSurveyCollectionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IQuizzSurveyCollection>;
}

/** A filter input for the type `QuizzSurveyCollection`. */
export interface IQuizzSurveyCollectionFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IQuizzSurveyCollectionFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IQuizzSurveyCollectionFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IQuizzSurveyCollectionFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  playerCTALabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  playerCTALabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  playerCTALabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  playerCTALabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  playerCTALabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  questions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  questions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  quizzCTALabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  quizzCTALabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  quizzCTALabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  quizzCTALabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  quizzCTALabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `QuizzSurveyCollection`. */
export enum IQuizzSurveyCollectionOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `playerCTALabel` in ascending order. */
  PlayerCtaLabelAsc = 'playerCTALabel_ASC',
  /** Order by `playerCTALabel` in descending order. */
  PlayerCtaLabelDesc = 'playerCTALabel_DESC',
  /** Order by `quizzCTALabel` in ascending order. */
  QuizzCtaLabelAsc = 'quizzCTALabel_ASC',
  /** Order by `quizzCTALabel` in descending order. */
  QuizzCtaLabelDesc = 'quizzCTALabel_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A connection from an object to a list of objects of type `QuizzSurvey`. */
export interface IQuizzSurveyConnection {
  __typename?: 'QuizzSurveyConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IQuizzSurveyEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IQuizzSurvey>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `QuizzSurvey`. */
export interface IQuizzSurveyEdge {
  __typename?: 'QuizzSurveyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IQuizzSurvey>;
}

/** A filter input for the type `QuizzSurvey`. */
export interface IQuizzSurveyFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IQuizzSurveyFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IQuizzSurveyFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IQuizzSurveyFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  ctaLabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  ctaLabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  ctaLabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  ctaLabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  ctaLabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  liveEventID?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  liveEventID_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  liveEventID_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  liveEventID_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  liveEventID_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  liveEventID_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  questions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  questions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  sourceUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  sourceUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  vimeoHlsUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  vimeoHlsUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  vimeoHlsUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  vimeoHlsUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  vimeoHlsUrl_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `QuizzSurvey`. */
export enum IQuizzSurveyOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `ctaLabel` in ascending order. */
  CtaLabelAsc = 'ctaLabel_ASC',
  /** Order by `ctaLabel` in descending order. */
  CtaLabelDesc = 'ctaLabel_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `liveEventID` in ascending order. */
  LiveEventIdAsc = 'liveEventID_ASC',
  /** Order by `liveEventID` in descending order. */
  LiveEventIdDesc = 'liveEventID_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `sourceUrl` in ascending order. */
  SourceUrlAsc = 'sourceUrl_ASC',
  /** Order by `sourceUrl` in descending order. */
  SourceUrlDesc = 'sourceUrl_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `vimeoHlsUrl` in ascending order. */
  VimeoHlsUrlAsc = 'vimeoHlsUrl_ASC',
  /** Order by `vimeoHlsUrl` in descending order. */
  VimeoHlsUrlDesc = 'vimeoHlsUrl_DESC'
}

export interface IRadio extends IContent, IContentItems, IDescriptionBlockCmp, IElement, IMetasAuthorCmp, ITop10Cmp {
  __typename?: 'Radio';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** You can add all sort of featured people (including hosts, guests, technical crew, etc.) */
  author?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  descriptionTitle?: Maybe<Scalars['String']>;
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** URL to the EPG file */
  epg?: Maybe<Scalars['String']>;
  exclusives?: Maybe<Scalars['Boolean']>;
  /** URL to the HLS file */
  hls?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  imageFormat?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<IContent>>>;
  /** The level. */
  level: Scalars['Int'];
  linkedJobs?: Maybe<Scalars['String']>;
  mogadorProductKey?: Maybe<Scalars['String']>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  personality?: Maybe<Array<Maybe<Scalars['String']>>>;
  pubDate?: Maybe<Scalars['DateTime']>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
  subtitle?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  top10?: Maybe<Array<Maybe<IBlockListItem>>>;
  top10Title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IRadioAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRadioChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRadioDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRadioDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioDescriptionTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioTop10Args {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioTop10TitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IRadioCateg extends IContent, IElement {
  __typename?: 'RadioCateg';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  isExpand?: Maybe<Scalars['Boolean']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IRadioCategAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRadioCategChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRadioCategDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRadioCategNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioCategParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioCategUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRadioCategUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `RadioCateg`. */
export interface IRadioCategConnection {
  __typename?: 'RadioCategConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IRadioCategEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IRadioCateg>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `RadioCateg`. */
export interface IRadioCategEdge {
  __typename?: 'RadioCategEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IRadioCateg>;
}

/** A filter input for the type `RadioCateg`. */
export interface IRadioCategFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IRadioCategFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IRadioCategFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IRadioCategFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  isExpand?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `RadioCateg`. */
export enum IRadioCategOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `isExpand` in ascending order. */
  IsExpandAsc = 'isExpand_ASC',
  /** Order by `isExpand` in descending order. */
  IsExpandDesc = 'isExpand_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** A connection from an object to a list of objects of type `Radio`. */
export interface IRadioConnection {
  __typename?: 'RadioConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IRadioEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IRadio>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Radio`. */
export interface IRadioEdge {
  __typename?: 'RadioEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IRadio>;
}

/** A filter input for the type `Radio`. */
export interface IRadioFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IRadioFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IRadioFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IRadioFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  descriptionTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  descriptionTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  descriptionTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  descriptionTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  descriptionTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  epg?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  epg_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  epg_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  epg_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  epg_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  exclusives?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  hls?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  hls_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  hls_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  hls_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  hls_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  imageFormat?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  imageFormat_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  imageFormat_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  imageFormat_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  imageFormat_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  linkedJobs?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  linkedJobs_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  linkedJobs_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  linkedJobs_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  linkedJobs_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  mogadorProductKey?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  mogadorProductKey_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  mogadorProductKey_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  mogadorProductKey_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  mogadorProductKey_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  musicGenre_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  musicGenre_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  personality_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  personality_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  pubDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  pubDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  pubDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  pubDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  pubDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must match all of the values. */
  regions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  regions_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  top10Title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  top10Title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  top10Title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  top10Title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  top10Title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Radio`. */
export enum IRadioOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `descriptionTitle` in ascending order. */
  DescriptionTitleAsc = 'descriptionTitle_ASC',
  /** Order by `descriptionTitle` in descending order. */
  DescriptionTitleDesc = 'descriptionTitle_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `epg` in ascending order. */
  EpgAsc = 'epg_ASC',
  /** Order by `epg` in descending order. */
  EpgDesc = 'epg_DESC',
  /** Order by `exclusives` in ascending order. */
  ExclusivesAsc = 'exclusives_ASC',
  /** Order by `exclusives` in descending order. */
  ExclusivesDesc = 'exclusives_DESC',
  /** Order by `hls` in ascending order. */
  HlsAsc = 'hls_ASC',
  /** Order by `hls` in descending order. */
  HlsDesc = 'hls_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `imageFormat` in ascending order. */
  ImageFormatAsc = 'imageFormat_ASC',
  /** Order by `imageFormat` in descending order. */
  ImageFormatDesc = 'imageFormat_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `linkedJobs` in ascending order. */
  LinkedJobsAsc = 'linkedJobs_ASC',
  /** Order by `linkedJobs` in descending order. */
  LinkedJobsDesc = 'linkedJobs_DESC',
  /** Order by `mogadorProductKey` in ascending order. */
  MogadorProductKeyAsc = 'mogadorProductKey_ASC',
  /** Order by `mogadorProductKey` in descending order. */
  MogadorProductKeyDesc = 'mogadorProductKey_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `pubDate` in ascending order. */
  PubDateAsc = 'pubDate_ASC',
  /** Order by `pubDate` in descending order. */
  PubDateDesc = 'pubDate_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `top10Title` in ascending order. */
  Top10TitleAsc = 'top10Title_ASC',
  /** Order by `top10Title` in descending order. */
  Top10TitleDesc = 'top10Title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IRegion extends IContent, IElement {
  __typename?: 'Region';
  accountPush?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select the countries contained in this Region */
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** Define the default Language for this Region */
  defaultLanguage?: Maybe<Scalars['String']>;
  /** Define the default Paywall for Premium only content. This Paywall can then be override at the content level */
  defaultPaywall?: Maybe<IContent>;
  /** The descendants. */
  descendants: IContentConnection;
  discovery?: Maybe<IContent>;
  /** Select the Homepage for the region */
  homepage?: Maybe<IContent>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** Select the Learn Homepage for the region */
  learnHomepage?: Maybe<IContent>;
  /** The level. */
  level: Scalars['Int'];
  /** Select the Listen Homepage for the region */
  listenHomepage?: Maybe<IContent>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** Define the Push block inside the burger menu */
  push?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** Blocks displayed on Search Page to Highlight content */
  searchPageBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** Top blocks on Search Page */
  searchTopBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Define the bottom part of the Burger Menu */
  subMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** Define the upper part of the burger menu */
  topMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  /** Select the Watch Homepage for the region */
  watchHomepage?: Maybe<IContent>;
  webArtistHome?: Maybe<IContent>;
  webBottomMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  webHomepage?: Maybe<IContent>;
  webLearnHome?: Maybe<IContent>;
  webListenHome?: Maybe<IContent>;
  webPush?: Maybe<Array<Maybe<IBlockListItem>>>;
  webTopMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  webWatchHome?: Maybe<IContent>;
}


export interface IRegionAccountPushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRegionChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRegionDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IRegionNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionPushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionSearchPageBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionSearchTopBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionSubMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionTopMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionWebBottomMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionWebPushArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IRegionWebTopMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Region`. */
export interface IRegionConnection {
  __typename?: 'RegionConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IRegionEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IRegion>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Region`. */
export interface IRegionEdge {
  __typename?: 'RegionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IRegion>;
}

/** A filter input for the type `Region`. */
export interface IRegionFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IRegionFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IRegionFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IRegionFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countries_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countries_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  defaultLanguage?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  defaultLanguage_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  defaultLanguage_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  defaultLanguage_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  defaultLanguage_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  defaultPaywall?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  discovery?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  homepage?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  learnHomepage?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  listenHomepage?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  watchHomepage?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  webArtistHome?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  webHomepage?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  webLearnHome?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  webListenHome?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  webWatchHome?: InputMaybe<IContentFilterInput>;
}

/** An order input for the type `Region`. */
export enum IRegionOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `defaultLanguage` in ascending order. */
  DefaultLanguageAsc = 'defaultLanguage_ASC',
  /** Order by `defaultLanguage` in descending order. */
  DefaultLanguageDesc = 'defaultLanguage_DESC',
  /** Order by `defaultPaywall` in ascending order. */
  DefaultPaywallAsc = 'defaultPaywall_ASC',
  /** Order by `defaultPaywall` in descending order. */
  DefaultPaywallDesc = 'defaultPaywall_DESC',
  /** Order by `discovery` in ascending order. */
  DiscoveryAsc = 'discovery_ASC',
  /** Order by `discovery` in descending order. */
  DiscoveryDesc = 'discovery_DESC',
  /** Order by `homepage` in ascending order. */
  HomepageAsc = 'homepage_ASC',
  /** Order by `homepage` in descending order. */
  HomepageDesc = 'homepage_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `learnHomepage` in ascending order. */
  LearnHomepageAsc = 'learnHomepage_ASC',
  /** Order by `learnHomepage` in descending order. */
  LearnHomepageDesc = 'learnHomepage_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `listenHomepage` in ascending order. */
  ListenHomepageAsc = 'listenHomepage_ASC',
  /** Order by `listenHomepage` in descending order. */
  ListenHomepageDesc = 'listenHomepage_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `watchHomepage` in ascending order. */
  WatchHomepageAsc = 'watchHomepage_ASC',
  /** Order by `watchHomepage` in descending order. */
  WatchHomepageDesc = 'watchHomepage_DESC',
  /** Order by `webArtistHome` in ascending order. */
  WebArtistHomeAsc = 'webArtistHome_ASC',
  /** Order by `webArtistHome` in descending order. */
  WebArtistHomeDesc = 'webArtistHome_DESC',
  /** Order by `webHomepage` in ascending order. */
  WebHomepageAsc = 'webHomepage_ASC',
  /** Order by `webHomepage` in descending order. */
  WebHomepageDesc = 'webHomepage_DESC',
  /** Order by `webLearnHome` in ascending order. */
  WebLearnHomeAsc = 'webLearnHome_ASC',
  /** Order by `webLearnHome` in descending order. */
  WebLearnHomeDesc = 'webLearnHome_DESC',
  /** Order by `webListenHome` in ascending order. */
  WebListenHomeAsc = 'webListenHome_ASC',
  /** Order by `webListenHome` in descending order. */
  WebListenHomeDesc = 'webListenHome_DESC',
  /** Order by `webWatchHome` in ascending order. */
  WebWatchHomeAsc = 'webWatchHome_ASC',
  /** Order by `webWatchHome` in descending order. */
  WebWatchHomeDesc = 'webWatchHome_DESC'
}

export interface ISectionPage extends IContent, IElement, IHeroSliderCmp, IPage, ITopMenuComp {
  __typename?: 'SectionPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  autoloop?: Maybe<Scalars['Boolean']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  heroSlider?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** (milli seconds) */
  loopDelay?: Maybe<Scalars['Int']>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  pageBlocks?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  topMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ISectionPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISectionPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISectionPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISectionPageHeroSliderArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISectionPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISectionPagePageBlocksArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISectionPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISectionPageTopMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISectionPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISectionPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `SectionPage`. */
export interface ISectionPageConnection {
  __typename?: 'SectionPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISectionPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISectionPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `SectionPage`. */
export interface ISectionPageEdge {
  __typename?: 'SectionPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISectionPage>;
}

/** A filter input for the type `SectionPage`. */
export interface ISectionPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISectionPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISectionPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISectionPageFilterInput>>>;
  /** Field must equal value. */
  autoloop?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  loopDelay?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  loopDelay_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  loopDelay_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  loopDelay_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  loopDelay_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  loopDelay_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `SectionPage`. */
export enum ISectionPageOrderByInput {
  /** Order by `autoloop` in ascending order. */
  AutoloopAsc = 'autoloop_ASC',
  /** Order by `autoloop` in descending order. */
  AutoloopDesc = 'autoloop_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `loopDelay` in ascending order. */
  LoopDelayAsc = 'loopDelay_ASC',
  /** Order by `loopDelay` in descending order. */
  LoopDelayDesc = 'loopDelay_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** Icon media + short text */
export interface IService extends IElement {
  __typename?: 'Service';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  icon?: Maybe<IMediaWithCrops>;
  text?: Maybe<Scalars['String']>;
}

export interface IServicesList extends IElement {
  __typename?: 'ServicesList';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  services?: Maybe<Array<Maybe<IBlockListItem>>>;
  title?: Maybe<Scalars['String']>;
}

export interface ISettings extends IContent, ICoverImageCmp, IElement {
  __typename?: 'Settings';
  /** The ancestors. */
  ancestors: IContentConnection;
  androidCancelSubUrl?: Maybe<Scalars['String']>;
  androidCurrentVersion?: Maybe<Scalars['String']>;
  androidRedirectURL?: Maybe<Scalars['String']>;
  androidRequiredVersion?: Maybe<Scalars['String']>;
  audioUploadParentId?: Maybe<Scalars['String']>;
  /** List of string ids */
  brazeSubscriptionGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  cTALabel?: Maybe<Scalars['String']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<IMediaWithCrops>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** This image will be used for hero page on Web */
  defaultHeaderImage?: Maybe<IMediaWithCrops>;
  /** The descendants. */
  descendants: IContentConnection;
  footerLogo?: Maybe<IMediaWithCrops>;
  footerMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  footerShortDescription?: Maybe<Scalars['String']>;
  guestBurgerMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
  huaweiCancelSubUrl?: Maybe<Scalars['String']>;
  huaweiCurrentVersion?: Maybe<Scalars['String']>;
  huaweiRedirectUrl?: Maybe<Scalars['String']>;
  huaweiRequiredVersion?: Maybe<Scalars['String']>;
  iOSCancelSubUrl?: Maybe<Scalars['String']>;
  iOSCurrentVersion?: Maybe<Scalars['String']>;
  iOSRedirectUrl?: Maybe<Scalars['String']>;
  iOSRequiredVersion?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  imageUploadParentId?: Maybe<Scalars['String']>;
  legalFooter?: Maybe<Array<Maybe<IBlockListItem>>>;
  legals?: Maybe<Array<Maybe<IContent>>>;
  /** The level. */
  level: Scalars['Int'];
  /** QR Code to send user to distant login page */
  loginQR?: Maybe<IMediaWithCrops>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  passwordValidation?: Maybe<Array<Maybe<IBlockListItem>>>;
  privacyPolicies?: Maybe<Array<Maybe<IContent>>>;
  /** Use shortcodes : {{FIRST_NAME}},  {{LINK}},  {{EMAIL}} */
  resetPassword?: Maybe<Array<Maybe<IBlockListItem>>>;
  sessionAlertMessage?: Maybe<Scalars['String']>;
  /** Select the form for member sign up */
  signupForm?: Maybe<Scalars['JSON']>;
  signupSteps?: Maybe<Array<Maybe<IContent>>>;
  socialBar?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  termsConditions?: Maybe<Array<Maybe<IContent>>>;
  title?: Maybe<Scalars['String']>;
  tutorialSlides?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  webCover?: Maybe<IMediaWithCrops>;
}


export interface ISettingsAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISettingsCTaLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISettingsDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISettingsFooterMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsFooterShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsGuestBurgerMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsLegalFooterArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsLegalsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsPasswordValidationArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsResetPasswordArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsSessionAlertMessageArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsSignupFormArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsSocialBarArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsTutorialSlidesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISettingsUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ISettingsAccessRestrictionCmp extends IElement {
  __typename?: 'SettingsAccessRestrictionCmp';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
}

export interface ISettingsAccessRestrictionCmp1 extends IElement {
  __typename?: 'SettingsAccessRestrictionCmp1';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
}

export interface ISettingsAccessRestrictionCmp2 extends IElement {
  __typename?: 'SettingsAccessRestrictionCmp2';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
}

/** A connection from an object to a list of objects of type `Settings`. */
export interface ISettingsConnection {
  __typename?: 'SettingsConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISettingsEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISettings>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

export interface ISettingsDateCmp extends IElement {
  __typename?: 'SettingsDateCmp';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
}

/** An edge in a connection from an object to another object of type `Settings`. */
export interface ISettingsEdge {
  __typename?: 'SettingsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISettings>;
}

/** External ID to match after import or export */
export interface ISettingsExternalId extends IElement {
  __typename?: 'SettingsExternalId';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
}

/** A filter input for the type `Settings`. */
export interface ISettingsFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISettingsFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISettingsFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISettingsFilterInput>>>;
  /** Field must equal value. */
  androidCancelSubUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  androidCancelSubUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  androidCancelSubUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  androidCancelSubUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  androidCancelSubUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  androidCurrentVersion?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  androidCurrentVersion_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  androidCurrentVersion_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  androidCurrentVersion_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  androidCurrentVersion_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  androidRedirectURL?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  androidRedirectURL_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  androidRedirectURL_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  androidRedirectURL_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  androidRedirectURL_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  androidRequiredVersion?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  androidRequiredVersion_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  androidRequiredVersion_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  androidRequiredVersion_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  androidRequiredVersion_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  audioUploadParentId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  audioUploadParentId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  audioUploadParentId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  audioUploadParentId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  audioUploadParentId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  brazeSubscriptionGroupIds_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  brazeSubscriptionGroupIds_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  cTALabel?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  cTALabel_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  cTALabel_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  cTALabel_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  cTALabel_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  footerShortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  footerShortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  footerShortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  footerShortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  footerShortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  huaweiCancelSubUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  huaweiCancelSubUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  huaweiCancelSubUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  huaweiCancelSubUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  huaweiCancelSubUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  huaweiCurrentVersion?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  huaweiCurrentVersion_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  huaweiCurrentVersion_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  huaweiCurrentVersion_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  huaweiCurrentVersion_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  huaweiRedirectUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  huaweiRedirectUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  huaweiRedirectUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  huaweiRedirectUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  huaweiRedirectUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  huaweiRequiredVersion?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  huaweiRequiredVersion_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  huaweiRequiredVersion_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  huaweiRequiredVersion_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  huaweiRequiredVersion_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  iOSCancelSubUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  iOSCancelSubUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  iOSCancelSubUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  iOSCancelSubUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  iOSCancelSubUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  iOSCurrentVersion?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  iOSCurrentVersion_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  iOSCurrentVersion_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  iOSCurrentVersion_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  iOSCurrentVersion_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  iOSRedirectUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  iOSRedirectUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  iOSRedirectUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  iOSRedirectUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  iOSRedirectUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  iOSRequiredVersion?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  iOSRequiredVersion_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  iOSRequiredVersion_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  iOSRequiredVersion_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  iOSRequiredVersion_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  imageUploadParentId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  imageUploadParentId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  imageUploadParentId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  imageUploadParentId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  imageUploadParentId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  legals_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  legals_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  privacyPolicies_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  privacyPolicies_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sessionAlertMessage?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  sessionAlertMessage_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  sessionAlertMessage_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  sessionAlertMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  sessionAlertMessage_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  signupSteps_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  signupSteps_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  termsConditions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  termsConditions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Settings`. */
export enum ISettingsOrderByInput {
  /** Order by `androidCancelSubUrl` in ascending order. */
  AndroidCancelSubUrlAsc = 'androidCancelSubUrl_ASC',
  /** Order by `androidCancelSubUrl` in descending order. */
  AndroidCancelSubUrlDesc = 'androidCancelSubUrl_DESC',
  /** Order by `androidCurrentVersion` in ascending order. */
  AndroidCurrentVersionAsc = 'androidCurrentVersion_ASC',
  /** Order by `androidCurrentVersion` in descending order. */
  AndroidCurrentVersionDesc = 'androidCurrentVersion_DESC',
  /** Order by `androidRedirectURL` in ascending order. */
  AndroidRedirectUrlAsc = 'androidRedirectURL_ASC',
  /** Order by `androidRedirectURL` in descending order. */
  AndroidRedirectUrlDesc = 'androidRedirectURL_DESC',
  /** Order by `androidRequiredVersion` in ascending order. */
  AndroidRequiredVersionAsc = 'androidRequiredVersion_ASC',
  /** Order by `androidRequiredVersion` in descending order. */
  AndroidRequiredVersionDesc = 'androidRequiredVersion_DESC',
  /** Order by `audioUploadParentId` in ascending order. */
  AudioUploadParentIdAsc = 'audioUploadParentId_ASC',
  /** Order by `audioUploadParentId` in descending order. */
  AudioUploadParentIdDesc = 'audioUploadParentId_DESC',
  /** Order by `cTALabel` in ascending order. */
  CTaLabelAsc = 'cTALabel_ASC',
  /** Order by `cTALabel` in descending order. */
  CTaLabelDesc = 'cTALabel_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `footerShortDescription` in ascending order. */
  FooterShortDescriptionAsc = 'footerShortDescription_ASC',
  /** Order by `footerShortDescription` in descending order. */
  FooterShortDescriptionDesc = 'footerShortDescription_DESC',
  /** Order by `huaweiCancelSubUrl` in ascending order. */
  HuaweiCancelSubUrlAsc = 'huaweiCancelSubUrl_ASC',
  /** Order by `huaweiCancelSubUrl` in descending order. */
  HuaweiCancelSubUrlDesc = 'huaweiCancelSubUrl_DESC',
  /** Order by `huaweiCurrentVersion` in ascending order. */
  HuaweiCurrentVersionAsc = 'huaweiCurrentVersion_ASC',
  /** Order by `huaweiCurrentVersion` in descending order. */
  HuaweiCurrentVersionDesc = 'huaweiCurrentVersion_DESC',
  /** Order by `huaweiRedirectUrl` in ascending order. */
  HuaweiRedirectUrlAsc = 'huaweiRedirectUrl_ASC',
  /** Order by `huaweiRedirectUrl` in descending order. */
  HuaweiRedirectUrlDesc = 'huaweiRedirectUrl_DESC',
  /** Order by `huaweiRequiredVersion` in ascending order. */
  HuaweiRequiredVersionAsc = 'huaweiRequiredVersion_ASC',
  /** Order by `huaweiRequiredVersion` in descending order. */
  HuaweiRequiredVersionDesc = 'huaweiRequiredVersion_DESC',
  /** Order by `iOSCancelSubUrl` in ascending order. */
  IOsCancelSubUrlAsc = 'iOSCancelSubUrl_ASC',
  /** Order by `iOSCancelSubUrl` in descending order. */
  IOsCancelSubUrlDesc = 'iOSCancelSubUrl_DESC',
  /** Order by `iOSCurrentVersion` in ascending order. */
  IOsCurrentVersionAsc = 'iOSCurrentVersion_ASC',
  /** Order by `iOSCurrentVersion` in descending order. */
  IOsCurrentVersionDesc = 'iOSCurrentVersion_DESC',
  /** Order by `iOSRedirectUrl` in ascending order. */
  IOsRedirectUrlAsc = 'iOSRedirectUrl_ASC',
  /** Order by `iOSRedirectUrl` in descending order. */
  IOsRedirectUrlDesc = 'iOSRedirectUrl_DESC',
  /** Order by `iOSRequiredVersion` in ascending order. */
  IOsRequiredVersionAsc = 'iOSRequiredVersion_ASC',
  /** Order by `iOSRequiredVersion` in descending order. */
  IOsRequiredVersionDesc = 'iOSRequiredVersion_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `imageUploadParentId` in ascending order. */
  ImageUploadParentIdAsc = 'imageUploadParentId_ASC',
  /** Order by `imageUploadParentId` in descending order. */
  ImageUploadParentIdDesc = 'imageUploadParentId_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sessionAlertMessage` in ascending order. */
  SessionAlertMessageAsc = 'sessionAlertMessage_ASC',
  /** Order by `sessionAlertMessage` in descending order. */
  SessionAlertMessageDesc = 'sessionAlertMessage_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ISliderHighlight {
  background?: Maybe<IMediaWithCrops>;
  backgroundDesktop?: Maybe<IMediaWithCrops>;
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  surtitle?: Maybe<Scalars['String']>;
}


export interface ISliderHighlightBackgroundDesktopArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISliderHighlightDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISliderHighlightSurtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ISliderThumbnailSettings {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  showThumbnailTitle?: Maybe<Scalars['Boolean']>;
  showThumbnailsSubtitle?: Maybe<Scalars['Boolean']>;
}

export enum ISortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export interface ISpace extends IContent, IElement {
  __typename?: 'Space';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ISpaceAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISpaceChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISpaceDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISpaceNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISpaceParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISpaceUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISpaceUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Space`. */
export interface ISpaceConnection {
  __typename?: 'SpaceConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISpaceEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISpace>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `Space`. */
export interface ISpaceEdge {
  __typename?: 'SpaceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISpace>;
}

/** A filter input for the type `Space`. */
export interface ISpaceFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISpaceFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISpaceFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISpaceFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Space`. */
export enum ISpaceOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IStaticPageLink extends IElement {
  __typename?: 'StaticPageLink';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  link?: Maybe<IContent>;
  title?: Maybe<Scalars['String']>;
}

export interface ISubscription extends IContent, IContentDescriptionCmp, IElement {
  __typename?: 'Subscription';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<IMediaWithCrops>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** Usefull to disable content premium restriction */
  isFree?: Maybe<Scalars['Boolean']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  productID?: Maybe<Scalars['String']>;
  /** 300 char. max. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  /** Add a visual tag to show a promoted price */
  tag?: Maybe<Array<Maybe<IBlockListItem>>>;
  thankYouBody?: Maybe<Scalars['String']>;
  thankYouCover?: Maybe<Array<Maybe<IBlockListItem>>>;
  thankYouTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ISubscriptionAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionThankYouBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionThankYouTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `Subscription`. */
export interface ISubscriptionConnection {
  __typename?: 'SubscriptionConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISubscriptionEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISubscription>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

export interface ISubscriptionData extends IContent, IElement {
  __typename?: 'SubscriptionData';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  deviceType?: Maybe<Scalars['String']>;
  externalID?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subscriptionEnd?: Maybe<Scalars['DateTime']>;
  subscriptionPrice?: Maybe<Scalars['Decimal']>;
  subscriptionStart?: Maybe<Scalars['DateTime']>;
  subscriptionType?: Maybe<IContent>;
  transactionId?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ISubscriptionDataAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionDataChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionDataDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionDataNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionDataParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionDataUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionDataUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `SubscriptionData`. */
export interface ISubscriptionDataConnection {
  __typename?: 'SubscriptionDataConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISubscriptionDataEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISubscriptionData>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `SubscriptionData`. */
export interface ISubscriptionDataEdge {
  __typename?: 'SubscriptionDataEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISubscriptionData>;
}

/** A filter input for the type `SubscriptionData`. */
export interface ISubscriptionDataFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISubscriptionDataFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISubscriptionDataFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISubscriptionDataFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  deviceType?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  deviceType_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  deviceType_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  deviceType_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  deviceType_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  externalID?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalID_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalID_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalID_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalID_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subscriptionEnd?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  subscriptionEnd_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  subscriptionEnd_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  subscriptionEnd_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  subscriptionEnd_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subscriptionPrice?: InputMaybe<Scalars['Decimal']>;
  /** Field must match any of the values. */
  subscriptionPrice_any?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  /** Field must be greater than the value. */
  subscriptionPrice_gt?: InputMaybe<Scalars['Decimal']>;
  /** Field must be greater than or equal the value. */
  subscriptionPrice_gte?: InputMaybe<Scalars['Decimal']>;
  /** Field must be less than the value. */
  subscriptionPrice_lt?: InputMaybe<Scalars['Decimal']>;
  /** Field must be less than or equal the value. */
  subscriptionPrice_lte?: InputMaybe<Scalars['Decimal']>;
  /** Field must equal value. */
  subscriptionStart?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  subscriptionStart_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  subscriptionStart_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  subscriptionStart_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  subscriptionStart_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subscriptionType?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  transactionId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  transactionId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  transactionId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  transactionId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  transactionId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

export interface ISubscriptionDataFolder extends IContent, IElement {
  __typename?: 'SubscriptionDataFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ISubscriptionDataFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionDataFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionDataFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionDataFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionDataFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionDataFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionDataFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `SubscriptionDataFolder`. */
export interface ISubscriptionDataFolderConnection {
  __typename?: 'SubscriptionDataFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISubscriptionDataFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISubscriptionDataFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `SubscriptionDataFolder`. */
export interface ISubscriptionDataFolderEdge {
  __typename?: 'SubscriptionDataFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISubscriptionDataFolder>;
}

/** A filter input for the type `SubscriptionDataFolder`. */
export interface ISubscriptionDataFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISubscriptionDataFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISubscriptionDataFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISubscriptionDataFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `SubscriptionDataFolder`. */
export enum ISubscriptionDataFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An order input for the type `SubscriptionData`. */
export enum ISubscriptionDataOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `deviceType` in ascending order. */
  DeviceTypeAsc = 'deviceType_ASC',
  /** Order by `deviceType` in descending order. */
  DeviceTypeDesc = 'deviceType_DESC',
  /** Order by `externalID` in ascending order. */
  ExternalIdAsc = 'externalID_ASC',
  /** Order by `externalID` in descending order. */
  ExternalIdDesc = 'externalID_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subscriptionEnd` in ascending order. */
  SubscriptionEndAsc = 'subscriptionEnd_ASC',
  /** Order by `subscriptionEnd` in descending order. */
  SubscriptionEndDesc = 'subscriptionEnd_DESC',
  /** Order by `subscriptionPrice` in ascending order. */
  SubscriptionPriceAsc = 'subscriptionPrice_ASC',
  /** Order by `subscriptionPrice` in descending order. */
  SubscriptionPriceDesc = 'subscriptionPrice_DESC',
  /** Order by `subscriptionStart` in ascending order. */
  SubscriptionStartAsc = 'subscriptionStart_ASC',
  /** Order by `subscriptionStart` in descending order. */
  SubscriptionStartDesc = 'subscriptionStart_DESC',
  /** Order by `subscriptionType` in ascending order. */
  SubscriptionTypeAsc = 'subscriptionType_ASC',
  /** Order by `subscriptionType` in descending order. */
  SubscriptionTypeDesc = 'subscriptionType_DESC',
  /** Order by `transactionId` in ascending order. */
  TransactionIdAsc = 'transactionId_ASC',
  /** Order by `transactionId` in descending order. */
  TransactionIdDesc = 'transactionId_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** An edge in a connection from an object to another object of type `Subscription`. */
export interface ISubscriptionEdge {
  __typename?: 'SubscriptionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISubscription>;
}

/** A filter input for the type `Subscription`. */
export interface ISubscriptionFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISubscriptionFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISubscriptionFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISubscriptionFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  isFree?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  productID?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  productID_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  productID_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  productID_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  productID_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  thankYouBody?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  thankYouBody_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  thankYouBody_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  thankYouBody_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  thankYouBody_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  thankYouTitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  thankYouTitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  thankYouTitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  thankYouTitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  thankYouTitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `Subscription`. */
export enum ISubscriptionOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `isFree` in ascending order. */
  IsFreeAsc = 'isFree_ASC',
  /** Order by `isFree` in descending order. */
  IsFreeDesc = 'isFree_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `productID` in ascending order. */
  ProductIdAsc = 'productID_ASC',
  /** Order by `productID` in descending order. */
  ProductIdDesc = 'productID_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `thankYouBody` in ascending order. */
  ThankYouBodyAsc = 'thankYouBody_ASC',
  /** Order by `thankYouBody` in descending order. */
  ThankYouBodyDesc = 'thankYouBody_DESC',
  /** Order by `thankYouTitle` in ascending order. */
  ThankYouTitleAsc = 'thankYouTitle_ASC',
  /** Order by `thankYouTitle` in descending order. */
  ThankYouTitleDesc = 'thankYouTitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ISubscriptionsFolder extends IContent, IElement {
  __typename?: 'SubscriptionsFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ISubscriptionsFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionsFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionsFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISubscriptionsFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionsFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionsFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISubscriptionsFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `SubscriptionsFolder`. */
export interface ISubscriptionsFolderConnection {
  __typename?: 'SubscriptionsFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISubscriptionsFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISubscriptionsFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `SubscriptionsFolder`. */
export interface ISubscriptionsFolderEdge {
  __typename?: 'SubscriptionsFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISubscriptionsFolder>;
}

/** A filter input for the type `SubscriptionsFolder`. */
export interface ISubscriptionsFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISubscriptionsFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISubscriptionsFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISubscriptionsFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `SubscriptionsFolder`. */
export enum ISubscriptionsFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ISubscriptionsList extends IElement {
  __typename?: 'SubscriptionsList';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  subscriptionsList?: Maybe<Array<Maybe<IContent>>>;
}

/** Nugget with a question and mutliple possible answers */
export interface ISumaryNugget extends IContent, IElement, INuggetFeedbackCmp {
  __typename?: 'SumaryNugget';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** Used for identification from import */
  externalId?: Maybe<Scalars['String']>;
  /** Tick to use the feedbacks below for empty choices' feebacks */
  genericFeedback?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  negativeFeedback?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  positiveFeedback?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  statements?: Maybe<Array<Maybe<IBlockListItem>>>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetNegativeFeedbackArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetPositiveFeedbackArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetStatementsArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Nugget with a question and mutliple possible answers */
export interface ISumaryNuggetUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `SumaryNugget`. */
export interface ISumaryNuggetConnection {
  __typename?: 'SumaryNuggetConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISumaryNuggetEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISumaryNugget>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `SumaryNugget`. */
export interface ISumaryNuggetEdge {
  __typename?: 'SumaryNuggetEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISumaryNugget>;
}

/** A filter input for the type `SumaryNugget`. */
export interface ISumaryNuggetFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISumaryNuggetFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISumaryNuggetFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISumaryNuggetFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  externalId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  externalId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  externalId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  externalId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  externalId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  genericFeedback?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  negativeFeedback?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  negativeFeedback_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  negativeFeedback_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  negativeFeedback_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  negativeFeedback_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  positiveFeedback?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  positiveFeedback_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  positiveFeedback_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  positiveFeedback_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  positiveFeedback_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `SumaryNugget`. */
export enum ISumaryNuggetOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `externalId` in ascending order. */
  ExternalIdAsc = 'externalId_ASC',
  /** Order by `externalId` in descending order. */
  ExternalIdDesc = 'externalId_DESC',
  /** Order by `genericFeedback` in ascending order. */
  GenericFeedbackAsc = 'genericFeedback_ASC',
  /** Order by `genericFeedback` in descending order. */
  GenericFeedbackDesc = 'genericFeedback_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `negativeFeedback` in ascending order. */
  NegativeFeedbackAsc = 'negativeFeedback_ASC',
  /** Order by `negativeFeedback` in descending order. */
  NegativeFeedbackDesc = 'negativeFeedback_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `positiveFeedback` in ascending order. */
  PositiveFeedbackAsc = 'positiveFeedback_ASC',
  /** Order by `positiveFeedback` in descending order. */
  PositiveFeedbackDesc = 'positiveFeedback_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ISummaryNuggetStatement extends IElement {
  __typename?: 'SummaryNuggetStatement';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  options?: Maybe<Array<Maybe<IBlockListItem>>>;
}

export interface ISurveyQuizzFolder extends IContent, IElement {
  __typename?: 'SurveyQuizzFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ISurveyQuizzFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISurveyQuizzFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISurveyQuizzFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ISurveyQuizzFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISurveyQuizzFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISurveyQuizzFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ISurveyQuizzFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `SurveyQuizzFolder`. */
export interface ISurveyQuizzFolderConnection {
  __typename?: 'SurveyQuizzFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ISurveyQuizzFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ISurveyQuizzFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `SurveyQuizzFolder`. */
export interface ISurveyQuizzFolderEdge {
  __typename?: 'SurveyQuizzFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ISurveyQuizzFolder>;
}

/** A filter input for the type `SurveyQuizzFolder`. */
export interface ISurveyQuizzFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ISurveyQuizzFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ISurveyQuizzFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ISurveyQuizzFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `SurveyQuizzFolder`. */
export enum ISurveyQuizzFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ITextPage extends IContent, IElement {
  __typename?: 'TextPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  body?: Maybe<Scalars['HTML']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ITextPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITextPageBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITextPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITextPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITextPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITextPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITextPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITextPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITextPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `TextPage`. */
export interface ITextPageConnection {
  __typename?: 'TextPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ITextPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ITextPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `TextPage`. */
export interface ITextPageEdge {
  __typename?: 'TextPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ITextPage>;
}

/** A filter input for the type `TextPage`. */
export interface ITextPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ITextPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ITextPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ITextPageFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `TextPage`. */
export enum ITextPageOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** a slide with title overtitle, text and background cover */
export interface ITextSlide1 extends IElement {
  __typename?: 'TextSlide1';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  description?: Maybe<Scalars['String']>;
  /** Redirects the user on click on the slide */
  linkTo?: Maybe<Array<Maybe<IBlockListItem>>>;
  overtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** a slide with title overtitle, text and background cover */
export interface ITextSlide1DescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** a slide with title overtitle, text and background cover */
export interface ITextSlide1OvertitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** a slide with title overtitle, text and background cover */
export interface ITextSlide1TitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** for Forms */
export interface IThankYouPage extends IContent, ICoverVideoCmp, IElement, IPage {
  __typename?: 'ThankYouPage';
  /** The ancestors. */
  ancestors: IContentConnection;
  body?: Maybe<Scalars['String']>;
  cTA?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


/** for Forms */
export interface IThankYouPageAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** for Forms */
export interface IThankYouPageBodyArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for Forms */
export interface IThankYouPageCTaArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for Forms */
export interface IThankYouPageChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** for Forms */
export interface IThankYouPageDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


/** for Forms */
export interface IThankYouPageNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for Forms */
export interface IThankYouPageParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for Forms */
export interface IThankYouPageSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for Forms */
export interface IThankYouPageTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for Forms */
export interface IThankYouPageUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** for Forms */
export interface IThankYouPageUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `ThankYouPage`. */
export interface IThankYouPageConnection {
  __typename?: 'ThankYouPageConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IThankYouPageEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IThankYouPage>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `ThankYouPage`. */
export interface IThankYouPageEdge {
  __typename?: 'ThankYouPageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IThankYouPage>;
}

/** A filter input for the type `ThankYouPage`. */
export interface IThankYouPageFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IThankYouPageFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IThankYouPageFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IThankYouPageFilterInput>>>;
  /** Field must equal value. */
  body?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  body_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  body_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  body_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  body_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `ThankYouPage`. */
export enum IThankYouPageOrderByInput {
  /** Order by `body` in ascending order. */
  BodyAsc = 'body_ASC',
  /** Order by `body` in descending order. */
  BodyDesc = 'body_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

/** slider with a title and basic slides */
export interface ITitleSlider extends IElement {
  __typename?: 'TitleSlider';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  slides?: Maybe<Array<Maybe<IBlockListItem>>>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}


/** slider with a title and basic slides */
export interface ITitleSliderSlidesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** slider with a title and basic slides */
export interface ITitleSliderSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** slider with a title and basic slides */
export interface ITitleSliderTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ITop10Cmp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  top10?: Maybe<Array<Maybe<IBlockListItem>>>;
  top10Title?: Maybe<Scalars['String']>;
}


export interface ITop10CmpTop10Args {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITop10CmpTop10TitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Song for radio Top10 */
export interface ITop10Song extends IElement {
  __typename?: 'Top10Song';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
}


/** Song for radio Top10 */
export interface ITop10SongSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Song for radio Top10 */
export interface ITop10SongThumbnailArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ITopMenuComp {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
  topMenu?: Maybe<Array<Maybe<IBlockListItem>>>;
}


export interface ITopMenuCompTopMenuArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface ITranslationContext extends IContent, IElement {
  __typename?: 'TranslationContext';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ITranslationContextAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationContextChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationContextDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationContextNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationContextParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationContextUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationContextUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `TranslationContext`. */
export interface ITranslationContextConnection {
  __typename?: 'TranslationContextConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ITranslationContextEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ITranslationContext>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `TranslationContext`. */
export interface ITranslationContextEdge {
  __typename?: 'TranslationContextEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ITranslationContext>;
}

/** A filter input for the type `TranslationContext`. */
export interface ITranslationContextFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ITranslationContextFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ITranslationContextFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ITranslationContextFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `TranslationContext`. */
export enum ITranslationContextOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ITranslationFolder extends IContent, IElement {
  __typename?: 'TranslationFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface ITranslationFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `TranslationFolder`. */
export interface ITranslationFolderConnection {
  __typename?: 'TranslationFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ITranslationFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ITranslationFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `TranslationFolder`. */
export interface ITranslationFolderEdge {
  __typename?: 'TranslationFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ITranslationFolder>;
}

/** A filter input for the type `TranslationFolder`. */
export interface ITranslationFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ITranslationFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ITranslationFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ITranslationFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `TranslationFolder`. */
export enum ITranslationFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface ITranslationItem extends IContent, IElement {
  __typename?: 'TranslationItem';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}


export interface ITranslationItemAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationItemChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationItemDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface ITranslationItemNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationItemParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationItemUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationItemUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface ITranslationItemValueArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `TranslationItem`. */
export interface ITranslationItemConnection {
  __typename?: 'TranslationItemConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<ITranslationItemEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<ITranslationItem>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `TranslationItem`. */
export interface ITranslationItemEdge {
  __typename?: 'TranslationItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ITranslationItem>;
}

/** A filter input for the type `TranslationItem`. */
export interface ITranslationItemFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<ITranslationItemFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<ITranslationItemFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<ITranslationItemFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  value?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  value_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  value_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  value_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  value_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `TranslationItem`. */
export enum ITranslationItemOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `value` in ascending order. */
  ValueAsc = 'value_ASC',
  /** Order by `value` in descending order. */
  ValueDesc = 'value_DESC'
}

/** fix */
export interface ITutorialSlide extends IElement {
  __typename?: 'TutorialSlide';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** Audio player from Vimeo */
export interface IUcAudio extends IContentLiveVideoCmp, IElement {
  __typename?: 'UcAudio';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Live event ID or Vimeo Video ID */
  liveEventID?: Maybe<Scalars['Int']>;
  /** Other video source */
  sourceUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<IMediaWithCrops>;
}


/** Audio player from Vimeo */
export interface IUcAudioLiveEventIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Audio player from Vimeo */
export interface IUcAudioThumbnailArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** Image */
export interface IUcImage extends IElement {
  __typename?: 'UcImage';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  image?: Maybe<IMediaWithCrops>;
  text?: Maybe<Scalars['String']>;
}

/** Separator */
export interface IUcLineBreak extends IElement {
  __typename?: 'UcLineBreak';
  body?: Maybe<Scalars['String']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  text?: Maybe<Scalars['String']>;
}

/** Just a standard textarea with lite styling */
export interface IUcText extends IElement {
  __typename?: 'UcText';
  body?: Maybe<Scalars['HTML']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
}

/** Vimeo video with caption */
export interface IUcVideo extends IContentLiveVideoCmp, IElement {
  __typename?: 'UcVideo';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Live event ID or Vimeo Video ID */
  liveEventID?: Maybe<Scalars['Int']>;
  /** Other video source */
  sourceUrl?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** 🛑 DO NOT EDIT ! Technical information */
  vimeoURL?: Maybe<Scalars['String']>;
}


/** Vimeo video with caption */
export interface IUcVideoLiveEventIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}


/** Vimeo video with caption */
export interface IUcVideoVimeoUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IUmbracoMediaArticle extends IMedia {
  __typename?: 'UmbracoMediaArticle';
  /** The ancestors. */
  ancestors: IMediaConnection;
  /** The children. */
  children: IMediaConnection;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IMediaConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The Media Type alias. */
  mediaTypeAlias: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
  /** The parent Media, can be null if Media is at root. */
  parent?: Maybe<IMedia>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** in bytes */
  umbracoBytes?: Maybe<Scalars['String']>;
  umbracoExtension?: Maybe<Scalars['String']>;
  umbracoFile?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate: Scalars['DateTime'];
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IUmbracoMediaArticleAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaArticleChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaArticleDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaArticleUmbracoFileArgs {
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaArticleUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUmbracoMediaArticleUrlArgs {
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  culture?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface IUmbracoMediaAudio extends IMedia {
  __typename?: 'UmbracoMediaAudio';
  /** The ancestors. */
  ancestors: IMediaConnection;
  /** The children. */
  children: IMediaConnection;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IMediaConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The Media Type alias. */
  mediaTypeAlias: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
  /** The parent Media, can be null if Media is at root. */
  parent?: Maybe<IMedia>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** in bytes */
  umbracoBytes?: Maybe<Scalars['String']>;
  umbracoExtension?: Maybe<Scalars['String']>;
  umbracoFile?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate: Scalars['DateTime'];
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IUmbracoMediaAudioAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaAudioChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaAudioDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaAudioUmbracoFileArgs {
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaAudioUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUmbracoMediaAudioUrlArgs {
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  culture?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface IUmbracoMediaVectorGraphics extends IMedia {
  __typename?: 'UmbracoMediaVectorGraphics';
  /** The ancestors. */
  ancestors: IMediaConnection;
  /** The children. */
  children: IMediaConnection;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IMediaConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The Media Type alias. */
  mediaTypeAlias: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
  /** The parent Media, can be null if Media is at root. */
  parent?: Maybe<IMedia>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** in bytes */
  umbracoBytes?: Maybe<Scalars['String']>;
  umbracoExtension?: Maybe<Scalars['String']>;
  umbracoFile?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate: Scalars['DateTime'];
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IUmbracoMediaVectorGraphicsAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaVectorGraphicsChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaVectorGraphicsDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaVectorGraphicsUmbracoFileArgs {
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaVectorGraphicsUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUmbracoMediaVectorGraphicsUrlArgs {
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  culture?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface IUmbracoMediaVideo extends IMedia {
  __typename?: 'UmbracoMediaVideo';
  /** The ancestors. */
  ancestors: IMediaConnection;
  /** The children. */
  children: IMediaConnection;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IMediaConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The Media Type alias. */
  mediaTypeAlias: Scalars['String'];
  /** The name. */
  name: Scalars['String'];
  /** The parent Media, can be null if Media is at root. */
  parent?: Maybe<IMedia>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** in bytes */
  umbracoBytes?: Maybe<Scalars['String']>;
  umbracoExtension?: Maybe<Scalars['String']>;
  umbracoFile?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate: Scalars['DateTime'];
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IUmbracoMediaVideoAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaVideoChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaVideoDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaVideoUmbracoFileArgs {
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}


export interface IUmbracoMediaVideoUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUmbracoMediaVideoUrlArgs {
  autoRotate?: InputMaybe<Scalars['Boolean']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  cropAnchor?: InputMaybe<IImageCropAnchor>;
  cropMode?: InputMaybe<IImageCropMode>;
  culture?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<IImageCropFormat>;
  height?: InputMaybe<Scalars['Int']>;
  quality?: InputMaybe<Scalars['Int']>;
  ratioMode?: InputMaybe<IImageCropRatioMode>;
  upscale?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
}

export interface IUmbracoTest extends IContent, IElement {
  __typename?: 'UmbracoTest';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IUmbracoTestAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUmbracoTestChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUmbracoTestDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUmbracoTestNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUmbracoTestParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUmbracoTestUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUmbracoTestUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `UmbracoTest`. */
export interface IUmbracoTestConnection {
  __typename?: 'UmbracoTestConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IUmbracoTestEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IUmbracoTest>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `UmbracoTest`. */
export interface IUmbracoTestEdge {
  __typename?: 'UmbracoTestEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IUmbracoTest>;
}

/** A filter input for the type `UmbracoTest`. */
export interface IUmbracoTestFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IUmbracoTestFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IUmbracoTestFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IUmbracoTestFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `UmbracoTest`. */
export enum IUmbracoTestOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IUnitNuggetAnswer extends IContent, IElement {
  __typename?: 'UnitNuggetAnswer';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
}


export interface IUnitNuggetAnswerAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitNuggetAnswerChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitNuggetAnswerDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitNuggetAnswerNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitNuggetAnswerParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitNuggetAnswerUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitNuggetAnswerUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `UnitNuggetAnswer`. */
export interface IUnitNuggetAnswerConnection {
  __typename?: 'UnitNuggetAnswerConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IUnitNuggetAnswerEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IUnitNuggetAnswer>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `UnitNuggetAnswer`. */
export interface IUnitNuggetAnswerEdge {
  __typename?: 'UnitNuggetAnswerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IUnitNuggetAnswer>;
}

/** A filter input for the type `UnitNuggetAnswer`. */
export interface IUnitNuggetAnswerFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IUnitNuggetAnswerFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IUnitNuggetAnswerFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IUnitNuggetAnswerFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  value_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  value_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
}

/** An order input for the type `UnitNuggetAnswer`. */
export enum IUnitNuggetAnswerOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IUnitNuggetGapFillAnswer extends IContent, IElement {
  __typename?: 'UnitNuggetGapFillAnswer';
  /** The ancestors. */
  ancestors: IContentConnection;
  answers?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IUnitNuggetGapFillAnswerAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitNuggetGapFillAnswerChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitNuggetGapFillAnswerDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitNuggetGapFillAnswerNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitNuggetGapFillAnswerParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitNuggetGapFillAnswerUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitNuggetGapFillAnswerUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `UnitNuggetGapFillAnswer`. */
export interface IUnitNuggetGapFillAnswerConnection {
  __typename?: 'UnitNuggetGapFillAnswerConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IUnitNuggetGapFillAnswerEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IUnitNuggetGapFillAnswer>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `UnitNuggetGapFillAnswer`. */
export interface IUnitNuggetGapFillAnswerEdge {
  __typename?: 'UnitNuggetGapFillAnswerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IUnitNuggetGapFillAnswer>;
}

/** A filter input for the type `UnitNuggetGapFillAnswer`. */
export interface IUnitNuggetGapFillAnswerFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IUnitNuggetGapFillAnswerFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IUnitNuggetGapFillAnswerFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IUnitNuggetGapFillAnswerFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

export interface IUnitNuggetGapFillAnswerItem extends IElement {
  __typename?: 'UnitNuggetGapFillAnswerItem';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  reference?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

/** An order input for the type `UnitNuggetGapFillAnswer`. */
export enum IUnitNuggetGapFillAnswerOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IUnitProgression extends IContent, IElement {
  __typename?: 'UnitProgression';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  courseId?: Maybe<Scalars['String']>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  finished?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** Cache */
  json?: Maybe<Scalars['String']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IUnitProgressionAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitProgressionChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitProgressionDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IUnitProgressionNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitProgressionParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitProgressionUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IUnitProgressionUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `UnitProgression`. */
export interface IUnitProgressionConnection {
  __typename?: 'UnitProgressionConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IUnitProgressionEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IUnitProgression>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `UnitProgression`. */
export interface IUnitProgressionEdge {
  __typename?: 'UnitProgressionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IUnitProgression>;
}

/** A filter input for the type `UnitProgression`. */
export interface IUnitProgressionFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IUnitProgressionFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IUnitProgressionFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IUnitProgressionFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  courseId?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  courseId_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  courseId_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  courseId_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  courseId_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  finished?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  json?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  json_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  json_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  json_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  json_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `UnitProgression`. */
export enum IUnitProgressionOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `courseId` in ascending order. */
  CourseIdAsc = 'courseId_ASC',
  /** Order by `courseId` in descending order. */
  CourseIdDesc = 'courseId_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `finished` in ascending order. */
  FinishedAsc = 'finished_ASC',
  /** Order by `finished` in descending order. */
  FinishedDesc = 'finished_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `json` in ascending order. */
  JsonAsc = 'json_ASC',
  /** Order by `json` in descending order. */
  JsonDesc = 'json_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IVodItem extends IContent, IContentDescriptionCmp, IContentItems, IElement, IMetasAuthorCmp, IMetasVideosCmp {
  __typename?: 'VODItem';
  /** is the content restricted to Subscriber only */
  accessType?: Maybe<Array<Maybe<IContent>>>;
  /** The ancestors. */
  ancestors: IContentConnection;
  /** You can add all sort of featured people (including hosts, guests, technical crew, etc.) */
  author?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** if the content is available across only certain regions, please select them here. If left blank, the content will be available on every regions */
  availableRegions?: Maybe<Array<Maybe<IContent>>>;
  byteplusVideoID: Maybe<Scalars['String']>;
  channel?: Maybe<IContent>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** Select countries in which this content shouldn't be accessible */
  countriesRestriction?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** recommended size : 1000 x 1280 */
  cover?: Maybe<Array<Maybe<IBlockListItem>>>;
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  description?: Maybe<Scalars['String']>;
  /** Use this field to provide the legal date of publishing end. It will block access to the content on that given date */
  endDate?: Maybe<Scalars['DateTime']>;
  episodeNumber?: Maybe<Scalars['Int']>;
  exclusives?: Maybe<Scalars['Boolean']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  imageFormat?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Maybe<IContent>>>;
  is3rdparty?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Scalars['String']>;
  /** in seconds */
  length?: Maybe<Scalars['Int']>;
  /** The level. */
  level: Scalars['Int'];
  linkedJobs?: Maybe<Scalars['String']>;
  /** Live event ID or Vimeo Video ID */
  liveEventID?: Maybe<Scalars['Int']>;
  mogadorProductKey?: Maybe<Scalars['String']>;
  musicGenre?: Maybe<Array<Maybe<IContent>>>;
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  partners?: Maybe<Array<Maybe<IContent>>>;
  /** Use this feature to override the default paywall for this given content */
  paywall?: Maybe<IContent>;
  personality?: Maybe<Array<Maybe<Scalars['String']>>>;
  producerName?: Maybe<Scalars['String']>;
  productionCountry?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<Maybe<IContent>>>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  resolution?: Maybe<Scalars['String']>;
  revShare?: Maybe<Scalars['Int']>;
  searchTag?: Maybe<Array<Maybe<Scalars['String']>>>;
  seasonNumber?: Maybe<Scalars['Int']>;
  /** 300 char. max. */
  shortDescription?: Maybe<Scalars['String']>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** Other video source */
  sourceUrl?: Maybe<Scalars['String']>;
  /** Use this field if you want to publish the content but not make it accessible before a certain date */
  startDate?: Maybe<Scalars['DateTime']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitlesLanguage?: Maybe<Scalars['String']>;
  themes?: Maybe<Array<Maybe<IContent>>>;
  thumbnail?: Maybe<IMediaWithCrops>;
  title?: Maybe<Scalars['String']>;
  /** Vimeo ID for trailer video */
  trailer?: Maybe<Scalars['Int']>;
  typeOfFormat?: Maybe<Scalars['String']>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  vimeoHlsUrl?: Maybe<Scalars['String']>;
  voiceOverLanguage?: Maybe<Scalars['String']>;
  youtubeId?: Maybe<Scalars['String']>;
}


export interface IVodItemAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVodItemChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVodItemDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVodItemDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemLanguagesArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemLiveEventIdArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemSearchTagArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemShortDescriptionArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemSubtitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemSubtitlesLanguageArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemTitleArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemTrailerArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemVimeoHlsUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodItemVoiceOverLanguageArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `VODItem`. */
export interface IVodItemConnection {
  __typename?: 'VODItemConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IVodItemEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IVodItem>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `VODItem`. */
export interface IVodItemEdge {
  __typename?: 'VODItemEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IVodItem>;
}

/** A filter input for the type `VODItem`. */
export interface IVodItemFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IVodItemFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IVodItemFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IVodItemFilterInput>>>;
  /** Field must match all of the values. */
  accessType_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  accessType_some?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  availableRegions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  availableRegions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  channel?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  countriesRestriction_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  countriesRestriction_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  description?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  description_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  episodeNumber?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  episodeNumber_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  episodeNumber_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  episodeNumber_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  episodeNumber_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  episodeNumber_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  exclusives?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  imageFormat?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  imageFormat_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  imageFormat_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  imageFormat_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  imageFormat_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  interests_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  interests_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  is3rdparty?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  languages?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  languages_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  languages_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  languages_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  languages_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  length?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  length_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  length_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  length_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  length_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  length_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  linkedJobs?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  linkedJobs_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  linkedJobs_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  linkedJobs_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  linkedJobs_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  liveEventID?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  liveEventID_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  liveEventID_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  liveEventID_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  liveEventID_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  liveEventID_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  mogadorProductKey?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  mogadorProductKey_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  mogadorProductKey_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  mogadorProductKey_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  mogadorProductKey_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  musicGenre_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  musicGenre_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  partners_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  partners_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  paywall?: InputMaybe<IContentFilterInput>;
  /** Field must match all of the values. */
  personality_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  personality_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  producerName?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  producerName_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  producerName_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  producerName_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  producerName_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  productionCountry?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  productionCountry_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  productionCountry_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  productionCountry_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  productionCountry_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  public?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  public_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  public_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  public_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  public_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  regions_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  regions_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  releaseDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  releaseDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  releaseDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  releaseDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  releaseDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  resolution?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  resolution_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  resolution_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  resolution_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  resolution_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  revShare?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  revShare_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  revShare_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  revShare_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  revShare_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  revShare_lte?: InputMaybe<Scalars['Int']>;
  /** Field must match all of the values. */
  searchTag_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must match some of the values. */
  searchTag_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must equal value. */
  seasonNumber?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  seasonNumber_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  seasonNumber_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  seasonNumber_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  seasonNumber_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  seasonNumber_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  shortDescription?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  shortDescription_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  shortDescription_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  shortDescription_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  shortDescription_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  sourceUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  sourceUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  sourceUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  sourceUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  sourceUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitle_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitle_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitle_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitle_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  subtitlesLanguage?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  subtitlesLanguage_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  subtitlesLanguage_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  subtitlesLanguage_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  subtitlesLanguage_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must match all of the values. */
  themes_all?: InputMaybe<IContentFilterInput>;
  /** Field must match some of the values. */
  themes_some?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  title?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  title_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  trailer?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  trailer_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  trailer_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  trailer_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  trailer_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  trailer_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  typeOfFormat?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  typeOfFormat_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  typeOfFormat_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  typeOfFormat_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  typeOfFormat_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  vimeoHlsUrl?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  vimeoHlsUrl_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  vimeoHlsUrl_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  vimeoHlsUrl_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  vimeoHlsUrl_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  voiceOverLanguage?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  voiceOverLanguage_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  voiceOverLanguage_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  voiceOverLanguage_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  voiceOverLanguage_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `VODItem`. */
export enum IVodItemOrderByInput {
  /** Order by `channel` in ascending order. */
  ChannelAsc = 'channel_ASC',
  /** Order by `channel` in descending order. */
  ChannelDesc = 'channel_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `description` in ascending order. */
  DescriptionAsc = 'description_ASC',
  /** Order by `description` in descending order. */
  DescriptionDesc = 'description_DESC',
  /** Order by `endDate` in ascending order. */
  EndDateAsc = 'endDate_ASC',
  /** Order by `endDate` in descending order. */
  EndDateDesc = 'endDate_DESC',
  /** Order by `episodeNumber` in ascending order. */
  EpisodeNumberAsc = 'episodeNumber_ASC',
  /** Order by `episodeNumber` in descending order. */
  EpisodeNumberDesc = 'episodeNumber_DESC',
  /** Order by `exclusives` in ascending order. */
  ExclusivesAsc = 'exclusives_ASC',
  /** Order by `exclusives` in descending order. */
  ExclusivesDesc = 'exclusives_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `imageFormat` in ascending order. */
  ImageFormatAsc = 'imageFormat_ASC',
  /** Order by `imageFormat` in descending order. */
  ImageFormatDesc = 'imageFormat_DESC',
  /** Order by `is3rdparty` in ascending order. */
  Is3rdpartyAsc = 'is3rdparty_ASC',
  /** Order by `is3rdparty` in descending order. */
  Is3rdpartyDesc = 'is3rdparty_DESC',
  /** Order by `languages` in ascending order. */
  LanguagesAsc = 'languages_ASC',
  /** Order by `languages` in descending order. */
  LanguagesDesc = 'languages_DESC',
  /** Order by `length` in ascending order. */
  LengthAsc = 'length_ASC',
  /** Order by `length` in descending order. */
  LengthDesc = 'length_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `linkedJobs` in ascending order. */
  LinkedJobsAsc = 'linkedJobs_ASC',
  /** Order by `linkedJobs` in descending order. */
  LinkedJobsDesc = 'linkedJobs_DESC',
  /** Order by `liveEventID` in ascending order. */
  LiveEventIdAsc = 'liveEventID_ASC',
  /** Order by `liveEventID` in descending order. */
  LiveEventIdDesc = 'liveEventID_DESC',
  /** Order by `mogadorProductKey` in ascending order. */
  MogadorProductKeyAsc = 'mogadorProductKey_ASC',
  /** Order by `mogadorProductKey` in descending order. */
  MogadorProductKeyDesc = 'mogadorProductKey_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `paywall` in ascending order. */
  PaywallAsc = 'paywall_ASC',
  /** Order by `paywall` in descending order. */
  PaywallDesc = 'paywall_DESC',
  /** Order by `producerName` in ascending order. */
  ProducerNameAsc = 'producerName_ASC',
  /** Order by `producerName` in descending order. */
  ProducerNameDesc = 'producerName_DESC',
  /** Order by `productionCountry` in ascending order. */
  ProductionCountryAsc = 'productionCountry_ASC',
  /** Order by `productionCountry` in descending order. */
  ProductionCountryDesc = 'productionCountry_DESC',
  /** Order by `public` in ascending order. */
  PublicAsc = 'public_ASC',
  /** Order by `public` in descending order. */
  PublicDesc = 'public_DESC',
  /** Order by `releaseDate` in ascending order. */
  ReleaseDateAsc = 'releaseDate_ASC',
  /** Order by `releaseDate` in descending order. */
  ReleaseDateDesc = 'releaseDate_DESC',
  /** Order by `resolution` in ascending order. */
  ResolutionAsc = 'resolution_ASC',
  /** Order by `resolution` in descending order. */
  ResolutionDesc = 'resolution_DESC',
  /** Order by `revShare` in ascending order. */
  RevShareAsc = 'revShare_ASC',
  /** Order by `revShare` in descending order. */
  RevShareDesc = 'revShare_DESC',
  /** Order by `seasonNumber` in ascending order. */
  SeasonNumberAsc = 'seasonNumber_ASC',
  /** Order by `seasonNumber` in descending order. */
  SeasonNumberDesc = 'seasonNumber_DESC',
  /** Order by `shortDescription` in ascending order. */
  ShortDescriptionAsc = 'shortDescription_ASC',
  /** Order by `shortDescription` in descending order. */
  ShortDescriptionDesc = 'shortDescription_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `sourceUrl` in ascending order. */
  SourceUrlAsc = 'sourceUrl_ASC',
  /** Order by `sourceUrl` in descending order. */
  SourceUrlDesc = 'sourceUrl_DESC',
  /** Order by `startDate` in ascending order. */
  StartDateAsc = 'startDate_ASC',
  /** Order by `startDate` in descending order. */
  StartDateDesc = 'startDate_DESC',
  /** Order by `subtitle` in ascending order. */
  SubtitleAsc = 'subtitle_ASC',
  /** Order by `subtitle` in descending order. */
  SubtitleDesc = 'subtitle_DESC',
  /** Order by `subtitlesLanguage` in ascending order. */
  SubtitlesLanguageAsc = 'subtitlesLanguage_ASC',
  /** Order by `subtitlesLanguage` in descending order. */
  SubtitlesLanguageDesc = 'subtitlesLanguage_DESC',
  /** Order by `title` in ascending order. */
  TitleAsc = 'title_ASC',
  /** Order by `title` in descending order. */
  TitleDesc = 'title_DESC',
  /** Order by `trailer` in ascending order. */
  TrailerAsc = 'trailer_ASC',
  /** Order by `trailer` in descending order. */
  TrailerDesc = 'trailer_DESC',
  /** Order by `typeOfFormat` in ascending order. */
  TypeOfFormatAsc = 'typeOfFormat_ASC',
  /** Order by `typeOfFormat` in descending order. */
  TypeOfFormatDesc = 'typeOfFormat_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `vimeoHlsUrl` in ascending order. */
  VimeoHlsUrlAsc = 'vimeoHlsUrl_ASC',
  /** Order by `vimeoHlsUrl` in descending order. */
  VimeoHlsUrlDesc = 'vimeoHlsUrl_DESC',
  /** Order by `voiceOverLanguage` in ascending order. */
  VoiceOverLanguageAsc = 'voiceOverLanguage_ASC',
  /** Order by `voiceOverLanguage` in descending order. */
  VoiceOverLanguageDesc = 'voiceOverLanguage_DESC'
}

export interface IVodMenu extends IContent, IElement, IWatchMenu {
  __typename?: 'VODMenu';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IVodMenuAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVodMenuChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVodMenuDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVodMenuNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodMenuParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodMenuUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVodMenuUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `VODMenu`. */
export interface IVodMenuConnection {
  __typename?: 'VODMenuConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IVodMenuEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IVodMenu>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `VODMenu`. */
export interface IVodMenuEdge {
  __typename?: 'VODMenuEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IVodMenu>;
}

/** A filter input for the type `VODMenu`. */
export interface IVodMenuFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IVodMenuFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IVodMenuFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IVodMenuFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `VODMenu`. */
export enum IVodMenuOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IValidationElement extends IElement {
  __typename?: 'ValidationElement';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  /** Regex validation */
  regex?: Maybe<Scalars['String']>;
}


export interface IValidationElementLabelArgs {
  culture?: InputMaybe<Scalars['String']>;
}

export interface IVotingFolder extends IContent, IElement {
  __typename?: 'VotingFolder';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IVotingFolderAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVotingFolderChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVotingFolderDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVotingFolderNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVotingFolderParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVotingFolderUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVotingFolderUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `VotingFolder`. */
export interface IVotingFolderConnection {
  __typename?: 'VotingFolderConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IVotingFolderEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IVotingFolder>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `VotingFolder`. */
export interface IVotingFolderEdge {
  __typename?: 'VotingFolderEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IVotingFolder>;
}

/** A filter input for the type `VotingFolder`. */
export interface IVotingFolderFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IVotingFolderFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IVotingFolderFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IVotingFolderFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `VotingFolder`. */
export enum IVotingFolderOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IVotingRecord extends IContent, IElement {
  __typename?: 'VotingRecord';
  /** The ancestors. */
  ancestors: IContentConnection;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  email?: Maybe<Scalars['String']>;
  /** The unique identifier. */
  id: Scalars['ID'];
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
  votedAt?: Maybe<Scalars['DateTime']>;
  votedCategory?: Maybe<Scalars['String']>;
  votedFor?: Maybe<Scalars['String']>;
}


export interface IVotingRecordAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVotingRecordChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVotingRecordDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IVotingRecordNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVotingRecordParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVotingRecordUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IVotingRecordUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `VotingRecord`. */
export interface IVotingRecordConnection {
  __typename?: 'VotingRecordConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IVotingRecordEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IVotingRecord>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `VotingRecord`. */
export interface IVotingRecordEdge {
  __typename?: 'VotingRecordEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IVotingRecord>;
}

/** A filter input for the type `VotingRecord`. */
export interface IVotingRecordFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IVotingRecordFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IVotingRecordFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IVotingRecordFilterInput>>>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  email?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  email_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  email_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  email_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  email_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  votedAt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  votedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  votedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  votedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  votedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  votedCategory?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  votedCategory_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  votedCategory_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  votedCategory_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  votedCategory_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  votedFor?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  votedFor_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  votedFor_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  votedFor_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  votedFor_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `VotingRecord`. */
export enum IVotingRecordOrderByInput {
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `email` in ascending order. */
  EmailAsc = 'email_ASC',
  /** Order by `email` in descending order. */
  EmailDesc = 'email_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC',
  /** Order by `votedAt` in ascending order. */
  VotedAtAsc = 'votedAt_ASC',
  /** Order by `votedAt` in descending order. */
  VotedAtDesc = 'votedAt_DESC',
  /** Order by `votedCategory` in ascending order. */
  VotedCategoryAsc = 'votedCategory_ASC',
  /** Order by `votedCategory` in descending order. */
  VotedCategoryDesc = 'votedCategory_DESC',
  /** Order by `votedFor` in ascending order. */
  VotedForAsc = 'votedFor_ASC',
  /** Order by `votedFor` in descending order. */
  VotedForDesc = 'votedFor_DESC'
}

export interface IWatchCateg extends IContent, IElement {
  __typename?: 'WatchCateg';
  /** The ancestors. */
  ancestors: IContentConnection;
  backgroundColor?: Maybe<Scalars['String']>;
  /** The children. */
  children: IContentConnection;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  /** The create date. */
  createDate: Scalars['DateTime'];
  /** The descendants. */
  descendants: IContentConnection;
  /** The unique identifier. */
  id: Scalars['ID'];
  isExpand?: Maybe<Scalars['Boolean']>;
  /** The level. */
  level: Scalars['Int'];
  /** The name. */
  name?: Maybe<Scalars['String']>;
  /** The parent Content, can be null if Content is at root. */
  parent?: Maybe<IContent>;
  /** The sort order. */
  sortOrder: Scalars['Int'];
  thumbnail?: Maybe<IMediaWithCrops>;
  /** The update date. */
  updateDate?: Maybe<Scalars['DateTime']>;
  /** The url. */
  url?: Maybe<Scalars['String']>;
}


export interface IWatchCategAncestorsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IWatchCategChildrenArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IWatchCategDescendantsArgs {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>>>;
  where?: InputMaybe<IContentFilterInput>;
}


export interface IWatchCategNameArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IWatchCategParentArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IWatchCategUpdateDateArgs {
  culture?: InputMaybe<Scalars['String']>;
}


export interface IWatchCategUrlArgs {
  culture?: InputMaybe<Scalars['String']>;
}

/** A connection from an object to a list of objects of type `WatchCateg`. */
export interface IWatchCategConnection {
  __typename?: 'WatchCategConnection';
  /** A list of all of the edges returned in the connection. */
  edges: Array<Maybe<IWatchCategEdge>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items: Array<Maybe<IWatchCateg>>;
  /** Information to aid in pagination. */
  pageInfo: IPageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']>;
}

/** An edge in a connection from an object to another object of type `WatchCateg`. */
export interface IWatchCategEdge {
  __typename?: 'WatchCategEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IWatchCateg>;
}

/** A filter input for the type `WatchCateg`. */
export interface IWatchCategFilterInput {
  /** All of the filters much match */
  AND?: InputMaybe<Array<InputMaybe<IWatchCategFilterInput>>>;
  /** None of the filters much match */
  NOT?: InputMaybe<Array<InputMaybe<IWatchCategFilterInput>>>;
  /** Some of the filters much match */
  OR?: InputMaybe<Array<InputMaybe<IWatchCategFilterInput>>>;
  /** Field must equal value. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  backgroundColor_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  backgroundColor_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  backgroundColor_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  contentTypeAlias_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  contentTypeAlias_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  contentTypeAlias_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  contentTypeAlias_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  createDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  createDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  createDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  createDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  createDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  id?: InputMaybe<Scalars['ID']>;
  /** Field must match any of the values. */
  id_any?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Field must equal value. */
  isExpand?: InputMaybe<Scalars['Boolean']>;
  /** Field must equal value. */
  level?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  level_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  level_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  level_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  level_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  level_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  name?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  name_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  /** Field must equal value. */
  parent?: InputMaybe<IContentFilterInput>;
  /** Field must equal value. */
  sortOrder?: InputMaybe<Scalars['Int']>;
  /** Field must match any of the values. */
  sortOrder_any?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Field must be greater than the value. */
  sortOrder_gt?: InputMaybe<Scalars['Int']>;
  /** Field must be greater than or equal the value. */
  sortOrder_gte?: InputMaybe<Scalars['Int']>;
  /** Field must be less than the value. */
  sortOrder_lt?: InputMaybe<Scalars['Int']>;
  /** Field must be less than or equal the value. */
  sortOrder_lte?: InputMaybe<Scalars['Int']>;
  /** Field must equal value. */
  updateDate?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than the value. */
  updateDate_gt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be greater than or equal the value. */
  updateDate_gte?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than the value. */
  updateDate_lt?: InputMaybe<Scalars['DateTime']>;
  /** Field must be less than or equal the value. */
  updateDate_lte?: InputMaybe<Scalars['DateTime']>;
  /** Field must equal value. */
  url?: InputMaybe<Scalars['String']>;
  /** Field must match any of the values. */
  url_any?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Field must contain the value. */
  url_contains?: InputMaybe<Scalars['String']>;
  /** Field must end with the value. */
  url_ends_with?: InputMaybe<Scalars['String']>;
  /** Field must start with the value. */
  url_starts_with?: InputMaybe<Scalars['String']>;
}

/** An order input for the type `WatchCateg`. */
export enum IWatchCategOrderByInput {
  /** Order by `backgroundColor` in ascending order. */
  BackgroundColorAsc = 'backgroundColor_ASC',
  /** Order by `backgroundColor` in descending order. */
  BackgroundColorDesc = 'backgroundColor_DESC',
  /** Order by `contentTypeAlias` in ascending order. */
  ContentTypeAliasAsc = 'contentTypeAlias_ASC',
  /** Order by `contentTypeAlias` in descending order. */
  ContentTypeAliasDesc = 'contentTypeAlias_DESC',
  /** Order by `createDate` in ascending order. */
  CreateDateAsc = 'createDate_ASC',
  /** Order by `createDate` in descending order. */
  CreateDateDesc = 'createDate_DESC',
  /** Order by `id` in ascending order. */
  IdAsc = 'id_ASC',
  /** Order by `id` in descending order. */
  IdDesc = 'id_DESC',
  /** Order by `isExpand` in ascending order. */
  IsExpandAsc = 'isExpand_ASC',
  /** Order by `isExpand` in descending order. */
  IsExpandDesc = 'isExpand_DESC',
  /** Order by `level` in ascending order. */
  LevelAsc = 'level_ASC',
  /** Order by `level` in descending order. */
  LevelDesc = 'level_DESC',
  /** Order by `name` in ascending order. */
  NameAsc = 'name_ASC',
  /** Order by `name` in descending order. */
  NameDesc = 'name_DESC',
  /** Order by `parent` in ascending order. */
  ParentAsc = 'parent_ASC',
  /** Order by `parent` in descending order. */
  ParentDesc = 'parent_DESC',
  /** Order by `path` in ascending order. */
  PathAsc = 'path_ASC',
  /** Order by `path` in descending order. */
  PathDesc = 'path_DESC',
  /** Order by `sortOrder` in ascending order. */
  SortOrderAsc = 'sortOrder_ASC',
  /** Order by `sortOrder` in descending order. */
  SortOrderDesc = 'sortOrder_DESC',
  /** Order by `updateDate` in ascending order. */
  UpdateDateAsc = 'updateDate_ASC',
  /** Order by `updateDate` in descending order. */
  UpdateDateDesc = 'updateDate_DESC',
  /** Order by `url` in ascending order. */
  UrlAsc = 'url_ASC',
  /** Order by `url` in descending order. */
  UrlDesc = 'url_DESC'
}

export interface IWatchMenu {
  /** The Content Type alias */
  contentTypeAlias: Scalars['String'];
}

export interface IWatchedContent extends IElement {
  __typename?: 'WatchedContent';
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  linkedContent?: Maybe<IContent>;
  timestamp?: Maybe<Scalars['Int']>;
}

/** Text content with formatting */
export interface IWysiwyg extends IElement {
  __typename?: 'Wysiwyg';
  body?: Maybe<Scalars['HTML']>;
  /** The Content Type alias. */
  contentTypeAlias: Scalars['String'];
  title?: Maybe<Scalars['String']>;
}

export type IContentFragment_ArtistService_Fragment = (
  { __typename: 'ArtistService' }
  & Pick<IArtistService, 'name' | 'url'>
);

export type IContentFragment_ArtistServiceFolder_Fragment = (
  { __typename: 'ArtistServiceFolder' }
  & Pick<IArtistServiceFolder, 'name' | 'url'>
);

export type IContentFragment_ArtistServicesPage_Fragment = (
  { __typename: 'ArtistServicesPage' }
  & Pick<IArtistServicesPage, 'name' | 'url'>
);

export type IContentFragment_AwardCategoryPage_Fragment = (
  { __typename: 'AwardCategoryPage' }
  & Pick<IAwardCategoryPage, 'name' | 'url'>
);

export type IContentFragment_AwardsArtist_Fragment = (
  { __typename: 'AwardsArtist' }
  & Pick<IAwardsArtist, 'name' | 'url'>
);

export type IContentFragment_AwardsCategoryMenu_Fragment = (
  { __typename: 'AwardsCategoryMenu' }
  & Pick<IAwardsCategoryMenu, 'name' | 'url'>
);

export type IContentFragment_AwardsCategoryMenuDev_Fragment = (
  { __typename: 'AwardsCategoryMenuDev' }
  & Pick<IAwardsCategoryMenuDev, 'name' | 'url'>
);

export type IContentFragment_AwardsCategoryMenuFolder_Fragment = (
  { __typename: 'AwardsCategoryMenuFolder' }
  & Pick<IAwardsCategoryMenuFolder, 'name' | 'url'>
);

export type IContentFragment_AwardsCategoryMenuFolderDev_Fragment = (
  { __typename: 'AwardsCategoryMenuFolderDev' }
  & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url'>
);

export type IContentFragment_AwardsHomepage_Fragment = (
  { __typename: 'AwardsHomepage' }
  & Pick<IAwardsHomepage, 'name' | 'url'>
);

export type IContentFragment_CmsPage_Fragment = (
  { __typename: 'CMSPage' }
  & Pick<ICmsPage, 'name' | 'url'>
);

export type IContentFragment_CategBgColor_Fragment = (
  { __typename: 'CategBgColor' }
  & Pick<ICategBgColor, 'name' | 'url'>
);

export type IContentFragment_CategoryPage_Fragment = (
  { __typename: 'CategoryPage' }
  & Pick<ICategoryPage, 'name' | 'url'>
  & ICategoryPageFragmentFragment
);

export type IContentFragment_Channel_Fragment = (
  { __typename: 'Channel' }
  & Pick<IChannel, 'name' | 'url'>
);

export type IContentFragment_ChannelFolder_Fragment = (
  { __typename: 'ChannelFolder' }
  & Pick<IChannelFolder, 'name' | 'url'>
);

export type IContentFragment_ChoiceNugget_Fragment = (
  { __typename: 'ChoiceNugget' }
  & Pick<IChoiceNugget, 'name' | 'url'>
);

export type IContentFragment_Collection_Fragment = (
  { __typename: 'Collection' }
  & Pick<ICollection, 'name' | 'url'>
  & IContentItemsFragment_Collection_Fragment
  & ICollectionFragmentFragment
);

export type IContentFragment_ContentEditorFolder_Fragment = (
  { __typename: 'ContentEditorFolder' }
  & Pick<IContentEditorFolder, 'name' | 'url'>
);

export type IContentFragment_ContentTag_Fragment = (
  { __typename: 'ContentTag' }
  & Pick<IContentTag, 'name' | 'url'>
);

export type IContentFragment_ContentTags_Fragment = (
  { __typename: 'ContentTags' }
  & Pick<IContentTags, 'name' | 'url'>
);

export type IContentFragment_ContentTagsCateg_Fragment = (
  { __typename: 'ContentTagsCateg' }
  & Pick<IContentTagsCateg, 'name' | 'url'>
);

export type IContentFragment_Course_Fragment = (
  { __typename: 'Course' }
  & Pick<ICourse, 'name' | 'url'>
);

export type IContentFragment_CourseCategoriesFolder_Fragment = (
  { __typename: 'CourseCategoriesFolder' }
  & Pick<ICourseCategoriesFolder, 'name' | 'url'>
);

export type IContentFragment_CourseCategory_Fragment = (
  { __typename: 'CourseCategory' }
  & Pick<ICourseCategory, 'name' | 'url'>
);

export type IContentFragment_CourseExam_Fragment = (
  { __typename: 'CourseExam' }
  & Pick<ICourseExam, 'name' | 'url'>
);

export type IContentFragment_CourseShare_Fragment = (
  { __typename: 'CourseShare' }
  & Pick<ICourseShare, 'name' | 'url'>
);

export type IContentFragment_CourseStatus_Fragment = (
  { __typename: 'CourseStatus' }
  & Pick<ICourseStatus, 'name' | 'url'>
);

export type IContentFragment_CourseTestProgression_Fragment = (
  { __typename: 'CourseTestProgression' }
  & Pick<ICourseTestProgression, 'name' | 'url'>
);

export type IContentFragment_CourseUnit_Fragment = (
  { __typename: 'CourseUnit' }
  & Pick<ICourseUnit, 'name' | 'url'>
);

export type IContentFragment_Discovery_Fragment = (
  { __typename: 'Discovery' }
  & Pick<IDiscovery, 'name' | 'url'>
);

export type IContentFragment_DiscoverySlide1_Fragment = (
  { __typename: 'DiscoverySlide1' }
  & Pick<IDiscoverySlide1, 'name' | 'url'>
);

export type IContentFragment_EntrepreunarialHub_Fragment = (
  { __typename: 'EntrepreunarialHub' }
  & Pick<IEntrepreunarialHub, 'name' | 'url'>
);

export type IContentFragment_FormFolder_Fragment = (
  { __typename: 'FormFolder' }
  & Pick<IFormFolder, 'name' | 'url'>
);

export type IContentFragment_FormPage_Fragment = (
  { __typename: 'FormPage' }
  & Pick<IFormPage, 'name' | 'url'>
);

export type IContentFragment_GapfillNugget_Fragment = (
  { __typename: 'GapfillNugget' }
  & Pick<IGapfillNugget, 'name' | 'url'>
);

export type IContentFragment_HelpdeskCateg_Fragment = (
  { __typename: 'HelpdeskCateg' }
  & Pick<IHelpdeskCateg, 'name' | 'url'>
);

export type IContentFragment_HelpdeskFolder_Fragment = (
  { __typename: 'HelpdeskFolder' }
  & Pick<IHelpdeskFolder, 'name' | 'url'>
);

export type IContentFragment_HelpdeskPage_Fragment = (
  { __typename: 'HelpdeskPage' }
  & Pick<IHelpdeskPage, 'name' | 'url'>
);

export type IContentFragment_HomePage_Fragment = (
  { __typename: 'HomePage' }
  & Pick<IHomePage, 'name' | 'url'>
);

export type IContentFragment_JobBoardPage_Fragment = (
  { __typename: 'JobBoardPage' }
  & Pick<IJobBoardPage, 'name' | 'url'>
);

export type IContentFragment_JobHub_Fragment = (
  { __typename: 'JobHub' }
  & Pick<IJobHub, 'name' | 'url'>
);

export type IContentFragment_JobHubsFolder_Fragment = (
  { __typename: 'JobHubsFolder' }
  & Pick<IJobHubsFolder, 'name' | 'url'>
);

export type IContentFragment_JobProgress_Fragment = (
  { __typename: 'JobProgress' }
  & Pick<IJobProgress, 'name' | 'url'>
);

export type IContentFragment_JobShare_Fragment = (
  { __typename: 'JobShare' }
  & Pick<IJobShare, 'name' | 'url'>
);

export type IContentFragment_JobTraining_Fragment = (
  { __typename: 'JobTraining' }
  & Pick<IJobTraining, 'name' | 'url'>
);

export type IContentFragment_JobTrainingFolder_Fragment = (
  { __typename: 'JobTrainingFolder' }
  & Pick<IJobTrainingFolder, 'name' | 'url'>
);

export type IContentFragment_JobVacanciesFolder_Fragment = (
  { __typename: 'JobVacanciesFolder' }
  & Pick<IJobVacanciesFolder, 'name' | 'url'>
);

export type IContentFragment_JobVacancy_Fragment = (
  { __typename: 'JobVacancy' }
  & Pick<IJobVacancy, 'name' | 'url'>
);

export type IContentFragment_LandingPage_Fragment = (
  { __typename: 'LandingPage' }
  & Pick<ILandingPage, 'name' | 'url'>
);

export type IContentFragment_LearnMenu_Fragment = (
  { __typename: 'LearnMenu' }
  & Pick<ILearnMenu, 'name' | 'url'>
);

export type IContentFragment_LegalsFolder_Fragment = (
  { __typename: 'LegalsFolder' }
  & Pick<ILegalsFolder, 'name' | 'url'>
);

export type IContentFragment_ListenCateg_Fragment = (
  { __typename: 'ListenCateg' }
  & Pick<IListenCateg, 'name' | 'url'>
);

export type IContentFragment_LiveEvent_Fragment = (
  { __typename: 'LiveEvent' }
  & Pick<ILiveEvent, 'name' | 'url'>
  & IContentItemsFragment_LiveEvent_Fragment
  & ILiveEventFragmentFragment
);

export type IContentFragment_LiveEventsMenu_Fragment = (
  { __typename: 'LiveEventsMenu' }
  & Pick<ILiveEventsMenu, 'name' | 'url'>
);

export type IContentFragment_LiveEventsPage_Fragment = (
  { __typename: 'LiveEventsPage' }
  & Pick<ILiveEventsPage, 'name' | 'url'>
  & ILiveEventsPageFragmentFragment
);

export type IContentFragment_LiveTvPage_Fragment = (
  { __typename: 'LiveTVPage' }
  & Pick<ILiveTvPage, 'name' | 'url'>
  & ILiveTvPageFragmentFragment
);

export type IContentFragment_MemberContentTypesLink_Fragment = (
  { __typename: 'MemberContentTypesLink' }
  & Pick<IMemberContentTypesLink, 'name' | 'url'>
);

export type IContentFragment_MemberDatas_Fragment = (
  { __typename: 'MemberDatas' }
  & Pick<IMemberDatas, 'name' | 'url'>
);

export type IContentFragment_MemberDownloaded_Fragment = (
  { __typename: 'MemberDownloaded' }
  & Pick<IMemberDownloaded, 'name' | 'url'>
);

export type IContentFragment_MemberMessage_Fragment = (
  { __typename: 'MemberMessage' }
  & Pick<IMemberMessage, 'name' | 'url'>
);

export type IContentFragment_MemberNotify_Fragment = (
  { __typename: 'MemberNotify' }
  & Pick<IMemberNotify, 'name' | 'url'>
);

export type IContentFragment_MemberOpportunity_Fragment = (
  { __typename: 'MemberOpportunity' }
  & Pick<IMemberOpportunity, 'name' | 'url'>
);

export type IContentFragment_MemberSaved_Fragment = (
  { __typename: 'MemberSaved' }
  & Pick<IMemberSaved, 'name' | 'url'>
);

export type IContentFragment_MemberSearch_Fragment = (
  { __typename: 'MemberSearch' }
  & Pick<IMemberSearch, 'name' | 'url'>
);

export type IContentFragment_MemberWatched_Fragment = (
  { __typename: 'MemberWatched' }
  & Pick<IMemberWatched, 'name' | 'url'>
);

export type IContentFragment_MembersDatas_Fragment = (
  { __typename: 'MembersDatas' }
  & Pick<IMembersDatas, 'name' | 'url'>
);

export type IContentFragment_MiniSitesFolder_Fragment = (
  { __typename: 'MiniSitesFolder' }
  & Pick<IMiniSitesFolder, 'name' | 'url'>
);

export type IContentFragment_NavMessage_Fragment = (
  { __typename: 'NavMessage' }
  & Pick<INavMessage, 'name' | 'url'>
);

export type IContentFragment_NavigationMessagesFolder_Fragment = (
  { __typename: 'NavigationMessagesFolder' }
  & Pick<INavigationMessagesFolder, 'name' | 'url'>
);

export type IContentFragment_NetlifyDeploy_Fragment = (
  { __typename: 'NetlifyDeploy' }
  & Pick<INetlifyDeploy, 'name' | 'url'>
);

export type IContentFragment_News_Fragment = (
  { __typename: 'News' }
  & Pick<INews, 'name' | 'url'>
);

export type IContentFragment_NewsCateg_Fragment = (
  { __typename: 'NewsCateg' }
  & Pick<INewsCateg, 'name' | 'url'>
);

export type IContentFragment_NewsFolder_Fragment = (
  { __typename: 'NewsFolder' }
  & Pick<INewsFolder, 'name' | 'url'>
);

export type IContentFragment_NewsPage_Fragment = (
  { __typename: 'NewsPage' }
  & Pick<INewsPage, 'name' | 'url'>
);

export type IContentFragment_ObtainedJob_Fragment = (
  { __typename: 'ObtainedJob' }
  & Pick<IObtainedJob, 'name' | 'url'>
);

export type IContentFragment_Opportunity_Fragment = (
  { __typename: 'Opportunity' }
  & Pick<IOpportunity, 'name' | 'url'>
);

export type IContentFragment_OpportunityCenter_Fragment = (
  { __typename: 'OpportunityCenter' }
  & Pick<IOpportunityCenter, 'name' | 'url'>
);

export type IContentFragment_OpportunityFolder_Fragment = (
  { __typename: 'OpportunityFolder' }
  & Pick<IOpportunityFolder, 'name' | 'url'>
);

export type IContentFragment_Partner_Fragment = (
  { __typename: 'Partner' }
  & Pick<IPartner, 'name' | 'url'>
);

export type IContentFragment_Partners_Fragment = (
  { __typename: 'Partners' }
  & Pick<IPartners, 'name' | 'url'>
);

export type IContentFragment_PartnersPage_Fragment = (
  { __typename: 'PartnersPage' }
  & Pick<IPartnersPage, 'name' | 'url'>
);

export type IContentFragment_Paywall_Fragment = (
  { __typename: 'Paywall' }
  & Pick<IPaywall, 'name' | 'url'>
);

export type IContentFragment_PaywallFolder_Fragment = (
  { __typename: 'PaywallFolder' }
  & Pick<IPaywallFolder, 'name' | 'url'>
);

export type IContentFragment_PersonalityPages_Fragment = (
  { __typename: 'PersonalityPages' }
  & Pick<IPersonalityPages, 'name' | 'url'>
);

export type IContentFragment_PersonalityQuiz_Fragment = (
  { __typename: 'PersonalityQuiz' }
  & Pick<IPersonalityQuiz, 'name' | 'url'>
);

export type IContentFragment_PersonalityQuiz1_Fragment = (
  { __typename: 'PersonalityQuiz1' }
  & Pick<IPersonalityQuiz1, 'name' | 'url'>
);

export type IContentFragment_PersonalityType_Fragment = (
  { __typename: 'PersonalityType' }
  & Pick<IPersonalityType, 'name' | 'url'>
);

export type IContentFragment_Playlist_Fragment = (
  { __typename: 'Playlist' }
  & Pick<IPlaylist, 'name' | 'url'>
  & IContentItemsFragment_Playlist_Fragment
  & IPlaylistFragmentFragment
);

export type IContentFragment_PlaylistRadioMenu_Fragment = (
  { __typename: 'PlaylistRadioMenu' }
  & Pick<IPlaylistRadioMenu, 'name' | 'url'>
);

export type IContentFragment_Podcast_Fragment = (
  { __typename: 'Podcast' }
  & Pick<IPodcast, 'name' | 'url'>
  & IContentItemsFragment_Podcast_Fragment
  & IPodcastFragmentFragment
);

export type IContentFragment_PodcastCateg_Fragment = (
  { __typename: 'PodcastCateg' }
  & Pick<IPodcastCateg, 'name' | 'url'>
);

export type IContentFragment_PodcastItem_Fragment = (
  { __typename: 'PodcastItem' }
  & Pick<IPodcastItem, 'name' | 'url'>
  & IPodcastItemFragmentFragment
);

export type IContentFragment_PodcastMenu_Fragment = (
  { __typename: 'PodcastMenu' }
  & Pick<IPodcastMenu, 'name' | 'url'>
);

export type IContentFragment_PromoCode_Fragment = (
  { __typename: 'PromoCode' }
  & Pick<IPromoCode, 'name' | 'url'>
);

export type IContentFragment_PromoCodeFolder_Fragment = (
  { __typename: 'PromoCodeFolder' }
  & Pick<IPromoCodeFolder, 'name' | 'url'>
);

export type IContentFragment_QuizPage_Fragment = (
  { __typename: 'QuizPage' }
  & Pick<IQuizPage, 'name' | 'url'>
);

export type IContentFragment_QuizzSurvey_Fragment = (
  { __typename: 'QuizzSurvey' }
  & Pick<IQuizzSurvey, 'name' | 'url'>
);

export type IContentFragment_QuizzSurveyCategory_Fragment = (
  { __typename: 'QuizzSurveyCategory' }
  & Pick<IQuizzSurveyCategory, 'name' | 'url'>
);

export type IContentFragment_QuizzSurveyCollection_Fragment = (
  { __typename: 'QuizzSurveyCollection' }
  & Pick<IQuizzSurveyCollection, 'name' | 'url'>
);

export type IContentFragment_Radio_Fragment = (
  { __typename: 'Radio' }
  & Pick<IRadio, 'name' | 'url'>
  & IContentItemsFragment_Radio_Fragment
  & IRadioFragmentFragment
);

export type IContentFragment_RadioCateg_Fragment = (
  { __typename: 'RadioCateg' }
  & Pick<IRadioCateg, 'name' | 'url'>
);

export type IContentFragment_Region_Fragment = (
  { __typename: 'Region' }
  & Pick<IRegion, 'name' | 'url'>
);

export type IContentFragment_SectionPage_Fragment = (
  { __typename: 'SectionPage' }
  & Pick<ISectionPage, 'name' | 'url'>
);

export type IContentFragment_Settings_Fragment = (
  { __typename: 'Settings' }
  & Pick<ISettings, 'name' | 'url'>
);

export type IContentFragment_Space_Fragment = (
  { __typename: 'Space' }
  & Pick<ISpace, 'name' | 'url'>
);

export type IContentFragment_Subscription_Fragment = (
  { __typename: 'Subscription' }
  & Pick<ISubscription, 'name' | 'url'>
);

export type IContentFragment_SubscriptionData_Fragment = (
  { __typename: 'SubscriptionData' }
  & Pick<ISubscriptionData, 'name' | 'url'>
);

export type IContentFragment_SubscriptionDataFolder_Fragment = (
  { __typename: 'SubscriptionDataFolder' }
  & Pick<ISubscriptionDataFolder, 'name' | 'url'>
);

export type IContentFragment_SubscriptionsFolder_Fragment = (
  { __typename: 'SubscriptionsFolder' }
  & Pick<ISubscriptionsFolder, 'name' | 'url'>
);

export type IContentFragment_SumaryNugget_Fragment = (
  { __typename: 'SumaryNugget' }
  & Pick<ISumaryNugget, 'name' | 'url'>
);

export type IContentFragment_SurveyQuizzFolder_Fragment = (
  { __typename: 'SurveyQuizzFolder' }
  & Pick<ISurveyQuizzFolder, 'name' | 'url'>
);

export type IContentFragment_TextPage_Fragment = (
  { __typename: 'TextPage' }
  & Pick<ITextPage, 'name' | 'url'>
);

export type IContentFragment_ThankYouPage_Fragment = (
  { __typename: 'ThankYouPage' }
  & Pick<IThankYouPage, 'name' | 'url'>
);

export type IContentFragment_TranslationContext_Fragment = (
  { __typename: 'TranslationContext' }
  & Pick<ITranslationContext, 'name' | 'url'>
);

export type IContentFragment_TranslationFolder_Fragment = (
  { __typename: 'TranslationFolder' }
  & Pick<ITranslationFolder, 'name' | 'url'>
);

export type IContentFragment_TranslationItem_Fragment = (
  { __typename: 'TranslationItem' }
  & Pick<ITranslationItem, 'name' | 'url'>
);

export type IContentFragment_UmbracoTest_Fragment = (
  { __typename: 'UmbracoTest' }
  & Pick<IUmbracoTest, 'name' | 'url'>
);

export type IContentFragment_UnitNuggetAnswer_Fragment = (
  { __typename: 'UnitNuggetAnswer' }
  & Pick<IUnitNuggetAnswer, 'name' | 'url'>
);

export type IContentFragment_UnitNuggetGapFillAnswer_Fragment = (
  { __typename: 'UnitNuggetGapFillAnswer' }
  & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url'>
);

export type IContentFragment_UnitProgression_Fragment = (
  { __typename: 'UnitProgression' }
  & Pick<IUnitProgression, 'name' | 'url'>
);

export type IContentFragment_VodItem_Fragment = (
  { __typename: 'VODItem' }
  & Pick<IVodItem, 'name' | 'url'>
  & IContentItemsFragment_VodItem_Fragment
  & IVodItemFragmentFragment
);

export type IContentFragment_VodMenu_Fragment = (
  { __typename: 'VODMenu' }
  & Pick<IVodMenu, 'name' | 'url'>
);

export type IContentFragment_VotingFolder_Fragment = (
  { __typename: 'VotingFolder' }
  & Pick<IVotingFolder, 'name' | 'url'>
);

export type IContentFragment_VotingRecord_Fragment = (
  { __typename: 'VotingRecord' }
  & Pick<IVotingRecord, 'name' | 'url'>
);

export type IContentFragment_WatchCateg_Fragment = (
  { __typename: 'WatchCateg' }
  & Pick<IWatchCateg, 'name' | 'url'>
);

export type IContentFragmentFragment = IContentFragment_ArtistService_Fragment | IContentFragment_ArtistServiceFolder_Fragment | IContentFragment_ArtistServicesPage_Fragment | IContentFragment_AwardCategoryPage_Fragment | IContentFragment_AwardsArtist_Fragment | IContentFragment_AwardsCategoryMenu_Fragment | IContentFragment_AwardsCategoryMenuDev_Fragment | IContentFragment_AwardsCategoryMenuFolder_Fragment | IContentFragment_AwardsCategoryMenuFolderDev_Fragment | IContentFragment_AwardsHomepage_Fragment | IContentFragment_CmsPage_Fragment | IContentFragment_CategBgColor_Fragment | IContentFragment_CategoryPage_Fragment | IContentFragment_Channel_Fragment | IContentFragment_ChannelFolder_Fragment | IContentFragment_ChoiceNugget_Fragment | IContentFragment_Collection_Fragment | IContentFragment_ContentEditorFolder_Fragment | IContentFragment_ContentTag_Fragment | IContentFragment_ContentTags_Fragment | IContentFragment_ContentTagsCateg_Fragment | IContentFragment_Course_Fragment | IContentFragment_CourseCategoriesFolder_Fragment | IContentFragment_CourseCategory_Fragment | IContentFragment_CourseExam_Fragment | IContentFragment_CourseShare_Fragment | IContentFragment_CourseStatus_Fragment | IContentFragment_CourseTestProgression_Fragment | IContentFragment_CourseUnit_Fragment | IContentFragment_Discovery_Fragment | IContentFragment_DiscoverySlide1_Fragment | IContentFragment_EntrepreunarialHub_Fragment | IContentFragment_FormFolder_Fragment | IContentFragment_FormPage_Fragment | IContentFragment_GapfillNugget_Fragment | IContentFragment_HelpdeskCateg_Fragment | IContentFragment_HelpdeskFolder_Fragment | IContentFragment_HelpdeskPage_Fragment | IContentFragment_HomePage_Fragment | IContentFragment_JobBoardPage_Fragment | IContentFragment_JobHub_Fragment | IContentFragment_JobHubsFolder_Fragment | IContentFragment_JobProgress_Fragment | IContentFragment_JobShare_Fragment | IContentFragment_JobTraining_Fragment | IContentFragment_JobTrainingFolder_Fragment | IContentFragment_JobVacanciesFolder_Fragment | IContentFragment_JobVacancy_Fragment | IContentFragment_LandingPage_Fragment | IContentFragment_LearnMenu_Fragment | IContentFragment_LegalsFolder_Fragment | IContentFragment_ListenCateg_Fragment | IContentFragment_LiveEvent_Fragment | IContentFragment_LiveEventsMenu_Fragment | IContentFragment_LiveEventsPage_Fragment | IContentFragment_LiveTvPage_Fragment | IContentFragment_MemberContentTypesLink_Fragment | IContentFragment_MemberDatas_Fragment | IContentFragment_MemberDownloaded_Fragment | IContentFragment_MemberMessage_Fragment | IContentFragment_MemberNotify_Fragment | IContentFragment_MemberOpportunity_Fragment | IContentFragment_MemberSaved_Fragment | IContentFragment_MemberSearch_Fragment | IContentFragment_MemberWatched_Fragment | IContentFragment_MembersDatas_Fragment | IContentFragment_MiniSitesFolder_Fragment | IContentFragment_NavMessage_Fragment | IContentFragment_NavigationMessagesFolder_Fragment | IContentFragment_NetlifyDeploy_Fragment | IContentFragment_News_Fragment | IContentFragment_NewsCateg_Fragment | IContentFragment_NewsFolder_Fragment | IContentFragment_NewsPage_Fragment | IContentFragment_ObtainedJob_Fragment | IContentFragment_Opportunity_Fragment | IContentFragment_OpportunityCenter_Fragment | IContentFragment_OpportunityFolder_Fragment | IContentFragment_Partner_Fragment | IContentFragment_Partners_Fragment | IContentFragment_PartnersPage_Fragment | IContentFragment_Paywall_Fragment | IContentFragment_PaywallFolder_Fragment | IContentFragment_PersonalityPages_Fragment | IContentFragment_PersonalityQuiz_Fragment | IContentFragment_PersonalityQuiz1_Fragment | IContentFragment_PersonalityType_Fragment | IContentFragment_Playlist_Fragment | IContentFragment_PlaylistRadioMenu_Fragment | IContentFragment_Podcast_Fragment | IContentFragment_PodcastCateg_Fragment | IContentFragment_PodcastItem_Fragment | IContentFragment_PodcastMenu_Fragment | IContentFragment_PromoCode_Fragment | IContentFragment_PromoCodeFolder_Fragment | IContentFragment_QuizPage_Fragment | IContentFragment_QuizzSurvey_Fragment | IContentFragment_QuizzSurveyCategory_Fragment | IContentFragment_QuizzSurveyCollection_Fragment | IContentFragment_Radio_Fragment | IContentFragment_RadioCateg_Fragment | IContentFragment_Region_Fragment | IContentFragment_SectionPage_Fragment | IContentFragment_Settings_Fragment | IContentFragment_Space_Fragment | IContentFragment_Subscription_Fragment | IContentFragment_SubscriptionData_Fragment | IContentFragment_SubscriptionDataFolder_Fragment | IContentFragment_SubscriptionsFolder_Fragment | IContentFragment_SumaryNugget_Fragment | IContentFragment_SurveyQuizzFolder_Fragment | IContentFragment_TextPage_Fragment | IContentFragment_ThankYouPage_Fragment | IContentFragment_TranslationContext_Fragment | IContentFragment_TranslationFolder_Fragment | IContentFragment_TranslationItem_Fragment | IContentFragment_UmbracoTest_Fragment | IContentFragment_UnitNuggetAnswer_Fragment | IContentFragment_UnitNuggetGapFillAnswer_Fragment | IContentFragment_UnitProgression_Fragment | IContentFragment_VodItem_Fragment | IContentFragment_VodMenu_Fragment | IContentFragment_VotingFolder_Fragment | IContentFragment_VotingRecord_Fragment | IContentFragment_WatchCateg_Fragment;

export type IAwardsArtistFragmentFragment = (
  { __typename: 'AwardsArtist' }
  & Pick<IAwardsArtist, 'id' | 'name' | 'subtitle' | 'title' | 'description' | 'exportID'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & Pick<IAccordions, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Advantage' }
      & Pick<IAdvantage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AdvantagesList' }
      & Pick<IAdvantagesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Article' }
      & Pick<IArticle, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistService' }
      & Pick<IArtistService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Author' }
      & Pick<IAuthor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Button' }
      & Pick<IButton, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CMSPage' }
      & Pick<ICmsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlide' }
      & Pick<ICtaSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlider' }
      & Pick<ICtaSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Card' }
      & Pick<ICard, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardIcon' }
      & Pick<ICardIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardLink' }
      & Pick<ICardLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardList' }
      & Pick<ICardList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategBgColor' }
      & Pick<ICategBgColor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategoryPage' }
      & Pick<ICategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySlider' }
      & Pick<ICategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Channel' }
      & Pick<IChannel, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChannelFolder' }
      & Pick<IChannelFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Collection' }
      & Pick<ICollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ColorTag' }
      & Pick<IColorTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentCategCmp' }
      & Pick<IContentCategCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentLink' }
      & Pick<IContentLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSlider' }
      & Pick<IContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & Pick<IContentSliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTag' }
      & Pick<IContentTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTags' }
      & Pick<IContentTags, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & Pick<IContextualContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Course' }
      & Pick<ICourse, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategory' }
      & Pick<ICourseCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & Pick<ICourseCategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseExam' }
      & Pick<ICourseExam, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & Pick<ICourseItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseNugget' }
      & Pick<ICourseNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CoursePage' }
      & Pick<ICoursePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseShare' }
      & Pick<ICourseShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseStatus' }
      & Pick<ICourseStatus, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseUnit' }
      & Pick<ICourseUnit, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Discovery' }
      & Pick<IDiscovery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide' }
      & Pick<IDiscoverySlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EditoSlider' }
      & Pick<IEditoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExpandMenu' }
      & Pick<IExpandMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExternalLink' }
      & Pick<IExternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqItem' }
      & Pick<IFaqItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqPageLink' }
      & Pick<IFaqPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormFolder' }
      & Pick<IFormFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormPage' }
      & Pick<IFormPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Gallery' }
      & Pick<IGallery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner' }
      & Pick<IHeroBanner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner1' }
      & Pick<IHeroBanner1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroServices' }
      & Pick<IHeroServices, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroSlide' }
      & Pick<IHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroVideoCover' }
      & Pick<IHeroVideoCover, 'contentTypeAlias'>
      & IHeroVideoCoverFragmentFragment
    ) | (
      { __typename?: 'HomePage' }
      & Pick<IHomePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'IconSlide' }
      & Pick<IIconSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'InternalLink' }
      & Pick<IInternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHub' }
      & Pick<IJobHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobProgress' }
      & Pick<IJobProgress, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobShare' }
      & Pick<IJobShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacancy' }
      & Pick<IJobVacancy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigure' }
      & Pick<IKeyFigure, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigures' }
      & Pick<IKeyFigures, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingAbout' }
      & Pick<ILandingAbout, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingPage' }
      & Pick<ILandingPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & Pick<ILearnHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnMenu' }
      & Pick<ILearnMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalPageLink' }
      & Pick<ILegalPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkIcon' }
      & Pick<ILinkIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkPicker' }
      & Pick<ILinkPicker, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ListenCateg' }
      & Pick<IListenCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEvent' }
      & Pick<ILiveEvent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoLink' }
      & Pick<ILogoLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoSlider' }
      & Pick<ILogoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDatas' }
      & Pick<IMemberDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberMessage' }
      & Pick<IMemberMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberNotify' }
      & Pick<IMemberNotify, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSaved' }
      & Pick<IMemberSaved, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSearch' }
      & Pick<IMemberSearch, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberWatched' }
      & Pick<IMemberWatched, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MembersDatas' }
      & Pick<IMembersDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MenuColumn' }
      & Pick<IMenuColumn, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & Pick<IMetadatasLanguages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasExclusives' }
      & Pick<IMetasExclusives, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & Pick<IMetasPublicationDate, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MultiSlider' }
      & Pick<IMultiSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavMessage' }
      & Pick<INavMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'News' }
      & Pick<INews, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsCateg' }
      & Pick<INewsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsFolder' }
      & Pick<INewsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsPage' }
      & Pick<INewsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ObtainedJob' }
      & Pick<IObtainedJob, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Opportunity' }
      & Pick<IOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PageSEO' }
      & Pick<IPageSeo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PagecontentSlider' }
      & Pick<IPagecontentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partner' }
      & Pick<IPartner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnerSlider' }
      & Pick<IPartnerSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partners' }
      & Pick<IPartners, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnersPage' }
      & Pick<IPartnersPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Paywall' }
      & Pick<IPaywall, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPush' }
      & Pick<IPersonalityPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityType' }
      & Pick<IPersonalityType, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Playlist' }
      & Pick<IPlaylist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Podcast' }
      & Pick<IPodcast, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastItem' }
      & Pick<IPodcastItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCode' }
      & Pick<IPromoCode, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Push' }
      & Pick<IPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & Pick<IQuizItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizPage' }
      & Pick<IQuizPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Radio' }
      & Pick<IRadio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'RadioCateg' }
      & Pick<IRadioCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Region' }
      & Pick<IRegion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SectionPage' }
      & Pick<ISectionPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Service' }
      & Pick<IService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ServicesList' }
      & Pick<IServicesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Settings' }
      & Pick<ISettings, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & Pick<ISettingsDateCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsExternalId' }
      & Pick<ISettingsExternalId, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Space' }
      & Pick<ISpace, 'contentTypeAlias'>
    ) | (
      { __typename?: 'StaticPageLink' }
      & Pick<IStaticPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Subscription' }
      & Pick<ISubscription, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsList' }
      & Pick<ISubscriptionsList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextPage' }
      & Pick<ITextPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextSlide1' }
      & Pick<ITextSlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ThankYouPage' }
      & Pick<IThankYouPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TitleSlider' }
      & Pick<ITitleSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Top10Song' }
      & Pick<ITop10Song, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationContext' }
      & Pick<ITranslationContext, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationItem' }
      & Pick<ITranslationItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TutorialSlide' }
      & Pick<ITutorialSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcAudio' }
      & Pick<IUcAudio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcImage' }
      & Pick<IUcImage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcLineBreak' }
      & Pick<IUcLineBreak, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcText' }
      & Pick<IUcText, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcVideo' }
      & Pick<IUcVideo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitProgression' }
      & Pick<IUnitProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODItem' }
      & Pick<IVodItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODMenu' }
      & Pick<IVodMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ValidationElement' }
      & Pick<IValidationElement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingFolder' }
      & Pick<IVotingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingRecord' }
      & Pick<IVotingRecord, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchCateg' }
      & Pick<IWatchCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchedContent' }
      & Pick<IWatchedContent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Wysiwyg' }
      & Pick<IWysiwyg, 'contentTypeAlias'>
    ) }
  )>>>, button?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | (
      { __typename?: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, parent?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
);

export type ICtaSlideFragmentFragment = (
  { __typename: 'CTASlide' }
  & Pick<ICtaSlide, 'title' | 'description'>
  & { button?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | (
      { __typename: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type ICardLinkFragmentFragment = (
  { __typename?: 'CardLink' }
  & Pick<ICardLink, 'title' | 'description'>
  & { image?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, links?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | (
      { __typename: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IChannelFragmentFragment = (
  { __typename: 'Channel' }
  & Pick<IChannel, 'id' | 'createDate' | 'epg' | 'title' | 'sourceUrl' | 'name' | 'sortOrder' | 'countriesRestriction' | 'url' | 'updateDate' | 'shortDescription'>
  & { liveEventId: IChannel['vimeoEventId'] }
  & { logo?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, regions?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
    { __typename?: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, availableRegions?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>>, musicGenre?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
  & IParentInfo_Channel_Fragment
);

export type ICollectionFragmentFragment = (
  { __typename: 'Collection' }
  & Pick<ICollection, 'countryOfProduction' | 'id' | 'startDate' | 'updateDate' | 'sortOrder' | 'shortDescription' | 'description' | 'releaseDate' | 'url' | 'public' | 'countriesRestriction' | 'trailer'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, regions?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
    { __typename?: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, availableRegions?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>>, musicGenre?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
  & IContentItemsFragment_Collection_Fragment
  & IParentInfo_Collection_Fragment
);

export type IContentEdgeFragmentFragment = (
  { __typename: 'ContentEdge' }
  & Pick<IContentEdge, 'cursor'>
  & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | (
    { __typename: 'PodcastItem' }
    & IPodcastItemFragmentFragment
  ) | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
);

export type IContentRestrictedCountries_ArtistService_Fragment = { __typename?: 'ArtistService' };

export type IContentRestrictedCountries_ArtistServiceFolder_Fragment = { __typename?: 'ArtistServiceFolder' };

export type IContentRestrictedCountries_ArtistServicesPage_Fragment = { __typename?: 'ArtistServicesPage' };

export type IContentRestrictedCountries_AwardCategoryPage_Fragment = { __typename?: 'AwardCategoryPage' };

export type IContentRestrictedCountries_AwardsArtist_Fragment = { __typename?: 'AwardsArtist' };

export type IContentRestrictedCountries_AwardsCategoryMenu_Fragment = { __typename?: 'AwardsCategoryMenu' };

export type IContentRestrictedCountries_AwardsCategoryMenuDev_Fragment = { __typename?: 'AwardsCategoryMenuDev' };

export type IContentRestrictedCountries_AwardsCategoryMenuFolder_Fragment = { __typename?: 'AwardsCategoryMenuFolder' };

export type IContentRestrictedCountries_AwardsCategoryMenuFolderDev_Fragment = { __typename?: 'AwardsCategoryMenuFolderDev' };

export type IContentRestrictedCountries_AwardsHomepage_Fragment = { __typename?: 'AwardsHomepage' };

export type IContentRestrictedCountries_CmsPage_Fragment = { __typename?: 'CMSPage' };

export type IContentRestrictedCountries_CategBgColor_Fragment = { __typename?: 'CategBgColor' };

export type IContentRestrictedCountries_CategoryPage_Fragment = { __typename?: 'CategoryPage' };

export type IContentRestrictedCountries_Channel_Fragment = (
  { __typename?: 'Channel' }
  & Pick<IChannel, 'countriesRestriction'>
);

export type IContentRestrictedCountries_ChannelFolder_Fragment = { __typename?: 'ChannelFolder' };

export type IContentRestrictedCountries_ChoiceNugget_Fragment = { __typename?: 'ChoiceNugget' };

export type IContentRestrictedCountries_Collection_Fragment = (
  { __typename?: 'Collection' }
  & Pick<ICollection, 'countriesRestriction'>
);

export type IContentRestrictedCountries_ContentEditorFolder_Fragment = { __typename?: 'ContentEditorFolder' };

export type IContentRestrictedCountries_ContentTag_Fragment = { __typename?: 'ContentTag' };

export type IContentRestrictedCountries_ContentTags_Fragment = { __typename?: 'ContentTags' };

export type IContentRestrictedCountries_ContentTagsCateg_Fragment = { __typename?: 'ContentTagsCateg' };

export type IContentRestrictedCountries_Course_Fragment = { __typename?: 'Course' };

export type IContentRestrictedCountries_CourseCategoriesFolder_Fragment = { __typename?: 'CourseCategoriesFolder' };

export type IContentRestrictedCountries_CourseCategory_Fragment = { __typename?: 'CourseCategory' };

export type IContentRestrictedCountries_CourseExam_Fragment = { __typename?: 'CourseExam' };

export type IContentRestrictedCountries_CourseShare_Fragment = { __typename?: 'CourseShare' };

export type IContentRestrictedCountries_CourseStatus_Fragment = { __typename?: 'CourseStatus' };

export type IContentRestrictedCountries_CourseTestProgression_Fragment = { __typename?: 'CourseTestProgression' };

export type IContentRestrictedCountries_CourseUnit_Fragment = { __typename?: 'CourseUnit' };

export type IContentRestrictedCountries_Discovery_Fragment = { __typename?: 'Discovery' };

export type IContentRestrictedCountries_DiscoverySlide1_Fragment = { __typename?: 'DiscoverySlide1' };

export type IContentRestrictedCountries_EntrepreunarialHub_Fragment = { __typename?: 'EntrepreunarialHub' };

export type IContentRestrictedCountries_FormFolder_Fragment = { __typename?: 'FormFolder' };

export type IContentRestrictedCountries_FormPage_Fragment = { __typename?: 'FormPage' };

export type IContentRestrictedCountries_GapfillNugget_Fragment = { __typename?: 'GapfillNugget' };

export type IContentRestrictedCountries_HelpdeskCateg_Fragment = { __typename?: 'HelpdeskCateg' };

export type IContentRestrictedCountries_HelpdeskFolder_Fragment = { __typename?: 'HelpdeskFolder' };

export type IContentRestrictedCountries_HelpdeskPage_Fragment = { __typename?: 'HelpdeskPage' };

export type IContentRestrictedCountries_HomePage_Fragment = { __typename?: 'HomePage' };

export type IContentRestrictedCountries_JobBoardPage_Fragment = { __typename?: 'JobBoardPage' };

export type IContentRestrictedCountries_JobHub_Fragment = { __typename?: 'JobHub' };

export type IContentRestrictedCountries_JobHubsFolder_Fragment = { __typename?: 'JobHubsFolder' };

export type IContentRestrictedCountries_JobProgress_Fragment = { __typename?: 'JobProgress' };

export type IContentRestrictedCountries_JobShare_Fragment = { __typename?: 'JobShare' };

export type IContentRestrictedCountries_JobTraining_Fragment = { __typename?: 'JobTraining' };

export type IContentRestrictedCountries_JobTrainingFolder_Fragment = { __typename?: 'JobTrainingFolder' };

export type IContentRestrictedCountries_JobVacanciesFolder_Fragment = { __typename?: 'JobVacanciesFolder' };

export type IContentRestrictedCountries_JobVacancy_Fragment = { __typename?: 'JobVacancy' };

export type IContentRestrictedCountries_LandingPage_Fragment = { __typename?: 'LandingPage' };

export type IContentRestrictedCountries_LearnMenu_Fragment = { __typename?: 'LearnMenu' };

export type IContentRestrictedCountries_LegalsFolder_Fragment = { __typename?: 'LegalsFolder' };

export type IContentRestrictedCountries_ListenCateg_Fragment = { __typename?: 'ListenCateg' };

export type IContentRestrictedCountries_LiveEvent_Fragment = (
  { __typename?: 'LiveEvent' }
  & Pick<ILiveEvent, 'countriesRestriction'>
);

export type IContentRestrictedCountries_LiveEventsMenu_Fragment = { __typename?: 'LiveEventsMenu' };

export type IContentRestrictedCountries_LiveEventsPage_Fragment = { __typename?: 'LiveEventsPage' };

export type IContentRestrictedCountries_LiveTvPage_Fragment = { __typename?: 'LiveTVPage' };

export type IContentRestrictedCountries_MemberContentTypesLink_Fragment = { __typename?: 'MemberContentTypesLink' };

export type IContentRestrictedCountries_MemberDatas_Fragment = { __typename?: 'MemberDatas' };

export type IContentRestrictedCountries_MemberDownloaded_Fragment = { __typename?: 'MemberDownloaded' };

export type IContentRestrictedCountries_MemberMessage_Fragment = { __typename?: 'MemberMessage' };

export type IContentRestrictedCountries_MemberNotify_Fragment = { __typename?: 'MemberNotify' };

export type IContentRestrictedCountries_MemberOpportunity_Fragment = { __typename?: 'MemberOpportunity' };

export type IContentRestrictedCountries_MemberSaved_Fragment = { __typename?: 'MemberSaved' };

export type IContentRestrictedCountries_MemberSearch_Fragment = { __typename?: 'MemberSearch' };

export type IContentRestrictedCountries_MemberWatched_Fragment = { __typename?: 'MemberWatched' };

export type IContentRestrictedCountries_MembersDatas_Fragment = { __typename?: 'MembersDatas' };

export type IContentRestrictedCountries_MiniSitesFolder_Fragment = { __typename?: 'MiniSitesFolder' };

export type IContentRestrictedCountries_NavMessage_Fragment = { __typename?: 'NavMessage' };

export type IContentRestrictedCountries_NavigationMessagesFolder_Fragment = { __typename?: 'NavigationMessagesFolder' };

export type IContentRestrictedCountries_NetlifyDeploy_Fragment = { __typename?: 'NetlifyDeploy' };

export type IContentRestrictedCountries_News_Fragment = (
  { __typename?: 'News' }
  & Pick<INews, 'countriesRestriction'>
);

export type IContentRestrictedCountries_NewsCateg_Fragment = { __typename?: 'NewsCateg' };

export type IContentRestrictedCountries_NewsFolder_Fragment = { __typename?: 'NewsFolder' };

export type IContentRestrictedCountries_NewsPage_Fragment = { __typename?: 'NewsPage' };

export type IContentRestrictedCountries_ObtainedJob_Fragment = { __typename?: 'ObtainedJob' };

export type IContentRestrictedCountries_Opportunity_Fragment = (
  { __typename?: 'Opportunity' }
  & Pick<IOpportunity, 'countriesRestriction'>
);

export type IContentRestrictedCountries_OpportunityCenter_Fragment = { __typename?: 'OpportunityCenter' };

export type IContentRestrictedCountries_OpportunityFolder_Fragment = { __typename?: 'OpportunityFolder' };

export type IContentRestrictedCountries_Partner_Fragment = { __typename?: 'Partner' };

export type IContentRestrictedCountries_Partners_Fragment = { __typename?: 'Partners' };

export type IContentRestrictedCountries_PartnersPage_Fragment = { __typename?: 'PartnersPage' };

export type IContentRestrictedCountries_Paywall_Fragment = { __typename?: 'Paywall' };

export type IContentRestrictedCountries_PaywallFolder_Fragment = { __typename?: 'PaywallFolder' };

export type IContentRestrictedCountries_PersonalityPages_Fragment = { __typename?: 'PersonalityPages' };

export type IContentRestrictedCountries_PersonalityQuiz_Fragment = { __typename?: 'PersonalityQuiz' };

export type IContentRestrictedCountries_PersonalityQuiz1_Fragment = { __typename?: 'PersonalityQuiz1' };

export type IContentRestrictedCountries_PersonalityType_Fragment = { __typename?: 'PersonalityType' };

export type IContentRestrictedCountries_Playlist_Fragment = (
  { __typename?: 'Playlist' }
  & Pick<IPlaylist, 'countriesRestriction'>
);

export type IContentRestrictedCountries_PlaylistRadioMenu_Fragment = { __typename?: 'PlaylistRadioMenu' };

export type IContentRestrictedCountries_Podcast_Fragment = (
  { __typename?: 'Podcast' }
  & Pick<IPodcast, 'countriesRestriction'>
);

export type IContentRestrictedCountries_PodcastCateg_Fragment = { __typename?: 'PodcastCateg' };

export type IContentRestrictedCountries_PodcastItem_Fragment = { __typename?: 'PodcastItem' };

export type IContentRestrictedCountries_PodcastMenu_Fragment = { __typename?: 'PodcastMenu' };

export type IContentRestrictedCountries_PromoCode_Fragment = { __typename?: 'PromoCode' };

export type IContentRestrictedCountries_PromoCodeFolder_Fragment = { __typename?: 'PromoCodeFolder' };

export type IContentRestrictedCountries_QuizPage_Fragment = { __typename?: 'QuizPage' };

export type IContentRestrictedCountries_QuizzSurvey_Fragment = { __typename?: 'QuizzSurvey' };

export type IContentRestrictedCountries_QuizzSurveyCategory_Fragment = { __typename?: 'QuizzSurveyCategory' };

export type IContentRestrictedCountries_QuizzSurveyCollection_Fragment = { __typename?: 'QuizzSurveyCollection' };

export type IContentRestrictedCountries_Radio_Fragment = (
  { __typename?: 'Radio' }
  & Pick<IRadio, 'countriesRestriction'>
);

export type IContentRestrictedCountries_RadioCateg_Fragment = { __typename?: 'RadioCateg' };

export type IContentRestrictedCountries_Region_Fragment = { __typename?: 'Region' };

export type IContentRestrictedCountries_SectionPage_Fragment = { __typename?: 'SectionPage' };

export type IContentRestrictedCountries_Settings_Fragment = { __typename?: 'Settings' };

export type IContentRestrictedCountries_Space_Fragment = { __typename?: 'Space' };

export type IContentRestrictedCountries_Subscription_Fragment = { __typename?: 'Subscription' };

export type IContentRestrictedCountries_SubscriptionData_Fragment = { __typename?: 'SubscriptionData' };

export type IContentRestrictedCountries_SubscriptionDataFolder_Fragment = { __typename?: 'SubscriptionDataFolder' };

export type IContentRestrictedCountries_SubscriptionsFolder_Fragment = { __typename?: 'SubscriptionsFolder' };

export type IContentRestrictedCountries_SumaryNugget_Fragment = { __typename?: 'SumaryNugget' };

export type IContentRestrictedCountries_SurveyQuizzFolder_Fragment = { __typename?: 'SurveyQuizzFolder' };

export type IContentRestrictedCountries_TextPage_Fragment = { __typename?: 'TextPage' };

export type IContentRestrictedCountries_ThankYouPage_Fragment = { __typename?: 'ThankYouPage' };

export type IContentRestrictedCountries_TranslationContext_Fragment = { __typename?: 'TranslationContext' };

export type IContentRestrictedCountries_TranslationFolder_Fragment = { __typename?: 'TranslationFolder' };

export type IContentRestrictedCountries_TranslationItem_Fragment = { __typename?: 'TranslationItem' };

export type IContentRestrictedCountries_UmbracoTest_Fragment = { __typename?: 'UmbracoTest' };

export type IContentRestrictedCountries_UnitNuggetAnswer_Fragment = { __typename?: 'UnitNuggetAnswer' };

export type IContentRestrictedCountries_UnitNuggetGapFillAnswer_Fragment = { __typename?: 'UnitNuggetGapFillAnswer' };

export type IContentRestrictedCountries_UnitProgression_Fragment = { __typename?: 'UnitProgression' };

export type IContentRestrictedCountries_VodItem_Fragment = (
  { __typename?: 'VODItem' }
  & Pick<IVodItem, 'countriesRestriction'>
);

export type IContentRestrictedCountries_VodMenu_Fragment = { __typename?: 'VODMenu' };

export type IContentRestrictedCountries_VotingFolder_Fragment = { __typename?: 'VotingFolder' };

export type IContentRestrictedCountries_VotingRecord_Fragment = { __typename?: 'VotingRecord' };

export type IContentRestrictedCountries_WatchCateg_Fragment = { __typename?: 'WatchCateg' };

export type IContentRestrictedCountriesFragment = IContentRestrictedCountries_ArtistService_Fragment | IContentRestrictedCountries_ArtistServiceFolder_Fragment | IContentRestrictedCountries_ArtistServicesPage_Fragment | IContentRestrictedCountries_AwardCategoryPage_Fragment | IContentRestrictedCountries_AwardsArtist_Fragment | IContentRestrictedCountries_AwardsCategoryMenu_Fragment | IContentRestrictedCountries_AwardsCategoryMenuDev_Fragment | IContentRestrictedCountries_AwardsCategoryMenuFolder_Fragment | IContentRestrictedCountries_AwardsCategoryMenuFolderDev_Fragment | IContentRestrictedCountries_AwardsHomepage_Fragment | IContentRestrictedCountries_CmsPage_Fragment | IContentRestrictedCountries_CategBgColor_Fragment | IContentRestrictedCountries_CategoryPage_Fragment | IContentRestrictedCountries_Channel_Fragment | IContentRestrictedCountries_ChannelFolder_Fragment | IContentRestrictedCountries_ChoiceNugget_Fragment | IContentRestrictedCountries_Collection_Fragment | IContentRestrictedCountries_ContentEditorFolder_Fragment | IContentRestrictedCountries_ContentTag_Fragment | IContentRestrictedCountries_ContentTags_Fragment | IContentRestrictedCountries_ContentTagsCateg_Fragment | IContentRestrictedCountries_Course_Fragment | IContentRestrictedCountries_CourseCategoriesFolder_Fragment | IContentRestrictedCountries_CourseCategory_Fragment | IContentRestrictedCountries_CourseExam_Fragment | IContentRestrictedCountries_CourseShare_Fragment | IContentRestrictedCountries_CourseStatus_Fragment | IContentRestrictedCountries_CourseTestProgression_Fragment | IContentRestrictedCountries_CourseUnit_Fragment | IContentRestrictedCountries_Discovery_Fragment | IContentRestrictedCountries_DiscoverySlide1_Fragment | IContentRestrictedCountries_EntrepreunarialHub_Fragment | IContentRestrictedCountries_FormFolder_Fragment | IContentRestrictedCountries_FormPage_Fragment | IContentRestrictedCountries_GapfillNugget_Fragment | IContentRestrictedCountries_HelpdeskCateg_Fragment | IContentRestrictedCountries_HelpdeskFolder_Fragment | IContentRestrictedCountries_HelpdeskPage_Fragment | IContentRestrictedCountries_HomePage_Fragment | IContentRestrictedCountries_JobBoardPage_Fragment | IContentRestrictedCountries_JobHub_Fragment | IContentRestrictedCountries_JobHubsFolder_Fragment | IContentRestrictedCountries_JobProgress_Fragment | IContentRestrictedCountries_JobShare_Fragment | IContentRestrictedCountries_JobTraining_Fragment | IContentRestrictedCountries_JobTrainingFolder_Fragment | IContentRestrictedCountries_JobVacanciesFolder_Fragment | IContentRestrictedCountries_JobVacancy_Fragment | IContentRestrictedCountries_LandingPage_Fragment | IContentRestrictedCountries_LearnMenu_Fragment | IContentRestrictedCountries_LegalsFolder_Fragment | IContentRestrictedCountries_ListenCateg_Fragment | IContentRestrictedCountries_LiveEvent_Fragment | IContentRestrictedCountries_LiveEventsMenu_Fragment | IContentRestrictedCountries_LiveEventsPage_Fragment | IContentRestrictedCountries_LiveTvPage_Fragment | IContentRestrictedCountries_MemberContentTypesLink_Fragment | IContentRestrictedCountries_MemberDatas_Fragment | IContentRestrictedCountries_MemberDownloaded_Fragment | IContentRestrictedCountries_MemberMessage_Fragment | IContentRestrictedCountries_MemberNotify_Fragment | IContentRestrictedCountries_MemberOpportunity_Fragment | IContentRestrictedCountries_MemberSaved_Fragment | IContentRestrictedCountries_MemberSearch_Fragment | IContentRestrictedCountries_MemberWatched_Fragment | IContentRestrictedCountries_MembersDatas_Fragment | IContentRestrictedCountries_MiniSitesFolder_Fragment | IContentRestrictedCountries_NavMessage_Fragment | IContentRestrictedCountries_NavigationMessagesFolder_Fragment | IContentRestrictedCountries_NetlifyDeploy_Fragment | IContentRestrictedCountries_News_Fragment | IContentRestrictedCountries_NewsCateg_Fragment | IContentRestrictedCountries_NewsFolder_Fragment | IContentRestrictedCountries_NewsPage_Fragment | IContentRestrictedCountries_ObtainedJob_Fragment | IContentRestrictedCountries_Opportunity_Fragment | IContentRestrictedCountries_OpportunityCenter_Fragment | IContentRestrictedCountries_OpportunityFolder_Fragment | IContentRestrictedCountries_Partner_Fragment | IContentRestrictedCountries_Partners_Fragment | IContentRestrictedCountries_PartnersPage_Fragment | IContentRestrictedCountries_Paywall_Fragment | IContentRestrictedCountries_PaywallFolder_Fragment | IContentRestrictedCountries_PersonalityPages_Fragment | IContentRestrictedCountries_PersonalityQuiz_Fragment | IContentRestrictedCountries_PersonalityQuiz1_Fragment | IContentRestrictedCountries_PersonalityType_Fragment | IContentRestrictedCountries_Playlist_Fragment | IContentRestrictedCountries_PlaylistRadioMenu_Fragment | IContentRestrictedCountries_Podcast_Fragment | IContentRestrictedCountries_PodcastCateg_Fragment | IContentRestrictedCountries_PodcastItem_Fragment | IContentRestrictedCountries_PodcastMenu_Fragment | IContentRestrictedCountries_PromoCode_Fragment | IContentRestrictedCountries_PromoCodeFolder_Fragment | IContentRestrictedCountries_QuizPage_Fragment | IContentRestrictedCountries_QuizzSurvey_Fragment | IContentRestrictedCountries_QuizzSurveyCategory_Fragment | IContentRestrictedCountries_QuizzSurveyCollection_Fragment | IContentRestrictedCountries_Radio_Fragment | IContentRestrictedCountries_RadioCateg_Fragment | IContentRestrictedCountries_Region_Fragment | IContentRestrictedCountries_SectionPage_Fragment | IContentRestrictedCountries_Settings_Fragment | IContentRestrictedCountries_Space_Fragment | IContentRestrictedCountries_Subscription_Fragment | IContentRestrictedCountries_SubscriptionData_Fragment | IContentRestrictedCountries_SubscriptionDataFolder_Fragment | IContentRestrictedCountries_SubscriptionsFolder_Fragment | IContentRestrictedCountries_SumaryNugget_Fragment | IContentRestrictedCountries_SurveyQuizzFolder_Fragment | IContentRestrictedCountries_TextPage_Fragment | IContentRestrictedCountries_ThankYouPage_Fragment | IContentRestrictedCountries_TranslationContext_Fragment | IContentRestrictedCountries_TranslationFolder_Fragment | IContentRestrictedCountries_TranslationItem_Fragment | IContentRestrictedCountries_UmbracoTest_Fragment | IContentRestrictedCountries_UnitNuggetAnswer_Fragment | IContentRestrictedCountries_UnitNuggetGapFillAnswer_Fragment | IContentRestrictedCountries_UnitProgression_Fragment | IContentRestrictedCountries_VodItem_Fragment | IContentRestrictedCountries_VodMenu_Fragment | IContentRestrictedCountries_VotingFolder_Fragment | IContentRestrictedCountries_VotingRecord_Fragment | IContentRestrictedCountries_WatchCateg_Fragment;

export type IContentTagFragmentFragment = (
  { __typename: 'ContentTag' }
  & Pick<IContentTag, 'name' | 'id' | 'url' | 'color'>
);

export type IFormPageFragmentFragment = (
  { __typename?: 'FormPage' }
  & Pick<IFormPage, 'id' | 'url' | 'title' | 'subtitle' | 'form'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type IHelpdeskCategFragmentFragment = (
  { __typename: 'HelpdeskCateg' }
  & Pick<IHelpdeskCateg, 'url' | 'title' | 'name'>
  & { faqItems?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | (
      { __typename: 'FaqItem' }
      & IFaqItemFragmentFragment
    ) | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IIconSlideFragmentFragment = (
  { __typename?: 'IconSlide' }
  & Pick<IIconSlide, 'title' | 'overtitle'>
  & { icon?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IKeyFigureFragmentFragment = (
  { __typename: 'KeyFigure' }
  & Pick<IKeyFigure, 'figure' | 'description'>
);

export type IChoiceNuggerAnswerFragmentFragment = (
  { __typename: 'ChoiceNuggerAnswer' }
  & Pick<IChoiceNuggerAnswer, 'value' | 'description' | 'feedback' | 'isCorrect'>
  & { image?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'cropUrl'>
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IChoiceNuggetFragmentFragment = (
  { __typename: 'ChoiceNugget' }
  & Pick<IChoiceNugget, 'id' | 'genericFeedback' | 'positiveFeedback' | 'negativeFeedback' | 'externalId' | 'updateDate'>
  & { question?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | (
      { __typename?: 'UcAudio' }
      & IUcAudioFragmentFragment
    ) | (
      { __typename?: 'UcImage' }
      & IUcImageFragmentFragment
    ) | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | (
      { __typename?: 'UcVideo' }
      & IUcVideoFragmentFragment
    ) | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | (
      { __typename: 'Wysiwyg' }
      & Pick<IWysiwyg, 'title' | 'body'>
    ) }
  )>>>, options?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IChoiceNuggerAnswerFragmentFragment
    ) | { __typename?: 'ChoiceNugget' } | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & { answersList?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | (
          { __typename: 'ChoiceNuggerAnswer' }
          & IChoiceNuggerAnswerFragmentFragment
        ) | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>> }
    ) | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name'>
    & { parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'name'>
      & { linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
        { __typename: 'Partner' }
        & IPartnerFragmentFragment
      ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
    ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
  ) | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
);

export type ICourseFragmentFragment = (
  { __typename: 'Course' }
  & Pick<ICourse, 'id' | 'url' | 'name' | 'title' | 'trailer' | 'length' | 'description' | 'updateDate'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'cropUrl'>
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'] }
  )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
    { __typename: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id' | 'url' | 'gradingPolicy'>
    ) | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'title' | 'length' | 'id' | 'url'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'cropUrl'>
        & { url: IMediaWithCrops['cropUrl'] }
      )> }
    ) | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ), interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
);

export type ICourseCategoryFragmentFragment = (
  { __typename: 'CourseCategory' }
  & Pick<ICourseCategory, 'id' | 'url' | 'name'>
  & { children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
      { __typename: 'Course' }
      & Pick<ICourse, 'title' | 'id' | 'url' | 'length'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'cropUrl'>
        & { url: IMediaWithCrops['cropUrl'] }
      )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
        { __typename: 'Partner' }
        & { logo?: Maybe<(
          { __typename?: 'MediaWithCrops' }
          & { url: IMediaWithCrops['cropUrl'] }
        )> }
      ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<(
          { __typename: 'ArtistService' }
          & Pick<IArtistService, 'id'>
        ) | (
          { __typename: 'ArtistServiceFolder' }
          & Pick<IArtistServiceFolder, 'id'>
        ) | (
          { __typename: 'ArtistServicesPage' }
          & Pick<IArtistServicesPage, 'id'>
        ) | (
          { __typename: 'AwardCategoryPage' }
          & Pick<IAwardCategoryPage, 'id'>
        ) | (
          { __typename: 'AwardsArtist' }
          & Pick<IAwardsArtist, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenu' }
          & Pick<IAwardsCategoryMenu, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuDev' }
          & Pick<IAwardsCategoryMenuDev, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolder' }
          & Pick<IAwardsCategoryMenuFolder, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolderDev' }
          & Pick<IAwardsCategoryMenuFolderDev, 'id'>
        ) | (
          { __typename: 'AwardsHomepage' }
          & Pick<IAwardsHomepage, 'id'>
        ) | (
          { __typename: 'CMSPage' }
          & Pick<ICmsPage, 'id'>
        ) | (
          { __typename: 'CategBgColor' }
          & Pick<ICategBgColor, 'id'>
        ) | (
          { __typename: 'CategoryPage' }
          & Pick<ICategoryPage, 'id'>
        ) | (
          { __typename: 'Channel' }
          & Pick<IChannel, 'id'>
        ) | (
          { __typename: 'ChannelFolder' }
          & Pick<IChannelFolder, 'id'>
        ) | (
          { __typename: 'ChoiceNugget' }
          & Pick<IChoiceNugget, 'id'>
        ) | (
          { __typename: 'Collection' }
          & Pick<ICollection, 'id'>
        ) | (
          { __typename: 'ContentEditorFolder' }
          & Pick<IContentEditorFolder, 'id'>
        ) | (
          { __typename: 'ContentTag' }
          & Pick<IContentTag, 'id'>
        ) | (
          { __typename: 'ContentTags' }
          & Pick<IContentTags, 'id'>
        ) | (
          { __typename: 'ContentTagsCateg' }
          & Pick<IContentTagsCateg, 'id'>
        ) | (
          { __typename: 'Course' }
          & Pick<ICourse, 'id'>
        ) | (
          { __typename: 'CourseCategoriesFolder' }
          & Pick<ICourseCategoriesFolder, 'id'>
        ) | (
          { __typename: 'CourseCategory' }
          & Pick<ICourseCategory, 'id'>
        ) | (
          { __typename: 'CourseExam' }
          & Pick<ICourseExam, 'id'>
        ) | (
          { __typename: 'CourseShare' }
          & Pick<ICourseShare, 'id'>
        ) | (
          { __typename: 'CourseStatus' }
          & Pick<ICourseStatus, 'id'>
        ) | (
          { __typename: 'CourseTestProgression' }
          & Pick<ICourseTestProgression, 'id'>
        ) | (
          { __typename: 'CourseUnit' }
          & Pick<ICourseUnit, 'id'>
        ) | (
          { __typename: 'Discovery' }
          & Pick<IDiscovery, 'id'>
        ) | (
          { __typename: 'DiscoverySlide1' }
          & Pick<IDiscoverySlide1, 'id'>
        ) | (
          { __typename: 'EntrepreunarialHub' }
          & Pick<IEntrepreunarialHub, 'id'>
        ) | (
          { __typename: 'FormFolder' }
          & Pick<IFormFolder, 'id'>
        ) | (
          { __typename: 'FormPage' }
          & Pick<IFormPage, 'id'>
        ) | (
          { __typename: 'GapfillNugget' }
          & Pick<IGapfillNugget, 'id'>
        ) | (
          { __typename: 'HelpdeskCateg' }
          & Pick<IHelpdeskCateg, 'id'>
        ) | (
          { __typename: 'HelpdeskFolder' }
          & Pick<IHelpdeskFolder, 'id'>
        ) | (
          { __typename: 'HelpdeskPage' }
          & Pick<IHelpdeskPage, 'id'>
        ) | (
          { __typename: 'HomePage' }
          & Pick<IHomePage, 'id'>
        ) | (
          { __typename: 'JobBoardPage' }
          & Pick<IJobBoardPage, 'id'>
        ) | (
          { __typename: 'JobHub' }
          & Pick<IJobHub, 'id'>
        ) | (
          { __typename: 'JobHubsFolder' }
          & Pick<IJobHubsFolder, 'id'>
        ) | (
          { __typename: 'JobProgress' }
          & Pick<IJobProgress, 'id'>
        ) | (
          { __typename: 'JobShare' }
          & Pick<IJobShare, 'id'>
        ) | (
          { __typename: 'JobTraining' }
          & Pick<IJobTraining, 'id'>
        ) | (
          { __typename: 'JobTrainingFolder' }
          & Pick<IJobTrainingFolder, 'id'>
        ) | (
          { __typename: 'JobVacanciesFolder' }
          & Pick<IJobVacanciesFolder, 'id'>
        ) | (
          { __typename: 'JobVacancy' }
          & Pick<IJobVacancy, 'id'>
        ) | (
          { __typename: 'LandingPage' }
          & Pick<ILandingPage, 'id'>
        ) | (
          { __typename: 'LearnMenu' }
          & Pick<ILearnMenu, 'id'>
        ) | (
          { __typename: 'LegalsFolder' }
          & Pick<ILegalsFolder, 'id'>
        ) | (
          { __typename: 'ListenCateg' }
          & Pick<IListenCateg, 'id'>
        ) | (
          { __typename: 'LiveEvent' }
          & Pick<ILiveEvent, 'id'>
        ) | (
          { __typename: 'LiveEventsMenu' }
          & Pick<ILiveEventsMenu, 'id'>
        ) | (
          { __typename: 'LiveEventsPage' }
          & Pick<ILiveEventsPage, 'id'>
        ) | (
          { __typename: 'LiveTVPage' }
          & Pick<ILiveTvPage, 'id'>
        ) | (
          { __typename: 'MemberContentTypesLink' }
          & Pick<IMemberContentTypesLink, 'id'>
        ) | (
          { __typename: 'MemberDatas' }
          & Pick<IMemberDatas, 'id'>
        ) | (
          { __typename: 'MemberDownloaded' }
          & Pick<IMemberDownloaded, 'id'>
        ) | (
          { __typename: 'MemberMessage' }
          & Pick<IMemberMessage, 'id'>
        ) | (
          { __typename: 'MemberNotify' }
          & Pick<IMemberNotify, 'id'>
        ) | (
          { __typename: 'MemberOpportunity' }
          & Pick<IMemberOpportunity, 'id'>
        ) | (
          { __typename: 'MemberSaved' }
          & Pick<IMemberSaved, 'id'>
        ) | (
          { __typename: 'MemberSearch' }
          & Pick<IMemberSearch, 'id'>
        ) | (
          { __typename: 'MemberWatched' }
          & Pick<IMemberWatched, 'id'>
        ) | (
          { __typename: 'MembersDatas' }
          & Pick<IMembersDatas, 'id'>
        ) | (
          { __typename: 'MiniSitesFolder' }
          & Pick<IMiniSitesFolder, 'id'>
        ) | (
          { __typename: 'NavMessage' }
          & Pick<INavMessage, 'id'>
        ) | (
          { __typename: 'NavigationMessagesFolder' }
          & Pick<INavigationMessagesFolder, 'id'>
        ) | (
          { __typename: 'NetlifyDeploy' }
          & Pick<INetlifyDeploy, 'id'>
        ) | (
          { __typename: 'News' }
          & Pick<INews, 'id'>
        ) | (
          { __typename: 'NewsCateg' }
          & Pick<INewsCateg, 'id'>
        ) | (
          { __typename: 'NewsFolder' }
          & Pick<INewsFolder, 'id'>
        ) | (
          { __typename: 'NewsPage' }
          & Pick<INewsPage, 'id'>
        ) | (
          { __typename: 'ObtainedJob' }
          & Pick<IObtainedJob, 'id'>
        ) | (
          { __typename: 'Opportunity' }
          & Pick<IOpportunity, 'id'>
        ) | (
          { __typename: 'OpportunityCenter' }
          & Pick<IOpportunityCenter, 'id'>
        ) | (
          { __typename: 'OpportunityFolder' }
          & Pick<IOpportunityFolder, 'id'>
        ) | (
          { __typename: 'Partner' }
          & Pick<IPartner, 'id'>
        ) | (
          { __typename: 'Partners' }
          & Pick<IPartners, 'id'>
        ) | (
          { __typename: 'PartnersPage' }
          & Pick<IPartnersPage, 'id'>
        ) | (
          { __typename: 'Paywall' }
          & Pick<IPaywall, 'id'>
        ) | (
          { __typename: 'PaywallFolder' }
          & Pick<IPaywallFolder, 'id'>
        ) | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'id'>
        ) | (
          { __typename: 'PersonalityQuiz' }
          & Pick<IPersonalityQuiz, 'id'>
        ) | (
          { __typename: 'PersonalityQuiz1' }
          & Pick<IPersonalityQuiz1, 'id'>
        ) | (
          { __typename: 'PersonalityType' }
          & Pick<IPersonalityType, 'id'>
        ) | (
          { __typename: 'Playlist' }
          & Pick<IPlaylist, 'id'>
        ) | (
          { __typename: 'PlaylistRadioMenu' }
          & Pick<IPlaylistRadioMenu, 'id'>
        ) | (
          { __typename: 'Podcast' }
          & Pick<IPodcast, 'id'>
        ) | (
          { __typename: 'PodcastCateg' }
          & Pick<IPodcastCateg, 'id'>
        ) | (
          { __typename: 'PodcastItem' }
          & Pick<IPodcastItem, 'id'>
        ) | (
          { __typename: 'PodcastMenu' }
          & Pick<IPodcastMenu, 'id'>
        ) | (
          { __typename: 'PromoCode' }
          & Pick<IPromoCode, 'id'>
        ) | (
          { __typename: 'PromoCodeFolder' }
          & Pick<IPromoCodeFolder, 'id'>
        ) | (
          { __typename: 'QuizPage' }
          & Pick<IQuizPage, 'id'>
        ) | (
          { __typename: 'QuizzSurvey' }
          & Pick<IQuizzSurvey, 'id'>
        ) | (
          { __typename: 'QuizzSurveyCategory' }
          & Pick<IQuizzSurveyCategory, 'id'>
        ) | (
          { __typename: 'QuizzSurveyCollection' }
          & Pick<IQuizzSurveyCollection, 'id'>
        ) | (
          { __typename: 'Radio' }
          & Pick<IRadio, 'id'>
        ) | (
          { __typename: 'RadioCateg' }
          & Pick<IRadioCateg, 'id'>
        ) | (
          { __typename: 'Region' }
          & Pick<IRegion, 'id'>
        ) | (
          { __typename: 'SectionPage' }
          & Pick<ISectionPage, 'id'>
        ) | (
          { __typename: 'Settings' }
          & Pick<ISettings, 'id'>
        ) | (
          { __typename: 'Space' }
          & Pick<ISpace, 'id'>
        ) | (
          { __typename: 'Subscription' }
          & Pick<ISubscription, 'id'>
        ) | (
          { __typename: 'SubscriptionData' }
          & Pick<ISubscriptionData, 'id'>
        ) | (
          { __typename: 'SubscriptionDataFolder' }
          & Pick<ISubscriptionDataFolder, 'id'>
        ) | (
          { __typename: 'SubscriptionsFolder' }
          & Pick<ISubscriptionsFolder, 'id'>
        ) | (
          { __typename: 'SumaryNugget' }
          & Pick<ISumaryNugget, 'id'>
        ) | (
          { __typename: 'SurveyQuizzFolder' }
          & Pick<ISurveyQuizzFolder, 'id'>
        ) | (
          { __typename: 'TextPage' }
          & Pick<ITextPage, 'id'>
        ) | (
          { __typename: 'ThankYouPage' }
          & Pick<IThankYouPage, 'id'>
        ) | (
          { __typename: 'TranslationContext' }
          & Pick<ITranslationContext, 'id'>
        ) | (
          { __typename: 'TranslationFolder' }
          & Pick<ITranslationFolder, 'id'>
        ) | (
          { __typename: 'TranslationItem' }
          & Pick<ITranslationItem, 'id'>
        ) | (
          { __typename: 'UmbracoTest' }
          & Pick<IUmbracoTest, 'id'>
        ) | (
          { __typename: 'UnitNuggetAnswer' }
          & Pick<IUnitNuggetAnswer, 'id'>
        ) | (
          { __typename: 'UnitNuggetGapFillAnswer' }
          & Pick<IUnitNuggetGapFillAnswer, 'id'>
        ) | (
          { __typename: 'UnitProgression' }
          & Pick<IUnitProgression, 'id'>
        ) | (
          { __typename: 'VODItem' }
          & Pick<IVodItem, 'id'>
        ) | (
          { __typename: 'VODMenu' }
          & Pick<IVodMenu, 'id'>
        ) | (
          { __typename: 'VotingFolder' }
          & Pick<IVotingFolder, 'id'>
        ) | (
          { __typename: 'VotingRecord' }
          & Pick<IVotingRecord, 'id'>
        ) | (
          { __typename: 'WatchCateg' }
          & Pick<IWatchCateg, 'id'>
        )>> }
      ) }
    ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ) }
);

export type ICourseExamFragmentFragment = (
  { __typename: 'CourseExam' }
  & Pick<ICourseExam, 'id' | 'url' | 'description' | 'title' | 'attemptDelay' | 'gradingPolicy' | 'allowedAttempts' | 'length' | 'updateDate' | 'limitedAttempts'>
  & { examNuggets?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | (
    { __typename: 'ChoiceNugget' }
    & IChoiceNuggetFragmentFragment
  ) | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | (
    { __typename: 'GapfillNugget' }
    & IGapfillNuggetFragmentFragment
  ) | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | (
    { __typename: 'SumaryNugget' }
    & ISummaryNuggetFragmentFragment
  ) | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, before?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | (
      { __typename: 'CoursePage' }
      & ICoursePageFragmentFragment
    ) | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'title' | 'name'>
    & { linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
      { __typename: 'Partner' }
      & IPartnerFragmentFragment
    ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, interests?: Maybe<Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id' | 'name'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id' | 'name'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id' | 'name'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id' | 'name'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id' | 'name'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id' | 'name'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id' | 'name'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id' | 'name'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id' | 'name'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id' | 'name'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'name'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id' | 'name'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id' | 'name'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id' | 'name'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id' | 'name'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id' | 'name'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id' | 'name'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id' | 'name'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id' | 'name'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id' | 'name'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id' | 'name'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id' | 'name'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id' | 'name'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id' | 'name'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id' | 'name'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id' | 'name'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id' | 'name'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id' | 'name'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id' | 'name'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id' | 'name'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id' | 'name'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id' | 'name'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id' | 'name'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id' | 'name'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id' | 'name'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id' | 'name'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id' | 'name'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id' | 'name'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id' | 'name'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id' | 'name'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id' | 'name'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id' | 'name'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id' | 'name'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id' | 'name'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id' | 'name'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id' | 'name'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id' | 'name'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id' | 'name'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id' | 'name'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id' | 'name'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id' | 'name'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id' | 'name'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id' | 'name'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id' | 'name'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id' | 'name'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id' | 'name'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id' | 'name'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id' | 'name'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id' | 'name'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id' | 'name'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id' | 'name'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id' | 'name'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id' | 'name'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id' | 'name'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id' | 'name'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id' | 'name'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id' | 'name'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id' | 'name'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id' | 'name'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id' | 'name'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id' | 'name'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id' | 'name'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id' | 'name'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id' | 'name'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id' | 'name'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id' | 'name'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id' | 'name'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id' | 'name'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id' | 'name'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id' | 'name'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id' | 'name'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id' | 'name'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id' | 'name'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id' | 'name'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id' | 'name'>
    )>>>, children: (
      { __typename: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
);

export type ICourseItemsSliderFragmentFragment = (
  { __typename?: 'CourseItemsSlider' }
  & Pick<ICourseItemsSlider, 'title' | 'template'>
  & { contentItems?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
    { __typename: 'Course' }
    & Pick<ICourse, 'title' | 'id' | 'url' | 'length'>
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & Pick<IMediaWithCrops, 'cropUrl'>
      & { url: IMediaWithCrops['cropUrl'] }
    )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
      { __typename: 'Partner' }
      & { logo?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & { url: IMediaWithCrops['cropUrl'] }
      )> }
    ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url' | 'title' | 'length'>
    & { partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
      { __typename?: 'Partner' }
      & { logo?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & { url: IMediaWithCrops['cropUrl'] }
      )> }
    ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, cover?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
        { __typename?: 'HeroVideoCover' }
        & IHeroVideoCoverFragmentFragment
      ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
    )>>>, courses?: Maybe<Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
    )>>> }
  ) | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type ICourseNuggetFragmentFragment = (
  { __typename: 'CourseNugget' }
  & { nuggets?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
    & IChoiceNuggetFragmentFragment
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
    & IGapfillNuggetFragmentFragment
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
    & ISummaryNuggetFragmentFragment
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
);

export type ICoursePageFragmentFragment = (
  { __typename?: 'CoursePage' }
  & Pick<ICoursePage, 'title' | 'subtitle'>
  & { announce?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | (
      { __typename: 'Advantage' }
      & IAdvantageFragmentFragment
    ) | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, navMessage?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | (
    { __typename: 'NavMessage' }
    & INavMessageFragmentFragment
  ) | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>, blocks?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | (
      { __typename: 'UcAudio' }
      & IUcAudioFragmentFragment
    ) | (
      { __typename: 'UcImage' }
      & IUcImageFragmentFragment
    ) | (
      { __typename: 'UcLineBreak' }
      & IUcLineBreakFragmentFragment
    ) | { __typename: 'UcText' } | (
      { __typename: 'UcVideo' }
      & IUcVideoFragmentFragment
    ) | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | (
      { __typename: 'Wysiwyg' }
      & Pick<IWysiwyg, 'title' | 'body'>
    ) }
  )>>>, cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type ICourseUnitFragmentFragment = (
  { __typename: 'CourseUnit' }
  & Pick<ICourseUnit, 'id' | 'url' | 'title' | 'description' | 'name' | 'length' | 'updateDate'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'cropUrl'>
    & { url: IMediaWithCrops['cropUrl'] }
  )>, pages?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | (
      { __typename: 'CourseNugget' }
      & ICourseNuggetFragmentFragment
    ) | (
      { __typename: 'CoursePage' }
      & ICoursePageFragmentFragment
    ) | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url' | 'name'>
    & { linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
      { __typename: 'Partner' }
      & IPartnerFragmentFragment
    ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, interests?: Maybe<Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id' | 'name'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id' | 'name'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id' | 'name'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id' | 'name'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id' | 'name'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id' | 'name'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id' | 'name'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id' | 'name'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id' | 'name'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id' | 'name'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'name'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id' | 'name'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id' | 'name'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id' | 'name'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id' | 'name'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id' | 'name'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id' | 'name'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id' | 'name'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id' | 'name'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id' | 'name'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id' | 'name'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id' | 'name'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id' | 'name'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id' | 'name'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id' | 'name'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id' | 'name'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id' | 'name'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id' | 'name'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id' | 'name'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id' | 'name'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id' | 'name'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id' | 'name'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id' | 'name'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id' | 'name'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id' | 'name'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id' | 'name'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id' | 'name'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id' | 'name'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id' | 'name'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id' | 'name'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id' | 'name'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id' | 'name'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id' | 'name'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id' | 'name'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id' | 'name'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id' | 'name'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id' | 'name'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id' | 'name'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id' | 'name'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id' | 'name'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id' | 'name'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id' | 'name'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id' | 'name'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id' | 'name'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id' | 'name'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id' | 'name'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id' | 'name'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id' | 'name'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id' | 'name'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id' | 'name'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id' | 'name'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id' | 'name'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id' | 'name'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id' | 'name'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id' | 'name'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id' | 'name'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id' | 'name'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id' | 'name'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id' | 'name'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id' | 'name'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id' | 'name'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id' | 'name'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id' | 'name'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id' | 'name'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id' | 'name'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id' | 'name'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id' | 'name'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id' | 'name'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id' | 'name'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id' | 'name'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id' | 'name'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id' | 'name'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id' | 'name'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id' | 'name'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id' | 'name'>
    )>>>, children: (
      { __typename: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'url'>
      )>> }
    ) }
  ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
);

export type IDownloadCourseFragmentFragment = (
  { __typename: 'Course' }
  & Pick<ICourse, 'id' | 'url' | 'name' | 'title' | 'trailer' | 'description' | 'updateDate'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
    { __typename: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | (
      { __typename: 'CourseExam' }
      & ICourseExamFragmentFragment
    ) | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | (
      { __typename: 'CourseUnit' }
      & ICourseUnitFragmentFragment
    ) | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ), interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
);

export type IDownloadJobTrainingFragmentFragment = (
  { __typename: 'JobTraining' }
  & Pick<IJobTraining, 'updateDate' | 'id' | 'url' | 'name' | 'title' | 'description' | 'length' | 'videosCount' | 'multimediaUnits' | 'quizzes' | 'coursesCertificates' | 'trailer'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
    { __typename?: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, courses?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | (
    { __typename?: 'Course' }
    & IDownloadCourseFragmentFragment
  ) | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
);

export type IGapfillNuggetFragmentFragment = (
  { __typename: 'GapfillNugget' }
  & Pick<IGapfillNugget, 'id' | 'title' | 'body' | 'externalId' | 'genericFeedback' | 'positiveFeedback' | 'negativeFeedback' | 'updateDate'>
  & { gapFillText: IGapfillNugget['question'] }
  & { options?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | (
      { __typename: 'GapFillNuggetAnswer' }
      & Pick<IGapFillNuggetAnswer, 'reference' | 'positiveFeedback' | 'negativeFeedback'>
      & { values?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | (
          { __typename: 'NuggetsTextAnswerOption' }
          & Pick<INuggetsTextAnswerOption, 'value' | 'isCorrect'>
          & { image?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & Pick<IMediaWithCrops, 'cropUrl'>
            & { url: IMediaWithCrops['cropUrl'] }
          )> }
        ) | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>> }
    ) | (
      { __typename: 'GapFillNuggetImageAnswer' }
      & Pick<IGapFillNuggetImageAnswer, 'reference' | 'positiveFeedback' | 'negativeFeedback'>
      & { referenceImage?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'cropUrl'>
        & { url: IMediaWithCrops['cropUrl'] }
      )>, values?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | (
          { __typename: 'NuggetsTextAnswerOption' }
          & Pick<INuggetsTextAnswerOption, 'value' | 'isCorrect'>
          & { image?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & Pick<IMediaWithCrops, 'cropUrl'>
            & { url: IMediaWithCrops['cropUrl'] }
          )> }
        ) | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>> }
    ) | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name'>
    & { parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'name'>
      & { linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
        { __typename: 'Partner' }
        & IPartnerFragmentFragment
      ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
    ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
  ) | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
);

export type IEntrepreunarialHubFragmentFragment = (
  { __typename: 'EntrepreunarialHub' }
  & Pick<IEntrepreunarialHub, 'id' | 'hubTitle'>
  & { hubCourses?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | (
    { __typename: 'CourseCategory' }
    & ICourseCategoryFragmentFragment
  ) | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>, tips?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | (
      { __typename: 'CardLink' }
      & ICardLinkFragmentFragment
    ) | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IJobBoardPageFragmentFragment = (
  { __typename: 'JobBoardPage' }
  & Pick<IJobBoardPage, 'id' | 'url' | 'autoloop' | 'loopDelay'>
  & { heroSlider?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | (
      { __typename?: 'HeroSlide' }
      & IHeroSlideFragmentFragment
    ) | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, tipsSlides?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | (
      { __typename?: 'CTASlide' }
      & ICtaSlideFragmentFragment
    ) | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | (
      { __typename?: 'IconSlide' }
      & IIconSlideFragmentFragment
    ) | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | (
      { __typename?: 'TextSlide1' }
      & ITextSlide1FragmentFragment
    ) | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, jobHubs?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | (
    { __typename?: 'JobHub' }
    & IJobHubFragmentFragment
  ) | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, jobVancancies?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'title' | 'shortDescription' | 'id' | 'url' | 'link'>
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & Pick<IMediaWithCrops, 'url'>
    )>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
      { __typename?: 'Partner' }
      & IPartnerFragmentFragment
    ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
  ) | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, activeOppotunities?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'title' | 'shortDescription' | 'startDate' | 'id' | 'url'>
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & Pick<IMediaWithCrops, 'url'>
    )>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
      { __typename?: 'Partner' }
      & IPartnerFragmentFragment
    ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
  ) | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
    { __typename?: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, push?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | (
      { __typename?: 'Push' }
      & IPushFragmentFragment
    ) | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, topMenu?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | (
      { __typename: 'ExpandMenu' }
      & IExpandMenuFragmentFragment
    ) | (
      { __typename: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | (
      { __typename: 'LinkPicker' }
      & ILinkPickerFragmentFragment
    ) | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, children: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id' | 'url'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id' | 'url'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id' | 'url'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id' | 'url'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id' | 'url'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id' | 'url'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id' | 'url'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id' | 'url'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id' | 'url'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id' | 'url'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id' | 'url'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id' | 'url'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id' | 'url'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id' | 'url'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id' | 'url'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id' | 'url'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id' | 'url'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id' | 'url'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'url'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id' | 'url'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id' | 'url'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id' | 'url'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id' | 'url'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id' | 'url'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id' | 'url'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id' | 'url'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id' | 'url'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id' | 'url'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id' | 'url'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id' | 'url'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id' | 'url'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id' | 'url'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id' | 'url'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id' | 'url'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id' | 'url'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id' | 'url'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id' | 'url'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id' | 'url'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id' | 'url'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id' | 'url'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id' | 'url'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id' | 'url'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id' | 'url'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id' | 'url'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id' | 'url'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id' | 'url'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id' | 'url'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id' | 'url'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id' | 'url'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id' | 'url'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id' | 'url'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id' | 'url'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id' | 'url'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id' | 'url'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id' | 'url'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id' | 'url'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id' | 'url'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id' | 'url'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id' | 'url'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id' | 'url'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id' | 'url'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id' | 'url'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id' | 'url'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id' | 'url'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id' | 'url'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id' | 'url'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id' | 'url'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id' | 'url'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id' | 'url'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id' | 'url'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id' | 'url'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id' | 'url'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id' | 'url'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id' | 'url'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id' | 'url'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id' | 'url'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id' | 'url'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id' | 'url'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id' | 'url'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id' | 'url'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id' | 'url'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id' | 'url'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id' | 'url'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id' | 'url'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id' | 'url'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id' | 'url'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id' | 'url'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id' | 'url'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id' | 'url'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id' | 'url'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id' | 'url'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id' | 'url'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'url'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id' | 'url'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id' | 'url'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id' | 'url'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id' | 'url'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id' | 'url'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id' | 'url'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id' | 'url'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id' | 'url'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id' | 'url'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id' | 'url'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id' | 'url'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id' | 'url'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id' | 'url'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id' | 'url'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id' | 'url'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id' | 'url'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id' | 'url'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id' | 'url'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id' | 'url'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id' | 'url'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id' | 'url'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id' | 'url'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id' | 'url'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id' | 'url'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id' | 'url'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id' | 'url'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id' | 'url'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id' | 'url'>
    )>> }
  ) }
);

export type IJobHubFragmentFragment = (
  { __typename: 'JobHub' }
  & Pick<IJobHub, 'id' | 'url' | 'title' | 'shortDescription' | 'longDescription' | 'country' | 'link'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IJobVacancyFragmentFragment = (
  { __typename: 'JobVacancy' }
  & Pick<IJobVacancy, 'id' | 'url' | 'title' | 'link' | 'shortDescription' | 'companyName' | 'contractType' | 'location' | 'country'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'cropUrl'>
    & { url: IMediaWithCrops['cropUrl'] }
  )>, certificate?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url' | 'title'>
  ) | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
    { __typename?: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, personalities?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | (
    { __typename: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, interests?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | (
    { __typename: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, themes?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | (
    { __typename: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type IJobTrainingFragmentFragment = (
  { __typename: 'JobTraining' }
  & Pick<IJobTraining, 'updateDate' | 'id' | 'url' | 'name' | 'title' | 'description' | 'length' | 'videosCount' | 'multimediaUnits' | 'quizzes' | 'coursesCertificates' | 'trailer'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
    { __typename?: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, courses?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | (
    { __typename?: 'Course' }
    & IPartCourseFragmentFragment
  ) | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
);

export type ILearnHeroSildeFragmentFragment = (
  { __typename: 'LearnHeroSlide' }
  & Pick<ILearnHeroSlide, 'title'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, button?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | (
      { __typename?: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, partners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
    { __typename: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type INavMessageFragmentFragment = (
  { __typename: 'NavMessage' }
  & Pick<INavMessage, 'description' | 'title' | 'updateDate'>
  & { image?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IPartCourseFragmentFragment = (
  { __typename: 'Course' }
  & Pick<ICourse, 'title' | 'id' | 'url' | 'length' | 'description'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'cropUrl'>
    & { url: IMediaWithCrops['cropUrl'] }
  )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
    { __typename: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type IPartnersPageFragmentFragment = (
  { __typename: 'PartnersPage' }
  & Pick<IPartnersPage, 'id' | 'url' | 'title' | 'subtitle'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, list?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
    { __typename?: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
);

export type IPersonalityPagesFragmentFragment = (
  { __typename: 'PersonalityPages' }
  & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
  & { icon?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, cover?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, linkedTag?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'color' | 'name' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, body?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | (
      { __typename?: 'UcImage' }
      & IUcImageFragmentFragment
    ) | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | (
      { __typename?: 'Wysiwyg' }
      & IWysiwygFragmentFragment
    ) }
  )>>> }
);

export type IPersonalityPushFragmentFragment = (
  { __typename: 'PersonalityPush' }
  & Pick<IPersonalityPush, 'title' | 'description'>
  & { icon?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IPersonalityQuizFragmentFragment = (
  { __typename: 'PersonalityQuiz' }
  & Pick<IPersonalityQuiz, 'id' | 'url' | 'title' | 'subtitle' | 'ctaLabel'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, children: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
      & { icon?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'url'>
      )> }
    ) | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
  ), personalitiesPush?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | (
      { __typename: 'PersonalityPush' }
      & IPersonalityPushFragmentFragment
    ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, methodologyPush?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | (
      { __typename: 'PersonalityPush' }
      & IPersonalityPushFragmentFragment
    ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IPersonalityQuizQuestionFragmentFragment = (
  { __typename?: 'PersonalityQuizQuestion' }
  & Pick<IPersonalityQuizQuestion, 'weight' | 'label'>
  & { linkedPersonalities?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'title' | 'subtitle' | 'introduction'>
    & { icon?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & { urlOld: IMediaWithCrops['url'], url: IMediaWithCrops['cropUrl'] }
    )>, linkedTag?: Maybe<Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'color' | 'name' | 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
    )>>> }
  ) | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
);

export type IQuizPageFragmentFragment = (
  { __typename: 'QuizPage' }
  & Pick<IQuizPage, 'id' | 'url' | 'title' | 'subtitle' | 'ctaLabel'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, personalitiesPush?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | (
      { __typename: 'PersonalityPush' }
      & IPersonalityPushFragmentFragment
    ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, methodologyPush?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | (
      { __typename: 'PersonalityPush' }
      & IPersonalityPushFragmentFragment
    ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type ISummaryNuggetFragmentFragment = (
  { __typename: 'SumaryNugget' }
  & Pick<ISumaryNugget, 'id' | 'genericFeedback' | 'positiveFeedback' | 'negativeFeedback' | 'externalId' | 'title' | 'updateDate'>
  & { statements?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | (
      { __typename: 'SummaryNuggetStatement' }
      & { options?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | (
          { __typename: 'ChoiceNuggerAnswer' }
          & IChoiceNuggerAnswerFragmentFragment
        ) | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>> }
    ) | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name'>
    & { parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'name'>
      & { linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
        { __typename: 'Partner' }
        & IPartnerFragmentFragment
      ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
    ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
  ) | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
);

export type IUcAudioFragmentFragment = (
  { __typename: 'UcAudio' }
  & Pick<IUcAudio, 'sourceUrl'>
  & { liveEventId: IUcAudio['liveEventID'] }
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IUcImageFragmentFragment = (
  { __typename: 'UcImage' }
  & Pick<IUcImage, 'text'>
  & { image?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IUcLineBreakFragmentFragment = (
  { __typename: 'UcLineBreak' }
  & Pick<IUcLineBreak, 'text'>
  & { lineBreakBody: IUcLineBreak['body'] }
);

export type IUcVideoFragmentFragment = (
  { __typename: 'UcVideo' }
  & Pick<IUcVideo, 'title' | 'subtitle' | 'vimeoURL' | 'sourceUrl'>
  & { liveEventId: IUcVideo['liveEventID'] }
);

export type ILiveEventFragmentFragment = (
  { __typename: 'LiveEvent' }
  & Pick<ILiveEvent, 'id' | 'startDate' | 'endDate' | 'createDate' | 'description' | 'sourceUrl' | 'name' | 'countriesRestriction' | 'shortDescription' | 'subtitle' | 'title' | 'url'>
  & { liveEventId: ILiveEvent['liveEventID'] }
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, regions?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
    { __typename?: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, channel?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | (
    { __typename?: 'Channel' }
    & IChannelFragmentFragment
  ) | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, availableRegions?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>>, musicGenre?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
  & IParentInfo_LiveEvent_Fragment
);

export type ILogoLinkFragmentFragment = (
  { __typename: 'LogoLink' }
  & { logo?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'cropUrl'>
    & { url: IMediaWithCrops['cropUrl'] }
  )>, link?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | (
      { __typename: 'ContentLink' }
      & IContentLinkFragmentFragment
    ) | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | (
      { __typename: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | (
      { __typename: 'InternalLink' }
      & IInternalLinkFragmentFragment
    ) | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IMemberDatasFragmentFragment = (
  { __typename: 'MemberDatas' }
  & Pick<IMemberDatas, 'id' | 'url'>
);

export type IMemberDownloadedFragmentFragment = (
  { __typename: 'MemberDownloaded' }
  & Pick<IMemberDownloaded, 'id' | 'createDate' | 'updateDate'>
  & { contentLink?: Maybe<(
    { __typename?: 'ArtistService' }
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename?: 'AwardsArtist' }
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename?: 'AwardsHomepage' }
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename?: 'CMSPage' }
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename?: 'CategBgColor' }
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename?: 'CategoryPage' }
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename?: 'Channel' }
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename?: 'ChannelFolder' }
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename?: 'ChoiceNugget' }
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename?: 'Collection' }
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename?: 'ContentTag' }
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename?: 'ContentTags' }
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename?: 'Course' }
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename?: 'CourseCategory' }
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename?: 'CourseExam' }
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename?: 'CourseShare' }
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename?: 'CourseStatus' }
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename?: 'CourseTestProgression' }
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename?: 'CourseUnit' }
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename?: 'Discovery' }
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename?: 'FormFolder' }
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename?: 'FormPage' }
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename?: 'GapfillNugget' }
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename?: 'HelpdeskPage' }
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename?: 'HomePage' }
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename?: 'JobBoardPage' }
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename?: 'JobHub' }
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename?: 'JobHubsFolder' }
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename?: 'JobProgress' }
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename?: 'JobShare' }
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename?: 'JobTraining' }
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename?: 'JobVacancy' }
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename?: 'LandingPage' }
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename?: 'LearnMenu' }
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename?: 'LegalsFolder' }
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename?: 'ListenCateg' }
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename?: 'LiveEvent' }
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename?: 'LiveEventsPage' }
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename?: 'LiveTVPage' }
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename?: 'MemberDatas' }
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename?: 'MemberDownloaded' }
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename?: 'MemberMessage' }
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename?: 'MemberNotify' }
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename?: 'MemberOpportunity' }
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename?: 'MemberSaved' }
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename?: 'MemberSearch' }
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename?: 'MemberWatched' }
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename?: 'MembersDatas' }
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename?: 'NavMessage' }
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename?: 'News' }
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename?: 'NewsCateg' }
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename?: 'NewsFolder' }
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename?: 'NewsPage' }
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename?: 'ObtainedJob' }
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename?: 'Opportunity' }
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename?: 'OpportunityCenter' }
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename?: 'OpportunityFolder' }
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename?: 'Partner' }
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename?: 'Partners' }
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename?: 'PartnersPage' }
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename?: 'Paywall' }
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename?: 'PaywallFolder' }
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename?: 'PersonalityPages' }
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename?: 'PersonalityType' }
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename?: 'Playlist' }
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename?: 'Podcast' }
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename?: 'PodcastCateg' }
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename?: 'PodcastItem' }
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename?: 'PodcastMenu' }
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename?: 'PromoCode' }
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename?: 'QuizPage' }
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename?: 'QuizzSurvey' }
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename?: 'Radio' }
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename?: 'RadioCateg' }
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename?: 'Region' }
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename?: 'SectionPage' }
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename?: 'Settings' }
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename?: 'Space' }
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename?: 'Subscription' }
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename?: 'SubscriptionData' }
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename?: 'SumaryNugget' }
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename?: 'TextPage' }
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename?: 'ThankYouPage' }
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename?: 'TranslationContext' }
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename?: 'TranslationFolder' }
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename?: 'TranslationItem' }
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename?: 'UmbracoTest' }
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename?: 'UnitProgression' }
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename?: 'VODItem' }
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename?: 'VODMenu' }
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename?: 'VotingFolder' }
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename?: 'VotingRecord' }
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename?: 'WatchCateg' }
    & IMainContentListFragment_WatchCateg_Fragment
  )> }
);

export type IMemberMessageFragmentFragment = (
  { __typename: 'MemberMessage' }
  & Pick<IMemberMessage, 'id' | 'message' | 'title' | 'url' | 'createDate' | 'updateDate' | 'read'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IMemberNotifyFragmentFragment = (
  { __typename: 'MemberNotify' }
  & Pick<IMemberNotify, 'id' | 'createDate' | 'updateDate' | 'read' | 'contentSource'>
  & { contentLink?: Maybe<(
    { __typename?: 'ArtistService' }
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename?: 'AwardsArtist' }
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename?: 'AwardsHomepage' }
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename?: 'CMSPage' }
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename?: 'CategBgColor' }
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename?: 'CategoryPage' }
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename?: 'Channel' }
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename?: 'ChannelFolder' }
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename?: 'ChoiceNugget' }
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename?: 'Collection' }
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename?: 'ContentTag' }
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename?: 'ContentTags' }
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename?: 'Course' }
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename?: 'CourseCategory' }
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename?: 'CourseExam' }
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename?: 'CourseShare' }
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename?: 'CourseStatus' }
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename?: 'CourseTestProgression' }
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename?: 'CourseUnit' }
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename?: 'Discovery' }
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename?: 'FormFolder' }
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename?: 'FormPage' }
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename?: 'GapfillNugget' }
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename?: 'HelpdeskPage' }
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename?: 'HomePage' }
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename?: 'JobBoardPage' }
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename?: 'JobHub' }
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename?: 'JobHubsFolder' }
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename?: 'JobProgress' }
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename?: 'JobShare' }
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename?: 'JobTraining' }
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename?: 'JobVacancy' }
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename?: 'LandingPage' }
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename?: 'LearnMenu' }
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename?: 'LegalsFolder' }
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename?: 'ListenCateg' }
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename?: 'LiveEvent' }
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename?: 'LiveEventsPage' }
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename?: 'LiveTVPage' }
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename?: 'MemberDatas' }
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename?: 'MemberDownloaded' }
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename?: 'MemberMessage' }
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename?: 'MemberNotify' }
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename?: 'MemberOpportunity' }
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename?: 'MemberSaved' }
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename?: 'MemberSearch' }
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename?: 'MemberWatched' }
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename?: 'MembersDatas' }
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename?: 'NavMessage' }
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename?: 'News' }
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename?: 'NewsCateg' }
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename?: 'NewsFolder' }
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename?: 'NewsPage' }
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename?: 'ObtainedJob' }
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename?: 'Opportunity' }
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename?: 'OpportunityCenter' }
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename?: 'OpportunityFolder' }
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename?: 'Partner' }
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename?: 'Partners' }
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename?: 'PartnersPage' }
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename?: 'Paywall' }
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename?: 'PaywallFolder' }
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename?: 'PersonalityPages' }
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename?: 'PersonalityType' }
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename?: 'Playlist' }
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename?: 'Podcast' }
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename?: 'PodcastCateg' }
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename?: 'PodcastItem' }
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename?: 'PodcastMenu' }
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename?: 'PromoCode' }
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename?: 'QuizPage' }
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename?: 'QuizzSurvey' }
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename?: 'Radio' }
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename?: 'RadioCateg' }
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename?: 'Region' }
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename?: 'SectionPage' }
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename?: 'Settings' }
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename?: 'Space' }
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename?: 'Subscription' }
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename?: 'SubscriptionData' }
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename?: 'SumaryNugget' }
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename?: 'TextPage' }
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename?: 'ThankYouPage' }
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename?: 'TranslationContext' }
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename?: 'TranslationFolder' }
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename?: 'TranslationItem' }
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename?: 'UmbracoTest' }
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename?: 'UnitProgression' }
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename?: 'VODItem' }
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename?: 'VODMenu' }
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename?: 'VotingFolder' }
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename?: 'VotingRecord' }
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename?: 'WatchCateg' }
    & IMainContentListFragment_WatchCateg_Fragment
  )> }
);

export type IMemberOpportunityFragmentFragment = (
  { __typename: 'MemberOpportunity' }
  & Pick<IMemberOpportunity, 'id' | 'name' | 'read' | 'updateDate' | 'createDate'>
  & { contentLink?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | (
    { __typename?: 'Opportunity' }
    & IOpportunityFragmentFragment
  ) | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
);

export type IMemberSavedFragmentFragment = (
  { __typename: 'MemberSaved' }
  & Pick<IMemberSaved, 'id' | 'createDate' | 'updateDate'>
  & { contentLink?: Maybe<(
    { __typename?: 'ArtistService' }
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename?: 'AwardsArtist' }
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename?: 'AwardsHomepage' }
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename?: 'CMSPage' }
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename?: 'CategBgColor' }
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename?: 'CategoryPage' }
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename?: 'Channel' }
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename?: 'ChannelFolder' }
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename?: 'ChoiceNugget' }
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename?: 'Collection' }
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename?: 'ContentTag' }
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename?: 'ContentTags' }
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename?: 'Course' }
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename?: 'CourseCategory' }
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename?: 'CourseExam' }
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename?: 'CourseShare' }
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename?: 'CourseStatus' }
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename?: 'CourseTestProgression' }
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename?: 'CourseUnit' }
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename?: 'Discovery' }
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename?: 'FormFolder' }
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename?: 'FormPage' }
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename?: 'GapfillNugget' }
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename?: 'HelpdeskPage' }
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename?: 'HomePage' }
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename?: 'JobBoardPage' }
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename?: 'JobHub' }
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename?: 'JobHubsFolder' }
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename?: 'JobProgress' }
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename?: 'JobShare' }
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename?: 'JobTraining' }
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename?: 'JobVacancy' }
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename?: 'LandingPage' }
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename?: 'LearnMenu' }
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename?: 'LegalsFolder' }
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename?: 'ListenCateg' }
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename?: 'LiveEvent' }
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename?: 'LiveEventsPage' }
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename?: 'LiveTVPage' }
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename?: 'MemberDatas' }
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename?: 'MemberDownloaded' }
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename?: 'MemberMessage' }
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename?: 'MemberNotify' }
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename?: 'MemberOpportunity' }
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename?: 'MemberSaved' }
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename?: 'MemberSearch' }
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename?: 'MemberWatched' }
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename?: 'MembersDatas' }
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename?: 'NavMessage' }
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename?: 'News' }
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename?: 'NewsCateg' }
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename?: 'NewsFolder' }
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename?: 'NewsPage' }
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename?: 'ObtainedJob' }
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename?: 'Opportunity' }
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename?: 'OpportunityCenter' }
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename?: 'OpportunityFolder' }
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename?: 'Partner' }
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename?: 'Partners' }
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename?: 'PartnersPage' }
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename?: 'Paywall' }
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename?: 'PaywallFolder' }
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename?: 'PersonalityPages' }
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename?: 'PersonalityType' }
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename?: 'Playlist' }
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename?: 'Podcast' }
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename?: 'PodcastCateg' }
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename?: 'PodcastItem' }
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename?: 'PodcastMenu' }
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename?: 'PromoCode' }
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename?: 'QuizPage' }
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename?: 'QuizzSurvey' }
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename?: 'Radio' }
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename?: 'RadioCateg' }
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename?: 'Region' }
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename?: 'SectionPage' }
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename?: 'Settings' }
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename?: 'Space' }
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename?: 'Subscription' }
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename?: 'SubscriptionData' }
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename?: 'SumaryNugget' }
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename?: 'TextPage' }
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename?: 'ThankYouPage' }
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename?: 'TranslationContext' }
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename?: 'TranslationFolder' }
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename?: 'TranslationItem' }
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename?: 'UmbracoTest' }
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename?: 'UnitProgression' }
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename?: 'VODItem' }
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename?: 'VODMenu' }
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename?: 'VotingFolder' }
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename?: 'VotingRecord' }
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename?: 'WatchCateg' }
    & IMainContentListFragment_WatchCateg_Fragment
  )> }
);

export type IMemberSearchFragmentFragment = (
  { __typename: 'MemberSearch' }
  & Pick<IMemberSearch, 'id' | 'url' | 'createDate' | 'updateDate' | 'text'>
);

export type IMemberWatchedFragmentFragment = (
  { __typename: 'MemberWatched' }
  & Pick<IMemberWatched, 'id' | 'watchedTimestamp' | 'createDate' | 'updateDate' | 'length' | 'contentSource'>
  & { contentLink?: Maybe<(
    { __typename?: 'ArtistService' }
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename?: 'AwardsArtist' }
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename?: 'AwardsHomepage' }
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename?: 'CMSPage' }
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename?: 'CategBgColor' }
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename?: 'CategoryPage' }
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename?: 'Channel' }
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename?: 'ChannelFolder' }
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename?: 'ChoiceNugget' }
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename?: 'Collection' }
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename?: 'ContentTag' }
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename?: 'ContentTags' }
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename?: 'Course' }
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename?: 'CourseCategory' }
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename?: 'CourseExam' }
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename?: 'CourseShare' }
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename?: 'CourseStatus' }
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename?: 'CourseTestProgression' }
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename?: 'CourseUnit' }
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename?: 'Discovery' }
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename?: 'FormFolder' }
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename?: 'FormPage' }
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename?: 'GapfillNugget' }
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename?: 'HelpdeskPage' }
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename?: 'HomePage' }
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename?: 'JobBoardPage' }
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename?: 'JobHub' }
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename?: 'JobHubsFolder' }
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename?: 'JobProgress' }
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename?: 'JobShare' }
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename?: 'JobTraining' }
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename?: 'JobVacancy' }
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename?: 'LandingPage' }
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename?: 'LearnMenu' }
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename?: 'LegalsFolder' }
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename?: 'ListenCateg' }
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename?: 'LiveEvent' }
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename?: 'LiveEventsPage' }
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename?: 'LiveTVPage' }
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename?: 'MemberDatas' }
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename?: 'MemberDownloaded' }
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename?: 'MemberMessage' }
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename?: 'MemberNotify' }
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename?: 'MemberOpportunity' }
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename?: 'MemberSaved' }
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename?: 'MemberSearch' }
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename?: 'MemberWatched' }
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename?: 'MembersDatas' }
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename?: 'NavMessage' }
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename?: 'News' }
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename?: 'NewsCateg' }
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename?: 'NewsFolder' }
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename?: 'NewsPage' }
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename?: 'ObtainedJob' }
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename?: 'Opportunity' }
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename?: 'OpportunityCenter' }
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename?: 'OpportunityFolder' }
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename?: 'Partner' }
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename?: 'Partners' }
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename?: 'PartnersPage' }
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename?: 'Paywall' }
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename?: 'PaywallFolder' }
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename?: 'PersonalityPages' }
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename?: 'PersonalityType' }
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename?: 'Playlist' }
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename?: 'Podcast' }
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename?: 'PodcastCateg' }
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename?: 'PodcastItem' }
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename?: 'PodcastMenu' }
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename?: 'PromoCode' }
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename?: 'QuizPage' }
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename?: 'QuizzSurvey' }
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename?: 'Radio' }
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename?: 'RadioCateg' }
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename?: 'Region' }
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename?: 'SectionPage' }
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename?: 'Settings' }
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename?: 'Space' }
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename?: 'Subscription' }
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename?: 'SubscriptionData' }
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename?: 'SumaryNugget' }
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename?: 'TextPage' }
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename?: 'ThankYouPage' }
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename?: 'TranslationContext' }
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename?: 'TranslationFolder' }
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename?: 'TranslationItem' }
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename?: 'UmbracoTest' }
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename?: 'UnitProgression' }
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename?: 'VODItem' }
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename?: 'VODMenu' }
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename?: 'VotingFolder' }
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename?: 'VotingRecord' }
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename?: 'WatchCateg' }
    & IMainContentListFragment_WatchCateg_Fragment
  )> }
);

export type INewsFragmentFragment = (
  { __typename: 'News' }
  & Pick<INews, 'id' | 'url' | 'video' | 'vimeoId' | 'vimeoHlsUrl' | 'sourceUrl' | 'title' | 'startDate' | 'pubDate' | 'shortDescription' | 'countriesRestriction' | 'endDate'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, author?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | (
      { __typename: 'Author' }
      & IAuthorFragmentFragment
    ) | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, regions?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
    { __typename?: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>>, musicGenre?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
  & IParentInfo_News_Fragment
);

export type INewsCategFragmentFragment = (
  { __typename: 'NewsCateg' }
  & Pick<INewsCateg, 'id' | 'name' | 'url' | 'createDate' | 'updateDate'>
  & { children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | (
      { __typename: 'News' }
      & INewsFragmentFragment
    ) | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ) }
);

export type INewsFolderFragmentFragment = (
  { __typename: 'NewsFolder' }
  & Pick<INewsFolder, 'id' | 'name' | 'url' | 'createDate' | 'updateDate'>
  & { children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | (
      { __typename: 'News' }
      & INewsFragmentFragment
    ) | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ) }
);

export type IOpportunityFragmentFragment = (
  { __typename: 'Opportunity' }
  & Pick<IOpportunity, 'id' | 'url' | 'title' | 'name' | 'startDate' | 'endDate' | 'createDate' | 'shortDescription' | 'countriesRestriction' | 'location' | 'pageContent' | 'contractType'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
    { __typename?: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, availableRegions?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, pageCover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, certificate?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url' | 'title'>
  ) | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, personalities?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | (
    { __typename: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, interests?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | (
    { __typename: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, themes?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | (
    { __typename: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
  & IParentInfo_Opportunity_Fragment
);

export type IParentInfo_ArtistService_Fragment = (
  { __typename?: 'ArtistService' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ArtistServiceFolder_Fragment = (
  { __typename?: 'ArtistServiceFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ArtistServicesPage_Fragment = (
  { __typename?: 'ArtistServicesPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_AwardCategoryPage_Fragment = (
  { __typename?: 'AwardCategoryPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_AwardsArtist_Fragment = (
  { __typename?: 'AwardsArtist' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_AwardsCategoryMenu_Fragment = (
  { __typename?: 'AwardsCategoryMenu' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_AwardsCategoryMenuDev_Fragment = (
  { __typename?: 'AwardsCategoryMenuDev' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_AwardsCategoryMenuFolder_Fragment = (
  { __typename?: 'AwardsCategoryMenuFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_AwardsCategoryMenuFolderDev_Fragment = (
  { __typename?: 'AwardsCategoryMenuFolderDev' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_AwardsHomepage_Fragment = (
  { __typename?: 'AwardsHomepage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CmsPage_Fragment = (
  { __typename?: 'CMSPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CategBgColor_Fragment = (
  { __typename?: 'CategBgColor' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CategoryPage_Fragment = (
  { __typename?: 'CategoryPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Channel_Fragment = (
  { __typename?: 'Channel' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ChannelFolder_Fragment = (
  { __typename?: 'ChannelFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ChoiceNugget_Fragment = (
  { __typename?: 'ChoiceNugget' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Collection_Fragment = (
  { __typename?: 'Collection' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ContentEditorFolder_Fragment = (
  { __typename?: 'ContentEditorFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ContentTag_Fragment = (
  { __typename?: 'ContentTag' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ContentTags_Fragment = (
  { __typename?: 'ContentTags' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ContentTagsCateg_Fragment = (
  { __typename?: 'ContentTagsCateg' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Course_Fragment = (
  { __typename?: 'Course' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CourseCategoriesFolder_Fragment = (
  { __typename?: 'CourseCategoriesFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CourseCategory_Fragment = (
  { __typename?: 'CourseCategory' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CourseExam_Fragment = (
  { __typename?: 'CourseExam' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CourseShare_Fragment = (
  { __typename?: 'CourseShare' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CourseStatus_Fragment = (
  { __typename?: 'CourseStatus' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CourseTestProgression_Fragment = (
  { __typename?: 'CourseTestProgression' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_CourseUnit_Fragment = (
  { __typename?: 'CourseUnit' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Discovery_Fragment = (
  { __typename?: 'Discovery' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_DiscoverySlide1_Fragment = (
  { __typename?: 'DiscoverySlide1' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_EntrepreunarialHub_Fragment = (
  { __typename?: 'EntrepreunarialHub' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_FormFolder_Fragment = (
  { __typename?: 'FormFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_FormPage_Fragment = (
  { __typename?: 'FormPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_GapfillNugget_Fragment = (
  { __typename?: 'GapfillNugget' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_HelpdeskCateg_Fragment = (
  { __typename?: 'HelpdeskCateg' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_HelpdeskFolder_Fragment = (
  { __typename?: 'HelpdeskFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_HelpdeskPage_Fragment = (
  { __typename?: 'HelpdeskPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_HomePage_Fragment = (
  { __typename?: 'HomePage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobBoardPage_Fragment = (
  { __typename?: 'JobBoardPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobHub_Fragment = (
  { __typename?: 'JobHub' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobHubsFolder_Fragment = (
  { __typename?: 'JobHubsFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobProgress_Fragment = (
  { __typename?: 'JobProgress' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobShare_Fragment = (
  { __typename?: 'JobShare' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobTraining_Fragment = (
  { __typename?: 'JobTraining' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobTrainingFolder_Fragment = (
  { __typename?: 'JobTrainingFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobVacanciesFolder_Fragment = (
  { __typename?: 'JobVacanciesFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_JobVacancy_Fragment = (
  { __typename?: 'JobVacancy' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_LandingPage_Fragment = (
  { __typename?: 'LandingPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_LearnMenu_Fragment = (
  { __typename?: 'LearnMenu' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_LegalsFolder_Fragment = (
  { __typename?: 'LegalsFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ListenCateg_Fragment = (
  { __typename?: 'ListenCateg' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_LiveEvent_Fragment = (
  { __typename?: 'LiveEvent' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_LiveEventsMenu_Fragment = (
  { __typename?: 'LiveEventsMenu' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_LiveEventsPage_Fragment = (
  { __typename?: 'LiveEventsPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_LiveTvPage_Fragment = (
  { __typename?: 'LiveTVPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberContentTypesLink_Fragment = (
  { __typename?: 'MemberContentTypesLink' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberDatas_Fragment = (
  { __typename?: 'MemberDatas' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberDownloaded_Fragment = (
  { __typename?: 'MemberDownloaded' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberMessage_Fragment = (
  { __typename?: 'MemberMessage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberNotify_Fragment = (
  { __typename?: 'MemberNotify' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberOpportunity_Fragment = (
  { __typename?: 'MemberOpportunity' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberSaved_Fragment = (
  { __typename?: 'MemberSaved' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberSearch_Fragment = (
  { __typename?: 'MemberSearch' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MemberWatched_Fragment = (
  { __typename?: 'MemberWatched' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MembersDatas_Fragment = (
  { __typename?: 'MembersDatas' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_MiniSitesFolder_Fragment = (
  { __typename?: 'MiniSitesFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_NavMessage_Fragment = (
  { __typename?: 'NavMessage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_NavigationMessagesFolder_Fragment = (
  { __typename?: 'NavigationMessagesFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_NetlifyDeploy_Fragment = (
  { __typename?: 'NetlifyDeploy' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_News_Fragment = (
  { __typename?: 'News' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_NewsCateg_Fragment = (
  { __typename?: 'NewsCateg' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_NewsFolder_Fragment = (
  { __typename?: 'NewsFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_NewsPage_Fragment = (
  { __typename?: 'NewsPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ObtainedJob_Fragment = (
  { __typename?: 'ObtainedJob' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Opportunity_Fragment = (
  { __typename?: 'Opportunity' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_OpportunityCenter_Fragment = (
  { __typename?: 'OpportunityCenter' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_OpportunityFolder_Fragment = (
  { __typename?: 'OpportunityFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Partner_Fragment = (
  { __typename?: 'Partner' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Partners_Fragment = (
  { __typename?: 'Partners' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PartnersPage_Fragment = (
  { __typename?: 'PartnersPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Paywall_Fragment = (
  { __typename?: 'Paywall' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PaywallFolder_Fragment = (
  { __typename?: 'PaywallFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PersonalityPages_Fragment = (
  { __typename?: 'PersonalityPages' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PersonalityQuiz_Fragment = (
  { __typename?: 'PersonalityQuiz' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PersonalityQuiz1_Fragment = (
  { __typename?: 'PersonalityQuiz1' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PersonalityType_Fragment = (
  { __typename?: 'PersonalityType' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Playlist_Fragment = (
  { __typename?: 'Playlist' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PlaylistRadioMenu_Fragment = (
  { __typename?: 'PlaylistRadioMenu' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Podcast_Fragment = (
  { __typename?: 'Podcast' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PodcastCateg_Fragment = (
  { __typename?: 'PodcastCateg' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PodcastItem_Fragment = (
  { __typename?: 'PodcastItem' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PodcastMenu_Fragment = (
  { __typename?: 'PodcastMenu' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PromoCode_Fragment = (
  { __typename?: 'PromoCode' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_PromoCodeFolder_Fragment = (
  { __typename?: 'PromoCodeFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_QuizPage_Fragment = (
  { __typename?: 'QuizPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_QuizzSurvey_Fragment = (
  { __typename?: 'QuizzSurvey' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_QuizzSurveyCategory_Fragment = (
  { __typename?: 'QuizzSurveyCategory' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_QuizzSurveyCollection_Fragment = (
  { __typename?: 'QuizzSurveyCollection' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Radio_Fragment = (
  { __typename?: 'Radio' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_RadioCateg_Fragment = (
  { __typename?: 'RadioCateg' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Region_Fragment = (
  { __typename?: 'Region' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_SectionPage_Fragment = (
  { __typename?: 'SectionPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Settings_Fragment = (
  { __typename?: 'Settings' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Space_Fragment = (
  { __typename?: 'Space' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_Subscription_Fragment = (
  { __typename?: 'Subscription' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_SubscriptionData_Fragment = (
  { __typename?: 'SubscriptionData' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_SubscriptionDataFolder_Fragment = (
  { __typename?: 'SubscriptionDataFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_SubscriptionsFolder_Fragment = (
  { __typename?: 'SubscriptionsFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_SumaryNugget_Fragment = (
  { __typename?: 'SumaryNugget' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_SurveyQuizzFolder_Fragment = (
  { __typename?: 'SurveyQuizzFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_TextPage_Fragment = (
  { __typename?: 'TextPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_ThankYouPage_Fragment = (
  { __typename?: 'ThankYouPage' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_TranslationContext_Fragment = (
  { __typename?: 'TranslationContext' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_TranslationFolder_Fragment = (
  { __typename?: 'TranslationFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_TranslationItem_Fragment = (
  { __typename?: 'TranslationItem' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_UmbracoTest_Fragment = (
  { __typename?: 'UmbracoTest' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_UnitNuggetAnswer_Fragment = (
  { __typename?: 'UnitNuggetAnswer' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_UnitNuggetGapFillAnswer_Fragment = (
  { __typename?: 'UnitNuggetGapFillAnswer' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_UnitProgression_Fragment = (
  { __typename?: 'UnitProgression' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_VodItem_Fragment = (
  { __typename?: 'VODItem' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_VodMenu_Fragment = (
  { __typename?: 'VODMenu' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_VotingFolder_Fragment = (
  { __typename?: 'VotingFolder' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_VotingRecord_Fragment = (
  { __typename?: 'VotingRecord' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfo_WatchCateg_Fragment = (
  { __typename?: 'WatchCateg' }
  & { parent?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'countryOfProduction' | 'name' | 'url' | 'id'>
    & { accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
      { __typename?: 'Paywall' }
      & IPaywallFragmentFragment
    ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'name' | 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'name' | 'url' | 'id'>
  )> }
);

export type IParentInfoFragment = IParentInfo_ArtistService_Fragment | IParentInfo_ArtistServiceFolder_Fragment | IParentInfo_ArtistServicesPage_Fragment | IParentInfo_AwardCategoryPage_Fragment | IParentInfo_AwardsArtist_Fragment | IParentInfo_AwardsCategoryMenu_Fragment | IParentInfo_AwardsCategoryMenuDev_Fragment | IParentInfo_AwardsCategoryMenuFolder_Fragment | IParentInfo_AwardsCategoryMenuFolderDev_Fragment | IParentInfo_AwardsHomepage_Fragment | IParentInfo_CmsPage_Fragment | IParentInfo_CategBgColor_Fragment | IParentInfo_CategoryPage_Fragment | IParentInfo_Channel_Fragment | IParentInfo_ChannelFolder_Fragment | IParentInfo_ChoiceNugget_Fragment | IParentInfo_Collection_Fragment | IParentInfo_ContentEditorFolder_Fragment | IParentInfo_ContentTag_Fragment | IParentInfo_ContentTags_Fragment | IParentInfo_ContentTagsCateg_Fragment | IParentInfo_Course_Fragment | IParentInfo_CourseCategoriesFolder_Fragment | IParentInfo_CourseCategory_Fragment | IParentInfo_CourseExam_Fragment | IParentInfo_CourseShare_Fragment | IParentInfo_CourseStatus_Fragment | IParentInfo_CourseTestProgression_Fragment | IParentInfo_CourseUnit_Fragment | IParentInfo_Discovery_Fragment | IParentInfo_DiscoverySlide1_Fragment | IParentInfo_EntrepreunarialHub_Fragment | IParentInfo_FormFolder_Fragment | IParentInfo_FormPage_Fragment | IParentInfo_GapfillNugget_Fragment | IParentInfo_HelpdeskCateg_Fragment | IParentInfo_HelpdeskFolder_Fragment | IParentInfo_HelpdeskPage_Fragment | IParentInfo_HomePage_Fragment | IParentInfo_JobBoardPage_Fragment | IParentInfo_JobHub_Fragment | IParentInfo_JobHubsFolder_Fragment | IParentInfo_JobProgress_Fragment | IParentInfo_JobShare_Fragment | IParentInfo_JobTraining_Fragment | IParentInfo_JobTrainingFolder_Fragment | IParentInfo_JobVacanciesFolder_Fragment | IParentInfo_JobVacancy_Fragment | IParentInfo_LandingPage_Fragment | IParentInfo_LearnMenu_Fragment | IParentInfo_LegalsFolder_Fragment | IParentInfo_ListenCateg_Fragment | IParentInfo_LiveEvent_Fragment | IParentInfo_LiveEventsMenu_Fragment | IParentInfo_LiveEventsPage_Fragment | IParentInfo_LiveTvPage_Fragment | IParentInfo_MemberContentTypesLink_Fragment | IParentInfo_MemberDatas_Fragment | IParentInfo_MemberDownloaded_Fragment | IParentInfo_MemberMessage_Fragment | IParentInfo_MemberNotify_Fragment | IParentInfo_MemberOpportunity_Fragment | IParentInfo_MemberSaved_Fragment | IParentInfo_MemberSearch_Fragment | IParentInfo_MemberWatched_Fragment | IParentInfo_MembersDatas_Fragment | IParentInfo_MiniSitesFolder_Fragment | IParentInfo_NavMessage_Fragment | IParentInfo_NavigationMessagesFolder_Fragment | IParentInfo_NetlifyDeploy_Fragment | IParentInfo_News_Fragment | IParentInfo_NewsCateg_Fragment | IParentInfo_NewsFolder_Fragment | IParentInfo_NewsPage_Fragment | IParentInfo_ObtainedJob_Fragment | IParentInfo_Opportunity_Fragment | IParentInfo_OpportunityCenter_Fragment | IParentInfo_OpportunityFolder_Fragment | IParentInfo_Partner_Fragment | IParentInfo_Partners_Fragment | IParentInfo_PartnersPage_Fragment | IParentInfo_Paywall_Fragment | IParentInfo_PaywallFolder_Fragment | IParentInfo_PersonalityPages_Fragment | IParentInfo_PersonalityQuiz_Fragment | IParentInfo_PersonalityQuiz1_Fragment | IParentInfo_PersonalityType_Fragment | IParentInfo_Playlist_Fragment | IParentInfo_PlaylistRadioMenu_Fragment | IParentInfo_Podcast_Fragment | IParentInfo_PodcastCateg_Fragment | IParentInfo_PodcastItem_Fragment | IParentInfo_PodcastMenu_Fragment | IParentInfo_PromoCode_Fragment | IParentInfo_PromoCodeFolder_Fragment | IParentInfo_QuizPage_Fragment | IParentInfo_QuizzSurvey_Fragment | IParentInfo_QuizzSurveyCategory_Fragment | IParentInfo_QuizzSurveyCollection_Fragment | IParentInfo_Radio_Fragment | IParentInfo_RadioCateg_Fragment | IParentInfo_Region_Fragment | IParentInfo_SectionPage_Fragment | IParentInfo_Settings_Fragment | IParentInfo_Space_Fragment | IParentInfo_Subscription_Fragment | IParentInfo_SubscriptionData_Fragment | IParentInfo_SubscriptionDataFolder_Fragment | IParentInfo_SubscriptionsFolder_Fragment | IParentInfo_SumaryNugget_Fragment | IParentInfo_SurveyQuizzFolder_Fragment | IParentInfo_TextPage_Fragment | IParentInfo_ThankYouPage_Fragment | IParentInfo_TranslationContext_Fragment | IParentInfo_TranslationFolder_Fragment | IParentInfo_TranslationItem_Fragment | IParentInfo_UmbracoTest_Fragment | IParentInfo_UnitNuggetAnswer_Fragment | IParentInfo_UnitNuggetGapFillAnswer_Fragment | IParentInfo_UnitProgression_Fragment | IParentInfo_VodItem_Fragment | IParentInfo_VodMenu_Fragment | IParentInfo_VotingFolder_Fragment | IParentInfo_VotingRecord_Fragment | IParentInfo_WatchCateg_Fragment;

export type IPartnerFragmentFragment = (
  { __typename: 'Partner' }
  & Pick<IPartner, 'id' | 'url' | 'title' | 'subtitle' | 'partnerName' | 'partnerUrl' | 'description' | 'shortDescription' | 'updateDate'>
  & { logo?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, cover?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IPaywallPreviewFragmentFragment = (
  { __typename?: 'Paywall' }
  & Pick<IPaywall, 'previewDurationVod' | 'previewDurationTv' | 'playerPremiumText' | 'disabledPreview' | 'previewTitle' | 'previewSubtitle' | 'previewAnimatedTitle' | 'previewLabelCta' | 'previewCancelMention' | 'previewMentionFooter' | 'previewAnimationDuration' | 'previewHighlightedSubtitle'>
  & { previewCoverMobile?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, previewCoverDesktop?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, previewIcon?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'url'>
  )> }
);

export type IPaywallFragmentFragment = (
  { __typename: 'Paywall' }
  & Pick<IPaywall, 'id' | 'title' | 'subtitle' | 'previewDurationVod' | 'previewDurationTv' | 'playerPremiumText' | 'disabledPreview' | 'url'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, pageBlocks?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | (
      { __typename: 'AdvantagesList' }
      & IAdvantagesListFragmentFragment
    ) | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | (
      { __typename: 'ServicesList' }
      & IServicesListFragmentFragment
    ) | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | (
      { __typename: 'SubscriptionsList' }
      & ISubscriptionsListFragmentFragment
    ) | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
  & IPaywallPreviewFragmentFragment
);

export type IPlaylistFragmentFragment = (
  { __typename: 'Playlist' }
  & Pick<IPlaylist, 'id' | 'startDate' | 'updateDate' | 'sortOrder' | 'url' | 'epg' | 'hls' | 'countriesRestriction'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, regions?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
    { __typename?: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, availableRegions?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>>, musicGenre?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
  & IContentItemsFragment_Playlist_Fragment
  & IParentInfo_Playlist_Fragment
);

export type IPodcastFragmentFragment = (
  { __typename: 'Podcast' }
  & Pick<IPodcast, 'id' | 'episodesCount' | 'seasonsCount' | 'releaseDate' | 'length' | 'url' | 'countriesRestriction' | 'description' | 'trailer'>
  & { author?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | (
      { __typename: 'Author' }
      & IAuthorFragmentFragment
    ) | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, children: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | (
      { __typename: 'PodcastItem' }
      & IPodcastItemFragmentFragment
    ) | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>, edges: Array<Maybe<(
      { __typename?: 'ContentEdge' }
      & IContentEdgeFragmentFragment
    )>> }
  ), accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, regions?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
    { __typename?: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, availableRegions?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
  & IContentItemsFragment_Podcast_Fragment
  & IParentInfo_Podcast_Fragment
);

export type IPodcastCategFragmentFragment = (
  { __typename: 'PodcastCateg' }
  & Pick<IPodcastCateg, 'id' | 'url' | 'name'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & IMainContentListFragment_ArtistService_Fragment
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & IMainContentListFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename: 'ArtistServicesPage' }
      & IMainContentListFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename: 'AwardCategoryPage' }
      & IMainContentListFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename: 'AwardsArtist' }
      & IMainContentListFragment_AwardsArtist_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & IMainContentListFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename: 'AwardsHomepage' }
      & IMainContentListFragment_AwardsHomepage_Fragment
    ) | (
      { __typename: 'CMSPage' }
      & IMainContentListFragment_CmsPage_Fragment
    ) | (
      { __typename: 'CategBgColor' }
      & IMainContentListFragment_CategBgColor_Fragment
    ) | (
      { __typename: 'CategoryPage' }
      & IMainContentListFragment_CategoryPage_Fragment
    ) | (
      { __typename: 'Channel' }
      & IMainContentListFragment_Channel_Fragment
    ) | (
      { __typename: 'ChannelFolder' }
      & IMainContentListFragment_ChannelFolder_Fragment
    ) | (
      { __typename: 'ChoiceNugget' }
      & IMainContentListFragment_ChoiceNugget_Fragment
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Collection_Fragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & IMainContentListFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename: 'ContentTag' }
      & IMainContentListFragment_ContentTag_Fragment
    ) | (
      { __typename: 'ContentTags' }
      & IMainContentListFragment_ContentTags_Fragment
    ) | (
      { __typename: 'ContentTagsCateg' }
      & IMainContentListFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename: 'Course' }
      & IMainContentListFragment_Course_Fragment
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & IMainContentListFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename: 'CourseCategory' }
      & IMainContentListFragment_CourseCategory_Fragment
    ) | (
      { __typename: 'CourseExam' }
      & IMainContentListFragment_CourseExam_Fragment
    ) | (
      { __typename: 'CourseShare' }
      & IMainContentListFragment_CourseShare_Fragment
    ) | (
      { __typename: 'CourseStatus' }
      & IMainContentListFragment_CourseStatus_Fragment
    ) | (
      { __typename: 'CourseTestProgression' }
      & IMainContentListFragment_CourseTestProgression_Fragment
    ) | (
      { __typename: 'CourseUnit' }
      & IMainContentListFragment_CourseUnit_Fragment
    ) | (
      { __typename: 'Discovery' }
      & IMainContentListFragment_Discovery_Fragment
    ) | (
      { __typename: 'DiscoverySlide1' }
      & IMainContentListFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & IMainContentListFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename: 'FormFolder' }
      & IMainContentListFragment_FormFolder_Fragment
    ) | (
      { __typename: 'FormPage' }
      & IMainContentListFragment_FormPage_Fragment
    ) | (
      { __typename: 'GapfillNugget' }
      & IMainContentListFragment_GapfillNugget_Fragment
    ) | (
      { __typename: 'HelpdeskCateg' }
      & IMainContentListFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename: 'HelpdeskFolder' }
      & IMainContentListFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename: 'HelpdeskPage' }
      & IMainContentListFragment_HelpdeskPage_Fragment
    ) | (
      { __typename: 'HomePage' }
      & IMainContentListFragment_HomePage_Fragment
    ) | (
      { __typename: 'JobBoardPage' }
      & IMainContentListFragment_JobBoardPage_Fragment
    ) | (
      { __typename: 'JobHub' }
      & IMainContentListFragment_JobHub_Fragment
    ) | (
      { __typename: 'JobHubsFolder' }
      & IMainContentListFragment_JobHubsFolder_Fragment
    ) | (
      { __typename: 'JobProgress' }
      & IMainContentListFragment_JobProgress_Fragment
    ) | (
      { __typename: 'JobShare' }
      & IMainContentListFragment_JobShare_Fragment
    ) | (
      { __typename: 'JobTraining' }
      & IMainContentListFragment_JobTraining_Fragment
    ) | (
      { __typename: 'JobTrainingFolder' }
      & IMainContentListFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & IMainContentListFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename: 'JobVacancy' }
      & IMainContentListFragment_JobVacancy_Fragment
    ) | (
      { __typename: 'LandingPage' }
      & IMainContentListFragment_LandingPage_Fragment
    ) | (
      { __typename: 'LearnMenu' }
      & IMainContentListFragment_LearnMenu_Fragment
    ) | (
      { __typename: 'LegalsFolder' }
      & IMainContentListFragment_LegalsFolder_Fragment
    ) | (
      { __typename: 'ListenCateg' }
      & IMainContentListFragment_ListenCateg_Fragment
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_LiveEvent_Fragment
    ) | (
      { __typename: 'LiveEventsMenu' }
      & IMainContentListFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename: 'LiveEventsPage' }
      & IMainContentListFragment_LiveEventsPage_Fragment
    ) | (
      { __typename: 'LiveTVPage' }
      & IMainContentListFragment_LiveTvPage_Fragment
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & IMainContentListFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename: 'MemberDatas' }
      & IMainContentListFragment_MemberDatas_Fragment
    ) | (
      { __typename: 'MemberDownloaded' }
      & IMainContentListFragment_MemberDownloaded_Fragment
    ) | (
      { __typename: 'MemberMessage' }
      & IMainContentListFragment_MemberMessage_Fragment
    ) | (
      { __typename: 'MemberNotify' }
      & IMainContentListFragment_MemberNotify_Fragment
    ) | (
      { __typename: 'MemberOpportunity' }
      & IMainContentListFragment_MemberOpportunity_Fragment
    ) | (
      { __typename: 'MemberSaved' }
      & IMainContentListFragment_MemberSaved_Fragment
    ) | (
      { __typename: 'MemberSearch' }
      & IMainContentListFragment_MemberSearch_Fragment
    ) | (
      { __typename: 'MemberWatched' }
      & IMainContentListFragment_MemberWatched_Fragment
    ) | (
      { __typename: 'MembersDatas' }
      & IMainContentListFragment_MembersDatas_Fragment
    ) | (
      { __typename: 'MiniSitesFolder' }
      & IMainContentListFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename: 'NavMessage' }
      & IMainContentListFragment_NavMessage_Fragment
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & IMainContentListFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename: 'NetlifyDeploy' }
      & IMainContentListFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename: 'News' }
      & IMainContentListFragment_News_Fragment
    ) | (
      { __typename: 'NewsCateg' }
      & IMainContentListFragment_NewsCateg_Fragment
    ) | (
      { __typename: 'NewsFolder' }
      & IMainContentListFragment_NewsFolder_Fragment
    ) | (
      { __typename: 'NewsPage' }
      & IMainContentListFragment_NewsPage_Fragment
    ) | (
      { __typename: 'ObtainedJob' }
      & IMainContentListFragment_ObtainedJob_Fragment
    ) | (
      { __typename: 'Opportunity' }
      & IMainContentListFragment_Opportunity_Fragment
    ) | (
      { __typename: 'OpportunityCenter' }
      & IMainContentListFragment_OpportunityCenter_Fragment
    ) | (
      { __typename: 'OpportunityFolder' }
      & IMainContentListFragment_OpportunityFolder_Fragment
    ) | (
      { __typename: 'Partner' }
      & IMainContentListFragment_Partner_Fragment
    ) | (
      { __typename: 'Partners' }
      & IMainContentListFragment_Partners_Fragment
    ) | (
      { __typename: 'PartnersPage' }
      & IMainContentListFragment_PartnersPage_Fragment
    ) | (
      { __typename: 'Paywall' }
      & IMainContentListFragment_Paywall_Fragment
    ) | (
      { __typename: 'PaywallFolder' }
      & IMainContentListFragment_PaywallFolder_Fragment
    ) | (
      { __typename: 'PersonalityPages' }
      & IMainContentListFragment_PersonalityPages_Fragment
    ) | (
      { __typename: 'PersonalityQuiz' }
      & IMainContentListFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & IMainContentListFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename: 'PersonalityType' }
      & IMainContentListFragment_PersonalityType_Fragment
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Playlist_Fragment
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & IMainContentListFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Podcast_Fragment
    ) | (
      { __typename: 'PodcastCateg' }
      & IMainContentListFragment_PodcastCateg_Fragment
    ) | (
      { __typename: 'PodcastItem' }
      & IMainContentListFragment_PodcastItem_Fragment
    ) | (
      { __typename: 'PodcastMenu' }
      & IMainContentListFragment_PodcastMenu_Fragment
    ) | (
      { __typename: 'PromoCode' }
      & IMainContentListFragment_PromoCode_Fragment
    ) | (
      { __typename: 'PromoCodeFolder' }
      & IMainContentListFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename: 'QuizPage' }
      & IMainContentListFragment_QuizPage_Fragment
    ) | (
      { __typename: 'QuizzSurvey' }
      & IMainContentListFragment_QuizzSurvey_Fragment
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & IMainContentListFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & IMainContentListFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Radio_Fragment
    ) | (
      { __typename: 'RadioCateg' }
      & IMainContentListFragment_RadioCateg_Fragment
    ) | (
      { __typename: 'Region' }
      & IMainContentListFragment_Region_Fragment
    ) | (
      { __typename: 'SectionPage' }
      & IMainContentListFragment_SectionPage_Fragment
    ) | (
      { __typename: 'Settings' }
      & IMainContentListFragment_Settings_Fragment
    ) | (
      { __typename: 'Space' }
      & IMainContentListFragment_Space_Fragment
    ) | (
      { __typename: 'Subscription' }
      & IMainContentListFragment_Subscription_Fragment
    ) | (
      { __typename: 'SubscriptionData' }
      & IMainContentListFragment_SubscriptionData_Fragment
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & IMainContentListFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & IMainContentListFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename: 'SumaryNugget' }
      & IMainContentListFragment_SumaryNugget_Fragment
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & IMainContentListFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename: 'TextPage' }
      & IMainContentListFragment_TextPage_Fragment
    ) | (
      { __typename: 'ThankYouPage' }
      & IMainContentListFragment_ThankYouPage_Fragment
    ) | (
      { __typename: 'TranslationContext' }
      & IMainContentListFragment_TranslationContext_Fragment
    ) | (
      { __typename: 'TranslationFolder' }
      & IMainContentListFragment_TranslationFolder_Fragment
    ) | (
      { __typename: 'TranslationItem' }
      & IMainContentListFragment_TranslationItem_Fragment
    ) | (
      { __typename: 'UmbracoTest' }
      & IMainContentListFragment_UmbracoTest_Fragment
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & IMainContentListFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename: 'UnitProgression' }
      & IMainContentListFragment_UnitProgression_Fragment
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_VodItem_Fragment
    ) | (
      { __typename: 'VODMenu' }
      & IMainContentListFragment_VodMenu_Fragment
    ) | (
      { __typename: 'VotingFolder' }
      & IMainContentListFragment_VotingFolder_Fragment
    ) | (
      { __typename: 'VotingRecord' }
      & IMainContentListFragment_VotingRecord_Fragment
    ) | (
      { __typename: 'WatchCateg' }
      & IMainContentListFragment_WatchCateg_Fragment
    )>> }
  ) }
);

export type IPodcastItemFragmentFragment = (
  { __typename: 'PodcastItem' }
  & Pick<IPodcastItem, 'id' | 'updateDate' | 'sortOrder' | 'public' | 'url' | 'title' | 'shortDescription' | 'description' | 'length' | 'releaseDate' | 'name' | 'vimeoId' | 'vimeoHlsUrl'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, parent?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'title' | 'id' | 'url'>
  ) | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
);

export type IQuizItemsSliderFragmentFragment = (
  { __typename: 'QuizItemsSlider' }
  & Pick<IQuizItemsSlider, 'title' | 'template' | 'showThumbnailTitle' | 'showThumbnailsSubtitle'>
  & { contentItems?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'title' | 'id' | 'shortDescription'>
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & Pick<IMediaWithCrops, 'url'>
      & { bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
    )> }
  ) | { __typename: 'QuizzSurveyCategory' } | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'title' | 'id' | 'shortDescription'>
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & Pick<IMediaWithCrops, 'url'>
      & { bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
    )> }
  ) | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type IQuizzSurveyFragmentFragment = (
  { __typename: 'QuizzSurvey' }
  & Pick<IQuizzSurvey, 'id' | 'url' | 'shortDescription' | 'title' | 'vimeoHlsUrl' | 'sourceUrl' | 'ctaLabel'>
  & { liveEventId: IQuizzSurvey['liveEventID'] }
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, questions?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'genericFeedback' | 'positiveFeedback' | 'negativeFeedback' | 'externalId'>
    & { question?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | (
        { __typename?: 'UcAudio' }
        & IUcAudioFragmentFragment
      ) | (
        { __typename?: 'UcImage' }
        & IUcImageFragmentFragment
      ) | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | (
        { __typename?: 'UcVideo' }
        & IUcVideoFragmentFragment
      ) | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | (
        { __typename: 'Wysiwyg' }
        & Pick<IWysiwyg, 'title' | 'body'>
      ) }
    )>>>, options?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | (
        { __typename?: 'ChoiceNuggerAnswer' }
        & IChoiceNuggerAnswerFragmentFragment
      ) | { __typename?: 'ChoiceNugget' } | (
        { __typename?: 'ChoiceNuggetAnswerGroup' }
        & { answersList?: Maybe<Array<Maybe<(
          { __typename?: 'BlockListItem' }
          & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | (
            { __typename: 'ChoiceNuggerAnswer' }
            & IChoiceNuggerAnswerFragmentFragment
          ) | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
        )>>> }
      ) | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
    )>>> }
  ) | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type IQuizzSurveyCategoryFragmentFragment = (
  { __typename: 'QuizzSurveyCategory' }
  & Pick<IQuizzSurveyCategory, 'id' | 'url' | 'name' | 'backgroundColor'>
  & { children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & IMainContentListFragment_ArtistService_Fragment
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & IMainContentListFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename: 'ArtistServicesPage' }
      & IMainContentListFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename: 'AwardCategoryPage' }
      & IMainContentListFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename: 'AwardsArtist' }
      & IMainContentListFragment_AwardsArtist_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & IMainContentListFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename: 'AwardsHomepage' }
      & IMainContentListFragment_AwardsHomepage_Fragment
    ) | (
      { __typename: 'CMSPage' }
      & IMainContentListFragment_CmsPage_Fragment
    ) | (
      { __typename: 'CategBgColor' }
      & IMainContentListFragment_CategBgColor_Fragment
    ) | (
      { __typename: 'CategoryPage' }
      & IMainContentListFragment_CategoryPage_Fragment
    ) | (
      { __typename: 'Channel' }
      & IMainContentListFragment_Channel_Fragment
    ) | (
      { __typename: 'ChannelFolder' }
      & IMainContentListFragment_ChannelFolder_Fragment
    ) | (
      { __typename: 'ChoiceNugget' }
      & IMainContentListFragment_ChoiceNugget_Fragment
    ) | (
      { __typename: 'Collection' }
      & IMainContentListFragment_Collection_Fragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & IMainContentListFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename: 'ContentTag' }
      & IMainContentListFragment_ContentTag_Fragment
    ) | (
      { __typename: 'ContentTags' }
      & IMainContentListFragment_ContentTags_Fragment
    ) | (
      { __typename: 'ContentTagsCateg' }
      & IMainContentListFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename: 'Course' }
      & IMainContentListFragment_Course_Fragment
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & IMainContentListFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename: 'CourseCategory' }
      & IMainContentListFragment_CourseCategory_Fragment
    ) | (
      { __typename: 'CourseExam' }
      & IMainContentListFragment_CourseExam_Fragment
    ) | (
      { __typename: 'CourseShare' }
      & IMainContentListFragment_CourseShare_Fragment
    ) | (
      { __typename: 'CourseStatus' }
      & IMainContentListFragment_CourseStatus_Fragment
    ) | (
      { __typename: 'CourseTestProgression' }
      & IMainContentListFragment_CourseTestProgression_Fragment
    ) | (
      { __typename: 'CourseUnit' }
      & IMainContentListFragment_CourseUnit_Fragment
    ) | (
      { __typename: 'Discovery' }
      & IMainContentListFragment_Discovery_Fragment
    ) | (
      { __typename: 'DiscoverySlide1' }
      & IMainContentListFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & IMainContentListFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename: 'FormFolder' }
      & IMainContentListFragment_FormFolder_Fragment
    ) | (
      { __typename: 'FormPage' }
      & IMainContentListFragment_FormPage_Fragment
    ) | (
      { __typename: 'GapfillNugget' }
      & IMainContentListFragment_GapfillNugget_Fragment
    ) | (
      { __typename: 'HelpdeskCateg' }
      & IMainContentListFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename: 'HelpdeskFolder' }
      & IMainContentListFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename: 'HelpdeskPage' }
      & IMainContentListFragment_HelpdeskPage_Fragment
    ) | (
      { __typename: 'HomePage' }
      & IMainContentListFragment_HomePage_Fragment
    ) | (
      { __typename: 'JobBoardPage' }
      & IMainContentListFragment_JobBoardPage_Fragment
    ) | (
      { __typename: 'JobHub' }
      & IMainContentListFragment_JobHub_Fragment
    ) | (
      { __typename: 'JobHubsFolder' }
      & IMainContentListFragment_JobHubsFolder_Fragment
    ) | (
      { __typename: 'JobProgress' }
      & IMainContentListFragment_JobProgress_Fragment
    ) | (
      { __typename: 'JobShare' }
      & IMainContentListFragment_JobShare_Fragment
    ) | (
      { __typename: 'JobTraining' }
      & IMainContentListFragment_JobTraining_Fragment
    ) | (
      { __typename: 'JobTrainingFolder' }
      & IMainContentListFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & IMainContentListFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename: 'JobVacancy' }
      & IMainContentListFragment_JobVacancy_Fragment
    ) | (
      { __typename: 'LandingPage' }
      & IMainContentListFragment_LandingPage_Fragment
    ) | (
      { __typename: 'LearnMenu' }
      & IMainContentListFragment_LearnMenu_Fragment
    ) | (
      { __typename: 'LegalsFolder' }
      & IMainContentListFragment_LegalsFolder_Fragment
    ) | (
      { __typename: 'ListenCateg' }
      & IMainContentListFragment_ListenCateg_Fragment
    ) | (
      { __typename: 'LiveEvent' }
      & IMainContentListFragment_LiveEvent_Fragment
    ) | (
      { __typename: 'LiveEventsMenu' }
      & IMainContentListFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename: 'LiveEventsPage' }
      & IMainContentListFragment_LiveEventsPage_Fragment
    ) | (
      { __typename: 'LiveTVPage' }
      & IMainContentListFragment_LiveTvPage_Fragment
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & IMainContentListFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename: 'MemberDatas' }
      & IMainContentListFragment_MemberDatas_Fragment
    ) | (
      { __typename: 'MemberDownloaded' }
      & IMainContentListFragment_MemberDownloaded_Fragment
    ) | (
      { __typename: 'MemberMessage' }
      & IMainContentListFragment_MemberMessage_Fragment
    ) | (
      { __typename: 'MemberNotify' }
      & IMainContentListFragment_MemberNotify_Fragment
    ) | (
      { __typename: 'MemberOpportunity' }
      & IMainContentListFragment_MemberOpportunity_Fragment
    ) | (
      { __typename: 'MemberSaved' }
      & IMainContentListFragment_MemberSaved_Fragment
    ) | (
      { __typename: 'MemberSearch' }
      & IMainContentListFragment_MemberSearch_Fragment
    ) | (
      { __typename: 'MemberWatched' }
      & IMainContentListFragment_MemberWatched_Fragment
    ) | (
      { __typename: 'MembersDatas' }
      & IMainContentListFragment_MembersDatas_Fragment
    ) | (
      { __typename: 'MiniSitesFolder' }
      & IMainContentListFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename: 'NavMessage' }
      & IMainContentListFragment_NavMessage_Fragment
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & IMainContentListFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename: 'NetlifyDeploy' }
      & IMainContentListFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename: 'News' }
      & IMainContentListFragment_News_Fragment
    ) | (
      { __typename: 'NewsCateg' }
      & IMainContentListFragment_NewsCateg_Fragment
    ) | (
      { __typename: 'NewsFolder' }
      & IMainContentListFragment_NewsFolder_Fragment
    ) | (
      { __typename: 'NewsPage' }
      & IMainContentListFragment_NewsPage_Fragment
    ) | (
      { __typename: 'ObtainedJob' }
      & IMainContentListFragment_ObtainedJob_Fragment
    ) | (
      { __typename: 'Opportunity' }
      & IMainContentListFragment_Opportunity_Fragment
    ) | (
      { __typename: 'OpportunityCenter' }
      & IMainContentListFragment_OpportunityCenter_Fragment
    ) | (
      { __typename: 'OpportunityFolder' }
      & IMainContentListFragment_OpportunityFolder_Fragment
    ) | (
      { __typename: 'Partner' }
      & IMainContentListFragment_Partner_Fragment
    ) | (
      { __typename: 'Partners' }
      & IMainContentListFragment_Partners_Fragment
    ) | (
      { __typename: 'PartnersPage' }
      & IMainContentListFragment_PartnersPage_Fragment
    ) | (
      { __typename: 'Paywall' }
      & IMainContentListFragment_Paywall_Fragment
    ) | (
      { __typename: 'PaywallFolder' }
      & IMainContentListFragment_PaywallFolder_Fragment
    ) | (
      { __typename: 'PersonalityPages' }
      & IMainContentListFragment_PersonalityPages_Fragment
    ) | (
      { __typename: 'PersonalityQuiz' }
      & IMainContentListFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & IMainContentListFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename: 'PersonalityType' }
      & IMainContentListFragment_PersonalityType_Fragment
    ) | (
      { __typename: 'Playlist' }
      & IMainContentListFragment_Playlist_Fragment
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & IMainContentListFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename: 'Podcast' }
      & IMainContentListFragment_Podcast_Fragment
    ) | (
      { __typename: 'PodcastCateg' }
      & IMainContentListFragment_PodcastCateg_Fragment
    ) | (
      { __typename: 'PodcastItem' }
      & IMainContentListFragment_PodcastItem_Fragment
    ) | (
      { __typename: 'PodcastMenu' }
      & IMainContentListFragment_PodcastMenu_Fragment
    ) | (
      { __typename: 'PromoCode' }
      & IMainContentListFragment_PromoCode_Fragment
    ) | (
      { __typename: 'PromoCodeFolder' }
      & IMainContentListFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename: 'QuizPage' }
      & IMainContentListFragment_QuizPage_Fragment
    ) | (
      { __typename: 'QuizzSurvey' }
      & IMainContentListFragment_QuizzSurvey_Fragment
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & IMainContentListFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & IMainContentListFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename: 'Radio' }
      & IMainContentListFragment_Radio_Fragment
    ) | (
      { __typename: 'RadioCateg' }
      & IMainContentListFragment_RadioCateg_Fragment
    ) | (
      { __typename: 'Region' }
      & IMainContentListFragment_Region_Fragment
    ) | (
      { __typename: 'SectionPage' }
      & IMainContentListFragment_SectionPage_Fragment
    ) | (
      { __typename: 'Settings' }
      & IMainContentListFragment_Settings_Fragment
    ) | (
      { __typename: 'Space' }
      & IMainContentListFragment_Space_Fragment
    ) | (
      { __typename: 'Subscription' }
      & IMainContentListFragment_Subscription_Fragment
    ) | (
      { __typename: 'SubscriptionData' }
      & IMainContentListFragment_SubscriptionData_Fragment
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & IMainContentListFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & IMainContentListFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename: 'SumaryNugget' }
      & IMainContentListFragment_SumaryNugget_Fragment
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & IMainContentListFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename: 'TextPage' }
      & IMainContentListFragment_TextPage_Fragment
    ) | (
      { __typename: 'ThankYouPage' }
      & IMainContentListFragment_ThankYouPage_Fragment
    ) | (
      { __typename: 'TranslationContext' }
      & IMainContentListFragment_TranslationContext_Fragment
    ) | (
      { __typename: 'TranslationFolder' }
      & IMainContentListFragment_TranslationFolder_Fragment
    ) | (
      { __typename: 'TranslationItem' }
      & IMainContentListFragment_TranslationItem_Fragment
    ) | (
      { __typename: 'UmbracoTest' }
      & IMainContentListFragment_UmbracoTest_Fragment
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & IMainContentListFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename: 'UnitProgression' }
      & IMainContentListFragment_UnitProgression_Fragment
    ) | (
      { __typename: 'VODItem' }
      & IMainContentListFragment_VodItem_Fragment
    ) | (
      { __typename: 'VODMenu' }
      & IMainContentListFragment_VodMenu_Fragment
    ) | (
      { __typename: 'VotingFolder' }
      & IMainContentListFragment_VotingFolder_Fragment
    ) | (
      { __typename: 'VotingRecord' }
      & IMainContentListFragment_VotingRecord_Fragment
    ) | (
      { __typename: 'WatchCateg' }
      & IMainContentListFragment_WatchCateg_Fragment
    )>> }
  ) }
);

export type IQuizzSurveyCollectionFragmentFragment = (
  { __typename: 'QuizzSurveyCollection' }
  & Pick<IQuizzSurveyCollection, 'id' | 'updateDate' | 'sortOrder' | 'shortDescription' | 'url' | 'title' | 'subtitle' | 'quizzCTALabel' | 'playerCTALabel'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'url'>
    & { bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, children: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'vimeoHlsUrl' | 'sourceUrl' | 'title' | 'id' | 'url' | 'ctaLabel' | 'shortDescription'>
      & { liveEventId: IQuizzSurvey['liveEventID'] }
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'url'>
        & { bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
      )>, questions?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
    ) | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ), questions?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type IQuizzSurveyCollectionLiteFragmentFragment = (
  { __typename: 'QuizzSurveyCollection' }
  & Pick<IQuizzSurveyCollection, 'id' | 'shortDescription' | 'url' | 'title' | 'subtitle'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'url'>
    & { bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IQuizzSurveyLiteFragmentFragment = (
  { __typename: 'QuizzSurvey' }
  & Pick<IQuizzSurvey, 'id' | 'url' | 'shortDescription' | 'title' | 'vimeoHlsUrl' | 'sourceUrl'>
  & { liveEventId: IQuizzSurvey['liveEventID'] }
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'url'>
    & { bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IQuizzSurveyRelatedContentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IQuizzSurveyRelatedContentQuery = (
  { __typename?: 'Query' }
  & { quizzSurveyCollection?: Maybe<(
    { __typename: 'QuizzSurveyCollection' }
    & { parent?: Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id' | 'url' | 'name' | 'backgroundColor'>
      & { children: (
        { __typename: 'ContentConnection' }
        & { items: Array<Maybe<(
          { __typename: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )>> }
      ) }
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
    )> }
  )> }
);

export type IRadioFragmentFragment = (
  { __typename: 'Radio' }
  & Pick<IRadio, 'id' | 'startDate' | 'updateDate' | 'sortOrder' | 'url' | 'epg' | 'hls' | 'description' | 'top10Title' | 'countriesRestriction'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, top10?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | (
      { __typename: 'Top10Song' }
      & ITopTenFragmentFragment
    ) | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, regions?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
    { __typename?: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, availableRegions?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>>, musicGenre?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
  & IContentItemsFragment_Radio_Fragment
  & IParentInfo_Radio_Fragment
);

export type IRadioCategFragmentFragment = (
  { __typename: 'RadioCateg' }
  & Pick<IRadioCateg, 'id' | 'url' | 'name'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & IMainContentListFragment_ArtistService_Fragment
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & IMainContentListFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename: 'ArtistServicesPage' }
      & IMainContentListFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename: 'AwardCategoryPage' }
      & IMainContentListFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename: 'AwardsArtist' }
      & IMainContentListFragment_AwardsArtist_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & IMainContentListFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename: 'AwardsHomepage' }
      & IMainContentListFragment_AwardsHomepage_Fragment
    ) | (
      { __typename: 'CMSPage' }
      & IMainContentListFragment_CmsPage_Fragment
    ) | (
      { __typename: 'CategBgColor' }
      & IMainContentListFragment_CategBgColor_Fragment
    ) | (
      { __typename: 'CategoryPage' }
      & IMainContentListFragment_CategoryPage_Fragment
    ) | (
      { __typename: 'Channel' }
      & IMainContentListFragment_Channel_Fragment
    ) | (
      { __typename: 'ChannelFolder' }
      & IMainContentListFragment_ChannelFolder_Fragment
    ) | (
      { __typename: 'ChoiceNugget' }
      & IMainContentListFragment_ChoiceNugget_Fragment
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Collection_Fragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & IMainContentListFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename: 'ContentTag' }
      & IMainContentListFragment_ContentTag_Fragment
    ) | (
      { __typename: 'ContentTags' }
      & IMainContentListFragment_ContentTags_Fragment
    ) | (
      { __typename: 'ContentTagsCateg' }
      & IMainContentListFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename: 'Course' }
      & IMainContentListFragment_Course_Fragment
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & IMainContentListFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename: 'CourseCategory' }
      & IMainContentListFragment_CourseCategory_Fragment
    ) | (
      { __typename: 'CourseExam' }
      & IMainContentListFragment_CourseExam_Fragment
    ) | (
      { __typename: 'CourseShare' }
      & IMainContentListFragment_CourseShare_Fragment
    ) | (
      { __typename: 'CourseStatus' }
      & IMainContentListFragment_CourseStatus_Fragment
    ) | (
      { __typename: 'CourseTestProgression' }
      & IMainContentListFragment_CourseTestProgression_Fragment
    ) | (
      { __typename: 'CourseUnit' }
      & IMainContentListFragment_CourseUnit_Fragment
    ) | (
      { __typename: 'Discovery' }
      & IMainContentListFragment_Discovery_Fragment
    ) | (
      { __typename: 'DiscoverySlide1' }
      & IMainContentListFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & IMainContentListFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename: 'FormFolder' }
      & IMainContentListFragment_FormFolder_Fragment
    ) | (
      { __typename: 'FormPage' }
      & IMainContentListFragment_FormPage_Fragment
    ) | (
      { __typename: 'GapfillNugget' }
      & IMainContentListFragment_GapfillNugget_Fragment
    ) | (
      { __typename: 'HelpdeskCateg' }
      & IMainContentListFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename: 'HelpdeskFolder' }
      & IMainContentListFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename: 'HelpdeskPage' }
      & IMainContentListFragment_HelpdeskPage_Fragment
    ) | (
      { __typename: 'HomePage' }
      & IMainContentListFragment_HomePage_Fragment
    ) | (
      { __typename: 'JobBoardPage' }
      & IMainContentListFragment_JobBoardPage_Fragment
    ) | (
      { __typename: 'JobHub' }
      & IMainContentListFragment_JobHub_Fragment
    ) | (
      { __typename: 'JobHubsFolder' }
      & IMainContentListFragment_JobHubsFolder_Fragment
    ) | (
      { __typename: 'JobProgress' }
      & IMainContentListFragment_JobProgress_Fragment
    ) | (
      { __typename: 'JobShare' }
      & IMainContentListFragment_JobShare_Fragment
    ) | (
      { __typename: 'JobTraining' }
      & IMainContentListFragment_JobTraining_Fragment
    ) | (
      { __typename: 'JobTrainingFolder' }
      & IMainContentListFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & IMainContentListFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename: 'JobVacancy' }
      & IMainContentListFragment_JobVacancy_Fragment
    ) | (
      { __typename: 'LandingPage' }
      & IMainContentListFragment_LandingPage_Fragment
    ) | (
      { __typename: 'LearnMenu' }
      & IMainContentListFragment_LearnMenu_Fragment
    ) | (
      { __typename: 'LegalsFolder' }
      & IMainContentListFragment_LegalsFolder_Fragment
    ) | (
      { __typename: 'ListenCateg' }
      & IMainContentListFragment_ListenCateg_Fragment
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_LiveEvent_Fragment
    ) | (
      { __typename: 'LiveEventsMenu' }
      & IMainContentListFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename: 'LiveEventsPage' }
      & IMainContentListFragment_LiveEventsPage_Fragment
    ) | (
      { __typename: 'LiveTVPage' }
      & IMainContentListFragment_LiveTvPage_Fragment
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & IMainContentListFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename: 'MemberDatas' }
      & IMainContentListFragment_MemberDatas_Fragment
    ) | (
      { __typename: 'MemberDownloaded' }
      & IMainContentListFragment_MemberDownloaded_Fragment
    ) | (
      { __typename: 'MemberMessage' }
      & IMainContentListFragment_MemberMessage_Fragment
    ) | (
      { __typename: 'MemberNotify' }
      & IMainContentListFragment_MemberNotify_Fragment
    ) | (
      { __typename: 'MemberOpportunity' }
      & IMainContentListFragment_MemberOpportunity_Fragment
    ) | (
      { __typename: 'MemberSaved' }
      & IMainContentListFragment_MemberSaved_Fragment
    ) | (
      { __typename: 'MemberSearch' }
      & IMainContentListFragment_MemberSearch_Fragment
    ) | (
      { __typename: 'MemberWatched' }
      & IMainContentListFragment_MemberWatched_Fragment
    ) | (
      { __typename: 'MembersDatas' }
      & IMainContentListFragment_MembersDatas_Fragment
    ) | (
      { __typename: 'MiniSitesFolder' }
      & IMainContentListFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename: 'NavMessage' }
      & IMainContentListFragment_NavMessage_Fragment
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & IMainContentListFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename: 'NetlifyDeploy' }
      & IMainContentListFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename: 'News' }
      & IMainContentListFragment_News_Fragment
    ) | (
      { __typename: 'NewsCateg' }
      & IMainContentListFragment_NewsCateg_Fragment
    ) | (
      { __typename: 'NewsFolder' }
      & IMainContentListFragment_NewsFolder_Fragment
    ) | (
      { __typename: 'NewsPage' }
      & IMainContentListFragment_NewsPage_Fragment
    ) | (
      { __typename: 'ObtainedJob' }
      & IMainContentListFragment_ObtainedJob_Fragment
    ) | (
      { __typename: 'Opportunity' }
      & IMainContentListFragment_Opportunity_Fragment
    ) | (
      { __typename: 'OpportunityCenter' }
      & IMainContentListFragment_OpportunityCenter_Fragment
    ) | (
      { __typename: 'OpportunityFolder' }
      & IMainContentListFragment_OpportunityFolder_Fragment
    ) | (
      { __typename: 'Partner' }
      & IMainContentListFragment_Partner_Fragment
    ) | (
      { __typename: 'Partners' }
      & IMainContentListFragment_Partners_Fragment
    ) | (
      { __typename: 'PartnersPage' }
      & IMainContentListFragment_PartnersPage_Fragment
    ) | (
      { __typename: 'Paywall' }
      & IMainContentListFragment_Paywall_Fragment
    ) | (
      { __typename: 'PaywallFolder' }
      & IMainContentListFragment_PaywallFolder_Fragment
    ) | (
      { __typename: 'PersonalityPages' }
      & IMainContentListFragment_PersonalityPages_Fragment
    ) | (
      { __typename: 'PersonalityQuiz' }
      & IMainContentListFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & IMainContentListFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename: 'PersonalityType' }
      & IMainContentListFragment_PersonalityType_Fragment
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Playlist_Fragment
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & IMainContentListFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Podcast_Fragment
    ) | (
      { __typename: 'PodcastCateg' }
      & IMainContentListFragment_PodcastCateg_Fragment
    ) | (
      { __typename: 'PodcastItem' }
      & IMainContentListFragment_PodcastItem_Fragment
    ) | (
      { __typename: 'PodcastMenu' }
      & IMainContentListFragment_PodcastMenu_Fragment
    ) | (
      { __typename: 'PromoCode' }
      & IMainContentListFragment_PromoCode_Fragment
    ) | (
      { __typename: 'PromoCodeFolder' }
      & IMainContentListFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename: 'QuizPage' }
      & IMainContentListFragment_QuizPage_Fragment
    ) | (
      { __typename: 'QuizzSurvey' }
      & IMainContentListFragment_QuizzSurvey_Fragment
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & IMainContentListFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & IMainContentListFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Radio_Fragment
    ) | (
      { __typename: 'RadioCateg' }
      & IMainContentListFragment_RadioCateg_Fragment
    ) | (
      { __typename: 'Region' }
      & IMainContentListFragment_Region_Fragment
    ) | (
      { __typename: 'SectionPage' }
      & IMainContentListFragment_SectionPage_Fragment
    ) | (
      { __typename: 'Settings' }
      & IMainContentListFragment_Settings_Fragment
    ) | (
      { __typename: 'Space' }
      & IMainContentListFragment_Space_Fragment
    ) | (
      { __typename: 'Subscription' }
      & IMainContentListFragment_Subscription_Fragment
    ) | (
      { __typename: 'SubscriptionData' }
      & IMainContentListFragment_SubscriptionData_Fragment
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & IMainContentListFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & IMainContentListFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename: 'SumaryNugget' }
      & IMainContentListFragment_SumaryNugget_Fragment
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & IMainContentListFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename: 'TextPage' }
      & IMainContentListFragment_TextPage_Fragment
    ) | (
      { __typename: 'ThankYouPage' }
      & IMainContentListFragment_ThankYouPage_Fragment
    ) | (
      { __typename: 'TranslationContext' }
      & IMainContentListFragment_TranslationContext_Fragment
    ) | (
      { __typename: 'TranslationFolder' }
      & IMainContentListFragment_TranslationFolder_Fragment
    ) | (
      { __typename: 'TranslationItem' }
      & IMainContentListFragment_TranslationItem_Fragment
    ) | (
      { __typename: 'UmbracoTest' }
      & IMainContentListFragment_UmbracoTest_Fragment
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & IMainContentListFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename: 'UnitProgression' }
      & IMainContentListFragment_UnitProgression_Fragment
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_VodItem_Fragment
    ) | (
      { __typename: 'VODMenu' }
      & IMainContentListFragment_VodMenu_Fragment
    ) | (
      { __typename: 'VotingFolder' }
      & IMainContentListFragment_VotingFolder_Fragment
    ) | (
      { __typename: 'VotingRecord' }
      & IMainContentListFragment_VotingRecord_Fragment
    ) | (
      { __typename: 'WatchCateg' }
      & IMainContentListFragment_WatchCateg_Fragment
    )>> }
  ) }
);

export type IRegionFragmentFragment = (
  { __typename?: 'Region' }
  & Pick<IRegion, 'id' | 'name' | 'url' | 'defaultLanguage'>
  & { discovery?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>, searchTopBlocks?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | (
      { __typename: 'LinkIcon' }
      & ILinkIconFragmentFragment
    ) | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, searchPageBlocks?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & IElementFragment_Accordions_Fragment
    ) | (
      { __typename?: 'Advantage' }
      & IElementFragment_Advantage_Fragment
    ) | (
      { __typename?: 'AdvantagesList' }
      & IElementFragment_AdvantagesList_Fragment
    ) | (
      { __typename?: 'Article' }
      & IElementFragment_Article_Fragment
    ) | (
      { __typename?: 'ArtistService' }
      & IElementFragment_ArtistService_Fragment
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & IElementFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & IElementFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename?: 'Author' }
      & IElementFragment_Author_Fragment
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & IElementFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename?: 'AwardsArtist' }
      & IElementFragment_AwardsArtist_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & IElementFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & IElementFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & IElementFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & IElementFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename?: 'AwardsHomepage' }
      & IElementFragment_AwardsHomepage_Fragment
    ) | (
      { __typename?: 'Button' }
      & IElementFragment_Button_Fragment
    ) | (
      { __typename?: 'CMSPage' }
      & IElementFragment_CmsPage_Fragment
    ) | (
      { __typename?: 'CTASlide' }
      & IElementFragment_CtaSlide_Fragment
    ) | (
      { __typename?: 'CTASlider' }
      & IElementFragment_CtaSlider_Fragment
    ) | (
      { __typename?: 'Card' }
      & IElementFragment_Card_Fragment
    ) | (
      { __typename?: 'CardIcon' }
      & IElementFragment_CardIcon_Fragment
    ) | (
      { __typename?: 'CardLink' }
      & IElementFragment_CardLink_Fragment
    ) | (
      { __typename?: 'CardList' }
      & IElementFragment_CardList_Fragment
    ) | (
      { __typename?: 'CategBgColor' }
      & IElementFragment_CategBgColor_Fragment
    ) | (
      { __typename?: 'CategoryPage' }
      & IElementFragment_CategoryPage_Fragment
    ) | (
      { __typename?: 'CategorySlider' }
      & IElementFragment_CategorySlider_Fragment
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & IElementFragment_CategorySliderHighlight_Fragment
    ) | (
      { __typename?: 'Channel' }
      & IElementFragment_Channel_Fragment
    ) | (
      { __typename?: 'ChannelFolder' }
      & IElementFragment_ChannelFolder_Fragment
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IElementFragment_ChoiceNuggerAnswer_Fragment
    ) | (
      { __typename?: 'ChoiceNugget' }
      & IElementFragment_ChoiceNugget_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & IElementFragment_ChoiceNuggetAnswerGroup_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & IElementFragment_ChoiceNuggetQuestion_Fragment
    ) | (
      { __typename?: 'Collection' }
      & IElementFragment_Collection_Fragment
    ) | (
      { __typename?: 'ColorTag' }
      & IElementFragment_ColorTag_Fragment
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & IElementFragment_ContentAudioFileCmp_Fragment
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & IElementFragment_ContentAudioVimeoCmp_Fragment
    ) | (
      { __typename?: 'ContentCategCmp' }
      & IElementFragment_ContentCategCmp_Fragment
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & IElementFragment_ContentEpgProgramFileCmp_Fragment
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & IElementFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename?: 'ContentLink' }
      & IElementFragment_ContentLink_Fragment
    ) | (
      { __typename?: 'ContentSlider' }
      & IElementFragment_ContentSlider_Fragment
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & IElementFragment_ContentSliderHighlight_Fragment
    ) | (
      { __typename?: 'ContentTag' }
      & IElementFragment_ContentTag_Fragment
    ) | (
      { __typename?: 'ContentTags' }
      & IElementFragment_ContentTags_Fragment
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & IElementFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & IElementFragment_ContextualContentSlider_Fragment
    ) | (
      { __typename?: 'Course' }
      & IElementFragment_Course_Fragment
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & IElementFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename?: 'CourseCategory' }
      & IElementFragment_CourseCategory_Fragment
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & IElementFragment_CourseCategorySlider_Fragment
    ) | (
      { __typename?: 'CourseExam' }
      & IElementFragment_CourseExam_Fragment
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & IElementFragment_CourseItemsSlider_Fragment
    ) | (
      { __typename?: 'CourseNugget' }
      & IElementFragment_CourseNugget_Fragment
    ) | (
      { __typename?: 'CoursePage' }
      & IElementFragment_CoursePage_Fragment
    ) | (
      { __typename?: 'CourseShare' }
      & IElementFragment_CourseShare_Fragment
    ) | (
      { __typename?: 'CourseStatus' }
      & IElementFragment_CourseStatus_Fragment
    ) | (
      { __typename?: 'CourseTestProgression' }
      & IElementFragment_CourseTestProgression_Fragment
    ) | (
      { __typename?: 'CourseUnit' }
      & IElementFragment_CourseUnit_Fragment
    ) | (
      { __typename?: 'Discovery' }
      & IElementFragment_Discovery_Fragment
    ) | (
      { __typename?: 'DiscoverySlide' }
      & IElementFragment_DiscoverySlide_Fragment
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & IElementFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename?: 'EditoSlider' }
      & IElementFragment_EditoSlider_Fragment
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & IElementFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename?: 'ExpandMenu' }
      & IElementFragment_ExpandMenu_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & IElementFragment_ExternalLink_Fragment
    ) | (
      { __typename?: 'FaqItem' }
      & IElementFragment_FaqItem_Fragment
    ) | (
      { __typename?: 'FaqPageLink' }
      & IElementFragment_FaqPageLink_Fragment
    ) | (
      { __typename?: 'FormFolder' }
      & IElementFragment_FormFolder_Fragment
    ) | (
      { __typename?: 'FormPage' }
      & IElementFragment_FormPage_Fragment
    ) | (
      { __typename?: 'Gallery' }
      & IElementFragment_Gallery_Fragment
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & IElementFragment_GapFillNuggetAnswer_Fragment
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & IElementFragment_GapFillNuggetImageAnswer_Fragment
    ) | (
      { __typename?: 'GapfillNugget' }
      & IElementFragment_GapfillNugget_Fragment
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & IElementFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & IElementFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename?: 'HelpdeskPage' }
      & IElementFragment_HelpdeskPage_Fragment
    ) | (
      { __typename?: 'HeroBanner' }
      & IElementFragment_HeroBanner_Fragment
    ) | (
      { __typename?: 'HeroBanner1' }
      & IElementFragment_HeroBanner1_Fragment
    ) | (
      { __typename?: 'HeroServices' }
      & IElementFragment_HeroServices_Fragment
    ) | (
      { __typename?: 'HeroSlide' }
      & IElementFragment_HeroSlide_Fragment
    ) | (
      { __typename?: 'HeroVideoCover' }
      & IElementFragment_HeroVideoCover_Fragment
    ) | (
      { __typename?: 'HomePage' }
      & IElementFragment_HomePage_Fragment
    ) | (
      { __typename?: 'IconSlide' }
      & IElementFragment_IconSlide_Fragment
    ) | (
      { __typename?: 'InternalLink' }
      & IElementFragment_InternalLink_Fragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & IElementFragment_JobBoardPage_Fragment
    ) | (
      { __typename?: 'JobHub' }
      & IElementFragment_JobHub_Fragment
    ) | (
      { __typename?: 'JobHubsFolder' }
      & IElementFragment_JobHubsFolder_Fragment
    ) | (
      { __typename?: 'JobProgress' }
      & IElementFragment_JobProgress_Fragment
    ) | (
      { __typename?: 'JobShare' }
      & IElementFragment_JobShare_Fragment
    ) | (
      { __typename?: 'JobTraining' }
      & IElementFragment_JobTraining_Fragment
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & IElementFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & IElementFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename?: 'JobVacancy' }
      & IElementFragment_JobVacancy_Fragment
    ) | (
      { __typename?: 'KeyFigure' }
      & IElementFragment_KeyFigure_Fragment
    ) | (
      { __typename?: 'KeyFigures' }
      & IElementFragment_KeyFigures_Fragment
    ) | (
      { __typename?: 'LandingAbout' }
      & IElementFragment_LandingAbout_Fragment
    ) | (
      { __typename?: 'LandingPage' }
      & IElementFragment_LandingPage_Fragment
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & IElementFragment_LearnHeroSlide_Fragment
    ) | (
      { __typename?: 'LearnMenu' }
      & IElementFragment_LearnMenu_Fragment
    ) | (
      { __typename?: 'LegalPageLink' }
      & IElementFragment_LegalPageLink_Fragment
    ) | (
      { __typename?: 'LegalsFolder' }
      & IElementFragment_LegalsFolder_Fragment
    ) | (
      { __typename?: 'LinkIcon' }
      & IElementFragment_LinkIcon_Fragment
    ) | (
      { __typename?: 'LinkPicker' }
      & IElementFragment_LinkPicker_Fragment
    ) | (
      { __typename?: 'ListenCateg' }
      & IElementFragment_ListenCateg_Fragment
    ) | (
      { __typename?: 'LiveEvent' }
      & IElementFragment_LiveEvent_Fragment
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & IElementFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename?: 'LiveEventsPage' }
      & IElementFragment_LiveEventsPage_Fragment
    ) | (
      { __typename?: 'LiveTVPage' }
      & IElementFragment_LiveTvPage_Fragment
    ) | (
      { __typename?: 'LogoLink' }
      & IElementFragment_LogoLink_Fragment
    ) | (
      { __typename?: 'LogoSlider' }
      & IElementFragment_LogoSlider_Fragment
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & IElementFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename?: 'MemberDatas' }
      & IElementFragment_MemberDatas_Fragment
    ) | (
      { __typename?: 'MemberDownloaded' }
      & IElementFragment_MemberDownloaded_Fragment
    ) | (
      { __typename?: 'MemberMessage' }
      & IElementFragment_MemberMessage_Fragment
    ) | (
      { __typename?: 'MemberNotify' }
      & IElementFragment_MemberNotify_Fragment
    ) | (
      { __typename?: 'MemberOpportunity' }
      & IElementFragment_MemberOpportunity_Fragment
    ) | (
      { __typename?: 'MemberSaved' }
      & IElementFragment_MemberSaved_Fragment
    ) | (
      { __typename?: 'MemberSearch' }
      & IElementFragment_MemberSearch_Fragment
    ) | (
      { __typename?: 'MemberWatched' }
      & IElementFragment_MemberWatched_Fragment
    ) | (
      { __typename?: 'MembersDatas' }
      & IElementFragment_MembersDatas_Fragment
    ) | (
      { __typename?: 'MenuColumn' }
      & IElementFragment_MenuColumn_Fragment
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & IElementFragment_MetadatasLanguages_Fragment
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & IElementFragment_MetadatasVodLanguage_Fragment
    ) | (
      { __typename?: 'MetasExclusives' }
      & IElementFragment_MetasExclusives_Fragment
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & IElementFragment_MetasPublicationDate_Fragment
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & IElementFragment_MetasTrailerCmp_Fragment
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & IElementFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename?: 'MultiSlider' }
      & IElementFragment_MultiSlider_Fragment
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & IElementFragment_MulticategoriesSlider_Fragment
    ) | (
      { __typename?: 'NavMessage' }
      & IElementFragment_NavMessage_Fragment
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & IElementFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & IElementFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename?: 'News' }
      & IElementFragment_News_Fragment
    ) | (
      { __typename?: 'NewsCateg' }
      & IElementFragment_NewsCateg_Fragment
    ) | (
      { __typename?: 'NewsFolder' }
      & IElementFragment_NewsFolder_Fragment
    ) | (
      { __typename?: 'NewsPage' }
      & IElementFragment_NewsPage_Fragment
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & IElementFragment_NuggetsTextAnswerOption_Fragment
    ) | (
      { __typename?: 'ObtainedJob' }
      & IElementFragment_ObtainedJob_Fragment
    ) | (
      { __typename?: 'Opportunity' }
      & IElementFragment_Opportunity_Fragment
    ) | (
      { __typename?: 'OpportunityCenter' }
      & IElementFragment_OpportunityCenter_Fragment
    ) | (
      { __typename?: 'OpportunityFolder' }
      & IElementFragment_OpportunityFolder_Fragment
    ) | (
      { __typename?: 'PageSEO' }
      & IElementFragment_PageSeo_Fragment
    ) | (
      { __typename?: 'PagecontentSlider' }
      & IElementFragment_PagecontentSlider_Fragment
    ) | (
      { __typename?: 'Partner' }
      & IElementFragment_Partner_Fragment
    ) | (
      { __typename?: 'PartnerSlider' }
      & IElementFragment_PartnerSlider_Fragment
    ) | (
      { __typename?: 'Partners' }
      & IElementFragment_Partners_Fragment
    ) | (
      { __typename?: 'PartnersPage' }
      & IElementFragment_PartnersPage_Fragment
    ) | (
      { __typename?: 'Paywall' }
      & IElementFragment_Paywall_Fragment
    ) | (
      { __typename?: 'PaywallFolder' }
      & IElementFragment_PaywallFolder_Fragment
    ) | (
      { __typename?: 'PersonalityPages' }
      & IElementFragment_PersonalityPages_Fragment
    ) | (
      { __typename?: 'PersonalityPush' }
      & IElementFragment_PersonalityPush_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & IElementFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & IElementFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & IElementFragment_PersonalityQuizQuestion_Fragment
    ) | (
      { __typename?: 'PersonalityType' }
      & IElementFragment_PersonalityType_Fragment
    ) | (
      { __typename?: 'Playlist' }
      & IElementFragment_Playlist_Fragment
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & IElementFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename?: 'Podcast' }
      & IElementFragment_Podcast_Fragment
    ) | (
      { __typename?: 'PodcastCateg' }
      & IElementFragment_PodcastCateg_Fragment
    ) | (
      { __typename?: 'PodcastItem' }
      & IElementFragment_PodcastItem_Fragment
    ) | (
      { __typename?: 'PodcastMenu' }
      & IElementFragment_PodcastMenu_Fragment
    ) | (
      { __typename?: 'PromoCode' }
      & IElementFragment_PromoCode_Fragment
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & IElementFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename?: 'Push' }
      & IElementFragment_Push_Fragment
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & IElementFragment_QuizItemsSlider_Fragment
    ) | (
      { __typename?: 'QuizPage' }
      & IElementFragment_QuizPage_Fragment
    ) | (
      { __typename?: 'QuizzSurvey' }
      & IElementFragment_QuizzSurvey_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & IElementFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & IElementFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename?: 'Radio' }
      & IElementFragment_Radio_Fragment
    ) | (
      { __typename?: 'RadioCateg' }
      & IElementFragment_RadioCateg_Fragment
    ) | (
      { __typename?: 'Region' }
      & IElementFragment_Region_Fragment
    ) | (
      { __typename?: 'SectionPage' }
      & IElementFragment_SectionPage_Fragment
    ) | (
      { __typename?: 'Service' }
      & IElementFragment_Service_Fragment
    ) | (
      { __typename?: 'ServicesList' }
      & IElementFragment_ServicesList_Fragment
    ) | (
      { __typename?: 'Settings' }
      & IElementFragment_Settings_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & IElementFragment_SettingsAccessRestrictionCmp_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & IElementFragment_SettingsAccessRestrictionCmp1_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & IElementFragment_SettingsAccessRestrictionCmp2_Fragment
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & IElementFragment_SettingsDateCmp_Fragment
    ) | (
      { __typename?: 'SettingsExternalId' }
      & IElementFragment_SettingsExternalId_Fragment
    ) | (
      { __typename?: 'Space' }
      & IElementFragment_Space_Fragment
    ) | (
      { __typename?: 'StaticPageLink' }
      & IElementFragment_StaticPageLink_Fragment
    ) | (
      { __typename?: 'Subscription' }
      & IElementFragment_Subscription_Fragment
    ) | (
      { __typename?: 'SubscriptionData' }
      & IElementFragment_SubscriptionData_Fragment
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & IElementFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & IElementFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsList' }
      & IElementFragment_SubscriptionsList_Fragment
    ) | (
      { __typename?: 'SumaryNugget' }
      & IElementFragment_SumaryNugget_Fragment
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & IElementFragment_SummaryNuggetStatement_Fragment
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & IElementFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename?: 'TextPage' }
      & IElementFragment_TextPage_Fragment
    ) | (
      { __typename?: 'TextSlide1' }
      & IElementFragment_TextSlide1_Fragment
    ) | (
      { __typename?: 'ThankYouPage' }
      & IElementFragment_ThankYouPage_Fragment
    ) | (
      { __typename?: 'TitleSlider' }
      & IElementFragment_TitleSlider_Fragment
    ) | (
      { __typename?: 'Top10Song' }
      & IElementFragment_Top10Song_Fragment
    ) | (
      { __typename?: 'TranslationContext' }
      & IElementFragment_TranslationContext_Fragment
    ) | (
      { __typename?: 'TranslationFolder' }
      & IElementFragment_TranslationFolder_Fragment
    ) | (
      { __typename?: 'TranslationItem' }
      & IElementFragment_TranslationItem_Fragment
    ) | (
      { __typename?: 'TutorialSlide' }
      & IElementFragment_TutorialSlide_Fragment
    ) | (
      { __typename?: 'UcAudio' }
      & IElementFragment_UcAudio_Fragment
    ) | (
      { __typename?: 'UcImage' }
      & IElementFragment_UcImage_Fragment
    ) | (
      { __typename?: 'UcLineBreak' }
      & IElementFragment_UcLineBreak_Fragment
    ) | (
      { __typename?: 'UcText' }
      & IElementFragment_UcText_Fragment
    ) | (
      { __typename?: 'UcVideo' }
      & IElementFragment_UcVideo_Fragment
    ) | (
      { __typename?: 'UmbracoTest' }
      & IElementFragment_UmbracoTest_Fragment
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & IElementFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & IElementFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IElementFragment_UnitNuggetGapFillAnswerItem_Fragment
    ) | (
      { __typename?: 'UnitProgression' }
      & IElementFragment_UnitProgression_Fragment
    ) | (
      { __typename?: 'VODItem' }
      & IElementFragment_VodItem_Fragment
    ) | (
      { __typename?: 'VODMenu' }
      & IElementFragment_VodMenu_Fragment
    ) | (
      { __typename?: 'ValidationElement' }
      & IElementFragment_ValidationElement_Fragment
    ) | (
      { __typename?: 'VotingFolder' }
      & IElementFragment_VotingFolder_Fragment
    ) | (
      { __typename?: 'VotingRecord' }
      & IElementFragment_VotingRecord_Fragment
    ) | (
      { __typename?: 'WatchCateg' }
      & IElementFragment_WatchCateg_Fragment
    ) | (
      { __typename?: 'WatchedContent' }
      & IElementFragment_WatchedContent_Fragment
    ) | (
      { __typename?: 'Wysiwyg' }
      & IElementFragment_Wysiwyg_Fragment
    ) }
  )>>>, homepageUrl?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
  )>, watchHomepage?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  )>, listenHomepage?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  )>, learnHomepage?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  )>, topMenu?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | (
      { __typename?: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | (
      { __typename?: 'LinkPicker' }
      & ILinkPickerFragmentFragment
    ) | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, subMenu?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | (
      { __typename?: 'LinkIcon' }
      & ILinkIconFragmentFragment
    ) | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, push?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | (
      { __typename?: 'Push' }
      & IPushFragmentFragment
    ) | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, accountPush?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | (
      { __typename?: 'Push' }
      & IPushFragmentFragment
    ) | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, defaultPaywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
);

export type IRegionWebFragmentFragment = (
  { __typename?: 'Region' }
  & Pick<IRegion, 'id' | 'name' | 'url' | 'defaultLanguage'>
  & { searchTopBlocks?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | (
      { __typename: 'LinkIcon' }
      & ILinkIconFragmentFragment
    ) | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, searchPageBlocks?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & IElementFragment_Accordions_Fragment
    ) | (
      { __typename?: 'Advantage' }
      & IElementFragment_Advantage_Fragment
    ) | (
      { __typename?: 'AdvantagesList' }
      & IElementFragment_AdvantagesList_Fragment
    ) | (
      { __typename?: 'Article' }
      & IElementFragment_Article_Fragment
    ) | (
      { __typename?: 'ArtistService' }
      & IElementFragment_ArtistService_Fragment
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & IElementFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & IElementFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename?: 'Author' }
      & IElementFragment_Author_Fragment
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & IElementFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename?: 'AwardsArtist' }
      & IElementFragment_AwardsArtist_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & IElementFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & IElementFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & IElementFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & IElementFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename?: 'AwardsHomepage' }
      & IElementFragment_AwardsHomepage_Fragment
    ) | (
      { __typename?: 'Button' }
      & IElementFragment_Button_Fragment
    ) | (
      { __typename?: 'CMSPage' }
      & IElementFragment_CmsPage_Fragment
    ) | (
      { __typename?: 'CTASlide' }
      & IElementFragment_CtaSlide_Fragment
    ) | (
      { __typename?: 'CTASlider' }
      & IElementFragment_CtaSlider_Fragment
    ) | (
      { __typename?: 'Card' }
      & IElementFragment_Card_Fragment
    ) | (
      { __typename?: 'CardIcon' }
      & IElementFragment_CardIcon_Fragment
    ) | (
      { __typename?: 'CardLink' }
      & IElementFragment_CardLink_Fragment
    ) | (
      { __typename?: 'CardList' }
      & IElementFragment_CardList_Fragment
    ) | (
      { __typename?: 'CategBgColor' }
      & IElementFragment_CategBgColor_Fragment
    ) | (
      { __typename?: 'CategoryPage' }
      & IElementFragment_CategoryPage_Fragment
    ) | (
      { __typename?: 'CategorySlider' }
      & IElementFragment_CategorySlider_Fragment
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & IElementFragment_CategorySliderHighlight_Fragment
    ) | (
      { __typename?: 'Channel' }
      & IElementFragment_Channel_Fragment
    ) | (
      { __typename?: 'ChannelFolder' }
      & IElementFragment_ChannelFolder_Fragment
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IElementFragment_ChoiceNuggerAnswer_Fragment
    ) | (
      { __typename?: 'ChoiceNugget' }
      & IElementFragment_ChoiceNugget_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & IElementFragment_ChoiceNuggetAnswerGroup_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & IElementFragment_ChoiceNuggetQuestion_Fragment
    ) | (
      { __typename?: 'Collection' }
      & IElementFragment_Collection_Fragment
    ) | (
      { __typename?: 'ColorTag' }
      & IElementFragment_ColorTag_Fragment
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & IElementFragment_ContentAudioFileCmp_Fragment
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & IElementFragment_ContentAudioVimeoCmp_Fragment
    ) | (
      { __typename?: 'ContentCategCmp' }
      & IElementFragment_ContentCategCmp_Fragment
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & IElementFragment_ContentEpgProgramFileCmp_Fragment
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & IElementFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename?: 'ContentLink' }
      & IElementFragment_ContentLink_Fragment
    ) | (
      { __typename?: 'ContentSlider' }
      & IElementFragment_ContentSlider_Fragment
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & IElementFragment_ContentSliderHighlight_Fragment
    ) | (
      { __typename?: 'ContentTag' }
      & IElementFragment_ContentTag_Fragment
    ) | (
      { __typename?: 'ContentTags' }
      & IElementFragment_ContentTags_Fragment
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & IElementFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & IElementFragment_ContextualContentSlider_Fragment
    ) | (
      { __typename?: 'Course' }
      & IElementFragment_Course_Fragment
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & IElementFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename?: 'CourseCategory' }
      & IElementFragment_CourseCategory_Fragment
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & IElementFragment_CourseCategorySlider_Fragment
    ) | (
      { __typename?: 'CourseExam' }
      & IElementFragment_CourseExam_Fragment
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & IElementFragment_CourseItemsSlider_Fragment
    ) | (
      { __typename?: 'CourseNugget' }
      & IElementFragment_CourseNugget_Fragment
    ) | (
      { __typename?: 'CoursePage' }
      & IElementFragment_CoursePage_Fragment
    ) | (
      { __typename?: 'CourseShare' }
      & IElementFragment_CourseShare_Fragment
    ) | (
      { __typename?: 'CourseStatus' }
      & IElementFragment_CourseStatus_Fragment
    ) | (
      { __typename?: 'CourseTestProgression' }
      & IElementFragment_CourseTestProgression_Fragment
    ) | (
      { __typename?: 'CourseUnit' }
      & IElementFragment_CourseUnit_Fragment
    ) | (
      { __typename?: 'Discovery' }
      & IElementFragment_Discovery_Fragment
    ) | (
      { __typename?: 'DiscoverySlide' }
      & IElementFragment_DiscoverySlide_Fragment
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & IElementFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename?: 'EditoSlider' }
      & IElementFragment_EditoSlider_Fragment
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & IElementFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename?: 'ExpandMenu' }
      & IElementFragment_ExpandMenu_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & IElementFragment_ExternalLink_Fragment
    ) | (
      { __typename?: 'FaqItem' }
      & IElementFragment_FaqItem_Fragment
    ) | (
      { __typename?: 'FaqPageLink' }
      & IElementFragment_FaqPageLink_Fragment
    ) | (
      { __typename?: 'FormFolder' }
      & IElementFragment_FormFolder_Fragment
    ) | (
      { __typename?: 'FormPage' }
      & IElementFragment_FormPage_Fragment
    ) | (
      { __typename?: 'Gallery' }
      & IElementFragment_Gallery_Fragment
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & IElementFragment_GapFillNuggetAnswer_Fragment
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & IElementFragment_GapFillNuggetImageAnswer_Fragment
    ) | (
      { __typename?: 'GapfillNugget' }
      & IElementFragment_GapfillNugget_Fragment
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & IElementFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & IElementFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename?: 'HelpdeskPage' }
      & IElementFragment_HelpdeskPage_Fragment
    ) | (
      { __typename?: 'HeroBanner' }
      & IElementFragment_HeroBanner_Fragment
    ) | (
      { __typename?: 'HeroBanner1' }
      & IElementFragment_HeroBanner1_Fragment
    ) | (
      { __typename?: 'HeroServices' }
      & IElementFragment_HeroServices_Fragment
    ) | (
      { __typename?: 'HeroSlide' }
      & IElementFragment_HeroSlide_Fragment
    ) | (
      { __typename?: 'HeroVideoCover' }
      & IElementFragment_HeroVideoCover_Fragment
    ) | (
      { __typename?: 'HomePage' }
      & IElementFragment_HomePage_Fragment
    ) | (
      { __typename?: 'IconSlide' }
      & IElementFragment_IconSlide_Fragment
    ) | (
      { __typename?: 'InternalLink' }
      & IElementFragment_InternalLink_Fragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & IElementFragment_JobBoardPage_Fragment
    ) | (
      { __typename?: 'JobHub' }
      & IElementFragment_JobHub_Fragment
    ) | (
      { __typename?: 'JobHubsFolder' }
      & IElementFragment_JobHubsFolder_Fragment
    ) | (
      { __typename?: 'JobProgress' }
      & IElementFragment_JobProgress_Fragment
    ) | (
      { __typename?: 'JobShare' }
      & IElementFragment_JobShare_Fragment
    ) | (
      { __typename?: 'JobTraining' }
      & IElementFragment_JobTraining_Fragment
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & IElementFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & IElementFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename?: 'JobVacancy' }
      & IElementFragment_JobVacancy_Fragment
    ) | (
      { __typename?: 'KeyFigure' }
      & IElementFragment_KeyFigure_Fragment
    ) | (
      { __typename?: 'KeyFigures' }
      & IElementFragment_KeyFigures_Fragment
    ) | (
      { __typename?: 'LandingAbout' }
      & IElementFragment_LandingAbout_Fragment
    ) | (
      { __typename?: 'LandingPage' }
      & IElementFragment_LandingPage_Fragment
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & IElementFragment_LearnHeroSlide_Fragment
    ) | (
      { __typename?: 'LearnMenu' }
      & IElementFragment_LearnMenu_Fragment
    ) | (
      { __typename?: 'LegalPageLink' }
      & IElementFragment_LegalPageLink_Fragment
    ) | (
      { __typename?: 'LegalsFolder' }
      & IElementFragment_LegalsFolder_Fragment
    ) | (
      { __typename?: 'LinkIcon' }
      & IElementFragment_LinkIcon_Fragment
    ) | (
      { __typename?: 'LinkPicker' }
      & IElementFragment_LinkPicker_Fragment
    ) | (
      { __typename?: 'ListenCateg' }
      & IElementFragment_ListenCateg_Fragment
    ) | (
      { __typename?: 'LiveEvent' }
      & IElementFragment_LiveEvent_Fragment
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & IElementFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename?: 'LiveEventsPage' }
      & IElementFragment_LiveEventsPage_Fragment
    ) | (
      { __typename?: 'LiveTVPage' }
      & IElementFragment_LiveTvPage_Fragment
    ) | (
      { __typename?: 'LogoLink' }
      & IElementFragment_LogoLink_Fragment
    ) | (
      { __typename?: 'LogoSlider' }
      & IElementFragment_LogoSlider_Fragment
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & IElementFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename?: 'MemberDatas' }
      & IElementFragment_MemberDatas_Fragment
    ) | (
      { __typename?: 'MemberDownloaded' }
      & IElementFragment_MemberDownloaded_Fragment
    ) | (
      { __typename?: 'MemberMessage' }
      & IElementFragment_MemberMessage_Fragment
    ) | (
      { __typename?: 'MemberNotify' }
      & IElementFragment_MemberNotify_Fragment
    ) | (
      { __typename?: 'MemberOpportunity' }
      & IElementFragment_MemberOpportunity_Fragment
    ) | (
      { __typename?: 'MemberSaved' }
      & IElementFragment_MemberSaved_Fragment
    ) | (
      { __typename?: 'MemberSearch' }
      & IElementFragment_MemberSearch_Fragment
    ) | (
      { __typename?: 'MemberWatched' }
      & IElementFragment_MemberWatched_Fragment
    ) | (
      { __typename?: 'MembersDatas' }
      & IElementFragment_MembersDatas_Fragment
    ) | (
      { __typename?: 'MenuColumn' }
      & IElementFragment_MenuColumn_Fragment
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & IElementFragment_MetadatasLanguages_Fragment
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & IElementFragment_MetadatasVodLanguage_Fragment
    ) | (
      { __typename?: 'MetasExclusives' }
      & IElementFragment_MetasExclusives_Fragment
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & IElementFragment_MetasPublicationDate_Fragment
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & IElementFragment_MetasTrailerCmp_Fragment
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & IElementFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename?: 'MultiSlider' }
      & IElementFragment_MultiSlider_Fragment
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & IElementFragment_MulticategoriesSlider_Fragment
    ) | (
      { __typename?: 'NavMessage' }
      & IElementFragment_NavMessage_Fragment
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & IElementFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & IElementFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename?: 'News' }
      & IElementFragment_News_Fragment
    ) | (
      { __typename?: 'NewsCateg' }
      & IElementFragment_NewsCateg_Fragment
    ) | (
      { __typename?: 'NewsFolder' }
      & IElementFragment_NewsFolder_Fragment
    ) | (
      { __typename?: 'NewsPage' }
      & IElementFragment_NewsPage_Fragment
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & IElementFragment_NuggetsTextAnswerOption_Fragment
    ) | (
      { __typename?: 'ObtainedJob' }
      & IElementFragment_ObtainedJob_Fragment
    ) | (
      { __typename?: 'Opportunity' }
      & IElementFragment_Opportunity_Fragment
    ) | (
      { __typename?: 'OpportunityCenter' }
      & IElementFragment_OpportunityCenter_Fragment
    ) | (
      { __typename?: 'OpportunityFolder' }
      & IElementFragment_OpportunityFolder_Fragment
    ) | (
      { __typename?: 'PageSEO' }
      & IElementFragment_PageSeo_Fragment
    ) | (
      { __typename?: 'PagecontentSlider' }
      & IElementFragment_PagecontentSlider_Fragment
    ) | (
      { __typename?: 'Partner' }
      & IElementFragment_Partner_Fragment
    ) | (
      { __typename?: 'PartnerSlider' }
      & IElementFragment_PartnerSlider_Fragment
    ) | (
      { __typename?: 'Partners' }
      & IElementFragment_Partners_Fragment
    ) | (
      { __typename?: 'PartnersPage' }
      & IElementFragment_PartnersPage_Fragment
    ) | (
      { __typename?: 'Paywall' }
      & IElementFragment_Paywall_Fragment
    ) | (
      { __typename?: 'PaywallFolder' }
      & IElementFragment_PaywallFolder_Fragment
    ) | (
      { __typename?: 'PersonalityPages' }
      & IElementFragment_PersonalityPages_Fragment
    ) | (
      { __typename?: 'PersonalityPush' }
      & IElementFragment_PersonalityPush_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & IElementFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & IElementFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & IElementFragment_PersonalityQuizQuestion_Fragment
    ) | (
      { __typename?: 'PersonalityType' }
      & IElementFragment_PersonalityType_Fragment
    ) | (
      { __typename?: 'Playlist' }
      & IElementFragment_Playlist_Fragment
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & IElementFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename?: 'Podcast' }
      & IElementFragment_Podcast_Fragment
    ) | (
      { __typename?: 'PodcastCateg' }
      & IElementFragment_PodcastCateg_Fragment
    ) | (
      { __typename?: 'PodcastItem' }
      & IElementFragment_PodcastItem_Fragment
    ) | (
      { __typename?: 'PodcastMenu' }
      & IElementFragment_PodcastMenu_Fragment
    ) | (
      { __typename?: 'PromoCode' }
      & IElementFragment_PromoCode_Fragment
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & IElementFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename?: 'Push' }
      & IElementFragment_Push_Fragment
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & IElementFragment_QuizItemsSlider_Fragment
    ) | (
      { __typename?: 'QuizPage' }
      & IElementFragment_QuizPage_Fragment
    ) | (
      { __typename?: 'QuizzSurvey' }
      & IElementFragment_QuizzSurvey_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & IElementFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & IElementFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename?: 'Radio' }
      & IElementFragment_Radio_Fragment
    ) | (
      { __typename?: 'RadioCateg' }
      & IElementFragment_RadioCateg_Fragment
    ) | (
      { __typename?: 'Region' }
      & IElementFragment_Region_Fragment
    ) | (
      { __typename?: 'SectionPage' }
      & IElementFragment_SectionPage_Fragment
    ) | (
      { __typename?: 'Service' }
      & IElementFragment_Service_Fragment
    ) | (
      { __typename?: 'ServicesList' }
      & IElementFragment_ServicesList_Fragment
    ) | (
      { __typename?: 'Settings' }
      & IElementFragment_Settings_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & IElementFragment_SettingsAccessRestrictionCmp_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & IElementFragment_SettingsAccessRestrictionCmp1_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & IElementFragment_SettingsAccessRestrictionCmp2_Fragment
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & IElementFragment_SettingsDateCmp_Fragment
    ) | (
      { __typename?: 'SettingsExternalId' }
      & IElementFragment_SettingsExternalId_Fragment
    ) | (
      { __typename?: 'Space' }
      & IElementFragment_Space_Fragment
    ) | (
      { __typename?: 'StaticPageLink' }
      & IElementFragment_StaticPageLink_Fragment
    ) | (
      { __typename?: 'Subscription' }
      & IElementFragment_Subscription_Fragment
    ) | (
      { __typename?: 'SubscriptionData' }
      & IElementFragment_SubscriptionData_Fragment
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & IElementFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & IElementFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsList' }
      & IElementFragment_SubscriptionsList_Fragment
    ) | (
      { __typename?: 'SumaryNugget' }
      & IElementFragment_SumaryNugget_Fragment
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & IElementFragment_SummaryNuggetStatement_Fragment
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & IElementFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename?: 'TextPage' }
      & IElementFragment_TextPage_Fragment
    ) | (
      { __typename?: 'TextSlide1' }
      & IElementFragment_TextSlide1_Fragment
    ) | (
      { __typename?: 'ThankYouPage' }
      & IElementFragment_ThankYouPage_Fragment
    ) | (
      { __typename?: 'TitleSlider' }
      & IElementFragment_TitleSlider_Fragment
    ) | (
      { __typename?: 'Top10Song' }
      & IElementFragment_Top10Song_Fragment
    ) | (
      { __typename?: 'TranslationContext' }
      & IElementFragment_TranslationContext_Fragment
    ) | (
      { __typename?: 'TranslationFolder' }
      & IElementFragment_TranslationFolder_Fragment
    ) | (
      { __typename?: 'TranslationItem' }
      & IElementFragment_TranslationItem_Fragment
    ) | (
      { __typename?: 'TutorialSlide' }
      & IElementFragment_TutorialSlide_Fragment
    ) | (
      { __typename?: 'UcAudio' }
      & IElementFragment_UcAudio_Fragment
    ) | (
      { __typename?: 'UcImage' }
      & IElementFragment_UcImage_Fragment
    ) | (
      { __typename?: 'UcLineBreak' }
      & IElementFragment_UcLineBreak_Fragment
    ) | (
      { __typename?: 'UcText' }
      & IElementFragment_UcText_Fragment
    ) | (
      { __typename?: 'UcVideo' }
      & IElementFragment_UcVideo_Fragment
    ) | (
      { __typename?: 'UmbracoTest' }
      & IElementFragment_UmbracoTest_Fragment
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & IElementFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & IElementFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IElementFragment_UnitNuggetGapFillAnswerItem_Fragment
    ) | (
      { __typename?: 'UnitProgression' }
      & IElementFragment_UnitProgression_Fragment
    ) | (
      { __typename?: 'VODItem' }
      & IElementFragment_VodItem_Fragment
    ) | (
      { __typename?: 'VODMenu' }
      & IElementFragment_VodMenu_Fragment
    ) | (
      { __typename?: 'ValidationElement' }
      & IElementFragment_ValidationElement_Fragment
    ) | (
      { __typename?: 'VotingFolder' }
      & IElementFragment_VotingFolder_Fragment
    ) | (
      { __typename?: 'VotingRecord' }
      & IElementFragment_VotingRecord_Fragment
    ) | (
      { __typename?: 'WatchCateg' }
      & IElementFragment_WatchCateg_Fragment
    ) | (
      { __typename?: 'WatchedContent' }
      & IElementFragment_WatchedContent_Fragment
    ) | (
      { __typename?: 'Wysiwyg' }
      & IElementFragment_Wysiwyg_Fragment
    ) }
  )>>>, homepageUrl?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
  )>, watchHomepage?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  )>, listenHomepage?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  )>, learnHomepage?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name' | 'url'>
      )>> }
    ) }
  )>, webArtistHome?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
  )>, topMenu?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | (
      { __typename?: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | (
      { __typename?: 'LinkPicker' }
      & ILinkPickerFragmentFragment
    ) | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, subMenu?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | (
      { __typename?: 'LinkIcon' }
      & ILinkIconFragmentFragment
    ) | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, push?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | (
      { __typename?: 'Push' }
      & IPushFragmentFragment
    ) | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, defaultPaywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
);

export type ISettingsFragmentFragment = (
  { __typename: 'Settings' }
  & Pick<ISettings, 'id' | 'url' | 'androidRedirectURL' | 'androidRequiredVersion' | 'androidCurrentVersion' | 'iOSRedirectUrl' | 'iOSCurrentVersion' | 'iOSRequiredVersion' | 'huaweiRedirectUrl' | 'huaweiCurrentVersion' | 'huaweiRequiredVersion' | 'signupForm' | 'title' | 'subtitle' | 'cTALabel' | 'sessionAlertMessage'>
  & { signupSteps?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | (
    { __typename?: 'FormPage' }
    & IFormPageFragmentFragment
  ) | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, passwordValidation?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | (
      { __typename: 'ValidationElement' }
      & IValidationElementFragmentFragment
    ) | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, cover?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, webCover?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, defaultHeaderImage?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type ISubscriptionFragmentFragment = (
  { __typename: 'Subscription' }
  & Pick<ISubscription, 'url' | 'id' | 'name' | 'description' | 'title' | 'subtitle' | 'shortDescription' | 'productID' | 'thankYouTitle' | 'thankYouBody'>
  & { tag?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | (
      { __typename: 'ColorTag' }
      & Pick<IColorTag, 'color' | 'value'>
    ) | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, icon?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, thankYouCover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type ISubscriptionDataFragmentFragment = (
  { __typename: 'SubscriptionData' }
  & Pick<ISubscriptionData, 'subscriptionPrice' | 'subscriptionStart' | 'subscriptionEnd' | 'id' | 'name' | 'deviceType'>
  & { subscriptionType?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
);

export type ITopTenFragmentFragment = (
  { __typename: 'Top10Song' }
  & Pick<ITop10Song, 'subtitle' | 'title'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type ITranslationItemFragmentFragment = (
  { __typename?: 'TranslationItem' }
  & Pick<ITranslationItem, 'id' | 'name' | 'value'>
);

export type IVodItemFragmentFragment = (
  { __typename: 'VODItem' }
  & Pick<IVodItem, 'id' | 'endDate' | 'updateDate' | 'shortDescription' | 'sortOrder' | 'releaseDate' | 'url' | 'productionCountry' | 'name' | 'title' | 'trailer' | 'description' | 'createDate' | 'subtitle' | 'sourceUrl' | 'vimeoHlsUrl' | 'length' | 'public' | 'countriesRestriction' | 'episodeNumber' | 'seasonNumber' | 'byteplusVideoID' | 'youtubeId'>
  & { liveEventId: IVodItem['liveEventID'] }
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
  )>, channel?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'url' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'url' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'url' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'url' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'url' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'url' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'url' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'url' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'url' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'url' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'url' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'url' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'url' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'url' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'url' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'url' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'url' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'url' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'url' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'url' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'url' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'url' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'url' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'url' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'url' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'url' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'url' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'url' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'url' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'url' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'url' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'url' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'url' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'url' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'url' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'url' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'url' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'url' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'url' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'url' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'url' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'url' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'url' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'url' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'url' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'url' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'url' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'url' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'url' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'url' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'url' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'url' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'url' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'url' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'url' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'url' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'url' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'url' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'url' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'url' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'url' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'url' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'url' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'url' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'url' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'url' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'url' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'url' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'url' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'url' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'url' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'url' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'url' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'url' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'url' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'url' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'url' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'url' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'url' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'url' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'url' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'url' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'url' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'url' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'url' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'url' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'url' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'url' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'url' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'url' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'url' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'url' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'url' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'url' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'url' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'url' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'url' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'url' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'url' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'url' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'url' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'url' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'url' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'url' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'url' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'url' | 'name'>
  )>, accessType?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, paywall?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | (
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  ) | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>, regions?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
    { __typename?: 'ContentTag' }
    & IContentTagFragmentFragment
  ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, availableRegions?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>>, interests?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>>, musicGenre?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
  & IContentItemsFragment_VodItem_Fragment
  & IParentInfo_VodItem_Fragment
);

export type IWatchCategFragmentFragment = (
  { __typename: 'WatchCateg' }
  & Pick<IWatchCateg, 'id' | 'url' | 'name' | 'backgroundColor' | 'isExpand'>
  & { thumbnail?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, children: (
    { __typename: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & IMainContentListFragment_ArtistService_Fragment
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & IMainContentListFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename: 'ArtistServicesPage' }
      & IMainContentListFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename: 'AwardCategoryPage' }
      & IMainContentListFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename: 'AwardsArtist' }
      & IMainContentListFragment_AwardsArtist_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & IMainContentListFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename: 'AwardsHomepage' }
      & IMainContentListFragment_AwardsHomepage_Fragment
    ) | (
      { __typename: 'CMSPage' }
      & IMainContentListFragment_CmsPage_Fragment
    ) | (
      { __typename: 'CategBgColor' }
      & IMainContentListFragment_CategBgColor_Fragment
    ) | (
      { __typename: 'CategoryPage' }
      & IMainContentListFragment_CategoryPage_Fragment
    ) | (
      { __typename: 'Channel' }
      & IMainContentListFragment_Channel_Fragment
    ) | (
      { __typename: 'ChannelFolder' }
      & IMainContentListFragment_ChannelFolder_Fragment
    ) | (
      { __typename: 'ChoiceNugget' }
      & IMainContentListFragment_ChoiceNugget_Fragment
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Collection_Fragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & IMainContentListFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename: 'ContentTag' }
      & IMainContentListFragment_ContentTag_Fragment
    ) | (
      { __typename: 'ContentTags' }
      & IMainContentListFragment_ContentTags_Fragment
    ) | (
      { __typename: 'ContentTagsCateg' }
      & IMainContentListFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename: 'Course' }
      & IMainContentListFragment_Course_Fragment
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & IMainContentListFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename: 'CourseCategory' }
      & IMainContentListFragment_CourseCategory_Fragment
    ) | (
      { __typename: 'CourseExam' }
      & IMainContentListFragment_CourseExam_Fragment
    ) | (
      { __typename: 'CourseShare' }
      & IMainContentListFragment_CourseShare_Fragment
    ) | (
      { __typename: 'CourseStatus' }
      & IMainContentListFragment_CourseStatus_Fragment
    ) | (
      { __typename: 'CourseTestProgression' }
      & IMainContentListFragment_CourseTestProgression_Fragment
    ) | (
      { __typename: 'CourseUnit' }
      & IMainContentListFragment_CourseUnit_Fragment
    ) | (
      { __typename: 'Discovery' }
      & IMainContentListFragment_Discovery_Fragment
    ) | (
      { __typename: 'DiscoverySlide1' }
      & IMainContentListFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & IMainContentListFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename: 'FormFolder' }
      & IMainContentListFragment_FormFolder_Fragment
    ) | (
      { __typename: 'FormPage' }
      & IMainContentListFragment_FormPage_Fragment
    ) | (
      { __typename: 'GapfillNugget' }
      & IMainContentListFragment_GapfillNugget_Fragment
    ) | (
      { __typename: 'HelpdeskCateg' }
      & IMainContentListFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename: 'HelpdeskFolder' }
      & IMainContentListFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename: 'HelpdeskPage' }
      & IMainContentListFragment_HelpdeskPage_Fragment
    ) | (
      { __typename: 'HomePage' }
      & IMainContentListFragment_HomePage_Fragment
    ) | (
      { __typename: 'JobBoardPage' }
      & IMainContentListFragment_JobBoardPage_Fragment
    ) | (
      { __typename: 'JobHub' }
      & IMainContentListFragment_JobHub_Fragment
    ) | (
      { __typename: 'JobHubsFolder' }
      & IMainContentListFragment_JobHubsFolder_Fragment
    ) | (
      { __typename: 'JobProgress' }
      & IMainContentListFragment_JobProgress_Fragment
    ) | (
      { __typename: 'JobShare' }
      & IMainContentListFragment_JobShare_Fragment
    ) | (
      { __typename: 'JobTraining' }
      & IMainContentListFragment_JobTraining_Fragment
    ) | (
      { __typename: 'JobTrainingFolder' }
      & IMainContentListFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & IMainContentListFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename: 'JobVacancy' }
      & IMainContentListFragment_JobVacancy_Fragment
    ) | (
      { __typename: 'LandingPage' }
      & IMainContentListFragment_LandingPage_Fragment
    ) | (
      { __typename: 'LearnMenu' }
      & IMainContentListFragment_LearnMenu_Fragment
    ) | (
      { __typename: 'LegalsFolder' }
      & IMainContentListFragment_LegalsFolder_Fragment
    ) | (
      { __typename: 'ListenCateg' }
      & IMainContentListFragment_ListenCateg_Fragment
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_LiveEvent_Fragment
    ) | (
      { __typename: 'LiveEventsMenu' }
      & IMainContentListFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename: 'LiveEventsPage' }
      & IMainContentListFragment_LiveEventsPage_Fragment
    ) | (
      { __typename: 'LiveTVPage' }
      & IMainContentListFragment_LiveTvPage_Fragment
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & IMainContentListFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename: 'MemberDatas' }
      & IMainContentListFragment_MemberDatas_Fragment
    ) | (
      { __typename: 'MemberDownloaded' }
      & IMainContentListFragment_MemberDownloaded_Fragment
    ) | (
      { __typename: 'MemberMessage' }
      & IMainContentListFragment_MemberMessage_Fragment
    ) | (
      { __typename: 'MemberNotify' }
      & IMainContentListFragment_MemberNotify_Fragment
    ) | (
      { __typename: 'MemberOpportunity' }
      & IMainContentListFragment_MemberOpportunity_Fragment
    ) | (
      { __typename: 'MemberSaved' }
      & IMainContentListFragment_MemberSaved_Fragment
    ) | (
      { __typename: 'MemberSearch' }
      & IMainContentListFragment_MemberSearch_Fragment
    ) | (
      { __typename: 'MemberWatched' }
      & IMainContentListFragment_MemberWatched_Fragment
    ) | (
      { __typename: 'MembersDatas' }
      & IMainContentListFragment_MembersDatas_Fragment
    ) | (
      { __typename: 'MiniSitesFolder' }
      & IMainContentListFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename: 'NavMessage' }
      & IMainContentListFragment_NavMessage_Fragment
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & IMainContentListFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename: 'NetlifyDeploy' }
      & IMainContentListFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename: 'News' }
      & IMainContentListFragment_News_Fragment
    ) | (
      { __typename: 'NewsCateg' }
      & IMainContentListFragment_NewsCateg_Fragment
    ) | (
      { __typename: 'NewsFolder' }
      & IMainContentListFragment_NewsFolder_Fragment
    ) | (
      { __typename: 'NewsPage' }
      & IMainContentListFragment_NewsPage_Fragment
    ) | (
      { __typename: 'ObtainedJob' }
      & IMainContentListFragment_ObtainedJob_Fragment
    ) | (
      { __typename: 'Opportunity' }
      & IMainContentListFragment_Opportunity_Fragment
    ) | (
      { __typename: 'OpportunityCenter' }
      & IMainContentListFragment_OpportunityCenter_Fragment
    ) | (
      { __typename: 'OpportunityFolder' }
      & IMainContentListFragment_OpportunityFolder_Fragment
    ) | (
      { __typename: 'Partner' }
      & IMainContentListFragment_Partner_Fragment
    ) | (
      { __typename: 'Partners' }
      & IMainContentListFragment_Partners_Fragment
    ) | (
      { __typename: 'PartnersPage' }
      & IMainContentListFragment_PartnersPage_Fragment
    ) | (
      { __typename: 'Paywall' }
      & IMainContentListFragment_Paywall_Fragment
    ) | (
      { __typename: 'PaywallFolder' }
      & IMainContentListFragment_PaywallFolder_Fragment
    ) | (
      { __typename: 'PersonalityPages' }
      & IMainContentListFragment_PersonalityPages_Fragment
    ) | (
      { __typename: 'PersonalityQuiz' }
      & IMainContentListFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & IMainContentListFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename: 'PersonalityType' }
      & IMainContentListFragment_PersonalityType_Fragment
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Playlist_Fragment
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & IMainContentListFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Podcast_Fragment
    ) | (
      { __typename: 'PodcastCateg' }
      & IMainContentListFragment_PodcastCateg_Fragment
    ) | (
      { __typename: 'PodcastItem' }
      & IMainContentListFragment_PodcastItem_Fragment
    ) | (
      { __typename: 'PodcastMenu' }
      & IMainContentListFragment_PodcastMenu_Fragment
    ) | (
      { __typename: 'PromoCode' }
      & IMainContentListFragment_PromoCode_Fragment
    ) | (
      { __typename: 'PromoCodeFolder' }
      & IMainContentListFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename: 'QuizPage' }
      & IMainContentListFragment_QuizPage_Fragment
    ) | (
      { __typename: 'QuizzSurvey' }
      & IMainContentListFragment_QuizzSurvey_Fragment
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & IMainContentListFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & IMainContentListFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_Radio_Fragment
    ) | (
      { __typename: 'RadioCateg' }
      & IMainContentListFragment_RadioCateg_Fragment
    ) | (
      { __typename: 'Region' }
      & IMainContentListFragment_Region_Fragment
    ) | (
      { __typename: 'SectionPage' }
      & IMainContentListFragment_SectionPage_Fragment
    ) | (
      { __typename: 'Settings' }
      & IMainContentListFragment_Settings_Fragment
    ) | (
      { __typename: 'Space' }
      & IMainContentListFragment_Space_Fragment
    ) | (
      { __typename: 'Subscription' }
      & IMainContentListFragment_Subscription_Fragment
    ) | (
      { __typename: 'SubscriptionData' }
      & IMainContentListFragment_SubscriptionData_Fragment
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & IMainContentListFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & IMainContentListFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename: 'SumaryNugget' }
      & IMainContentListFragment_SumaryNugget_Fragment
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & IMainContentListFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename: 'TextPage' }
      & IMainContentListFragment_TextPage_Fragment
    ) | (
      { __typename: 'ThankYouPage' }
      & IMainContentListFragment_ThankYouPage_Fragment
    ) | (
      { __typename: 'TranslationContext' }
      & IMainContentListFragment_TranslationContext_Fragment
    ) | (
      { __typename: 'TranslationFolder' }
      & IMainContentListFragment_TranslationFolder_Fragment
    ) | (
      { __typename: 'TranslationItem' }
      & IMainContentListFragment_TranslationItem_Fragment
    ) | (
      { __typename: 'UmbracoTest' }
      & IMainContentListFragment_UmbracoTest_Fragment
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & IMainContentListFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename: 'UnitProgression' }
      & IMainContentListFragment_UnitProgression_Fragment
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'title' | 'subtitle' | 'countriesRestriction'>
      & IMainContentListFragment_VodItem_Fragment
    ) | (
      { __typename: 'VODMenu' }
      & IMainContentListFragment_VodMenu_Fragment
    ) | (
      { __typename: 'VotingFolder' }
      & IMainContentListFragment_VotingFolder_Fragment
    ) | (
      { __typename: 'VotingRecord' }
      & IMainContentListFragment_VotingRecord_Fragment
    ) | (
      { __typename: 'WatchCateg' }
      & IMainContentListFragment_WatchCateg_Fragment
    )>> }
  ) }
);

export type IMainContentListFragment_ArtistService_Fragment = { __typename?: 'ArtistService' };

export type IMainContentListFragment_ArtistServiceFolder_Fragment = { __typename?: 'ArtistServiceFolder' };

export type IMainContentListFragment_ArtistServicesPage_Fragment = { __typename?: 'ArtistServicesPage' };

export type IMainContentListFragment_AwardCategoryPage_Fragment = { __typename?: 'AwardCategoryPage' };

export type IMainContentListFragment_AwardsArtist_Fragment = { __typename?: 'AwardsArtist' };

export type IMainContentListFragment_AwardsCategoryMenu_Fragment = { __typename?: 'AwardsCategoryMenu' };

export type IMainContentListFragment_AwardsCategoryMenuDev_Fragment = { __typename?: 'AwardsCategoryMenuDev' };

export type IMainContentListFragment_AwardsCategoryMenuFolder_Fragment = { __typename?: 'AwardsCategoryMenuFolder' };

export type IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment = { __typename?: 'AwardsCategoryMenuFolderDev' };

export type IMainContentListFragment_AwardsHomepage_Fragment = { __typename?: 'AwardsHomepage' };

export type IMainContentListFragment_CmsPage_Fragment = { __typename?: 'CMSPage' };

export type IMainContentListFragment_CategBgColor_Fragment = { __typename?: 'CategBgColor' };

export type IMainContentListFragment_CategoryPage_Fragment = { __typename?: 'CategoryPage' };

export type IMainContentListFragment_Channel_Fragment = (
  { __typename?: 'Channel' }
  & IChannelFragmentFragment
);

export type IMainContentListFragment_ChannelFolder_Fragment = { __typename?: 'ChannelFolder' };

export type IMainContentListFragment_ChoiceNugget_Fragment = { __typename?: 'ChoiceNugget' };

export type IMainContentListFragment_Collection_Fragment = (
  { __typename?: 'Collection' }
  & IContentItemsFragment_Collection_Fragment
  & ICollectionFragmentFragment
);

export type IMainContentListFragment_ContentEditorFolder_Fragment = { __typename?: 'ContentEditorFolder' };

export type IMainContentListFragment_ContentTag_Fragment = { __typename?: 'ContentTag' };

export type IMainContentListFragment_ContentTags_Fragment = { __typename?: 'ContentTags' };

export type IMainContentListFragment_ContentTagsCateg_Fragment = { __typename?: 'ContentTagsCateg' };

export type IMainContentListFragment_Course_Fragment = (
  { __typename?: 'Course' }
  & ICourseFragmentFragment
);

export type IMainContentListFragment_CourseCategoriesFolder_Fragment = { __typename?: 'CourseCategoriesFolder' };

export type IMainContentListFragment_CourseCategory_Fragment = { __typename?: 'CourseCategory' };

export type IMainContentListFragment_CourseExam_Fragment = { __typename?: 'CourseExam' };

export type IMainContentListFragment_CourseShare_Fragment = { __typename?: 'CourseShare' };

export type IMainContentListFragment_CourseStatus_Fragment = { __typename?: 'CourseStatus' };

export type IMainContentListFragment_CourseTestProgression_Fragment = { __typename?: 'CourseTestProgression' };

export type IMainContentListFragment_CourseUnit_Fragment = { __typename?: 'CourseUnit' };

export type IMainContentListFragment_Discovery_Fragment = { __typename?: 'Discovery' };

export type IMainContentListFragment_DiscoverySlide1_Fragment = { __typename?: 'DiscoverySlide1' };

export type IMainContentListFragment_EntrepreunarialHub_Fragment = { __typename?: 'EntrepreunarialHub' };

export type IMainContentListFragment_FormFolder_Fragment = { __typename?: 'FormFolder' };

export type IMainContentListFragment_FormPage_Fragment = { __typename?: 'FormPage' };

export type IMainContentListFragment_GapfillNugget_Fragment = { __typename?: 'GapfillNugget' };

export type IMainContentListFragment_HelpdeskCateg_Fragment = { __typename?: 'HelpdeskCateg' };

export type IMainContentListFragment_HelpdeskFolder_Fragment = { __typename?: 'HelpdeskFolder' };

export type IMainContentListFragment_HelpdeskPage_Fragment = { __typename?: 'HelpdeskPage' };

export type IMainContentListFragment_HomePage_Fragment = { __typename?: 'HomePage' };

export type IMainContentListFragment_JobBoardPage_Fragment = { __typename?: 'JobBoardPage' };

export type IMainContentListFragment_JobHub_Fragment = { __typename?: 'JobHub' };

export type IMainContentListFragment_JobHubsFolder_Fragment = { __typename?: 'JobHubsFolder' };

export type IMainContentListFragment_JobProgress_Fragment = { __typename?: 'JobProgress' };

export type IMainContentListFragment_JobShare_Fragment = { __typename?: 'JobShare' };

export type IMainContentListFragment_JobTraining_Fragment = (
  { __typename?: 'JobTraining' }
  & IJobTrainingFragmentFragment
);

export type IMainContentListFragment_JobTrainingFolder_Fragment = { __typename?: 'JobTrainingFolder' };

export type IMainContentListFragment_JobVacanciesFolder_Fragment = { __typename?: 'JobVacanciesFolder' };

export type IMainContentListFragment_JobVacancy_Fragment = { __typename?: 'JobVacancy' };

export type IMainContentListFragment_LandingPage_Fragment = { __typename?: 'LandingPage' };

export type IMainContentListFragment_LearnMenu_Fragment = { __typename?: 'LearnMenu' };

export type IMainContentListFragment_LegalsFolder_Fragment = { __typename?: 'LegalsFolder' };

export type IMainContentListFragment_ListenCateg_Fragment = { __typename?: 'ListenCateg' };

export type IMainContentListFragment_LiveEvent_Fragment = (
  { __typename?: 'LiveEvent' }
  & IContentItemsFragment_LiveEvent_Fragment
  & ILiveEventFragmentFragment
);

export type IMainContentListFragment_LiveEventsMenu_Fragment = { __typename?: 'LiveEventsMenu' };

export type IMainContentListFragment_LiveEventsPage_Fragment = { __typename?: 'LiveEventsPage' };

export type IMainContentListFragment_LiveTvPage_Fragment = { __typename?: 'LiveTVPage' };

export type IMainContentListFragment_MemberContentTypesLink_Fragment = { __typename?: 'MemberContentTypesLink' };

export type IMainContentListFragment_MemberDatas_Fragment = { __typename?: 'MemberDatas' };

export type IMainContentListFragment_MemberDownloaded_Fragment = { __typename?: 'MemberDownloaded' };

export type IMainContentListFragment_MemberMessage_Fragment = { __typename?: 'MemberMessage' };

export type IMainContentListFragment_MemberNotify_Fragment = { __typename?: 'MemberNotify' };

export type IMainContentListFragment_MemberOpportunity_Fragment = { __typename?: 'MemberOpportunity' };

export type IMainContentListFragment_MemberSaved_Fragment = { __typename?: 'MemberSaved' };

export type IMainContentListFragment_MemberSearch_Fragment = { __typename?: 'MemberSearch' };

export type IMainContentListFragment_MemberWatched_Fragment = { __typename?: 'MemberWatched' };

export type IMainContentListFragment_MembersDatas_Fragment = { __typename?: 'MembersDatas' };

export type IMainContentListFragment_MiniSitesFolder_Fragment = { __typename?: 'MiniSitesFolder' };

export type IMainContentListFragment_NavMessage_Fragment = { __typename?: 'NavMessage' };

export type IMainContentListFragment_NavigationMessagesFolder_Fragment = { __typename?: 'NavigationMessagesFolder' };

export type IMainContentListFragment_NetlifyDeploy_Fragment = { __typename?: 'NetlifyDeploy' };

export type IMainContentListFragment_News_Fragment = (
  { __typename?: 'News' }
  & INewsFragmentFragment
);

export type IMainContentListFragment_NewsCateg_Fragment = { __typename?: 'NewsCateg' };

export type IMainContentListFragment_NewsFolder_Fragment = { __typename?: 'NewsFolder' };

export type IMainContentListFragment_NewsPage_Fragment = { __typename?: 'NewsPage' };

export type IMainContentListFragment_ObtainedJob_Fragment = { __typename?: 'ObtainedJob' };

export type IMainContentListFragment_Opportunity_Fragment = { __typename?: 'Opportunity' };

export type IMainContentListFragment_OpportunityCenter_Fragment = { __typename?: 'OpportunityCenter' };

export type IMainContentListFragment_OpportunityFolder_Fragment = { __typename?: 'OpportunityFolder' };

export type IMainContentListFragment_Partner_Fragment = { __typename?: 'Partner' };

export type IMainContentListFragment_Partners_Fragment = { __typename?: 'Partners' };

export type IMainContentListFragment_PartnersPage_Fragment = { __typename?: 'PartnersPage' };

export type IMainContentListFragment_Paywall_Fragment = { __typename?: 'Paywall' };

export type IMainContentListFragment_PaywallFolder_Fragment = { __typename?: 'PaywallFolder' };

export type IMainContentListFragment_PersonalityPages_Fragment = { __typename?: 'PersonalityPages' };

export type IMainContentListFragment_PersonalityQuiz_Fragment = { __typename?: 'PersonalityQuiz' };

export type IMainContentListFragment_PersonalityQuiz1_Fragment = { __typename?: 'PersonalityQuiz1' };

export type IMainContentListFragment_PersonalityType_Fragment = { __typename?: 'PersonalityType' };

export type IMainContentListFragment_Playlist_Fragment = (
  { __typename?: 'Playlist' }
  & IContentItemsFragment_Playlist_Fragment
  & IPlaylistFragmentFragment
);

export type IMainContentListFragment_PlaylistRadioMenu_Fragment = { __typename?: 'PlaylistRadioMenu' };

export type IMainContentListFragment_Podcast_Fragment = (
  { __typename?: 'Podcast' }
  & IContentItemsFragment_Podcast_Fragment
  & IPodcastFragmentFragment
);

export type IMainContentListFragment_PodcastCateg_Fragment = { __typename?: 'PodcastCateg' };

export type IMainContentListFragment_PodcastItem_Fragment = (
  { __typename?: 'PodcastItem' }
  & IPodcastItemFragmentFragment
);

export type IMainContentListFragment_PodcastMenu_Fragment = { __typename?: 'PodcastMenu' };

export type IMainContentListFragment_PromoCode_Fragment = { __typename?: 'PromoCode' };

export type IMainContentListFragment_PromoCodeFolder_Fragment = { __typename?: 'PromoCodeFolder' };

export type IMainContentListFragment_QuizPage_Fragment = { __typename?: 'QuizPage' };

export type IMainContentListFragment_QuizzSurvey_Fragment = (
  { __typename?: 'QuizzSurvey' }
  & IQuizzSurveyLiteFragmentFragment
);

export type IMainContentListFragment_QuizzSurveyCategory_Fragment = { __typename?: 'QuizzSurveyCategory' };

export type IMainContentListFragment_QuizzSurveyCollection_Fragment = (
  { __typename?: 'QuizzSurveyCollection' }
  & IQuizzSurveyCollectionLiteFragmentFragment
);

export type IMainContentListFragment_Radio_Fragment = (
  { __typename?: 'Radio' }
  & IContentItemsFragment_Radio_Fragment
  & IRadioFragmentFragment
);

export type IMainContentListFragment_RadioCateg_Fragment = { __typename?: 'RadioCateg' };

export type IMainContentListFragment_Region_Fragment = { __typename?: 'Region' };

export type IMainContentListFragment_SectionPage_Fragment = { __typename?: 'SectionPage' };

export type IMainContentListFragment_Settings_Fragment = { __typename?: 'Settings' };

export type IMainContentListFragment_Space_Fragment = { __typename?: 'Space' };

export type IMainContentListFragment_Subscription_Fragment = { __typename?: 'Subscription' };

export type IMainContentListFragment_SubscriptionData_Fragment = { __typename?: 'SubscriptionData' };

export type IMainContentListFragment_SubscriptionDataFolder_Fragment = { __typename?: 'SubscriptionDataFolder' };

export type IMainContentListFragment_SubscriptionsFolder_Fragment = { __typename?: 'SubscriptionsFolder' };

export type IMainContentListFragment_SumaryNugget_Fragment = { __typename?: 'SumaryNugget' };

export type IMainContentListFragment_SurveyQuizzFolder_Fragment = { __typename?: 'SurveyQuizzFolder' };

export type IMainContentListFragment_TextPage_Fragment = { __typename?: 'TextPage' };

export type IMainContentListFragment_ThankYouPage_Fragment = { __typename?: 'ThankYouPage' };

export type IMainContentListFragment_TranslationContext_Fragment = { __typename?: 'TranslationContext' };

export type IMainContentListFragment_TranslationFolder_Fragment = { __typename?: 'TranslationFolder' };

export type IMainContentListFragment_TranslationItem_Fragment = { __typename?: 'TranslationItem' };

export type IMainContentListFragment_UmbracoTest_Fragment = { __typename?: 'UmbracoTest' };

export type IMainContentListFragment_UnitNuggetAnswer_Fragment = { __typename?: 'UnitNuggetAnswer' };

export type IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment = { __typename?: 'UnitNuggetGapFillAnswer' };

export type IMainContentListFragment_UnitProgression_Fragment = { __typename?: 'UnitProgression' };

export type IMainContentListFragment_VodItem_Fragment = (
  { __typename?: 'VODItem' }
  & IContentItemsFragment_VodItem_Fragment
  & IVodItemFragmentFragment
);

export type IMainContentListFragment_VodMenu_Fragment = { __typename?: 'VODMenu' };

export type IMainContentListFragment_VotingFolder_Fragment = { __typename?: 'VotingFolder' };

export type IMainContentListFragment_VotingRecord_Fragment = { __typename?: 'VotingRecord' };

export type IMainContentListFragment_WatchCateg_Fragment = { __typename?: 'WatchCateg' };

export type IMainContentListFragmentFragment = IMainContentListFragment_ArtistService_Fragment | IMainContentListFragment_ArtistServiceFolder_Fragment | IMainContentListFragment_ArtistServicesPage_Fragment | IMainContentListFragment_AwardCategoryPage_Fragment | IMainContentListFragment_AwardsArtist_Fragment | IMainContentListFragment_AwardsCategoryMenu_Fragment | IMainContentListFragment_AwardsCategoryMenuDev_Fragment | IMainContentListFragment_AwardsCategoryMenuFolder_Fragment | IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment | IMainContentListFragment_AwardsHomepage_Fragment | IMainContentListFragment_CmsPage_Fragment | IMainContentListFragment_CategBgColor_Fragment | IMainContentListFragment_CategoryPage_Fragment | IMainContentListFragment_Channel_Fragment | IMainContentListFragment_ChannelFolder_Fragment | IMainContentListFragment_ChoiceNugget_Fragment | IMainContentListFragment_Collection_Fragment | IMainContentListFragment_ContentEditorFolder_Fragment | IMainContentListFragment_ContentTag_Fragment | IMainContentListFragment_ContentTags_Fragment | IMainContentListFragment_ContentTagsCateg_Fragment | IMainContentListFragment_Course_Fragment | IMainContentListFragment_CourseCategoriesFolder_Fragment | IMainContentListFragment_CourseCategory_Fragment | IMainContentListFragment_CourseExam_Fragment | IMainContentListFragment_CourseShare_Fragment | IMainContentListFragment_CourseStatus_Fragment | IMainContentListFragment_CourseTestProgression_Fragment | IMainContentListFragment_CourseUnit_Fragment | IMainContentListFragment_Discovery_Fragment | IMainContentListFragment_DiscoverySlide1_Fragment | IMainContentListFragment_EntrepreunarialHub_Fragment | IMainContentListFragment_FormFolder_Fragment | IMainContentListFragment_FormPage_Fragment | IMainContentListFragment_GapfillNugget_Fragment | IMainContentListFragment_HelpdeskCateg_Fragment | IMainContentListFragment_HelpdeskFolder_Fragment | IMainContentListFragment_HelpdeskPage_Fragment | IMainContentListFragment_HomePage_Fragment | IMainContentListFragment_JobBoardPage_Fragment | IMainContentListFragment_JobHub_Fragment | IMainContentListFragment_JobHubsFolder_Fragment | IMainContentListFragment_JobProgress_Fragment | IMainContentListFragment_JobShare_Fragment | IMainContentListFragment_JobTraining_Fragment | IMainContentListFragment_JobTrainingFolder_Fragment | IMainContentListFragment_JobVacanciesFolder_Fragment | IMainContentListFragment_JobVacancy_Fragment | IMainContentListFragment_LandingPage_Fragment | IMainContentListFragment_LearnMenu_Fragment | IMainContentListFragment_LegalsFolder_Fragment | IMainContentListFragment_ListenCateg_Fragment | IMainContentListFragment_LiveEvent_Fragment | IMainContentListFragment_LiveEventsMenu_Fragment | IMainContentListFragment_LiveEventsPage_Fragment | IMainContentListFragment_LiveTvPage_Fragment | IMainContentListFragment_MemberContentTypesLink_Fragment | IMainContentListFragment_MemberDatas_Fragment | IMainContentListFragment_MemberDownloaded_Fragment | IMainContentListFragment_MemberMessage_Fragment | IMainContentListFragment_MemberNotify_Fragment | IMainContentListFragment_MemberOpportunity_Fragment | IMainContentListFragment_MemberSaved_Fragment | IMainContentListFragment_MemberSearch_Fragment | IMainContentListFragment_MemberWatched_Fragment | IMainContentListFragment_MembersDatas_Fragment | IMainContentListFragment_MiniSitesFolder_Fragment | IMainContentListFragment_NavMessage_Fragment | IMainContentListFragment_NavigationMessagesFolder_Fragment | IMainContentListFragment_NetlifyDeploy_Fragment | IMainContentListFragment_News_Fragment | IMainContentListFragment_NewsCateg_Fragment | IMainContentListFragment_NewsFolder_Fragment | IMainContentListFragment_NewsPage_Fragment | IMainContentListFragment_ObtainedJob_Fragment | IMainContentListFragment_Opportunity_Fragment | IMainContentListFragment_OpportunityCenter_Fragment | IMainContentListFragment_OpportunityFolder_Fragment | IMainContentListFragment_Partner_Fragment | IMainContentListFragment_Partners_Fragment | IMainContentListFragment_PartnersPage_Fragment | IMainContentListFragment_Paywall_Fragment | IMainContentListFragment_PaywallFolder_Fragment | IMainContentListFragment_PersonalityPages_Fragment | IMainContentListFragment_PersonalityQuiz_Fragment | IMainContentListFragment_PersonalityQuiz1_Fragment | IMainContentListFragment_PersonalityType_Fragment | IMainContentListFragment_Playlist_Fragment | IMainContentListFragment_PlaylistRadioMenu_Fragment | IMainContentListFragment_Podcast_Fragment | IMainContentListFragment_PodcastCateg_Fragment | IMainContentListFragment_PodcastItem_Fragment | IMainContentListFragment_PodcastMenu_Fragment | IMainContentListFragment_PromoCode_Fragment | IMainContentListFragment_PromoCodeFolder_Fragment | IMainContentListFragment_QuizPage_Fragment | IMainContentListFragment_QuizzSurvey_Fragment | IMainContentListFragment_QuizzSurveyCategory_Fragment | IMainContentListFragment_QuizzSurveyCollection_Fragment | IMainContentListFragment_Radio_Fragment | IMainContentListFragment_RadioCateg_Fragment | IMainContentListFragment_Region_Fragment | IMainContentListFragment_SectionPage_Fragment | IMainContentListFragment_Settings_Fragment | IMainContentListFragment_Space_Fragment | IMainContentListFragment_Subscription_Fragment | IMainContentListFragment_SubscriptionData_Fragment | IMainContentListFragment_SubscriptionDataFolder_Fragment | IMainContentListFragment_SubscriptionsFolder_Fragment | IMainContentListFragment_SumaryNugget_Fragment | IMainContentListFragment_SurveyQuizzFolder_Fragment | IMainContentListFragment_TextPage_Fragment | IMainContentListFragment_ThankYouPage_Fragment | IMainContentListFragment_TranslationContext_Fragment | IMainContentListFragment_TranslationFolder_Fragment | IMainContentListFragment_TranslationItem_Fragment | IMainContentListFragment_UmbracoTest_Fragment | IMainContentListFragment_UnitNuggetAnswer_Fragment | IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment | IMainContentListFragment_UnitProgression_Fragment | IMainContentListFragment_VodItem_Fragment | IMainContentListFragment_VodMenu_Fragment | IMainContentListFragment_VotingFolder_Fragment | IMainContentListFragment_VotingRecord_Fragment | IMainContentListFragment_WatchCateg_Fragment;

export type IContentItemsFragment_Collection_Fragment = (
  { __typename: 'Collection' }
  & Pick<ICollection, 'title' | 'subtitle' | 'countriesRestriction'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IContentItemsFragment_LiveEvent_Fragment = (
  { __typename: 'LiveEvent' }
  & Pick<ILiveEvent, 'title' | 'subtitle' | 'countriesRestriction'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IContentItemsFragment_Playlist_Fragment = (
  { __typename: 'Playlist' }
  & Pick<IPlaylist, 'title' | 'subtitle' | 'countriesRestriction'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IContentItemsFragment_Podcast_Fragment = (
  { __typename: 'Podcast' }
  & Pick<IPodcast, 'title' | 'subtitle' | 'countriesRestriction'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IContentItemsFragment_Radio_Fragment = (
  { __typename: 'Radio' }
  & Pick<IRadio, 'title' | 'subtitle' | 'countriesRestriction'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IContentItemsFragment_VodItem_Fragment = (
  { __typename: 'VODItem' }
  & Pick<IVodItem, 'title' | 'subtitle' | 'countriesRestriction'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IContentItemsFragmentFragment = IContentItemsFragment_Collection_Fragment | IContentItemsFragment_LiveEvent_Fragment | IContentItemsFragment_Playlist_Fragment | IContentItemsFragment_Podcast_Fragment | IContentItemsFragment_Radio_Fragment | IContentItemsFragment_VodItem_Fragment;

export type IElementFragment_Accordions_Fragment = (
  { __typename: 'Accordions' }
  & Pick<IAccordions, 'contentTypeAlias'>
  & IAccordionsFragmentFragment
);

export type IElementFragment_Advantage_Fragment = (
  { __typename: 'Advantage' }
  & Pick<IAdvantage, 'contentTypeAlias'>
);

export type IElementFragment_AdvantagesList_Fragment = (
  { __typename: 'AdvantagesList' }
  & Pick<IAdvantagesList, 'contentTypeAlias'>
);

export type IElementFragment_Article_Fragment = (
  { __typename: 'Article' }
  & Pick<IArticle, 'contentTypeAlias'>
);

export type IElementFragment_ArtistService_Fragment = (
  { __typename: 'ArtistService' }
  & Pick<IArtistService, 'contentTypeAlias'>
);

export type IElementFragment_ArtistServiceFolder_Fragment = (
  { __typename: 'ArtistServiceFolder' }
  & Pick<IArtistServiceFolder, 'contentTypeAlias'>
);

export type IElementFragment_ArtistServicesPage_Fragment = (
  { __typename: 'ArtistServicesPage' }
  & Pick<IArtistServicesPage, 'contentTypeAlias'>
);

export type IElementFragment_Author_Fragment = (
  { __typename: 'Author' }
  & Pick<IAuthor, 'contentTypeAlias'>
);

export type IElementFragment_AwardCategoryPage_Fragment = (
  { __typename: 'AwardCategoryPage' }
  & Pick<IAwardCategoryPage, 'contentTypeAlias'>
);

export type IElementFragment_AwardsArtist_Fragment = (
  { __typename: 'AwardsArtist' }
  & Pick<IAwardsArtist, 'contentTypeAlias'>
);

export type IElementFragment_AwardsCategoryMenu_Fragment = (
  { __typename: 'AwardsCategoryMenu' }
  & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
);

export type IElementFragment_AwardsCategoryMenuDev_Fragment = (
  { __typename: 'AwardsCategoryMenuDev' }
  & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
);

export type IElementFragment_AwardsCategoryMenuFolder_Fragment = (
  { __typename: 'AwardsCategoryMenuFolder' }
  & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
);

export type IElementFragment_AwardsCategoryMenuFolderDev_Fragment = (
  { __typename: 'AwardsCategoryMenuFolderDev' }
  & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
);

export type IElementFragment_AwardsHomepage_Fragment = (
  { __typename: 'AwardsHomepage' }
  & Pick<IAwardsHomepage, 'contentTypeAlias'>
);

export type IElementFragment_Button_Fragment = (
  { __typename: 'Button' }
  & Pick<IButton, 'contentTypeAlias'>
);

export type IElementFragment_CmsPage_Fragment = (
  { __typename: 'CMSPage' }
  & Pick<ICmsPage, 'contentTypeAlias'>
);

export type IElementFragment_CtaSlide_Fragment = (
  { __typename: 'CTASlide' }
  & Pick<ICtaSlide, 'contentTypeAlias'>
);

export type IElementFragment_CtaSlider_Fragment = (
  { __typename: 'CTASlider' }
  & Pick<ICtaSlider, 'contentTypeAlias'>
);

export type IElementFragment_Card_Fragment = (
  { __typename: 'Card' }
  & Pick<ICard, 'contentTypeAlias'>
);

export type IElementFragment_CardIcon_Fragment = (
  { __typename: 'CardIcon' }
  & Pick<ICardIcon, 'contentTypeAlias'>
);

export type IElementFragment_CardLink_Fragment = (
  { __typename: 'CardLink' }
  & Pick<ICardLink, 'contentTypeAlias'>
);

export type IElementFragment_CardList_Fragment = (
  { __typename: 'CardList' }
  & Pick<ICardList, 'contentTypeAlias'>
);

export type IElementFragment_CategBgColor_Fragment = (
  { __typename: 'CategBgColor' }
  & Pick<ICategBgColor, 'contentTypeAlias'>
);

export type IElementFragment_CategoryPage_Fragment = (
  { __typename: 'CategoryPage' }
  & Pick<ICategoryPage, 'contentTypeAlias'>
);

export type IElementFragment_CategorySlider_Fragment = (
  { __typename: 'CategorySlider' }
  & Pick<ICategorySlider, 'showThumbnailTitle' | 'showThumbnailsSubtitle' | 'title' | 'template' | 'isLink' | 'contentTypeAlias'>
  & { category?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | (
    { __typename?: 'NewsCateg' }
    & INewsCategFragmentFragment
  ) | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | (
    { __typename?: 'PodcastCateg' }
    & IPodcastCategFragmentFragment
  ) | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | (
    { __typename?: 'QuizzSurveyCategory' }
    & IQuizzSurveyCategoryFragmentFragment
  ) | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | (
    { __typename?: 'RadioCateg' }
    & IRadioCategFragmentFragment
  ) | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | (
    { __typename?: 'WatchCateg' }
    & IWatchCategFragmentFragment
  )> }
);

export type IElementFragment_CategorySliderHighlight_Fragment = (
  { __typename: 'CategorySliderHighlight' }
  & Pick<ICategorySliderHighlight, 'showThumbnailTitle' | 'showThumbnailsSubtitle' | 'description' | 'surtitle' | 'title' | 'template' | 'isLink' | 'contentTypeAlias'>
  & { background?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, backgroundDesktop?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], mobileCover: IMediaWithCrops['cropUrl'] }
  )>, category?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | (
    { __typename?: 'NewsCateg' }
    & INewsCategFragmentFragment
  ) | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | (
    { __typename?: 'PodcastCateg' }
    & IPodcastCategFragmentFragment
  ) | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | (
    { __typename?: 'RadioCateg' }
    & IRadioCategFragmentFragment
  ) | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | (
    { __typename?: 'WatchCateg' }
    & IWatchCategFragmentFragment
  )> }
);

export type IElementFragment_Channel_Fragment = (
  { __typename: 'Channel' }
  & Pick<IChannel, 'contentTypeAlias'>
);

export type IElementFragment_ChannelFolder_Fragment = (
  { __typename: 'ChannelFolder' }
  & Pick<IChannelFolder, 'contentTypeAlias'>
);

export type IElementFragment_ChoiceNuggerAnswer_Fragment = (
  { __typename: 'ChoiceNuggerAnswer' }
  & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
);

export type IElementFragment_ChoiceNugget_Fragment = (
  { __typename: 'ChoiceNugget' }
  & Pick<IChoiceNugget, 'contentTypeAlias'>
);

export type IElementFragment_ChoiceNuggetAnswerGroup_Fragment = (
  { __typename: 'ChoiceNuggetAnswerGroup' }
  & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
);

export type IElementFragment_ChoiceNuggetQuestion_Fragment = (
  { __typename: 'ChoiceNuggetQuestion' }
  & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
);

export type IElementFragment_Collection_Fragment = (
  { __typename: 'Collection' }
  & Pick<ICollection, 'contentTypeAlias'>
);

export type IElementFragment_ColorTag_Fragment = (
  { __typename: 'ColorTag' }
  & Pick<IColorTag, 'contentTypeAlias'>
);

export type IElementFragment_ContentAudioFileCmp_Fragment = (
  { __typename: 'ContentAudioFileCmp' }
  & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
);

export type IElementFragment_ContentAudioVimeoCmp_Fragment = (
  { __typename: 'ContentAudioVimeoCmp' }
  & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
);

export type IElementFragment_ContentCategCmp_Fragment = (
  { __typename: 'ContentCategCmp' }
  & Pick<IContentCategCmp, 'contentTypeAlias'>
);

export type IElementFragment_ContentEpgProgramFileCmp_Fragment = (
  { __typename: 'ContentEPGProgramFileCmp' }
  & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
);

export type IElementFragment_ContentEditorFolder_Fragment = (
  { __typename: 'ContentEditorFolder' }
  & Pick<IContentEditorFolder, 'contentTypeAlias'>
);

export type IElementFragment_ContentLink_Fragment = (
  { __typename: 'ContentLink' }
  & Pick<IContentLink, 'contentTypeAlias'>
);

export type IElementFragment_ContentSlider_Fragment = (
  { __typename: 'ContentSlider' }
  & Pick<IContentSlider, 'showThumbnailTitle' | 'showThumbnailsSubtitle' | 'template' | 'title' | 'contentTypeAlias'>
  & { contentItems?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'url' | 'name'>
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'url' | 'name'>
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'url' | 'name'>
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'url' | 'name'>
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'url' | 'name'>
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'url' | 'name'>
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'url' | 'name'>
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'url' | 'name'>
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'url' | 'name'>
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'url' | 'name'>
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'url' | 'name'>
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'url' | 'name'>
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'url' | 'name'>
    & ICategoryPageFragmentFragment
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'url' | 'name'>
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'url' | 'name'>
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'url' | 'name'>
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'url' | 'name'>
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'url' | 'name'>
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'url' | 'name'>
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'url' | 'name'>
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'url' | 'name'>
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'url' | 'name'>
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'url' | 'name'>
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'url' | 'name'>
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'url' | 'name'>
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'url' | 'name'>
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'url' | 'name'>
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'url' | 'name'>
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'url' | 'name'>
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'url' | 'name'>
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'url' | 'name'>
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'url' | 'name'>
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'url' | 'name'>
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'url' | 'name'>
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'url' | 'name'>
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'url' | 'name'>
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'url' | 'name'>
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'url' | 'name'>
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'url' | 'name'>
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'url' | 'name'>
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'url' | 'name'>
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'url' | 'name'>
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'url' | 'name'>
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'url' | 'name'>
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'url' | 'name'>
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'url' | 'name'>
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'url' | 'name'>
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'url' | 'name'>
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'url' | 'name'>
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'url' | 'name'>
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'url' | 'name'>
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'url' | 'name'>
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'url' | 'name'>
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'url' | 'name'>
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'url' | 'name'>
    & ILiveEventsPageFragmentFragment
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'url' | 'name'>
    & ILiveTvPageFragmentFragment
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'url' | 'name'>
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'url' | 'name'>
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'url' | 'name'>
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'url' | 'name'>
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'url' | 'name'>
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'url' | 'name'>
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'url' | 'name'>
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'url' | 'name'>
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'url' | 'name'>
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'url' | 'name'>
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'url' | 'name'>
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'url' | 'name'>
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'url' | 'name'>
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'url' | 'name'>
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'url' | 'name'>
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'url' | 'name'>
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'url' | 'name'>
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'url' | 'name'>
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'url' | 'name'>
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'url' | 'name'>
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'url' | 'name'>
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'url' | 'name'>
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'url' | 'name'>
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'url' | 'name'>
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'url' | 'name'>
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'url' | 'name'>
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'url' | 'name'>
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'url' | 'name'>
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'url' | 'name'>
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'url' | 'name'>
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'url' | 'name'>
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'url' | 'name'>
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'url' | 'name'>
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'url' | 'name'>
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'url' | 'name'>
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'url' | 'name'>
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'url' | 'name'>
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'url' | 'name'>
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'url' | 'name'>
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'url' | 'name'>
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'url' | 'name'>
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'url' | 'name'>
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'url' | 'name'>
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'url' | 'name'>
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'url' | 'name'>
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'url' | 'name'>
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'url' | 'name'>
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'url' | 'name'>
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'url' | 'name'>
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'url' | 'name'>
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'url' | 'name'>
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'url' | 'name'>
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'url' | 'name'>
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'url' | 'name'>
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'url' | 'name'>
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'url' | 'name'>
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'url' | 'name'>
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'url' | 'name'>
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'url' | 'name'>
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'url' | 'name'>
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'url' | 'name'>
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'url' | 'name'>
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'url' | 'name'>
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'url' | 'name'>
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'url' | 'name'>
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'url' | 'name'>
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'url' | 'name'>
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'url' | 'name'>
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'url' | 'name'>
    & IMainContentListFragment_WatchCateg_Fragment
  )>>> }
);

export type IElementFragment_ContentSliderHighlight_Fragment = (
  { __typename: 'ContentSliderHighlight' }
  & Pick<IContentSliderHighlight, 'showThumbnailTitle' | 'showThumbnailsSubtitle' | 'description' | 'surtitle' | 'title' | 'template' | 'contentTypeAlias'>
  & { background?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, backgroundDesktop?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'], mobileCover: IMediaWithCrops['cropUrl'] }
  )>, contentItems?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'url' | 'name'>
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'url' | 'name'>
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'url' | 'name'>
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'url' | 'name'>
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'url' | 'name'>
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'url' | 'name'>
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'url' | 'name'>
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'url' | 'name'>
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'url' | 'name'>
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'url' | 'name'>
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'url' | 'name'>
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'url' | 'name'>
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'url' | 'name'>
    & ICategoryPageFragmentFragment
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'url' | 'name'>
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'url' | 'name'>
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'url' | 'name'>
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'url' | 'name'>
    & IContentItemsFragment_Collection_Fragment
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'url' | 'name'>
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'url' | 'name'>
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'url' | 'name'>
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'url' | 'name'>
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'url' | 'name'>
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'url' | 'name'>
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'url' | 'name'>
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'url' | 'name'>
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'url' | 'name'>
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'url' | 'name'>
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'url' | 'name'>
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'url' | 'name'>
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'url' | 'name'>
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'url' | 'name'>
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'url' | 'name'>
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'url' | 'name'>
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'url' | 'name'>
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'url' | 'name'>
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'url' | 'name'>
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'url' | 'name'>
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'url' | 'name'>
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'url' | 'name'>
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'url' | 'name'>
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'url' | 'name'>
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'url' | 'name'>
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'url' | 'name'>
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'url' | 'name'>
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'url' | 'name'>
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'url' | 'name'>
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'url' | 'name'>
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'url' | 'name'>
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'url' | 'name'>
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'url' | 'name'>
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'url' | 'name'>
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'url' | 'name'>
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'url' | 'name'>
    & IContentItemsFragment_LiveEvent_Fragment
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'url' | 'name'>
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'url' | 'name'>
    & ILiveEventsPageFragmentFragment
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'url' | 'name'>
    & ILiveTvPageFragmentFragment
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'url' | 'name'>
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'url' | 'name'>
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'url' | 'name'>
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'url' | 'name'>
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'url' | 'name'>
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'url' | 'name'>
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'url' | 'name'>
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'url' | 'name'>
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'url' | 'name'>
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'url' | 'name'>
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'url' | 'name'>
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'url' | 'name'>
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'url' | 'name'>
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'url' | 'name'>
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'url' | 'name'>
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'url' | 'name'>
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'url' | 'name'>
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'url' | 'name'>
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'url' | 'name'>
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'url' | 'name'>
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'url' | 'name'>
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'url' | 'name'>
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'url' | 'name'>
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'url' | 'name'>
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'url' | 'name'>
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'url' | 'name'>
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'url' | 'name'>
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'url' | 'name'>
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'url' | 'name'>
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'url' | 'name'>
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'url' | 'name'>
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'url' | 'name'>
    & IContentItemsFragment_Playlist_Fragment
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'url' | 'name'>
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'url' | 'name'>
    & IContentItemsFragment_Podcast_Fragment
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'url' | 'name'>
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'url' | 'name'>
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'url' | 'name'>
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'url' | 'name'>
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'url' | 'name'>
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'url' | 'name'>
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'url' | 'name'>
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'url' | 'name'>
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'url' | 'name'>
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'url' | 'name'>
    & IContentItemsFragment_Radio_Fragment
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'url' | 'name'>
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'url' | 'name'>
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'url' | 'name'>
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'url' | 'name'>
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'url' | 'name'>
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'url' | 'name'>
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'url' | 'name'>
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'url' | 'name'>
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'url' | 'name'>
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'url' | 'name'>
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'url' | 'name'>
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'url' | 'name'>
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'url' | 'name'>
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'url' | 'name'>
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'url' | 'name'>
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'url' | 'name'>
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'url' | 'name'>
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'url' | 'name'>
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'url' | 'name'>
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'url' | 'name'>
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'url' | 'name'>
    & IContentItemsFragment_VodItem_Fragment
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'url' | 'name'>
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'url' | 'name'>
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'url' | 'name'>
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'url' | 'name'>
    & IMainContentListFragment_WatchCateg_Fragment
  )>>> }
);

export type IElementFragment_ContentTag_Fragment = (
  { __typename: 'ContentTag' }
  & Pick<IContentTag, 'contentTypeAlias'>
);

export type IElementFragment_ContentTags_Fragment = (
  { __typename: 'ContentTags' }
  & Pick<IContentTags, 'contentTypeAlias'>
);

export type IElementFragment_ContentTagsCateg_Fragment = (
  { __typename: 'ContentTagsCateg' }
  & Pick<IContentTagsCateg, 'contentTypeAlias'>
);

export type IElementFragment_ContextualContentSlider_Fragment = (
  { __typename: 'ContextualContentSlider' }
  & Pick<IContextualContentSlider, 'showThumbnailTitle' | 'showThumbnailsSubtitle' | 'template' | 'type' | 'title' | 'contentTypeAlias'>
);

export type IElementFragment_Course_Fragment = (
  { __typename: 'Course' }
  & Pick<ICourse, 'contentTypeAlias'>
);

export type IElementFragment_CourseCategoriesFolder_Fragment = (
  { __typename: 'CourseCategoriesFolder' }
  & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
);

export type IElementFragment_CourseCategory_Fragment = (
  { __typename: 'CourseCategory' }
  & Pick<ICourseCategory, 'contentTypeAlias'>
);

export type IElementFragment_CourseCategorySlider_Fragment = (
  { __typename: 'CourseCategorySlider' }
  & Pick<ICourseCategorySlider, 'title' | 'template' | 'isLink' | 'contentTypeAlias'>
  & { category?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | (
    { __typename: 'CourseCategory' }
    & ICourseCategoryFragmentFragment
  ) | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
);

export type IElementFragment_CourseExam_Fragment = (
  { __typename: 'CourseExam' }
  & Pick<ICourseExam, 'contentTypeAlias'>
);

export type IElementFragment_CourseItemsSlider_Fragment = (
  { __typename: 'CourseItemsSlider' }
  & Pick<ICourseItemsSlider, 'contentTypeAlias'>
  & ICourseItemsSliderFragmentFragment
);

export type IElementFragment_CourseNugget_Fragment = (
  { __typename: 'CourseNugget' }
  & Pick<ICourseNugget, 'contentTypeAlias'>
);

export type IElementFragment_CoursePage_Fragment = (
  { __typename: 'CoursePage' }
  & Pick<ICoursePage, 'contentTypeAlias'>
);

export type IElementFragment_CourseShare_Fragment = (
  { __typename: 'CourseShare' }
  & Pick<ICourseShare, 'contentTypeAlias'>
);

export type IElementFragment_CourseStatus_Fragment = (
  { __typename: 'CourseStatus' }
  & Pick<ICourseStatus, 'contentTypeAlias'>
);

export type IElementFragment_CourseTestProgression_Fragment = (
  { __typename: 'CourseTestProgression' }
  & Pick<ICourseTestProgression, 'contentTypeAlias'>
);

export type IElementFragment_CourseUnit_Fragment = (
  { __typename: 'CourseUnit' }
  & Pick<ICourseUnit, 'contentTypeAlias'>
);

export type IElementFragment_Discovery_Fragment = (
  { __typename: 'Discovery' }
  & Pick<IDiscovery, 'contentTypeAlias'>
);

export type IElementFragment_DiscoverySlide_Fragment = (
  { __typename: 'DiscoverySlide' }
  & Pick<IDiscoverySlide, 'contentTypeAlias'>
);

export type IElementFragment_DiscoverySlide1_Fragment = (
  { __typename: 'DiscoverySlide1' }
  & Pick<IDiscoverySlide1, 'contentTypeAlias'>
);

export type IElementFragment_EditoSlider_Fragment = (
  { __typename: 'EditoSlider' }
  & Pick<IEditoSlider, 'contentTypeAlias'>
);

export type IElementFragment_EntrepreunarialHub_Fragment = (
  { __typename: 'EntrepreunarialHub' }
  & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
);

export type IElementFragment_ExpandMenu_Fragment = (
  { __typename: 'ExpandMenu' }
  & Pick<IExpandMenu, 'contentTypeAlias'>
);

export type IElementFragment_ExternalLink_Fragment = (
  { __typename: 'ExternalLink' }
  & Pick<IExternalLink, 'contentTypeAlias'>
);

export type IElementFragment_FaqItem_Fragment = (
  { __typename: 'FaqItem' }
  & Pick<IFaqItem, 'contentTypeAlias'>
);

export type IElementFragment_FaqPageLink_Fragment = (
  { __typename: 'FaqPageLink' }
  & Pick<IFaqPageLink, 'contentTypeAlias'>
);

export type IElementFragment_FormFolder_Fragment = (
  { __typename: 'FormFolder' }
  & Pick<IFormFolder, 'contentTypeAlias'>
);

export type IElementFragment_FormPage_Fragment = (
  { __typename: 'FormPage' }
  & Pick<IFormPage, 'contentTypeAlias'>
);

export type IElementFragment_Gallery_Fragment = (
  { __typename: 'Gallery' }
  & Pick<IGallery, 'contentTypeAlias'>
);

export type IElementFragment_GapFillNuggetAnswer_Fragment = (
  { __typename: 'GapFillNuggetAnswer' }
  & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
);

export type IElementFragment_GapFillNuggetImageAnswer_Fragment = (
  { __typename: 'GapFillNuggetImageAnswer' }
  & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
);

export type IElementFragment_GapfillNugget_Fragment = (
  { __typename: 'GapfillNugget' }
  & Pick<IGapfillNugget, 'contentTypeAlias'>
);

export type IElementFragment_HelpdeskCateg_Fragment = (
  { __typename: 'HelpdeskCateg' }
  & Pick<IHelpdeskCateg, 'contentTypeAlias'>
);

export type IElementFragment_HelpdeskFolder_Fragment = (
  { __typename: 'HelpdeskFolder' }
  & Pick<IHelpdeskFolder, 'contentTypeAlias'>
);

export type IElementFragment_HelpdeskPage_Fragment = (
  { __typename: 'HelpdeskPage' }
  & Pick<IHelpdeskPage, 'contentTypeAlias'>
);

export type IElementFragment_HeroBanner_Fragment = (
  { __typename: 'HeroBanner' }
  & Pick<IHeroBanner, 'title' | 'subtitle' | 'contentTypeAlias'>
  & { cTA?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | (
      { __typename?: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, backgroundImage?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, backgroundImageMobile?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IElementFragment_HeroBanner1_Fragment = (
  { __typename: 'HeroBanner1' }
  & Pick<IHeroBanner1, 'contentTypeAlias'>
);

export type IElementFragment_HeroServices_Fragment = (
  { __typename: 'HeroServices' }
  & Pick<IHeroServices, 'contentTypeAlias'>
);

export type IElementFragment_HeroSlide_Fragment = (
  { __typename: 'HeroSlide' }
  & Pick<IHeroSlide, 'contentTypeAlias'>
);

export type IElementFragment_HeroVideoCover_Fragment = (
  { __typename: 'HeroVideoCover' }
  & Pick<IHeroVideoCover, 'contentTypeAlias'>
  & IHeroVideoCoverFragmentFragment
);

export type IElementFragment_HomePage_Fragment = (
  { __typename: 'HomePage' }
  & Pick<IHomePage, 'contentTypeAlias'>
);

export type IElementFragment_IconSlide_Fragment = (
  { __typename: 'IconSlide' }
  & Pick<IIconSlide, 'contentTypeAlias'>
);

export type IElementFragment_InternalLink_Fragment = (
  { __typename: 'InternalLink' }
  & Pick<IInternalLink, 'contentTypeAlias'>
);

export type IElementFragment_JobBoardPage_Fragment = (
  { __typename: 'JobBoardPage' }
  & Pick<IJobBoardPage, 'contentTypeAlias'>
);

export type IElementFragment_JobHub_Fragment = (
  { __typename: 'JobHub' }
  & Pick<IJobHub, 'contentTypeAlias'>
);

export type IElementFragment_JobHubsFolder_Fragment = (
  { __typename: 'JobHubsFolder' }
  & Pick<IJobHubsFolder, 'contentTypeAlias'>
);

export type IElementFragment_JobProgress_Fragment = (
  { __typename: 'JobProgress' }
  & Pick<IJobProgress, 'contentTypeAlias'>
);

export type IElementFragment_JobShare_Fragment = (
  { __typename: 'JobShare' }
  & Pick<IJobShare, 'contentTypeAlias'>
);

export type IElementFragment_JobTraining_Fragment = (
  { __typename: 'JobTraining' }
  & Pick<IJobTraining, 'contentTypeAlias'>
);

export type IElementFragment_JobTrainingFolder_Fragment = (
  { __typename: 'JobTrainingFolder' }
  & Pick<IJobTrainingFolder, 'contentTypeAlias'>
);

export type IElementFragment_JobVacanciesFolder_Fragment = (
  { __typename: 'JobVacanciesFolder' }
  & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
);

export type IElementFragment_JobVacancy_Fragment = (
  { __typename: 'JobVacancy' }
  & Pick<IJobVacancy, 'contentTypeAlias'>
);

export type IElementFragment_KeyFigure_Fragment = (
  { __typename: 'KeyFigure' }
  & Pick<IKeyFigure, 'contentTypeAlias'>
);

export type IElementFragment_KeyFigures_Fragment = (
  { __typename: 'KeyFigures' }
  & Pick<IKeyFigures, 'contentTypeAlias'>
  & IKeyFiguresFragmentFragment
);

export type IElementFragment_LandingAbout_Fragment = (
  { __typename: 'LandingAbout' }
  & Pick<ILandingAbout, 'contentTypeAlias'>
);

export type IElementFragment_LandingPage_Fragment = (
  { __typename: 'LandingPage' }
  & Pick<ILandingPage, 'contentTypeAlias'>
);

export type IElementFragment_LearnHeroSlide_Fragment = (
  { __typename: 'LearnHeroSlide' }
  & Pick<ILearnHeroSlide, 'contentTypeAlias'>
);

export type IElementFragment_LearnMenu_Fragment = (
  { __typename: 'LearnMenu' }
  & Pick<ILearnMenu, 'contentTypeAlias'>
);

export type IElementFragment_LegalPageLink_Fragment = (
  { __typename: 'LegalPageLink' }
  & Pick<ILegalPageLink, 'contentTypeAlias'>
);

export type IElementFragment_LegalsFolder_Fragment = (
  { __typename: 'LegalsFolder' }
  & Pick<ILegalsFolder, 'contentTypeAlias'>
);

export type IElementFragment_LinkIcon_Fragment = (
  { __typename: 'LinkIcon' }
  & Pick<ILinkIcon, 'contentTypeAlias'>
);

export type IElementFragment_LinkPicker_Fragment = (
  { __typename: 'LinkPicker' }
  & Pick<ILinkPicker, 'contentTypeAlias'>
);

export type IElementFragment_ListenCateg_Fragment = (
  { __typename: 'ListenCateg' }
  & Pick<IListenCateg, 'contentTypeAlias'>
);

export type IElementFragment_LiveEvent_Fragment = (
  { __typename: 'LiveEvent' }
  & Pick<ILiveEvent, 'contentTypeAlias'>
);

export type IElementFragment_LiveEventsMenu_Fragment = (
  { __typename: 'LiveEventsMenu' }
  & Pick<ILiveEventsMenu, 'contentTypeAlias'>
);

export type IElementFragment_LiveEventsPage_Fragment = (
  { __typename: 'LiveEventsPage' }
  & Pick<ILiveEventsPage, 'contentTypeAlias'>
);

export type IElementFragment_LiveTvPage_Fragment = (
  { __typename: 'LiveTVPage' }
  & Pick<ILiveTvPage, 'contentTypeAlias'>
);

export type IElementFragment_LogoLink_Fragment = (
  { __typename: 'LogoLink' }
  & Pick<ILogoLink, 'contentTypeAlias'>
);

export type IElementFragment_LogoSlider_Fragment = (
  { __typename: 'LogoSlider' }
  & Pick<ILogoSlider, 'contentTypeAlias'>
  & ILogoSliderFragmentFragment
);

export type IElementFragment_MemberContentTypesLink_Fragment = (
  { __typename: 'MemberContentTypesLink' }
  & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
);

export type IElementFragment_MemberDatas_Fragment = (
  { __typename: 'MemberDatas' }
  & Pick<IMemberDatas, 'contentTypeAlias'>
);

export type IElementFragment_MemberDownloaded_Fragment = (
  { __typename: 'MemberDownloaded' }
  & Pick<IMemberDownloaded, 'contentTypeAlias'>
);

export type IElementFragment_MemberMessage_Fragment = (
  { __typename: 'MemberMessage' }
  & Pick<IMemberMessage, 'contentTypeAlias'>
);

export type IElementFragment_MemberNotify_Fragment = (
  { __typename: 'MemberNotify' }
  & Pick<IMemberNotify, 'contentTypeAlias'>
);

export type IElementFragment_MemberOpportunity_Fragment = (
  { __typename: 'MemberOpportunity' }
  & Pick<IMemberOpportunity, 'contentTypeAlias'>
);

export type IElementFragment_MemberSaved_Fragment = (
  { __typename: 'MemberSaved' }
  & Pick<IMemberSaved, 'contentTypeAlias'>
);

export type IElementFragment_MemberSearch_Fragment = (
  { __typename: 'MemberSearch' }
  & Pick<IMemberSearch, 'contentTypeAlias'>
);

export type IElementFragment_MemberWatched_Fragment = (
  { __typename: 'MemberWatched' }
  & Pick<IMemberWatched, 'contentTypeAlias'>
);

export type IElementFragment_MembersDatas_Fragment = (
  { __typename: 'MembersDatas' }
  & Pick<IMembersDatas, 'contentTypeAlias'>
);

export type IElementFragment_MenuColumn_Fragment = (
  { __typename: 'MenuColumn' }
  & Pick<IMenuColumn, 'contentTypeAlias'>
);

export type IElementFragment_MetadatasLanguages_Fragment = (
  { __typename: 'MetadatasLanguages' }
  & Pick<IMetadatasLanguages, 'contentTypeAlias'>
);

export type IElementFragment_MetadatasVodLanguage_Fragment = (
  { __typename: 'MetadatasVODLanguage' }
  & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
);

export type IElementFragment_MetasExclusives_Fragment = (
  { __typename: 'MetasExclusives' }
  & Pick<IMetasExclusives, 'contentTypeAlias'>
);

export type IElementFragment_MetasPublicationDate_Fragment = (
  { __typename: 'MetasPublicationDate' }
  & Pick<IMetasPublicationDate, 'contentTypeAlias'>
);

export type IElementFragment_MetasTrailerCmp_Fragment = (
  { __typename: 'MetasTrailerCmp' }
  & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
);

export type IElementFragment_MiniSitesFolder_Fragment = (
  { __typename: 'MiniSitesFolder' }
  & Pick<IMiniSitesFolder, 'contentTypeAlias'>
);

export type IElementFragment_MultiSlider_Fragment = (
  { __typename: 'MultiSlider' }
  & Pick<IMultiSlider, 'contentTypeAlias'>
  & IMultiSliderFragmentFragment
);

export type IElementFragment_MulticategoriesSlider_Fragment = (
  { __typename: 'MulticategoriesSlider' }
  & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
  & IMulticategoriesSliderFragmentFragment
);

export type IElementFragment_NavMessage_Fragment = (
  { __typename: 'NavMessage' }
  & Pick<INavMessage, 'contentTypeAlias'>
);

export type IElementFragment_NavigationMessagesFolder_Fragment = (
  { __typename: 'NavigationMessagesFolder' }
  & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
);

export type IElementFragment_NetlifyDeploy_Fragment = (
  { __typename: 'NetlifyDeploy' }
  & Pick<INetlifyDeploy, 'contentTypeAlias'>
);

export type IElementFragment_News_Fragment = (
  { __typename: 'News' }
  & Pick<INews, 'contentTypeAlias'>
);

export type IElementFragment_NewsCateg_Fragment = (
  { __typename: 'NewsCateg' }
  & Pick<INewsCateg, 'contentTypeAlias'>
);

export type IElementFragment_NewsFolder_Fragment = (
  { __typename: 'NewsFolder' }
  & Pick<INewsFolder, 'contentTypeAlias'>
);

export type IElementFragment_NewsPage_Fragment = (
  { __typename: 'NewsPage' }
  & Pick<INewsPage, 'contentTypeAlias'>
);

export type IElementFragment_NuggetsTextAnswerOption_Fragment = (
  { __typename: 'NuggetsTextAnswerOption' }
  & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
);

export type IElementFragment_ObtainedJob_Fragment = (
  { __typename: 'ObtainedJob' }
  & Pick<IObtainedJob, 'contentTypeAlias'>
);

export type IElementFragment_Opportunity_Fragment = (
  { __typename: 'Opportunity' }
  & Pick<IOpportunity, 'contentTypeAlias'>
);

export type IElementFragment_OpportunityCenter_Fragment = (
  { __typename: 'OpportunityCenter' }
  & Pick<IOpportunityCenter, 'contentTypeAlias'>
);

export type IElementFragment_OpportunityFolder_Fragment = (
  { __typename: 'OpportunityFolder' }
  & Pick<IOpportunityFolder, 'contentTypeAlias'>
);

export type IElementFragment_PageSeo_Fragment = (
  { __typename: 'PageSEO' }
  & Pick<IPageSeo, 'contentTypeAlias'>
);

export type IElementFragment_PagecontentSlider_Fragment = (
  { __typename: 'PagecontentSlider' }
  & Pick<IPagecontentSlider, 'contentTypeAlias'>
  & IPagecontentSliderFragmentFragment
);

export type IElementFragment_Partner_Fragment = (
  { __typename: 'Partner' }
  & Pick<IPartner, 'contentTypeAlias'>
);

export type IElementFragment_PartnerSlider_Fragment = (
  { __typename: 'PartnerSlider' }
  & Pick<IPartnerSlider, 'contentTypeAlias'>
  & IPartnerSliderFragmentFragment
  & IPartnerSliderFragmentFragment
);

export type IElementFragment_Partners_Fragment = (
  { __typename: 'Partners' }
  & Pick<IPartners, 'contentTypeAlias'>
);

export type IElementFragment_PartnersPage_Fragment = (
  { __typename: 'PartnersPage' }
  & Pick<IPartnersPage, 'contentTypeAlias'>
);

export type IElementFragment_Paywall_Fragment = (
  { __typename: 'Paywall' }
  & Pick<IPaywall, 'contentTypeAlias'>
);

export type IElementFragment_PaywallFolder_Fragment = (
  { __typename: 'PaywallFolder' }
  & Pick<IPaywallFolder, 'contentTypeAlias'>
);

export type IElementFragment_PersonalityPages_Fragment = (
  { __typename: 'PersonalityPages' }
  & Pick<IPersonalityPages, 'contentTypeAlias'>
);

export type IElementFragment_PersonalityPush_Fragment = (
  { __typename: 'PersonalityPush' }
  & Pick<IPersonalityPush, 'contentTypeAlias'>
);

export type IElementFragment_PersonalityQuiz_Fragment = (
  { __typename: 'PersonalityQuiz' }
  & Pick<IPersonalityQuiz, 'contentTypeAlias'>
);

export type IElementFragment_PersonalityQuiz1_Fragment = (
  { __typename: 'PersonalityQuiz1' }
  & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
);

export type IElementFragment_PersonalityQuizQuestion_Fragment = (
  { __typename: 'PersonalityQuizQuestion' }
  & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
);

export type IElementFragment_PersonalityType_Fragment = (
  { __typename: 'PersonalityType' }
  & Pick<IPersonalityType, 'contentTypeAlias'>
);

export type IElementFragment_Playlist_Fragment = (
  { __typename: 'Playlist' }
  & Pick<IPlaylist, 'contentTypeAlias'>
);

export type IElementFragment_PlaylistRadioMenu_Fragment = (
  { __typename: 'PlaylistRadioMenu' }
  & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
);

export type IElementFragment_Podcast_Fragment = (
  { __typename: 'Podcast' }
  & Pick<IPodcast, 'contentTypeAlias'>
);

export type IElementFragment_PodcastCateg_Fragment = (
  { __typename: 'PodcastCateg' }
  & Pick<IPodcastCateg, 'contentTypeAlias'>
);

export type IElementFragment_PodcastItem_Fragment = (
  { __typename: 'PodcastItem' }
  & Pick<IPodcastItem, 'contentTypeAlias'>
);

export type IElementFragment_PodcastMenu_Fragment = (
  { __typename: 'PodcastMenu' }
  & Pick<IPodcastMenu, 'contentTypeAlias'>
);

export type IElementFragment_PromoCode_Fragment = (
  { __typename: 'PromoCode' }
  & Pick<IPromoCode, 'contentTypeAlias'>
);

export type IElementFragment_PromoCodeFolder_Fragment = (
  { __typename: 'PromoCodeFolder' }
  & Pick<IPromoCodeFolder, 'contentTypeAlias'>
);

export type IElementFragment_Push_Fragment = (
  { __typename: 'Push' }
  & Pick<IPush, 'contentTypeAlias'>
  & IPushFragmentFragment
);

export type IElementFragment_QuizItemsSlider_Fragment = (
  { __typename: 'QuizItemsSlider' }
  & Pick<IQuizItemsSlider, 'contentTypeAlias'>
  & IQuizItemsSliderFragmentFragment
);

export type IElementFragment_QuizPage_Fragment = (
  { __typename: 'QuizPage' }
  & Pick<IQuizPage, 'contentTypeAlias'>
);

export type IElementFragment_QuizzSurvey_Fragment = (
  { __typename: 'QuizzSurvey' }
  & Pick<IQuizzSurvey, 'contentTypeAlias'>
);

export type IElementFragment_QuizzSurveyCategory_Fragment = (
  { __typename: 'QuizzSurveyCategory' }
  & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
);

export type IElementFragment_QuizzSurveyCollection_Fragment = (
  { __typename: 'QuizzSurveyCollection' }
  & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
);

export type IElementFragment_Radio_Fragment = (
  { __typename: 'Radio' }
  & Pick<IRadio, 'contentTypeAlias'>
);

export type IElementFragment_RadioCateg_Fragment = (
  { __typename: 'RadioCateg' }
  & Pick<IRadioCateg, 'contentTypeAlias'>
);

export type IElementFragment_Region_Fragment = (
  { __typename: 'Region' }
  & Pick<IRegion, 'contentTypeAlias'>
);

export type IElementFragment_SectionPage_Fragment = (
  { __typename: 'SectionPage' }
  & Pick<ISectionPage, 'contentTypeAlias'>
);

export type IElementFragment_Service_Fragment = (
  { __typename: 'Service' }
  & Pick<IService, 'contentTypeAlias'>
);

export type IElementFragment_ServicesList_Fragment = (
  { __typename: 'ServicesList' }
  & Pick<IServicesList, 'contentTypeAlias'>
);

export type IElementFragment_Settings_Fragment = (
  { __typename: 'Settings' }
  & Pick<ISettings, 'contentTypeAlias'>
);

export type IElementFragment_SettingsAccessRestrictionCmp_Fragment = (
  { __typename: 'SettingsAccessRestrictionCmp' }
  & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
);

export type IElementFragment_SettingsAccessRestrictionCmp1_Fragment = (
  { __typename: 'SettingsAccessRestrictionCmp1' }
  & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
);

export type IElementFragment_SettingsAccessRestrictionCmp2_Fragment = (
  { __typename: 'SettingsAccessRestrictionCmp2' }
  & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
);

export type IElementFragment_SettingsDateCmp_Fragment = (
  { __typename: 'SettingsDateCmp' }
  & Pick<ISettingsDateCmp, 'contentTypeAlias'>
);

export type IElementFragment_SettingsExternalId_Fragment = (
  { __typename: 'SettingsExternalId' }
  & Pick<ISettingsExternalId, 'contentTypeAlias'>
);

export type IElementFragment_Space_Fragment = (
  { __typename: 'Space' }
  & Pick<ISpace, 'contentTypeAlias'>
);

export type IElementFragment_StaticPageLink_Fragment = (
  { __typename: 'StaticPageLink' }
  & Pick<IStaticPageLink, 'contentTypeAlias'>
);

export type IElementFragment_Subscription_Fragment = (
  { __typename: 'Subscription' }
  & Pick<ISubscription, 'contentTypeAlias'>
);

export type IElementFragment_SubscriptionData_Fragment = (
  { __typename: 'SubscriptionData' }
  & Pick<ISubscriptionData, 'contentTypeAlias'>
);

export type IElementFragment_SubscriptionDataFolder_Fragment = (
  { __typename: 'SubscriptionDataFolder' }
  & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
);

export type IElementFragment_SubscriptionsFolder_Fragment = (
  { __typename: 'SubscriptionsFolder' }
  & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
);

export type IElementFragment_SubscriptionsList_Fragment = (
  { __typename: 'SubscriptionsList' }
  & Pick<ISubscriptionsList, 'contentTypeAlias'>
);

export type IElementFragment_SumaryNugget_Fragment = (
  { __typename: 'SumaryNugget' }
  & Pick<ISumaryNugget, 'contentTypeAlias'>
);

export type IElementFragment_SummaryNuggetStatement_Fragment = (
  { __typename: 'SummaryNuggetStatement' }
  & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
);

export type IElementFragment_SurveyQuizzFolder_Fragment = (
  { __typename: 'SurveyQuizzFolder' }
  & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
);

export type IElementFragment_TextPage_Fragment = (
  { __typename: 'TextPage' }
  & Pick<ITextPage, 'contentTypeAlias'>
);

export type IElementFragment_TextSlide1_Fragment = (
  { __typename: 'TextSlide1' }
  & Pick<ITextSlide1, 'contentTypeAlias'>
);

export type IElementFragment_ThankYouPage_Fragment = (
  { __typename: 'ThankYouPage' }
  & Pick<IThankYouPage, 'contentTypeAlias'>
);

export type IElementFragment_TitleSlider_Fragment = (
  { __typename: 'TitleSlider' }
  & Pick<ITitleSlider, 'contentTypeAlias'>
);

export type IElementFragment_Top10Song_Fragment = (
  { __typename: 'Top10Song' }
  & Pick<ITop10Song, 'contentTypeAlias'>
);

export type IElementFragment_TranslationContext_Fragment = (
  { __typename: 'TranslationContext' }
  & Pick<ITranslationContext, 'contentTypeAlias'>
);

export type IElementFragment_TranslationFolder_Fragment = (
  { __typename: 'TranslationFolder' }
  & Pick<ITranslationFolder, 'contentTypeAlias'>
);

export type IElementFragment_TranslationItem_Fragment = (
  { __typename: 'TranslationItem' }
  & Pick<ITranslationItem, 'contentTypeAlias'>
);

export type IElementFragment_TutorialSlide_Fragment = (
  { __typename: 'TutorialSlide' }
  & Pick<ITutorialSlide, 'contentTypeAlias'>
);

export type IElementFragment_UcAudio_Fragment = (
  { __typename: 'UcAudio' }
  & Pick<IUcAudio, 'contentTypeAlias'>
);

export type IElementFragment_UcImage_Fragment = (
  { __typename: 'UcImage' }
  & Pick<IUcImage, 'contentTypeAlias'>
);

export type IElementFragment_UcLineBreak_Fragment = (
  { __typename: 'UcLineBreak' }
  & Pick<IUcLineBreak, 'contentTypeAlias'>
);

export type IElementFragment_UcText_Fragment = (
  { __typename: 'UcText' }
  & Pick<IUcText, 'contentTypeAlias'>
);

export type IElementFragment_UcVideo_Fragment = (
  { __typename: 'UcVideo' }
  & Pick<IUcVideo, 'contentTypeAlias'>
);

export type IElementFragment_UmbracoTest_Fragment = (
  { __typename: 'UmbracoTest' }
  & Pick<IUmbracoTest, 'contentTypeAlias'>
);

export type IElementFragment_UnitNuggetAnswer_Fragment = (
  { __typename: 'UnitNuggetAnswer' }
  & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
);

export type IElementFragment_UnitNuggetGapFillAnswer_Fragment = (
  { __typename: 'UnitNuggetGapFillAnswer' }
  & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
);

export type IElementFragment_UnitNuggetGapFillAnswerItem_Fragment = (
  { __typename: 'UnitNuggetGapFillAnswerItem' }
  & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
);

export type IElementFragment_UnitProgression_Fragment = (
  { __typename: 'UnitProgression' }
  & Pick<IUnitProgression, 'contentTypeAlias'>
);

export type IElementFragment_VodItem_Fragment = (
  { __typename: 'VODItem' }
  & Pick<IVodItem, 'contentTypeAlias'>
);

export type IElementFragment_VodMenu_Fragment = (
  { __typename: 'VODMenu' }
  & Pick<IVodMenu, 'contentTypeAlias'>
);

export type IElementFragment_ValidationElement_Fragment = (
  { __typename: 'ValidationElement' }
  & Pick<IValidationElement, 'contentTypeAlias'>
);

export type IElementFragment_VotingFolder_Fragment = (
  { __typename: 'VotingFolder' }
  & Pick<IVotingFolder, 'contentTypeAlias'>
);

export type IElementFragment_VotingRecord_Fragment = (
  { __typename: 'VotingRecord' }
  & Pick<IVotingRecord, 'contentTypeAlias'>
);

export type IElementFragment_WatchCateg_Fragment = (
  { __typename: 'WatchCateg' }
  & Pick<IWatchCateg, 'contentTypeAlias'>
);

export type IElementFragment_WatchedContent_Fragment = (
  { __typename: 'WatchedContent' }
  & Pick<IWatchedContent, 'contentTypeAlias'>
);

export type IElementFragment_Wysiwyg_Fragment = (
  { __typename: 'Wysiwyg' }
  & Pick<IWysiwyg, 'contentTypeAlias'>
  & IWysiwygFragmentFragment
);

export type IElementFragmentFragment = IElementFragment_Accordions_Fragment | IElementFragment_Advantage_Fragment | IElementFragment_AdvantagesList_Fragment | IElementFragment_Article_Fragment | IElementFragment_ArtistService_Fragment | IElementFragment_ArtistServiceFolder_Fragment | IElementFragment_ArtistServicesPage_Fragment | IElementFragment_Author_Fragment | IElementFragment_AwardCategoryPage_Fragment | IElementFragment_AwardsArtist_Fragment | IElementFragment_AwardsCategoryMenu_Fragment | IElementFragment_AwardsCategoryMenuDev_Fragment | IElementFragment_AwardsCategoryMenuFolder_Fragment | IElementFragment_AwardsCategoryMenuFolderDev_Fragment | IElementFragment_AwardsHomepage_Fragment | IElementFragment_Button_Fragment | IElementFragment_CmsPage_Fragment | IElementFragment_CtaSlide_Fragment | IElementFragment_CtaSlider_Fragment | IElementFragment_Card_Fragment | IElementFragment_CardIcon_Fragment | IElementFragment_CardLink_Fragment | IElementFragment_CardList_Fragment | IElementFragment_CategBgColor_Fragment | IElementFragment_CategoryPage_Fragment | IElementFragment_CategorySlider_Fragment | IElementFragment_CategorySliderHighlight_Fragment | IElementFragment_Channel_Fragment | IElementFragment_ChannelFolder_Fragment | IElementFragment_ChoiceNuggerAnswer_Fragment | IElementFragment_ChoiceNugget_Fragment | IElementFragment_ChoiceNuggetAnswerGroup_Fragment | IElementFragment_ChoiceNuggetQuestion_Fragment | IElementFragment_Collection_Fragment | IElementFragment_ColorTag_Fragment | IElementFragment_ContentAudioFileCmp_Fragment | IElementFragment_ContentAudioVimeoCmp_Fragment | IElementFragment_ContentCategCmp_Fragment | IElementFragment_ContentEpgProgramFileCmp_Fragment | IElementFragment_ContentEditorFolder_Fragment | IElementFragment_ContentLink_Fragment | IElementFragment_ContentSlider_Fragment | IElementFragment_ContentSliderHighlight_Fragment | IElementFragment_ContentTag_Fragment | IElementFragment_ContentTags_Fragment | IElementFragment_ContentTagsCateg_Fragment | IElementFragment_ContextualContentSlider_Fragment | IElementFragment_Course_Fragment | IElementFragment_CourseCategoriesFolder_Fragment | IElementFragment_CourseCategory_Fragment | IElementFragment_CourseCategorySlider_Fragment | IElementFragment_CourseExam_Fragment | IElementFragment_CourseItemsSlider_Fragment | IElementFragment_CourseNugget_Fragment | IElementFragment_CoursePage_Fragment | IElementFragment_CourseShare_Fragment | IElementFragment_CourseStatus_Fragment | IElementFragment_CourseTestProgression_Fragment | IElementFragment_CourseUnit_Fragment | IElementFragment_Discovery_Fragment | IElementFragment_DiscoverySlide_Fragment | IElementFragment_DiscoverySlide1_Fragment | IElementFragment_EditoSlider_Fragment | IElementFragment_EntrepreunarialHub_Fragment | IElementFragment_ExpandMenu_Fragment | IElementFragment_ExternalLink_Fragment | IElementFragment_FaqItem_Fragment | IElementFragment_FaqPageLink_Fragment | IElementFragment_FormFolder_Fragment | IElementFragment_FormPage_Fragment | IElementFragment_Gallery_Fragment | IElementFragment_GapFillNuggetAnswer_Fragment | IElementFragment_GapFillNuggetImageAnswer_Fragment | IElementFragment_GapfillNugget_Fragment | IElementFragment_HelpdeskCateg_Fragment | IElementFragment_HelpdeskFolder_Fragment | IElementFragment_HelpdeskPage_Fragment | IElementFragment_HeroBanner_Fragment | IElementFragment_HeroBanner1_Fragment | IElementFragment_HeroServices_Fragment | IElementFragment_HeroSlide_Fragment | IElementFragment_HeroVideoCover_Fragment | IElementFragment_HomePage_Fragment | IElementFragment_IconSlide_Fragment | IElementFragment_InternalLink_Fragment | IElementFragment_JobBoardPage_Fragment | IElementFragment_JobHub_Fragment | IElementFragment_JobHubsFolder_Fragment | IElementFragment_JobProgress_Fragment | IElementFragment_JobShare_Fragment | IElementFragment_JobTraining_Fragment | IElementFragment_JobTrainingFolder_Fragment | IElementFragment_JobVacanciesFolder_Fragment | IElementFragment_JobVacancy_Fragment | IElementFragment_KeyFigure_Fragment | IElementFragment_KeyFigures_Fragment | IElementFragment_LandingAbout_Fragment | IElementFragment_LandingPage_Fragment | IElementFragment_LearnHeroSlide_Fragment | IElementFragment_LearnMenu_Fragment | IElementFragment_LegalPageLink_Fragment | IElementFragment_LegalsFolder_Fragment | IElementFragment_LinkIcon_Fragment | IElementFragment_LinkPicker_Fragment | IElementFragment_ListenCateg_Fragment | IElementFragment_LiveEvent_Fragment | IElementFragment_LiveEventsMenu_Fragment | IElementFragment_LiveEventsPage_Fragment | IElementFragment_LiveTvPage_Fragment | IElementFragment_LogoLink_Fragment | IElementFragment_LogoSlider_Fragment | IElementFragment_MemberContentTypesLink_Fragment | IElementFragment_MemberDatas_Fragment | IElementFragment_MemberDownloaded_Fragment | IElementFragment_MemberMessage_Fragment | IElementFragment_MemberNotify_Fragment | IElementFragment_MemberOpportunity_Fragment | IElementFragment_MemberSaved_Fragment | IElementFragment_MemberSearch_Fragment | IElementFragment_MemberWatched_Fragment | IElementFragment_MembersDatas_Fragment | IElementFragment_MenuColumn_Fragment | IElementFragment_MetadatasLanguages_Fragment | IElementFragment_MetadatasVodLanguage_Fragment | IElementFragment_MetasExclusives_Fragment | IElementFragment_MetasPublicationDate_Fragment | IElementFragment_MetasTrailerCmp_Fragment | IElementFragment_MiniSitesFolder_Fragment | IElementFragment_MultiSlider_Fragment | IElementFragment_MulticategoriesSlider_Fragment | IElementFragment_NavMessage_Fragment | IElementFragment_NavigationMessagesFolder_Fragment | IElementFragment_NetlifyDeploy_Fragment | IElementFragment_News_Fragment | IElementFragment_NewsCateg_Fragment | IElementFragment_NewsFolder_Fragment | IElementFragment_NewsPage_Fragment | IElementFragment_NuggetsTextAnswerOption_Fragment | IElementFragment_ObtainedJob_Fragment | IElementFragment_Opportunity_Fragment | IElementFragment_OpportunityCenter_Fragment | IElementFragment_OpportunityFolder_Fragment | IElementFragment_PageSeo_Fragment | IElementFragment_PagecontentSlider_Fragment | IElementFragment_Partner_Fragment | IElementFragment_PartnerSlider_Fragment | IElementFragment_Partners_Fragment | IElementFragment_PartnersPage_Fragment | IElementFragment_Paywall_Fragment | IElementFragment_PaywallFolder_Fragment | IElementFragment_PersonalityPages_Fragment | IElementFragment_PersonalityPush_Fragment | IElementFragment_PersonalityQuiz_Fragment | IElementFragment_PersonalityQuiz1_Fragment | IElementFragment_PersonalityQuizQuestion_Fragment | IElementFragment_PersonalityType_Fragment | IElementFragment_Playlist_Fragment | IElementFragment_PlaylistRadioMenu_Fragment | IElementFragment_Podcast_Fragment | IElementFragment_PodcastCateg_Fragment | IElementFragment_PodcastItem_Fragment | IElementFragment_PodcastMenu_Fragment | IElementFragment_PromoCode_Fragment | IElementFragment_PromoCodeFolder_Fragment | IElementFragment_Push_Fragment | IElementFragment_QuizItemsSlider_Fragment | IElementFragment_QuizPage_Fragment | IElementFragment_QuizzSurvey_Fragment | IElementFragment_QuizzSurveyCategory_Fragment | IElementFragment_QuizzSurveyCollection_Fragment | IElementFragment_Radio_Fragment | IElementFragment_RadioCateg_Fragment | IElementFragment_Region_Fragment | IElementFragment_SectionPage_Fragment | IElementFragment_Service_Fragment | IElementFragment_ServicesList_Fragment | IElementFragment_Settings_Fragment | IElementFragment_SettingsAccessRestrictionCmp_Fragment | IElementFragment_SettingsAccessRestrictionCmp1_Fragment | IElementFragment_SettingsAccessRestrictionCmp2_Fragment | IElementFragment_SettingsDateCmp_Fragment | IElementFragment_SettingsExternalId_Fragment | IElementFragment_Space_Fragment | IElementFragment_StaticPageLink_Fragment | IElementFragment_Subscription_Fragment | IElementFragment_SubscriptionData_Fragment | IElementFragment_SubscriptionDataFolder_Fragment | IElementFragment_SubscriptionsFolder_Fragment | IElementFragment_SubscriptionsList_Fragment | IElementFragment_SumaryNugget_Fragment | IElementFragment_SummaryNuggetStatement_Fragment | IElementFragment_SurveyQuizzFolder_Fragment | IElementFragment_TextPage_Fragment | IElementFragment_TextSlide1_Fragment | IElementFragment_ThankYouPage_Fragment | IElementFragment_TitleSlider_Fragment | IElementFragment_Top10Song_Fragment | IElementFragment_TranslationContext_Fragment | IElementFragment_TranslationFolder_Fragment | IElementFragment_TranslationItem_Fragment | IElementFragment_TutorialSlide_Fragment | IElementFragment_UcAudio_Fragment | IElementFragment_UcImage_Fragment | IElementFragment_UcLineBreak_Fragment | IElementFragment_UcText_Fragment | IElementFragment_UcVideo_Fragment | IElementFragment_UmbracoTest_Fragment | IElementFragment_UnitNuggetAnswer_Fragment | IElementFragment_UnitNuggetGapFillAnswer_Fragment | IElementFragment_UnitNuggetGapFillAnswerItem_Fragment | IElementFragment_UnitProgression_Fragment | IElementFragment_VodItem_Fragment | IElementFragment_VodMenu_Fragment | IElementFragment_ValidationElement_Fragment | IElementFragment_VotingFolder_Fragment | IElementFragment_VotingRecord_Fragment | IElementFragment_WatchCateg_Fragment | IElementFragment_WatchedContent_Fragment | IElementFragment_Wysiwyg_Fragment;

export type IAccordionsFragmentFragment = (
  { __typename: 'Accordions' }
  & Pick<IAccordions, 'title'>
  & { accordions?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | (
      { __typename: 'FaqItem' }
      & IFaqItemFragmentFragment
    ) | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IAdvantageFragmentFragment = (
  { __typename: 'Advantage' }
  & Pick<IAdvantage, 'description' | 'title'>
  & { image?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IAdvantagesListFragmentFragment = (
  { __typename?: 'AdvantagesList' }
  & Pick<IAdvantagesList, 'template'>
  & { advantages?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | (
      { __typename: 'Advantage' }
      & IAdvantageFragmentFragment
    ) | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IArticleFragmentFragment = (
  { __typename: 'Article' }
  & Pick<IArticle, 'title' | 'description'>
);

export type IAuthorFragmentFragment = (
  { __typename: 'Author' }
  & Pick<IAuthor, 'authorName'>
  & { authorImage?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IAwardsCategoryMenuFragmentFragment = (
  { __typename?: 'AwardsCategoryMenu' }
  & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'title'>
  & { menu?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | (
      { __typename: 'LinkPicker' }
      & ILinkPickerFragmentFragment
    ) | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IButtonFragmentFragment = (
  { __typename: 'Button' }
  & Pick<IButton, 'icon' | 'size' | 'title' | 'variant'>
  & { link_to?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & Pick<IAccordions, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Advantage' }
      & Pick<IAdvantage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AdvantagesList' }
      & Pick<IAdvantagesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Article' }
      & Pick<IArticle, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistService' }
      & Pick<IArtistService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Author' }
      & Pick<IAuthor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Button' }
      & Pick<IButton, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CMSPage' }
      & Pick<ICmsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlide' }
      & Pick<ICtaSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlider' }
      & Pick<ICtaSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Card' }
      & Pick<ICard, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardIcon' }
      & Pick<ICardIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardLink' }
      & Pick<ICardLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardList' }
      & Pick<ICardList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategBgColor' }
      & Pick<ICategBgColor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategoryPage' }
      & Pick<ICategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySlider' }
      & Pick<ICategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Channel' }
      & Pick<IChannel, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChannelFolder' }
      & Pick<IChannelFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Collection' }
      & Pick<ICollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ColorTag' }
      & Pick<IColorTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentCategCmp' }
      & Pick<IContentCategCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentLink' }
      & Pick<IContentLink, 'contentTypeAlias'>
      & IContentLinkFragmentFragment
    ) | (
      { __typename?: 'ContentSlider' }
      & Pick<IContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & Pick<IContentSliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTag' }
      & Pick<IContentTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTags' }
      & Pick<IContentTags, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & Pick<IContextualContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Course' }
      & Pick<ICourse, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategory' }
      & Pick<ICourseCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & Pick<ICourseCategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseExam' }
      & Pick<ICourseExam, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & Pick<ICourseItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseNugget' }
      & Pick<ICourseNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CoursePage' }
      & Pick<ICoursePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseShare' }
      & Pick<ICourseShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseStatus' }
      & Pick<ICourseStatus, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseUnit' }
      & Pick<ICourseUnit, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Discovery' }
      & Pick<IDiscovery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide' }
      & Pick<IDiscoverySlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EditoSlider' }
      & Pick<IEditoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExpandMenu' }
      & Pick<IExpandMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExternalLink' }
      & Pick<IExternalLink, 'contentTypeAlias'>
      & IExternalLinkFragmentFragment
    ) | (
      { __typename?: 'FaqItem' }
      & Pick<IFaqItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqPageLink' }
      & Pick<IFaqPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormFolder' }
      & Pick<IFormFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormPage' }
      & Pick<IFormPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Gallery' }
      & Pick<IGallery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner' }
      & Pick<IHeroBanner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner1' }
      & Pick<IHeroBanner1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroServices' }
      & Pick<IHeroServices, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroSlide' }
      & Pick<IHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroVideoCover' }
      & Pick<IHeroVideoCover, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HomePage' }
      & Pick<IHomePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'IconSlide' }
      & Pick<IIconSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'InternalLink' }
      & Pick<IInternalLink, 'contentTypeAlias'>
      & IInternalLinkFragmentFragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHub' }
      & Pick<IJobHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobProgress' }
      & Pick<IJobProgress, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobShare' }
      & Pick<IJobShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacancy' }
      & Pick<IJobVacancy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigure' }
      & Pick<IKeyFigure, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigures' }
      & Pick<IKeyFigures, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingAbout' }
      & Pick<ILandingAbout, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingPage' }
      & Pick<ILandingPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & Pick<ILearnHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnMenu' }
      & Pick<ILearnMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalPageLink' }
      & Pick<ILegalPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkIcon' }
      & Pick<ILinkIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkPicker' }
      & Pick<ILinkPicker, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ListenCateg' }
      & Pick<IListenCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEvent' }
      & Pick<ILiveEvent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoLink' }
      & Pick<ILogoLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoSlider' }
      & Pick<ILogoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDatas' }
      & Pick<IMemberDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberMessage' }
      & Pick<IMemberMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberNotify' }
      & Pick<IMemberNotify, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSaved' }
      & Pick<IMemberSaved, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSearch' }
      & Pick<IMemberSearch, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberWatched' }
      & Pick<IMemberWatched, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MembersDatas' }
      & Pick<IMembersDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MenuColumn' }
      & Pick<IMenuColumn, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & Pick<IMetadatasLanguages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasExclusives' }
      & Pick<IMetasExclusives, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & Pick<IMetasPublicationDate, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MultiSlider' }
      & Pick<IMultiSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavMessage' }
      & Pick<INavMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'News' }
      & Pick<INews, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsCateg' }
      & Pick<INewsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsFolder' }
      & Pick<INewsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsPage' }
      & Pick<INewsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ObtainedJob' }
      & Pick<IObtainedJob, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Opportunity' }
      & Pick<IOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PageSEO' }
      & Pick<IPageSeo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PagecontentSlider' }
      & Pick<IPagecontentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partner' }
      & Pick<IPartner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnerSlider' }
      & Pick<IPartnerSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partners' }
      & Pick<IPartners, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnersPage' }
      & Pick<IPartnersPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Paywall' }
      & Pick<IPaywall, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPush' }
      & Pick<IPersonalityPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityType' }
      & Pick<IPersonalityType, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Playlist' }
      & Pick<IPlaylist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Podcast' }
      & Pick<IPodcast, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastItem' }
      & Pick<IPodcastItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCode' }
      & Pick<IPromoCode, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Push' }
      & Pick<IPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & Pick<IQuizItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizPage' }
      & Pick<IQuizPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Radio' }
      & Pick<IRadio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'RadioCateg' }
      & Pick<IRadioCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Region' }
      & Pick<IRegion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SectionPage' }
      & Pick<ISectionPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Service' }
      & Pick<IService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ServicesList' }
      & Pick<IServicesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Settings' }
      & Pick<ISettings, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & Pick<ISettingsDateCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsExternalId' }
      & Pick<ISettingsExternalId, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Space' }
      & Pick<ISpace, 'contentTypeAlias'>
    ) | (
      { __typename?: 'StaticPageLink' }
      & Pick<IStaticPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Subscription' }
      & Pick<ISubscription, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsList' }
      & Pick<ISubscriptionsList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextPage' }
      & Pick<ITextPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextSlide1' }
      & Pick<ITextSlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ThankYouPage' }
      & Pick<IThankYouPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TitleSlider' }
      & Pick<ITitleSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Top10Song' }
      & Pick<ITop10Song, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationContext' }
      & Pick<ITranslationContext, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationItem' }
      & Pick<ITranslationItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TutorialSlide' }
      & Pick<ITutorialSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcAudio' }
      & Pick<IUcAudio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcImage' }
      & Pick<IUcImage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcLineBreak' }
      & Pick<IUcLineBreak, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcText' }
      & Pick<IUcText, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcVideo' }
      & Pick<IUcVideo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitProgression' }
      & Pick<IUnitProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODItem' }
      & Pick<IVodItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODMenu' }
      & Pick<IVodMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ValidationElement' }
      & Pick<IValidationElement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingFolder' }
      & Pick<IVotingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingRecord' }
      & Pick<IVotingRecord, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchCateg' }
      & Pick<IWatchCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchedContent' }
      & Pick<IWatchedContent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Wysiwyg' }
      & Pick<IWysiwyg, 'contentTypeAlias'>
    ) }
  )>>> }
);

export type ICtaSliderFragmentFragment = (
  { __typename?: 'MultiSlider' }
  & Pick<IMultiSlider, 'title' | 'description' | 'template'>
  & { sliders?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | (
      { __typename: 'TitleSlider' }
      & ITitleSliderFragmentFragment
    ) | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IContentLinkFragmentFragment = (
  { __typename: 'ContentLink' }
  & { link?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ArtistService_Fragment
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ArtistServiceFolder_Fragment
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ArtistServicesPage_Fragment
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_AwardCategoryPage_Fragment
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_AwardsArtist_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_AwardsCategoryMenu_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_AwardsHomepage_Fragment
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CmsPage_Fragment
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CategBgColor_Fragment
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CategoryPage_Fragment
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'sourceUrl' | 'url' | 'id' | 'name'>
    & { liveEventId: IChannel['vimeoEventId'] }
    & IContentRestrictedCountries_Channel_Fragment
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ChannelFolder_Fragment
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ChoiceNugget_Fragment
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Collection_Fragment
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ContentEditorFolder_Fragment
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ContentTag_Fragment
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ContentTags_Fragment
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ContentTagsCateg_Fragment
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Course_Fragment
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CourseCategoriesFolder_Fragment
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CourseCategory_Fragment
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CourseExam_Fragment
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CourseShare_Fragment
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CourseStatus_Fragment
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CourseTestProgression_Fragment
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_CourseUnit_Fragment
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Discovery_Fragment
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_DiscoverySlide1_Fragment
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_EntrepreunarialHub_Fragment
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_FormFolder_Fragment
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_FormPage_Fragment
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_GapfillNugget_Fragment
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_HelpdeskCateg_Fragment
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_HelpdeskFolder_Fragment
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_HelpdeskPage_Fragment
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_HomePage_Fragment
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobBoardPage_Fragment
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobHub_Fragment
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobHubsFolder_Fragment
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobProgress_Fragment
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobShare_Fragment
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobTraining_Fragment
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobTrainingFolder_Fragment
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobVacanciesFolder_Fragment
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_JobVacancy_Fragment
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_LandingPage_Fragment
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_LearnMenu_Fragment
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_LegalsFolder_Fragment
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ListenCateg_Fragment
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'sourceUrl' | 'url' | 'id' | 'name'>
    & { liveEventId: ILiveEvent['liveEventID'] }
    & IContentRestrictedCountries_LiveEvent_Fragment
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_LiveEventsMenu_Fragment
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_LiveEventsPage_Fragment
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_LiveTvPage_Fragment
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberContentTypesLink_Fragment
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberDatas_Fragment
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberDownloaded_Fragment
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberMessage_Fragment
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberNotify_Fragment
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberOpportunity_Fragment
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberSaved_Fragment
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberSearch_Fragment
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MemberWatched_Fragment
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MembersDatas_Fragment
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_MiniSitesFolder_Fragment
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_NavMessage_Fragment
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_NavigationMessagesFolder_Fragment
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_NetlifyDeploy_Fragment
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_News_Fragment
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_NewsCateg_Fragment
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_NewsFolder_Fragment
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_NewsPage_Fragment
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ObtainedJob_Fragment
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Opportunity_Fragment
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_OpportunityCenter_Fragment
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_OpportunityFolder_Fragment
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Partner_Fragment
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Partners_Fragment
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PartnersPage_Fragment
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Paywall_Fragment
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PaywallFolder_Fragment
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PersonalityPages_Fragment
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PersonalityQuiz_Fragment
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PersonalityQuiz1_Fragment
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PersonalityType_Fragment
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Playlist_Fragment
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PlaylistRadioMenu_Fragment
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Podcast_Fragment
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PodcastCateg_Fragment
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PodcastItem_Fragment
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PodcastMenu_Fragment
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PromoCode_Fragment
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_PromoCodeFolder_Fragment
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_QuizPage_Fragment
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_QuizzSurvey_Fragment
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_QuizzSurveyCategory_Fragment
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_QuizzSurveyCollection_Fragment
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Radio_Fragment
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_RadioCateg_Fragment
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Region_Fragment
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_SectionPage_Fragment
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Settings_Fragment
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Space_Fragment
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_Subscription_Fragment
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_SubscriptionData_Fragment
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_SubscriptionDataFolder_Fragment
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_SubscriptionsFolder_Fragment
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_SumaryNugget_Fragment
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_SurveyQuizzFolder_Fragment
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_TextPage_Fragment
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_ThankYouPage_Fragment
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_TranslationContext_Fragment
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_TranslationFolder_Fragment
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_TranslationItem_Fragment
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_UmbracoTest_Fragment
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_UnitNuggetAnswer_Fragment
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_UnitProgression_Fragment
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_VodItem_Fragment
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_VodMenu_Fragment
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_VotingFolder_Fragment
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_VotingRecord_Fragment
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'url' | 'id' | 'name'>
    & IContentRestrictedCountries_WatchCateg_Fragment
  )> }
);

export type IDiscoverySlideFragmentFragment = (
  { __typename: 'DiscoverySlide' }
  & Pick<IDiscoverySlide, 'button_label' | 'shortDescription' | 'title'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, slideContent?: Maybe<(
    { __typename?: 'ArtistService' }
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename?: 'AwardsArtist' }
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename?: 'AwardsHomepage' }
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename?: 'CMSPage' }
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename?: 'CategBgColor' }
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename?: 'CategoryPage' }
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename?: 'Channel' }
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename?: 'ChannelFolder' }
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename?: 'ChoiceNugget' }
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename?: 'Collection' }
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename?: 'ContentTag' }
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename?: 'ContentTags' }
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename?: 'Course' }
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename?: 'CourseCategory' }
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename?: 'CourseExam' }
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename?: 'CourseShare' }
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename?: 'CourseStatus' }
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename?: 'CourseTestProgression' }
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename?: 'CourseUnit' }
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename?: 'Discovery' }
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename?: 'FormFolder' }
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename?: 'FormPage' }
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename?: 'GapfillNugget' }
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename?: 'HelpdeskPage' }
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename?: 'HomePage' }
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename?: 'JobBoardPage' }
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename?: 'JobHub' }
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename?: 'JobHubsFolder' }
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename?: 'JobProgress' }
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename?: 'JobShare' }
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename?: 'JobTraining' }
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename?: 'JobVacancy' }
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename?: 'LandingPage' }
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename?: 'LearnMenu' }
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename?: 'LegalsFolder' }
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename?: 'ListenCateg' }
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename?: 'LiveEvent' }
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename?: 'LiveEventsPage' }
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename?: 'LiveTVPage' }
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename?: 'MemberDatas' }
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename?: 'MemberDownloaded' }
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename?: 'MemberMessage' }
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename?: 'MemberNotify' }
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename?: 'MemberOpportunity' }
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename?: 'MemberSaved' }
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename?: 'MemberSearch' }
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename?: 'MemberWatched' }
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename?: 'MembersDatas' }
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename?: 'NavMessage' }
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename?: 'News' }
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename?: 'NewsCateg' }
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename?: 'NewsFolder' }
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename?: 'NewsPage' }
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename?: 'ObtainedJob' }
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename?: 'Opportunity' }
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename?: 'OpportunityCenter' }
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename?: 'OpportunityFolder' }
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename?: 'Partner' }
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename?: 'Partners' }
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename?: 'PartnersPage' }
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename?: 'Paywall' }
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename?: 'PaywallFolder' }
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename?: 'PersonalityPages' }
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename?: 'PersonalityType' }
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename?: 'Playlist' }
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename?: 'Podcast' }
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename?: 'PodcastCateg' }
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename?: 'PodcastItem' }
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename?: 'PodcastMenu' }
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename?: 'PromoCode' }
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename?: 'QuizPage' }
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename?: 'QuizzSurvey' }
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename?: 'Radio' }
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename?: 'RadioCateg' }
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename?: 'Region' }
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename?: 'SectionPage' }
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename?: 'Settings' }
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename?: 'Space' }
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename?: 'Subscription' }
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename?: 'SubscriptionData' }
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename?: 'SumaryNugget' }
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename?: 'TextPage' }
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename?: 'ThankYouPage' }
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename?: 'TranslationContext' }
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename?: 'TranslationFolder' }
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename?: 'TranslationItem' }
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename?: 'UmbracoTest' }
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename?: 'UnitProgression' }
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename?: 'VODItem' }
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename?: 'VODMenu' }
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename?: 'VotingFolder' }
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename?: 'VotingRecord' }
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename?: 'WatchCateg' }
    & IMainContentListFragment_WatchCateg_Fragment
  )> }
);

export type IDiscoverySlide1FragmentFragment = (
  { __typename: 'DiscoverySlide1' }
  & Pick<IDiscoverySlide1, 'id' | 'button_label' | 'shortDescription' | 'title'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, slideContent?: Maybe<(
    { __typename?: 'ArtistService' }
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename?: 'AwardsArtist' }
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename?: 'AwardsHomepage' }
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename?: 'CMSPage' }
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename?: 'CategBgColor' }
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename?: 'CategoryPage' }
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename?: 'Channel' }
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename?: 'ChannelFolder' }
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename?: 'ChoiceNugget' }
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename?: 'Collection' }
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename?: 'ContentTag' }
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename?: 'ContentTags' }
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename?: 'Course' }
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename?: 'CourseCategory' }
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename?: 'CourseExam' }
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename?: 'CourseShare' }
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename?: 'CourseStatus' }
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename?: 'CourseTestProgression' }
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename?: 'CourseUnit' }
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename?: 'Discovery' }
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename?: 'FormFolder' }
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename?: 'FormPage' }
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename?: 'GapfillNugget' }
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename?: 'HelpdeskPage' }
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename?: 'HomePage' }
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename?: 'JobBoardPage' }
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename?: 'JobHub' }
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename?: 'JobHubsFolder' }
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename?: 'JobProgress' }
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename?: 'JobShare' }
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename?: 'JobTraining' }
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename?: 'JobVacancy' }
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename?: 'LandingPage' }
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename?: 'LearnMenu' }
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename?: 'LegalsFolder' }
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename?: 'ListenCateg' }
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename?: 'LiveEvent' }
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename?: 'LiveEventsPage' }
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename?: 'LiveTVPage' }
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename?: 'MemberDatas' }
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename?: 'MemberDownloaded' }
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename?: 'MemberMessage' }
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename?: 'MemberNotify' }
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename?: 'MemberOpportunity' }
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename?: 'MemberSaved' }
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename?: 'MemberSearch' }
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename?: 'MemberWatched' }
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename?: 'MembersDatas' }
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename?: 'NavMessage' }
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename?: 'News' }
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename?: 'NewsCateg' }
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename?: 'NewsFolder' }
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename?: 'NewsPage' }
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename?: 'ObtainedJob' }
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename?: 'Opportunity' }
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename?: 'OpportunityCenter' }
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename?: 'OpportunityFolder' }
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename?: 'Partner' }
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename?: 'Partners' }
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename?: 'PartnersPage' }
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename?: 'Paywall' }
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename?: 'PaywallFolder' }
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename?: 'PersonalityPages' }
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename?: 'PersonalityType' }
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename?: 'Playlist' }
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename?: 'Podcast' }
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename?: 'PodcastCateg' }
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename?: 'PodcastItem' }
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename?: 'PodcastMenu' }
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename?: 'PromoCode' }
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename?: 'QuizPage' }
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename?: 'QuizzSurvey' }
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename?: 'Radio' }
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename?: 'RadioCateg' }
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename?: 'Region' }
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename?: 'SectionPage' }
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename?: 'Settings' }
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename?: 'Space' }
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename?: 'Subscription' }
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename?: 'SubscriptionData' }
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename?: 'SumaryNugget' }
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename?: 'TextPage' }
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename?: 'ThankYouPage' }
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename?: 'TranslationContext' }
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename?: 'TranslationFolder' }
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename?: 'TranslationItem' }
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename?: 'UmbracoTest' }
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename?: 'UnitProgression' }
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename?: 'VODItem' }
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename?: 'VODMenu' }
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename?: 'VotingFolder' }
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename?: 'VotingRecord' }
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename?: 'WatchCateg' }
    & IMainContentListFragment_WatchCateg_Fragment
  )> }
);

export type IExpandMenuFragmentFragment = (
  { __typename?: 'ExpandMenu' }
  & Pick<IExpandMenu, 'title'>
  & { links?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | (
      { __typename: 'LinkPicker' }
      & ILinkPickerFragmentFragment
    ) | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IExternalLinkFragmentFragment = (
  { __typename: 'ExternalLink' }
  & Pick<IExternalLink, 'title' | 'externalUrl'>
);

export type IFaqItemFragmentFragment = (
  { __typename: 'FaqItem' }
  & Pick<IFaqItem, 'title' | 'htmlContent' | 'showForm'>
);

export type IHeroVideoCoverFragmentFragment = (
  { __typename: 'HeroVideoCover' }
  & Pick<IHeroVideoCover, 'vimeoVideoId' | 'vimeoHlsUrl' | 'videoCenter'>
  & { image?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & Pick<IMediaWithCrops, 'cropUrl'>
    & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], mobileCover: IMediaWithCrops['cropUrl'], webCover: IMediaWithCrops['cropUrl'] }
  )>, desktopImage?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IInternalLinkFragmentFragment = (
  { __typename: 'InternalLink' }
  & { link?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'sourceUrl' | 'id' | 'url' | 'name'>
    & { liveEventId: IChannel['vimeoEventId'] }
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url' | 'name'>
  )> }
);

export type IKeyFiguresFragmentFragment = (
  { __typename: 'KeyFigures' }
  & { list?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | (
      { __typename: 'KeyFigure' }
      & IKeyFigureFragmentFragment
    ) | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type ILinkIconFragmentFragment = (
  { __typename: 'LinkIcon' }
  & Pick<ILinkIcon, 'icon' | 'title'>
  & { link?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | (
      { __typename?: 'ContentLink' }
      & IContentLinkFragmentFragment
    ) | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | (
      { __typename?: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | (
      { __typename?: 'InternalLink' }
      & IInternalLinkFragmentFragment
    ) | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type ILinkPickerFragmentFragment = (
  { __typename?: 'LinkPicker' }
  & Pick<ILinkPicker, 'title' | 'subtitle'>
  & { link?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | (
      { __typename: 'ContentLink' }
      & IContentLinkFragmentFragment
    ) | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | (
      { __typename: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | (
      { __typename: 'InternalLink' }
      & IInternalLinkFragmentFragment
    ) | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type ILogoSliderFragmentFragment = (
  { __typename: 'LogoSlider' }
  & Pick<ILogoSlider, 'title'>
  & { slides?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | (
      { __typename?: 'LogoLink' }
      & ILogoLinkFragmentFragment
    ) | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type IMultiSliderFragmentFragment = (
  { __typename?: 'MultiSlider' }
  & Pick<IMultiSlider, 'title' | 'description' | 'template'>
  & { sliders?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | (
      { __typename: 'TitleSlider' }
      & ITitleSliderFragmentFragment
    ) | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IMulticategoriesSliderFragmentFragment = (
  { __typename?: 'MulticategoriesSlider' }
  & Pick<IMulticategoriesSlider, 'title' | 'template' | 'showThumbnailTitle' | 'showThumbnailsSubtitle'>
  & { categories?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url' | 'name'>
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & { url: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
    )> }
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url' | 'name'>
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & { url: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
    )> }
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'backgroundColor' | 'url' | 'name'>
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & { url: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
    )> }
  )>>> }
);

export type IPagecontentSliderFragmentFragment = (
  { __typename: 'PagecontentSlider' }
  & Pick<IPagecontentSlider, 'isLink' | 'template' | 'title' | 'showThumbnailTitle' | 'showThumbnailsSubtitle'>
  & { page?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name' | 'url'>
    & IContentFragment_ArtistService_Fragment
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
    & IContentFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
    & IContentFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
    & IContentFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
    & IContentFragment_AwardsArtist_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
    & IContentFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
    & IContentFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
    & IContentFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
    & IContentFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
    & IContentFragment_AwardsHomepage_Fragment
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name' | 'url'>
    & IContentFragment_CmsPage_Fragment
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name' | 'url'>
    & IContentFragment_CategBgColor_Fragment
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name' | 'url'>
    & IContentFragment_CategoryPage_Fragment
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name' | 'url'>
    & IContentFragment_Channel_Fragment
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name' | 'url'>
    & IContentFragment_ChannelFolder_Fragment
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
    & IContentFragment_ChoiceNugget_Fragment
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name' | 'url'>
    & IContentFragment_Collection_Fragment
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
    & IContentFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name' | 'url'>
    & IContentFragment_ContentTag_Fragment
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name' | 'url'>
    & IContentFragment_ContentTags_Fragment
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
    & IContentFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name' | 'url'>
    & IContentFragment_Course_Fragment
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
    & IContentFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name' | 'url'>
    & IContentFragment_CourseCategory_Fragment
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name' | 'url'>
    & IContentFragment_CourseExam_Fragment
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name' | 'url'>
    & IContentFragment_CourseShare_Fragment
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name' | 'url'>
    & IContentFragment_CourseStatus_Fragment
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
    & IContentFragment_CourseTestProgression_Fragment
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name' | 'url'>
    & IContentFragment_CourseUnit_Fragment
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name' | 'url'>
    & IContentFragment_Discovery_Fragment
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
    & IContentFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
    & IContentFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name' | 'url'>
    & IContentFragment_FormFolder_Fragment
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name' | 'url'>
    & IContentFragment_FormPage_Fragment
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
    & IContentFragment_GapfillNugget_Fragment
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
    & IContentFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
    & IContentFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
    & IContentFragment_HelpdeskPage_Fragment
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name' | 'url'>
    & IContentFragment_HomePage_Fragment
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
    & IContentFragment_JobBoardPage_Fragment
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name' | 'url'>
    & IContentFragment_JobHub_Fragment
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
    & IContentFragment_JobHubsFolder_Fragment
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name' | 'url'>
    & IContentFragment_JobProgress_Fragment
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name' | 'url'>
    & IContentFragment_JobShare_Fragment
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name' | 'url'>
    & IContentFragment_JobTraining_Fragment
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
    & IContentFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
    & IContentFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name' | 'url'>
    & IContentFragment_JobVacancy_Fragment
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name' | 'url'>
    & IContentFragment_LandingPage_Fragment
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name' | 'url'>
    & IContentFragment_LearnMenu_Fragment
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
    & IContentFragment_LegalsFolder_Fragment
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name' | 'url'>
    & IContentFragment_ListenCateg_Fragment
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name' | 'url'>
    & IContentFragment_LiveEvent_Fragment
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
    & IContentFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
    & IContentFragment_LiveEventsPage_Fragment
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
    & IContentFragment_LiveTvPage_Fragment
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
    & IContentFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name' | 'url'>
    & IContentFragment_MemberDatas_Fragment
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
    & IContentFragment_MemberDownloaded_Fragment
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name' | 'url'>
    & IContentFragment_MemberMessage_Fragment
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name' | 'url'>
    & IContentFragment_MemberNotify_Fragment
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
    & IContentFragment_MemberOpportunity_Fragment
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name' | 'url'>
    & IContentFragment_MemberSaved_Fragment
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name' | 'url'>
    & IContentFragment_MemberSearch_Fragment
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name' | 'url'>
    & IContentFragment_MemberWatched_Fragment
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name' | 'url'>
    & IContentFragment_MembersDatas_Fragment
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
    & IContentFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name' | 'url'>
    & IContentFragment_NavMessage_Fragment
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
    & IContentFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
    & IContentFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name' | 'url'>
    & IContentFragment_News_Fragment
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name' | 'url'>
    & IContentFragment_NewsCateg_Fragment
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name' | 'url'>
    & IContentFragment_NewsFolder_Fragment
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name' | 'url'>
    & IContentFragment_NewsPage_Fragment
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name' | 'url'>
    & IContentFragment_ObtainedJob_Fragment
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name' | 'url'>
    & IContentFragment_Opportunity_Fragment
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
    & IContentFragment_OpportunityCenter_Fragment
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
    & IContentFragment_OpportunityFolder_Fragment
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name' | 'url'>
    & IContentFragment_Partner_Fragment
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name' | 'url'>
    & IContentFragment_Partners_Fragment
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name' | 'url'>
    & IContentFragment_PartnersPage_Fragment
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name' | 'url'>
    & IContentFragment_Paywall_Fragment
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
    & IContentFragment_PaywallFolder_Fragment
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
    & IContentFragment_PersonalityPages_Fragment
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
    & IContentFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
    & IContentFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name' | 'url'>
    & IContentFragment_PersonalityType_Fragment
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name' | 'url'>
    & IContentFragment_Playlist_Fragment
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
    & IContentFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name' | 'url'>
    & IContentFragment_Podcast_Fragment
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
    & IContentFragment_PodcastCateg_Fragment
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name' | 'url'>
    & IContentFragment_PodcastItem_Fragment
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
    & IContentFragment_PodcastMenu_Fragment
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name' | 'url'>
    & IContentFragment_PromoCode_Fragment
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
    & IContentFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name' | 'url'>
    & IContentFragment_QuizPage_Fragment
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
    & IContentFragment_QuizzSurvey_Fragment
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
    & IContentFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
    & IContentFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name' | 'url'>
    & IContentFragment_Radio_Fragment
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name' | 'url'>
    & IContentFragment_RadioCateg_Fragment
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name' | 'url'>
    & IContentFragment_Region_Fragment
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name' | 'url'>
    & IContentFragment_SectionPage_Fragment
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name' | 'url'>
    & IContentFragment_Settings_Fragment
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name' | 'url'>
    & IContentFragment_Space_Fragment
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name' | 'url'>
    & IContentFragment_Subscription_Fragment
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
    & IContentFragment_SubscriptionData_Fragment
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
    & IContentFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
    & IContentFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
    & IContentFragment_SumaryNugget_Fragment
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
    & IContentFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name' | 'url'>
    & IContentFragment_TextPage_Fragment
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name' | 'url'>
    & IContentFragment_ThankYouPage_Fragment
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name' | 'url'>
    & IContentFragment_TranslationContext_Fragment
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
    & IContentFragment_TranslationFolder_Fragment
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name' | 'url'>
    & IContentFragment_TranslationItem_Fragment
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
    & IContentFragment_UmbracoTest_Fragment
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
    & IContentFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
    & IContentFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name' | 'url'>
    & IContentFragment_UnitProgression_Fragment
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name' | 'url'>
    & IContentFragment_VodItem_Fragment
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name' | 'url'>
    & IContentFragment_VodMenu_Fragment
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name' | 'url'>
    & IContentFragment_VotingFolder_Fragment
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name' | 'url'>
    & IContentFragment_VotingRecord_Fragment
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name' | 'url'>
    & IContentFragment_WatchCateg_Fragment
  )> }
);

export type IPartnerSliderFragmentFragment = (
  { __typename: 'PartnerSlider' }
  & Pick<IPartnerSlider, 'title'>
  & { partnerLink?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
  ) | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>, slider?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
    { __typename: 'Partner' }
    & IPartnerFragmentFragment
  ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type IPushFragmentFragment = (
  { __typename: 'Push' }
  & Pick<IPush, 'topTitle' | 'title' | 'description' | 'style' | 'isPremium'>
  & { icon?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, background?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, backgroundDesktop?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, link?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename: 'Accordions' }
      & Pick<IAccordions, 'contentTypeAlias'>
    ) | (
      { __typename: 'Advantage' }
      & Pick<IAdvantage, 'contentTypeAlias'>
    ) | (
      { __typename: 'AdvantagesList' }
      & Pick<IAdvantagesList, 'contentTypeAlias'>
    ) | (
      { __typename: 'Article' }
      & Pick<IArticle, 'contentTypeAlias'>
    ) | (
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'contentTypeAlias'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'Author' }
      & Pick<IAuthor, 'contentTypeAlias'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'contentTypeAlias'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'contentTypeAlias'>
    ) | (
      { __typename: 'Button' }
      & Pick<IButton, 'contentTypeAlias'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'CTASlide' }
      & Pick<ICtaSlide, 'contentTypeAlias'>
    ) | (
      { __typename: 'CTASlider' }
      & Pick<ICtaSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'Card' }
      & Pick<ICard, 'contentTypeAlias'>
    ) | (
      { __typename: 'CardIcon' }
      & Pick<ICardIcon, 'contentTypeAlias'>
    ) | (
      { __typename: 'CardLink' }
      & Pick<ICardLink, 'contentTypeAlias'>
    ) | (
      { __typename: 'CardList' }
      & Pick<ICardList, 'contentTypeAlias'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'contentTypeAlias'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'CategorySlider' }
      & Pick<ICategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'CategorySliderHighlight' }
      & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'contentTypeAlias'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'ChoiceNuggerAnswer' }
      & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'contentTypeAlias'>
    ) | (
      { __typename: 'ChoiceNuggetAnswerGroup' }
      & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
    ) | (
      { __typename: 'ChoiceNuggetQuestion' }
      & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'contentTypeAlias'>
    ) | (
      { __typename: 'ColorTag' }
      & Pick<IColorTag, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentAudioFileCmp' }
      & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentAudioVimeoCmp' }
      & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentCategCmp' }
      & Pick<IContentCategCmp, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentEPGProgramFileCmp' }
      & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentLink' }
      & Pick<IContentLink, 'contentTypeAlias'>
      & IContentLinkFragmentFragment
    ) | (
      { __typename: 'ContentSlider' }
      & Pick<IContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentSliderHighlight' }
      & Pick<IContentSliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'contentTypeAlias'>
    ) | (
      { __typename: 'ContextualContentSlider' }
      & Pick<IContextualContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseCategorySlider' }
      & Pick<ICourseCategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseItemsSlider' }
      & Pick<ICourseItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseNugget' }
      & Pick<ICourseNugget, 'contentTypeAlias'>
    ) | (
      { __typename: 'CoursePage' }
      & Pick<ICoursePage, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'contentTypeAlias'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'contentTypeAlias'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'contentTypeAlias'>
    ) | (
      { __typename: 'DiscoverySlide' }
      & Pick<IDiscoverySlide, 'contentTypeAlias'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'contentTypeAlias'>
    ) | (
      { __typename: 'EditoSlider' }
      & Pick<IEditoSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
    ) | (
      { __typename: 'ExpandMenu' }
      & Pick<IExpandMenu, 'contentTypeAlias'>
    ) | (
      { __typename: 'ExternalLink' }
      & Pick<IExternalLink, 'contentTypeAlias'>
      & IExternalLinkFragmentFragment
    ) | (
      { __typename: 'FaqItem' }
      & Pick<IFaqItem, 'contentTypeAlias'>
    ) | (
      { __typename: 'FaqPageLink' }
      & Pick<IFaqPageLink, 'contentTypeAlias'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'Gallery' }
      & Pick<IGallery, 'contentTypeAlias'>
    ) | (
      { __typename: 'GapFillNuggetAnswer' }
      & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename: 'GapFillNuggetImageAnswer' }
      & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'contentTypeAlias'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'contentTypeAlias'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'HeroBanner' }
      & Pick<IHeroBanner, 'contentTypeAlias'>
    ) | (
      { __typename: 'HeroBanner1' }
      & Pick<IHeroBanner1, 'contentTypeAlias'>
    ) | (
      { __typename: 'HeroServices' }
      & Pick<IHeroServices, 'contentTypeAlias'>
    ) | (
      { __typename: 'HeroSlide' }
      & Pick<IHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename: 'HeroVideoCover' }
      & Pick<IHeroVideoCover, 'contentTypeAlias'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'contentTypeAlias'>
    ) | (
      { __typename: 'IconSlide' }
      & Pick<IIconSlide, 'contentTypeAlias'>
    ) | (
      { __typename: 'InternalLink' }
      & Pick<IInternalLink, 'contentTypeAlias'>
      & IInternalLinkFragmentFragment
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'contentTypeAlias'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'contentTypeAlias'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'contentTypeAlias'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'contentTypeAlias'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'contentTypeAlias'>
    ) | (
      { __typename: 'KeyFigure' }
      & Pick<IKeyFigure, 'contentTypeAlias'>
    ) | (
      { __typename: 'KeyFigures' }
      & Pick<IKeyFigures, 'contentTypeAlias'>
    ) | (
      { __typename: 'LandingAbout' }
      & Pick<ILandingAbout, 'contentTypeAlias'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'LearnHeroSlide' }
      & Pick<ILearnHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'contentTypeAlias'>
    ) | (
      { __typename: 'LegalPageLink' }
      & Pick<ILegalPageLink, 'contentTypeAlias'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'LinkIcon' }
      & Pick<ILinkIcon, 'contentTypeAlias'>
    ) | (
      { __typename: 'LinkPicker' }
      & Pick<ILinkPicker, 'contentTypeAlias'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'contentTypeAlias'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'contentTypeAlias'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'contentTypeAlias'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'LogoLink' }
      & Pick<ILogoLink, 'contentTypeAlias'>
    ) | (
      { __typename: 'LogoSlider' }
      & Pick<ILogoSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'contentTypeAlias'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'contentTypeAlias'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'contentTypeAlias'>
    ) | (
      { __typename: 'MenuColumn' }
      & Pick<IMenuColumn, 'contentTypeAlias'>
    ) | (
      { __typename: 'MetadatasLanguages' }
      & Pick<IMetadatasLanguages, 'contentTypeAlias'>
    ) | (
      { __typename: 'MetadatasVODLanguage' }
      & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
    ) | (
      { __typename: 'MetasExclusives' }
      & Pick<IMetasExclusives, 'contentTypeAlias'>
    ) | (
      { __typename: 'MetasPublicationDate' }
      & Pick<IMetasPublicationDate, 'contentTypeAlias'>
    ) | (
      { __typename: 'MetasTrailerCmp' }
      & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'MultiSlider' }
      & Pick<IMultiSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'MulticategoriesSlider' }
      & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'contentTypeAlias'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'contentTypeAlias'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'contentTypeAlias'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'contentTypeAlias'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'NuggetsTextAnswerOption' }
      & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'contentTypeAlias'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'contentTypeAlias'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'PageSEO' }
      & Pick<IPageSeo, 'contentTypeAlias'>
    ) | (
      { __typename: 'PagecontentSlider' }
      & Pick<IPagecontentSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'contentTypeAlias'>
    ) | (
      { __typename: 'PartnerSlider' }
      & Pick<IPartnerSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'contentTypeAlias'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'contentTypeAlias'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'contentTypeAlias'>
    ) | (
      { __typename: 'PersonalityPush' }
      & Pick<IPersonalityPush, 'contentTypeAlias'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'contentTypeAlias'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
    ) | (
      { __typename: 'PersonalityQuizQuestion' }
      & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'contentTypeAlias'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'contentTypeAlias'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'contentTypeAlias'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'contentTypeAlias'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'contentTypeAlias'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'contentTypeAlias'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'contentTypeAlias'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'Push' }
      & Pick<IPush, 'contentTypeAlias'>
    ) | (
      { __typename: 'QuizItemsSlider' }
      & Pick<IQuizItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'contentTypeAlias'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'contentTypeAlias'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'contentTypeAlias'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'contentTypeAlias'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'Service' }
      & Pick<IService, 'contentTypeAlias'>
    ) | (
      { __typename: 'ServicesList' }
      & Pick<IServicesList, 'contentTypeAlias'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'contentTypeAlias'>
    ) | (
      { __typename: 'SettingsAccessRestrictionCmp' }
      & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
    ) | (
      { __typename: 'SettingsAccessRestrictionCmp1' }
      & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
    ) | (
      { __typename: 'SettingsAccessRestrictionCmp2' }
      & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
    ) | (
      { __typename: 'SettingsDateCmp' }
      & Pick<ISettingsDateCmp, 'contentTypeAlias'>
    ) | (
      { __typename: 'SettingsExternalId' }
      & Pick<ISettingsExternalId, 'contentTypeAlias'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'contentTypeAlias'>
    ) | (
      { __typename: 'StaticPageLink' }
      & Pick<IStaticPageLink, 'contentTypeAlias'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'contentTypeAlias'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'contentTypeAlias'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'SubscriptionsList' }
      & Pick<ISubscriptionsList, 'contentTypeAlias'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'contentTypeAlias'>
    ) | (
      { __typename: 'SummaryNuggetStatement' }
      & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'TextSlide1' }
      & Pick<ITextSlide1, 'contentTypeAlias'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'contentTypeAlias'>
    ) | (
      { __typename: 'TitleSlider' }
      & Pick<ITitleSlider, 'contentTypeAlias'>
    ) | (
      { __typename: 'Top10Song' }
      & Pick<ITop10Song, 'contentTypeAlias'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'contentTypeAlias'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'contentTypeAlias'>
    ) | (
      { __typename: 'TutorialSlide' }
      & Pick<ITutorialSlide, 'contentTypeAlias'>
    ) | (
      { __typename: 'UcAudio' }
      & Pick<IUcAudio, 'contentTypeAlias'>
    ) | (
      { __typename: 'UcImage' }
      & Pick<IUcImage, 'contentTypeAlias'>
    ) | (
      { __typename: 'UcLineBreak' }
      & Pick<IUcLineBreak, 'contentTypeAlias'>
    ) | (
      { __typename: 'UcText' }
      & Pick<IUcText, 'contentTypeAlias'>
    ) | (
      { __typename: 'UcVideo' }
      & Pick<IUcVideo, 'contentTypeAlias'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'contentTypeAlias'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswerItem' }
      & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'contentTypeAlias'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'contentTypeAlias'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'contentTypeAlias'>
    ) | (
      { __typename: 'ValidationElement' }
      & Pick<IValidationElement, 'contentTypeAlias'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'contentTypeAlias'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'contentTypeAlias'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'contentTypeAlias'>
    ) | (
      { __typename: 'WatchedContent' }
      & Pick<IWatchedContent, 'contentTypeAlias'>
    ) | (
      { __typename: 'Wysiwyg' }
      & Pick<IWysiwyg, 'contentTypeAlias'>
    ) }
  )>>> }
);

export type IServiceFragmentFragment = (
  { __typename: 'Service' }
  & Pick<IService, 'text'>
  & { icon?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )> }
);

export type IServicesListFragmentFragment = (
  { __typename: 'ServicesList' }
  & Pick<IServicesList, 'title'>
  & { services?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | (
      { __typename: 'Service' }
      & IServiceFragmentFragment
    ) | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type ISubscriptionsListFragmentFragment = (
  { __typename: 'SubscriptionsList' }
  & { subscriptionsList?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | (
    { __typename?: 'Subscription' }
    & ISubscriptionFragmentFragment
  ) | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
);

export type ITextPageFragmentFragment = (
  { __typename: 'TextPage' }
  & Pick<ITextPage, 'url' | 'title' | 'body' | 'id' | 'name'>
);

export type ITextSlide1FragmentFragment = (
  { __typename?: 'TextSlide1' }
  & Pick<ITextSlide1, 'title' | 'description' | 'overtitle'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, linkTo?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | (
      { __typename?: 'ContentLink' }
      & IContentLinkFragmentFragment
    ) | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | (
      { __typename?: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | (
      { __typename?: 'InternalLink' }
      & IInternalLinkFragmentFragment
    ) | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type ITitleSliderFragmentFragment = (
  { __typename: 'TitleSlider' }
  & Pick<ITitleSlider, 'title' | 'subtitle'>
  & { slides?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | (
      { __typename: 'CTASlide' }
      & ICtaSlideFragmentFragment
    ) | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | (
      { __typename: 'IconSlide' }
      & IIconSlideFragmentFragment
    ) | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | (
      { __typename: 'TextSlide1' }
      & ITextSlide1FragmentFragment
    ) | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IValidationElementFragmentFragment = (
  { __typename: 'ValidationElement' }
  & Pick<IValidationElement, 'label' | 'regex'>
);

export type IWysiwygFragmentFragment = (
  { __typename?: 'Wysiwyg' }
  & Pick<IWysiwyg, 'title' | 'body'>
);

export type IHeroSlideFragmentFragment = (
  { __typename: 'HeroSlide' }
  & Pick<IHeroSlide, 'highlights' | 'title'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, button?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | (
      { __typename?: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type IArtistServiceFragmentFragment = (
  { __typename: 'ArtistService' }
  & Pick<IArtistService, 'id' | 'title' | 'subtitle' | 'url'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & Pick<IAccordions, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Advantage' }
      & Pick<IAdvantage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AdvantagesList' }
      & Pick<IAdvantagesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Article' }
      & Pick<IArticle, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistService' }
      & Pick<IArtistService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Author' }
      & Pick<IAuthor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Button' }
      & Pick<IButton, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CMSPage' }
      & Pick<ICmsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlide' }
      & Pick<ICtaSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlider' }
      & Pick<ICtaSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Card' }
      & Pick<ICard, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardIcon' }
      & Pick<ICardIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardLink' }
      & Pick<ICardLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardList' }
      & Pick<ICardList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategBgColor' }
      & Pick<ICategBgColor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategoryPage' }
      & Pick<ICategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySlider' }
      & Pick<ICategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Channel' }
      & Pick<IChannel, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChannelFolder' }
      & Pick<IChannelFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Collection' }
      & Pick<ICollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ColorTag' }
      & Pick<IColorTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentCategCmp' }
      & Pick<IContentCategCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentLink' }
      & Pick<IContentLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSlider' }
      & Pick<IContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & Pick<IContentSliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTag' }
      & Pick<IContentTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTags' }
      & Pick<IContentTags, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & Pick<IContextualContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Course' }
      & Pick<ICourse, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategory' }
      & Pick<ICourseCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & Pick<ICourseCategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseExam' }
      & Pick<ICourseExam, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & Pick<ICourseItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseNugget' }
      & Pick<ICourseNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CoursePage' }
      & Pick<ICoursePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseShare' }
      & Pick<ICourseShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseStatus' }
      & Pick<ICourseStatus, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseUnit' }
      & Pick<ICourseUnit, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Discovery' }
      & Pick<IDiscovery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide' }
      & Pick<IDiscoverySlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EditoSlider' }
      & Pick<IEditoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExpandMenu' }
      & Pick<IExpandMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExternalLink' }
      & Pick<IExternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqItem' }
      & Pick<IFaqItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqPageLink' }
      & Pick<IFaqPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormFolder' }
      & Pick<IFormFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormPage' }
      & Pick<IFormPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Gallery' }
      & Pick<IGallery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner' }
      & Pick<IHeroBanner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner1' }
      & Pick<IHeroBanner1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroServices' }
      & Pick<IHeroServices, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroSlide' }
      & Pick<IHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroVideoCover' }
      & Pick<IHeroVideoCover, 'contentTypeAlias'>
      & IHeroVideoCoverFragmentFragment
    ) | (
      { __typename?: 'HomePage' }
      & Pick<IHomePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'IconSlide' }
      & Pick<IIconSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'InternalLink' }
      & Pick<IInternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHub' }
      & Pick<IJobHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobProgress' }
      & Pick<IJobProgress, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobShare' }
      & Pick<IJobShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacancy' }
      & Pick<IJobVacancy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigure' }
      & Pick<IKeyFigure, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigures' }
      & Pick<IKeyFigures, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingAbout' }
      & Pick<ILandingAbout, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingPage' }
      & Pick<ILandingPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & Pick<ILearnHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnMenu' }
      & Pick<ILearnMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalPageLink' }
      & Pick<ILegalPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkIcon' }
      & Pick<ILinkIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkPicker' }
      & Pick<ILinkPicker, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ListenCateg' }
      & Pick<IListenCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEvent' }
      & Pick<ILiveEvent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoLink' }
      & Pick<ILogoLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoSlider' }
      & Pick<ILogoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDatas' }
      & Pick<IMemberDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberMessage' }
      & Pick<IMemberMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberNotify' }
      & Pick<IMemberNotify, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSaved' }
      & Pick<IMemberSaved, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSearch' }
      & Pick<IMemberSearch, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberWatched' }
      & Pick<IMemberWatched, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MembersDatas' }
      & Pick<IMembersDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MenuColumn' }
      & Pick<IMenuColumn, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & Pick<IMetadatasLanguages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasExclusives' }
      & Pick<IMetasExclusives, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & Pick<IMetasPublicationDate, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MultiSlider' }
      & Pick<IMultiSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavMessage' }
      & Pick<INavMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'News' }
      & Pick<INews, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsCateg' }
      & Pick<INewsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsFolder' }
      & Pick<INewsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsPage' }
      & Pick<INewsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ObtainedJob' }
      & Pick<IObtainedJob, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Opportunity' }
      & Pick<IOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PageSEO' }
      & Pick<IPageSeo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PagecontentSlider' }
      & Pick<IPagecontentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partner' }
      & Pick<IPartner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnerSlider' }
      & Pick<IPartnerSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partners' }
      & Pick<IPartners, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnersPage' }
      & Pick<IPartnersPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Paywall' }
      & Pick<IPaywall, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPush' }
      & Pick<IPersonalityPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityType' }
      & Pick<IPersonalityType, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Playlist' }
      & Pick<IPlaylist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Podcast' }
      & Pick<IPodcast, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastItem' }
      & Pick<IPodcastItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCode' }
      & Pick<IPromoCode, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Push' }
      & Pick<IPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & Pick<IQuizItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizPage' }
      & Pick<IQuizPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Radio' }
      & Pick<IRadio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'RadioCateg' }
      & Pick<IRadioCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Region' }
      & Pick<IRegion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SectionPage' }
      & Pick<ISectionPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Service' }
      & Pick<IService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ServicesList' }
      & Pick<IServicesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Settings' }
      & Pick<ISettings, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & Pick<ISettingsDateCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsExternalId' }
      & Pick<ISettingsExternalId, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Space' }
      & Pick<ISpace, 'contentTypeAlias'>
    ) | (
      { __typename?: 'StaticPageLink' }
      & Pick<IStaticPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Subscription' }
      & Pick<ISubscription, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsList' }
      & Pick<ISubscriptionsList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextPage' }
      & Pick<ITextPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextSlide1' }
      & Pick<ITextSlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ThankYouPage' }
      & Pick<IThankYouPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TitleSlider' }
      & Pick<ITitleSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Top10Song' }
      & Pick<ITop10Song, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationContext' }
      & Pick<ITranslationContext, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationItem' }
      & Pick<ITranslationItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TutorialSlide' }
      & Pick<ITutorialSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcAudio' }
      & Pick<IUcAudio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcImage' }
      & Pick<IUcImage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcLineBreak' }
      & Pick<IUcLineBreak, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcText' }
      & Pick<IUcText, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcVideo' }
      & Pick<IUcVideo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitProgression' }
      & Pick<IUnitProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODItem' }
      & Pick<IVodItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODMenu' }
      & Pick<IVodMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ValidationElement' }
      & Pick<IValidationElement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingFolder' }
      & Pick<IVotingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingRecord' }
      & Pick<IVotingRecord, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchCateg' }
      & Pick<IWatchCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchedContent' }
      & Pick<IWatchedContent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Wysiwyg' }
      & Pick<IWysiwyg, 'contentTypeAlias'>
    ) }
  )>>>, button?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | (
      { __typename: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | (
      { __typename: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, pageBlocks?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & IElementFragment_Accordions_Fragment
    ) | (
      { __typename?: 'Advantage' }
      & IElementFragment_Advantage_Fragment
    ) | (
      { __typename?: 'AdvantagesList' }
      & IElementFragment_AdvantagesList_Fragment
    ) | (
      { __typename?: 'Article' }
      & IElementFragment_Article_Fragment
    ) | (
      { __typename?: 'ArtistService' }
      & IElementFragment_ArtistService_Fragment
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & IElementFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & IElementFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename?: 'Author' }
      & IElementFragment_Author_Fragment
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & IElementFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename?: 'AwardsArtist' }
      & IElementFragment_AwardsArtist_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & IElementFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & IElementFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & IElementFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & IElementFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename?: 'AwardsHomepage' }
      & IElementFragment_AwardsHomepage_Fragment
    ) | (
      { __typename?: 'Button' }
      & IElementFragment_Button_Fragment
    ) | (
      { __typename?: 'CMSPage' }
      & IElementFragment_CmsPage_Fragment
    ) | (
      { __typename?: 'CTASlide' }
      & IElementFragment_CtaSlide_Fragment
    ) | (
      { __typename?: 'CTASlider' }
      & IElementFragment_CtaSlider_Fragment
    ) | (
      { __typename?: 'Card' }
      & IElementFragment_Card_Fragment
    ) | (
      { __typename?: 'CardIcon' }
      & IElementFragment_CardIcon_Fragment
    ) | (
      { __typename?: 'CardLink' }
      & IElementFragment_CardLink_Fragment
    ) | (
      { __typename?: 'CardList' }
      & IElementFragment_CardList_Fragment
    ) | (
      { __typename?: 'CategBgColor' }
      & IElementFragment_CategBgColor_Fragment
    ) | (
      { __typename?: 'CategoryPage' }
      & IElementFragment_CategoryPage_Fragment
    ) | (
      { __typename?: 'CategorySlider' }
      & IElementFragment_CategorySlider_Fragment
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & IElementFragment_CategorySliderHighlight_Fragment
    ) | (
      { __typename?: 'Channel' }
      & IElementFragment_Channel_Fragment
    ) | (
      { __typename?: 'ChannelFolder' }
      & IElementFragment_ChannelFolder_Fragment
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IElementFragment_ChoiceNuggerAnswer_Fragment
    ) | (
      { __typename?: 'ChoiceNugget' }
      & IElementFragment_ChoiceNugget_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & IElementFragment_ChoiceNuggetAnswerGroup_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & IElementFragment_ChoiceNuggetQuestion_Fragment
    ) | (
      { __typename?: 'Collection' }
      & IElementFragment_Collection_Fragment
    ) | (
      { __typename?: 'ColorTag' }
      & IElementFragment_ColorTag_Fragment
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & IElementFragment_ContentAudioFileCmp_Fragment
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & IElementFragment_ContentAudioVimeoCmp_Fragment
    ) | (
      { __typename?: 'ContentCategCmp' }
      & IElementFragment_ContentCategCmp_Fragment
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & IElementFragment_ContentEpgProgramFileCmp_Fragment
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & IElementFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename?: 'ContentLink' }
      & IElementFragment_ContentLink_Fragment
    ) | (
      { __typename?: 'ContentSlider' }
      & IElementFragment_ContentSlider_Fragment
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & IElementFragment_ContentSliderHighlight_Fragment
    ) | (
      { __typename?: 'ContentTag' }
      & IElementFragment_ContentTag_Fragment
    ) | (
      { __typename?: 'ContentTags' }
      & IElementFragment_ContentTags_Fragment
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & IElementFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & IElementFragment_ContextualContentSlider_Fragment
    ) | (
      { __typename?: 'Course' }
      & IElementFragment_Course_Fragment
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & IElementFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename?: 'CourseCategory' }
      & IElementFragment_CourseCategory_Fragment
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & IElementFragment_CourseCategorySlider_Fragment
    ) | (
      { __typename?: 'CourseExam' }
      & IElementFragment_CourseExam_Fragment
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & IElementFragment_CourseItemsSlider_Fragment
    ) | (
      { __typename?: 'CourseNugget' }
      & IElementFragment_CourseNugget_Fragment
    ) | (
      { __typename?: 'CoursePage' }
      & IElementFragment_CoursePage_Fragment
    ) | (
      { __typename?: 'CourseShare' }
      & IElementFragment_CourseShare_Fragment
    ) | (
      { __typename?: 'CourseStatus' }
      & IElementFragment_CourseStatus_Fragment
    ) | (
      { __typename?: 'CourseTestProgression' }
      & IElementFragment_CourseTestProgression_Fragment
    ) | (
      { __typename?: 'CourseUnit' }
      & IElementFragment_CourseUnit_Fragment
    ) | (
      { __typename?: 'Discovery' }
      & IElementFragment_Discovery_Fragment
    ) | (
      { __typename?: 'DiscoverySlide' }
      & IElementFragment_DiscoverySlide_Fragment
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & IElementFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename?: 'EditoSlider' }
      & IElementFragment_EditoSlider_Fragment
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & IElementFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename?: 'ExpandMenu' }
      & IElementFragment_ExpandMenu_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & IElementFragment_ExternalLink_Fragment
    ) | (
      { __typename?: 'FaqItem' }
      & IElementFragment_FaqItem_Fragment
    ) | (
      { __typename?: 'FaqPageLink' }
      & IElementFragment_FaqPageLink_Fragment
    ) | (
      { __typename?: 'FormFolder' }
      & IElementFragment_FormFolder_Fragment
    ) | (
      { __typename?: 'FormPage' }
      & IElementFragment_FormPage_Fragment
    ) | (
      { __typename?: 'Gallery' }
      & IElementFragment_Gallery_Fragment
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & IElementFragment_GapFillNuggetAnswer_Fragment
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & IElementFragment_GapFillNuggetImageAnswer_Fragment
    ) | (
      { __typename?: 'GapfillNugget' }
      & IElementFragment_GapfillNugget_Fragment
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & IElementFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & IElementFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename?: 'HelpdeskPage' }
      & IElementFragment_HelpdeskPage_Fragment
    ) | (
      { __typename?: 'HeroBanner' }
      & IElementFragment_HeroBanner_Fragment
    ) | (
      { __typename?: 'HeroBanner1' }
      & IElementFragment_HeroBanner1_Fragment
    ) | (
      { __typename?: 'HeroServices' }
      & IElementFragment_HeroServices_Fragment
    ) | (
      { __typename?: 'HeroSlide' }
      & IElementFragment_HeroSlide_Fragment
    ) | (
      { __typename?: 'HeroVideoCover' }
      & IElementFragment_HeroVideoCover_Fragment
    ) | (
      { __typename?: 'HomePage' }
      & IElementFragment_HomePage_Fragment
    ) | (
      { __typename?: 'IconSlide' }
      & IElementFragment_IconSlide_Fragment
    ) | (
      { __typename?: 'InternalLink' }
      & IElementFragment_InternalLink_Fragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & IElementFragment_JobBoardPage_Fragment
    ) | (
      { __typename?: 'JobHub' }
      & IElementFragment_JobHub_Fragment
    ) | (
      { __typename?: 'JobHubsFolder' }
      & IElementFragment_JobHubsFolder_Fragment
    ) | (
      { __typename?: 'JobProgress' }
      & IElementFragment_JobProgress_Fragment
    ) | (
      { __typename?: 'JobShare' }
      & IElementFragment_JobShare_Fragment
    ) | (
      { __typename?: 'JobTraining' }
      & IElementFragment_JobTraining_Fragment
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & IElementFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & IElementFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename?: 'JobVacancy' }
      & IElementFragment_JobVacancy_Fragment
    ) | (
      { __typename?: 'KeyFigure' }
      & IElementFragment_KeyFigure_Fragment
    ) | (
      { __typename?: 'KeyFigures' }
      & IElementFragment_KeyFigures_Fragment
    ) | (
      { __typename?: 'LandingAbout' }
      & IElementFragment_LandingAbout_Fragment
    ) | (
      { __typename?: 'LandingPage' }
      & IElementFragment_LandingPage_Fragment
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & IElementFragment_LearnHeroSlide_Fragment
    ) | (
      { __typename?: 'LearnMenu' }
      & IElementFragment_LearnMenu_Fragment
    ) | (
      { __typename?: 'LegalPageLink' }
      & IElementFragment_LegalPageLink_Fragment
    ) | (
      { __typename?: 'LegalsFolder' }
      & IElementFragment_LegalsFolder_Fragment
    ) | (
      { __typename?: 'LinkIcon' }
      & IElementFragment_LinkIcon_Fragment
    ) | (
      { __typename?: 'LinkPicker' }
      & IElementFragment_LinkPicker_Fragment
    ) | (
      { __typename?: 'ListenCateg' }
      & IElementFragment_ListenCateg_Fragment
    ) | (
      { __typename?: 'LiveEvent' }
      & IElementFragment_LiveEvent_Fragment
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & IElementFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename?: 'LiveEventsPage' }
      & IElementFragment_LiveEventsPage_Fragment
    ) | (
      { __typename?: 'LiveTVPage' }
      & IElementFragment_LiveTvPage_Fragment
    ) | (
      { __typename?: 'LogoLink' }
      & IElementFragment_LogoLink_Fragment
    ) | (
      { __typename?: 'LogoSlider' }
      & IElementFragment_LogoSlider_Fragment
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & IElementFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename?: 'MemberDatas' }
      & IElementFragment_MemberDatas_Fragment
    ) | (
      { __typename?: 'MemberDownloaded' }
      & IElementFragment_MemberDownloaded_Fragment
    ) | (
      { __typename?: 'MemberMessage' }
      & IElementFragment_MemberMessage_Fragment
    ) | (
      { __typename?: 'MemberNotify' }
      & IElementFragment_MemberNotify_Fragment
    ) | (
      { __typename?: 'MemberOpportunity' }
      & IElementFragment_MemberOpportunity_Fragment
    ) | (
      { __typename?: 'MemberSaved' }
      & IElementFragment_MemberSaved_Fragment
    ) | (
      { __typename?: 'MemberSearch' }
      & IElementFragment_MemberSearch_Fragment
    ) | (
      { __typename?: 'MemberWatched' }
      & IElementFragment_MemberWatched_Fragment
    ) | (
      { __typename?: 'MembersDatas' }
      & IElementFragment_MembersDatas_Fragment
    ) | (
      { __typename?: 'MenuColumn' }
      & IElementFragment_MenuColumn_Fragment
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & IElementFragment_MetadatasLanguages_Fragment
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & IElementFragment_MetadatasVodLanguage_Fragment
    ) | (
      { __typename?: 'MetasExclusives' }
      & IElementFragment_MetasExclusives_Fragment
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & IElementFragment_MetasPublicationDate_Fragment
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & IElementFragment_MetasTrailerCmp_Fragment
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & IElementFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename?: 'MultiSlider' }
      & IElementFragment_MultiSlider_Fragment
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & IElementFragment_MulticategoriesSlider_Fragment
    ) | (
      { __typename?: 'NavMessage' }
      & IElementFragment_NavMessage_Fragment
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & IElementFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & IElementFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename?: 'News' }
      & IElementFragment_News_Fragment
    ) | (
      { __typename?: 'NewsCateg' }
      & IElementFragment_NewsCateg_Fragment
    ) | (
      { __typename?: 'NewsFolder' }
      & IElementFragment_NewsFolder_Fragment
    ) | (
      { __typename?: 'NewsPage' }
      & IElementFragment_NewsPage_Fragment
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & IElementFragment_NuggetsTextAnswerOption_Fragment
    ) | (
      { __typename?: 'ObtainedJob' }
      & IElementFragment_ObtainedJob_Fragment
    ) | (
      { __typename?: 'Opportunity' }
      & IElementFragment_Opportunity_Fragment
    ) | (
      { __typename?: 'OpportunityCenter' }
      & IElementFragment_OpportunityCenter_Fragment
    ) | (
      { __typename?: 'OpportunityFolder' }
      & IElementFragment_OpportunityFolder_Fragment
    ) | (
      { __typename?: 'PageSEO' }
      & IElementFragment_PageSeo_Fragment
    ) | (
      { __typename?: 'PagecontentSlider' }
      & IElementFragment_PagecontentSlider_Fragment
    ) | (
      { __typename?: 'Partner' }
      & IElementFragment_Partner_Fragment
    ) | (
      { __typename?: 'PartnerSlider' }
      & IElementFragment_PartnerSlider_Fragment
    ) | (
      { __typename?: 'Partners' }
      & IElementFragment_Partners_Fragment
    ) | (
      { __typename?: 'PartnersPage' }
      & IElementFragment_PartnersPage_Fragment
    ) | (
      { __typename?: 'Paywall' }
      & IElementFragment_Paywall_Fragment
    ) | (
      { __typename?: 'PaywallFolder' }
      & IElementFragment_PaywallFolder_Fragment
    ) | (
      { __typename?: 'PersonalityPages' }
      & IElementFragment_PersonalityPages_Fragment
    ) | (
      { __typename?: 'PersonalityPush' }
      & IElementFragment_PersonalityPush_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & IElementFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & IElementFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & IElementFragment_PersonalityQuizQuestion_Fragment
    ) | (
      { __typename?: 'PersonalityType' }
      & IElementFragment_PersonalityType_Fragment
    ) | (
      { __typename?: 'Playlist' }
      & IElementFragment_Playlist_Fragment
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & IElementFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename?: 'Podcast' }
      & IElementFragment_Podcast_Fragment
    ) | (
      { __typename?: 'PodcastCateg' }
      & IElementFragment_PodcastCateg_Fragment
    ) | (
      { __typename?: 'PodcastItem' }
      & IElementFragment_PodcastItem_Fragment
    ) | (
      { __typename?: 'PodcastMenu' }
      & IElementFragment_PodcastMenu_Fragment
    ) | (
      { __typename?: 'PromoCode' }
      & IElementFragment_PromoCode_Fragment
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & IElementFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename?: 'Push' }
      & IElementFragment_Push_Fragment
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & IElementFragment_QuizItemsSlider_Fragment
    ) | (
      { __typename?: 'QuizPage' }
      & IElementFragment_QuizPage_Fragment
    ) | (
      { __typename?: 'QuizzSurvey' }
      & IElementFragment_QuizzSurvey_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & IElementFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & IElementFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename?: 'Radio' }
      & IElementFragment_Radio_Fragment
    ) | (
      { __typename?: 'RadioCateg' }
      & IElementFragment_RadioCateg_Fragment
    ) | (
      { __typename?: 'Region' }
      & IElementFragment_Region_Fragment
    ) | (
      { __typename?: 'SectionPage' }
      & IElementFragment_SectionPage_Fragment
    ) | (
      { __typename?: 'Service' }
      & IElementFragment_Service_Fragment
    ) | (
      { __typename?: 'ServicesList' }
      & IElementFragment_ServicesList_Fragment
    ) | (
      { __typename?: 'Settings' }
      & IElementFragment_Settings_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & IElementFragment_SettingsAccessRestrictionCmp_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & IElementFragment_SettingsAccessRestrictionCmp1_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & IElementFragment_SettingsAccessRestrictionCmp2_Fragment
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & IElementFragment_SettingsDateCmp_Fragment
    ) | (
      { __typename?: 'SettingsExternalId' }
      & IElementFragment_SettingsExternalId_Fragment
    ) | (
      { __typename?: 'Space' }
      & IElementFragment_Space_Fragment
    ) | (
      { __typename?: 'StaticPageLink' }
      & IElementFragment_StaticPageLink_Fragment
    ) | (
      { __typename?: 'Subscription' }
      & IElementFragment_Subscription_Fragment
    ) | (
      { __typename?: 'SubscriptionData' }
      & IElementFragment_SubscriptionData_Fragment
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & IElementFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & IElementFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsList' }
      & IElementFragment_SubscriptionsList_Fragment
    ) | (
      { __typename?: 'SumaryNugget' }
      & IElementFragment_SumaryNugget_Fragment
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & IElementFragment_SummaryNuggetStatement_Fragment
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & IElementFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename?: 'TextPage' }
      & IElementFragment_TextPage_Fragment
    ) | (
      { __typename?: 'TextSlide1' }
      & IElementFragment_TextSlide1_Fragment
    ) | (
      { __typename?: 'ThankYouPage' }
      & IElementFragment_ThankYouPage_Fragment
    ) | (
      { __typename?: 'TitleSlider' }
      & IElementFragment_TitleSlider_Fragment
    ) | (
      { __typename?: 'Top10Song' }
      & IElementFragment_Top10Song_Fragment
    ) | (
      { __typename?: 'TranslationContext' }
      & IElementFragment_TranslationContext_Fragment
    ) | (
      { __typename?: 'TranslationFolder' }
      & IElementFragment_TranslationFolder_Fragment
    ) | (
      { __typename?: 'TranslationItem' }
      & IElementFragment_TranslationItem_Fragment
    ) | (
      { __typename?: 'TutorialSlide' }
      & IElementFragment_TutorialSlide_Fragment
    ) | (
      { __typename?: 'UcAudio' }
      & IElementFragment_UcAudio_Fragment
    ) | (
      { __typename?: 'UcImage' }
      & IElementFragment_UcImage_Fragment
    ) | (
      { __typename?: 'UcLineBreak' }
      & IElementFragment_UcLineBreak_Fragment
    ) | (
      { __typename?: 'UcText' }
      & IElementFragment_UcText_Fragment
    ) | (
      { __typename?: 'UcVideo' }
      & IElementFragment_UcVideo_Fragment
    ) | (
      { __typename?: 'UmbracoTest' }
      & IElementFragment_UmbracoTest_Fragment
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & IElementFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & IElementFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IElementFragment_UnitNuggetGapFillAnswerItem_Fragment
    ) | (
      { __typename?: 'UnitProgression' }
      & IElementFragment_UnitProgression_Fragment
    ) | (
      { __typename?: 'VODItem' }
      & IElementFragment_VodItem_Fragment
    ) | (
      { __typename?: 'VODMenu' }
      & IElementFragment_VodMenu_Fragment
    ) | (
      { __typename?: 'ValidationElement' }
      & IElementFragment_ValidationElement_Fragment
    ) | (
      { __typename?: 'VotingFolder' }
      & IElementFragment_VotingFolder_Fragment
    ) | (
      { __typename?: 'VotingRecord' }
      & IElementFragment_VotingRecord_Fragment
    ) | (
      { __typename?: 'WatchCateg' }
      & IElementFragment_WatchCateg_Fragment
    ) | (
      { __typename?: 'WatchedContent' }
      & IElementFragment_WatchedContent_Fragment
    ) | (
      { __typename?: 'Wysiwyg' }
      & IElementFragment_Wysiwyg_Fragment
    ) }
  )>>> }
);

export type IArtistServicesPageFragmentFragment = (
  { __typename: 'ArtistServicesPage' }
  & Pick<IArtistServicesPage, 'id' | 'title' | 'subtitle' | 'url'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & Pick<IAccordions, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Advantage' }
      & Pick<IAdvantage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AdvantagesList' }
      & Pick<IAdvantagesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Article' }
      & Pick<IArticle, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistService' }
      & Pick<IArtistService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Author' }
      & Pick<IAuthor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Button' }
      & Pick<IButton, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CMSPage' }
      & Pick<ICmsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlide' }
      & Pick<ICtaSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlider' }
      & Pick<ICtaSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Card' }
      & Pick<ICard, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardIcon' }
      & Pick<ICardIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardLink' }
      & Pick<ICardLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardList' }
      & Pick<ICardList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategBgColor' }
      & Pick<ICategBgColor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategoryPage' }
      & Pick<ICategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySlider' }
      & Pick<ICategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Channel' }
      & Pick<IChannel, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChannelFolder' }
      & Pick<IChannelFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Collection' }
      & Pick<ICollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ColorTag' }
      & Pick<IColorTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentCategCmp' }
      & Pick<IContentCategCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentLink' }
      & Pick<IContentLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSlider' }
      & Pick<IContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & Pick<IContentSliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTag' }
      & Pick<IContentTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTags' }
      & Pick<IContentTags, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & Pick<IContextualContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Course' }
      & Pick<ICourse, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategory' }
      & Pick<ICourseCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & Pick<ICourseCategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseExam' }
      & Pick<ICourseExam, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & Pick<ICourseItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseNugget' }
      & Pick<ICourseNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CoursePage' }
      & Pick<ICoursePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseShare' }
      & Pick<ICourseShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseStatus' }
      & Pick<ICourseStatus, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseUnit' }
      & Pick<ICourseUnit, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Discovery' }
      & Pick<IDiscovery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide' }
      & Pick<IDiscoverySlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EditoSlider' }
      & Pick<IEditoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExpandMenu' }
      & Pick<IExpandMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExternalLink' }
      & Pick<IExternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqItem' }
      & Pick<IFaqItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqPageLink' }
      & Pick<IFaqPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormFolder' }
      & Pick<IFormFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormPage' }
      & Pick<IFormPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Gallery' }
      & Pick<IGallery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner' }
      & Pick<IHeroBanner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner1' }
      & Pick<IHeroBanner1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroServices' }
      & Pick<IHeroServices, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroSlide' }
      & Pick<IHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroVideoCover' }
      & Pick<IHeroVideoCover, 'contentTypeAlias'>
      & IHeroVideoCoverFragmentFragment
    ) | (
      { __typename?: 'HomePage' }
      & Pick<IHomePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'IconSlide' }
      & Pick<IIconSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'InternalLink' }
      & Pick<IInternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHub' }
      & Pick<IJobHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobProgress' }
      & Pick<IJobProgress, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobShare' }
      & Pick<IJobShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacancy' }
      & Pick<IJobVacancy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigure' }
      & Pick<IKeyFigure, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigures' }
      & Pick<IKeyFigures, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingAbout' }
      & Pick<ILandingAbout, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingPage' }
      & Pick<ILandingPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & Pick<ILearnHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnMenu' }
      & Pick<ILearnMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalPageLink' }
      & Pick<ILegalPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkIcon' }
      & Pick<ILinkIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkPicker' }
      & Pick<ILinkPicker, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ListenCateg' }
      & Pick<IListenCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEvent' }
      & Pick<ILiveEvent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoLink' }
      & Pick<ILogoLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoSlider' }
      & Pick<ILogoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDatas' }
      & Pick<IMemberDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberMessage' }
      & Pick<IMemberMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberNotify' }
      & Pick<IMemberNotify, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSaved' }
      & Pick<IMemberSaved, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSearch' }
      & Pick<IMemberSearch, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberWatched' }
      & Pick<IMemberWatched, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MembersDatas' }
      & Pick<IMembersDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MenuColumn' }
      & Pick<IMenuColumn, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & Pick<IMetadatasLanguages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasExclusives' }
      & Pick<IMetasExclusives, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & Pick<IMetasPublicationDate, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MultiSlider' }
      & Pick<IMultiSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavMessage' }
      & Pick<INavMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'News' }
      & Pick<INews, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsCateg' }
      & Pick<INewsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsFolder' }
      & Pick<INewsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsPage' }
      & Pick<INewsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ObtainedJob' }
      & Pick<IObtainedJob, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Opportunity' }
      & Pick<IOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PageSEO' }
      & Pick<IPageSeo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PagecontentSlider' }
      & Pick<IPagecontentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partner' }
      & Pick<IPartner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnerSlider' }
      & Pick<IPartnerSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partners' }
      & Pick<IPartners, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnersPage' }
      & Pick<IPartnersPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Paywall' }
      & Pick<IPaywall, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPush' }
      & Pick<IPersonalityPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityType' }
      & Pick<IPersonalityType, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Playlist' }
      & Pick<IPlaylist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Podcast' }
      & Pick<IPodcast, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastItem' }
      & Pick<IPodcastItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCode' }
      & Pick<IPromoCode, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Push' }
      & Pick<IPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & Pick<IQuizItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizPage' }
      & Pick<IQuizPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Radio' }
      & Pick<IRadio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'RadioCateg' }
      & Pick<IRadioCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Region' }
      & Pick<IRegion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SectionPage' }
      & Pick<ISectionPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Service' }
      & Pick<IService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ServicesList' }
      & Pick<IServicesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Settings' }
      & Pick<ISettings, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & Pick<ISettingsDateCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsExternalId' }
      & Pick<ISettingsExternalId, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Space' }
      & Pick<ISpace, 'contentTypeAlias'>
    ) | (
      { __typename?: 'StaticPageLink' }
      & Pick<IStaticPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Subscription' }
      & Pick<ISubscription, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsList' }
      & Pick<ISubscriptionsList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextPage' }
      & Pick<ITextPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextSlide1' }
      & Pick<ITextSlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ThankYouPage' }
      & Pick<IThankYouPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TitleSlider' }
      & Pick<ITitleSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Top10Song' }
      & Pick<ITop10Song, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationContext' }
      & Pick<ITranslationContext, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationItem' }
      & Pick<ITranslationItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TutorialSlide' }
      & Pick<ITutorialSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcAudio' }
      & Pick<IUcAudio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcImage' }
      & Pick<IUcImage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcLineBreak' }
      & Pick<IUcLineBreak, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcText' }
      & Pick<IUcText, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcVideo' }
      & Pick<IUcVideo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitProgression' }
      & Pick<IUnitProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODItem' }
      & Pick<IVodItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODMenu' }
      & Pick<IVodMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ValidationElement' }
      & Pick<IValidationElement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingFolder' }
      & Pick<IVotingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingRecord' }
      & Pick<IVotingRecord, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchCateg' }
      & Pick<IWatchCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchedContent' }
      & Pick<IWatchedContent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Wysiwyg' }
      & Pick<IWysiwyg, 'contentTypeAlias'>
    ) }
  )>>>, button?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | (
      { __typename: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | (
      { __typename: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, children: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id' | 'title' | 'url'>
    ) | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id' | 'url'>
    ) | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ), services?: Maybe<Array<Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'title' | 'url'>
  ) | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, pageBlocks?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & IElementFragment_Accordions_Fragment
    ) | (
      { __typename?: 'Advantage' }
      & IElementFragment_Advantage_Fragment
    ) | (
      { __typename?: 'AdvantagesList' }
      & IElementFragment_AdvantagesList_Fragment
    ) | (
      { __typename?: 'Article' }
      & IElementFragment_Article_Fragment
    ) | (
      { __typename?: 'ArtistService' }
      & IElementFragment_ArtistService_Fragment
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & IElementFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & IElementFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename?: 'Author' }
      & IElementFragment_Author_Fragment
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & IElementFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename?: 'AwardsArtist' }
      & IElementFragment_AwardsArtist_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & IElementFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & IElementFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & IElementFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & IElementFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename?: 'AwardsHomepage' }
      & IElementFragment_AwardsHomepage_Fragment
    ) | (
      { __typename?: 'Button' }
      & IElementFragment_Button_Fragment
    ) | (
      { __typename?: 'CMSPage' }
      & IElementFragment_CmsPage_Fragment
    ) | (
      { __typename?: 'CTASlide' }
      & IElementFragment_CtaSlide_Fragment
    ) | (
      { __typename?: 'CTASlider' }
      & IElementFragment_CtaSlider_Fragment
    ) | (
      { __typename?: 'Card' }
      & IElementFragment_Card_Fragment
    ) | (
      { __typename?: 'CardIcon' }
      & IElementFragment_CardIcon_Fragment
    ) | (
      { __typename?: 'CardLink' }
      & IElementFragment_CardLink_Fragment
    ) | (
      { __typename?: 'CardList' }
      & IElementFragment_CardList_Fragment
    ) | (
      { __typename?: 'CategBgColor' }
      & IElementFragment_CategBgColor_Fragment
    ) | (
      { __typename?: 'CategoryPage' }
      & IElementFragment_CategoryPage_Fragment
    ) | (
      { __typename?: 'CategorySlider' }
      & IElementFragment_CategorySlider_Fragment
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & IElementFragment_CategorySliderHighlight_Fragment
    ) | (
      { __typename?: 'Channel' }
      & IElementFragment_Channel_Fragment
    ) | (
      { __typename?: 'ChannelFolder' }
      & IElementFragment_ChannelFolder_Fragment
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IElementFragment_ChoiceNuggerAnswer_Fragment
    ) | (
      { __typename?: 'ChoiceNugget' }
      & IElementFragment_ChoiceNugget_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & IElementFragment_ChoiceNuggetAnswerGroup_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & IElementFragment_ChoiceNuggetQuestion_Fragment
    ) | (
      { __typename?: 'Collection' }
      & IElementFragment_Collection_Fragment
    ) | (
      { __typename?: 'ColorTag' }
      & IElementFragment_ColorTag_Fragment
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & IElementFragment_ContentAudioFileCmp_Fragment
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & IElementFragment_ContentAudioVimeoCmp_Fragment
    ) | (
      { __typename?: 'ContentCategCmp' }
      & IElementFragment_ContentCategCmp_Fragment
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & IElementFragment_ContentEpgProgramFileCmp_Fragment
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & IElementFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename?: 'ContentLink' }
      & IElementFragment_ContentLink_Fragment
    ) | (
      { __typename?: 'ContentSlider' }
      & IElementFragment_ContentSlider_Fragment
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & IElementFragment_ContentSliderHighlight_Fragment
    ) | (
      { __typename?: 'ContentTag' }
      & IElementFragment_ContentTag_Fragment
    ) | (
      { __typename?: 'ContentTags' }
      & IElementFragment_ContentTags_Fragment
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & IElementFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & IElementFragment_ContextualContentSlider_Fragment
    ) | (
      { __typename?: 'Course' }
      & IElementFragment_Course_Fragment
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & IElementFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename?: 'CourseCategory' }
      & IElementFragment_CourseCategory_Fragment
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & IElementFragment_CourseCategorySlider_Fragment
    ) | (
      { __typename?: 'CourseExam' }
      & IElementFragment_CourseExam_Fragment
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & IElementFragment_CourseItemsSlider_Fragment
    ) | (
      { __typename?: 'CourseNugget' }
      & IElementFragment_CourseNugget_Fragment
    ) | (
      { __typename?: 'CoursePage' }
      & IElementFragment_CoursePage_Fragment
    ) | (
      { __typename?: 'CourseShare' }
      & IElementFragment_CourseShare_Fragment
    ) | (
      { __typename?: 'CourseStatus' }
      & IElementFragment_CourseStatus_Fragment
    ) | (
      { __typename?: 'CourseTestProgression' }
      & IElementFragment_CourseTestProgression_Fragment
    ) | (
      { __typename?: 'CourseUnit' }
      & IElementFragment_CourseUnit_Fragment
    ) | (
      { __typename?: 'Discovery' }
      & IElementFragment_Discovery_Fragment
    ) | (
      { __typename?: 'DiscoverySlide' }
      & IElementFragment_DiscoverySlide_Fragment
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & IElementFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename?: 'EditoSlider' }
      & IElementFragment_EditoSlider_Fragment
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & IElementFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename?: 'ExpandMenu' }
      & IElementFragment_ExpandMenu_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & IElementFragment_ExternalLink_Fragment
    ) | (
      { __typename?: 'FaqItem' }
      & IElementFragment_FaqItem_Fragment
    ) | (
      { __typename?: 'FaqPageLink' }
      & IElementFragment_FaqPageLink_Fragment
    ) | (
      { __typename?: 'FormFolder' }
      & IElementFragment_FormFolder_Fragment
    ) | (
      { __typename?: 'FormPage' }
      & IElementFragment_FormPage_Fragment
    ) | (
      { __typename?: 'Gallery' }
      & IElementFragment_Gallery_Fragment
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & IElementFragment_GapFillNuggetAnswer_Fragment
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & IElementFragment_GapFillNuggetImageAnswer_Fragment
    ) | (
      { __typename?: 'GapfillNugget' }
      & IElementFragment_GapfillNugget_Fragment
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & IElementFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & IElementFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename?: 'HelpdeskPage' }
      & IElementFragment_HelpdeskPage_Fragment
    ) | (
      { __typename?: 'HeroBanner' }
      & IElementFragment_HeroBanner_Fragment
    ) | (
      { __typename?: 'HeroBanner1' }
      & IElementFragment_HeroBanner1_Fragment
    ) | (
      { __typename?: 'HeroServices' }
      & IElementFragment_HeroServices_Fragment
    ) | (
      { __typename?: 'HeroSlide' }
      & IElementFragment_HeroSlide_Fragment
    ) | (
      { __typename?: 'HeroVideoCover' }
      & IElementFragment_HeroVideoCover_Fragment
    ) | (
      { __typename?: 'HomePage' }
      & IElementFragment_HomePage_Fragment
    ) | (
      { __typename?: 'IconSlide' }
      & IElementFragment_IconSlide_Fragment
    ) | (
      { __typename?: 'InternalLink' }
      & IElementFragment_InternalLink_Fragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & IElementFragment_JobBoardPage_Fragment
    ) | (
      { __typename?: 'JobHub' }
      & IElementFragment_JobHub_Fragment
    ) | (
      { __typename?: 'JobHubsFolder' }
      & IElementFragment_JobHubsFolder_Fragment
    ) | (
      { __typename?: 'JobProgress' }
      & IElementFragment_JobProgress_Fragment
    ) | (
      { __typename?: 'JobShare' }
      & IElementFragment_JobShare_Fragment
    ) | (
      { __typename?: 'JobTraining' }
      & IElementFragment_JobTraining_Fragment
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & IElementFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & IElementFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename?: 'JobVacancy' }
      & IElementFragment_JobVacancy_Fragment
    ) | (
      { __typename?: 'KeyFigure' }
      & IElementFragment_KeyFigure_Fragment
    ) | (
      { __typename?: 'KeyFigures' }
      & IElementFragment_KeyFigures_Fragment
    ) | (
      { __typename?: 'LandingAbout' }
      & IElementFragment_LandingAbout_Fragment
    ) | (
      { __typename?: 'LandingPage' }
      & IElementFragment_LandingPage_Fragment
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & IElementFragment_LearnHeroSlide_Fragment
    ) | (
      { __typename?: 'LearnMenu' }
      & IElementFragment_LearnMenu_Fragment
    ) | (
      { __typename?: 'LegalPageLink' }
      & IElementFragment_LegalPageLink_Fragment
    ) | (
      { __typename?: 'LegalsFolder' }
      & IElementFragment_LegalsFolder_Fragment
    ) | (
      { __typename?: 'LinkIcon' }
      & IElementFragment_LinkIcon_Fragment
    ) | (
      { __typename?: 'LinkPicker' }
      & IElementFragment_LinkPicker_Fragment
    ) | (
      { __typename?: 'ListenCateg' }
      & IElementFragment_ListenCateg_Fragment
    ) | (
      { __typename?: 'LiveEvent' }
      & IElementFragment_LiveEvent_Fragment
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & IElementFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename?: 'LiveEventsPage' }
      & IElementFragment_LiveEventsPage_Fragment
    ) | (
      { __typename?: 'LiveTVPage' }
      & IElementFragment_LiveTvPage_Fragment
    ) | (
      { __typename?: 'LogoLink' }
      & IElementFragment_LogoLink_Fragment
    ) | (
      { __typename?: 'LogoSlider' }
      & IElementFragment_LogoSlider_Fragment
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & IElementFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename?: 'MemberDatas' }
      & IElementFragment_MemberDatas_Fragment
    ) | (
      { __typename?: 'MemberDownloaded' }
      & IElementFragment_MemberDownloaded_Fragment
    ) | (
      { __typename?: 'MemberMessage' }
      & IElementFragment_MemberMessage_Fragment
    ) | (
      { __typename?: 'MemberNotify' }
      & IElementFragment_MemberNotify_Fragment
    ) | (
      { __typename?: 'MemberOpportunity' }
      & IElementFragment_MemberOpportunity_Fragment
    ) | (
      { __typename?: 'MemberSaved' }
      & IElementFragment_MemberSaved_Fragment
    ) | (
      { __typename?: 'MemberSearch' }
      & IElementFragment_MemberSearch_Fragment
    ) | (
      { __typename?: 'MemberWatched' }
      & IElementFragment_MemberWatched_Fragment
    ) | (
      { __typename?: 'MembersDatas' }
      & IElementFragment_MembersDatas_Fragment
    ) | (
      { __typename?: 'MenuColumn' }
      & IElementFragment_MenuColumn_Fragment
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & IElementFragment_MetadatasLanguages_Fragment
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & IElementFragment_MetadatasVodLanguage_Fragment
    ) | (
      { __typename?: 'MetasExclusives' }
      & IElementFragment_MetasExclusives_Fragment
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & IElementFragment_MetasPublicationDate_Fragment
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & IElementFragment_MetasTrailerCmp_Fragment
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & IElementFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename?: 'MultiSlider' }
      & IElementFragment_MultiSlider_Fragment
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & IElementFragment_MulticategoriesSlider_Fragment
    ) | (
      { __typename?: 'NavMessage' }
      & IElementFragment_NavMessage_Fragment
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & IElementFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & IElementFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename?: 'News' }
      & IElementFragment_News_Fragment
    ) | (
      { __typename?: 'NewsCateg' }
      & IElementFragment_NewsCateg_Fragment
    ) | (
      { __typename?: 'NewsFolder' }
      & IElementFragment_NewsFolder_Fragment
    ) | (
      { __typename?: 'NewsPage' }
      & IElementFragment_NewsPage_Fragment
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & IElementFragment_NuggetsTextAnswerOption_Fragment
    ) | (
      { __typename?: 'ObtainedJob' }
      & IElementFragment_ObtainedJob_Fragment
    ) | (
      { __typename?: 'Opportunity' }
      & IElementFragment_Opportunity_Fragment
    ) | (
      { __typename?: 'OpportunityCenter' }
      & IElementFragment_OpportunityCenter_Fragment
    ) | (
      { __typename?: 'OpportunityFolder' }
      & IElementFragment_OpportunityFolder_Fragment
    ) | (
      { __typename?: 'PageSEO' }
      & IElementFragment_PageSeo_Fragment
    ) | (
      { __typename?: 'PagecontentSlider' }
      & IElementFragment_PagecontentSlider_Fragment
    ) | (
      { __typename?: 'Partner' }
      & IElementFragment_Partner_Fragment
    ) | (
      { __typename?: 'PartnerSlider' }
      & IElementFragment_PartnerSlider_Fragment
    ) | (
      { __typename?: 'Partners' }
      & IElementFragment_Partners_Fragment
    ) | (
      { __typename?: 'PartnersPage' }
      & IElementFragment_PartnersPage_Fragment
    ) | (
      { __typename?: 'Paywall' }
      & IElementFragment_Paywall_Fragment
    ) | (
      { __typename?: 'PaywallFolder' }
      & IElementFragment_PaywallFolder_Fragment
    ) | (
      { __typename?: 'PersonalityPages' }
      & IElementFragment_PersonalityPages_Fragment
    ) | (
      { __typename?: 'PersonalityPush' }
      & IElementFragment_PersonalityPush_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & IElementFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & IElementFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & IElementFragment_PersonalityQuizQuestion_Fragment
    ) | (
      { __typename?: 'PersonalityType' }
      & IElementFragment_PersonalityType_Fragment
    ) | (
      { __typename?: 'Playlist' }
      & IElementFragment_Playlist_Fragment
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & IElementFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename?: 'Podcast' }
      & IElementFragment_Podcast_Fragment
    ) | (
      { __typename?: 'PodcastCateg' }
      & IElementFragment_PodcastCateg_Fragment
    ) | (
      { __typename?: 'PodcastItem' }
      & IElementFragment_PodcastItem_Fragment
    ) | (
      { __typename?: 'PodcastMenu' }
      & IElementFragment_PodcastMenu_Fragment
    ) | (
      { __typename?: 'PromoCode' }
      & IElementFragment_PromoCode_Fragment
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & IElementFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename?: 'Push' }
      & IElementFragment_Push_Fragment
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & IElementFragment_QuizItemsSlider_Fragment
    ) | (
      { __typename?: 'QuizPage' }
      & IElementFragment_QuizPage_Fragment
    ) | (
      { __typename?: 'QuizzSurvey' }
      & IElementFragment_QuizzSurvey_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & IElementFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & IElementFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename?: 'Radio' }
      & IElementFragment_Radio_Fragment
    ) | (
      { __typename?: 'RadioCateg' }
      & IElementFragment_RadioCateg_Fragment
    ) | (
      { __typename?: 'Region' }
      & IElementFragment_Region_Fragment
    ) | (
      { __typename?: 'SectionPage' }
      & IElementFragment_SectionPage_Fragment
    ) | (
      { __typename?: 'Service' }
      & IElementFragment_Service_Fragment
    ) | (
      { __typename?: 'ServicesList' }
      & IElementFragment_ServicesList_Fragment
    ) | (
      { __typename?: 'Settings' }
      & IElementFragment_Settings_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & IElementFragment_SettingsAccessRestrictionCmp_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & IElementFragment_SettingsAccessRestrictionCmp1_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & IElementFragment_SettingsAccessRestrictionCmp2_Fragment
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & IElementFragment_SettingsDateCmp_Fragment
    ) | (
      { __typename?: 'SettingsExternalId' }
      & IElementFragment_SettingsExternalId_Fragment
    ) | (
      { __typename?: 'Space' }
      & IElementFragment_Space_Fragment
    ) | (
      { __typename?: 'StaticPageLink' }
      & IElementFragment_StaticPageLink_Fragment
    ) | (
      { __typename?: 'Subscription' }
      & IElementFragment_Subscription_Fragment
    ) | (
      { __typename?: 'SubscriptionData' }
      & IElementFragment_SubscriptionData_Fragment
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & IElementFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & IElementFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsList' }
      & IElementFragment_SubscriptionsList_Fragment
    ) | (
      { __typename?: 'SumaryNugget' }
      & IElementFragment_SumaryNugget_Fragment
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & IElementFragment_SummaryNuggetStatement_Fragment
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & IElementFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename?: 'TextPage' }
      & IElementFragment_TextPage_Fragment
    ) | (
      { __typename?: 'TextSlide1' }
      & IElementFragment_TextSlide1_Fragment
    ) | (
      { __typename?: 'ThankYouPage' }
      & IElementFragment_ThankYouPage_Fragment
    ) | (
      { __typename?: 'TitleSlider' }
      & IElementFragment_TitleSlider_Fragment
    ) | (
      { __typename?: 'Top10Song' }
      & IElementFragment_Top10Song_Fragment
    ) | (
      { __typename?: 'TranslationContext' }
      & IElementFragment_TranslationContext_Fragment
    ) | (
      { __typename?: 'TranslationFolder' }
      & IElementFragment_TranslationFolder_Fragment
    ) | (
      { __typename?: 'TranslationItem' }
      & IElementFragment_TranslationItem_Fragment
    ) | (
      { __typename?: 'TutorialSlide' }
      & IElementFragment_TutorialSlide_Fragment
    ) | (
      { __typename?: 'UcAudio' }
      & IElementFragment_UcAudio_Fragment
    ) | (
      { __typename?: 'UcImage' }
      & IElementFragment_UcImage_Fragment
    ) | (
      { __typename?: 'UcLineBreak' }
      & IElementFragment_UcLineBreak_Fragment
    ) | (
      { __typename?: 'UcText' }
      & IElementFragment_UcText_Fragment
    ) | (
      { __typename?: 'UcVideo' }
      & IElementFragment_UcVideo_Fragment
    ) | (
      { __typename?: 'UmbracoTest' }
      & IElementFragment_UmbracoTest_Fragment
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & IElementFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & IElementFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IElementFragment_UnitNuggetGapFillAnswerItem_Fragment
    ) | (
      { __typename?: 'UnitProgression' }
      & IElementFragment_UnitProgression_Fragment
    ) | (
      { __typename?: 'VODItem' }
      & IElementFragment_VodItem_Fragment
    ) | (
      { __typename?: 'VODMenu' }
      & IElementFragment_VodMenu_Fragment
    ) | (
      { __typename?: 'ValidationElement' }
      & IElementFragment_ValidationElement_Fragment
    ) | (
      { __typename?: 'VotingFolder' }
      & IElementFragment_VotingFolder_Fragment
    ) | (
      { __typename?: 'VotingRecord' }
      & IElementFragment_VotingRecord_Fragment
    ) | (
      { __typename?: 'WatchCateg' }
      & IElementFragment_WatchCateg_Fragment
    ) | (
      { __typename?: 'WatchedContent' }
      & IElementFragment_WatchedContent_Fragment
    ) | (
      { __typename?: 'Wysiwyg' }
      & IElementFragment_Wysiwyg_Fragment
    ) }
  )>>> }
);

export type IAwardCategoryPageFragmentFragment = (
  { __typename: 'AwardCategoryPage' }
  & Pick<IAwardCategoryPage, 'id' | 'title' | 'categTitle' | 'description' | 'subtitle' | 'url' | 'urlRewrite' | 'metaTitle' | 'metaDescription'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & Pick<IAccordions, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Advantage' }
      & Pick<IAdvantage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AdvantagesList' }
      & Pick<IAdvantagesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Article' }
      & Pick<IArticle, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistService' }
      & Pick<IArtistService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Author' }
      & Pick<IAuthor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Button' }
      & Pick<IButton, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CMSPage' }
      & Pick<ICmsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlide' }
      & Pick<ICtaSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlider' }
      & Pick<ICtaSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Card' }
      & Pick<ICard, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardIcon' }
      & Pick<ICardIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardLink' }
      & Pick<ICardLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardList' }
      & Pick<ICardList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategBgColor' }
      & Pick<ICategBgColor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategoryPage' }
      & Pick<ICategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySlider' }
      & Pick<ICategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Channel' }
      & Pick<IChannel, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChannelFolder' }
      & Pick<IChannelFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Collection' }
      & Pick<ICollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ColorTag' }
      & Pick<IColorTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentCategCmp' }
      & Pick<IContentCategCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentLink' }
      & Pick<IContentLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSlider' }
      & Pick<IContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & Pick<IContentSliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTag' }
      & Pick<IContentTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTags' }
      & Pick<IContentTags, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & Pick<IContextualContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Course' }
      & Pick<ICourse, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategory' }
      & Pick<ICourseCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & Pick<ICourseCategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseExam' }
      & Pick<ICourseExam, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & Pick<ICourseItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseNugget' }
      & Pick<ICourseNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CoursePage' }
      & Pick<ICoursePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseShare' }
      & Pick<ICourseShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseStatus' }
      & Pick<ICourseStatus, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseUnit' }
      & Pick<ICourseUnit, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Discovery' }
      & Pick<IDiscovery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide' }
      & Pick<IDiscoverySlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EditoSlider' }
      & Pick<IEditoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExpandMenu' }
      & Pick<IExpandMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExternalLink' }
      & Pick<IExternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqItem' }
      & Pick<IFaqItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqPageLink' }
      & Pick<IFaqPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormFolder' }
      & Pick<IFormFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormPage' }
      & Pick<IFormPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Gallery' }
      & Pick<IGallery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner' }
      & Pick<IHeroBanner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner1' }
      & Pick<IHeroBanner1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroServices' }
      & Pick<IHeroServices, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroSlide' }
      & Pick<IHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroVideoCover' }
      & Pick<IHeroVideoCover, 'contentTypeAlias'>
      & IHeroVideoCoverFragmentFragment
    ) | (
      { __typename?: 'HomePage' }
      & Pick<IHomePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'IconSlide' }
      & Pick<IIconSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'InternalLink' }
      & Pick<IInternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHub' }
      & Pick<IJobHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobProgress' }
      & Pick<IJobProgress, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobShare' }
      & Pick<IJobShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacancy' }
      & Pick<IJobVacancy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigure' }
      & Pick<IKeyFigure, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigures' }
      & Pick<IKeyFigures, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingAbout' }
      & Pick<ILandingAbout, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingPage' }
      & Pick<ILandingPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & Pick<ILearnHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnMenu' }
      & Pick<ILearnMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalPageLink' }
      & Pick<ILegalPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkIcon' }
      & Pick<ILinkIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkPicker' }
      & Pick<ILinkPicker, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ListenCateg' }
      & Pick<IListenCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEvent' }
      & Pick<ILiveEvent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoLink' }
      & Pick<ILogoLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoSlider' }
      & Pick<ILogoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDatas' }
      & Pick<IMemberDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberMessage' }
      & Pick<IMemberMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberNotify' }
      & Pick<IMemberNotify, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSaved' }
      & Pick<IMemberSaved, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSearch' }
      & Pick<IMemberSearch, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberWatched' }
      & Pick<IMemberWatched, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MembersDatas' }
      & Pick<IMembersDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MenuColumn' }
      & Pick<IMenuColumn, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & Pick<IMetadatasLanguages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasExclusives' }
      & Pick<IMetasExclusives, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & Pick<IMetasPublicationDate, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MultiSlider' }
      & Pick<IMultiSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavMessage' }
      & Pick<INavMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'News' }
      & Pick<INews, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsCateg' }
      & Pick<INewsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsFolder' }
      & Pick<INewsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsPage' }
      & Pick<INewsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ObtainedJob' }
      & Pick<IObtainedJob, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Opportunity' }
      & Pick<IOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PageSEO' }
      & Pick<IPageSeo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PagecontentSlider' }
      & Pick<IPagecontentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partner' }
      & Pick<IPartner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnerSlider' }
      & Pick<IPartnerSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partners' }
      & Pick<IPartners, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnersPage' }
      & Pick<IPartnersPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Paywall' }
      & Pick<IPaywall, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPush' }
      & Pick<IPersonalityPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityType' }
      & Pick<IPersonalityType, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Playlist' }
      & Pick<IPlaylist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Podcast' }
      & Pick<IPodcast, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastItem' }
      & Pick<IPodcastItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCode' }
      & Pick<IPromoCode, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Push' }
      & Pick<IPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & Pick<IQuizItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizPage' }
      & Pick<IQuizPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Radio' }
      & Pick<IRadio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'RadioCateg' }
      & Pick<IRadioCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Region' }
      & Pick<IRegion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SectionPage' }
      & Pick<ISectionPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Service' }
      & Pick<IService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ServicesList' }
      & Pick<IServicesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Settings' }
      & Pick<ISettings, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & Pick<ISettingsDateCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsExternalId' }
      & Pick<ISettingsExternalId, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Space' }
      & Pick<ISpace, 'contentTypeAlias'>
    ) | (
      { __typename?: 'StaticPageLink' }
      & Pick<IStaticPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Subscription' }
      & Pick<ISubscription, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsList' }
      & Pick<ISubscriptionsList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextPage' }
      & Pick<ITextPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextSlide1' }
      & Pick<ITextSlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ThankYouPage' }
      & Pick<IThankYouPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TitleSlider' }
      & Pick<ITitleSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Top10Song' }
      & Pick<ITop10Song, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationContext' }
      & Pick<ITranslationContext, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationItem' }
      & Pick<ITranslationItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TutorialSlide' }
      & Pick<ITutorialSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcAudio' }
      & Pick<IUcAudio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcImage' }
      & Pick<IUcImage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcLineBreak' }
      & Pick<IUcLineBreak, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcText' }
      & Pick<IUcText, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcVideo' }
      & Pick<IUcVideo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitProgression' }
      & Pick<IUnitProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODItem' }
      & Pick<IVodItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODMenu' }
      & Pick<IVodMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ValidationElement' }
      & Pick<IValidationElement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingFolder' }
      & Pick<IVotingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingRecord' }
      & Pick<IVotingRecord, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchCateg' }
      & Pick<IWatchCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchedContent' }
      & Pick<IWatchedContent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Wysiwyg' }
      & Pick<IWysiwyg, 'contentTypeAlias'>
    ) }
  )>>>, footerBlocks?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & IElementFragment_Accordions_Fragment
    ) | (
      { __typename?: 'Advantage' }
      & IElementFragment_Advantage_Fragment
    ) | (
      { __typename?: 'AdvantagesList' }
      & IElementFragment_AdvantagesList_Fragment
    ) | (
      { __typename?: 'Article' }
      & IElementFragment_Article_Fragment
    ) | (
      { __typename?: 'ArtistService' }
      & IElementFragment_ArtistService_Fragment
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & IElementFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & IElementFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename?: 'Author' }
      & IElementFragment_Author_Fragment
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & IElementFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename?: 'AwardsArtist' }
      & IElementFragment_AwardsArtist_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & IElementFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & IElementFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & IElementFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & IElementFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename?: 'AwardsHomepage' }
      & IElementFragment_AwardsHomepage_Fragment
    ) | (
      { __typename?: 'Button' }
      & IElementFragment_Button_Fragment
    ) | (
      { __typename?: 'CMSPage' }
      & IElementFragment_CmsPage_Fragment
    ) | (
      { __typename?: 'CTASlide' }
      & IElementFragment_CtaSlide_Fragment
    ) | (
      { __typename?: 'CTASlider' }
      & IElementFragment_CtaSlider_Fragment
    ) | (
      { __typename?: 'Card' }
      & IElementFragment_Card_Fragment
    ) | (
      { __typename?: 'CardIcon' }
      & IElementFragment_CardIcon_Fragment
    ) | (
      { __typename?: 'CardLink' }
      & IElementFragment_CardLink_Fragment
    ) | (
      { __typename?: 'CardList' }
      & IElementFragment_CardList_Fragment
    ) | (
      { __typename?: 'CategBgColor' }
      & IElementFragment_CategBgColor_Fragment
    ) | (
      { __typename?: 'CategoryPage' }
      & IElementFragment_CategoryPage_Fragment
    ) | (
      { __typename?: 'CategorySlider' }
      & IElementFragment_CategorySlider_Fragment
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & IElementFragment_CategorySliderHighlight_Fragment
    ) | (
      { __typename?: 'Channel' }
      & IElementFragment_Channel_Fragment
    ) | (
      { __typename?: 'ChannelFolder' }
      & IElementFragment_ChannelFolder_Fragment
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IElementFragment_ChoiceNuggerAnswer_Fragment
    ) | (
      { __typename?: 'ChoiceNugget' }
      & IElementFragment_ChoiceNugget_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & IElementFragment_ChoiceNuggetAnswerGroup_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & IElementFragment_ChoiceNuggetQuestion_Fragment
    ) | (
      { __typename?: 'Collection' }
      & IElementFragment_Collection_Fragment
    ) | (
      { __typename?: 'ColorTag' }
      & IElementFragment_ColorTag_Fragment
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & IElementFragment_ContentAudioFileCmp_Fragment
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & IElementFragment_ContentAudioVimeoCmp_Fragment
    ) | (
      { __typename?: 'ContentCategCmp' }
      & IElementFragment_ContentCategCmp_Fragment
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & IElementFragment_ContentEpgProgramFileCmp_Fragment
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & IElementFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename?: 'ContentLink' }
      & IElementFragment_ContentLink_Fragment
    ) | (
      { __typename?: 'ContentSlider' }
      & IElementFragment_ContentSlider_Fragment
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & IElementFragment_ContentSliderHighlight_Fragment
    ) | (
      { __typename?: 'ContentTag' }
      & IElementFragment_ContentTag_Fragment
    ) | (
      { __typename?: 'ContentTags' }
      & IElementFragment_ContentTags_Fragment
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & IElementFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & IElementFragment_ContextualContentSlider_Fragment
    ) | (
      { __typename?: 'Course' }
      & IElementFragment_Course_Fragment
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & IElementFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename?: 'CourseCategory' }
      & IElementFragment_CourseCategory_Fragment
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & IElementFragment_CourseCategorySlider_Fragment
    ) | (
      { __typename?: 'CourseExam' }
      & IElementFragment_CourseExam_Fragment
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & IElementFragment_CourseItemsSlider_Fragment
    ) | (
      { __typename?: 'CourseNugget' }
      & IElementFragment_CourseNugget_Fragment
    ) | (
      { __typename?: 'CoursePage' }
      & IElementFragment_CoursePage_Fragment
    ) | (
      { __typename?: 'CourseShare' }
      & IElementFragment_CourseShare_Fragment
    ) | (
      { __typename?: 'CourseStatus' }
      & IElementFragment_CourseStatus_Fragment
    ) | (
      { __typename?: 'CourseTestProgression' }
      & IElementFragment_CourseTestProgression_Fragment
    ) | (
      { __typename?: 'CourseUnit' }
      & IElementFragment_CourseUnit_Fragment
    ) | (
      { __typename?: 'Discovery' }
      & IElementFragment_Discovery_Fragment
    ) | (
      { __typename?: 'DiscoverySlide' }
      & IElementFragment_DiscoverySlide_Fragment
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & IElementFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename?: 'EditoSlider' }
      & IElementFragment_EditoSlider_Fragment
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & IElementFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename?: 'ExpandMenu' }
      & IElementFragment_ExpandMenu_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & IElementFragment_ExternalLink_Fragment
    ) | (
      { __typename?: 'FaqItem' }
      & IElementFragment_FaqItem_Fragment
    ) | (
      { __typename?: 'FaqPageLink' }
      & IElementFragment_FaqPageLink_Fragment
    ) | (
      { __typename?: 'FormFolder' }
      & IElementFragment_FormFolder_Fragment
    ) | (
      { __typename?: 'FormPage' }
      & IElementFragment_FormPage_Fragment
    ) | (
      { __typename?: 'Gallery' }
      & IElementFragment_Gallery_Fragment
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & IElementFragment_GapFillNuggetAnswer_Fragment
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & IElementFragment_GapFillNuggetImageAnswer_Fragment
    ) | (
      { __typename?: 'GapfillNugget' }
      & IElementFragment_GapfillNugget_Fragment
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & IElementFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & IElementFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename?: 'HelpdeskPage' }
      & IElementFragment_HelpdeskPage_Fragment
    ) | (
      { __typename?: 'HeroBanner' }
      & IElementFragment_HeroBanner_Fragment
    ) | (
      { __typename?: 'HeroBanner1' }
      & IElementFragment_HeroBanner1_Fragment
    ) | (
      { __typename?: 'HeroServices' }
      & IElementFragment_HeroServices_Fragment
    ) | (
      { __typename?: 'HeroSlide' }
      & IElementFragment_HeroSlide_Fragment
    ) | (
      { __typename?: 'HeroVideoCover' }
      & IElementFragment_HeroVideoCover_Fragment
    ) | (
      { __typename?: 'HomePage' }
      & IElementFragment_HomePage_Fragment
    ) | (
      { __typename?: 'IconSlide' }
      & IElementFragment_IconSlide_Fragment
    ) | (
      { __typename?: 'InternalLink' }
      & IElementFragment_InternalLink_Fragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & IElementFragment_JobBoardPage_Fragment
    ) | (
      { __typename?: 'JobHub' }
      & IElementFragment_JobHub_Fragment
    ) | (
      { __typename?: 'JobHubsFolder' }
      & IElementFragment_JobHubsFolder_Fragment
    ) | (
      { __typename?: 'JobProgress' }
      & IElementFragment_JobProgress_Fragment
    ) | (
      { __typename?: 'JobShare' }
      & IElementFragment_JobShare_Fragment
    ) | (
      { __typename?: 'JobTraining' }
      & IElementFragment_JobTraining_Fragment
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & IElementFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & IElementFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename?: 'JobVacancy' }
      & IElementFragment_JobVacancy_Fragment
    ) | (
      { __typename?: 'KeyFigure' }
      & IElementFragment_KeyFigure_Fragment
    ) | (
      { __typename?: 'KeyFigures' }
      & IElementFragment_KeyFigures_Fragment
    ) | (
      { __typename?: 'LandingAbout' }
      & IElementFragment_LandingAbout_Fragment
    ) | (
      { __typename?: 'LandingPage' }
      & IElementFragment_LandingPage_Fragment
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & IElementFragment_LearnHeroSlide_Fragment
    ) | (
      { __typename?: 'LearnMenu' }
      & IElementFragment_LearnMenu_Fragment
    ) | (
      { __typename?: 'LegalPageLink' }
      & IElementFragment_LegalPageLink_Fragment
    ) | (
      { __typename?: 'LegalsFolder' }
      & IElementFragment_LegalsFolder_Fragment
    ) | (
      { __typename?: 'LinkIcon' }
      & IElementFragment_LinkIcon_Fragment
    ) | (
      { __typename?: 'LinkPicker' }
      & IElementFragment_LinkPicker_Fragment
    ) | (
      { __typename?: 'ListenCateg' }
      & IElementFragment_ListenCateg_Fragment
    ) | (
      { __typename?: 'LiveEvent' }
      & IElementFragment_LiveEvent_Fragment
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & IElementFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename?: 'LiveEventsPage' }
      & IElementFragment_LiveEventsPage_Fragment
    ) | (
      { __typename?: 'LiveTVPage' }
      & IElementFragment_LiveTvPage_Fragment
    ) | (
      { __typename?: 'LogoLink' }
      & IElementFragment_LogoLink_Fragment
    ) | (
      { __typename?: 'LogoSlider' }
      & IElementFragment_LogoSlider_Fragment
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & IElementFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename?: 'MemberDatas' }
      & IElementFragment_MemberDatas_Fragment
    ) | (
      { __typename?: 'MemberDownloaded' }
      & IElementFragment_MemberDownloaded_Fragment
    ) | (
      { __typename?: 'MemberMessage' }
      & IElementFragment_MemberMessage_Fragment
    ) | (
      { __typename?: 'MemberNotify' }
      & IElementFragment_MemberNotify_Fragment
    ) | (
      { __typename?: 'MemberOpportunity' }
      & IElementFragment_MemberOpportunity_Fragment
    ) | (
      { __typename?: 'MemberSaved' }
      & IElementFragment_MemberSaved_Fragment
    ) | (
      { __typename?: 'MemberSearch' }
      & IElementFragment_MemberSearch_Fragment
    ) | (
      { __typename?: 'MemberWatched' }
      & IElementFragment_MemberWatched_Fragment
    ) | (
      { __typename?: 'MembersDatas' }
      & IElementFragment_MembersDatas_Fragment
    ) | (
      { __typename?: 'MenuColumn' }
      & IElementFragment_MenuColumn_Fragment
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & IElementFragment_MetadatasLanguages_Fragment
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & IElementFragment_MetadatasVodLanguage_Fragment
    ) | (
      { __typename?: 'MetasExclusives' }
      & IElementFragment_MetasExclusives_Fragment
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & IElementFragment_MetasPublicationDate_Fragment
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & IElementFragment_MetasTrailerCmp_Fragment
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & IElementFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename?: 'MultiSlider' }
      & IElementFragment_MultiSlider_Fragment
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & IElementFragment_MulticategoriesSlider_Fragment
    ) | (
      { __typename?: 'NavMessage' }
      & IElementFragment_NavMessage_Fragment
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & IElementFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & IElementFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename?: 'News' }
      & IElementFragment_News_Fragment
    ) | (
      { __typename?: 'NewsCateg' }
      & IElementFragment_NewsCateg_Fragment
    ) | (
      { __typename?: 'NewsFolder' }
      & IElementFragment_NewsFolder_Fragment
    ) | (
      { __typename?: 'NewsPage' }
      & IElementFragment_NewsPage_Fragment
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & IElementFragment_NuggetsTextAnswerOption_Fragment
    ) | (
      { __typename?: 'ObtainedJob' }
      & IElementFragment_ObtainedJob_Fragment
    ) | (
      { __typename?: 'Opportunity' }
      & IElementFragment_Opportunity_Fragment
    ) | (
      { __typename?: 'OpportunityCenter' }
      & IElementFragment_OpportunityCenter_Fragment
    ) | (
      { __typename?: 'OpportunityFolder' }
      & IElementFragment_OpportunityFolder_Fragment
    ) | (
      { __typename?: 'PageSEO' }
      & IElementFragment_PageSeo_Fragment
    ) | (
      { __typename?: 'PagecontentSlider' }
      & IElementFragment_PagecontentSlider_Fragment
    ) | (
      { __typename?: 'Partner' }
      & IElementFragment_Partner_Fragment
    ) | (
      { __typename?: 'PartnerSlider' }
      & IElementFragment_PartnerSlider_Fragment
    ) | (
      { __typename?: 'Partners' }
      & IElementFragment_Partners_Fragment
    ) | (
      { __typename?: 'PartnersPage' }
      & IElementFragment_PartnersPage_Fragment
    ) | (
      { __typename?: 'Paywall' }
      & IElementFragment_Paywall_Fragment
    ) | (
      { __typename?: 'PaywallFolder' }
      & IElementFragment_PaywallFolder_Fragment
    ) | (
      { __typename?: 'PersonalityPages' }
      & IElementFragment_PersonalityPages_Fragment
    ) | (
      { __typename?: 'PersonalityPush' }
      & IElementFragment_PersonalityPush_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & IElementFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & IElementFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & IElementFragment_PersonalityQuizQuestion_Fragment
    ) | (
      { __typename?: 'PersonalityType' }
      & IElementFragment_PersonalityType_Fragment
    ) | (
      { __typename?: 'Playlist' }
      & IElementFragment_Playlist_Fragment
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & IElementFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename?: 'Podcast' }
      & IElementFragment_Podcast_Fragment
    ) | (
      { __typename?: 'PodcastCateg' }
      & IElementFragment_PodcastCateg_Fragment
    ) | (
      { __typename?: 'PodcastItem' }
      & IElementFragment_PodcastItem_Fragment
    ) | (
      { __typename?: 'PodcastMenu' }
      & IElementFragment_PodcastMenu_Fragment
    ) | (
      { __typename?: 'PromoCode' }
      & IElementFragment_PromoCode_Fragment
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & IElementFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename?: 'Push' }
      & IElementFragment_Push_Fragment
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & IElementFragment_QuizItemsSlider_Fragment
    ) | (
      { __typename?: 'QuizPage' }
      & IElementFragment_QuizPage_Fragment
    ) | (
      { __typename?: 'QuizzSurvey' }
      & IElementFragment_QuizzSurvey_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & IElementFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & IElementFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename?: 'Radio' }
      & IElementFragment_Radio_Fragment
    ) | (
      { __typename?: 'RadioCateg' }
      & IElementFragment_RadioCateg_Fragment
    ) | (
      { __typename?: 'Region' }
      & IElementFragment_Region_Fragment
    ) | (
      { __typename?: 'SectionPage' }
      & IElementFragment_SectionPage_Fragment
    ) | (
      { __typename?: 'Service' }
      & IElementFragment_Service_Fragment
    ) | (
      { __typename?: 'ServicesList' }
      & IElementFragment_ServicesList_Fragment
    ) | (
      { __typename?: 'Settings' }
      & IElementFragment_Settings_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & IElementFragment_SettingsAccessRestrictionCmp_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & IElementFragment_SettingsAccessRestrictionCmp1_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & IElementFragment_SettingsAccessRestrictionCmp2_Fragment
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & IElementFragment_SettingsDateCmp_Fragment
    ) | (
      { __typename?: 'SettingsExternalId' }
      & IElementFragment_SettingsExternalId_Fragment
    ) | (
      { __typename?: 'Space' }
      & IElementFragment_Space_Fragment
    ) | (
      { __typename?: 'StaticPageLink' }
      & IElementFragment_StaticPageLink_Fragment
    ) | (
      { __typename?: 'Subscription' }
      & IElementFragment_Subscription_Fragment
    ) | (
      { __typename?: 'SubscriptionData' }
      & IElementFragment_SubscriptionData_Fragment
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & IElementFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & IElementFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsList' }
      & IElementFragment_SubscriptionsList_Fragment
    ) | (
      { __typename?: 'SumaryNugget' }
      & IElementFragment_SumaryNugget_Fragment
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & IElementFragment_SummaryNuggetStatement_Fragment
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & IElementFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename?: 'TextPage' }
      & IElementFragment_TextPage_Fragment
    ) | (
      { __typename?: 'TextSlide1' }
      & IElementFragment_TextSlide1_Fragment
    ) | (
      { __typename?: 'ThankYouPage' }
      & IElementFragment_ThankYouPage_Fragment
    ) | (
      { __typename?: 'TitleSlider' }
      & IElementFragment_TitleSlider_Fragment
    ) | (
      { __typename?: 'Top10Song' }
      & IElementFragment_Top10Song_Fragment
    ) | (
      { __typename?: 'TranslationContext' }
      & IElementFragment_TranslationContext_Fragment
    ) | (
      { __typename?: 'TranslationFolder' }
      & IElementFragment_TranslationFolder_Fragment
    ) | (
      { __typename?: 'TranslationItem' }
      & IElementFragment_TranslationItem_Fragment
    ) | (
      { __typename?: 'TutorialSlide' }
      & IElementFragment_TutorialSlide_Fragment
    ) | (
      { __typename?: 'UcAudio' }
      & IElementFragment_UcAudio_Fragment
    ) | (
      { __typename?: 'UcImage' }
      & IElementFragment_UcImage_Fragment
    ) | (
      { __typename?: 'UcLineBreak' }
      & IElementFragment_UcLineBreak_Fragment
    ) | (
      { __typename?: 'UcText' }
      & IElementFragment_UcText_Fragment
    ) | (
      { __typename?: 'UcVideo' }
      & IElementFragment_UcVideo_Fragment
    ) | (
      { __typename?: 'UmbracoTest' }
      & IElementFragment_UmbracoTest_Fragment
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & IElementFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & IElementFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IElementFragment_UnitNuggetGapFillAnswerItem_Fragment
    ) | (
      { __typename?: 'UnitProgression' }
      & IElementFragment_UnitProgression_Fragment
    ) | (
      { __typename?: 'VODItem' }
      & IElementFragment_VodItem_Fragment
    ) | (
      { __typename?: 'VODMenu' }
      & IElementFragment_VodMenu_Fragment
    ) | (
      { __typename?: 'ValidationElement' }
      & IElementFragment_ValidationElement_Fragment
    ) | (
      { __typename?: 'VotingFolder' }
      & IElementFragment_VotingFolder_Fragment
    ) | (
      { __typename?: 'VotingRecord' }
      & IElementFragment_VotingRecord_Fragment
    ) | (
      { __typename?: 'WatchCateg' }
      & IElementFragment_WatchCateg_Fragment
    ) | (
      { __typename?: 'WatchedContent' }
      & IElementFragment_WatchedContent_Fragment
    ) | (
      { __typename?: 'Wysiwyg' }
      & IElementFragment_Wysiwyg_Fragment
    ) }
  )>>>, children: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | (
      { __typename?: 'AwardsArtist' }
      & IAwardsArtistFragmentFragment
    ) | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
  ), menu?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
    & IAwardsCategoryMenuFragmentFragment
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )> }
);

export type IAwardHomePageFragmentFragment = (
  { __typename: 'AwardsHomepage' }
  & Pick<IAwardsHomepage, 'id' | 'title' | 'introduction' | 'url'>
  & { logo?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & Pick<IAccordions, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Advantage' }
      & Pick<IAdvantage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AdvantagesList' }
      & Pick<IAdvantagesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Article' }
      & Pick<IArticle, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistService' }
      & Pick<IArtistService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Author' }
      & Pick<IAuthor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
    ) | (
      { __typename?: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Button' }
      & Pick<IButton, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CMSPage' }
      & Pick<ICmsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlide' }
      & Pick<ICtaSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CTASlider' }
      & Pick<ICtaSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Card' }
      & Pick<ICard, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardIcon' }
      & Pick<ICardIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardLink' }
      & Pick<ICardLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CardList' }
      & Pick<ICardList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategBgColor' }
      & Pick<ICategBgColor, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategoryPage' }
      & Pick<ICategoryPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySlider' }
      & Pick<ICategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Channel' }
      & Pick<IChannel, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChannelFolder' }
      & Pick<IChannelFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Collection' }
      & Pick<ICollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ColorTag' }
      & Pick<IColorTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentCategCmp' }
      & Pick<IContentCategCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentLink' }
      & Pick<IContentLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSlider' }
      & Pick<IContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & Pick<IContentSliderHighlight, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTag' }
      & Pick<IContentTag, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTags' }
      & Pick<IContentTags, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & Pick<IContextualContentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Course' }
      & Pick<ICourse, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategory' }
      & Pick<ICourseCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & Pick<ICourseCategorySlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseExam' }
      & Pick<ICourseExam, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & Pick<ICourseItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseNugget' }
      & Pick<ICourseNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CoursePage' }
      & Pick<ICoursePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseShare' }
      & Pick<ICourseShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseStatus' }
      & Pick<ICourseStatus, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'CourseUnit' }
      & Pick<ICourseUnit, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Discovery' }
      & Pick<IDiscovery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide' }
      & Pick<IDiscoverySlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EditoSlider' }
      & Pick<IEditoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExpandMenu' }
      & Pick<IExpandMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ExternalLink' }
      & Pick<IExternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqItem' }
      & Pick<IFaqItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FaqPageLink' }
      & Pick<IFaqPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormFolder' }
      & Pick<IFormFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'FormPage' }
      & Pick<IFormPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Gallery' }
      & Pick<IGallery, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner' }
      & Pick<IHeroBanner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroBanner1' }
      & Pick<IHeroBanner1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroServices' }
      & Pick<IHeroServices, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroSlide' }
      & Pick<IHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'HeroVideoCover' }
      & Pick<IHeroVideoCover, 'contentTypeAlias'>
      & IHeroVideoCoverFragmentFragment
    ) | (
      { __typename?: 'HomePage' }
      & Pick<IHomePage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'IconSlide' }
      & Pick<IIconSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'InternalLink' }
      & Pick<IInternalLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHub' }
      & Pick<IJobHub, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobProgress' }
      & Pick<IJobProgress, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobShare' }
      & Pick<IJobShare, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'JobVacancy' }
      & Pick<IJobVacancy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigure' }
      & Pick<IKeyFigure, 'contentTypeAlias'>
    ) | (
      { __typename?: 'KeyFigures' }
      & Pick<IKeyFigures, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingAbout' }
      & Pick<ILandingAbout, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LandingPage' }
      & Pick<ILandingPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & Pick<ILearnHeroSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LearnMenu' }
      & Pick<ILearnMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalPageLink' }
      & Pick<ILegalPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkIcon' }
      & Pick<ILinkIcon, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LinkPicker' }
      & Pick<ILinkPicker, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ListenCateg' }
      & Pick<IListenCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEvent' }
      & Pick<ILiveEvent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoLink' }
      & Pick<ILogoLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'LogoSlider' }
      & Pick<ILogoSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDatas' }
      & Pick<IMemberDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberMessage' }
      & Pick<IMemberMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberNotify' }
      & Pick<IMemberNotify, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSaved' }
      & Pick<IMemberSaved, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberSearch' }
      & Pick<IMemberSearch, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MemberWatched' }
      & Pick<IMemberWatched, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MembersDatas' }
      & Pick<IMembersDatas, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MenuColumn' }
      & Pick<IMenuColumn, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & Pick<IMetadatasLanguages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasExclusives' }
      & Pick<IMetasExclusives, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & Pick<IMetasPublicationDate, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MultiSlider' }
      & Pick<IMultiSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavMessage' }
      & Pick<INavMessage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'contentTypeAlias'>
    ) | (
      { __typename?: 'News' }
      & Pick<INews, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsCateg' }
      & Pick<INewsCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsFolder' }
      & Pick<INewsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NewsPage' }
      & Pick<INewsPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ObtainedJob' }
      & Pick<IObtainedJob, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Opportunity' }
      & Pick<IOpportunity, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'contentTypeAlias'>
    ) | (
      { __typename?: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PageSEO' }
      & Pick<IPageSeo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PagecontentSlider' }
      & Pick<IPagecontentSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partner' }
      & Pick<IPartner, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnerSlider' }
      & Pick<IPartnerSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Partners' }
      & Pick<IPartners, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PartnersPage' }
      & Pick<IPartnersPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Paywall' }
      & Pick<IPaywall, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityPush' }
      & Pick<IPersonalityPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PersonalityType' }
      & Pick<IPersonalityType, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Playlist' }
      & Pick<IPlaylist, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Podcast' }
      & Pick<IPodcast, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastItem' }
      & Pick<IPodcastItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCode' }
      & Pick<IPromoCode, 'contentTypeAlias'>
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Push' }
      & Pick<IPush, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & Pick<IQuizItemsSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizPage' }
      & Pick<IQuizPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Radio' }
      & Pick<IRadio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'RadioCateg' }
      & Pick<IRadioCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Region' }
      & Pick<IRegion, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SectionPage' }
      & Pick<ISectionPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Service' }
      & Pick<IService, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ServicesList' }
      & Pick<IServicesList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Settings' }
      & Pick<ISettings, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & Pick<ISettingsDateCmp, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SettingsExternalId' }
      & Pick<ISettingsExternalId, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Space' }
      & Pick<ISpace, 'contentTypeAlias'>
    ) | (
      { __typename?: 'StaticPageLink' }
      & Pick<IStaticPageLink, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Subscription' }
      & Pick<ISubscription, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SubscriptionsList' }
      & Pick<ISubscriptionsList, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextPage' }
      & Pick<ITextPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TextSlide1' }
      & Pick<ITextSlide1, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ThankYouPage' }
      & Pick<IThankYouPage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TitleSlider' }
      & Pick<ITitleSlider, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Top10Song' }
      & Pick<ITop10Song, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationContext' }
      & Pick<ITranslationContext, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TranslationItem' }
      & Pick<ITranslationItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'TutorialSlide' }
      & Pick<ITutorialSlide, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcAudio' }
      & Pick<IUcAudio, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcImage' }
      & Pick<IUcImage, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcLineBreak' }
      & Pick<IUcLineBreak, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcText' }
      & Pick<IUcText, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UcVideo' }
      & Pick<IUcVideo, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'UnitProgression' }
      & Pick<IUnitProgression, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODItem' }
      & Pick<IVodItem, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VODMenu' }
      & Pick<IVodMenu, 'contentTypeAlias'>
    ) | (
      { __typename?: 'ValidationElement' }
      & Pick<IValidationElement, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingFolder' }
      & Pick<IVotingFolder, 'contentTypeAlias'>
    ) | (
      { __typename?: 'VotingRecord' }
      & Pick<IVotingRecord, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchCateg' }
      & Pick<IWatchCateg, 'contentTypeAlias'>
    ) | (
      { __typename?: 'WatchedContent' }
      & Pick<IWatchedContent, 'contentTypeAlias'>
    ) | (
      { __typename?: 'Wysiwyg' }
      & Pick<IWysiwyg, 'contentTypeAlias'>
    ) }
  )>>>, cTA?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | (
      { __typename: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | (
      { __typename: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, pageBlocks?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & IElementFragment_Accordions_Fragment
    ) | (
      { __typename?: 'Advantage' }
      & IElementFragment_Advantage_Fragment
    ) | (
      { __typename?: 'AdvantagesList' }
      & IElementFragment_AdvantagesList_Fragment
    ) | (
      { __typename?: 'Article' }
      & IElementFragment_Article_Fragment
    ) | (
      { __typename?: 'ArtistService' }
      & IElementFragment_ArtistService_Fragment
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & IElementFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & IElementFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename?: 'Author' }
      & IElementFragment_Author_Fragment
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & IElementFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename?: 'AwardsArtist' }
      & IElementFragment_AwardsArtist_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & IElementFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & IElementFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & IElementFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & IElementFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename?: 'AwardsHomepage' }
      & IElementFragment_AwardsHomepage_Fragment
    ) | (
      { __typename?: 'Button' }
      & IElementFragment_Button_Fragment
    ) | (
      { __typename?: 'CMSPage' }
      & IElementFragment_CmsPage_Fragment
    ) | (
      { __typename?: 'CTASlide' }
      & IElementFragment_CtaSlide_Fragment
    ) | (
      { __typename?: 'CTASlider' }
      & IElementFragment_CtaSlider_Fragment
    ) | (
      { __typename?: 'Card' }
      & IElementFragment_Card_Fragment
    ) | (
      { __typename?: 'CardIcon' }
      & IElementFragment_CardIcon_Fragment
    ) | (
      { __typename?: 'CardLink' }
      & IElementFragment_CardLink_Fragment
    ) | (
      { __typename?: 'CardList' }
      & IElementFragment_CardList_Fragment
    ) | (
      { __typename?: 'CategBgColor' }
      & IElementFragment_CategBgColor_Fragment
    ) | (
      { __typename?: 'CategoryPage' }
      & IElementFragment_CategoryPage_Fragment
    ) | (
      { __typename?: 'CategorySlider' }
      & IElementFragment_CategorySlider_Fragment
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & IElementFragment_CategorySliderHighlight_Fragment
    ) | (
      { __typename?: 'Channel' }
      & IElementFragment_Channel_Fragment
    ) | (
      { __typename?: 'ChannelFolder' }
      & IElementFragment_ChannelFolder_Fragment
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IElementFragment_ChoiceNuggerAnswer_Fragment
    ) | (
      { __typename?: 'ChoiceNugget' }
      & IElementFragment_ChoiceNugget_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & IElementFragment_ChoiceNuggetAnswerGroup_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & IElementFragment_ChoiceNuggetQuestion_Fragment
    ) | (
      { __typename?: 'Collection' }
      & IElementFragment_Collection_Fragment
    ) | (
      { __typename?: 'ColorTag' }
      & IElementFragment_ColorTag_Fragment
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & IElementFragment_ContentAudioFileCmp_Fragment
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & IElementFragment_ContentAudioVimeoCmp_Fragment
    ) | (
      { __typename?: 'ContentCategCmp' }
      & IElementFragment_ContentCategCmp_Fragment
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & IElementFragment_ContentEpgProgramFileCmp_Fragment
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & IElementFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename?: 'ContentLink' }
      & IElementFragment_ContentLink_Fragment
    ) | (
      { __typename?: 'ContentSlider' }
      & IElementFragment_ContentSlider_Fragment
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & IElementFragment_ContentSliderHighlight_Fragment
    ) | (
      { __typename?: 'ContentTag' }
      & IElementFragment_ContentTag_Fragment
    ) | (
      { __typename?: 'ContentTags' }
      & IElementFragment_ContentTags_Fragment
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & IElementFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & IElementFragment_ContextualContentSlider_Fragment
    ) | (
      { __typename?: 'Course' }
      & IElementFragment_Course_Fragment
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & IElementFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename?: 'CourseCategory' }
      & IElementFragment_CourseCategory_Fragment
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & IElementFragment_CourseCategorySlider_Fragment
    ) | (
      { __typename?: 'CourseExam' }
      & IElementFragment_CourseExam_Fragment
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & IElementFragment_CourseItemsSlider_Fragment
    ) | (
      { __typename?: 'CourseNugget' }
      & IElementFragment_CourseNugget_Fragment
    ) | (
      { __typename?: 'CoursePage' }
      & IElementFragment_CoursePage_Fragment
    ) | (
      { __typename?: 'CourseShare' }
      & IElementFragment_CourseShare_Fragment
    ) | (
      { __typename?: 'CourseStatus' }
      & IElementFragment_CourseStatus_Fragment
    ) | (
      { __typename?: 'CourseTestProgression' }
      & IElementFragment_CourseTestProgression_Fragment
    ) | (
      { __typename?: 'CourseUnit' }
      & IElementFragment_CourseUnit_Fragment
    ) | (
      { __typename?: 'Discovery' }
      & IElementFragment_Discovery_Fragment
    ) | (
      { __typename?: 'DiscoverySlide' }
      & IElementFragment_DiscoverySlide_Fragment
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & IElementFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename?: 'EditoSlider' }
      & IElementFragment_EditoSlider_Fragment
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & IElementFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename?: 'ExpandMenu' }
      & IElementFragment_ExpandMenu_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & IElementFragment_ExternalLink_Fragment
    ) | (
      { __typename?: 'FaqItem' }
      & IElementFragment_FaqItem_Fragment
    ) | (
      { __typename?: 'FaqPageLink' }
      & IElementFragment_FaqPageLink_Fragment
    ) | (
      { __typename?: 'FormFolder' }
      & IElementFragment_FormFolder_Fragment
    ) | (
      { __typename?: 'FormPage' }
      & IElementFragment_FormPage_Fragment
    ) | (
      { __typename?: 'Gallery' }
      & IElementFragment_Gallery_Fragment
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & IElementFragment_GapFillNuggetAnswer_Fragment
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & IElementFragment_GapFillNuggetImageAnswer_Fragment
    ) | (
      { __typename?: 'GapfillNugget' }
      & IElementFragment_GapfillNugget_Fragment
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & IElementFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & IElementFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename?: 'HelpdeskPage' }
      & IElementFragment_HelpdeskPage_Fragment
    ) | (
      { __typename?: 'HeroBanner' }
      & IElementFragment_HeroBanner_Fragment
    ) | (
      { __typename?: 'HeroBanner1' }
      & IElementFragment_HeroBanner1_Fragment
    ) | (
      { __typename?: 'HeroServices' }
      & IElementFragment_HeroServices_Fragment
    ) | (
      { __typename?: 'HeroSlide' }
      & IElementFragment_HeroSlide_Fragment
    ) | (
      { __typename?: 'HeroVideoCover' }
      & IElementFragment_HeroVideoCover_Fragment
    ) | (
      { __typename?: 'HomePage' }
      & IElementFragment_HomePage_Fragment
    ) | (
      { __typename?: 'IconSlide' }
      & IElementFragment_IconSlide_Fragment
    ) | (
      { __typename?: 'InternalLink' }
      & IElementFragment_InternalLink_Fragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & IElementFragment_JobBoardPage_Fragment
    ) | (
      { __typename?: 'JobHub' }
      & IElementFragment_JobHub_Fragment
    ) | (
      { __typename?: 'JobHubsFolder' }
      & IElementFragment_JobHubsFolder_Fragment
    ) | (
      { __typename?: 'JobProgress' }
      & IElementFragment_JobProgress_Fragment
    ) | (
      { __typename?: 'JobShare' }
      & IElementFragment_JobShare_Fragment
    ) | (
      { __typename?: 'JobTraining' }
      & IElementFragment_JobTraining_Fragment
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & IElementFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & IElementFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename?: 'JobVacancy' }
      & IElementFragment_JobVacancy_Fragment
    ) | (
      { __typename?: 'KeyFigure' }
      & IElementFragment_KeyFigure_Fragment
    ) | (
      { __typename?: 'KeyFigures' }
      & IElementFragment_KeyFigures_Fragment
    ) | (
      { __typename?: 'LandingAbout' }
      & IElementFragment_LandingAbout_Fragment
    ) | (
      { __typename?: 'LandingPage' }
      & IElementFragment_LandingPage_Fragment
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & IElementFragment_LearnHeroSlide_Fragment
    ) | (
      { __typename?: 'LearnMenu' }
      & IElementFragment_LearnMenu_Fragment
    ) | (
      { __typename?: 'LegalPageLink' }
      & IElementFragment_LegalPageLink_Fragment
    ) | (
      { __typename?: 'LegalsFolder' }
      & IElementFragment_LegalsFolder_Fragment
    ) | (
      { __typename?: 'LinkIcon' }
      & IElementFragment_LinkIcon_Fragment
    ) | (
      { __typename?: 'LinkPicker' }
      & IElementFragment_LinkPicker_Fragment
    ) | (
      { __typename?: 'ListenCateg' }
      & IElementFragment_ListenCateg_Fragment
    ) | (
      { __typename?: 'LiveEvent' }
      & IElementFragment_LiveEvent_Fragment
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & IElementFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename?: 'LiveEventsPage' }
      & IElementFragment_LiveEventsPage_Fragment
    ) | (
      { __typename?: 'LiveTVPage' }
      & IElementFragment_LiveTvPage_Fragment
    ) | (
      { __typename?: 'LogoLink' }
      & IElementFragment_LogoLink_Fragment
    ) | (
      { __typename?: 'LogoSlider' }
      & IElementFragment_LogoSlider_Fragment
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & IElementFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename?: 'MemberDatas' }
      & IElementFragment_MemberDatas_Fragment
    ) | (
      { __typename?: 'MemberDownloaded' }
      & IElementFragment_MemberDownloaded_Fragment
    ) | (
      { __typename?: 'MemberMessage' }
      & IElementFragment_MemberMessage_Fragment
    ) | (
      { __typename?: 'MemberNotify' }
      & IElementFragment_MemberNotify_Fragment
    ) | (
      { __typename?: 'MemberOpportunity' }
      & IElementFragment_MemberOpportunity_Fragment
    ) | (
      { __typename?: 'MemberSaved' }
      & IElementFragment_MemberSaved_Fragment
    ) | (
      { __typename?: 'MemberSearch' }
      & IElementFragment_MemberSearch_Fragment
    ) | (
      { __typename?: 'MemberWatched' }
      & IElementFragment_MemberWatched_Fragment
    ) | (
      { __typename?: 'MembersDatas' }
      & IElementFragment_MembersDatas_Fragment
    ) | (
      { __typename?: 'MenuColumn' }
      & IElementFragment_MenuColumn_Fragment
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & IElementFragment_MetadatasLanguages_Fragment
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & IElementFragment_MetadatasVodLanguage_Fragment
    ) | (
      { __typename?: 'MetasExclusives' }
      & IElementFragment_MetasExclusives_Fragment
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & IElementFragment_MetasPublicationDate_Fragment
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & IElementFragment_MetasTrailerCmp_Fragment
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & IElementFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename?: 'MultiSlider' }
      & IElementFragment_MultiSlider_Fragment
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & IElementFragment_MulticategoriesSlider_Fragment
    ) | (
      { __typename?: 'NavMessage' }
      & IElementFragment_NavMessage_Fragment
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & IElementFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & IElementFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename?: 'News' }
      & IElementFragment_News_Fragment
    ) | (
      { __typename?: 'NewsCateg' }
      & IElementFragment_NewsCateg_Fragment
    ) | (
      { __typename?: 'NewsFolder' }
      & IElementFragment_NewsFolder_Fragment
    ) | (
      { __typename?: 'NewsPage' }
      & IElementFragment_NewsPage_Fragment
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & IElementFragment_NuggetsTextAnswerOption_Fragment
    ) | (
      { __typename?: 'ObtainedJob' }
      & IElementFragment_ObtainedJob_Fragment
    ) | (
      { __typename?: 'Opportunity' }
      & IElementFragment_Opportunity_Fragment
    ) | (
      { __typename?: 'OpportunityCenter' }
      & IElementFragment_OpportunityCenter_Fragment
    ) | (
      { __typename?: 'OpportunityFolder' }
      & IElementFragment_OpportunityFolder_Fragment
    ) | (
      { __typename?: 'PageSEO' }
      & IElementFragment_PageSeo_Fragment
    ) | (
      { __typename?: 'PagecontentSlider' }
      & IElementFragment_PagecontentSlider_Fragment
    ) | (
      { __typename?: 'Partner' }
      & IElementFragment_Partner_Fragment
    ) | (
      { __typename?: 'PartnerSlider' }
      & IElementFragment_PartnerSlider_Fragment
    ) | (
      { __typename?: 'Partners' }
      & IElementFragment_Partners_Fragment
    ) | (
      { __typename?: 'PartnersPage' }
      & IElementFragment_PartnersPage_Fragment
    ) | (
      { __typename?: 'Paywall' }
      & IElementFragment_Paywall_Fragment
    ) | (
      { __typename?: 'PaywallFolder' }
      & IElementFragment_PaywallFolder_Fragment
    ) | (
      { __typename?: 'PersonalityPages' }
      & IElementFragment_PersonalityPages_Fragment
    ) | (
      { __typename?: 'PersonalityPush' }
      & IElementFragment_PersonalityPush_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & IElementFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & IElementFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & IElementFragment_PersonalityQuizQuestion_Fragment
    ) | (
      { __typename?: 'PersonalityType' }
      & IElementFragment_PersonalityType_Fragment
    ) | (
      { __typename?: 'Playlist' }
      & IElementFragment_Playlist_Fragment
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & IElementFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename?: 'Podcast' }
      & IElementFragment_Podcast_Fragment
    ) | (
      { __typename?: 'PodcastCateg' }
      & IElementFragment_PodcastCateg_Fragment
    ) | (
      { __typename?: 'PodcastItem' }
      & IElementFragment_PodcastItem_Fragment
    ) | (
      { __typename?: 'PodcastMenu' }
      & IElementFragment_PodcastMenu_Fragment
    ) | (
      { __typename?: 'PromoCode' }
      & IElementFragment_PromoCode_Fragment
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & IElementFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename?: 'Push' }
      & IElementFragment_Push_Fragment
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & IElementFragment_QuizItemsSlider_Fragment
    ) | (
      { __typename?: 'QuizPage' }
      & IElementFragment_QuizPage_Fragment
    ) | (
      { __typename?: 'QuizzSurvey' }
      & IElementFragment_QuizzSurvey_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & IElementFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & IElementFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename?: 'Radio' }
      & IElementFragment_Radio_Fragment
    ) | (
      { __typename?: 'RadioCateg' }
      & IElementFragment_RadioCateg_Fragment
    ) | (
      { __typename?: 'Region' }
      & IElementFragment_Region_Fragment
    ) | (
      { __typename?: 'SectionPage' }
      & IElementFragment_SectionPage_Fragment
    ) | (
      { __typename?: 'Service' }
      & IElementFragment_Service_Fragment
    ) | (
      { __typename?: 'ServicesList' }
      & IElementFragment_ServicesList_Fragment
    ) | (
      { __typename?: 'Settings' }
      & IElementFragment_Settings_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & IElementFragment_SettingsAccessRestrictionCmp_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & IElementFragment_SettingsAccessRestrictionCmp1_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & IElementFragment_SettingsAccessRestrictionCmp2_Fragment
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & IElementFragment_SettingsDateCmp_Fragment
    ) | (
      { __typename?: 'SettingsExternalId' }
      & IElementFragment_SettingsExternalId_Fragment
    ) | (
      { __typename?: 'Space' }
      & IElementFragment_Space_Fragment
    ) | (
      { __typename?: 'StaticPageLink' }
      & IElementFragment_StaticPageLink_Fragment
    ) | (
      { __typename?: 'Subscription' }
      & IElementFragment_Subscription_Fragment
    ) | (
      { __typename?: 'SubscriptionData' }
      & IElementFragment_SubscriptionData_Fragment
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & IElementFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & IElementFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsList' }
      & IElementFragment_SubscriptionsList_Fragment
    ) | (
      { __typename?: 'SumaryNugget' }
      & IElementFragment_SumaryNugget_Fragment
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & IElementFragment_SummaryNuggetStatement_Fragment
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & IElementFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename?: 'TextPage' }
      & IElementFragment_TextPage_Fragment
    ) | (
      { __typename?: 'TextSlide1' }
      & IElementFragment_TextSlide1_Fragment
    ) | (
      { __typename?: 'ThankYouPage' }
      & IElementFragment_ThankYouPage_Fragment
    ) | (
      { __typename?: 'TitleSlider' }
      & IElementFragment_TitleSlider_Fragment
    ) | (
      { __typename?: 'Top10Song' }
      & IElementFragment_Top10Song_Fragment
    ) | (
      { __typename?: 'TranslationContext' }
      & IElementFragment_TranslationContext_Fragment
    ) | (
      { __typename?: 'TranslationFolder' }
      & IElementFragment_TranslationFolder_Fragment
    ) | (
      { __typename?: 'TranslationItem' }
      & IElementFragment_TranslationItem_Fragment
    ) | (
      { __typename?: 'TutorialSlide' }
      & IElementFragment_TutorialSlide_Fragment
    ) | (
      { __typename?: 'UcAudio' }
      & IElementFragment_UcAudio_Fragment
    ) | (
      { __typename?: 'UcImage' }
      & IElementFragment_UcImage_Fragment
    ) | (
      { __typename?: 'UcLineBreak' }
      & IElementFragment_UcLineBreak_Fragment
    ) | (
      { __typename?: 'UcText' }
      & IElementFragment_UcText_Fragment
    ) | (
      { __typename?: 'UcVideo' }
      & IElementFragment_UcVideo_Fragment
    ) | (
      { __typename?: 'UmbracoTest' }
      & IElementFragment_UmbracoTest_Fragment
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & IElementFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & IElementFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IElementFragment_UnitNuggetGapFillAnswerItem_Fragment
    ) | (
      { __typename?: 'UnitProgression' }
      & IElementFragment_UnitProgression_Fragment
    ) | (
      { __typename?: 'VODItem' }
      & IElementFragment_VodItem_Fragment
    ) | (
      { __typename?: 'VODMenu' }
      & IElementFragment_VodMenu_Fragment
    ) | (
      { __typename?: 'ValidationElement' }
      & IElementFragment_ValidationElement_Fragment
    ) | (
      { __typename?: 'VotingFolder' }
      & IElementFragment_VotingFolder_Fragment
    ) | (
      { __typename?: 'VotingRecord' }
      & IElementFragment_VotingRecord_Fragment
    ) | (
      { __typename?: 'WatchCateg' }
      & IElementFragment_WatchCateg_Fragment
    ) | (
      { __typename?: 'WatchedContent' }
      & IElementFragment_WatchedContent_Fragment
    ) | (
      { __typename?: 'Wysiwyg' }
      & IElementFragment_Wysiwyg_Fragment
    ) }
  )>>> }
);

export type ICategoryPageFragmentFragment = (
  { __typename: 'CategoryPage' }
  & Pick<ICategoryPage, 'id' | 'url' | 'name' | 'backgroundColor'>
  & { categoryContent?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'contentTypeAlias'>
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'contentTypeAlias'>
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'contentTypeAlias'>
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'contentTypeAlias'>
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'contentTypeAlias'>
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'contentTypeAlias'>
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'contentTypeAlias'>
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'contentTypeAlias'>
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'contentTypeAlias'>
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'contentTypeAlias'>
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'contentTypeAlias'>
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'contentTypeAlias'>
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'title' | 'subtitle' | 'countriesRestriction' | 'contentTypeAlias'>
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'contentTypeAlias'>
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'contentTypeAlias'>
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'contentTypeAlias'>
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'contentTypeAlias'>
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'contentTypeAlias'>
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'contentTypeAlias'>
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'contentTypeAlias'>
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'contentTypeAlias'>
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'contentTypeAlias'>
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'contentTypeAlias'>
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'contentTypeAlias'>
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'contentTypeAlias'>
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'contentTypeAlias'>
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'contentTypeAlias'>
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'contentTypeAlias'>
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'contentTypeAlias'>
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'contentTypeAlias'>
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'contentTypeAlias'>
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'contentTypeAlias'>
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'contentTypeAlias'>
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'contentTypeAlias'>
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'contentTypeAlias'>
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'contentTypeAlias'>
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'contentTypeAlias'>
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'contentTypeAlias'>
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'contentTypeAlias'>
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'contentTypeAlias'>
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'contentTypeAlias'>
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'contentTypeAlias'>
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'contentTypeAlias'>
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'contentTypeAlias'>
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'contentTypeAlias'>
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'title' | 'subtitle' | 'countriesRestriction' | 'contentTypeAlias'>
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'contentTypeAlias'>
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'contentTypeAlias'>
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'contentTypeAlias'>
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'contentTypeAlias'>
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'contentTypeAlias'>
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'contentTypeAlias'>
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'contentTypeAlias'>
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'contentTypeAlias'>
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'contentTypeAlias'>
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'contentTypeAlias'>
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'contentTypeAlias'>
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'contentTypeAlias'>
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'contentTypeAlias'>
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'contentTypeAlias'>
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'contentTypeAlias'>
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'contentTypeAlias'>
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'contentTypeAlias'>
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'contentTypeAlias'>
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'contentTypeAlias'>
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'contentTypeAlias'>
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'contentTypeAlias'>
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'contentTypeAlias'>
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'contentTypeAlias'>
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'contentTypeAlias'>
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'contentTypeAlias'>
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'contentTypeAlias'>
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'contentTypeAlias'>
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'contentTypeAlias'>
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'contentTypeAlias'>
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'contentTypeAlias'>
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'contentTypeAlias'>
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'title' | 'subtitle' | 'countriesRestriction' | 'contentTypeAlias'>
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'title' | 'subtitle' | 'countriesRestriction' | 'contentTypeAlias'>
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'contentTypeAlias'>
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'contentTypeAlias'>
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'contentTypeAlias'>
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'contentTypeAlias'>
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'contentTypeAlias'>
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'contentTypeAlias'>
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'contentTypeAlias'>
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'title' | 'subtitle' | 'countriesRestriction' | 'contentTypeAlias'>
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'contentTypeAlias'>
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'contentTypeAlias'>
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'contentTypeAlias'>
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'contentTypeAlias'>
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'contentTypeAlias'>
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'contentTypeAlias'>
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'contentTypeAlias'>
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'contentTypeAlias'>
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'contentTypeAlias'>
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'contentTypeAlias'>
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'contentTypeAlias'>
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'contentTypeAlias'>
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'contentTypeAlias'>
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'contentTypeAlias'>
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'contentTypeAlias'>
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'title' | 'subtitle' | 'countriesRestriction' | 'contentTypeAlias'>
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'contentTypeAlias'>
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'contentTypeAlias'>
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'contentTypeAlias'>
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'contentTypeAlias'>
    & IMainContentListFragment_WatchCateg_Fragment
  )>>> }
);

export type IHelpdeskPageFragmentFragment = (
  { __typename: 'HelpdeskPage' }
  & Pick<IHelpdeskPage, 'name' | 'url'>
  & { push?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | (
      { __typename: 'Push' }
      & IPushFragmentFragment
    ) | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>>, topics?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'name'>
    & IHelpdeskCategFragmentFragment
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'name'>
  )>>> }
);

export type IHomePageFragmentFragment = (
  { __typename: 'HomePage' }
  & Pick<IHomePage, 'id' | 'url' | 'autoloop' | 'loopDelay'>
);

export type ILiveEventsPageFragmentFragment = (
  { __typename: 'LiveEventsPage' }
  & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
  & { liveEventsContent?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'url' | 'name'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'url' | 'name'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'url' | 'name'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'url' | 'name'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'url' | 'name'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'url' | 'name'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'url' | 'name'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'url' | 'name'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'url' | 'name'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'url' | 'name'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'url' | 'name'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'url' | 'name'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'url' | 'name'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'url' | 'name'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'url' | 'name'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'url' | 'name'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'url' | 'name'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'url' | 'name'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'url' | 'name'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'url' | 'name'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'url' | 'name'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'url' | 'name'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'url' | 'name'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'url' | 'name'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'url' | 'name'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'url' | 'name'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'url' | 'name'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'url' | 'name'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'url' | 'name'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'url' | 'name'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'url' | 'name'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'url' | 'name'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'url' | 'name'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'url' | 'name'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'url' | 'name'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'url' | 'name'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'url' | 'name'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'url' | 'name'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'url' | 'name'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'url' | 'name'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'url' | 'name'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'url' | 'name'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'url' | 'name'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'url' | 'name'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'url' | 'name'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'url' | 'name'>
    & ILiveEventFragmentFragment
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'url' | 'name'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'url' | 'name'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'url' | 'name'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'url' | 'name'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'url' | 'name'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'url' | 'name'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'url' | 'name'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'url' | 'name'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'url' | 'name'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'url' | 'name'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'url' | 'name'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'url' | 'name'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'url' | 'name'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'url' | 'name'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'url' | 'name'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'url' | 'name'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'url' | 'name'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'url' | 'name'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'url' | 'name'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'url' | 'name'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'url' | 'name'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'url' | 'name'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'url' | 'name'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'url' | 'name'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'url' | 'name'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'url' | 'name'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'url' | 'name'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'url' | 'name'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'url' | 'name'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'url' | 'name'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'url' | 'name'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'url' | 'name'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'url' | 'name'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'url' | 'name'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'url' | 'name'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'url' | 'name'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'url' | 'name'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'url' | 'name'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'url' | 'name'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'url' | 'name'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'url' | 'name'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'url' | 'name'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'url' | 'name'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'url' | 'name'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'url' | 'name'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'url' | 'name'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'url' | 'name'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'url' | 'name'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'url' | 'name'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'url' | 'name'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'url' | 'name'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'url' | 'name'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'url' | 'name'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'url' | 'name'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'url' | 'name'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'url' | 'name'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'url' | 'name'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'url' | 'name'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'url' | 'name'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'url' | 'name'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'url' | 'name'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'url' | 'name'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'url' | 'name'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'url' | 'name'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'url' | 'name'>
  )>>> }
);

export type ILiveTvPageFragmentFragment = (
  { __typename: 'LiveTVPage' }
  & Pick<ILiveTvPage, 'id' | 'url' | 'name'>
  & { liveTVContent?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | (
    { __typename: 'Channel' }
    & IChannelFragmentFragment
  ) | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
);

export type ISectionPageFragmentFragment = (
  { __typename: 'SectionPage' }
  & Pick<ISectionPage, 'id' | 'url' | 'autoloop' | 'loopDelay'>
  & { heroSlider?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | (
      { __typename?: 'HeroSlide' }
      & IHeroSlideFragmentFragment
    ) | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, pageBlocks?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & IElementFragment_Accordions_Fragment
    ) | (
      { __typename?: 'Advantage' }
      & IElementFragment_Advantage_Fragment
    ) | (
      { __typename?: 'AdvantagesList' }
      & IElementFragment_AdvantagesList_Fragment
    ) | (
      { __typename?: 'Article' }
      & IElementFragment_Article_Fragment
    ) | (
      { __typename?: 'ArtistService' }
      & IElementFragment_ArtistService_Fragment
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & IElementFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & IElementFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename?: 'Author' }
      & IElementFragment_Author_Fragment
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & IElementFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename?: 'AwardsArtist' }
      & IElementFragment_AwardsArtist_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & IElementFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & IElementFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & IElementFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & IElementFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename?: 'AwardsHomepage' }
      & IElementFragment_AwardsHomepage_Fragment
    ) | (
      { __typename?: 'Button' }
      & IElementFragment_Button_Fragment
    ) | (
      { __typename?: 'CMSPage' }
      & IElementFragment_CmsPage_Fragment
    ) | (
      { __typename?: 'CTASlide' }
      & IElementFragment_CtaSlide_Fragment
    ) | (
      { __typename?: 'CTASlider' }
      & IElementFragment_CtaSlider_Fragment
    ) | (
      { __typename?: 'Card' }
      & IElementFragment_Card_Fragment
    ) | (
      { __typename?: 'CardIcon' }
      & IElementFragment_CardIcon_Fragment
    ) | (
      { __typename?: 'CardLink' }
      & IElementFragment_CardLink_Fragment
    ) | (
      { __typename?: 'CardList' }
      & IElementFragment_CardList_Fragment
    ) | (
      { __typename?: 'CategBgColor' }
      & IElementFragment_CategBgColor_Fragment
    ) | (
      { __typename?: 'CategoryPage' }
      & IElementFragment_CategoryPage_Fragment
    ) | (
      { __typename?: 'CategorySlider' }
      & IElementFragment_CategorySlider_Fragment
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & IElementFragment_CategorySliderHighlight_Fragment
    ) | (
      { __typename?: 'Channel' }
      & IElementFragment_Channel_Fragment
    ) | (
      { __typename?: 'ChannelFolder' }
      & IElementFragment_ChannelFolder_Fragment
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IElementFragment_ChoiceNuggerAnswer_Fragment
    ) | (
      { __typename?: 'ChoiceNugget' }
      & IElementFragment_ChoiceNugget_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & IElementFragment_ChoiceNuggetAnswerGroup_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & IElementFragment_ChoiceNuggetQuestion_Fragment
    ) | (
      { __typename?: 'Collection' }
      & IElementFragment_Collection_Fragment
    ) | (
      { __typename?: 'ColorTag' }
      & IElementFragment_ColorTag_Fragment
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & IElementFragment_ContentAudioFileCmp_Fragment
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & IElementFragment_ContentAudioVimeoCmp_Fragment
    ) | (
      { __typename?: 'ContentCategCmp' }
      & IElementFragment_ContentCategCmp_Fragment
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & IElementFragment_ContentEpgProgramFileCmp_Fragment
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & IElementFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename?: 'ContentLink' }
      & IElementFragment_ContentLink_Fragment
    ) | (
      { __typename?: 'ContentSlider' }
      & IElementFragment_ContentSlider_Fragment
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & IElementFragment_ContentSliderHighlight_Fragment
    ) | (
      { __typename?: 'ContentTag' }
      & IElementFragment_ContentTag_Fragment
    ) | (
      { __typename?: 'ContentTags' }
      & IElementFragment_ContentTags_Fragment
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & IElementFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & IElementFragment_ContextualContentSlider_Fragment
    ) | (
      { __typename?: 'Course' }
      & IElementFragment_Course_Fragment
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & IElementFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename?: 'CourseCategory' }
      & IElementFragment_CourseCategory_Fragment
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & IElementFragment_CourseCategorySlider_Fragment
    ) | (
      { __typename?: 'CourseExam' }
      & IElementFragment_CourseExam_Fragment
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & IElementFragment_CourseItemsSlider_Fragment
    ) | (
      { __typename?: 'CourseNugget' }
      & IElementFragment_CourseNugget_Fragment
    ) | (
      { __typename?: 'CoursePage' }
      & IElementFragment_CoursePage_Fragment
    ) | (
      { __typename?: 'CourseShare' }
      & IElementFragment_CourseShare_Fragment
    ) | (
      { __typename?: 'CourseStatus' }
      & IElementFragment_CourseStatus_Fragment
    ) | (
      { __typename?: 'CourseTestProgression' }
      & IElementFragment_CourseTestProgression_Fragment
    ) | (
      { __typename?: 'CourseUnit' }
      & IElementFragment_CourseUnit_Fragment
    ) | (
      { __typename?: 'Discovery' }
      & IElementFragment_Discovery_Fragment
    ) | (
      { __typename?: 'DiscoverySlide' }
      & IElementFragment_DiscoverySlide_Fragment
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & IElementFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename?: 'EditoSlider' }
      & IElementFragment_EditoSlider_Fragment
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & IElementFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename?: 'ExpandMenu' }
      & IElementFragment_ExpandMenu_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & IElementFragment_ExternalLink_Fragment
    ) | (
      { __typename?: 'FaqItem' }
      & IElementFragment_FaqItem_Fragment
    ) | (
      { __typename?: 'FaqPageLink' }
      & IElementFragment_FaqPageLink_Fragment
    ) | (
      { __typename?: 'FormFolder' }
      & IElementFragment_FormFolder_Fragment
    ) | (
      { __typename?: 'FormPage' }
      & IElementFragment_FormPage_Fragment
    ) | (
      { __typename?: 'Gallery' }
      & IElementFragment_Gallery_Fragment
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & IElementFragment_GapFillNuggetAnswer_Fragment
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & IElementFragment_GapFillNuggetImageAnswer_Fragment
    ) | (
      { __typename?: 'GapfillNugget' }
      & IElementFragment_GapfillNugget_Fragment
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & IElementFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & IElementFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename?: 'HelpdeskPage' }
      & IElementFragment_HelpdeskPage_Fragment
    ) | (
      { __typename?: 'HeroBanner' }
      & IElementFragment_HeroBanner_Fragment
    ) | (
      { __typename?: 'HeroBanner1' }
      & IElementFragment_HeroBanner1_Fragment
    ) | (
      { __typename?: 'HeroServices' }
      & IElementFragment_HeroServices_Fragment
    ) | (
      { __typename?: 'HeroSlide' }
      & IElementFragment_HeroSlide_Fragment
    ) | (
      { __typename?: 'HeroVideoCover' }
      & IElementFragment_HeroVideoCover_Fragment
    ) | (
      { __typename?: 'HomePage' }
      & IElementFragment_HomePage_Fragment
    ) | (
      { __typename?: 'IconSlide' }
      & IElementFragment_IconSlide_Fragment
    ) | (
      { __typename?: 'InternalLink' }
      & IElementFragment_InternalLink_Fragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & IElementFragment_JobBoardPage_Fragment
    ) | (
      { __typename?: 'JobHub' }
      & IElementFragment_JobHub_Fragment
    ) | (
      { __typename?: 'JobHubsFolder' }
      & IElementFragment_JobHubsFolder_Fragment
    ) | (
      { __typename?: 'JobProgress' }
      & IElementFragment_JobProgress_Fragment
    ) | (
      { __typename?: 'JobShare' }
      & IElementFragment_JobShare_Fragment
    ) | (
      { __typename?: 'JobTraining' }
      & IElementFragment_JobTraining_Fragment
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & IElementFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & IElementFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename?: 'JobVacancy' }
      & IElementFragment_JobVacancy_Fragment
    ) | (
      { __typename?: 'KeyFigure' }
      & IElementFragment_KeyFigure_Fragment
    ) | (
      { __typename?: 'KeyFigures' }
      & IElementFragment_KeyFigures_Fragment
    ) | (
      { __typename?: 'LandingAbout' }
      & IElementFragment_LandingAbout_Fragment
    ) | (
      { __typename?: 'LandingPage' }
      & IElementFragment_LandingPage_Fragment
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & IElementFragment_LearnHeroSlide_Fragment
    ) | (
      { __typename?: 'LearnMenu' }
      & IElementFragment_LearnMenu_Fragment
    ) | (
      { __typename?: 'LegalPageLink' }
      & IElementFragment_LegalPageLink_Fragment
    ) | (
      { __typename?: 'LegalsFolder' }
      & IElementFragment_LegalsFolder_Fragment
    ) | (
      { __typename?: 'LinkIcon' }
      & IElementFragment_LinkIcon_Fragment
    ) | (
      { __typename?: 'LinkPicker' }
      & IElementFragment_LinkPicker_Fragment
    ) | (
      { __typename?: 'ListenCateg' }
      & IElementFragment_ListenCateg_Fragment
    ) | (
      { __typename?: 'LiveEvent' }
      & IElementFragment_LiveEvent_Fragment
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & IElementFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename?: 'LiveEventsPage' }
      & IElementFragment_LiveEventsPage_Fragment
    ) | (
      { __typename?: 'LiveTVPage' }
      & IElementFragment_LiveTvPage_Fragment
    ) | (
      { __typename?: 'LogoLink' }
      & IElementFragment_LogoLink_Fragment
    ) | (
      { __typename?: 'LogoSlider' }
      & IElementFragment_LogoSlider_Fragment
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & IElementFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename?: 'MemberDatas' }
      & IElementFragment_MemberDatas_Fragment
    ) | (
      { __typename?: 'MemberDownloaded' }
      & IElementFragment_MemberDownloaded_Fragment
    ) | (
      { __typename?: 'MemberMessage' }
      & IElementFragment_MemberMessage_Fragment
    ) | (
      { __typename?: 'MemberNotify' }
      & IElementFragment_MemberNotify_Fragment
    ) | (
      { __typename?: 'MemberOpportunity' }
      & IElementFragment_MemberOpportunity_Fragment
    ) | (
      { __typename?: 'MemberSaved' }
      & IElementFragment_MemberSaved_Fragment
    ) | (
      { __typename?: 'MemberSearch' }
      & IElementFragment_MemberSearch_Fragment
    ) | (
      { __typename?: 'MemberWatched' }
      & IElementFragment_MemberWatched_Fragment
    ) | (
      { __typename?: 'MembersDatas' }
      & IElementFragment_MembersDatas_Fragment
    ) | (
      { __typename?: 'MenuColumn' }
      & IElementFragment_MenuColumn_Fragment
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & IElementFragment_MetadatasLanguages_Fragment
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & IElementFragment_MetadatasVodLanguage_Fragment
    ) | (
      { __typename?: 'MetasExclusives' }
      & IElementFragment_MetasExclusives_Fragment
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & IElementFragment_MetasPublicationDate_Fragment
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & IElementFragment_MetasTrailerCmp_Fragment
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & IElementFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename?: 'MultiSlider' }
      & IElementFragment_MultiSlider_Fragment
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & IElementFragment_MulticategoriesSlider_Fragment
    ) | (
      { __typename?: 'NavMessage' }
      & IElementFragment_NavMessage_Fragment
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & IElementFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & IElementFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename?: 'News' }
      & IElementFragment_News_Fragment
    ) | (
      { __typename?: 'NewsCateg' }
      & IElementFragment_NewsCateg_Fragment
    ) | (
      { __typename?: 'NewsFolder' }
      & IElementFragment_NewsFolder_Fragment
    ) | (
      { __typename?: 'NewsPage' }
      & IElementFragment_NewsPage_Fragment
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & IElementFragment_NuggetsTextAnswerOption_Fragment
    ) | (
      { __typename?: 'ObtainedJob' }
      & IElementFragment_ObtainedJob_Fragment
    ) | (
      { __typename?: 'Opportunity' }
      & IElementFragment_Opportunity_Fragment
    ) | (
      { __typename?: 'OpportunityCenter' }
      & IElementFragment_OpportunityCenter_Fragment
    ) | (
      { __typename?: 'OpportunityFolder' }
      & IElementFragment_OpportunityFolder_Fragment
    ) | (
      { __typename?: 'PageSEO' }
      & IElementFragment_PageSeo_Fragment
    ) | (
      { __typename?: 'PagecontentSlider' }
      & IElementFragment_PagecontentSlider_Fragment
    ) | (
      { __typename?: 'Partner' }
      & IElementFragment_Partner_Fragment
    ) | (
      { __typename?: 'PartnerSlider' }
      & IElementFragment_PartnerSlider_Fragment
    ) | (
      { __typename?: 'Partners' }
      & IElementFragment_Partners_Fragment
    ) | (
      { __typename?: 'PartnersPage' }
      & IElementFragment_PartnersPage_Fragment
    ) | (
      { __typename?: 'Paywall' }
      & IElementFragment_Paywall_Fragment
    ) | (
      { __typename?: 'PaywallFolder' }
      & IElementFragment_PaywallFolder_Fragment
    ) | (
      { __typename?: 'PersonalityPages' }
      & IElementFragment_PersonalityPages_Fragment
    ) | (
      { __typename?: 'PersonalityPush' }
      & IElementFragment_PersonalityPush_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & IElementFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & IElementFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & IElementFragment_PersonalityQuizQuestion_Fragment
    ) | (
      { __typename?: 'PersonalityType' }
      & IElementFragment_PersonalityType_Fragment
    ) | (
      { __typename?: 'Playlist' }
      & IElementFragment_Playlist_Fragment
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & IElementFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename?: 'Podcast' }
      & IElementFragment_Podcast_Fragment
    ) | (
      { __typename?: 'PodcastCateg' }
      & IElementFragment_PodcastCateg_Fragment
    ) | (
      { __typename?: 'PodcastItem' }
      & IElementFragment_PodcastItem_Fragment
    ) | (
      { __typename?: 'PodcastMenu' }
      & IElementFragment_PodcastMenu_Fragment
    ) | (
      { __typename?: 'PromoCode' }
      & IElementFragment_PromoCode_Fragment
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & IElementFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename?: 'Push' }
      & IElementFragment_Push_Fragment
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & IElementFragment_QuizItemsSlider_Fragment
    ) | (
      { __typename?: 'QuizPage' }
      & IElementFragment_QuizPage_Fragment
    ) | (
      { __typename?: 'QuizzSurvey' }
      & IElementFragment_QuizzSurvey_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & IElementFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & IElementFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename?: 'Radio' }
      & IElementFragment_Radio_Fragment
    ) | (
      { __typename?: 'RadioCateg' }
      & IElementFragment_RadioCateg_Fragment
    ) | (
      { __typename?: 'Region' }
      & IElementFragment_Region_Fragment
    ) | (
      { __typename?: 'SectionPage' }
      & IElementFragment_SectionPage_Fragment
    ) | (
      { __typename?: 'Service' }
      & IElementFragment_Service_Fragment
    ) | (
      { __typename?: 'ServicesList' }
      & IElementFragment_ServicesList_Fragment
    ) | (
      { __typename?: 'Settings' }
      & IElementFragment_Settings_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & IElementFragment_SettingsAccessRestrictionCmp_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & IElementFragment_SettingsAccessRestrictionCmp1_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & IElementFragment_SettingsAccessRestrictionCmp2_Fragment
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & IElementFragment_SettingsDateCmp_Fragment
    ) | (
      { __typename?: 'SettingsExternalId' }
      & IElementFragment_SettingsExternalId_Fragment
    ) | (
      { __typename?: 'Space' }
      & IElementFragment_Space_Fragment
    ) | (
      { __typename?: 'StaticPageLink' }
      & IElementFragment_StaticPageLink_Fragment
    ) | (
      { __typename?: 'Subscription' }
      & IElementFragment_Subscription_Fragment
    ) | (
      { __typename?: 'SubscriptionData' }
      & IElementFragment_SubscriptionData_Fragment
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & IElementFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & IElementFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsList' }
      & IElementFragment_SubscriptionsList_Fragment
    ) | (
      { __typename?: 'SumaryNugget' }
      & IElementFragment_SumaryNugget_Fragment
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & IElementFragment_SummaryNuggetStatement_Fragment
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & IElementFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename?: 'TextPage' }
      & IElementFragment_TextPage_Fragment
    ) | (
      { __typename?: 'TextSlide1' }
      & IElementFragment_TextSlide1_Fragment
    ) | (
      { __typename?: 'ThankYouPage' }
      & IElementFragment_ThankYouPage_Fragment
    ) | (
      { __typename?: 'TitleSlider' }
      & IElementFragment_TitleSlider_Fragment
    ) | (
      { __typename?: 'Top10Song' }
      & IElementFragment_Top10Song_Fragment
    ) | (
      { __typename?: 'TranslationContext' }
      & IElementFragment_TranslationContext_Fragment
    ) | (
      { __typename?: 'TranslationFolder' }
      & IElementFragment_TranslationFolder_Fragment
    ) | (
      { __typename?: 'TranslationItem' }
      & IElementFragment_TranslationItem_Fragment
    ) | (
      { __typename?: 'TutorialSlide' }
      & IElementFragment_TutorialSlide_Fragment
    ) | (
      { __typename?: 'UcAudio' }
      & IElementFragment_UcAudio_Fragment
    ) | (
      { __typename?: 'UcImage' }
      & IElementFragment_UcImage_Fragment
    ) | (
      { __typename?: 'UcLineBreak' }
      & IElementFragment_UcLineBreak_Fragment
    ) | (
      { __typename?: 'UcText' }
      & IElementFragment_UcText_Fragment
    ) | (
      { __typename?: 'UcVideo' }
      & IElementFragment_UcVideo_Fragment
    ) | (
      { __typename?: 'UmbracoTest' }
      & IElementFragment_UmbracoTest_Fragment
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & IElementFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & IElementFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IElementFragment_UnitNuggetGapFillAnswerItem_Fragment
    ) | (
      { __typename?: 'UnitProgression' }
      & IElementFragment_UnitProgression_Fragment
    ) | (
      { __typename?: 'VODItem' }
      & IElementFragment_VodItem_Fragment
    ) | (
      { __typename?: 'VODMenu' }
      & IElementFragment_VodMenu_Fragment
    ) | (
      { __typename?: 'ValidationElement' }
      & IElementFragment_ValidationElement_Fragment
    ) | (
      { __typename?: 'VotingFolder' }
      & IElementFragment_VotingFolder_Fragment
    ) | (
      { __typename?: 'VotingRecord' }
      & IElementFragment_VotingRecord_Fragment
    ) | (
      { __typename?: 'WatchCateg' }
      & IElementFragment_WatchCateg_Fragment
    ) | (
      { __typename?: 'WatchedContent' }
      & IElementFragment_WatchedContent_Fragment
    ) | (
      { __typename?: 'Wysiwyg' }
      & IElementFragment_Wysiwyg_Fragment
    ) }
  )>>> }
);

export type ISectionPageContentFragmentFragment = (
  { __typename: 'SectionPage' }
  & Pick<ISectionPage, 'id' | 'url' | 'autoloop' | 'loopDelay'>
  & { heroSlider?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | (
      { __typename?: 'HeroSlide' }
      & IHeroSlideFragmentFragment
    ) | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | (
      { __typename?: 'LearnHeroSlide' }
      & ILearnHeroSildeFragmentFragment
    ) | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, pageBlocks?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: (
      { __typename?: 'Accordions' }
      & IElementFragment_Accordions_Fragment
    ) | (
      { __typename?: 'Advantage' }
      & IElementFragment_Advantage_Fragment
    ) | (
      { __typename?: 'AdvantagesList' }
      & IElementFragment_AdvantagesList_Fragment
    ) | (
      { __typename?: 'Article' }
      & IElementFragment_Article_Fragment
    ) | (
      { __typename?: 'ArtistService' }
      & IElementFragment_ArtistService_Fragment
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & IElementFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & IElementFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename?: 'Author' }
      & IElementFragment_Author_Fragment
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & IElementFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename?: 'AwardsArtist' }
      & IElementFragment_AwardsArtist_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & IElementFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & IElementFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & IElementFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & IElementFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename?: 'AwardsHomepage' }
      & IElementFragment_AwardsHomepage_Fragment
    ) | (
      { __typename?: 'Button' }
      & IElementFragment_Button_Fragment
    ) | (
      { __typename?: 'CMSPage' }
      & IElementFragment_CmsPage_Fragment
    ) | (
      { __typename?: 'CTASlide' }
      & IElementFragment_CtaSlide_Fragment
    ) | (
      { __typename?: 'CTASlider' }
      & IElementFragment_CtaSlider_Fragment
    ) | (
      { __typename?: 'Card' }
      & IElementFragment_Card_Fragment
    ) | (
      { __typename?: 'CardIcon' }
      & IElementFragment_CardIcon_Fragment
    ) | (
      { __typename?: 'CardLink' }
      & IElementFragment_CardLink_Fragment
    ) | (
      { __typename?: 'CardList' }
      & IElementFragment_CardList_Fragment
    ) | (
      { __typename?: 'CategBgColor' }
      & IElementFragment_CategBgColor_Fragment
    ) | (
      { __typename?: 'CategoryPage' }
      & IElementFragment_CategoryPage_Fragment
    ) | (
      { __typename?: 'CategorySlider' }
      & IElementFragment_CategorySlider_Fragment
    ) | (
      { __typename?: 'CategorySliderHighlight' }
      & IElementFragment_CategorySliderHighlight_Fragment
    ) | (
      { __typename?: 'Channel' }
      & IElementFragment_Channel_Fragment
    ) | (
      { __typename?: 'ChannelFolder' }
      & IElementFragment_ChannelFolder_Fragment
    ) | (
      { __typename?: 'ChoiceNuggerAnswer' }
      & IElementFragment_ChoiceNuggerAnswer_Fragment
    ) | (
      { __typename?: 'ChoiceNugget' }
      & IElementFragment_ChoiceNugget_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetAnswerGroup' }
      & IElementFragment_ChoiceNuggetAnswerGroup_Fragment
    ) | (
      { __typename?: 'ChoiceNuggetQuestion' }
      & IElementFragment_ChoiceNuggetQuestion_Fragment
    ) | (
      { __typename?: 'Collection' }
      & IElementFragment_Collection_Fragment
    ) | (
      { __typename?: 'ColorTag' }
      & IElementFragment_ColorTag_Fragment
    ) | (
      { __typename?: 'ContentAudioFileCmp' }
      & IElementFragment_ContentAudioFileCmp_Fragment
    ) | (
      { __typename?: 'ContentAudioVimeoCmp' }
      & IElementFragment_ContentAudioVimeoCmp_Fragment
    ) | (
      { __typename?: 'ContentCategCmp' }
      & IElementFragment_ContentCategCmp_Fragment
    ) | (
      { __typename?: 'ContentEPGProgramFileCmp' }
      & IElementFragment_ContentEpgProgramFileCmp_Fragment
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & IElementFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename?: 'ContentLink' }
      & IElementFragment_ContentLink_Fragment
    ) | (
      { __typename?: 'ContentSlider' }
      & IElementFragment_ContentSlider_Fragment
    ) | (
      { __typename?: 'ContentSliderHighlight' }
      & IElementFragment_ContentSliderHighlight_Fragment
    ) | (
      { __typename?: 'ContentTag' }
      & IElementFragment_ContentTag_Fragment
    ) | (
      { __typename?: 'ContentTags' }
      & IElementFragment_ContentTags_Fragment
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & IElementFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename?: 'ContextualContentSlider' }
      & IElementFragment_ContextualContentSlider_Fragment
    ) | (
      { __typename?: 'Course' }
      & IElementFragment_Course_Fragment
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & IElementFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename?: 'CourseCategory' }
      & IElementFragment_CourseCategory_Fragment
    ) | (
      { __typename?: 'CourseCategorySlider' }
      & IElementFragment_CourseCategorySlider_Fragment
    ) | (
      { __typename?: 'CourseExam' }
      & IElementFragment_CourseExam_Fragment
    ) | (
      { __typename?: 'CourseItemsSlider' }
      & IElementFragment_CourseItemsSlider_Fragment
    ) | (
      { __typename?: 'CourseNugget' }
      & IElementFragment_CourseNugget_Fragment
    ) | (
      { __typename?: 'CoursePage' }
      & IElementFragment_CoursePage_Fragment
    ) | (
      { __typename?: 'CourseShare' }
      & IElementFragment_CourseShare_Fragment
    ) | (
      { __typename?: 'CourseStatus' }
      & IElementFragment_CourseStatus_Fragment
    ) | (
      { __typename?: 'CourseTestProgression' }
      & IElementFragment_CourseTestProgression_Fragment
    ) | (
      { __typename?: 'CourseUnit' }
      & IElementFragment_CourseUnit_Fragment
    ) | (
      { __typename?: 'Discovery' }
      & IElementFragment_Discovery_Fragment
    ) | (
      { __typename?: 'DiscoverySlide' }
      & IElementFragment_DiscoverySlide_Fragment
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & IElementFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename?: 'EditoSlider' }
      & IElementFragment_EditoSlider_Fragment
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & IElementFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename?: 'ExpandMenu' }
      & IElementFragment_ExpandMenu_Fragment
    ) | (
      { __typename?: 'ExternalLink' }
      & IElementFragment_ExternalLink_Fragment
    ) | (
      { __typename?: 'FaqItem' }
      & IElementFragment_FaqItem_Fragment
    ) | (
      { __typename?: 'FaqPageLink' }
      & IElementFragment_FaqPageLink_Fragment
    ) | (
      { __typename?: 'FormFolder' }
      & IElementFragment_FormFolder_Fragment
    ) | (
      { __typename?: 'FormPage' }
      & IElementFragment_FormPage_Fragment
    ) | (
      { __typename?: 'Gallery' }
      & IElementFragment_Gallery_Fragment
    ) | (
      { __typename?: 'GapFillNuggetAnswer' }
      & IElementFragment_GapFillNuggetAnswer_Fragment
    ) | (
      { __typename?: 'GapFillNuggetImageAnswer' }
      & IElementFragment_GapFillNuggetImageAnswer_Fragment
    ) | (
      { __typename?: 'GapfillNugget' }
      & IElementFragment_GapfillNugget_Fragment
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & IElementFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & IElementFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename?: 'HelpdeskPage' }
      & IElementFragment_HelpdeskPage_Fragment
    ) | (
      { __typename?: 'HeroBanner' }
      & IElementFragment_HeroBanner_Fragment
    ) | (
      { __typename?: 'HeroBanner1' }
      & IElementFragment_HeroBanner1_Fragment
    ) | (
      { __typename?: 'HeroServices' }
      & IElementFragment_HeroServices_Fragment
    ) | (
      { __typename?: 'HeroSlide' }
      & IElementFragment_HeroSlide_Fragment
    ) | (
      { __typename?: 'HeroVideoCover' }
      & IElementFragment_HeroVideoCover_Fragment
    ) | (
      { __typename?: 'HomePage' }
      & IElementFragment_HomePage_Fragment
    ) | (
      { __typename?: 'IconSlide' }
      & IElementFragment_IconSlide_Fragment
    ) | (
      { __typename?: 'InternalLink' }
      & IElementFragment_InternalLink_Fragment
    ) | (
      { __typename?: 'JobBoardPage' }
      & IElementFragment_JobBoardPage_Fragment
    ) | (
      { __typename?: 'JobHub' }
      & IElementFragment_JobHub_Fragment
    ) | (
      { __typename?: 'JobHubsFolder' }
      & IElementFragment_JobHubsFolder_Fragment
    ) | (
      { __typename?: 'JobProgress' }
      & IElementFragment_JobProgress_Fragment
    ) | (
      { __typename?: 'JobShare' }
      & IElementFragment_JobShare_Fragment
    ) | (
      { __typename?: 'JobTraining' }
      & IElementFragment_JobTraining_Fragment
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & IElementFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & IElementFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename?: 'JobVacancy' }
      & IElementFragment_JobVacancy_Fragment
    ) | (
      { __typename?: 'KeyFigure' }
      & IElementFragment_KeyFigure_Fragment
    ) | (
      { __typename?: 'KeyFigures' }
      & IElementFragment_KeyFigures_Fragment
    ) | (
      { __typename?: 'LandingAbout' }
      & IElementFragment_LandingAbout_Fragment
    ) | (
      { __typename?: 'LandingPage' }
      & IElementFragment_LandingPage_Fragment
    ) | (
      { __typename?: 'LearnHeroSlide' }
      & IElementFragment_LearnHeroSlide_Fragment
    ) | (
      { __typename?: 'LearnMenu' }
      & IElementFragment_LearnMenu_Fragment
    ) | (
      { __typename?: 'LegalPageLink' }
      & IElementFragment_LegalPageLink_Fragment
    ) | (
      { __typename?: 'LegalsFolder' }
      & IElementFragment_LegalsFolder_Fragment
    ) | (
      { __typename?: 'LinkIcon' }
      & IElementFragment_LinkIcon_Fragment
    ) | (
      { __typename?: 'LinkPicker' }
      & IElementFragment_LinkPicker_Fragment
    ) | (
      { __typename?: 'ListenCateg' }
      & IElementFragment_ListenCateg_Fragment
    ) | (
      { __typename?: 'LiveEvent' }
      & IElementFragment_LiveEvent_Fragment
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & IElementFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename?: 'LiveEventsPage' }
      & IElementFragment_LiveEventsPage_Fragment
    ) | (
      { __typename?: 'LiveTVPage' }
      & IElementFragment_LiveTvPage_Fragment
    ) | (
      { __typename?: 'LogoLink' }
      & IElementFragment_LogoLink_Fragment
    ) | (
      { __typename?: 'LogoSlider' }
      & IElementFragment_LogoSlider_Fragment
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & IElementFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename?: 'MemberDatas' }
      & IElementFragment_MemberDatas_Fragment
    ) | (
      { __typename?: 'MemberDownloaded' }
      & IElementFragment_MemberDownloaded_Fragment
    ) | (
      { __typename?: 'MemberMessage' }
      & IElementFragment_MemberMessage_Fragment
    ) | (
      { __typename?: 'MemberNotify' }
      & IElementFragment_MemberNotify_Fragment
    ) | (
      { __typename?: 'MemberOpportunity' }
      & IElementFragment_MemberOpportunity_Fragment
    ) | (
      { __typename?: 'MemberSaved' }
      & IElementFragment_MemberSaved_Fragment
    ) | (
      { __typename?: 'MemberSearch' }
      & IElementFragment_MemberSearch_Fragment
    ) | (
      { __typename?: 'MemberWatched' }
      & IElementFragment_MemberWatched_Fragment
    ) | (
      { __typename?: 'MembersDatas' }
      & IElementFragment_MembersDatas_Fragment
    ) | (
      { __typename?: 'MenuColumn' }
      & IElementFragment_MenuColumn_Fragment
    ) | (
      { __typename?: 'MetadatasLanguages' }
      & IElementFragment_MetadatasLanguages_Fragment
    ) | (
      { __typename?: 'MetadatasVODLanguage' }
      & IElementFragment_MetadatasVodLanguage_Fragment
    ) | (
      { __typename?: 'MetasExclusives' }
      & IElementFragment_MetasExclusives_Fragment
    ) | (
      { __typename?: 'MetasPublicationDate' }
      & IElementFragment_MetasPublicationDate_Fragment
    ) | (
      { __typename?: 'MetasTrailerCmp' }
      & IElementFragment_MetasTrailerCmp_Fragment
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & IElementFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename?: 'MultiSlider' }
      & IElementFragment_MultiSlider_Fragment
    ) | (
      { __typename?: 'MulticategoriesSlider' }
      & IElementFragment_MulticategoriesSlider_Fragment
    ) | (
      { __typename?: 'NavMessage' }
      & IElementFragment_NavMessage_Fragment
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & IElementFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & IElementFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename?: 'News' }
      & IElementFragment_News_Fragment
    ) | (
      { __typename?: 'NewsCateg' }
      & IElementFragment_NewsCateg_Fragment
    ) | (
      { __typename?: 'NewsFolder' }
      & IElementFragment_NewsFolder_Fragment
    ) | (
      { __typename?: 'NewsPage' }
      & IElementFragment_NewsPage_Fragment
    ) | (
      { __typename?: 'NuggetsTextAnswerOption' }
      & IElementFragment_NuggetsTextAnswerOption_Fragment
    ) | (
      { __typename?: 'ObtainedJob' }
      & IElementFragment_ObtainedJob_Fragment
    ) | (
      { __typename?: 'Opportunity' }
      & IElementFragment_Opportunity_Fragment
    ) | (
      { __typename?: 'OpportunityCenter' }
      & IElementFragment_OpportunityCenter_Fragment
    ) | (
      { __typename?: 'OpportunityFolder' }
      & IElementFragment_OpportunityFolder_Fragment
    ) | (
      { __typename?: 'PageSEO' }
      & IElementFragment_PageSeo_Fragment
    ) | (
      { __typename?: 'PagecontentSlider' }
      & IElementFragment_PagecontentSlider_Fragment
    ) | (
      { __typename?: 'Partner' }
      & IElementFragment_Partner_Fragment
    ) | (
      { __typename?: 'PartnerSlider' }
      & IElementFragment_PartnerSlider_Fragment
    ) | (
      { __typename?: 'Partners' }
      & IElementFragment_Partners_Fragment
    ) | (
      { __typename?: 'PartnersPage' }
      & IElementFragment_PartnersPage_Fragment
    ) | (
      { __typename?: 'Paywall' }
      & IElementFragment_Paywall_Fragment
    ) | (
      { __typename?: 'PaywallFolder' }
      & IElementFragment_PaywallFolder_Fragment
    ) | (
      { __typename?: 'PersonalityPages' }
      & IElementFragment_PersonalityPages_Fragment
    ) | (
      { __typename?: 'PersonalityPush' }
      & IElementFragment_PersonalityPush_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & IElementFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & IElementFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename?: 'PersonalityQuizQuestion' }
      & IElementFragment_PersonalityQuizQuestion_Fragment
    ) | (
      { __typename?: 'PersonalityType' }
      & IElementFragment_PersonalityType_Fragment
    ) | (
      { __typename?: 'Playlist' }
      & IElementFragment_Playlist_Fragment
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & IElementFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename?: 'Podcast' }
      & IElementFragment_Podcast_Fragment
    ) | (
      { __typename?: 'PodcastCateg' }
      & IElementFragment_PodcastCateg_Fragment
    ) | (
      { __typename?: 'PodcastItem' }
      & IElementFragment_PodcastItem_Fragment
    ) | (
      { __typename?: 'PodcastMenu' }
      & IElementFragment_PodcastMenu_Fragment
    ) | (
      { __typename?: 'PromoCode' }
      & IElementFragment_PromoCode_Fragment
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & IElementFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename?: 'Push' }
      & IElementFragment_Push_Fragment
    ) | (
      { __typename?: 'QuizItemsSlider' }
      & IElementFragment_QuizItemsSlider_Fragment
    ) | (
      { __typename?: 'QuizPage' }
      & IElementFragment_QuizPage_Fragment
    ) | (
      { __typename?: 'QuizzSurvey' }
      & IElementFragment_QuizzSurvey_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & IElementFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & IElementFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename?: 'Radio' }
      & IElementFragment_Radio_Fragment
    ) | (
      { __typename?: 'RadioCateg' }
      & IElementFragment_RadioCateg_Fragment
    ) | (
      { __typename?: 'Region' }
      & IElementFragment_Region_Fragment
    ) | (
      { __typename?: 'SectionPage' }
      & IElementFragment_SectionPage_Fragment
    ) | (
      { __typename?: 'Service' }
      & IElementFragment_Service_Fragment
    ) | (
      { __typename?: 'ServicesList' }
      & IElementFragment_ServicesList_Fragment
    ) | (
      { __typename?: 'Settings' }
      & IElementFragment_Settings_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp' }
      & IElementFragment_SettingsAccessRestrictionCmp_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp1' }
      & IElementFragment_SettingsAccessRestrictionCmp1_Fragment
    ) | (
      { __typename?: 'SettingsAccessRestrictionCmp2' }
      & IElementFragment_SettingsAccessRestrictionCmp2_Fragment
    ) | (
      { __typename?: 'SettingsDateCmp' }
      & IElementFragment_SettingsDateCmp_Fragment
    ) | (
      { __typename?: 'SettingsExternalId' }
      & IElementFragment_SettingsExternalId_Fragment
    ) | (
      { __typename?: 'Space' }
      & IElementFragment_Space_Fragment
    ) | (
      { __typename?: 'StaticPageLink' }
      & IElementFragment_StaticPageLink_Fragment
    ) | (
      { __typename?: 'Subscription' }
      & IElementFragment_Subscription_Fragment
    ) | (
      { __typename?: 'SubscriptionData' }
      & IElementFragment_SubscriptionData_Fragment
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & IElementFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & IElementFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename?: 'SubscriptionsList' }
      & IElementFragment_SubscriptionsList_Fragment
    ) | (
      { __typename?: 'SumaryNugget' }
      & IElementFragment_SumaryNugget_Fragment
    ) | (
      { __typename?: 'SummaryNuggetStatement' }
      & IElementFragment_SummaryNuggetStatement_Fragment
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & IElementFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename?: 'TextPage' }
      & IElementFragment_TextPage_Fragment
    ) | (
      { __typename?: 'TextSlide1' }
      & IElementFragment_TextSlide1_Fragment
    ) | (
      { __typename?: 'ThankYouPage' }
      & IElementFragment_ThankYouPage_Fragment
    ) | (
      { __typename?: 'TitleSlider' }
      & IElementFragment_TitleSlider_Fragment
    ) | (
      { __typename?: 'Top10Song' }
      & IElementFragment_Top10Song_Fragment
    ) | (
      { __typename?: 'TranslationContext' }
      & IElementFragment_TranslationContext_Fragment
    ) | (
      { __typename?: 'TranslationFolder' }
      & IElementFragment_TranslationFolder_Fragment
    ) | (
      { __typename?: 'TranslationItem' }
      & IElementFragment_TranslationItem_Fragment
    ) | (
      { __typename?: 'TutorialSlide' }
      & IElementFragment_TutorialSlide_Fragment
    ) | (
      { __typename?: 'UcAudio' }
      & IElementFragment_UcAudio_Fragment
    ) | (
      { __typename?: 'UcImage' }
      & IElementFragment_UcImage_Fragment
    ) | (
      { __typename?: 'UcLineBreak' }
      & IElementFragment_UcLineBreak_Fragment
    ) | (
      { __typename?: 'UcText' }
      & IElementFragment_UcText_Fragment
    ) | (
      { __typename?: 'UcVideo' }
      & IElementFragment_UcVideo_Fragment
    ) | (
      { __typename?: 'UmbracoTest' }
      & IElementFragment_UmbracoTest_Fragment
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & IElementFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & IElementFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IElementFragment_UnitNuggetGapFillAnswerItem_Fragment
    ) | (
      { __typename?: 'UnitProgression' }
      & IElementFragment_UnitProgression_Fragment
    ) | (
      { __typename?: 'VODItem' }
      & IElementFragment_VodItem_Fragment
    ) | (
      { __typename?: 'VODMenu' }
      & IElementFragment_VodMenu_Fragment
    ) | (
      { __typename?: 'ValidationElement' }
      & IElementFragment_ValidationElement_Fragment
    ) | (
      { __typename?: 'VotingFolder' }
      & IElementFragment_VotingFolder_Fragment
    ) | (
      { __typename?: 'VotingRecord' }
      & IElementFragment_VotingRecord_Fragment
    ) | (
      { __typename?: 'WatchCateg' }
      & IElementFragment_WatchCateg_Fragment
    ) | (
      { __typename?: 'WatchedContent' }
      & IElementFragment_WatchedContent_Fragment
    ) | (
      { __typename?: 'Wysiwyg' }
      & IElementFragment_Wysiwyg_Fragment
    ) }
  )>>> }
);

export type IThankYouPageFragmentFragment = (
  { __typename: 'ThankYouPage' }
  & Pick<IThankYouPage, 'url' | 'id' | 'title' | 'subtitle' | 'body'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
      { __typename?: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>>, cTA?: Maybe<Array<Maybe<(
    { __typename: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | (
      { __typename?: 'Button' }
      & IButtonFragmentFragment
    ) | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type IAllChannelQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllChannelQuery = (
  { __typename?: 'Query' }
  & { allChannel: (
    { __typename?: 'ChannelConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Channel' }
      & IChannelFragmentFragment
    )>> }
  ) }
);

export type IAllInterestPerLangQueryVariables = Exact<{ [key: string]: never; }>;


export type IAllInterestPerLangQuery = (
  { __typename?: 'Query' }
  & { frTag?: Maybe<(
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'contentTypeAlias'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name'>
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name'>
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'id' | 'name'>
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name'>
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name'>
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name'>
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name'>
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name'>
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name'>
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name'>
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name'>
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name'>
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name'>
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name'>
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'id' | 'name'>
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'id' | 'name'>
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name'>
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name'>
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name'>
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name'>
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'id' | 'name'>
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'id' | 'name'>
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'id' | 'name'>
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'id' | 'name'>
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name'>
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name'>
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name'>
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name'>
      )>> }
    ) }
  )>, enTag?: Maybe<(
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'contentTypeAlias'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name'>
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name'>
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'id' | 'name'>
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name'>
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name'>
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name'>
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name'>
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name'>
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name'>
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name'>
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name'>
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name'>
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name'>
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name'>
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'id' | 'name'>
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'id' | 'name'>
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name'>
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name'>
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name'>
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name'>
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'id' | 'name'>
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'id' | 'name'>
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'id' | 'name'>
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'id' | 'name'>
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name'>
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name'>
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name'>
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name'>
      )>> }
    ) }
  )>, ptTag?: Maybe<(
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'contentTypeAlias'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name'>
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name'>
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'id' | 'name'>
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name'>
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name'>
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name'>
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name'>
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name'>
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name'>
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name'>
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name'>
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name'>
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name'>
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name'>
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'id' | 'name'>
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'id' | 'name'>
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name'>
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name'>
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name'>
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name'>
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'id' | 'name'>
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'id' | 'name'>
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'id' | 'name'>
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'id' | 'name'>
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name'>
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name'>
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name'>
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name'>
      )>> }
    ) }
  )> }
);

export type IAllLiveEventQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllLiveEventQuery = (
  { __typename?: 'Query' }
  & { allLiveEvent: (
    { __typename?: 'LiveEventConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'LiveEvent' }
      & ILiveEventFragmentFragment
    )>> }
  ) }
);

export type IAllMusicGenrePerLangQueryVariables = Exact<{ [key: string]: never; }>;


export type IAllMusicGenrePerLangQuery = (
  { __typename?: 'Query' }
  & { frTag?: Maybe<(
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'contentTypeAlias'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name'>
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name'>
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'id' | 'name'>
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name'>
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name'>
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name'>
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name'>
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name'>
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name'>
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name'>
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name'>
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name'>
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name'>
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name'>
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'id' | 'name'>
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'id' | 'name'>
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name'>
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name'>
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name'>
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name'>
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'id' | 'name'>
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'id' | 'name'>
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'id' | 'name'>
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'id' | 'name'>
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name'>
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name'>
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name'>
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name'>
      )>> }
    ) }
  )>, enTag?: Maybe<(
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'contentTypeAlias'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name'>
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name'>
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'id' | 'name'>
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name'>
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name'>
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name'>
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name'>
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name'>
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name'>
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name'>
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name'>
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name'>
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name'>
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name'>
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'id' | 'name'>
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'id' | 'name'>
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name'>
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name'>
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name'>
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name'>
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'id' | 'name'>
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'id' | 'name'>
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'id' | 'name'>
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'id' | 'name'>
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name'>
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name'>
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name'>
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name'>
      )>> }
    ) }
  )>, ptTag?: Maybe<(
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'contentTypeAlias'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'name'>
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'name'>
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'id' | 'name'>
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'name'>
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'name'>
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'name'>
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'name'>
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'name'>
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'id' | 'name'>
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'name'>
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'id' | 'name'>
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'name'>
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'name'>
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'name'>
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'name'>
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'name'>
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'name'>
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'name'>
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'name'>
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'name'>
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'name'>
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'id' | 'name'>
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'id' | 'name'>
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'id' | 'name'>
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'name'>
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'name'>
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'name'>
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'name'>
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'name'>
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'name'>
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'name'>
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'id' | 'name'>
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'name'>
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'id' | 'name'>
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'name'>
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'id' | 'name'>
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'id' | 'name'>
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'name'>
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'id' | 'name'>
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'name'>
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'name'>
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'id' | 'name'>
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'name'>
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'name'>
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'name'>
      )>> }
    ) }
  )> }
);

export type IAllTranslationFolderQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IAllTranslationFolderQuery = (
  { __typename?: 'Query' }
  & { allTranslationFolder: (
    { __typename?: 'TranslationFolderConnection' }
    & { items: Array<Maybe<(
      { __typename: 'TranslationFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | (
          { __typename: 'TranslationContext' }
          & Pick<ITranslationContext, 'id' | 'name'>
          & { children: (
            { __typename?: 'ContentConnection' }
            & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | (
              { __typename?: 'TranslationItem' }
              & ITranslationItemFragmentFragment
            ) | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
          ) }
        ) | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    )>> }
  ) }
);

export type IAppVersionQueryQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAppVersionQueryQuery = (
  { __typename?: 'Query' }
  & { settings?: Maybe<(
    { __typename?: 'Settings' }
    & ISettingsFragmentFragment
  )> }
);

export type IArtistServiceByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IArtistServiceByUrlQuery = (
  { __typename?: 'Query' }
  & { artistService?: Maybe<(
    { __typename: 'ArtistService' }
    & IArtistServiceFragmentFragment
  )> }
);

export type IArtistServiceByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IArtistServiceByIdQuery = (
  { __typename?: 'Query' }
  & { artistService?: Maybe<(
    { __typename: 'ArtistService' }
    & IArtistServiceFragmentFragment
  )> }
);

export type IAristServiceByIdQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAristServiceByIdQuery = (
  { __typename?: 'Query' }
  & { allContent: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id' | 'title' | 'subtitle'>
    ) | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ) }
);

export type IArtistServicesPageByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IArtistServicesPageByUrlQuery = (
  { __typename?: 'Query' }
  & { artistServicesPage?: Maybe<(
    { __typename?: 'ArtistServicesPage' }
    & IArtistServicesPageFragmentFragment
  )> }
);

export type IArtistServicesPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IArtistServicesPageByIdQuery = (
  { __typename?: 'Query' }
  & { artistServicesPage?: Maybe<(
    { __typename?: 'ArtistServicesPage' }
    & IArtistServicesPageFragmentFragment
  )> }
);

export type IAwardsArtistByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAwardsArtistByIdQuery = (
  { __typename?: 'Query' }
  & { awardsArtist?: Maybe<(
    { __typename?: 'AwardsArtist' }
    & IAwardsArtistFragmentFragment
  )> }
);

export type IAwardsArtistByNameQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAwardsArtistByNameQuery = (
  { __typename?: 'Query' }
  & { allAwardsArtist: (
    { __typename?: 'AwardsArtistConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'AwardsArtist' }
      & IAwardsArtistFragmentFragment
    )>> }
  ) }
);

export type IAwardCategoryPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAwardCategoryPageByIdQuery = (
  { __typename?: 'Query' }
  & { awardCategoryPage?: Maybe<(
    { __typename?: 'AwardCategoryPage' }
    & IAwardCategoryPageFragmentFragment
  )> }
);

export type IAwardHomePageByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAwardHomePageByUrlQuery = (
  { __typename?: 'Query' }
  & { awardsHomepage?: Maybe<(
    { __typename?: 'AwardsHomepage' }
    & IAwardHomePageFragmentFragment
  )> }
);

export type IAwardHomePageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAwardHomePageByIdQuery = (
  { __typename?: 'Query' }
  & { awardsHomepage?: Maybe<(
    { __typename?: 'AwardsHomepage' }
    & IAwardHomePageFragmentFragment
  )> }
);

export type IAwardSettingsFragmentFragment = (
  { __typename: 'AwardsHomepage' }
  & Pick<IAwardsHomepage, 'id' | 'urlRewrite' | 'metaTitle' | 'metaDescription' | 'formTitle' | 'formLabel' | 'formIntroduction' | 'form'>
  & { logo?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, backgroundImage?: Maybe<(
    { __typename?: 'MediaWithCrops' }
    & { url: IMediaWithCrops['cropUrl'] }
  )>, comingSoonPage?: Maybe<(
    { __typename?: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename?: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename?: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename?: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename?: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename?: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename?: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename?: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename?: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename?: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename?: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename?: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename?: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename?: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename?: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename?: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename?: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename?: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename?: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename?: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename?: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename?: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename?: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename?: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename?: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename?: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename?: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename?: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename?: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename?: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename?: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename?: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename?: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename?: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename?: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename?: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename?: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename?: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename?: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename?: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename?: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename?: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename?: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename?: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename?: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename?: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename?: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename?: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename?: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename?: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename?: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename?: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename?: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename?: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename?: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename?: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename?: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename?: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename?: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename?: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename?: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename?: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename?: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename?: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename?: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename?: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename?: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename?: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename?: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename?: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename?: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename?: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename?: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename?: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename?: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename?: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename?: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename?: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename?: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename?: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename?: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename?: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename?: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename?: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename?: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename?: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename?: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename?: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename?: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename?: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename?: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )> }
);

export type IAwardSettingsQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAwardSettingsQuery = (
  { __typename?: 'Query' }
  & { allAwardsHomepage: (
    { __typename?: 'AwardsHomepageConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'AwardsHomepage' }
      & IAwardSettingsFragmentFragment
    )>> }
  ) }
);

export type ICgvQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
}>;


export type ICgvQuery = (
  { __typename?: 'Query' }
  & { allSettings: (
    { __typename?: 'SettingsConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Settings' }
      & { termsConditions?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | (
        { __typename: 'TextPage' }
        & ITextPageFragmentFragment
      ) | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, privacyPolicies?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | (
        { __typename: 'TextPage' }
        & ITextPageFragmentFragment
      ) | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
    )>> }
  ) }
);

export type IAllCategoryMenuQueryVariables = Exact<{
  contentTypeAlias?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IAllCategoryMenuQuery = (
  { __typename?: 'Query' }
  & { allCategoryPage: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id' | 'name' | 'url'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id' | 'name' | 'url' | 'isExpand'>
    )>> }
  ) }
);

export type IAllRegionCategoryTagsQueryVariables = Exact<{
  id: Scalars['ID'];
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IAllRegionCategoryTagsQuery = (
  { __typename?: 'Query' }
  & { content?: Maybe<(
    { __typename?: 'ArtistService' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'AwardsArtist' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'AwardsHomepage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CMSPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CategBgColor' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CategoryPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Channel' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ChannelFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ChoiceNugget' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Collection' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ContentTag' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ContentTags' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Course' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CourseCategory' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CourseExam' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CourseShare' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CourseStatus' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CourseTestProgression' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'CourseUnit' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Discovery' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'FormFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'FormPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'GapfillNugget' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'HelpdeskPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'HomePage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobBoardPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobHub' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobHubsFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobProgress' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobShare' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobTraining' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'JobVacancy' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'LandingPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'LearnMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'LegalsFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ListenCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'LiveEvent' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'LiveEventsPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'LiveTVPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberDatas' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberDownloaded' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberMessage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberNotify' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberOpportunity' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberSaved' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberSearch' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MemberWatched' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MembersDatas' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'NavMessage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'News' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'NewsCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'NewsFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'NewsPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ObtainedJob' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Opportunity' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'OpportunityCenter' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'OpportunityFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Partner' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Partners' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PartnersPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Paywall' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PaywallFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PersonalityPages' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PersonalityType' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Playlist' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Podcast' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PodcastCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PodcastItem' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PodcastMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PromoCode' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'QuizPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'QuizzSurvey' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Radio' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'RadioCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Region' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'SectionPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Settings' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Space' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'Subscription' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'SubscriptionData' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'SumaryNugget' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'TextPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'ThankYouPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'TranslationContext' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'TranslationFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'TranslationItem' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'UmbracoTest' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'UnitProgression' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'VODItem' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'VODMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'VotingFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'VotingRecord' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  ) | (
    { __typename?: 'WatchCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | (
        { __typename?: 'ContentTag' }
        & IContentTagFragmentFragment
      ) | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  )> }
);

export type ICategoryChildrenByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<InputMaybe<IContentOrderByInput>> | InputMaybe<IContentOrderByInput>>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICategoryChildrenByIdQuery = (
  { __typename?: 'Query' }
  & { category?: Maybe<(
    { __typename?: 'ArtistService' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'AwardsArtist' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'AwardsHomepage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CMSPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CategBgColor' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CategoryPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Channel' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ChannelFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ChoiceNugget' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Collection' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ContentTag' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ContentTags' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Course' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CourseCategory' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CourseExam' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CourseShare' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CourseStatus' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CourseTestProgression' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'CourseUnit' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Discovery' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'FormFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'FormPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'GapfillNugget' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'HelpdeskPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'HomePage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobBoardPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobHub' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobHubsFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobProgress' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobShare' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobTraining' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'JobVacancy' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'LandingPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'LearnMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'LegalsFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ListenCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'LiveEvent' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'LiveEventsPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'LiveTVPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberDatas' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberDownloaded' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberMessage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberNotify' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberOpportunity' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberSaved' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberSearch' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MemberWatched' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MembersDatas' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'NavMessage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'News' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'NewsCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'NewsFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'NewsPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ObtainedJob' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Opportunity' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'OpportunityCenter' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'OpportunityFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Partner' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Partners' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PartnersPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Paywall' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PaywallFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PersonalityPages' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PersonalityType' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Playlist' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Podcast' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PodcastCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PodcastItem' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PodcastMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PromoCode' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'QuizPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'QuizzSurvey' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Radio' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'RadioCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Region' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'SectionPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Settings' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Space' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'Subscription' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'SubscriptionData' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'SumaryNugget' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'TextPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'ThankYouPage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'TranslationContext' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'TranslationFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'TranslationItem' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'UmbracoTest' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'UnitProgression' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'VODItem' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'VODMenu' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'VotingFolder' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'VotingRecord' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  ) | (
    { __typename?: 'WatchCateg' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { edges: Array<Maybe<(
        { __typename?: 'ContentEdge' }
        & Pick<IContentEdge, 'cursor'>
        & { node?: Maybe<(
          { __typename?: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename?: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename?: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename?: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename?: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename?: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename?: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename?: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename?: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename?: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename?: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename?: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename?: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename?: 'Collection' }
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename?: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename?: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename?: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename?: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename?: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename?: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename?: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename?: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename?: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename?: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename?: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename?: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename?: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename?: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename?: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename?: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename?: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename?: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename?: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename?: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename?: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename?: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename?: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename?: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename?: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename?: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename?: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename?: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename?: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename?: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename?: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename?: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename?: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename?: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename?: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename?: 'LiveEvent' }
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename?: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename?: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename?: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename?: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename?: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename?: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename?: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename?: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename?: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename?: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename?: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename?: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename?: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename?: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename?: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename?: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename?: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename?: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename?: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename?: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename?: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename?: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename?: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename?: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename?: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename?: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename?: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename?: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename?: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename?: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename?: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename?: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename?: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename?: 'Playlist' }
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename?: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename?: 'Podcast' }
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename?: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename?: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename?: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename?: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename?: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename?: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename?: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename?: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename?: 'Radio' }
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename?: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename?: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename?: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename?: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename?: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename?: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename?: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename?: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename?: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename?: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename?: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename?: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename?: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename?: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename?: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename?: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename?: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename?: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename?: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename?: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename?: 'VODItem' }
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename?: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename?: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename?: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename?: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )> }
      )>>, pageInfo: (
        { __typename: 'PageInfo' }
        & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
      ) }
    ) }
  )> }
);

export type INewsConnectionFragmentFragment = (
  { __typename?: 'NewsConnection' }
  & { edges: Array<Maybe<(
    { __typename?: 'NewsEdge' }
    & Pick<INewsEdge, 'cursor'>
    & { node?: Maybe<(
      { __typename?: 'News' }
      & INewsFragmentFragment
    )> }
  )>>, pageInfo: (
    { __typename: 'PageInfo' }
    & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
  ) }
);

export type INewsCategoryByUrlQueryVariables = Exact<{
  categoryUrl?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<InputMaybe<INewsOrderByInput>> | InputMaybe<INewsOrderByInput>>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type INewsCategoryByUrlQuery = (
  { __typename?: 'Query' }
  & { category: (
    { __typename?: 'NewsConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'NewsEdge' }
      & Pick<INewsEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'News' }
        & INewsFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type INewsCategoryByUrlWithRegionQueryVariables = Exact<{
  categoryUrl?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<InputMaybe<INewsOrderByInput>> | InputMaybe<INewsOrderByInput>>;
  regionTag?: InputMaybe<Scalars['ID']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type INewsCategoryByUrlWithRegionQuery = (
  { __typename?: 'Query' }
  & { category: (
    { __typename?: 'NewsConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'NewsEdge' }
      & Pick<INewsEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'News' }
        & INewsFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename: 'PageInfo' }
      & Pick<IPageInfo, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type IRelatedCAtegoryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  url_starts_with?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IRelatedCAtegoryQuery = (
  { __typename?: 'Query' }
  & { allCategoryPage: (
    { __typename?: 'CategoryPageConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'CategoryPage' }
      & ICategoryPageFragmentFragment
    )>> }
  ) }
);

export type IVodItemRelatedContentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IVodItemRelatedContentQuery = (
  { __typename?: 'Query' }
  & { vODItem?: Maybe<(
    { __typename: 'VODItem' }
    & { parent?: Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<(
          { __typename: 'ArtistService' }
          & Pick<IArtistService, 'name' | 'url'>
        ) | (
          { __typename: 'ArtistServiceFolder' }
          & Pick<IArtistServiceFolder, 'name' | 'url'>
        ) | (
          { __typename: 'ArtistServicesPage' }
          & Pick<IArtistServicesPage, 'name' | 'url'>
        ) | (
          { __typename: 'AwardCategoryPage' }
          & Pick<IAwardCategoryPage, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsArtist' }
          & Pick<IAwardsArtist, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsCategoryMenu' }
          & Pick<IAwardsCategoryMenu, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsCategoryMenuDev' }
          & Pick<IAwardsCategoryMenuDev, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolder' }
          & Pick<IAwardsCategoryMenuFolder, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolderDev' }
          & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsHomepage' }
          & Pick<IAwardsHomepage, 'name' | 'url'>
        ) | (
          { __typename: 'CMSPage' }
          & Pick<ICmsPage, 'name' | 'url'>
        ) | (
          { __typename: 'CategBgColor' }
          & Pick<ICategBgColor, 'name' | 'url'>
        ) | (
          { __typename: 'CategoryPage' }
          & Pick<ICategoryPage, 'name' | 'url'>
        ) | (
          { __typename: 'Channel' }
          & Pick<IChannel, 'name' | 'url'>
        ) | (
          { __typename: 'ChannelFolder' }
          & Pick<IChannelFolder, 'name' | 'url'>
        ) | (
          { __typename: 'ChoiceNugget' }
          & Pick<IChoiceNugget, 'name' | 'url'>
        ) | (
          { __typename: 'Collection' }
          & Pick<ICollection, 'name' | 'url'>
        ) | (
          { __typename: 'ContentEditorFolder' }
          & Pick<IContentEditorFolder, 'name' | 'url'>
        ) | (
          { __typename: 'ContentTag' }
          & Pick<IContentTag, 'name' | 'url'>
        ) | (
          { __typename: 'ContentTags' }
          & Pick<IContentTags, 'name' | 'url'>
        ) | (
          { __typename: 'ContentTagsCateg' }
          & Pick<IContentTagsCateg, 'name' | 'url'>
        ) | (
          { __typename: 'Course' }
          & Pick<ICourse, 'name' | 'url'>
        ) | (
          { __typename: 'CourseCategoriesFolder' }
          & Pick<ICourseCategoriesFolder, 'name' | 'url'>
        ) | (
          { __typename: 'CourseCategory' }
          & Pick<ICourseCategory, 'name' | 'url'>
        ) | (
          { __typename: 'CourseExam' }
          & Pick<ICourseExam, 'name' | 'url'>
        ) | (
          { __typename: 'CourseShare' }
          & Pick<ICourseShare, 'name' | 'url'>
        ) | (
          { __typename: 'CourseStatus' }
          & Pick<ICourseStatus, 'name' | 'url'>
        ) | (
          { __typename: 'CourseTestProgression' }
          & Pick<ICourseTestProgression, 'name' | 'url'>
        ) | (
          { __typename: 'CourseUnit' }
          & Pick<ICourseUnit, 'name' | 'url'>
        ) | (
          { __typename: 'Discovery' }
          & Pick<IDiscovery, 'name' | 'url'>
        ) | (
          { __typename: 'DiscoverySlide1' }
          & Pick<IDiscoverySlide1, 'name' | 'url'>
        ) | (
          { __typename: 'EntrepreunarialHub' }
          & Pick<IEntrepreunarialHub, 'name' | 'url'>
        ) | (
          { __typename: 'FormFolder' }
          & Pick<IFormFolder, 'name' | 'url'>
        ) | (
          { __typename: 'FormPage' }
          & Pick<IFormPage, 'name' | 'url'>
        ) | (
          { __typename: 'GapfillNugget' }
          & Pick<IGapfillNugget, 'name' | 'url'>
        ) | (
          { __typename: 'HelpdeskCateg' }
          & Pick<IHelpdeskCateg, 'name' | 'url'>
        ) | (
          { __typename: 'HelpdeskFolder' }
          & Pick<IHelpdeskFolder, 'name' | 'url'>
        ) | (
          { __typename: 'HelpdeskPage' }
          & Pick<IHelpdeskPage, 'name' | 'url'>
        ) | (
          { __typename: 'HomePage' }
          & Pick<IHomePage, 'name' | 'url'>
        ) | (
          { __typename: 'JobBoardPage' }
          & Pick<IJobBoardPage, 'name' | 'url'>
        ) | (
          { __typename: 'JobHub' }
          & Pick<IJobHub, 'name' | 'url'>
        ) | (
          { __typename: 'JobHubsFolder' }
          & Pick<IJobHubsFolder, 'name' | 'url'>
        ) | (
          { __typename: 'JobProgress' }
          & Pick<IJobProgress, 'name' | 'url'>
        ) | (
          { __typename: 'JobShare' }
          & Pick<IJobShare, 'name' | 'url'>
        ) | (
          { __typename: 'JobTraining' }
          & Pick<IJobTraining, 'name' | 'url'>
        ) | (
          { __typename: 'JobTrainingFolder' }
          & Pick<IJobTrainingFolder, 'name' | 'url'>
        ) | (
          { __typename: 'JobVacanciesFolder' }
          & Pick<IJobVacanciesFolder, 'name' | 'url'>
        ) | (
          { __typename: 'JobVacancy' }
          & Pick<IJobVacancy, 'name' | 'url'>
        ) | (
          { __typename: 'LandingPage' }
          & Pick<ILandingPage, 'name' | 'url'>
        ) | (
          { __typename: 'LearnMenu' }
          & Pick<ILearnMenu, 'name' | 'url'>
        ) | (
          { __typename: 'LegalsFolder' }
          & Pick<ILegalsFolder, 'name' | 'url'>
        ) | (
          { __typename: 'ListenCateg' }
          & Pick<IListenCateg, 'name' | 'url'>
        ) | (
          { __typename: 'LiveEvent' }
          & Pick<ILiveEvent, 'name' | 'url'>
        ) | (
          { __typename: 'LiveEventsMenu' }
          & Pick<ILiveEventsMenu, 'name' | 'url'>
        ) | (
          { __typename: 'LiveEventsPage' }
          & Pick<ILiveEventsPage, 'name' | 'url'>
        ) | (
          { __typename: 'LiveTVPage' }
          & Pick<ILiveTvPage, 'name' | 'url'>
        ) | (
          { __typename: 'MemberContentTypesLink' }
          & Pick<IMemberContentTypesLink, 'name' | 'url'>
        ) | (
          { __typename: 'MemberDatas' }
          & Pick<IMemberDatas, 'name' | 'url'>
        ) | (
          { __typename: 'MemberDownloaded' }
          & Pick<IMemberDownloaded, 'name' | 'url'>
        ) | (
          { __typename: 'MemberMessage' }
          & Pick<IMemberMessage, 'name' | 'url'>
        ) | (
          { __typename: 'MemberNotify' }
          & Pick<IMemberNotify, 'name' | 'url'>
        ) | (
          { __typename: 'MemberOpportunity' }
          & Pick<IMemberOpportunity, 'name' | 'url'>
        ) | (
          { __typename: 'MemberSaved' }
          & Pick<IMemberSaved, 'name' | 'url'>
        ) | (
          { __typename: 'MemberSearch' }
          & Pick<IMemberSearch, 'name' | 'url'>
        ) | (
          { __typename: 'MemberWatched' }
          & Pick<IMemberWatched, 'name' | 'url'>
        ) | (
          { __typename: 'MembersDatas' }
          & Pick<IMembersDatas, 'name' | 'url'>
        ) | (
          { __typename: 'MiniSitesFolder' }
          & Pick<IMiniSitesFolder, 'name' | 'url'>
        ) | (
          { __typename: 'NavMessage' }
          & Pick<INavMessage, 'name' | 'url'>
        ) | (
          { __typename: 'NavigationMessagesFolder' }
          & Pick<INavigationMessagesFolder, 'name' | 'url'>
        ) | (
          { __typename: 'NetlifyDeploy' }
          & Pick<INetlifyDeploy, 'name' | 'url'>
        ) | (
          { __typename: 'News' }
          & Pick<INews, 'name' | 'url'>
        ) | (
          { __typename: 'NewsCateg' }
          & Pick<INewsCateg, 'name' | 'url'>
        ) | (
          { __typename: 'NewsFolder' }
          & Pick<INewsFolder, 'name' | 'url'>
        ) | (
          { __typename: 'NewsPage' }
          & Pick<INewsPage, 'name' | 'url'>
        ) | (
          { __typename: 'ObtainedJob' }
          & Pick<IObtainedJob, 'name' | 'url'>
        ) | (
          { __typename: 'Opportunity' }
          & Pick<IOpportunity, 'name' | 'url'>
        ) | (
          { __typename: 'OpportunityCenter' }
          & Pick<IOpportunityCenter, 'name' | 'url'>
        ) | (
          { __typename: 'OpportunityFolder' }
          & Pick<IOpportunityFolder, 'name' | 'url'>
        ) | (
          { __typename: 'Partner' }
          & Pick<IPartner, 'name' | 'url'>
        ) | (
          { __typename: 'Partners' }
          & Pick<IPartners, 'name' | 'url'>
        ) | (
          { __typename: 'PartnersPage' }
          & Pick<IPartnersPage, 'name' | 'url'>
        ) | (
          { __typename: 'Paywall' }
          & Pick<IPaywall, 'name' | 'url'>
        ) | (
          { __typename: 'PaywallFolder' }
          & Pick<IPaywallFolder, 'name' | 'url'>
        ) | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'name' | 'url'>
        ) | (
          { __typename: 'PersonalityQuiz' }
          & Pick<IPersonalityQuiz, 'name' | 'url'>
        ) | (
          { __typename: 'PersonalityQuiz1' }
          & Pick<IPersonalityQuiz1, 'name' | 'url'>
        ) | (
          { __typename: 'PersonalityType' }
          & Pick<IPersonalityType, 'name' | 'url'>
        ) | (
          { __typename: 'Playlist' }
          & Pick<IPlaylist, 'name' | 'url'>
        ) | (
          { __typename: 'PlaylistRadioMenu' }
          & Pick<IPlaylistRadioMenu, 'name' | 'url'>
        ) | (
          { __typename: 'Podcast' }
          & Pick<IPodcast, 'name' | 'url'>
        ) | (
          { __typename: 'PodcastCateg' }
          & Pick<IPodcastCateg, 'name' | 'url'>
        ) | (
          { __typename: 'PodcastItem' }
          & Pick<IPodcastItem, 'name' | 'url'>
        ) | (
          { __typename: 'PodcastMenu' }
          & Pick<IPodcastMenu, 'name' | 'url'>
        ) | (
          { __typename: 'PromoCode' }
          & Pick<IPromoCode, 'name' | 'url'>
        ) | (
          { __typename: 'PromoCodeFolder' }
          & Pick<IPromoCodeFolder, 'name' | 'url'>
        ) | (
          { __typename: 'QuizPage' }
          & Pick<IQuizPage, 'name' | 'url'>
        ) | (
          { __typename: 'QuizzSurvey' }
          & Pick<IQuizzSurvey, 'name' | 'url'>
        ) | (
          { __typename: 'QuizzSurveyCategory' }
          & Pick<IQuizzSurveyCategory, 'name' | 'url'>
        ) | (
          { __typename: 'QuizzSurveyCollection' }
          & Pick<IQuizzSurveyCollection, 'name' | 'url'>
        ) | (
          { __typename: 'Radio' }
          & Pick<IRadio, 'name' | 'url'>
        ) | (
          { __typename: 'RadioCateg' }
          & Pick<IRadioCateg, 'name' | 'url'>
        ) | (
          { __typename: 'Region' }
          & Pick<IRegion, 'name' | 'url'>
        ) | (
          { __typename: 'SectionPage' }
          & Pick<ISectionPage, 'name' | 'url'>
        ) | (
          { __typename: 'Settings' }
          & Pick<ISettings, 'name' | 'url'>
        ) | (
          { __typename: 'Space' }
          & Pick<ISpace, 'name' | 'url'>
        ) | (
          { __typename: 'Subscription' }
          & Pick<ISubscription, 'name' | 'url'>
        ) | (
          { __typename: 'SubscriptionData' }
          & Pick<ISubscriptionData, 'name' | 'url'>
        ) | (
          { __typename: 'SubscriptionDataFolder' }
          & Pick<ISubscriptionDataFolder, 'name' | 'url'>
        ) | (
          { __typename: 'SubscriptionsFolder' }
          & Pick<ISubscriptionsFolder, 'name' | 'url'>
        ) | (
          { __typename: 'SumaryNugget' }
          & Pick<ISumaryNugget, 'name' | 'url'>
        ) | (
          { __typename: 'SurveyQuizzFolder' }
          & Pick<ISurveyQuizzFolder, 'name' | 'url'>
        ) | (
          { __typename: 'TextPage' }
          & Pick<ITextPage, 'name' | 'url'>
        ) | (
          { __typename: 'ThankYouPage' }
          & Pick<IThankYouPage, 'name' | 'url'>
        ) | (
          { __typename: 'TranslationContext' }
          & Pick<ITranslationContext, 'name' | 'url'>
        ) | (
          { __typename: 'TranslationFolder' }
          & Pick<ITranslationFolder, 'name' | 'url'>
        ) | (
          { __typename: 'TranslationItem' }
          & Pick<ITranslationItem, 'name' | 'url'>
        ) | (
          { __typename: 'UmbracoTest' }
          & Pick<IUmbracoTest, 'name' | 'url'>
        ) | (
          { __typename: 'UnitNuggetAnswer' }
          & Pick<IUnitNuggetAnswer, 'name' | 'url'>
        ) | (
          { __typename: 'UnitNuggetGapFillAnswer' }
          & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url'>
        ) | (
          { __typename: 'UnitProgression' }
          & Pick<IUnitProgression, 'name' | 'url'>
        ) | (
          { __typename: 'VODItem' }
          & Pick<IVodItem, 'name' | 'url'>
          & IVodItemFragmentFragment
        ) | (
          { __typename: 'VODMenu' }
          & Pick<IVodMenu, 'name' | 'url'>
        ) | (
          { __typename: 'VotingFolder' }
          & Pick<IVotingFolder, 'name' | 'url'>
        ) | (
          { __typename: 'VotingRecord' }
          & Pick<IVotingRecord, 'name' | 'url'>
        ) | (
          { __typename: 'WatchCateg' }
          & Pick<IWatchCateg, 'name' | 'url'>
        )>> }
      ) }
      & ICollectionFragmentFragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id' | 'url' | 'name' | 'backgroundColor'>
      & { children: (
        { __typename: 'ContentConnection' }
        & { items: Array<Maybe<(
          { __typename: 'ArtistService' }
          & IMainContentListFragment_ArtistService_Fragment
        ) | (
          { __typename: 'ArtistServiceFolder' }
          & IMainContentListFragment_ArtistServiceFolder_Fragment
        ) | (
          { __typename: 'ArtistServicesPage' }
          & IMainContentListFragment_ArtistServicesPage_Fragment
        ) | (
          { __typename: 'AwardCategoryPage' }
          & IMainContentListFragment_AwardCategoryPage_Fragment
        ) | (
          { __typename: 'AwardsArtist' }
          & IMainContentListFragment_AwardsArtist_Fragment
        ) | (
          { __typename: 'AwardsCategoryMenu' }
          & IMainContentListFragment_AwardsCategoryMenu_Fragment
        ) | (
          { __typename: 'AwardsCategoryMenuDev' }
          & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
        ) | (
          { __typename: 'AwardsCategoryMenuFolder' }
          & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
        ) | (
          { __typename: 'AwardsCategoryMenuFolderDev' }
          & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
        ) | (
          { __typename: 'AwardsHomepage' }
          & IMainContentListFragment_AwardsHomepage_Fragment
        ) | (
          { __typename: 'CMSPage' }
          & IMainContentListFragment_CmsPage_Fragment
        ) | (
          { __typename: 'CategBgColor' }
          & IMainContentListFragment_CategBgColor_Fragment
        ) | (
          { __typename: 'CategoryPage' }
          & IMainContentListFragment_CategoryPage_Fragment
        ) | (
          { __typename: 'Channel' }
          & IMainContentListFragment_Channel_Fragment
        ) | (
          { __typename: 'ChannelFolder' }
          & IMainContentListFragment_ChannelFolder_Fragment
        ) | (
          { __typename: 'ChoiceNugget' }
          & IMainContentListFragment_ChoiceNugget_Fragment
        ) | (
          { __typename: 'Collection' }
          & Pick<ICollection, 'title' | 'subtitle' | 'countriesRestriction'>
          & IMainContentListFragment_Collection_Fragment
        ) | (
          { __typename: 'ContentEditorFolder' }
          & IMainContentListFragment_ContentEditorFolder_Fragment
        ) | (
          { __typename: 'ContentTag' }
          & IMainContentListFragment_ContentTag_Fragment
        ) | (
          { __typename: 'ContentTags' }
          & IMainContentListFragment_ContentTags_Fragment
        ) | (
          { __typename: 'ContentTagsCateg' }
          & IMainContentListFragment_ContentTagsCateg_Fragment
        ) | (
          { __typename: 'Course' }
          & IMainContentListFragment_Course_Fragment
        ) | (
          { __typename: 'CourseCategoriesFolder' }
          & IMainContentListFragment_CourseCategoriesFolder_Fragment
        ) | (
          { __typename: 'CourseCategory' }
          & IMainContentListFragment_CourseCategory_Fragment
        ) | (
          { __typename: 'CourseExam' }
          & IMainContentListFragment_CourseExam_Fragment
        ) | (
          { __typename: 'CourseShare' }
          & IMainContentListFragment_CourseShare_Fragment
        ) | (
          { __typename: 'CourseStatus' }
          & IMainContentListFragment_CourseStatus_Fragment
        ) | (
          { __typename: 'CourseTestProgression' }
          & IMainContentListFragment_CourseTestProgression_Fragment
        ) | (
          { __typename: 'CourseUnit' }
          & IMainContentListFragment_CourseUnit_Fragment
        ) | (
          { __typename: 'Discovery' }
          & IMainContentListFragment_Discovery_Fragment
        ) | (
          { __typename: 'DiscoverySlide1' }
          & IMainContentListFragment_DiscoverySlide1_Fragment
        ) | (
          { __typename: 'EntrepreunarialHub' }
          & IMainContentListFragment_EntrepreunarialHub_Fragment
        ) | (
          { __typename: 'FormFolder' }
          & IMainContentListFragment_FormFolder_Fragment
        ) | (
          { __typename: 'FormPage' }
          & IMainContentListFragment_FormPage_Fragment
        ) | (
          { __typename: 'GapfillNugget' }
          & IMainContentListFragment_GapfillNugget_Fragment
        ) | (
          { __typename: 'HelpdeskCateg' }
          & IMainContentListFragment_HelpdeskCateg_Fragment
        ) | (
          { __typename: 'HelpdeskFolder' }
          & IMainContentListFragment_HelpdeskFolder_Fragment
        ) | (
          { __typename: 'HelpdeskPage' }
          & IMainContentListFragment_HelpdeskPage_Fragment
        ) | (
          { __typename: 'HomePage' }
          & IMainContentListFragment_HomePage_Fragment
        ) | (
          { __typename: 'JobBoardPage' }
          & IMainContentListFragment_JobBoardPage_Fragment
        ) | (
          { __typename: 'JobHub' }
          & IMainContentListFragment_JobHub_Fragment
        ) | (
          { __typename: 'JobHubsFolder' }
          & IMainContentListFragment_JobHubsFolder_Fragment
        ) | (
          { __typename: 'JobProgress' }
          & IMainContentListFragment_JobProgress_Fragment
        ) | (
          { __typename: 'JobShare' }
          & IMainContentListFragment_JobShare_Fragment
        ) | (
          { __typename: 'JobTraining' }
          & IMainContentListFragment_JobTraining_Fragment
        ) | (
          { __typename: 'JobTrainingFolder' }
          & IMainContentListFragment_JobTrainingFolder_Fragment
        ) | (
          { __typename: 'JobVacanciesFolder' }
          & IMainContentListFragment_JobVacanciesFolder_Fragment
        ) | (
          { __typename: 'JobVacancy' }
          & IMainContentListFragment_JobVacancy_Fragment
        ) | (
          { __typename: 'LandingPage' }
          & IMainContentListFragment_LandingPage_Fragment
        ) | (
          { __typename: 'LearnMenu' }
          & IMainContentListFragment_LearnMenu_Fragment
        ) | (
          { __typename: 'LegalsFolder' }
          & IMainContentListFragment_LegalsFolder_Fragment
        ) | (
          { __typename: 'ListenCateg' }
          & IMainContentListFragment_ListenCateg_Fragment
        ) | (
          { __typename: 'LiveEvent' }
          & Pick<ILiveEvent, 'title' | 'subtitle' | 'countriesRestriction'>
          & IMainContentListFragment_LiveEvent_Fragment
        ) | (
          { __typename: 'LiveEventsMenu' }
          & IMainContentListFragment_LiveEventsMenu_Fragment
        ) | (
          { __typename: 'LiveEventsPage' }
          & IMainContentListFragment_LiveEventsPage_Fragment
        ) | (
          { __typename: 'LiveTVPage' }
          & IMainContentListFragment_LiveTvPage_Fragment
        ) | (
          { __typename: 'MemberContentTypesLink' }
          & IMainContentListFragment_MemberContentTypesLink_Fragment
        ) | (
          { __typename: 'MemberDatas' }
          & IMainContentListFragment_MemberDatas_Fragment
        ) | (
          { __typename: 'MemberDownloaded' }
          & IMainContentListFragment_MemberDownloaded_Fragment
        ) | (
          { __typename: 'MemberMessage' }
          & IMainContentListFragment_MemberMessage_Fragment
        ) | (
          { __typename: 'MemberNotify' }
          & IMainContentListFragment_MemberNotify_Fragment
        ) | (
          { __typename: 'MemberOpportunity' }
          & IMainContentListFragment_MemberOpportunity_Fragment
        ) | (
          { __typename: 'MemberSaved' }
          & IMainContentListFragment_MemberSaved_Fragment
        ) | (
          { __typename: 'MemberSearch' }
          & IMainContentListFragment_MemberSearch_Fragment
        ) | (
          { __typename: 'MemberWatched' }
          & IMainContentListFragment_MemberWatched_Fragment
        ) | (
          { __typename: 'MembersDatas' }
          & IMainContentListFragment_MembersDatas_Fragment
        ) | (
          { __typename: 'MiniSitesFolder' }
          & IMainContentListFragment_MiniSitesFolder_Fragment
        ) | (
          { __typename: 'NavMessage' }
          & IMainContentListFragment_NavMessage_Fragment
        ) | (
          { __typename: 'NavigationMessagesFolder' }
          & IMainContentListFragment_NavigationMessagesFolder_Fragment
        ) | (
          { __typename: 'NetlifyDeploy' }
          & IMainContentListFragment_NetlifyDeploy_Fragment
        ) | (
          { __typename: 'News' }
          & IMainContentListFragment_News_Fragment
        ) | (
          { __typename: 'NewsCateg' }
          & IMainContentListFragment_NewsCateg_Fragment
        ) | (
          { __typename: 'NewsFolder' }
          & IMainContentListFragment_NewsFolder_Fragment
        ) | (
          { __typename: 'NewsPage' }
          & IMainContentListFragment_NewsPage_Fragment
        ) | (
          { __typename: 'ObtainedJob' }
          & IMainContentListFragment_ObtainedJob_Fragment
        ) | (
          { __typename: 'Opportunity' }
          & IMainContentListFragment_Opportunity_Fragment
        ) | (
          { __typename: 'OpportunityCenter' }
          & IMainContentListFragment_OpportunityCenter_Fragment
        ) | (
          { __typename: 'OpportunityFolder' }
          & IMainContentListFragment_OpportunityFolder_Fragment
        ) | (
          { __typename: 'Partner' }
          & IMainContentListFragment_Partner_Fragment
        ) | (
          { __typename: 'Partners' }
          & IMainContentListFragment_Partners_Fragment
        ) | (
          { __typename: 'PartnersPage' }
          & IMainContentListFragment_PartnersPage_Fragment
        ) | (
          { __typename: 'Paywall' }
          & IMainContentListFragment_Paywall_Fragment
        ) | (
          { __typename: 'PaywallFolder' }
          & IMainContentListFragment_PaywallFolder_Fragment
        ) | (
          { __typename: 'PersonalityPages' }
          & IMainContentListFragment_PersonalityPages_Fragment
        ) | (
          { __typename: 'PersonalityQuiz' }
          & IMainContentListFragment_PersonalityQuiz_Fragment
        ) | (
          { __typename: 'PersonalityQuiz1' }
          & IMainContentListFragment_PersonalityQuiz1_Fragment
        ) | (
          { __typename: 'PersonalityType' }
          & IMainContentListFragment_PersonalityType_Fragment
        ) | (
          { __typename: 'Playlist' }
          & Pick<IPlaylist, 'title' | 'subtitle' | 'countriesRestriction'>
          & IMainContentListFragment_Playlist_Fragment
        ) | (
          { __typename: 'PlaylistRadioMenu' }
          & IMainContentListFragment_PlaylistRadioMenu_Fragment
        ) | (
          { __typename: 'Podcast' }
          & Pick<IPodcast, 'title' | 'subtitle' | 'countriesRestriction'>
          & IMainContentListFragment_Podcast_Fragment
        ) | (
          { __typename: 'PodcastCateg' }
          & IMainContentListFragment_PodcastCateg_Fragment
        ) | (
          { __typename: 'PodcastItem' }
          & IMainContentListFragment_PodcastItem_Fragment
        ) | (
          { __typename: 'PodcastMenu' }
          & IMainContentListFragment_PodcastMenu_Fragment
        ) | (
          { __typename: 'PromoCode' }
          & IMainContentListFragment_PromoCode_Fragment
        ) | (
          { __typename: 'PromoCodeFolder' }
          & IMainContentListFragment_PromoCodeFolder_Fragment
        ) | (
          { __typename: 'QuizPage' }
          & IMainContentListFragment_QuizPage_Fragment
        ) | (
          { __typename: 'QuizzSurvey' }
          & IMainContentListFragment_QuizzSurvey_Fragment
        ) | (
          { __typename: 'QuizzSurveyCategory' }
          & IMainContentListFragment_QuizzSurveyCategory_Fragment
        ) | (
          { __typename: 'QuizzSurveyCollection' }
          & IMainContentListFragment_QuizzSurveyCollection_Fragment
        ) | (
          { __typename: 'Radio' }
          & Pick<IRadio, 'title' | 'subtitle' | 'countriesRestriction'>
          & IMainContentListFragment_Radio_Fragment
        ) | (
          { __typename: 'RadioCateg' }
          & IMainContentListFragment_RadioCateg_Fragment
        ) | (
          { __typename: 'Region' }
          & IMainContentListFragment_Region_Fragment
        ) | (
          { __typename: 'SectionPage' }
          & IMainContentListFragment_SectionPage_Fragment
        ) | (
          { __typename: 'Settings' }
          & IMainContentListFragment_Settings_Fragment
        ) | (
          { __typename: 'Space' }
          & IMainContentListFragment_Space_Fragment
        ) | (
          { __typename: 'Subscription' }
          & IMainContentListFragment_Subscription_Fragment
        ) | (
          { __typename: 'SubscriptionData' }
          & IMainContentListFragment_SubscriptionData_Fragment
        ) | (
          { __typename: 'SubscriptionDataFolder' }
          & IMainContentListFragment_SubscriptionDataFolder_Fragment
        ) | (
          { __typename: 'SubscriptionsFolder' }
          & IMainContentListFragment_SubscriptionsFolder_Fragment
        ) | (
          { __typename: 'SumaryNugget' }
          & IMainContentListFragment_SumaryNugget_Fragment
        ) | (
          { __typename: 'SurveyQuizzFolder' }
          & IMainContentListFragment_SurveyQuizzFolder_Fragment
        ) | (
          { __typename: 'TextPage' }
          & IMainContentListFragment_TextPage_Fragment
        ) | (
          { __typename: 'ThankYouPage' }
          & IMainContentListFragment_ThankYouPage_Fragment
        ) | (
          { __typename: 'TranslationContext' }
          & IMainContentListFragment_TranslationContext_Fragment
        ) | (
          { __typename: 'TranslationFolder' }
          & IMainContentListFragment_TranslationFolder_Fragment
        ) | (
          { __typename: 'TranslationItem' }
          & IMainContentListFragment_TranslationItem_Fragment
        ) | (
          { __typename: 'UmbracoTest' }
          & IMainContentListFragment_UmbracoTest_Fragment
        ) | (
          { __typename: 'UnitNuggetAnswer' }
          & IMainContentListFragment_UnitNuggetAnswer_Fragment
        ) | (
          { __typename: 'UnitNuggetGapFillAnswer' }
          & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
        ) | (
          { __typename: 'UnitProgression' }
          & IMainContentListFragment_UnitProgression_Fragment
        ) | (
          { __typename: 'VODItem' }
          & Pick<IVodItem, 'title' | 'subtitle' | 'countriesRestriction'>
          & IMainContentListFragment_VodItem_Fragment
        ) | (
          { __typename: 'VODMenu' }
          & IMainContentListFragment_VodMenu_Fragment
        ) | (
          { __typename: 'VotingFolder' }
          & IMainContentListFragment_VotingFolder_Fragment
        ) | (
          { __typename: 'VotingRecord' }
          & IMainContentListFragment_VotingRecord_Fragment
        ) | (
          { __typename: 'WatchCateg' }
          & IMainContentListFragment_WatchCateg_Fragment
        )>> }
      ) }
    )> }
  )> }
);

export type ICategoryPageByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICategoryPageByUrlQuery = (
  { __typename?: 'Query' }
  & { categoryPage?: Maybe<(
    { __typename?: 'CategoryPage' }
    & ICategoryPageFragmentFragment
  )> }
);

export type ICategoryPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICategoryPageByIdQuery = (
  { __typename?: 'Query' }
  & { categoryPage?: Maybe<(
    { __typename?: 'CategoryPage' }
    & ICategoryPageFragmentFragment
  )> }
);

export type IChannelByIdQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IChannelByIdQuery = (
  { __typename?: 'Query' }
  & { allContent: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | (
      { __typename: 'Channel' }
      & IChannelFragmentFragment
    ) | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
  ) }
);

export type ICollectionByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICollectionByUrlQuery = (
  { __typename?: 'Query' }
  & { collection?: Maybe<(
    { __typename?: 'Collection' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'name' | 'url'>
        & IVodItemFragmentFragment
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'name' | 'url'>
      )>> }
    ) }
    & ICollectionFragmentFragment
  )> }
);

export type ICollectionByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICollectionByIdQuery = (
  { __typename?: 'Query' }
  & { collection?: Maybe<(
    { __typename?: 'Collection' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'name' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'name' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'name' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'name' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'name' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'name' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'name' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'name' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'name' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'name' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'name' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'name' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'name' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'name' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'name' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'name' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'name' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'name' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'name' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'name' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'name' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'name' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'name' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'name' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'name' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'name' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'name' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'name' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'name' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'name' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'name' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'name' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'name' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'name' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'name' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'name' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'name' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'name' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'name' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'name' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'name' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'name' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'name' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'name' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'name' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'name' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'name' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'name' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'name' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'name' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'name' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'name' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'name' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'name' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'name' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'name' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'name' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'name' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'name' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'name' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'name' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'name' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'name' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'name' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'name' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'name' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'name' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'name' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'name' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'name' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'name' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'name' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'name' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'name' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'name' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'name' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'name' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'name' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'name' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'name' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'name' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'name' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'name' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'name' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'name' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'name' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'name' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'name' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'name' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'name' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'name' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'name' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'name' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'name' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'name' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'name' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'name' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'name' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'name' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'name' | 'url'>
        & IVodItemFragmentFragment
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'name' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'name' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'name' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'name' | 'url'>
      )>> }
    ) }
    & ICollectionFragmentFragment
  )> }
);

export type ICollectionByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICollectionByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allCollection: (
    { __typename?: 'CollectionConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Collection' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<(
          { __typename: 'ArtistService' }
          & Pick<IArtistService, 'name' | 'url'>
        ) | (
          { __typename: 'ArtistServiceFolder' }
          & Pick<IArtistServiceFolder, 'name' | 'url'>
        ) | (
          { __typename: 'ArtistServicesPage' }
          & Pick<IArtistServicesPage, 'name' | 'url'>
        ) | (
          { __typename: 'AwardCategoryPage' }
          & Pick<IAwardCategoryPage, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsArtist' }
          & Pick<IAwardsArtist, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsCategoryMenu' }
          & Pick<IAwardsCategoryMenu, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsCategoryMenuDev' }
          & Pick<IAwardsCategoryMenuDev, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolder' }
          & Pick<IAwardsCategoryMenuFolder, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolderDev' }
          & Pick<IAwardsCategoryMenuFolderDev, 'name' | 'url'>
        ) | (
          { __typename: 'AwardsHomepage' }
          & Pick<IAwardsHomepage, 'name' | 'url'>
        ) | (
          { __typename: 'CMSPage' }
          & Pick<ICmsPage, 'name' | 'url'>
        ) | (
          { __typename: 'CategBgColor' }
          & Pick<ICategBgColor, 'name' | 'url'>
        ) | (
          { __typename: 'CategoryPage' }
          & Pick<ICategoryPage, 'name' | 'url'>
        ) | (
          { __typename: 'Channel' }
          & Pick<IChannel, 'name' | 'url'>
        ) | (
          { __typename: 'ChannelFolder' }
          & Pick<IChannelFolder, 'name' | 'url'>
        ) | (
          { __typename: 'ChoiceNugget' }
          & Pick<IChoiceNugget, 'name' | 'url'>
        ) | (
          { __typename: 'Collection' }
          & Pick<ICollection, 'name' | 'url'>
        ) | (
          { __typename: 'ContentEditorFolder' }
          & Pick<IContentEditorFolder, 'name' | 'url'>
        ) | (
          { __typename: 'ContentTag' }
          & Pick<IContentTag, 'name' | 'url'>
        ) | (
          { __typename: 'ContentTags' }
          & Pick<IContentTags, 'name' | 'url'>
        ) | (
          { __typename: 'ContentTagsCateg' }
          & Pick<IContentTagsCateg, 'name' | 'url'>
        ) | (
          { __typename: 'Course' }
          & Pick<ICourse, 'name' | 'url'>
        ) | (
          { __typename: 'CourseCategoriesFolder' }
          & Pick<ICourseCategoriesFolder, 'name' | 'url'>
        ) | (
          { __typename: 'CourseCategory' }
          & Pick<ICourseCategory, 'name' | 'url'>
        ) | (
          { __typename: 'CourseExam' }
          & Pick<ICourseExam, 'name' | 'url'>
        ) | (
          { __typename: 'CourseShare' }
          & Pick<ICourseShare, 'name' | 'url'>
        ) | (
          { __typename: 'CourseStatus' }
          & Pick<ICourseStatus, 'name' | 'url'>
        ) | (
          { __typename: 'CourseTestProgression' }
          & Pick<ICourseTestProgression, 'name' | 'url'>
        ) | (
          { __typename: 'CourseUnit' }
          & Pick<ICourseUnit, 'name' | 'url'>
        ) | (
          { __typename: 'Discovery' }
          & Pick<IDiscovery, 'name' | 'url'>
        ) | (
          { __typename: 'DiscoverySlide1' }
          & Pick<IDiscoverySlide1, 'name' | 'url'>
        ) | (
          { __typename: 'EntrepreunarialHub' }
          & Pick<IEntrepreunarialHub, 'name' | 'url'>
        ) | (
          { __typename: 'FormFolder' }
          & Pick<IFormFolder, 'name' | 'url'>
        ) | (
          { __typename: 'FormPage' }
          & Pick<IFormPage, 'name' | 'url'>
        ) | (
          { __typename: 'GapfillNugget' }
          & Pick<IGapfillNugget, 'name' | 'url'>
        ) | (
          { __typename: 'HelpdeskCateg' }
          & Pick<IHelpdeskCateg, 'name' | 'url'>
        ) | (
          { __typename: 'HelpdeskFolder' }
          & Pick<IHelpdeskFolder, 'name' | 'url'>
        ) | (
          { __typename: 'HelpdeskPage' }
          & Pick<IHelpdeskPage, 'name' | 'url'>
        ) | (
          { __typename: 'HomePage' }
          & Pick<IHomePage, 'name' | 'url'>
        ) | (
          { __typename: 'JobBoardPage' }
          & Pick<IJobBoardPage, 'name' | 'url'>
        ) | (
          { __typename: 'JobHub' }
          & Pick<IJobHub, 'name' | 'url'>
        ) | (
          { __typename: 'JobHubsFolder' }
          & Pick<IJobHubsFolder, 'name' | 'url'>
        ) | (
          { __typename: 'JobProgress' }
          & Pick<IJobProgress, 'name' | 'url'>
        ) | (
          { __typename: 'JobShare' }
          & Pick<IJobShare, 'name' | 'url'>
        ) | (
          { __typename: 'JobTraining' }
          & Pick<IJobTraining, 'name' | 'url'>
        ) | (
          { __typename: 'JobTrainingFolder' }
          & Pick<IJobTrainingFolder, 'name' | 'url'>
        ) | (
          { __typename: 'JobVacanciesFolder' }
          & Pick<IJobVacanciesFolder, 'name' | 'url'>
        ) | (
          { __typename: 'JobVacancy' }
          & Pick<IJobVacancy, 'name' | 'url'>
        ) | (
          { __typename: 'LandingPage' }
          & Pick<ILandingPage, 'name' | 'url'>
        ) | (
          { __typename: 'LearnMenu' }
          & Pick<ILearnMenu, 'name' | 'url'>
        ) | (
          { __typename: 'LegalsFolder' }
          & Pick<ILegalsFolder, 'name' | 'url'>
        ) | (
          { __typename: 'ListenCateg' }
          & Pick<IListenCateg, 'name' | 'url'>
        ) | (
          { __typename: 'LiveEvent' }
          & Pick<ILiveEvent, 'name' | 'url'>
        ) | (
          { __typename: 'LiveEventsMenu' }
          & Pick<ILiveEventsMenu, 'name' | 'url'>
        ) | (
          { __typename: 'LiveEventsPage' }
          & Pick<ILiveEventsPage, 'name' | 'url'>
        ) | (
          { __typename: 'LiveTVPage' }
          & Pick<ILiveTvPage, 'name' | 'url'>
        ) | (
          { __typename: 'MemberContentTypesLink' }
          & Pick<IMemberContentTypesLink, 'name' | 'url'>
        ) | (
          { __typename: 'MemberDatas' }
          & Pick<IMemberDatas, 'name' | 'url'>
        ) | (
          { __typename: 'MemberDownloaded' }
          & Pick<IMemberDownloaded, 'name' | 'url'>
        ) | (
          { __typename: 'MemberMessage' }
          & Pick<IMemberMessage, 'name' | 'url'>
        ) | (
          { __typename: 'MemberNotify' }
          & Pick<IMemberNotify, 'name' | 'url'>
        ) | (
          { __typename: 'MemberOpportunity' }
          & Pick<IMemberOpportunity, 'name' | 'url'>
        ) | (
          { __typename: 'MemberSaved' }
          & Pick<IMemberSaved, 'name' | 'url'>
        ) | (
          { __typename: 'MemberSearch' }
          & Pick<IMemberSearch, 'name' | 'url'>
        ) | (
          { __typename: 'MemberWatched' }
          & Pick<IMemberWatched, 'name' | 'url'>
        ) | (
          { __typename: 'MembersDatas' }
          & Pick<IMembersDatas, 'name' | 'url'>
        ) | (
          { __typename: 'MiniSitesFolder' }
          & Pick<IMiniSitesFolder, 'name' | 'url'>
        ) | (
          { __typename: 'NavMessage' }
          & Pick<INavMessage, 'name' | 'url'>
        ) | (
          { __typename: 'NavigationMessagesFolder' }
          & Pick<INavigationMessagesFolder, 'name' | 'url'>
        ) | (
          { __typename: 'NetlifyDeploy' }
          & Pick<INetlifyDeploy, 'name' | 'url'>
        ) | (
          { __typename: 'News' }
          & Pick<INews, 'name' | 'url'>
        ) | (
          { __typename: 'NewsCateg' }
          & Pick<INewsCateg, 'name' | 'url'>
        ) | (
          { __typename: 'NewsFolder' }
          & Pick<INewsFolder, 'name' | 'url'>
        ) | (
          { __typename: 'NewsPage' }
          & Pick<INewsPage, 'name' | 'url'>
        ) | (
          { __typename: 'ObtainedJob' }
          & Pick<IObtainedJob, 'name' | 'url'>
        ) | (
          { __typename: 'Opportunity' }
          & Pick<IOpportunity, 'name' | 'url'>
        ) | (
          { __typename: 'OpportunityCenter' }
          & Pick<IOpportunityCenter, 'name' | 'url'>
        ) | (
          { __typename: 'OpportunityFolder' }
          & Pick<IOpportunityFolder, 'name' | 'url'>
        ) | (
          { __typename: 'Partner' }
          & Pick<IPartner, 'name' | 'url'>
        ) | (
          { __typename: 'Partners' }
          & Pick<IPartners, 'name' | 'url'>
        ) | (
          { __typename: 'PartnersPage' }
          & Pick<IPartnersPage, 'name' | 'url'>
        ) | (
          { __typename: 'Paywall' }
          & Pick<IPaywall, 'name' | 'url'>
        ) | (
          { __typename: 'PaywallFolder' }
          & Pick<IPaywallFolder, 'name' | 'url'>
        ) | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'name' | 'url'>
        ) | (
          { __typename: 'PersonalityQuiz' }
          & Pick<IPersonalityQuiz, 'name' | 'url'>
        ) | (
          { __typename: 'PersonalityQuiz1' }
          & Pick<IPersonalityQuiz1, 'name' | 'url'>
        ) | (
          { __typename: 'PersonalityType' }
          & Pick<IPersonalityType, 'name' | 'url'>
        ) | (
          { __typename: 'Playlist' }
          & Pick<IPlaylist, 'name' | 'url'>
        ) | (
          { __typename: 'PlaylistRadioMenu' }
          & Pick<IPlaylistRadioMenu, 'name' | 'url'>
        ) | (
          { __typename: 'Podcast' }
          & Pick<IPodcast, 'name' | 'url'>
        ) | (
          { __typename: 'PodcastCateg' }
          & Pick<IPodcastCateg, 'name' | 'url'>
        ) | (
          { __typename: 'PodcastItem' }
          & Pick<IPodcastItem, 'name' | 'url'>
        ) | (
          { __typename: 'PodcastMenu' }
          & Pick<IPodcastMenu, 'name' | 'url'>
        ) | (
          { __typename: 'PromoCode' }
          & Pick<IPromoCode, 'name' | 'url'>
        ) | (
          { __typename: 'PromoCodeFolder' }
          & Pick<IPromoCodeFolder, 'name' | 'url'>
        ) | (
          { __typename: 'QuizPage' }
          & Pick<IQuizPage, 'name' | 'url'>
        ) | (
          { __typename: 'QuizzSurvey' }
          & Pick<IQuizzSurvey, 'name' | 'url'>
        ) | (
          { __typename: 'QuizzSurveyCategory' }
          & Pick<IQuizzSurveyCategory, 'name' | 'url'>
        ) | (
          { __typename: 'QuizzSurveyCollection' }
          & Pick<IQuizzSurveyCollection, 'name' | 'url'>
        ) | (
          { __typename: 'Radio' }
          & Pick<IRadio, 'name' | 'url'>
        ) | (
          { __typename: 'RadioCateg' }
          & Pick<IRadioCateg, 'name' | 'url'>
        ) | (
          { __typename: 'Region' }
          & Pick<IRegion, 'name' | 'url'>
        ) | (
          { __typename: 'SectionPage' }
          & Pick<ISectionPage, 'name' | 'url'>
        ) | (
          { __typename: 'Settings' }
          & Pick<ISettings, 'name' | 'url'>
        ) | (
          { __typename: 'Space' }
          & Pick<ISpace, 'name' | 'url'>
        ) | (
          { __typename: 'Subscription' }
          & Pick<ISubscription, 'name' | 'url'>
        ) | (
          { __typename: 'SubscriptionData' }
          & Pick<ISubscriptionData, 'name' | 'url'>
        ) | (
          { __typename: 'SubscriptionDataFolder' }
          & Pick<ISubscriptionDataFolder, 'name' | 'url'>
        ) | (
          { __typename: 'SubscriptionsFolder' }
          & Pick<ISubscriptionsFolder, 'name' | 'url'>
        ) | (
          { __typename: 'SumaryNugget' }
          & Pick<ISumaryNugget, 'name' | 'url'>
        ) | (
          { __typename: 'SurveyQuizzFolder' }
          & Pick<ISurveyQuizzFolder, 'name' | 'url'>
        ) | (
          { __typename: 'TextPage' }
          & Pick<ITextPage, 'name' | 'url'>
        ) | (
          { __typename: 'ThankYouPage' }
          & Pick<IThankYouPage, 'name' | 'url'>
        ) | (
          { __typename: 'TranslationContext' }
          & Pick<ITranslationContext, 'name' | 'url'>
        ) | (
          { __typename: 'TranslationFolder' }
          & Pick<ITranslationFolder, 'name' | 'url'>
        ) | (
          { __typename: 'TranslationItem' }
          & Pick<ITranslationItem, 'name' | 'url'>
        ) | (
          { __typename: 'UmbracoTest' }
          & Pick<IUmbracoTest, 'name' | 'url'>
        ) | (
          { __typename: 'UnitNuggetAnswer' }
          & Pick<IUnitNuggetAnswer, 'name' | 'url'>
        ) | (
          { __typename: 'UnitNuggetGapFillAnswer' }
          & Pick<IUnitNuggetGapFillAnswer, 'name' | 'url'>
        ) | (
          { __typename: 'UnitProgression' }
          & Pick<IUnitProgression, 'name' | 'url'>
        ) | (
          { __typename: 'VODItem' }
          & Pick<IVodItem, 'name' | 'url'>
          & IVodItemFragmentFragment
        ) | (
          { __typename: 'VODMenu' }
          & Pick<IVodMenu, 'name' | 'url'>
        ) | (
          { __typename: 'VotingFolder' }
          & Pick<IVotingFolder, 'name' | 'url'>
        ) | (
          { __typename: 'VotingRecord' }
          & Pick<IVotingRecord, 'name' | 'url'>
        ) | (
          { __typename: 'WatchCateg' }
          & Pick<IWatchCateg, 'name' | 'url'>
        )>> }
      ) }
      & ICollectionFragmentFragment
    )>> }
  ) }
);

export type IAllContentByListIdQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllContentByListIdQuery = (
  { __typename?: 'Query' }
  & { allContent: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id' | 'name'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id' | 'name'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'name'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id' | 'name'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id' | 'name'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id' | 'name'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id' | 'name'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id' | 'name'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id' | 'name'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id' | 'name'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id' | 'name'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id' | 'name'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'name'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id' | 'name'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id' | 'name'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id' | 'name'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id' | 'name'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id' | 'name'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id' | 'name'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id' | 'name'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id' | 'name'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id' | 'name'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id' | 'name'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id' | 'name'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id' | 'name'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id' | 'name'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id' | 'name'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id' | 'name'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id' | 'name'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id' | 'name'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id' | 'name'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id' | 'name'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id' | 'name'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id' | 'name'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id' | 'name'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id' | 'name'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id' | 'name'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id' | 'name'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id' | 'name'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id' | 'name'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id' | 'name'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id' | 'name'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id' | 'name'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id' | 'name'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id' | 'name'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id' | 'name'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id' | 'name'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id' | 'name'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id' | 'name'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id' | 'name'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id' | 'name'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id' | 'name'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id' | 'name'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id' | 'name'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id' | 'name'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id' | 'name'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id' | 'name'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id' | 'name'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id' | 'name'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id' | 'name'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id' | 'name'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id' | 'name'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id' | 'name'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id' | 'name'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id' | 'name'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id' | 'name'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id' | 'name'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id' | 'name'>
      & IPodcastItemFragmentFragment
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id' | 'name'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id' | 'name'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id' | 'name'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id' | 'name'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id' | 'name'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id' | 'name'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id' | 'name'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id' | 'name'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id' | 'name'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id' | 'name'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id' | 'name'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id' | 'name'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id' | 'name'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id' | 'name'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id' | 'name'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id' | 'name'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id' | 'name'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id' | 'name'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id' | 'name'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id' | 'name'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id' | 'name'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id' | 'name'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id' | 'name'>
      & IVodItemFragmentFragment
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id' | 'name'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id' | 'name'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id' | 'name'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id' | 'name'>
    )>> }
  ) }
);

export type IDeepLinkContentFragment_ArtistService_Fragment = { __typename?: 'ArtistService' };

export type IDeepLinkContentFragment_ArtistServiceFolder_Fragment = { __typename?: 'ArtistServiceFolder' };

export type IDeepLinkContentFragment_ArtistServicesPage_Fragment = { __typename?: 'ArtistServicesPage' };

export type IDeepLinkContentFragment_AwardCategoryPage_Fragment = { __typename?: 'AwardCategoryPage' };

export type IDeepLinkContentFragment_AwardsArtist_Fragment = { __typename?: 'AwardsArtist' };

export type IDeepLinkContentFragment_AwardsCategoryMenu_Fragment = { __typename?: 'AwardsCategoryMenu' };

export type IDeepLinkContentFragment_AwardsCategoryMenuDev_Fragment = { __typename?: 'AwardsCategoryMenuDev' };

export type IDeepLinkContentFragment_AwardsCategoryMenuFolder_Fragment = { __typename?: 'AwardsCategoryMenuFolder' };

export type IDeepLinkContentFragment_AwardsCategoryMenuFolderDev_Fragment = { __typename?: 'AwardsCategoryMenuFolderDev' };

export type IDeepLinkContentFragment_AwardsHomepage_Fragment = { __typename?: 'AwardsHomepage' };

export type IDeepLinkContentFragment_CmsPage_Fragment = { __typename?: 'CMSPage' };

export type IDeepLinkContentFragment_CategBgColor_Fragment = { __typename?: 'CategBgColor' };

export type IDeepLinkContentFragment_CategoryPage_Fragment = { __typename?: 'CategoryPage' };

export type IDeepLinkContentFragment_Channel_Fragment = (
  { __typename?: 'Channel' }
  & Pick<IChannel, 'title'>
);

export type IDeepLinkContentFragment_ChannelFolder_Fragment = { __typename?: 'ChannelFolder' };

export type IDeepLinkContentFragment_ChoiceNugget_Fragment = { __typename?: 'ChoiceNugget' };

export type IDeepLinkContentFragment_Collection_Fragment = (
  { __typename?: 'Collection' }
  & Pick<ICollection, 'title'>
);

export type IDeepLinkContentFragment_ContentEditorFolder_Fragment = { __typename?: 'ContentEditorFolder' };

export type IDeepLinkContentFragment_ContentTag_Fragment = { __typename?: 'ContentTag' };

export type IDeepLinkContentFragment_ContentTags_Fragment = { __typename?: 'ContentTags' };

export type IDeepLinkContentFragment_ContentTagsCateg_Fragment = { __typename?: 'ContentTagsCateg' };

export type IDeepLinkContentFragment_Course_Fragment = (
  { __typename?: 'Course' }
  & Pick<ICourse, 'title'>
);

export type IDeepLinkContentFragment_CourseCategoriesFolder_Fragment = { __typename?: 'CourseCategoriesFolder' };

export type IDeepLinkContentFragment_CourseCategory_Fragment = { __typename?: 'CourseCategory' };

export type IDeepLinkContentFragment_CourseExam_Fragment = { __typename?: 'CourseExam' };

export type IDeepLinkContentFragment_CourseShare_Fragment = { __typename?: 'CourseShare' };

export type IDeepLinkContentFragment_CourseStatus_Fragment = { __typename?: 'CourseStatus' };

export type IDeepLinkContentFragment_CourseTestProgression_Fragment = { __typename?: 'CourseTestProgression' };

export type IDeepLinkContentFragment_CourseUnit_Fragment = { __typename?: 'CourseUnit' };

export type IDeepLinkContentFragment_Discovery_Fragment = { __typename?: 'Discovery' };

export type IDeepLinkContentFragment_DiscoverySlide1_Fragment = { __typename?: 'DiscoverySlide1' };

export type IDeepLinkContentFragment_EntrepreunarialHub_Fragment = { __typename?: 'EntrepreunarialHub' };

export type IDeepLinkContentFragment_FormFolder_Fragment = { __typename?: 'FormFolder' };

export type IDeepLinkContentFragment_FormPage_Fragment = { __typename?: 'FormPage' };

export type IDeepLinkContentFragment_GapfillNugget_Fragment = { __typename?: 'GapfillNugget' };

export type IDeepLinkContentFragment_HelpdeskCateg_Fragment = { __typename?: 'HelpdeskCateg' };

export type IDeepLinkContentFragment_HelpdeskFolder_Fragment = { __typename?: 'HelpdeskFolder' };

export type IDeepLinkContentFragment_HelpdeskPage_Fragment = { __typename?: 'HelpdeskPage' };

export type IDeepLinkContentFragment_HomePage_Fragment = { __typename?: 'HomePage' };

export type IDeepLinkContentFragment_JobBoardPage_Fragment = { __typename?: 'JobBoardPage' };

export type IDeepLinkContentFragment_JobHub_Fragment = { __typename?: 'JobHub' };

export type IDeepLinkContentFragment_JobHubsFolder_Fragment = { __typename?: 'JobHubsFolder' };

export type IDeepLinkContentFragment_JobProgress_Fragment = { __typename?: 'JobProgress' };

export type IDeepLinkContentFragment_JobShare_Fragment = { __typename?: 'JobShare' };

export type IDeepLinkContentFragment_JobTraining_Fragment = (
  { __typename?: 'JobTraining' }
  & Pick<IJobTraining, 'title'>
);

export type IDeepLinkContentFragment_JobTrainingFolder_Fragment = { __typename?: 'JobTrainingFolder' };

export type IDeepLinkContentFragment_JobVacanciesFolder_Fragment = { __typename?: 'JobVacanciesFolder' };

export type IDeepLinkContentFragment_JobVacancy_Fragment = { __typename?: 'JobVacancy' };

export type IDeepLinkContentFragment_LandingPage_Fragment = { __typename?: 'LandingPage' };

export type IDeepLinkContentFragment_LearnMenu_Fragment = { __typename?: 'LearnMenu' };

export type IDeepLinkContentFragment_LegalsFolder_Fragment = { __typename?: 'LegalsFolder' };

export type IDeepLinkContentFragment_ListenCateg_Fragment = { __typename?: 'ListenCateg' };

export type IDeepLinkContentFragment_LiveEvent_Fragment = (
  { __typename?: 'LiveEvent' }
  & Pick<ILiveEvent, 'title'>
);

export type IDeepLinkContentFragment_LiveEventsMenu_Fragment = { __typename?: 'LiveEventsMenu' };

export type IDeepLinkContentFragment_LiveEventsPage_Fragment = { __typename?: 'LiveEventsPage' };

export type IDeepLinkContentFragment_LiveTvPage_Fragment = { __typename?: 'LiveTVPage' };

export type IDeepLinkContentFragment_MemberContentTypesLink_Fragment = { __typename?: 'MemberContentTypesLink' };

export type IDeepLinkContentFragment_MemberDatas_Fragment = { __typename?: 'MemberDatas' };

export type IDeepLinkContentFragment_MemberDownloaded_Fragment = { __typename?: 'MemberDownloaded' };

export type IDeepLinkContentFragment_MemberMessage_Fragment = { __typename?: 'MemberMessage' };

export type IDeepLinkContentFragment_MemberNotify_Fragment = { __typename?: 'MemberNotify' };

export type IDeepLinkContentFragment_MemberOpportunity_Fragment = { __typename?: 'MemberOpportunity' };

export type IDeepLinkContentFragment_MemberSaved_Fragment = { __typename?: 'MemberSaved' };

export type IDeepLinkContentFragment_MemberSearch_Fragment = { __typename?: 'MemberSearch' };

export type IDeepLinkContentFragment_MemberWatched_Fragment = { __typename?: 'MemberWatched' };

export type IDeepLinkContentFragment_MembersDatas_Fragment = { __typename?: 'MembersDatas' };

export type IDeepLinkContentFragment_MiniSitesFolder_Fragment = { __typename?: 'MiniSitesFolder' };

export type IDeepLinkContentFragment_NavMessage_Fragment = { __typename?: 'NavMessage' };

export type IDeepLinkContentFragment_NavigationMessagesFolder_Fragment = { __typename?: 'NavigationMessagesFolder' };

export type IDeepLinkContentFragment_NetlifyDeploy_Fragment = { __typename?: 'NetlifyDeploy' };

export type IDeepLinkContentFragment_News_Fragment = (
  { __typename?: 'News' }
  & Pick<INews, 'title'>
);

export type IDeepLinkContentFragment_NewsCateg_Fragment = { __typename?: 'NewsCateg' };

export type IDeepLinkContentFragment_NewsFolder_Fragment = { __typename?: 'NewsFolder' };

export type IDeepLinkContentFragment_NewsPage_Fragment = { __typename?: 'NewsPage' };

export type IDeepLinkContentFragment_ObtainedJob_Fragment = { __typename?: 'ObtainedJob' };

export type IDeepLinkContentFragment_Opportunity_Fragment = { __typename?: 'Opportunity' };

export type IDeepLinkContentFragment_OpportunityCenter_Fragment = { __typename?: 'OpportunityCenter' };

export type IDeepLinkContentFragment_OpportunityFolder_Fragment = { __typename?: 'OpportunityFolder' };

export type IDeepLinkContentFragment_Partner_Fragment = { __typename?: 'Partner' };

export type IDeepLinkContentFragment_Partners_Fragment = { __typename?: 'Partners' };

export type IDeepLinkContentFragment_PartnersPage_Fragment = { __typename?: 'PartnersPage' };

export type IDeepLinkContentFragment_Paywall_Fragment = { __typename?: 'Paywall' };

export type IDeepLinkContentFragment_PaywallFolder_Fragment = { __typename?: 'PaywallFolder' };

export type IDeepLinkContentFragment_PersonalityPages_Fragment = { __typename?: 'PersonalityPages' };

export type IDeepLinkContentFragment_PersonalityQuiz_Fragment = { __typename?: 'PersonalityQuiz' };

export type IDeepLinkContentFragment_PersonalityQuiz1_Fragment = { __typename?: 'PersonalityQuiz1' };

export type IDeepLinkContentFragment_PersonalityType_Fragment = { __typename?: 'PersonalityType' };

export type IDeepLinkContentFragment_Playlist_Fragment = (
  { __typename?: 'Playlist' }
  & Pick<IPlaylist, 'title'>
);

export type IDeepLinkContentFragment_PlaylistRadioMenu_Fragment = { __typename?: 'PlaylistRadioMenu' };

export type IDeepLinkContentFragment_Podcast_Fragment = (
  { __typename?: 'Podcast' }
  & Pick<IPodcast, 'title'>
);

export type IDeepLinkContentFragment_PodcastCateg_Fragment = { __typename?: 'PodcastCateg' };

export type IDeepLinkContentFragment_PodcastItem_Fragment = (
  { __typename?: 'PodcastItem' }
  & Pick<IPodcastItem, 'title'>
);

export type IDeepLinkContentFragment_PodcastMenu_Fragment = { __typename?: 'PodcastMenu' };

export type IDeepLinkContentFragment_PromoCode_Fragment = { __typename?: 'PromoCode' };

export type IDeepLinkContentFragment_PromoCodeFolder_Fragment = { __typename?: 'PromoCodeFolder' };

export type IDeepLinkContentFragment_QuizPage_Fragment = { __typename?: 'QuizPage' };

export type IDeepLinkContentFragment_QuizzSurvey_Fragment = (
  { __typename?: 'QuizzSurvey' }
  & Pick<IQuizzSurvey, 'title'>
);

export type IDeepLinkContentFragment_QuizzSurveyCategory_Fragment = { __typename?: 'QuizzSurveyCategory' };

export type IDeepLinkContentFragment_QuizzSurveyCollection_Fragment = (
  { __typename?: 'QuizzSurveyCollection' }
  & Pick<IQuizzSurveyCollection, 'title'>
);

export type IDeepLinkContentFragment_Radio_Fragment = (
  { __typename?: 'Radio' }
  & Pick<IRadio, 'title'>
);

export type IDeepLinkContentFragment_RadioCateg_Fragment = { __typename?: 'RadioCateg' };

export type IDeepLinkContentFragment_Region_Fragment = { __typename?: 'Region' };

export type IDeepLinkContentFragment_SectionPage_Fragment = { __typename?: 'SectionPage' };

export type IDeepLinkContentFragment_Settings_Fragment = { __typename?: 'Settings' };

export type IDeepLinkContentFragment_Space_Fragment = { __typename?: 'Space' };

export type IDeepLinkContentFragment_Subscription_Fragment = { __typename?: 'Subscription' };

export type IDeepLinkContentFragment_SubscriptionData_Fragment = { __typename?: 'SubscriptionData' };

export type IDeepLinkContentFragment_SubscriptionDataFolder_Fragment = { __typename?: 'SubscriptionDataFolder' };

export type IDeepLinkContentFragment_SubscriptionsFolder_Fragment = { __typename?: 'SubscriptionsFolder' };

export type IDeepLinkContentFragment_SumaryNugget_Fragment = { __typename?: 'SumaryNugget' };

export type IDeepLinkContentFragment_SurveyQuizzFolder_Fragment = { __typename?: 'SurveyQuizzFolder' };

export type IDeepLinkContentFragment_TextPage_Fragment = { __typename?: 'TextPage' };

export type IDeepLinkContentFragment_ThankYouPage_Fragment = { __typename?: 'ThankYouPage' };

export type IDeepLinkContentFragment_TranslationContext_Fragment = { __typename?: 'TranslationContext' };

export type IDeepLinkContentFragment_TranslationFolder_Fragment = { __typename?: 'TranslationFolder' };

export type IDeepLinkContentFragment_TranslationItem_Fragment = { __typename?: 'TranslationItem' };

export type IDeepLinkContentFragment_UmbracoTest_Fragment = { __typename?: 'UmbracoTest' };

export type IDeepLinkContentFragment_UnitNuggetAnswer_Fragment = { __typename?: 'UnitNuggetAnswer' };

export type IDeepLinkContentFragment_UnitNuggetGapFillAnswer_Fragment = { __typename?: 'UnitNuggetGapFillAnswer' };

export type IDeepLinkContentFragment_UnitProgression_Fragment = { __typename?: 'UnitProgression' };

export type IDeepLinkContentFragment_VodItem_Fragment = (
  { __typename?: 'VODItem' }
  & Pick<IVodItem, 'title'>
);

export type IDeepLinkContentFragment_VodMenu_Fragment = { __typename?: 'VODMenu' };

export type IDeepLinkContentFragment_VotingFolder_Fragment = { __typename?: 'VotingFolder' };

export type IDeepLinkContentFragment_VotingRecord_Fragment = { __typename?: 'VotingRecord' };

export type IDeepLinkContentFragment_WatchCateg_Fragment = { __typename?: 'WatchCateg' };

export type IDeepLinkContentFragmentFragment = IDeepLinkContentFragment_ArtistService_Fragment | IDeepLinkContentFragment_ArtistServiceFolder_Fragment | IDeepLinkContentFragment_ArtistServicesPage_Fragment | IDeepLinkContentFragment_AwardCategoryPage_Fragment | IDeepLinkContentFragment_AwardsArtist_Fragment | IDeepLinkContentFragment_AwardsCategoryMenu_Fragment | IDeepLinkContentFragment_AwardsCategoryMenuDev_Fragment | IDeepLinkContentFragment_AwardsCategoryMenuFolder_Fragment | IDeepLinkContentFragment_AwardsCategoryMenuFolderDev_Fragment | IDeepLinkContentFragment_AwardsHomepage_Fragment | IDeepLinkContentFragment_CmsPage_Fragment | IDeepLinkContentFragment_CategBgColor_Fragment | IDeepLinkContentFragment_CategoryPage_Fragment | IDeepLinkContentFragment_Channel_Fragment | IDeepLinkContentFragment_ChannelFolder_Fragment | IDeepLinkContentFragment_ChoiceNugget_Fragment | IDeepLinkContentFragment_Collection_Fragment | IDeepLinkContentFragment_ContentEditorFolder_Fragment | IDeepLinkContentFragment_ContentTag_Fragment | IDeepLinkContentFragment_ContentTags_Fragment | IDeepLinkContentFragment_ContentTagsCateg_Fragment | IDeepLinkContentFragment_Course_Fragment | IDeepLinkContentFragment_CourseCategoriesFolder_Fragment | IDeepLinkContentFragment_CourseCategory_Fragment | IDeepLinkContentFragment_CourseExam_Fragment | IDeepLinkContentFragment_CourseShare_Fragment | IDeepLinkContentFragment_CourseStatus_Fragment | IDeepLinkContentFragment_CourseTestProgression_Fragment | IDeepLinkContentFragment_CourseUnit_Fragment | IDeepLinkContentFragment_Discovery_Fragment | IDeepLinkContentFragment_DiscoverySlide1_Fragment | IDeepLinkContentFragment_EntrepreunarialHub_Fragment | IDeepLinkContentFragment_FormFolder_Fragment | IDeepLinkContentFragment_FormPage_Fragment | IDeepLinkContentFragment_GapfillNugget_Fragment | IDeepLinkContentFragment_HelpdeskCateg_Fragment | IDeepLinkContentFragment_HelpdeskFolder_Fragment | IDeepLinkContentFragment_HelpdeskPage_Fragment | IDeepLinkContentFragment_HomePage_Fragment | IDeepLinkContentFragment_JobBoardPage_Fragment | IDeepLinkContentFragment_JobHub_Fragment | IDeepLinkContentFragment_JobHubsFolder_Fragment | IDeepLinkContentFragment_JobProgress_Fragment | IDeepLinkContentFragment_JobShare_Fragment | IDeepLinkContentFragment_JobTraining_Fragment | IDeepLinkContentFragment_JobTrainingFolder_Fragment | IDeepLinkContentFragment_JobVacanciesFolder_Fragment | IDeepLinkContentFragment_JobVacancy_Fragment | IDeepLinkContentFragment_LandingPage_Fragment | IDeepLinkContentFragment_LearnMenu_Fragment | IDeepLinkContentFragment_LegalsFolder_Fragment | IDeepLinkContentFragment_ListenCateg_Fragment | IDeepLinkContentFragment_LiveEvent_Fragment | IDeepLinkContentFragment_LiveEventsMenu_Fragment | IDeepLinkContentFragment_LiveEventsPage_Fragment | IDeepLinkContentFragment_LiveTvPage_Fragment | IDeepLinkContentFragment_MemberContentTypesLink_Fragment | IDeepLinkContentFragment_MemberDatas_Fragment | IDeepLinkContentFragment_MemberDownloaded_Fragment | IDeepLinkContentFragment_MemberMessage_Fragment | IDeepLinkContentFragment_MemberNotify_Fragment | IDeepLinkContentFragment_MemberOpportunity_Fragment | IDeepLinkContentFragment_MemberSaved_Fragment | IDeepLinkContentFragment_MemberSearch_Fragment | IDeepLinkContentFragment_MemberWatched_Fragment | IDeepLinkContentFragment_MembersDatas_Fragment | IDeepLinkContentFragment_MiniSitesFolder_Fragment | IDeepLinkContentFragment_NavMessage_Fragment | IDeepLinkContentFragment_NavigationMessagesFolder_Fragment | IDeepLinkContentFragment_NetlifyDeploy_Fragment | IDeepLinkContentFragment_News_Fragment | IDeepLinkContentFragment_NewsCateg_Fragment | IDeepLinkContentFragment_NewsFolder_Fragment | IDeepLinkContentFragment_NewsPage_Fragment | IDeepLinkContentFragment_ObtainedJob_Fragment | IDeepLinkContentFragment_Opportunity_Fragment | IDeepLinkContentFragment_OpportunityCenter_Fragment | IDeepLinkContentFragment_OpportunityFolder_Fragment | IDeepLinkContentFragment_Partner_Fragment | IDeepLinkContentFragment_Partners_Fragment | IDeepLinkContentFragment_PartnersPage_Fragment | IDeepLinkContentFragment_Paywall_Fragment | IDeepLinkContentFragment_PaywallFolder_Fragment | IDeepLinkContentFragment_PersonalityPages_Fragment | IDeepLinkContentFragment_PersonalityQuiz_Fragment | IDeepLinkContentFragment_PersonalityQuiz1_Fragment | IDeepLinkContentFragment_PersonalityType_Fragment | IDeepLinkContentFragment_Playlist_Fragment | IDeepLinkContentFragment_PlaylistRadioMenu_Fragment | IDeepLinkContentFragment_Podcast_Fragment | IDeepLinkContentFragment_PodcastCateg_Fragment | IDeepLinkContentFragment_PodcastItem_Fragment | IDeepLinkContentFragment_PodcastMenu_Fragment | IDeepLinkContentFragment_PromoCode_Fragment | IDeepLinkContentFragment_PromoCodeFolder_Fragment | IDeepLinkContentFragment_QuizPage_Fragment | IDeepLinkContentFragment_QuizzSurvey_Fragment | IDeepLinkContentFragment_QuizzSurveyCategory_Fragment | IDeepLinkContentFragment_QuizzSurveyCollection_Fragment | IDeepLinkContentFragment_Radio_Fragment | IDeepLinkContentFragment_RadioCateg_Fragment | IDeepLinkContentFragment_Region_Fragment | IDeepLinkContentFragment_SectionPage_Fragment | IDeepLinkContentFragment_Settings_Fragment | IDeepLinkContentFragment_Space_Fragment | IDeepLinkContentFragment_Subscription_Fragment | IDeepLinkContentFragment_SubscriptionData_Fragment | IDeepLinkContentFragment_SubscriptionDataFolder_Fragment | IDeepLinkContentFragment_SubscriptionsFolder_Fragment | IDeepLinkContentFragment_SumaryNugget_Fragment | IDeepLinkContentFragment_SurveyQuizzFolder_Fragment | IDeepLinkContentFragment_TextPage_Fragment | IDeepLinkContentFragment_ThankYouPage_Fragment | IDeepLinkContentFragment_TranslationContext_Fragment | IDeepLinkContentFragment_TranslationFolder_Fragment | IDeepLinkContentFragment_TranslationItem_Fragment | IDeepLinkContentFragment_UmbracoTest_Fragment | IDeepLinkContentFragment_UnitNuggetAnswer_Fragment | IDeepLinkContentFragment_UnitNuggetGapFillAnswer_Fragment | IDeepLinkContentFragment_UnitProgression_Fragment | IDeepLinkContentFragment_VodItem_Fragment | IDeepLinkContentFragment_VodMenu_Fragment | IDeepLinkContentFragment_VotingFolder_Fragment | IDeepLinkContentFragment_VotingRecord_Fragment | IDeepLinkContentFragment_WatchCateg_Fragment;

export type IContentIdByEndUrlQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  contentTypeAlias?: InputMaybe<Scalars['String']>;
}>;


export type IContentIdByEndUrlQuery = (
  { __typename?: 'Query' }
  & { en: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
      & IDeepLinkContentFragment_ArtistService_Fragment
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
      & IDeepLinkContentFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
      & IDeepLinkContentFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
      & IDeepLinkContentFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
      & IDeepLinkContentFragment_AwardsArtist_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
      & IDeepLinkContentFragment_AwardsHomepage_Fragment
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
      & IDeepLinkContentFragment_CmsPage_Fragment
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
      & IDeepLinkContentFragment_CategBgColor_Fragment
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
      & IDeepLinkContentFragment_CategoryPage_Fragment
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'sourceUrl' | 'id'>
      & { liveEventId: IChannel['vimeoEventId'] }
      & IDeepLinkContentFragment_Channel_Fragment
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
      & IDeepLinkContentFragment_ChannelFolder_Fragment
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
      & IDeepLinkContentFragment_ChoiceNugget_Fragment
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
      & IDeepLinkContentFragment_Collection_Fragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
      & IDeepLinkContentFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
      & IDeepLinkContentFragment_ContentTag_Fragment
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
      & IDeepLinkContentFragment_ContentTags_Fragment
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
      & IDeepLinkContentFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
      & IDeepLinkContentFragment_Course_Fragment
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
      & IDeepLinkContentFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
      & IDeepLinkContentFragment_CourseCategory_Fragment
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
      & IDeepLinkContentFragment_CourseExam_Fragment
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
      & IDeepLinkContentFragment_CourseShare_Fragment
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
      & IDeepLinkContentFragment_CourseStatus_Fragment
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
      & IDeepLinkContentFragment_CourseTestProgression_Fragment
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
      & IDeepLinkContentFragment_CourseUnit_Fragment
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
      & IDeepLinkContentFragment_Discovery_Fragment
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
      & IDeepLinkContentFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
      & IDeepLinkContentFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
      & IDeepLinkContentFragment_FormFolder_Fragment
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
      & IDeepLinkContentFragment_FormPage_Fragment
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
      & IDeepLinkContentFragment_GapfillNugget_Fragment
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
      & IDeepLinkContentFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
      & IDeepLinkContentFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
      & IDeepLinkContentFragment_HelpdeskPage_Fragment
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
      & IDeepLinkContentFragment_HomePage_Fragment
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
      & IDeepLinkContentFragment_JobBoardPage_Fragment
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
      & IDeepLinkContentFragment_JobHub_Fragment
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
      & IDeepLinkContentFragment_JobHubsFolder_Fragment
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
      & IDeepLinkContentFragment_JobProgress_Fragment
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
      & IDeepLinkContentFragment_JobShare_Fragment
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
      & IDeepLinkContentFragment_JobTraining_Fragment
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
      & IDeepLinkContentFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
      & IDeepLinkContentFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
      & IDeepLinkContentFragment_JobVacancy_Fragment
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
      & IDeepLinkContentFragment_LandingPage_Fragment
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
      & IDeepLinkContentFragment_LearnMenu_Fragment
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
      & IDeepLinkContentFragment_LegalsFolder_Fragment
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
      & IDeepLinkContentFragment_ListenCateg_Fragment
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
      & IDeepLinkContentFragment_LiveEvent_Fragment
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
      & IDeepLinkContentFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
      & IDeepLinkContentFragment_LiveEventsPage_Fragment
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
      & IDeepLinkContentFragment_LiveTvPage_Fragment
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
      & IDeepLinkContentFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
      & IDeepLinkContentFragment_MemberDatas_Fragment
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
      & IDeepLinkContentFragment_MemberDownloaded_Fragment
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
      & IDeepLinkContentFragment_MemberMessage_Fragment
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
      & IDeepLinkContentFragment_MemberNotify_Fragment
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
      & IDeepLinkContentFragment_MemberOpportunity_Fragment
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
      & IDeepLinkContentFragment_MemberSaved_Fragment
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
      & IDeepLinkContentFragment_MemberSearch_Fragment
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
      & IDeepLinkContentFragment_MemberWatched_Fragment
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
      & IDeepLinkContentFragment_MembersDatas_Fragment
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
      & IDeepLinkContentFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
      & IDeepLinkContentFragment_NavMessage_Fragment
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
      & IDeepLinkContentFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
      & IDeepLinkContentFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
      & IDeepLinkContentFragment_News_Fragment
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
      & IDeepLinkContentFragment_NewsCateg_Fragment
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
      & IDeepLinkContentFragment_NewsFolder_Fragment
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
      & IDeepLinkContentFragment_NewsPage_Fragment
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
      & IDeepLinkContentFragment_ObtainedJob_Fragment
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
      & IDeepLinkContentFragment_Opportunity_Fragment
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
      & IDeepLinkContentFragment_OpportunityCenter_Fragment
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
      & IDeepLinkContentFragment_OpportunityFolder_Fragment
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
      & IDeepLinkContentFragment_Partner_Fragment
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
      & IDeepLinkContentFragment_Partners_Fragment
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
      & IDeepLinkContentFragment_PartnersPage_Fragment
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
      & IDeepLinkContentFragment_Paywall_Fragment
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
      & IDeepLinkContentFragment_PaywallFolder_Fragment
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
      & IDeepLinkContentFragment_PersonalityPages_Fragment
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
      & IDeepLinkContentFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
      & IDeepLinkContentFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
      & IDeepLinkContentFragment_PersonalityType_Fragment
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
      & IDeepLinkContentFragment_Playlist_Fragment
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
      & IDeepLinkContentFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
      & IDeepLinkContentFragment_Podcast_Fragment
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
      & IDeepLinkContentFragment_PodcastCateg_Fragment
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
      & IDeepLinkContentFragment_PodcastItem_Fragment
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
      & IDeepLinkContentFragment_PodcastMenu_Fragment
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
      & IDeepLinkContentFragment_PromoCode_Fragment
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
      & IDeepLinkContentFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
      & IDeepLinkContentFragment_QuizPage_Fragment
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
      & IDeepLinkContentFragment_QuizzSurvey_Fragment
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
      & IDeepLinkContentFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
      & IDeepLinkContentFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
      & IDeepLinkContentFragment_Radio_Fragment
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
      & IDeepLinkContentFragment_RadioCateg_Fragment
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
      & IDeepLinkContentFragment_Region_Fragment
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
      & IDeepLinkContentFragment_SectionPage_Fragment
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
      & IDeepLinkContentFragment_Settings_Fragment
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
      & IDeepLinkContentFragment_Space_Fragment
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
      & IDeepLinkContentFragment_Subscription_Fragment
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
      & IDeepLinkContentFragment_SubscriptionData_Fragment
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
      & IDeepLinkContentFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
      & IDeepLinkContentFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
      & IDeepLinkContentFragment_SumaryNugget_Fragment
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
      & IDeepLinkContentFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
      & IDeepLinkContentFragment_TextPage_Fragment
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
      & IDeepLinkContentFragment_ThankYouPage_Fragment
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
      & IDeepLinkContentFragment_TranslationContext_Fragment
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
      & IDeepLinkContentFragment_TranslationFolder_Fragment
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
      & IDeepLinkContentFragment_TranslationItem_Fragment
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
      & IDeepLinkContentFragment_UmbracoTest_Fragment
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
      & IDeepLinkContentFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
      & IDeepLinkContentFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
      & IDeepLinkContentFragment_UnitProgression_Fragment
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
      & IDeepLinkContentFragment_VodItem_Fragment
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
      & IDeepLinkContentFragment_VodMenu_Fragment
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
      & IDeepLinkContentFragment_VotingFolder_Fragment
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
      & IDeepLinkContentFragment_VotingRecord_Fragment
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
      & IDeepLinkContentFragment_WatchCateg_Fragment
    )>> }
  ), fr: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
      & IDeepLinkContentFragment_ArtistService_Fragment
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
      & IDeepLinkContentFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
      & IDeepLinkContentFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
      & IDeepLinkContentFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
      & IDeepLinkContentFragment_AwardsArtist_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
      & IDeepLinkContentFragment_AwardsHomepage_Fragment
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
      & IDeepLinkContentFragment_CmsPage_Fragment
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
      & IDeepLinkContentFragment_CategBgColor_Fragment
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
      & IDeepLinkContentFragment_CategoryPage_Fragment
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'sourceUrl' | 'id'>
      & { liveEventId: IChannel['vimeoEventId'] }
      & IDeepLinkContentFragment_Channel_Fragment
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
      & IDeepLinkContentFragment_ChannelFolder_Fragment
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
      & IDeepLinkContentFragment_ChoiceNugget_Fragment
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
      & IDeepLinkContentFragment_Collection_Fragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
      & IDeepLinkContentFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
      & IDeepLinkContentFragment_ContentTag_Fragment
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
      & IDeepLinkContentFragment_ContentTags_Fragment
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
      & IDeepLinkContentFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
      & IDeepLinkContentFragment_Course_Fragment
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
      & IDeepLinkContentFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
      & IDeepLinkContentFragment_CourseCategory_Fragment
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
      & IDeepLinkContentFragment_CourseExam_Fragment
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
      & IDeepLinkContentFragment_CourseShare_Fragment
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
      & IDeepLinkContentFragment_CourseStatus_Fragment
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
      & IDeepLinkContentFragment_CourseTestProgression_Fragment
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
      & IDeepLinkContentFragment_CourseUnit_Fragment
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
      & IDeepLinkContentFragment_Discovery_Fragment
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
      & IDeepLinkContentFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
      & IDeepLinkContentFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
      & IDeepLinkContentFragment_FormFolder_Fragment
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
      & IDeepLinkContentFragment_FormPage_Fragment
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
      & IDeepLinkContentFragment_GapfillNugget_Fragment
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
      & IDeepLinkContentFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
      & IDeepLinkContentFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
      & IDeepLinkContentFragment_HelpdeskPage_Fragment
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
      & IDeepLinkContentFragment_HomePage_Fragment
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
      & IDeepLinkContentFragment_JobBoardPage_Fragment
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
      & IDeepLinkContentFragment_JobHub_Fragment
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
      & IDeepLinkContentFragment_JobHubsFolder_Fragment
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
      & IDeepLinkContentFragment_JobProgress_Fragment
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
      & IDeepLinkContentFragment_JobShare_Fragment
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
      & IDeepLinkContentFragment_JobTraining_Fragment
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
      & IDeepLinkContentFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
      & IDeepLinkContentFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
      & IDeepLinkContentFragment_JobVacancy_Fragment
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
      & IDeepLinkContentFragment_LandingPage_Fragment
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
      & IDeepLinkContentFragment_LearnMenu_Fragment
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
      & IDeepLinkContentFragment_LegalsFolder_Fragment
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
      & IDeepLinkContentFragment_ListenCateg_Fragment
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
      & IDeepLinkContentFragment_LiveEvent_Fragment
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
      & IDeepLinkContentFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
      & IDeepLinkContentFragment_LiveEventsPage_Fragment
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
      & IDeepLinkContentFragment_LiveTvPage_Fragment
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
      & IDeepLinkContentFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
      & IDeepLinkContentFragment_MemberDatas_Fragment
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
      & IDeepLinkContentFragment_MemberDownloaded_Fragment
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
      & IDeepLinkContentFragment_MemberMessage_Fragment
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
      & IDeepLinkContentFragment_MemberNotify_Fragment
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
      & IDeepLinkContentFragment_MemberOpportunity_Fragment
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
      & IDeepLinkContentFragment_MemberSaved_Fragment
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
      & IDeepLinkContentFragment_MemberSearch_Fragment
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
      & IDeepLinkContentFragment_MemberWatched_Fragment
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
      & IDeepLinkContentFragment_MembersDatas_Fragment
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
      & IDeepLinkContentFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
      & IDeepLinkContentFragment_NavMessage_Fragment
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
      & IDeepLinkContentFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
      & IDeepLinkContentFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
      & IDeepLinkContentFragment_News_Fragment
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
      & IDeepLinkContentFragment_NewsCateg_Fragment
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
      & IDeepLinkContentFragment_NewsFolder_Fragment
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
      & IDeepLinkContentFragment_NewsPage_Fragment
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
      & IDeepLinkContentFragment_ObtainedJob_Fragment
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
      & IDeepLinkContentFragment_Opportunity_Fragment
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
      & IDeepLinkContentFragment_OpportunityCenter_Fragment
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
      & IDeepLinkContentFragment_OpportunityFolder_Fragment
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
      & IDeepLinkContentFragment_Partner_Fragment
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
      & IDeepLinkContentFragment_Partners_Fragment
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
      & IDeepLinkContentFragment_PartnersPage_Fragment
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
      & IDeepLinkContentFragment_Paywall_Fragment
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
      & IDeepLinkContentFragment_PaywallFolder_Fragment
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
      & IDeepLinkContentFragment_PersonalityPages_Fragment
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
      & IDeepLinkContentFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
      & IDeepLinkContentFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
      & IDeepLinkContentFragment_PersonalityType_Fragment
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
      & IDeepLinkContentFragment_Playlist_Fragment
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
      & IDeepLinkContentFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
      & IDeepLinkContentFragment_Podcast_Fragment
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
      & IDeepLinkContentFragment_PodcastCateg_Fragment
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
      & IDeepLinkContentFragment_PodcastItem_Fragment
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
      & IDeepLinkContentFragment_PodcastMenu_Fragment
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
      & IDeepLinkContentFragment_PromoCode_Fragment
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
      & IDeepLinkContentFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
      & IDeepLinkContentFragment_QuizPage_Fragment
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
      & IDeepLinkContentFragment_QuizzSurvey_Fragment
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
      & IDeepLinkContentFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
      & IDeepLinkContentFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
      & IDeepLinkContentFragment_Radio_Fragment
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
      & IDeepLinkContentFragment_RadioCateg_Fragment
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
      & IDeepLinkContentFragment_Region_Fragment
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
      & IDeepLinkContentFragment_SectionPage_Fragment
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
      & IDeepLinkContentFragment_Settings_Fragment
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
      & IDeepLinkContentFragment_Space_Fragment
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
      & IDeepLinkContentFragment_Subscription_Fragment
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
      & IDeepLinkContentFragment_SubscriptionData_Fragment
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
      & IDeepLinkContentFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
      & IDeepLinkContentFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
      & IDeepLinkContentFragment_SumaryNugget_Fragment
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
      & IDeepLinkContentFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
      & IDeepLinkContentFragment_TextPage_Fragment
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
      & IDeepLinkContentFragment_ThankYouPage_Fragment
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
      & IDeepLinkContentFragment_TranslationContext_Fragment
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
      & IDeepLinkContentFragment_TranslationFolder_Fragment
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
      & IDeepLinkContentFragment_TranslationItem_Fragment
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
      & IDeepLinkContentFragment_UmbracoTest_Fragment
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
      & IDeepLinkContentFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
      & IDeepLinkContentFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
      & IDeepLinkContentFragment_UnitProgression_Fragment
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
      & IDeepLinkContentFragment_VodItem_Fragment
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
      & IDeepLinkContentFragment_VodMenu_Fragment
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
      & IDeepLinkContentFragment_VotingFolder_Fragment
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
      & IDeepLinkContentFragment_VotingRecord_Fragment
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
      & IDeepLinkContentFragment_WatchCateg_Fragment
    )>> }
  ), pt: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
      & IDeepLinkContentFragment_ArtistService_Fragment
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
      & IDeepLinkContentFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
      & IDeepLinkContentFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
      & IDeepLinkContentFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
      & IDeepLinkContentFragment_AwardsArtist_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      & IDeepLinkContentFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
      & IDeepLinkContentFragment_AwardsHomepage_Fragment
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
      & IDeepLinkContentFragment_CmsPage_Fragment
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
      & IDeepLinkContentFragment_CategBgColor_Fragment
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
      & IDeepLinkContentFragment_CategoryPage_Fragment
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'sourceUrl' | 'id'>
      & { liveEventId: IChannel['vimeoEventId'] }
      & IDeepLinkContentFragment_Channel_Fragment
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
      & IDeepLinkContentFragment_ChannelFolder_Fragment
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
      & IDeepLinkContentFragment_ChoiceNugget_Fragment
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
      & IDeepLinkContentFragment_Collection_Fragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
      & IDeepLinkContentFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
      & IDeepLinkContentFragment_ContentTag_Fragment
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
      & IDeepLinkContentFragment_ContentTags_Fragment
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
      & IDeepLinkContentFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
      & IDeepLinkContentFragment_Course_Fragment
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
      & IDeepLinkContentFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
      & IDeepLinkContentFragment_CourseCategory_Fragment
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
      & IDeepLinkContentFragment_CourseExam_Fragment
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
      & IDeepLinkContentFragment_CourseShare_Fragment
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
      & IDeepLinkContentFragment_CourseStatus_Fragment
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
      & IDeepLinkContentFragment_CourseTestProgression_Fragment
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
      & IDeepLinkContentFragment_CourseUnit_Fragment
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
      & IDeepLinkContentFragment_Discovery_Fragment
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
      & IDeepLinkContentFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
      & IDeepLinkContentFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
      & IDeepLinkContentFragment_FormFolder_Fragment
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
      & IDeepLinkContentFragment_FormPage_Fragment
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
      & IDeepLinkContentFragment_GapfillNugget_Fragment
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
      & IDeepLinkContentFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
      & IDeepLinkContentFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
      & IDeepLinkContentFragment_HelpdeskPage_Fragment
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
      & IDeepLinkContentFragment_HomePage_Fragment
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
      & IDeepLinkContentFragment_JobBoardPage_Fragment
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
      & IDeepLinkContentFragment_JobHub_Fragment
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
      & IDeepLinkContentFragment_JobHubsFolder_Fragment
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
      & IDeepLinkContentFragment_JobProgress_Fragment
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
      & IDeepLinkContentFragment_JobShare_Fragment
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
      & IDeepLinkContentFragment_JobTraining_Fragment
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
      & IDeepLinkContentFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
      & IDeepLinkContentFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
      & IDeepLinkContentFragment_JobVacancy_Fragment
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
      & IDeepLinkContentFragment_LandingPage_Fragment
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
      & IDeepLinkContentFragment_LearnMenu_Fragment
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
      & IDeepLinkContentFragment_LegalsFolder_Fragment
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
      & IDeepLinkContentFragment_ListenCateg_Fragment
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
      & IDeepLinkContentFragment_LiveEvent_Fragment
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
      & IDeepLinkContentFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
      & IDeepLinkContentFragment_LiveEventsPage_Fragment
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
      & IDeepLinkContentFragment_LiveTvPage_Fragment
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
      & IDeepLinkContentFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
      & IDeepLinkContentFragment_MemberDatas_Fragment
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
      & IDeepLinkContentFragment_MemberDownloaded_Fragment
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
      & IDeepLinkContentFragment_MemberMessage_Fragment
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
      & IDeepLinkContentFragment_MemberNotify_Fragment
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
      & IDeepLinkContentFragment_MemberOpportunity_Fragment
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
      & IDeepLinkContentFragment_MemberSaved_Fragment
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
      & IDeepLinkContentFragment_MemberSearch_Fragment
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
      & IDeepLinkContentFragment_MemberWatched_Fragment
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
      & IDeepLinkContentFragment_MembersDatas_Fragment
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
      & IDeepLinkContentFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
      & IDeepLinkContentFragment_NavMessage_Fragment
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
      & IDeepLinkContentFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
      & IDeepLinkContentFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
      & IDeepLinkContentFragment_News_Fragment
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
      & IDeepLinkContentFragment_NewsCateg_Fragment
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
      & IDeepLinkContentFragment_NewsFolder_Fragment
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
      & IDeepLinkContentFragment_NewsPage_Fragment
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
      & IDeepLinkContentFragment_ObtainedJob_Fragment
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
      & IDeepLinkContentFragment_Opportunity_Fragment
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
      & IDeepLinkContentFragment_OpportunityCenter_Fragment
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
      & IDeepLinkContentFragment_OpportunityFolder_Fragment
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
      & IDeepLinkContentFragment_Partner_Fragment
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
      & IDeepLinkContentFragment_Partners_Fragment
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
      & IDeepLinkContentFragment_PartnersPage_Fragment
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
      & IDeepLinkContentFragment_Paywall_Fragment
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
      & IDeepLinkContentFragment_PaywallFolder_Fragment
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
      & IDeepLinkContentFragment_PersonalityPages_Fragment
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
      & IDeepLinkContentFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
      & IDeepLinkContentFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
      & IDeepLinkContentFragment_PersonalityType_Fragment
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
      & IDeepLinkContentFragment_Playlist_Fragment
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
      & IDeepLinkContentFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
      & IDeepLinkContentFragment_Podcast_Fragment
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
      & IDeepLinkContentFragment_PodcastCateg_Fragment
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
      & IDeepLinkContentFragment_PodcastItem_Fragment
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
      & IDeepLinkContentFragment_PodcastMenu_Fragment
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
      & IDeepLinkContentFragment_PromoCode_Fragment
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
      & IDeepLinkContentFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
      & IDeepLinkContentFragment_QuizPage_Fragment
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
      & IDeepLinkContentFragment_QuizzSurvey_Fragment
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
      & IDeepLinkContentFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
      & IDeepLinkContentFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
      & IDeepLinkContentFragment_Radio_Fragment
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
      & IDeepLinkContentFragment_RadioCateg_Fragment
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
      & IDeepLinkContentFragment_Region_Fragment
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
      & IDeepLinkContentFragment_SectionPage_Fragment
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
      & IDeepLinkContentFragment_Settings_Fragment
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
      & IDeepLinkContentFragment_Space_Fragment
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
      & IDeepLinkContentFragment_Subscription_Fragment
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
      & IDeepLinkContentFragment_SubscriptionData_Fragment
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
      & IDeepLinkContentFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
      & IDeepLinkContentFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
      & IDeepLinkContentFragment_SumaryNugget_Fragment
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
      & IDeepLinkContentFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
      & IDeepLinkContentFragment_TextPage_Fragment
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
      & IDeepLinkContentFragment_ThankYouPage_Fragment
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
      & IDeepLinkContentFragment_TranslationContext_Fragment
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
      & IDeepLinkContentFragment_TranslationFolder_Fragment
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
      & IDeepLinkContentFragment_TranslationItem_Fragment
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
      & IDeepLinkContentFragment_UmbracoTest_Fragment
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
      & IDeepLinkContentFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
      & IDeepLinkContentFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
      & IDeepLinkContentFragment_UnitProgression_Fragment
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
      & IDeepLinkContentFragment_VodItem_Fragment
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
      & IDeepLinkContentFragment_VodMenu_Fragment
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
      & IDeepLinkContentFragment_VotingFolder_Fragment
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
      & IDeepLinkContentFragment_VotingRecord_Fragment
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
      & IDeepLinkContentFragment_WatchCateg_Fragment
    )>> }
  ) }
);

export type IContentUrlByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IContentUrlByIdQuery = (
  { __typename?: 'Query' }
  & { content?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url'>
  )> }
);

export type ICountMemberSavedByContentIdQueryVariables = Exact<{
  contentId?: InputMaybe<Scalars['ID']>;
}>;


export type ICountMemberSavedByContentIdQuery = (
  { __typename?: 'Query' }
  & { allMemberSaved: (
    { __typename?: 'MemberSavedConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    )>> }
  ) }
);

export type ICountMemberUnitProgressionQueryVariables = Exact<{
  memberDatasId?: InputMaybe<Scalars['ID']>;
}>;


export type ICountMemberUnitProgressionQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename?: 'MemberDatas' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'finished' | 'id'>
      ) | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
    ) }
  )> }
);

export type IGetContentByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetContentByIdQuery = (
  { __typename?: 'Query' }
  & { content?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | (
    { __typename?: 'Channel' }
    & IChannelFragmentFragment
  ) | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | (
    { __typename?: 'LiveEvent' }
    & ILiveEventFragmentFragment
  ) | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | (
    { __typename?: 'VODItem' }
    & IVodItemFragmentFragment
  ) | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
);

export type IContentByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IContentByIdQuery = (
  { __typename?: 'Query' }
  & { content?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'url' | 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'url' | 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'url' | 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'url' | 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'url' | 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'url' | 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'url' | 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'url' | 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'url' | 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'url' | 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'url' | 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'url' | 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'url' | 'id'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'url' | 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'url' | 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'url' | 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'url' | 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'url' | 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'url' | 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'url' | 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'url' | 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'url' | 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'url' | 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'url' | 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'url' | 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'url' | 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'url' | 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'url' | 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'url' | 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'url' | 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'url' | 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'url' | 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'url' | 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'url' | 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'url' | 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'url' | 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'url' | 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'url' | 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'url' | 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'url' | 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'url' | 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'url' | 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'url' | 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'url' | 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'url' | 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'url' | 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'url' | 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'url' | 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'url' | 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'url' | 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'url' | 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'url' | 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'url' | 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'url' | 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'url' | 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'url' | 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'url' | 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'url' | 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'url' | 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'url' | 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'url' | 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'url' | 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'url' | 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'url' | 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'url' | 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'url' | 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'url' | 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'url' | 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'url' | 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'url' | 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'url' | 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'url' | 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'url' | 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'url' | 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'url' | 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'url' | 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'url' | 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'url' | 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'url' | 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'url' | 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'url' | 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'url' | 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'url' | 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'url' | 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'url' | 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'url' | 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'url' | 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'url' | 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'url' | 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'url' | 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'url' | 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'url' | 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'url' | 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'url' | 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'url' | 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'url' | 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'url' | 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'url' | 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'url' | 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'url' | 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'url' | 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'url' | 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'url' | 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'url' | 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'url' | 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'url' | 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'url' | 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'url' | 'id'>
  )> }
);

export type IContentByUrlEndQueryVariables = Exact<{
  urlEnd?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IContentByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allContent: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'url' | 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'url' | 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'url' | 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'url' | 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'url' | 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'url' | 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'url' | 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'url' | 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'url' | 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'url' | 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'url' | 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'url' | 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'url' | 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'url' | 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'url' | 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'url' | 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'url' | 'id'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'url' | 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'url' | 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'url' | 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'url' | 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'url' | 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'url' | 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'url' | 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'url' | 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'url' | 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'url' | 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'url' | 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'url' | 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'url' | 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'url' | 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'url' | 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'url' | 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'url' | 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'url' | 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'url' | 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'url' | 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'url' | 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'url' | 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'url' | 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'url' | 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'url' | 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'url' | 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'url' | 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'url' | 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'url' | 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'url' | 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'url' | 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'url' | 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'url' | 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'url' | 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'url' | 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'url' | 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'url' | 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'url' | 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'url' | 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'url' | 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'url' | 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'url' | 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'url' | 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'url' | 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'url' | 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'url' | 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'url' | 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'url' | 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'url' | 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'url' | 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'url' | 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'url' | 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'url' | 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'url' | 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'url' | 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'url' | 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'url' | 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'url' | 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'url' | 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'url' | 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'url' | 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'url' | 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'url' | 'id'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'url' | 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'url' | 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'url' | 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'url' | 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'url' | 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'url' | 'id'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'url' | 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'url' | 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'url' | 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'url' | 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'url' | 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'url' | 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'url' | 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'url' | 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'url' | 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'url' | 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'url' | 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'url' | 'id'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'url' | 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'url' | 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'url' | 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'url' | 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'url' | 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'url' | 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'url' | 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'url' | 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'url' | 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'url' | 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'url' | 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'url' | 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'url' | 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'url' | 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'url' | 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'url' | 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'url' | 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'url' | 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'url' | 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'url' | 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'url' | 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'url' | 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'url' | 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'url' | 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'url' | 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'url' | 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'url' | 'id'>
    )>> }
  ) }
);

export type IContentByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IContentByUrlQuery = (
  { __typename?: 'Query' }
  & { content?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
    & ICategoryPageFragmentFragment
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
    & ISectionPageFragmentFragment
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id' | 'url' | 'level' | 'name' | 'contentTypeAlias'>
  )> }
);

export type IFileUploadSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type IFileUploadSettingQuery = (
  { __typename?: 'Query' }
  & { allSettings: (
    { __typename?: 'SettingsConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Settings' }
      & Pick<ISettings, 'imageUploadParentId' | 'audioUploadParentId'>
    )>> }
  ) }
);

export type IFormPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IFormPageByIdQuery = (
  { __typename?: 'Query' }
  & { formPage?: Maybe<(
    { __typename?: 'FormPage' }
    & IFormPageFragmentFragment
  )> }
);

export type IFormPageByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IFormPageByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allFormPage: (
    { __typename?: 'FormPageConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'FormPage' }
      & IFormPageFragmentFragment
    )>> }
  ) }
);

export type IAllHelpdeskFolderQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IAllHelpdeskFolderQuery = (
  { __typename?: 'Query' }
  & { allHelpdeskFolder: (
    { __typename?: 'HelpdeskFolderConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'zendeskForm' | 'url' | 'id'>
    )>> }
  ) }
);

export type IHelpdeskPageByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IHelpdeskPageByUrlQuery = (
  { __typename?: 'Query' }
  & { helpdeskPage?: Maybe<(
    { __typename?: 'HelpdeskPage' }
    & IHelpdeskPageFragmentFragment
  )> }
);

export type IHelpdeskPageByHomepageIdQueryVariables = Exact<{
  homepageId?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IHelpdeskPageByHomepageIdQuery = (
  { __typename?: 'Query' }
  & { homePage?: Maybe<(
    { __typename?: 'HomePage' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
        { __typename?: 'HelpdeskPage' }
        & IHelpdeskPageFragmentFragment
      ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  )> }
);

export type IHelpdeskPageByRegionIdQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IHelpdeskPageByRegionIdQuery = (
  { __typename?: 'Query' }
  & { region?: Maybe<(
    { __typename?: 'Region' }
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsArtist' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsHomepage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CMSPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CategBgColor' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CategoryPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Channel' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ChannelFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ChoiceNugget' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Collection' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTag' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTags' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Course' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseCategory' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseExam' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseShare' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseStatus' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseTestProgression' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseUnit' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Discovery' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'FormFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'FormPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'GapfillNugget' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HomePage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobBoardPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobHub' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobHubsFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobProgress' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobShare' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobTraining' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobVacancy' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LandingPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LearnMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LegalsFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ListenCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEvent' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEventsPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveTVPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberDatas' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberDownloaded' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberMessage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberNotify' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberOpportunity' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberSaved' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberSearch' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberWatched' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MembersDatas' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NavMessage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'News' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ObtainedJob' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Opportunity' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'OpportunityCenter' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'OpportunityFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Partner' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Partners' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PartnersPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Paywall' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PaywallFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityPages' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityType' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Playlist' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Podcast' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastItem' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PromoCode' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurvey' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Radio' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'RadioCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Region' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SectionPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Settings' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Space' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Subscription' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionData' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SumaryNugget' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TextPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ThankYouPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationContext' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationItem' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UmbracoTest' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitProgression' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VODItem' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VODMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VotingFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VotingRecord' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'WatchCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | (
            { __typename?: 'HelpdeskPage' }
            & IHelpdeskPageFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
        ) }
      )>> }
    ) }
  )> }
);

export type IHomePageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IHomePageQuery = (
  { __typename?: 'Query' }
  & { homePage?: Maybe<(
    { __typename?: 'HomePage' }
    & IHomePageFragmentFragment
  )> }
);

export type IAllCourseByPartnerQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllCourseByPartnerQuery = (
  { __typename?: 'Query' }
  & { allCourse: (
    { __typename?: 'CourseConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Course' }
      & IPartCourseFragmentFragment
    )>> }
  ) }
);

export type IAllCourseBySomeIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IAllCourseBySomeIdsQuery = (
  { __typename?: 'Query' }
  & { courses: (
    { __typename?: 'CourseConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Course' }
      & Pick<ICourse, 'title' | 'id' | 'url' | 'length' | 'description'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'url' | 'cropUrl'>
      )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'url' | 'partnerUrl'>
        & { logo?: Maybe<(
          { __typename?: 'MediaWithCrops' }
          & Pick<IMediaWithCrops, 'url'>
        )> }
      ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<(
          { __typename: 'ArtistService' }
          & Pick<IArtistService, 'id'>
        ) | (
          { __typename: 'ArtistServiceFolder' }
          & Pick<IArtistServiceFolder, 'id'>
        ) | (
          { __typename: 'ArtistServicesPage' }
          & Pick<IArtistServicesPage, 'id'>
        ) | (
          { __typename: 'AwardCategoryPage' }
          & Pick<IAwardCategoryPage, 'id'>
        ) | (
          { __typename: 'AwardsArtist' }
          & Pick<IAwardsArtist, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenu' }
          & Pick<IAwardsCategoryMenu, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuDev' }
          & Pick<IAwardsCategoryMenuDev, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolder' }
          & Pick<IAwardsCategoryMenuFolder, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolderDev' }
          & Pick<IAwardsCategoryMenuFolderDev, 'id'>
        ) | (
          { __typename: 'AwardsHomepage' }
          & Pick<IAwardsHomepage, 'id'>
        ) | (
          { __typename: 'CMSPage' }
          & Pick<ICmsPage, 'id'>
        ) | (
          { __typename: 'CategBgColor' }
          & Pick<ICategBgColor, 'id'>
        ) | (
          { __typename: 'CategoryPage' }
          & Pick<ICategoryPage, 'id'>
        ) | (
          { __typename: 'Channel' }
          & Pick<IChannel, 'id'>
        ) | (
          { __typename: 'ChannelFolder' }
          & Pick<IChannelFolder, 'id'>
        ) | (
          { __typename: 'ChoiceNugget' }
          & Pick<IChoiceNugget, 'id'>
        ) | (
          { __typename: 'Collection' }
          & Pick<ICollection, 'id'>
        ) | (
          { __typename: 'ContentEditorFolder' }
          & Pick<IContentEditorFolder, 'id'>
        ) | (
          { __typename: 'ContentTag' }
          & Pick<IContentTag, 'id'>
        ) | (
          { __typename: 'ContentTags' }
          & Pick<IContentTags, 'id'>
        ) | (
          { __typename: 'ContentTagsCateg' }
          & Pick<IContentTagsCateg, 'id'>
        ) | (
          { __typename: 'Course' }
          & Pick<ICourse, 'id'>
        ) | (
          { __typename: 'CourseCategoriesFolder' }
          & Pick<ICourseCategoriesFolder, 'id'>
        ) | (
          { __typename: 'CourseCategory' }
          & Pick<ICourseCategory, 'id'>
        ) | (
          { __typename: 'CourseExam' }
          & Pick<ICourseExam, 'id'>
        ) | (
          { __typename: 'CourseShare' }
          & Pick<ICourseShare, 'id'>
        ) | (
          { __typename: 'CourseStatus' }
          & Pick<ICourseStatus, 'id'>
        ) | (
          { __typename: 'CourseTestProgression' }
          & Pick<ICourseTestProgression, 'id'>
        ) | (
          { __typename: 'CourseUnit' }
          & Pick<ICourseUnit, 'id'>
        ) | (
          { __typename: 'Discovery' }
          & Pick<IDiscovery, 'id'>
        ) | (
          { __typename: 'DiscoverySlide1' }
          & Pick<IDiscoverySlide1, 'id'>
        ) | (
          { __typename: 'EntrepreunarialHub' }
          & Pick<IEntrepreunarialHub, 'id'>
        ) | (
          { __typename: 'FormFolder' }
          & Pick<IFormFolder, 'id'>
        ) | (
          { __typename: 'FormPage' }
          & Pick<IFormPage, 'id'>
        ) | (
          { __typename: 'GapfillNugget' }
          & Pick<IGapfillNugget, 'id'>
        ) | (
          { __typename: 'HelpdeskCateg' }
          & Pick<IHelpdeskCateg, 'id'>
        ) | (
          { __typename: 'HelpdeskFolder' }
          & Pick<IHelpdeskFolder, 'id'>
        ) | (
          { __typename: 'HelpdeskPage' }
          & Pick<IHelpdeskPage, 'id'>
        ) | (
          { __typename: 'HomePage' }
          & Pick<IHomePage, 'id'>
        ) | (
          { __typename: 'JobBoardPage' }
          & Pick<IJobBoardPage, 'id'>
        ) | (
          { __typename: 'JobHub' }
          & Pick<IJobHub, 'id'>
        ) | (
          { __typename: 'JobHubsFolder' }
          & Pick<IJobHubsFolder, 'id'>
        ) | (
          { __typename: 'JobProgress' }
          & Pick<IJobProgress, 'id'>
        ) | (
          { __typename: 'JobShare' }
          & Pick<IJobShare, 'id'>
        ) | (
          { __typename: 'JobTraining' }
          & Pick<IJobTraining, 'id'>
        ) | (
          { __typename: 'JobTrainingFolder' }
          & Pick<IJobTrainingFolder, 'id'>
        ) | (
          { __typename: 'JobVacanciesFolder' }
          & Pick<IJobVacanciesFolder, 'id'>
        ) | (
          { __typename: 'JobVacancy' }
          & Pick<IJobVacancy, 'id'>
        ) | (
          { __typename: 'LandingPage' }
          & Pick<ILandingPage, 'id'>
        ) | (
          { __typename: 'LearnMenu' }
          & Pick<ILearnMenu, 'id'>
        ) | (
          { __typename: 'LegalsFolder' }
          & Pick<ILegalsFolder, 'id'>
        ) | (
          { __typename: 'ListenCateg' }
          & Pick<IListenCateg, 'id'>
        ) | (
          { __typename: 'LiveEvent' }
          & Pick<ILiveEvent, 'id'>
        ) | (
          { __typename: 'LiveEventsMenu' }
          & Pick<ILiveEventsMenu, 'id'>
        ) | (
          { __typename: 'LiveEventsPage' }
          & Pick<ILiveEventsPage, 'id'>
        ) | (
          { __typename: 'LiveTVPage' }
          & Pick<ILiveTvPage, 'id'>
        ) | (
          { __typename: 'MemberContentTypesLink' }
          & Pick<IMemberContentTypesLink, 'id'>
        ) | (
          { __typename: 'MemberDatas' }
          & Pick<IMemberDatas, 'id'>
        ) | (
          { __typename: 'MemberDownloaded' }
          & Pick<IMemberDownloaded, 'id'>
        ) | (
          { __typename: 'MemberMessage' }
          & Pick<IMemberMessage, 'id'>
        ) | (
          { __typename: 'MemberNotify' }
          & Pick<IMemberNotify, 'id'>
        ) | (
          { __typename: 'MemberOpportunity' }
          & Pick<IMemberOpportunity, 'id'>
        ) | (
          { __typename: 'MemberSaved' }
          & Pick<IMemberSaved, 'id'>
        ) | (
          { __typename: 'MemberSearch' }
          & Pick<IMemberSearch, 'id'>
        ) | (
          { __typename: 'MemberWatched' }
          & Pick<IMemberWatched, 'id'>
        ) | (
          { __typename: 'MembersDatas' }
          & Pick<IMembersDatas, 'id'>
        ) | (
          { __typename: 'MiniSitesFolder' }
          & Pick<IMiniSitesFolder, 'id'>
        ) | (
          { __typename: 'NavMessage' }
          & Pick<INavMessage, 'id'>
        ) | (
          { __typename: 'NavigationMessagesFolder' }
          & Pick<INavigationMessagesFolder, 'id'>
        ) | (
          { __typename: 'NetlifyDeploy' }
          & Pick<INetlifyDeploy, 'id'>
        ) | (
          { __typename: 'News' }
          & Pick<INews, 'id'>
        ) | (
          { __typename: 'NewsCateg' }
          & Pick<INewsCateg, 'id'>
        ) | (
          { __typename: 'NewsFolder' }
          & Pick<INewsFolder, 'id'>
        ) | (
          { __typename: 'NewsPage' }
          & Pick<INewsPage, 'id'>
        ) | (
          { __typename: 'ObtainedJob' }
          & Pick<IObtainedJob, 'id'>
        ) | (
          { __typename: 'Opportunity' }
          & Pick<IOpportunity, 'id'>
        ) | (
          { __typename: 'OpportunityCenter' }
          & Pick<IOpportunityCenter, 'id'>
        ) | (
          { __typename: 'OpportunityFolder' }
          & Pick<IOpportunityFolder, 'id'>
        ) | (
          { __typename: 'Partner' }
          & Pick<IPartner, 'id'>
        ) | (
          { __typename: 'Partners' }
          & Pick<IPartners, 'id'>
        ) | (
          { __typename: 'PartnersPage' }
          & Pick<IPartnersPage, 'id'>
        ) | (
          { __typename: 'Paywall' }
          & Pick<IPaywall, 'id'>
        ) | (
          { __typename: 'PaywallFolder' }
          & Pick<IPaywallFolder, 'id'>
        ) | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'id'>
        ) | (
          { __typename: 'PersonalityQuiz' }
          & Pick<IPersonalityQuiz, 'id'>
        ) | (
          { __typename: 'PersonalityQuiz1' }
          & Pick<IPersonalityQuiz1, 'id'>
        ) | (
          { __typename: 'PersonalityType' }
          & Pick<IPersonalityType, 'id'>
        ) | (
          { __typename: 'Playlist' }
          & Pick<IPlaylist, 'id'>
        ) | (
          { __typename: 'PlaylistRadioMenu' }
          & Pick<IPlaylistRadioMenu, 'id'>
        ) | (
          { __typename: 'Podcast' }
          & Pick<IPodcast, 'id'>
        ) | (
          { __typename: 'PodcastCateg' }
          & Pick<IPodcastCateg, 'id'>
        ) | (
          { __typename: 'PodcastItem' }
          & Pick<IPodcastItem, 'id'>
        ) | (
          { __typename: 'PodcastMenu' }
          & Pick<IPodcastMenu, 'id'>
        ) | (
          { __typename: 'PromoCode' }
          & Pick<IPromoCode, 'id'>
        ) | (
          { __typename: 'PromoCodeFolder' }
          & Pick<IPromoCodeFolder, 'id'>
        ) | (
          { __typename: 'QuizPage' }
          & Pick<IQuizPage, 'id'>
        ) | (
          { __typename: 'QuizzSurvey' }
          & Pick<IQuizzSurvey, 'id'>
        ) | (
          { __typename: 'QuizzSurveyCategory' }
          & Pick<IQuizzSurveyCategory, 'id'>
        ) | (
          { __typename: 'QuizzSurveyCollection' }
          & Pick<IQuizzSurveyCollection, 'id'>
        ) | (
          { __typename: 'Radio' }
          & Pick<IRadio, 'id'>
        ) | (
          { __typename: 'RadioCateg' }
          & Pick<IRadioCateg, 'id'>
        ) | (
          { __typename: 'Region' }
          & Pick<IRegion, 'id'>
        ) | (
          { __typename: 'SectionPage' }
          & Pick<ISectionPage, 'id'>
        ) | (
          { __typename: 'Settings' }
          & Pick<ISettings, 'id'>
        ) | (
          { __typename: 'Space' }
          & Pick<ISpace, 'id'>
        ) | (
          { __typename: 'Subscription' }
          & Pick<ISubscription, 'id'>
        ) | (
          { __typename: 'SubscriptionData' }
          & Pick<ISubscriptionData, 'id'>
        ) | (
          { __typename: 'SubscriptionDataFolder' }
          & Pick<ISubscriptionDataFolder, 'id'>
        ) | (
          { __typename: 'SubscriptionsFolder' }
          & Pick<ISubscriptionsFolder, 'id'>
        ) | (
          { __typename: 'SumaryNugget' }
          & Pick<ISumaryNugget, 'id'>
        ) | (
          { __typename: 'SurveyQuizzFolder' }
          & Pick<ISurveyQuizzFolder, 'id'>
        ) | (
          { __typename: 'TextPage' }
          & Pick<ITextPage, 'id'>
        ) | (
          { __typename: 'ThankYouPage' }
          & Pick<IThankYouPage, 'id'>
        ) | (
          { __typename: 'TranslationContext' }
          & Pick<ITranslationContext, 'id'>
        ) | (
          { __typename: 'TranslationFolder' }
          & Pick<ITranslationFolder, 'id'>
        ) | (
          { __typename: 'TranslationItem' }
          & Pick<ITranslationItem, 'id'>
        ) | (
          { __typename: 'UmbracoTest' }
          & Pick<IUmbracoTest, 'id'>
        ) | (
          { __typename: 'UnitNuggetAnswer' }
          & Pick<IUnitNuggetAnswer, 'id'>
        ) | (
          { __typename: 'UnitNuggetGapFillAnswer' }
          & Pick<IUnitNuggetGapFillAnswer, 'id'>
        ) | (
          { __typename: 'UnitProgression' }
          & Pick<IUnitProgression, 'id'>
        ) | (
          { __typename: 'VODItem' }
          & Pick<IVodItem, 'id'>
        ) | (
          { __typename: 'VODMenu' }
          & Pick<IVodMenu, 'id'>
        ) | (
          { __typename: 'VotingFolder' }
          & Pick<IVotingFolder, 'id'>
        ) | (
          { __typename: 'VotingRecord' }
          & Pick<IVotingRecord, 'id'>
        ) | (
          { __typename: 'WatchCateg' }
          & Pick<IWatchCateg, 'id'>
        )>> }
      ) }
    )>> }
  ) }
);

export type IAllCourseCompletedQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllCourseCompletedQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'finished' | 'id'>
        & { course?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & IPartCourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type IAllJobHubQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllJobHubQuery = (
  { __typename?: 'Query' }
  & { allJobHub: (
    { __typename?: 'JobHubConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'JobHub' }
      & IJobHubFragmentFragment
    )>> }
  ) }
);

export type IAllJobTrainingByCourseQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllJobTrainingByCourseQuery = (
  { __typename?: 'Query' }
  & { allJobTraining: (
    { __typename?: 'JobTrainingConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'title' | 'id' | 'url' | 'length'>
      & { cover?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
          { __typename?: 'HeroVideoCover' }
          & IHeroVideoCoverFragmentFragment
        ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
      )>>>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
        { __typename?: 'Partner' }
        & IPartnerFragmentFragment
      ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, courses?: Maybe<Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>>> }
    )>> }
  ) }
);

export type IJobTrainingByCourseQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IJobTrainingByCourseQuery = (
  { __typename?: 'Query' }
  & { allJobTraining: (
    { __typename?: 'JobTrainingConnection' }
    & { items: Array<Maybe<(
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id' | 'name'>
    )>> }
  ) }
);

export type IAllJobTrainingBySomeCourseQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllJobTrainingBySomeCourseQuery = (
  { __typename?: 'Query' }
  & { jobs: (
    { __typename?: 'JobTrainingConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'title' | 'id' | 'url' | 'length'>
      & { cover?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
          { __typename?: 'HeroVideoCover' }
          & IHeroVideoCoverFragmentFragment
        ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
      )>>>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
        { __typename?: 'Partner' }
        & IPartnerFragmentFragment
      ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, courses?: Maybe<Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>>> }
    )>> }
  ) }
);

export type IAllJobTrainingBySomeIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllJobTrainingBySomeIdsQuery = (
  { __typename?: 'Query' }
  & { allJobTraining: (
    { __typename?: 'JobTrainingConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'JobTraining' }
      & Pick<IJobTraining, 'title' | 'id' | 'url' | 'length'>
      & { cover?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
          { __typename?: 'HeroVideoCover' }
          & IHeroVideoCoverFragmentFragment
        ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
      )>>>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
        { __typename?: 'Partner' }
        & IPartnerFragmentFragment
      ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, courses?: Maybe<Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>>> }
    )>> }
  ) }
);

export type IGetAllJobVacancyQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<InputMaybe<IJobVacancyOrderByInput>> | InputMaybe<IJobVacancyOrderByInput>>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetAllJobVacancyQuery = (
  { __typename?: 'Query' }
  & { allJobVacancy: (
    { __typename?: 'JobVacancyConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'JobVacancy' }
      & IJobVacancyFragmentFragment
    )>> }
  ) }
);

export type IGetAllOpportunityQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<InputMaybe<IOpportunityOrderByInput>> | InputMaybe<IOpportunityOrderByInput>>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetAllOpportunityQuery = (
  { __typename?: 'Query' }
  & { allOpportunity: (
    { __typename?: 'OpportunityConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Opportunity' }
      & IOpportunityFragmentFragment
    )>> }
  ) }
);

export type IAllOpportunityByJobsQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IAllOpportunityByJobsQuery = (
  { __typename?: 'Query' }
  & { allOpportunity: (
    { __typename?: 'OpportunityConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'title' | 'shortDescription' | 'startDate' | 'id' | 'endDate' | 'url'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'url'>
      )>, partners?: Maybe<Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
        & { logo?: Maybe<(
          { __typename?: 'MediaWithCrops' }
          & Pick<IMediaWithCrops, 'url'>
        )> }
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>>> }
    )>> }
  ) }
);

export type IAllOpportunityByPartnerQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllOpportunityByPartnerQuery = (
  { __typename?: 'Query' }
  & { allOpportunity: (
    { __typename?: 'OpportunityConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Opportunity' }
      & IOpportunityFragmentFragment
    )>> }
  ) }
);

export type IAllOpportunityByIdQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IAllOpportunityByIdQuery = (
  { __typename?: 'Query' }
  & { allOpportunity: (
    { __typename?: 'OpportunityConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'title' | 'shortDescription' | 'startDate' | 'id' | 'endDate' | 'url'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'url'>
      )>, partners?: Maybe<Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
        & { logo?: Maybe<(
          { __typename?: 'MediaWithCrops' }
          & Pick<IMediaWithCrops, 'url'>
        )> }
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>>> }
    )>> }
  ) }
);

export type IAllPartnerQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllPartnerQuery = (
  { __typename?: 'Query' }
  & { allPartner: (
    { __typename?: 'PartnerConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Partner' }
      & IPartnerFragmentFragment
    )>> }
  ) }
);

export type ICountCourseUnitProgressionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  courseUnits?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  courseId?: InputMaybe<Scalars['String']>;
}>;


export type ICountCourseUnitProgressionQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'name' | 'finished' | 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )>, courseStatus?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'finished' | 'id'>
        & { course?: Maybe<(
          { __typename: 'ArtistService' }
          & Pick<IArtistService, 'id'>
        ) | (
          { __typename: 'ArtistServiceFolder' }
          & Pick<IArtistServiceFolder, 'id'>
        ) | (
          { __typename: 'ArtistServicesPage' }
          & Pick<IArtistServicesPage, 'id'>
        ) | (
          { __typename: 'AwardCategoryPage' }
          & Pick<IAwardCategoryPage, 'id'>
        ) | (
          { __typename: 'AwardsArtist' }
          & Pick<IAwardsArtist, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenu' }
          & Pick<IAwardsCategoryMenu, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuDev' }
          & Pick<IAwardsCategoryMenuDev, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolder' }
          & Pick<IAwardsCategoryMenuFolder, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolderDev' }
          & Pick<IAwardsCategoryMenuFolderDev, 'id'>
        ) | (
          { __typename: 'AwardsHomepage' }
          & Pick<IAwardsHomepage, 'id'>
        ) | (
          { __typename: 'CMSPage' }
          & Pick<ICmsPage, 'id'>
        ) | (
          { __typename: 'CategBgColor' }
          & Pick<ICategBgColor, 'id'>
        ) | (
          { __typename: 'CategoryPage' }
          & Pick<ICategoryPage, 'id'>
        ) | (
          { __typename: 'Channel' }
          & Pick<IChannel, 'id'>
        ) | (
          { __typename: 'ChannelFolder' }
          & Pick<IChannelFolder, 'id'>
        ) | (
          { __typename: 'ChoiceNugget' }
          & Pick<IChoiceNugget, 'id'>
        ) | (
          { __typename: 'Collection' }
          & Pick<ICollection, 'id'>
        ) | (
          { __typename: 'ContentEditorFolder' }
          & Pick<IContentEditorFolder, 'id'>
        ) | (
          { __typename: 'ContentTag' }
          & Pick<IContentTag, 'id'>
        ) | (
          { __typename: 'ContentTags' }
          & Pick<IContentTags, 'id'>
        ) | (
          { __typename: 'ContentTagsCateg' }
          & Pick<IContentTagsCateg, 'id'>
        ) | (
          { __typename: 'Course' }
          & Pick<ICourse, 'id'>
        ) | (
          { __typename: 'CourseCategoriesFolder' }
          & Pick<ICourseCategoriesFolder, 'id'>
        ) | (
          { __typename: 'CourseCategory' }
          & Pick<ICourseCategory, 'id'>
        ) | (
          { __typename: 'CourseExam' }
          & Pick<ICourseExam, 'id'>
        ) | (
          { __typename: 'CourseShare' }
          & Pick<ICourseShare, 'id'>
        ) | (
          { __typename: 'CourseStatus' }
          & Pick<ICourseStatus, 'id'>
        ) | (
          { __typename: 'CourseTestProgression' }
          & Pick<ICourseTestProgression, 'id'>
        ) | (
          { __typename: 'CourseUnit' }
          & Pick<ICourseUnit, 'id'>
        ) | (
          { __typename: 'Discovery' }
          & Pick<IDiscovery, 'id'>
        ) | (
          { __typename: 'DiscoverySlide1' }
          & Pick<IDiscoverySlide1, 'id'>
        ) | (
          { __typename: 'EntrepreunarialHub' }
          & Pick<IEntrepreunarialHub, 'id'>
        ) | (
          { __typename: 'FormFolder' }
          & Pick<IFormFolder, 'id'>
        ) | (
          { __typename: 'FormPage' }
          & Pick<IFormPage, 'id'>
        ) | (
          { __typename: 'GapfillNugget' }
          & Pick<IGapfillNugget, 'id'>
        ) | (
          { __typename: 'HelpdeskCateg' }
          & Pick<IHelpdeskCateg, 'id'>
        ) | (
          { __typename: 'HelpdeskFolder' }
          & Pick<IHelpdeskFolder, 'id'>
        ) | (
          { __typename: 'HelpdeskPage' }
          & Pick<IHelpdeskPage, 'id'>
        ) | (
          { __typename: 'HomePage' }
          & Pick<IHomePage, 'id'>
        ) | (
          { __typename: 'JobBoardPage' }
          & Pick<IJobBoardPage, 'id'>
        ) | (
          { __typename: 'JobHub' }
          & Pick<IJobHub, 'id'>
        ) | (
          { __typename: 'JobHubsFolder' }
          & Pick<IJobHubsFolder, 'id'>
        ) | (
          { __typename: 'JobProgress' }
          & Pick<IJobProgress, 'id'>
        ) | (
          { __typename: 'JobShare' }
          & Pick<IJobShare, 'id'>
        ) | (
          { __typename: 'JobTraining' }
          & Pick<IJobTraining, 'id'>
        ) | (
          { __typename: 'JobTrainingFolder' }
          & Pick<IJobTrainingFolder, 'id'>
        ) | (
          { __typename: 'JobVacanciesFolder' }
          & Pick<IJobVacanciesFolder, 'id'>
        ) | (
          { __typename: 'JobVacancy' }
          & Pick<IJobVacancy, 'id'>
        ) | (
          { __typename: 'LandingPage' }
          & Pick<ILandingPage, 'id'>
        ) | (
          { __typename: 'LearnMenu' }
          & Pick<ILearnMenu, 'id'>
        ) | (
          { __typename: 'LegalsFolder' }
          & Pick<ILegalsFolder, 'id'>
        ) | (
          { __typename: 'ListenCateg' }
          & Pick<IListenCateg, 'id'>
        ) | (
          { __typename: 'LiveEvent' }
          & Pick<ILiveEvent, 'id'>
        ) | (
          { __typename: 'LiveEventsMenu' }
          & Pick<ILiveEventsMenu, 'id'>
        ) | (
          { __typename: 'LiveEventsPage' }
          & Pick<ILiveEventsPage, 'id'>
        ) | (
          { __typename: 'LiveTVPage' }
          & Pick<ILiveTvPage, 'id'>
        ) | (
          { __typename: 'MemberContentTypesLink' }
          & Pick<IMemberContentTypesLink, 'id'>
        ) | (
          { __typename: 'MemberDatas' }
          & Pick<IMemberDatas, 'id'>
        ) | (
          { __typename: 'MemberDownloaded' }
          & Pick<IMemberDownloaded, 'id'>
        ) | (
          { __typename: 'MemberMessage' }
          & Pick<IMemberMessage, 'id'>
        ) | (
          { __typename: 'MemberNotify' }
          & Pick<IMemberNotify, 'id'>
        ) | (
          { __typename: 'MemberOpportunity' }
          & Pick<IMemberOpportunity, 'id'>
        ) | (
          { __typename: 'MemberSaved' }
          & Pick<IMemberSaved, 'id'>
        ) | (
          { __typename: 'MemberSearch' }
          & Pick<IMemberSearch, 'id'>
        ) | (
          { __typename: 'MemberWatched' }
          & Pick<IMemberWatched, 'id'>
        ) | (
          { __typename: 'MembersDatas' }
          & Pick<IMembersDatas, 'id'>
        ) | (
          { __typename: 'MiniSitesFolder' }
          & Pick<IMiniSitesFolder, 'id'>
        ) | (
          { __typename: 'NavMessage' }
          & Pick<INavMessage, 'id'>
        ) | (
          { __typename: 'NavigationMessagesFolder' }
          & Pick<INavigationMessagesFolder, 'id'>
        ) | (
          { __typename: 'NetlifyDeploy' }
          & Pick<INetlifyDeploy, 'id'>
        ) | (
          { __typename: 'News' }
          & Pick<INews, 'id'>
        ) | (
          { __typename: 'NewsCateg' }
          & Pick<INewsCateg, 'id'>
        ) | (
          { __typename: 'NewsFolder' }
          & Pick<INewsFolder, 'id'>
        ) | (
          { __typename: 'NewsPage' }
          & Pick<INewsPage, 'id'>
        ) | (
          { __typename: 'ObtainedJob' }
          & Pick<IObtainedJob, 'id'>
        ) | (
          { __typename: 'Opportunity' }
          & Pick<IOpportunity, 'id'>
        ) | (
          { __typename: 'OpportunityCenter' }
          & Pick<IOpportunityCenter, 'id'>
        ) | (
          { __typename: 'OpportunityFolder' }
          & Pick<IOpportunityFolder, 'id'>
        ) | (
          { __typename: 'Partner' }
          & Pick<IPartner, 'id'>
        ) | (
          { __typename: 'Partners' }
          & Pick<IPartners, 'id'>
        ) | (
          { __typename: 'PartnersPage' }
          & Pick<IPartnersPage, 'id'>
        ) | (
          { __typename: 'Paywall' }
          & Pick<IPaywall, 'id'>
        ) | (
          { __typename: 'PaywallFolder' }
          & Pick<IPaywallFolder, 'id'>
        ) | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'id'>
        ) | (
          { __typename: 'PersonalityQuiz' }
          & Pick<IPersonalityQuiz, 'id'>
        ) | (
          { __typename: 'PersonalityQuiz1' }
          & Pick<IPersonalityQuiz1, 'id'>
        ) | (
          { __typename: 'PersonalityType' }
          & Pick<IPersonalityType, 'id'>
        ) | (
          { __typename: 'Playlist' }
          & Pick<IPlaylist, 'id'>
        ) | (
          { __typename: 'PlaylistRadioMenu' }
          & Pick<IPlaylistRadioMenu, 'id'>
        ) | (
          { __typename: 'Podcast' }
          & Pick<IPodcast, 'id'>
        ) | (
          { __typename: 'PodcastCateg' }
          & Pick<IPodcastCateg, 'id'>
        ) | (
          { __typename: 'PodcastItem' }
          & Pick<IPodcastItem, 'id'>
        ) | (
          { __typename: 'PodcastMenu' }
          & Pick<IPodcastMenu, 'id'>
        ) | (
          { __typename: 'PromoCode' }
          & Pick<IPromoCode, 'id'>
        ) | (
          { __typename: 'PromoCodeFolder' }
          & Pick<IPromoCodeFolder, 'id'>
        ) | (
          { __typename: 'QuizPage' }
          & Pick<IQuizPage, 'id'>
        ) | (
          { __typename: 'QuizzSurvey' }
          & Pick<IQuizzSurvey, 'id'>
        ) | (
          { __typename: 'QuizzSurveyCategory' }
          & Pick<IQuizzSurveyCategory, 'id'>
        ) | (
          { __typename: 'QuizzSurveyCollection' }
          & Pick<IQuizzSurveyCollection, 'id'>
        ) | (
          { __typename: 'Radio' }
          & Pick<IRadio, 'id'>
        ) | (
          { __typename: 'RadioCateg' }
          & Pick<IRadioCateg, 'id'>
        ) | (
          { __typename: 'Region' }
          & Pick<IRegion, 'id'>
        ) | (
          { __typename: 'SectionPage' }
          & Pick<ISectionPage, 'id'>
        ) | (
          { __typename: 'Settings' }
          & Pick<ISettings, 'id'>
        ) | (
          { __typename: 'Space' }
          & Pick<ISpace, 'id'>
        ) | (
          { __typename: 'Subscription' }
          & Pick<ISubscription, 'id'>
        ) | (
          { __typename: 'SubscriptionData' }
          & Pick<ISubscriptionData, 'id'>
        ) | (
          { __typename: 'SubscriptionDataFolder' }
          & Pick<ISubscriptionDataFolder, 'id'>
        ) | (
          { __typename: 'SubscriptionsFolder' }
          & Pick<ISubscriptionsFolder, 'id'>
        ) | (
          { __typename: 'SumaryNugget' }
          & Pick<ISumaryNugget, 'id'>
        ) | (
          { __typename: 'SurveyQuizzFolder' }
          & Pick<ISurveyQuizzFolder, 'id'>
        ) | (
          { __typename: 'TextPage' }
          & Pick<ITextPage, 'id'>
        ) | (
          { __typename: 'ThankYouPage' }
          & Pick<IThankYouPage, 'id'>
        ) | (
          { __typename: 'TranslationContext' }
          & Pick<ITranslationContext, 'id'>
        ) | (
          { __typename: 'TranslationFolder' }
          & Pick<ITranslationFolder, 'id'>
        ) | (
          { __typename: 'TranslationItem' }
          & Pick<ITranslationItem, 'id'>
        ) | (
          { __typename: 'UmbracoTest' }
          & Pick<IUmbracoTest, 'id'>
        ) | (
          { __typename: 'UnitNuggetAnswer' }
          & Pick<IUnitNuggetAnswer, 'id'>
        ) | (
          { __typename: 'UnitNuggetGapFillAnswer' }
          & Pick<IUnitNuggetGapFillAnswer, 'id'>
        ) | (
          { __typename: 'UnitProgression' }
          & Pick<IUnitProgression, 'id'>
        ) | (
          { __typename: 'VODItem' }
          & Pick<IVodItem, 'id'>
        ) | (
          { __typename: 'VODMenu' }
          & Pick<IVodMenu, 'id'>
        ) | (
          { __typename: 'VotingFolder' }
          & Pick<IVotingFolder, 'id'>
        ) | (
          { __typename: 'VotingRecord' }
          & Pick<IVotingRecord, 'id'>
        ) | (
          { __typename: 'WatchCateg' }
          & Pick<IWatchCateg, 'id'>
        )> }
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type ICourseByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICourseByUrlQuery = (
  { __typename?: 'Query' }
  & { course?: Maybe<(
    { __typename?: 'Course' }
    & ICourseFragmentFragment
  )> }
);

export type ICourseByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICourseByIdQuery = (
  { __typename?: 'Query' }
  & { course?: Maybe<(
    { __typename?: 'Course' }
    & ICourseFragmentFragment
  )> }
);

export type ICourseByEndUrlQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICourseByEndUrlQuery = (
  { __typename?: 'Query' }
  & { allCourse: (
    { __typename?: 'CourseConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Course' }
      & ICourseFragmentFragment
    )>> }
  ) }
);

export type ICourseOverviewFragmentFragment = (
  { __typename: 'Course' }
  & Pick<ICourse, 'id' | 'name'>
  & { children: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | (
      { __typename?: 'CourseExam' }
      & ICourseExamOverviewFragmentFragment
    ) | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | (
      { __typename?: 'CourseUnit' }
      & ICourseUnitOverviewFragmentFragment
    ) | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
  ) }
);

export type ICourseExamOverviewFragmentFragment = (
  { __typename: 'CourseExam' }
  & Pick<ICourseExam, 'id' | 'length'>
);

export type ICourseNuggetOverviewFragmentFragment = (
  { __typename: 'CourseNugget' }
  & { nuggets?: Maybe<Array<Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'id'>
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'id'>
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'id'>
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'id'>
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'id'>
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'id'>
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'id'>
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'id'>
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'id'>
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'id'>
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'id'>
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'id'>
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'id'>
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'id'>
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'id'>
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'id'>
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'id'>
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'id'>
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'id'>
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'id'>
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'id'>
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'id'>
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'id'>
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'id'>
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'id'>
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'id'>
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'id'>
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'id'>
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'id'>
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'id'>
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'id'>
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'id'>
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'id'>
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'id'>
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'id'>
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'id'>
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'id'>
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'id'>
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'id'>
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'id'>
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'id'>
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'id'>
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'id'>
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'id'>
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'id'>
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'id'>
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'id'>
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'id'>
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'id'>
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'id'>
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'id'>
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'id'>
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'id'>
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'id'>
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'id'>
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'id'>
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'id'>
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'id'>
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'id'>
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'id'>
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'id'>
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'id'>
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'id'>
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'id'>
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'id'>
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'id'>
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'id'>
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'id'>
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'id'>
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'id'>
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'id'>
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'id'>
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id'>
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'id'>
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'id'>
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'id'>
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'id'>
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'id'>
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'id'>
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'id'>
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id'>
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'id'>
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'id'>
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'id'>
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'id'>
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'id'>
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'id'>
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'id'>
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'id'>
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'id'>
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'id'>
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id'>
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id'>
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'id'>
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id'>
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'id'>
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'id'>
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'id'>
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'id'>
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'id'>
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'id'>
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'id'>
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'id'>
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'id'>
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'id'>
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'id'>
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'id'>
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'id'>
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'id'>
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'id'>
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'id'>
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'id'>
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'id'>
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'id'>
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'id'>
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'id'>
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'id'>
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'id'>
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'id'>
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'id'>
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'id'>
  )>>> }
);

export type ICoursePageOverviewFragmentFragment = (
  { __typename: 'CoursePage' }
  & { blocks?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type ICourseUnitOverviewFragmentFragment = (
  { __typename: 'CourseUnit' }
  & Pick<ICourseUnit, 'id' | 'length'>
  & { pages?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | (
      { __typename?: 'CourseNugget' }
      & ICourseNuggetOverviewFragmentFragment
    ) | (
      { __typename?: 'CoursePage' }
      & ICoursePageOverviewFragmentFragment
    ) | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type ICourseExamByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICourseExamByIdQuery = (
  { __typename?: 'Query' }
  & { courseExam?: Maybe<(
    { __typename?: 'CourseExam' }
    & ICourseExamFragmentFragment
  )> }
);

export type ICourseExamByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICourseExamByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allCourseExam: (
    { __typename?: 'CourseExamConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'CourseExam' }
      & ICourseExamFragmentFragment
    )>> }
  ) }
);

export type ICourseOverviewByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type ICourseOverviewByIdQuery = (
  { __typename?: 'Query' }
  & { course?: Maybe<(
    { __typename?: 'Course' }
    & ICourseOverviewFragmentFragment
  )> }
);

export type ICourseUnitByEndUrlQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICourseUnitByEndUrlQuery = (
  { __typename?: 'Query' }
  & { allCourseUnit: (
    { __typename?: 'CourseUnitConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'CourseUnit' }
      & ICourseUnitFragmentFragment
    )>> }
  ) }
);

export type ICourseByUnitIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICourseByUnitIdQuery = (
  { __typename?: 'Query' }
  & { courseUnit?: Maybe<(
    { __typename?: 'CourseUnit' }
    & ICourseUnitFragmentFragment
  )> }
);

export type IGetCourseDownloadQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetCourseDownloadQuery = (
  { __typename?: 'Query' }
  & { course?: Maybe<(
    { __typename?: 'Course' }
    & IDownloadCourseFragmentFragment
  )> }
);

export type IGetJobDownloadQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetJobDownloadQuery = (
  { __typename?: 'Query' }
  & { jobTraining?: Maybe<(
    { __typename?: 'JobTraining' }
    & IDownloadJobTrainingFragmentFragment
  )> }
);

export type IEntrepreneurialHubByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IEntrepreneurialHubByIdQuery = (
  { __typename?: 'Query' }
  & { entrepreunarialHub?: Maybe<(
    { __typename?: 'EntrepreunarialHub' }
    & IEntrepreunarialHubFragmentFragment
  )> }
);

export type IEntrepreneurialHubByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IEntrepreneurialHubByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allEntrepreunarialHub: (
    { __typename?: 'EntrepreunarialHubConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'EntrepreunarialHub' }
      & IEntrepreunarialHubFragmentFragment
    )>> }
  ) }
);

export type IGetExamOverviewQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetExamOverviewQuery = (
  { __typename?: 'Query' }
  & { allLearnMenu: (
    { __typename?: 'LearnMenuConnection' }
    & { items: Array<Maybe<(
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'pageContent' | 'subtitle'>
      & { cover?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
          { __typename?: 'HeroVideoCover' }
          & IHeroVideoCoverFragmentFragment
        ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
      )>>>, positiveResult?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | (
          { __typename: 'Wysiwyg' }
          & IWysiwygFragmentFragment
        ) }
      )>>>, negativeResult?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | (
          { __typename: 'Wysiwyg' }
          & IWysiwygFragmentFragment
        ) }
      )>>> }
    )>> }
  ) }
);

export type IGetExamResultQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IGetExamResultQuery = (
  { __typename?: 'Query' }
  & { allLearnMenu: (
    { __typename?: 'LearnMenuConnection' }
    & { items: Array<Maybe<(
      { __typename: 'LearnMenu' }
      & { positiveResult?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | (
          { __typename: 'Wysiwyg' }
          & IWysiwygFragmentFragment
        ) }
      )>>>, negativeResult?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | (
          { __typename: 'Wysiwyg' }
          & IWysiwygFragmentFragment
        ) }
      )>>> }
    )>> }
  ) }
);

export type IGetOpportunityCenterQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IGetOpportunityCenterQuery = (
  { __typename?: 'Query' }
  & { opportunityCenter?: Maybe<(
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'id' | 'url' | 'opportunityTitle' | 'opportunitySubtitle'>
  )> }
);

export type IGetOpportunityCenterByUrlEndQueryVariables = Exact<{
  urlEnd?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IGetOpportunityCenterByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allOpportunityCenter: (
    { __typename?: 'OpportunityCenterConnection' }
    & { items: Array<Maybe<(
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id' | 'url' | 'opportunityTitle' | 'opportunitySubtitle'>
    )>> }
  ) }
);

export type IJobBoardPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IJobBoardPageByIdQuery = (
  { __typename?: 'Query' }
  & { jobBoardPage?: Maybe<(
    { __typename?: 'JobBoardPage' }
    & IJobBoardPageFragmentFragment
  )> }
);

export type IJobBoardPageByUrlEndQueryVariables = Exact<{
  urlEnd?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IJobBoardPageByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allJobBoardPage: (
    { __typename?: 'JobBoardPageConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'JobBoardPage' }
      & IJobBoardPageFragmentFragment
    )>> }
  ) }
);

export type IJobTrainingByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IJobTrainingByIdQuery = (
  { __typename?: 'Query' }
  & { jobTraining?: Maybe<(
    { __typename?: 'JobTraining' }
    & IJobTrainingFragmentFragment
  )> }
);

export type IJobTrainingByUrlEndQueryVariables = Exact<{
  urlEnd?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IJobTrainingByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allJobTraining: (
    { __typename?: 'JobTrainingConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'JobTraining' }
      & IJobTrainingFragmentFragment
    )>> }
  ) }
);

export type IJobTrainingOverviewFragmentFragment = (
  { __typename: 'JobTraining' }
  & Pick<IJobTraining, 'id' | 'url' | 'name' | 'quizzes'>
  & { courses?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | (
    { __typename?: 'Course' }
    & ICourseOverviewFragmentFragment
  ) | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
);

export type IJobTrainingOverviewByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IJobTrainingOverviewByIdQuery = (
  { __typename?: 'Query' }
  & { jobTraining?: Maybe<(
    { __typename?: 'JobTraining' }
    & IJobTrainingOverviewFragmentFragment
  )> }
);

export type IJobTrainingOverviewByUrlEndQueryVariables = Exact<{
  urlEnd?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IJobTrainingOverviewByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allJobTraining: (
    { __typename?: 'JobTrainingConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'JobTraining' }
      & IJobTrainingOverviewFragmentFragment
    )>> }
  ) }
);

export type IOpportunityByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IOpportunityByIdQuery = (
  { __typename?: 'Query' }
  & { opportunity?: Maybe<(
    { __typename?: 'Opportunity' }
    & IOpportunityFragmentFragment
  )> }
);

export type IOpportunityByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IOpportunityByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allOpportunity: (
    { __typename?: 'OpportunityConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Opportunity' }
      & IOpportunityFragmentFragment
    )>> }
  ) }
);

export type IPartnerByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPartnerByIdQuery = (
  { __typename?: 'Query' }
  & { partner?: Maybe<(
    { __typename?: 'Partner' }
    & IPartnerFragmentFragment
  )> }
);

export type IPartnerByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPartnerByUrlQuery = (
  { __typename?: 'Query' }
  & { partner?: Maybe<(
    { __typename?: 'Partner' }
    & IPartnerFragmentFragment
  )> }
);

export type IPartnerByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPartnerByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allPartner: (
    { __typename?: 'PartnerConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Partner' }
      & IPartnerFragmentFragment
    )>> }
  ) }
);

export type IPartnerRelatedContentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPartnerRelatedContentQuery = (
  { __typename?: 'Query' }
  & { partner?: Maybe<(
    { __typename: 'Partner' }
    & { parent?: Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
          { __typename: 'Partner' }
          & IPartnerFragmentFragment
        ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
    )> }
  )> }
);

export type IPartnersPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPartnersPageByIdQuery = (
  { __typename?: 'Query' }
  & { partnersPage?: Maybe<(
    { __typename: 'PartnersPage' }
    & IPartnersPageFragmentFragment
  )> }
);

export type IAllCourseByPersonalityQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllCourseByPersonalityQuery = (
  { __typename?: 'Query' }
  & { allCourse: (
    { __typename?: 'CourseConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'url' | 'name' | 'title' | 'trailer' | 'description'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'url'>
      )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
        { __typename: 'Partner' }
        & IPartnerFragmentFragment
      ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
    )>> }
  ) }
);

export type IGetAllPersonalityPagesByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetAllPersonalityPagesByIdQuery = (
  { __typename?: 'Query' }
  & { quizPage?: Maybe<(
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'url' | 'personalitiesTitle' | 'personalitiesSubtitle' | 'personalitiesCTALabel'>
    & { personalitiesCover?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
        { __typename?: 'HeroVideoCover' }
        & IHeroVideoCoverFragmentFragment
      ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
    )>>>, quizz?: Maybe<Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
          & { icon?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & Pick<IMediaWithCrops, 'url'>
          )> }
        ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
    )>>> }
  )> }
);

export type IGetAllPersonalityPagesByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetAllPersonalityPagesByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allQuizPage: (
    { __typename?: 'QuizPageConnection' }
    & { items: Array<Maybe<(
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'url' | 'personalitiesTitle' | 'personalitiesSubtitle' | 'personalitiesCTALabel'>
      & { personalitiesCover?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
          { __typename?: 'HeroVideoCover' }
          & IHeroVideoCoverFragmentFragment
        ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
      )>>>, quizz?: Maybe<Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | (
            { __typename: 'PersonalityPages' }
            & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
            & { icon?: Maybe<(
              { __typename?: 'MediaWithCrops' }
              & Pick<IMediaWithCrops, 'url'>
            )> }
          ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>>> }
    )>> }
  ) }
);

export type IGetPersonalityByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetPersonalityByIdQuery = (
  { __typename?: 'Query' }
  & { personalityQuiz?: Maybe<(
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url' | 'personalitiesTitle' | 'personalitiesSubtitle' | 'personalitiesCTALabel'>
    & { personalitiesCover?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
        { __typename?: 'HeroVideoCover' }
        & IHeroVideoCoverFragmentFragment
      ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
    )>>>, children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
        & { icon?: Maybe<(
          { __typename?: 'MediaWithCrops' }
          & Pick<IMediaWithCrops, 'url'>
        )> }
      ) | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  )> }
);

export type IGetPersonalityPageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetPersonalityPageQuery = (
  { __typename?: 'Query' }
  & { personalityPages?: Maybe<(
    { __typename?: 'PersonalityPages' }
    & { parent?: Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
          & { icon?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & Pick<IMediaWithCrops, 'url'>
          )> }
        ) | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
    )> }
    & IPersonalityPagesFragmentFragment
  )> }
);

export type IGetPersonalityQuizResultQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  quizId?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetPersonalityQuizResultQuery = (
  { __typename?: 'Query' }
  & { personalityQuiz?: Maybe<(
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'url' | 'name' | 'resultTitle' | 'resultSubtitle'>
  )>, allPersonalityPages: (
    { __typename?: 'PersonalityPagesConnection' }
    & { items: Array<Maybe<(
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
      & { icon?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'url'>
      )> }
    )>> }
  ) }
);

export type IQuizResultByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IQuizResultByIdQuery = (
  { __typename?: 'Query' }
  & { quizPage?: Maybe<(
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name' | 'url' | 'resultSubtitle' | 'resultTitle' | 'ctaLabel'>
    & { quizz?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | (
          { __typename: 'PersonalityQuizQuestion' }
          & IPersonalityQuizQuestionFragmentFragment
        ) | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>>, children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
          & { icon?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & { url: IMediaWithCrops['cropUrl'] }
          )>, linkedTag?: Maybe<Array<Maybe<(
            { __typename: 'ArtistService' }
            & Pick<IArtistService, 'id'>
          ) | (
            { __typename: 'ArtistServiceFolder' }
            & Pick<IArtistServiceFolder, 'id'>
          ) | (
            { __typename: 'ArtistServicesPage' }
            & Pick<IArtistServicesPage, 'id'>
          ) | (
            { __typename: 'AwardCategoryPage' }
            & Pick<IAwardCategoryPage, 'id'>
          ) | (
            { __typename: 'AwardsArtist' }
            & Pick<IAwardsArtist, 'id'>
          ) | (
            { __typename: 'AwardsCategoryMenu' }
            & Pick<IAwardsCategoryMenu, 'id'>
          ) | (
            { __typename: 'AwardsCategoryMenuDev' }
            & Pick<IAwardsCategoryMenuDev, 'id'>
          ) | (
            { __typename: 'AwardsCategoryMenuFolder' }
            & Pick<IAwardsCategoryMenuFolder, 'id'>
          ) | (
            { __typename: 'AwardsCategoryMenuFolderDev' }
            & Pick<IAwardsCategoryMenuFolderDev, 'id'>
          ) | (
            { __typename: 'AwardsHomepage' }
            & Pick<IAwardsHomepage, 'id'>
          ) | (
            { __typename: 'CMSPage' }
            & Pick<ICmsPage, 'id'>
          ) | (
            { __typename: 'CategBgColor' }
            & Pick<ICategBgColor, 'id'>
          ) | (
            { __typename: 'CategoryPage' }
            & Pick<ICategoryPage, 'id'>
          ) | (
            { __typename: 'Channel' }
            & Pick<IChannel, 'id'>
          ) | (
            { __typename: 'ChannelFolder' }
            & Pick<IChannelFolder, 'id'>
          ) | (
            { __typename: 'ChoiceNugget' }
            & Pick<IChoiceNugget, 'id'>
          ) | (
            { __typename: 'Collection' }
            & Pick<ICollection, 'id'>
          ) | (
            { __typename: 'ContentEditorFolder' }
            & Pick<IContentEditorFolder, 'id'>
          ) | (
            { __typename: 'ContentTag' }
            & Pick<IContentTag, 'color' | 'name' | 'id'>
          ) | (
            { __typename: 'ContentTags' }
            & Pick<IContentTags, 'id'>
          ) | (
            { __typename: 'ContentTagsCateg' }
            & Pick<IContentTagsCateg, 'id'>
          ) | (
            { __typename: 'Course' }
            & Pick<ICourse, 'id'>
          ) | (
            { __typename: 'CourseCategoriesFolder' }
            & Pick<ICourseCategoriesFolder, 'id'>
          ) | (
            { __typename: 'CourseCategory' }
            & Pick<ICourseCategory, 'id'>
          ) | (
            { __typename: 'CourseExam' }
            & Pick<ICourseExam, 'id'>
          ) | (
            { __typename: 'CourseShare' }
            & Pick<ICourseShare, 'id'>
          ) | (
            { __typename: 'CourseStatus' }
            & Pick<ICourseStatus, 'id'>
          ) | (
            { __typename: 'CourseTestProgression' }
            & Pick<ICourseTestProgression, 'id'>
          ) | (
            { __typename: 'CourseUnit' }
            & Pick<ICourseUnit, 'id'>
          ) | (
            { __typename: 'Discovery' }
            & Pick<IDiscovery, 'id'>
          ) | (
            { __typename: 'DiscoverySlide1' }
            & Pick<IDiscoverySlide1, 'id'>
          ) | (
            { __typename: 'EntrepreunarialHub' }
            & Pick<IEntrepreunarialHub, 'id'>
          ) | (
            { __typename: 'FormFolder' }
            & Pick<IFormFolder, 'id'>
          ) | (
            { __typename: 'FormPage' }
            & Pick<IFormPage, 'id'>
          ) | (
            { __typename: 'GapfillNugget' }
            & Pick<IGapfillNugget, 'id'>
          ) | (
            { __typename: 'HelpdeskCateg' }
            & Pick<IHelpdeskCateg, 'id'>
          ) | (
            { __typename: 'HelpdeskFolder' }
            & Pick<IHelpdeskFolder, 'id'>
          ) | (
            { __typename: 'HelpdeskPage' }
            & Pick<IHelpdeskPage, 'id'>
          ) | (
            { __typename: 'HomePage' }
            & Pick<IHomePage, 'id'>
          ) | (
            { __typename: 'JobBoardPage' }
            & Pick<IJobBoardPage, 'id'>
          ) | (
            { __typename: 'JobHub' }
            & Pick<IJobHub, 'id'>
          ) | (
            { __typename: 'JobHubsFolder' }
            & Pick<IJobHubsFolder, 'id'>
          ) | (
            { __typename: 'JobProgress' }
            & Pick<IJobProgress, 'id'>
          ) | (
            { __typename: 'JobShare' }
            & Pick<IJobShare, 'id'>
          ) | (
            { __typename: 'JobTraining' }
            & Pick<IJobTraining, 'id'>
          ) | (
            { __typename: 'JobTrainingFolder' }
            & Pick<IJobTrainingFolder, 'id'>
          ) | (
            { __typename: 'JobVacanciesFolder' }
            & Pick<IJobVacanciesFolder, 'id'>
          ) | (
            { __typename: 'JobVacancy' }
            & Pick<IJobVacancy, 'id'>
          ) | (
            { __typename: 'LandingPage' }
            & Pick<ILandingPage, 'id'>
          ) | (
            { __typename: 'LearnMenu' }
            & Pick<ILearnMenu, 'id'>
          ) | (
            { __typename: 'LegalsFolder' }
            & Pick<ILegalsFolder, 'id'>
          ) | (
            { __typename: 'ListenCateg' }
            & Pick<IListenCateg, 'id'>
          ) | (
            { __typename: 'LiveEvent' }
            & Pick<ILiveEvent, 'id'>
          ) | (
            { __typename: 'LiveEventsMenu' }
            & Pick<ILiveEventsMenu, 'id'>
          ) | (
            { __typename: 'LiveEventsPage' }
            & Pick<ILiveEventsPage, 'id'>
          ) | (
            { __typename: 'LiveTVPage' }
            & Pick<ILiveTvPage, 'id'>
          ) | (
            { __typename: 'MemberContentTypesLink' }
            & Pick<IMemberContentTypesLink, 'id'>
          ) | (
            { __typename: 'MemberDatas' }
            & Pick<IMemberDatas, 'id'>
          ) | (
            { __typename: 'MemberDownloaded' }
            & Pick<IMemberDownloaded, 'id'>
          ) | (
            { __typename: 'MemberMessage' }
            & Pick<IMemberMessage, 'id'>
          ) | (
            { __typename: 'MemberNotify' }
            & Pick<IMemberNotify, 'id'>
          ) | (
            { __typename: 'MemberOpportunity' }
            & Pick<IMemberOpportunity, 'id'>
          ) | (
            { __typename: 'MemberSaved' }
            & Pick<IMemberSaved, 'id'>
          ) | (
            { __typename: 'MemberSearch' }
            & Pick<IMemberSearch, 'id'>
          ) | (
            { __typename: 'MemberWatched' }
            & Pick<IMemberWatched, 'id'>
          ) | (
            { __typename: 'MembersDatas' }
            & Pick<IMembersDatas, 'id'>
          ) | (
            { __typename: 'MiniSitesFolder' }
            & Pick<IMiniSitesFolder, 'id'>
          ) | (
            { __typename: 'NavMessage' }
            & Pick<INavMessage, 'id'>
          ) | (
            { __typename: 'NavigationMessagesFolder' }
            & Pick<INavigationMessagesFolder, 'id'>
          ) | (
            { __typename: 'NetlifyDeploy' }
            & Pick<INetlifyDeploy, 'id'>
          ) | (
            { __typename: 'News' }
            & Pick<INews, 'id'>
          ) | (
            { __typename: 'NewsCateg' }
            & Pick<INewsCateg, 'id'>
          ) | (
            { __typename: 'NewsFolder' }
            & Pick<INewsFolder, 'id'>
          ) | (
            { __typename: 'NewsPage' }
            & Pick<INewsPage, 'id'>
          ) | (
            { __typename: 'ObtainedJob' }
            & Pick<IObtainedJob, 'id'>
          ) | (
            { __typename: 'Opportunity' }
            & Pick<IOpportunity, 'id'>
          ) | (
            { __typename: 'OpportunityCenter' }
            & Pick<IOpportunityCenter, 'id'>
          ) | (
            { __typename: 'OpportunityFolder' }
            & Pick<IOpportunityFolder, 'id'>
          ) | (
            { __typename: 'Partner' }
            & Pick<IPartner, 'id'>
          ) | (
            { __typename: 'Partners' }
            & Pick<IPartners, 'id'>
          ) | (
            { __typename: 'PartnersPage' }
            & Pick<IPartnersPage, 'id'>
          ) | (
            { __typename: 'Paywall' }
            & Pick<IPaywall, 'id'>
          ) | (
            { __typename: 'PaywallFolder' }
            & Pick<IPaywallFolder, 'id'>
          ) | (
            { __typename: 'PersonalityPages' }
            & Pick<IPersonalityPages, 'id'>
          ) | (
            { __typename: 'PersonalityQuiz' }
            & Pick<IPersonalityQuiz, 'id'>
          ) | (
            { __typename: 'PersonalityQuiz1' }
            & Pick<IPersonalityQuiz1, 'id'>
          ) | (
            { __typename: 'PersonalityType' }
            & Pick<IPersonalityType, 'id'>
          ) | (
            { __typename: 'Playlist' }
            & Pick<IPlaylist, 'id'>
          ) | (
            { __typename: 'PlaylistRadioMenu' }
            & Pick<IPlaylistRadioMenu, 'id'>
          ) | (
            { __typename: 'Podcast' }
            & Pick<IPodcast, 'id'>
          ) | (
            { __typename: 'PodcastCateg' }
            & Pick<IPodcastCateg, 'id'>
          ) | (
            { __typename: 'PodcastItem' }
            & Pick<IPodcastItem, 'id'>
          ) | (
            { __typename: 'PodcastMenu' }
            & Pick<IPodcastMenu, 'id'>
          ) | (
            { __typename: 'PromoCode' }
            & Pick<IPromoCode, 'id'>
          ) | (
            { __typename: 'PromoCodeFolder' }
            & Pick<IPromoCodeFolder, 'id'>
          ) | (
            { __typename: 'QuizPage' }
            & Pick<IQuizPage, 'id'>
          ) | (
            { __typename: 'QuizzSurvey' }
            & Pick<IQuizzSurvey, 'id'>
          ) | (
            { __typename: 'QuizzSurveyCategory' }
            & Pick<IQuizzSurveyCategory, 'id'>
          ) | (
            { __typename: 'QuizzSurveyCollection' }
            & Pick<IQuizzSurveyCollection, 'id'>
          ) | (
            { __typename: 'Radio' }
            & Pick<IRadio, 'id'>
          ) | (
            { __typename: 'RadioCateg' }
            & Pick<IRadioCateg, 'id'>
          ) | (
            { __typename: 'Region' }
            & Pick<IRegion, 'id'>
          ) | (
            { __typename: 'SectionPage' }
            & Pick<ISectionPage, 'id'>
          ) | (
            { __typename: 'Settings' }
            & Pick<ISettings, 'id'>
          ) | (
            { __typename: 'Space' }
            & Pick<ISpace, 'id'>
          ) | (
            { __typename: 'Subscription' }
            & Pick<ISubscription, 'id'>
          ) | (
            { __typename: 'SubscriptionData' }
            & Pick<ISubscriptionData, 'id'>
          ) | (
            { __typename: 'SubscriptionDataFolder' }
            & Pick<ISubscriptionDataFolder, 'id'>
          ) | (
            { __typename: 'SubscriptionsFolder' }
            & Pick<ISubscriptionsFolder, 'id'>
          ) | (
            { __typename: 'SumaryNugget' }
            & Pick<ISumaryNugget, 'id'>
          ) | (
            { __typename: 'SurveyQuizzFolder' }
            & Pick<ISurveyQuizzFolder, 'id'>
          ) | (
            { __typename: 'TextPage' }
            & Pick<ITextPage, 'id'>
          ) | (
            { __typename: 'ThankYouPage' }
            & Pick<IThankYouPage, 'id'>
          ) | (
            { __typename: 'TranslationContext' }
            & Pick<ITranslationContext, 'id'>
          ) | (
            { __typename: 'TranslationFolder' }
            & Pick<ITranslationFolder, 'id'>
          ) | (
            { __typename: 'TranslationItem' }
            & Pick<ITranslationItem, 'id'>
          ) | (
            { __typename: 'UmbracoTest' }
            & Pick<IUmbracoTest, 'id'>
          ) | (
            { __typename: 'UnitNuggetAnswer' }
            & Pick<IUnitNuggetAnswer, 'id'>
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & Pick<IUnitNuggetGapFillAnswer, 'id'>
          ) | (
            { __typename: 'UnitProgression' }
            & Pick<IUnitProgression, 'id'>
          ) | (
            { __typename: 'VODItem' }
            & Pick<IVodItem, 'id'>
          ) | (
            { __typename: 'VODMenu' }
            & Pick<IVodMenu, 'id'>
          ) | (
            { __typename: 'VotingFolder' }
            & Pick<IVotingFolder, 'id'>
          ) | (
            { __typename: 'VotingRecord' }
            & Pick<IVotingRecord, 'id'>
          ) | (
            { __typename: 'WatchCateg' }
            & Pick<IWatchCateg, 'id'>
          )>>> }
        ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
  )> }
);

export type IQuizResultByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IQuizResultByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allQuizPage: (
    { __typename?: 'QuizPageConnection' }
    & { items: Array<Maybe<(
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'name' | 'url' | 'resultSubtitle' | 'resultTitle' | 'ctaLabel'>
      & { quizz?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'BlockListItem' }
          & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | (
            { __typename: 'PersonalityQuizQuestion' }
            & IPersonalityQuizQuestionFragmentFragment
          ) | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
        )>>>, children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | (
            { __typename: 'PersonalityPages' }
            & Pick<IPersonalityPages, 'id' | 'url' | 'title' | 'subtitle' | 'introduction'>
            & { icon?: Maybe<(
              { __typename?: 'MediaWithCrops' }
              & { url: IMediaWithCrops['cropUrl'] }
            )>, linkedTag?: Maybe<Array<Maybe<(
              { __typename: 'ArtistService' }
              & Pick<IArtistService, 'id'>
            ) | (
              { __typename: 'ArtistServiceFolder' }
              & Pick<IArtistServiceFolder, 'id'>
            ) | (
              { __typename: 'ArtistServicesPage' }
              & Pick<IArtistServicesPage, 'id'>
            ) | (
              { __typename: 'AwardCategoryPage' }
              & Pick<IAwardCategoryPage, 'id'>
            ) | (
              { __typename: 'AwardsArtist' }
              & Pick<IAwardsArtist, 'id'>
            ) | (
              { __typename: 'AwardsCategoryMenu' }
              & Pick<IAwardsCategoryMenu, 'id'>
            ) | (
              { __typename: 'AwardsCategoryMenuDev' }
              & Pick<IAwardsCategoryMenuDev, 'id'>
            ) | (
              { __typename: 'AwardsCategoryMenuFolder' }
              & Pick<IAwardsCategoryMenuFolder, 'id'>
            ) | (
              { __typename: 'AwardsCategoryMenuFolderDev' }
              & Pick<IAwardsCategoryMenuFolderDev, 'id'>
            ) | (
              { __typename: 'AwardsHomepage' }
              & Pick<IAwardsHomepage, 'id'>
            ) | (
              { __typename: 'CMSPage' }
              & Pick<ICmsPage, 'id'>
            ) | (
              { __typename: 'CategBgColor' }
              & Pick<ICategBgColor, 'id'>
            ) | (
              { __typename: 'CategoryPage' }
              & Pick<ICategoryPage, 'id'>
            ) | (
              { __typename: 'Channel' }
              & Pick<IChannel, 'id'>
            ) | (
              { __typename: 'ChannelFolder' }
              & Pick<IChannelFolder, 'id'>
            ) | (
              { __typename: 'ChoiceNugget' }
              & Pick<IChoiceNugget, 'id'>
            ) | (
              { __typename: 'Collection' }
              & Pick<ICollection, 'id'>
            ) | (
              { __typename: 'ContentEditorFolder' }
              & Pick<IContentEditorFolder, 'id'>
            ) | (
              { __typename: 'ContentTag' }
              & Pick<IContentTag, 'color' | 'name' | 'id'>
            ) | (
              { __typename: 'ContentTags' }
              & Pick<IContentTags, 'id'>
            ) | (
              { __typename: 'ContentTagsCateg' }
              & Pick<IContentTagsCateg, 'id'>
            ) | (
              { __typename: 'Course' }
              & Pick<ICourse, 'id'>
            ) | (
              { __typename: 'CourseCategoriesFolder' }
              & Pick<ICourseCategoriesFolder, 'id'>
            ) | (
              { __typename: 'CourseCategory' }
              & Pick<ICourseCategory, 'id'>
            ) | (
              { __typename: 'CourseExam' }
              & Pick<ICourseExam, 'id'>
            ) | (
              { __typename: 'CourseShare' }
              & Pick<ICourseShare, 'id'>
            ) | (
              { __typename: 'CourseStatus' }
              & Pick<ICourseStatus, 'id'>
            ) | (
              { __typename: 'CourseTestProgression' }
              & Pick<ICourseTestProgression, 'id'>
            ) | (
              { __typename: 'CourseUnit' }
              & Pick<ICourseUnit, 'id'>
            ) | (
              { __typename: 'Discovery' }
              & Pick<IDiscovery, 'id'>
            ) | (
              { __typename: 'DiscoverySlide1' }
              & Pick<IDiscoverySlide1, 'id'>
            ) | (
              { __typename: 'EntrepreunarialHub' }
              & Pick<IEntrepreunarialHub, 'id'>
            ) | (
              { __typename: 'FormFolder' }
              & Pick<IFormFolder, 'id'>
            ) | (
              { __typename: 'FormPage' }
              & Pick<IFormPage, 'id'>
            ) | (
              { __typename: 'GapfillNugget' }
              & Pick<IGapfillNugget, 'id'>
            ) | (
              { __typename: 'HelpdeskCateg' }
              & Pick<IHelpdeskCateg, 'id'>
            ) | (
              { __typename: 'HelpdeskFolder' }
              & Pick<IHelpdeskFolder, 'id'>
            ) | (
              { __typename: 'HelpdeskPage' }
              & Pick<IHelpdeskPage, 'id'>
            ) | (
              { __typename: 'HomePage' }
              & Pick<IHomePage, 'id'>
            ) | (
              { __typename: 'JobBoardPage' }
              & Pick<IJobBoardPage, 'id'>
            ) | (
              { __typename: 'JobHub' }
              & Pick<IJobHub, 'id'>
            ) | (
              { __typename: 'JobHubsFolder' }
              & Pick<IJobHubsFolder, 'id'>
            ) | (
              { __typename: 'JobProgress' }
              & Pick<IJobProgress, 'id'>
            ) | (
              { __typename: 'JobShare' }
              & Pick<IJobShare, 'id'>
            ) | (
              { __typename: 'JobTraining' }
              & Pick<IJobTraining, 'id'>
            ) | (
              { __typename: 'JobTrainingFolder' }
              & Pick<IJobTrainingFolder, 'id'>
            ) | (
              { __typename: 'JobVacanciesFolder' }
              & Pick<IJobVacanciesFolder, 'id'>
            ) | (
              { __typename: 'JobVacancy' }
              & Pick<IJobVacancy, 'id'>
            ) | (
              { __typename: 'LandingPage' }
              & Pick<ILandingPage, 'id'>
            ) | (
              { __typename: 'LearnMenu' }
              & Pick<ILearnMenu, 'id'>
            ) | (
              { __typename: 'LegalsFolder' }
              & Pick<ILegalsFolder, 'id'>
            ) | (
              { __typename: 'ListenCateg' }
              & Pick<IListenCateg, 'id'>
            ) | (
              { __typename: 'LiveEvent' }
              & Pick<ILiveEvent, 'id'>
            ) | (
              { __typename: 'LiveEventsMenu' }
              & Pick<ILiveEventsMenu, 'id'>
            ) | (
              { __typename: 'LiveEventsPage' }
              & Pick<ILiveEventsPage, 'id'>
            ) | (
              { __typename: 'LiveTVPage' }
              & Pick<ILiveTvPage, 'id'>
            ) | (
              { __typename: 'MemberContentTypesLink' }
              & Pick<IMemberContentTypesLink, 'id'>
            ) | (
              { __typename: 'MemberDatas' }
              & Pick<IMemberDatas, 'id'>
            ) | (
              { __typename: 'MemberDownloaded' }
              & Pick<IMemberDownloaded, 'id'>
            ) | (
              { __typename: 'MemberMessage' }
              & Pick<IMemberMessage, 'id'>
            ) | (
              { __typename: 'MemberNotify' }
              & Pick<IMemberNotify, 'id'>
            ) | (
              { __typename: 'MemberOpportunity' }
              & Pick<IMemberOpportunity, 'id'>
            ) | (
              { __typename: 'MemberSaved' }
              & Pick<IMemberSaved, 'id'>
            ) | (
              { __typename: 'MemberSearch' }
              & Pick<IMemberSearch, 'id'>
            ) | (
              { __typename: 'MemberWatched' }
              & Pick<IMemberWatched, 'id'>
            ) | (
              { __typename: 'MembersDatas' }
              & Pick<IMembersDatas, 'id'>
            ) | (
              { __typename: 'MiniSitesFolder' }
              & Pick<IMiniSitesFolder, 'id'>
            ) | (
              { __typename: 'NavMessage' }
              & Pick<INavMessage, 'id'>
            ) | (
              { __typename: 'NavigationMessagesFolder' }
              & Pick<INavigationMessagesFolder, 'id'>
            ) | (
              { __typename: 'NetlifyDeploy' }
              & Pick<INetlifyDeploy, 'id'>
            ) | (
              { __typename: 'News' }
              & Pick<INews, 'id'>
            ) | (
              { __typename: 'NewsCateg' }
              & Pick<INewsCateg, 'id'>
            ) | (
              { __typename: 'NewsFolder' }
              & Pick<INewsFolder, 'id'>
            ) | (
              { __typename: 'NewsPage' }
              & Pick<INewsPage, 'id'>
            ) | (
              { __typename: 'ObtainedJob' }
              & Pick<IObtainedJob, 'id'>
            ) | (
              { __typename: 'Opportunity' }
              & Pick<IOpportunity, 'id'>
            ) | (
              { __typename: 'OpportunityCenter' }
              & Pick<IOpportunityCenter, 'id'>
            ) | (
              { __typename: 'OpportunityFolder' }
              & Pick<IOpportunityFolder, 'id'>
            ) | (
              { __typename: 'Partner' }
              & Pick<IPartner, 'id'>
            ) | (
              { __typename: 'Partners' }
              & Pick<IPartners, 'id'>
            ) | (
              { __typename: 'PartnersPage' }
              & Pick<IPartnersPage, 'id'>
            ) | (
              { __typename: 'Paywall' }
              & Pick<IPaywall, 'id'>
            ) | (
              { __typename: 'PaywallFolder' }
              & Pick<IPaywallFolder, 'id'>
            ) | (
              { __typename: 'PersonalityPages' }
              & Pick<IPersonalityPages, 'id'>
            ) | (
              { __typename: 'PersonalityQuiz' }
              & Pick<IPersonalityQuiz, 'id'>
            ) | (
              { __typename: 'PersonalityQuiz1' }
              & Pick<IPersonalityQuiz1, 'id'>
            ) | (
              { __typename: 'PersonalityType' }
              & Pick<IPersonalityType, 'id'>
            ) | (
              { __typename: 'Playlist' }
              & Pick<IPlaylist, 'id'>
            ) | (
              { __typename: 'PlaylistRadioMenu' }
              & Pick<IPlaylistRadioMenu, 'id'>
            ) | (
              { __typename: 'Podcast' }
              & Pick<IPodcast, 'id'>
            ) | (
              { __typename: 'PodcastCateg' }
              & Pick<IPodcastCateg, 'id'>
            ) | (
              { __typename: 'PodcastItem' }
              & Pick<IPodcastItem, 'id'>
            ) | (
              { __typename: 'PodcastMenu' }
              & Pick<IPodcastMenu, 'id'>
            ) | (
              { __typename: 'PromoCode' }
              & Pick<IPromoCode, 'id'>
            ) | (
              { __typename: 'PromoCodeFolder' }
              & Pick<IPromoCodeFolder, 'id'>
            ) | (
              { __typename: 'QuizPage' }
              & Pick<IQuizPage, 'id'>
            ) | (
              { __typename: 'QuizzSurvey' }
              & Pick<IQuizzSurvey, 'id'>
            ) | (
              { __typename: 'QuizzSurveyCategory' }
              & Pick<IQuizzSurveyCategory, 'id'>
            ) | (
              { __typename: 'QuizzSurveyCollection' }
              & Pick<IQuizzSurveyCollection, 'id'>
            ) | (
              { __typename: 'Radio' }
              & Pick<IRadio, 'id'>
            ) | (
              { __typename: 'RadioCateg' }
              & Pick<IRadioCateg, 'id'>
            ) | (
              { __typename: 'Region' }
              & Pick<IRegion, 'id'>
            ) | (
              { __typename: 'SectionPage' }
              & Pick<ISectionPage, 'id'>
            ) | (
              { __typename: 'Settings' }
              & Pick<ISettings, 'id'>
            ) | (
              { __typename: 'Space' }
              & Pick<ISpace, 'id'>
            ) | (
              { __typename: 'Subscription' }
              & Pick<ISubscription, 'id'>
            ) | (
              { __typename: 'SubscriptionData' }
              & Pick<ISubscriptionData, 'id'>
            ) | (
              { __typename: 'SubscriptionDataFolder' }
              & Pick<ISubscriptionDataFolder, 'id'>
            ) | (
              { __typename: 'SubscriptionsFolder' }
              & Pick<ISubscriptionsFolder, 'id'>
            ) | (
              { __typename: 'SumaryNugget' }
              & Pick<ISumaryNugget, 'id'>
            ) | (
              { __typename: 'SurveyQuizzFolder' }
              & Pick<ISurveyQuizzFolder, 'id'>
            ) | (
              { __typename: 'TextPage' }
              & Pick<ITextPage, 'id'>
            ) | (
              { __typename: 'ThankYouPage' }
              & Pick<IThankYouPage, 'id'>
            ) | (
              { __typename: 'TranslationContext' }
              & Pick<ITranslationContext, 'id'>
            ) | (
              { __typename: 'TranslationFolder' }
              & Pick<ITranslationFolder, 'id'>
            ) | (
              { __typename: 'TranslationItem' }
              & Pick<ITranslationItem, 'id'>
            ) | (
              { __typename: 'UmbracoTest' }
              & Pick<IUmbracoTest, 'id'>
            ) | (
              { __typename: 'UnitNuggetAnswer' }
              & Pick<IUnitNuggetAnswer, 'id'>
            ) | (
              { __typename: 'UnitNuggetGapFillAnswer' }
              & Pick<IUnitNuggetGapFillAnswer, 'id'>
            ) | (
              { __typename: 'UnitProgression' }
              & Pick<IUnitProgression, 'id'>
            ) | (
              { __typename: 'VODItem' }
              & Pick<IVodItem, 'id'>
            ) | (
              { __typename: 'VODMenu' }
              & Pick<IVodMenu, 'id'>
            ) | (
              { __typename: 'VotingFolder' }
              & Pick<IVotingFolder, 'id'>
            ) | (
              { __typename: 'VotingRecord' }
              & Pick<IVotingRecord, 'id'>
            ) | (
              { __typename: 'WatchCateg' }
              & Pick<IWatchCateg, 'id'>
            )>>> }
          ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
    )>> }
  ) }
);

export type IMethodologyQuizQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMethodologyQuizQuery = (
  { __typename?: 'Query' }
  & { quizPage?: Maybe<(
    { __typename?: 'QuizPage' }
    & Pick<IQuizPage, 'methodTitle' | 'methodIntro'>
    & { methodCover?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
        { __typename: 'HeroVideoCover' }
        & IHeroVideoCoverFragmentFragment
      ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
    )>>>, methodBody?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | (
        { __typename: 'UcImage' }
        & IUcImageFragmentFragment
      ) | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | (
        { __typename: 'Wysiwyg' }
        & IWysiwygFragmentFragment
      ) }
    )>>>, methodHighlightedCourses?: Maybe<(
      { __typename?: 'ArtistService' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'AwardsArtist' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'AwardsHomepage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CMSPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CategBgColor' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CategoryPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Channel' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ChannelFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ChoiceNugget' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Collection' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ContentTag' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ContentTags' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Course' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CourseCategory' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CourseExam' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CourseShare' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CourseStatus' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CourseTestProgression' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'CourseUnit' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Discovery' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'FormFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'FormPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'GapfillNugget' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'HelpdeskPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'HomePage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobBoardPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobHub' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobHubsFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobProgress' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobShare' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobTraining' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'JobVacancy' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'LandingPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'LearnMenu' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'LegalsFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ListenCateg' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'LiveEvent' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'LiveEventsPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'LiveTVPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberDatas' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberDownloaded' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberMessage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberNotify' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberOpportunity' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberSaved' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberSearch' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MemberWatched' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MembersDatas' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'NavMessage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'News' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'NewsCateg' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'NewsFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'NewsPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ObtainedJob' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Opportunity' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'OpportunityCenter' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'OpportunityFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Partner' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Partners' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PartnersPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Paywall' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PaywallFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PersonalityPages' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PersonalityType' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Playlist' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Podcast' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PodcastCateg' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PodcastItem' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PodcastMenu' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PromoCode' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'QuizPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'QuizzSurvey' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Radio' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'RadioCateg' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Region' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'SectionPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Settings' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Space' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'Subscription' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'SubscriptionData' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'SumaryNugget' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'TextPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'ThankYouPage' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'TranslationContext' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'TranslationFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'TranslationItem' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'UmbracoTest' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'UnitProgression' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'VODItem' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'VODMenu' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'VotingFolder' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'VotingRecord' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    ) | (
      { __typename?: 'WatchCateg' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
          { __typename: 'Course' }
          & ICourseFragmentFragment
        ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
      ) }
    )>, personalitiesPush?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | (
        { __typename: 'PersonalityPush' }
        & IPersonalityPushFragmentFragment
      ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
    )>>> }
  )> }
);

export type IMethodologyQuizByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMethodologyQuizByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allQuizPage: (
    { __typename?: 'QuizPageConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'url' | 'methodTitle' | 'methodIntro'>
      & { methodCover?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
          { __typename: 'HeroVideoCover' }
          & IHeroVideoCoverFragmentFragment
        ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>>, methodBody?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | (
          { __typename: 'UcImage' }
          & IUcImageFragmentFragment
        ) | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | (
          { __typename: 'Wysiwyg' }
          & IWysiwygFragmentFragment
        ) }
      )>>>, methodHighlightedCourses?: Maybe<(
        { __typename?: 'ArtistService' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsArtist' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsHomepage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CMSPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CategBgColor' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CategoryPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Channel' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ChannelFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ChoiceNugget' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Collection' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTag' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTags' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Course' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseCategory' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseExam' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseShare' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseStatus' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseTestProgression' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseUnit' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Discovery' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'FormFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'FormPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'GapfillNugget' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HomePage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobBoardPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobHub' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobHubsFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobProgress' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobShare' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobTraining' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobVacancy' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LandingPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LearnMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LegalsFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ListenCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEvent' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEventsPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveTVPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberDatas' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberDownloaded' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberMessage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberNotify' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberOpportunity' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberSaved' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberSearch' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberWatched' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MembersDatas' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NavMessage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'News' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ObtainedJob' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Opportunity' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'OpportunityCenter' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'OpportunityFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Partner' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Partners' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PartnersPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Paywall' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PaywallFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityPages' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityType' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Playlist' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Podcast' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastItem' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PromoCode' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurvey' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Radio' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'RadioCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Region' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SectionPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Settings' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Space' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Subscription' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionData' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SumaryNugget' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TextPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ThankYouPage' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationContext' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationItem' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UmbracoTest' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitProgression' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VODItem' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VODMenu' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VotingFolder' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VotingRecord' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'WatchCateg' }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | (
            { __typename: 'Course' }
            & ICourseFragmentFragment
          ) | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      )>, personalitiesPush?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | (
          { __typename: 'PersonalityPush' }
          & IPersonalityPushFragmentFragment
        ) | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>> }
    )>> }
  ) }
);

export type IPersonalityQuizByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPersonalityQuizByIdQuery = (
  { __typename?: 'Query' }
  & { personalityQuiz?: Maybe<(
    { __typename?: 'PersonalityQuiz' }
    & IPersonalityQuizFragmentFragment
  )> }
);

export type IPersonalityQuizQuestionByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPersonalityQuizQuestionByIdQuery = (
  { __typename?: 'Query' }
  & { personalityQuiz?: Maybe<(
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'id' | 'name'>
    & { questions?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | (
        { __typename: 'PersonalityQuizQuestion' }
        & IPersonalityQuizQuestionFragmentFragment
      ) | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
    )>>> }
  )> }
);

export type IQuizPageQuestionByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IQuizPageQuestionByIdQuery = (
  { __typename?: 'Query' }
  & { quizPage?: Maybe<(
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'id' | 'name'>
    & { quizz?: Maybe<Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
      & { questions?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | (
          { __typename: 'PersonalityQuizQuestion' }
          & IPersonalityQuizQuestionFragmentFragment
        ) | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>> }
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
    )>>> }
  )> }
);

export type IQuizPageQuestionByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IQuizPageQuestionByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allQuizPage: (
    { __typename?: 'QuizPageConnection' }
    & { items: Array<Maybe<(
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id' | 'url' | 'name'>
      & { quizz?: Maybe<Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'url'>
        & { questions?: Maybe<Array<Maybe<(
          { __typename?: 'BlockListItem' }
          & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | (
            { __typename: 'PersonalityQuizQuestion' }
            & IPersonalityQuizQuestionFragmentFragment
          ) | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
        )>>> }
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'url'>
      )>>> }
    )>> }
  ) }
);

export type IQuizPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IQuizPageByIdQuery = (
  { __typename?: 'Query' }
  & { quizPage?: Maybe<(
    { __typename?: 'QuizPage' }
    & IQuizPageFragmentFragment
  )> }
);

export type ICoursesByPersonalityIdsQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ICoursesByPersonalityIdsQuery = (
  { __typename?: 'Query' }
  & { allCourse: (
    { __typename?: 'CourseConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Course' }
      & Pick<ICourse, 'id' | 'url' | 'name' | 'title' | 'trailer' | 'description'>
      & { thumbnail?: Maybe<(
        { __typename?: 'MediaWithCrops' }
        & Pick<IMediaWithCrops, 'url'>
      )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
        { __typename: 'Partner' }
        & IPartnerFragmentFragment
      ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
    )>> }
  ) }
);

export type IGetAllUnitProgressionQueryVariables = Exact<{
  memberDataId?: InputMaybe<Scalars['ID']>;
}>;


export type IGetAllUnitProgressionQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'finished' | 'id' | 'name'>
      ) | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
    ) }
  )> }
);

export type IGetCourseTestProgressionByIdQueryVariables = Exact<{
  testId?: InputMaybe<Scalars['String']>;
  memberDataId?: InputMaybe<Scalars['ID']>;
}>;


export type IGetCourseTestProgressionByIdQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'id'>
        & { testId: IArtistService['name'] }
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
        & { testId: IArtistServiceFolder['name'] }
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
        & { testId: IArtistServicesPage['name'] }
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
        & { testId: IAwardCategoryPage['name'] }
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
        & { testId: IAwardsArtist['name'] }
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
        & { testId: IAwardsCategoryMenu['name'] }
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
        & { testId: IAwardsCategoryMenuDev['name'] }
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
        & { testId: IAwardsCategoryMenuFolder['name'] }
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
        & { testId: IAwardsCategoryMenuFolderDev['name'] }
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
        & { testId: IAwardsHomepage['name'] }
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
        & { testId: ICmsPage['name'] }
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
        & { testId: ICategBgColor['name'] }
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
        & { testId: ICategoryPage['name'] }
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'id'>
        & { testId: IChannel['name'] }
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
        & { testId: IChannelFolder['name'] }
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
        & { testId: IChoiceNugget['name'] }
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'id'>
        & { testId: ICollection['name'] }
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
        & { testId: IContentEditorFolder['name'] }
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'id'>
        & { testId: IContentTag['name'] }
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'id'>
        & { testId: IContentTags['name'] }
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
        & { testId: IContentTagsCateg['name'] }
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'id'>
        & { testId: ICourse['name'] }
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
        & { testId: ICourseCategoriesFolder['name'] }
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
        & { testId: ICourseCategory['name'] }
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
        & { testId: ICourseExam['name'] }
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
        & { testId: ICourseShare['name'] }
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
        & { testId: ICourseStatus['name'] }
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'json' | 'attempt' | 'lastAttempt' | 'id'>
        & { testId: ICourseTestProgression['name'] }
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
        & { testId: ICourseUnit['name'] }
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'id'>
        & { testId: IDiscovery['name'] }
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
        & { testId: IDiscoverySlide1['name'] }
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
        & { testId: IEntrepreunarialHub['name'] }
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
        & { testId: IFormFolder['name'] }
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'id'>
        & { testId: IFormPage['name'] }
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
        & { testId: IGapfillNugget['name'] }
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
        & { testId: IHelpdeskCateg['name'] }
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
        & { testId: IHelpdeskFolder['name'] }
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
        & { testId: IHelpdeskPage['name'] }
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'id'>
        & { testId: IHomePage['name'] }
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
        & { testId: IJobBoardPage['name'] }
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'id'>
        & { testId: IJobHub['name'] }
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
        & { testId: IJobHubsFolder['name'] }
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
        & { testId: IJobProgress['name'] }
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'id'>
        & { testId: IJobShare['name'] }
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
        & { testId: IJobTraining['name'] }
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
        & { testId: IJobTrainingFolder['name'] }
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
        & { testId: IJobVacanciesFolder['name'] }
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
        & { testId: IJobVacancy['name'] }
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
        & { testId: ILandingPage['name'] }
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
        & { testId: ILearnMenu['name'] }
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
        & { testId: ILegalsFolder['name'] }
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
        & { testId: IListenCateg['name'] }
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
        & { testId: ILiveEvent['name'] }
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
        & { testId: ILiveEventsMenu['name'] }
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
        & { testId: ILiveEventsPage['name'] }
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
        & { testId: ILiveTvPage['name'] }
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
        & { testId: IMemberContentTypesLink['name'] }
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
        & { testId: IMemberDatas['name'] }
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
        & { testId: IMemberDownloaded['name'] }
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
        & { testId: IMemberMessage['name'] }
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
        & { testId: IMemberNotify['name'] }
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
        & { testId: IMemberOpportunity['name'] }
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
        & { testId: IMemberSaved['name'] }
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
        & { testId: IMemberSearch['name'] }
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
        & { testId: IMemberWatched['name'] }
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
        & { testId: IMembersDatas['name'] }
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
        & { testId: IMiniSitesFolder['name'] }
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'id'>
        & { testId: INavMessage['name'] }
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
        & { testId: INavigationMessagesFolder['name'] }
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
        & { testId: INetlifyDeploy['name'] }
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'id'>
        & { testId: INews['name'] }
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
        & { testId: INewsCateg['name'] }
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
        & { testId: INewsFolder['name'] }
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'id'>
        & { testId: INewsPage['name'] }
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
        & { testId: IObtainedJob['name'] }
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
        & { testId: IOpportunity['name'] }
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
        & { testId: IOpportunityCenter['name'] }
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
        & { testId: IOpportunityFolder['name'] }
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'id'>
        & { testId: IPartner['name'] }
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'id'>
        & { testId: IPartners['name'] }
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
        & { testId: IPartnersPage['name'] }
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'id'>
        & { testId: IPaywall['name'] }
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
        & { testId: IPaywallFolder['name'] }
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
        & { testId: IPersonalityPages['name'] }
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
        & { testId: IPersonalityQuiz['name'] }
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
        & { testId: IPersonalityQuiz1['name'] }
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
        & { testId: IPersonalityType['name'] }
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'id'>
        & { testId: IPlaylist['name'] }
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
        & { testId: IPlaylistRadioMenu['name'] }
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'id'>
        & { testId: IPodcast['name'] }
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
        & { testId: IPodcastCateg['name'] }
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
        & { testId: IPodcastItem['name'] }
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
        & { testId: IPodcastMenu['name'] }
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
        & { testId: IPromoCode['name'] }
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
        & { testId: IPromoCodeFolder['name'] }
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
        & { testId: IQuizPage['name'] }
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
        & { testId: IQuizzSurvey['name'] }
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
        & { testId: IQuizzSurveyCategory['name'] }
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
        & { testId: IQuizzSurveyCollection['name'] }
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'id'>
        & { testId: IRadio['name'] }
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
        & { testId: IRadioCateg['name'] }
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'id'>
        & { testId: IRegion['name'] }
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
        & { testId: ISectionPage['name'] }
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'id'>
        & { testId: ISettings['name'] }
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'id'>
        & { testId: ISpace['name'] }
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'id'>
        & { testId: ISubscription['name'] }
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
        & { testId: ISubscriptionData['name'] }
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
        & { testId: ISubscriptionDataFolder['name'] }
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
        & { testId: ISubscriptionsFolder['name'] }
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
        & { testId: ISumaryNugget['name'] }
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
        & { testId: ISurveyQuizzFolder['name'] }
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'id'>
        & { testId: ITextPage['name'] }
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
        & { testId: IThankYouPage['name'] }
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
        & { testId: ITranslationContext['name'] }
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
        & { testId: ITranslationFolder['name'] }
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
        & { testId: ITranslationItem['name'] }
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
        & { testId: IUmbracoTest['name'] }
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
        & { testId: IUnitNuggetAnswer['name'] }
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
        & { testId: IUnitNuggetGapFillAnswer['name'] }
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
        & { testId: IUnitProgression['name'] }
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'id'>
        & { testId: IVodItem['name'] }
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
        & { testId: IVodMenu['name'] }
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
        & { testId: IVotingFolder['name'] }
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
        & { testId: IVotingRecord['name'] }
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
        & { testId: IWatchCateg['name'] }
      )>> }
    ) }
  )> }
);

export type IGetUnitProgressionByIdQueryVariables = Exact<{
  unitId?: InputMaybe<Scalars['String']>;
  memberDataId?: InputMaybe<Scalars['ID']>;
}>;


export type IGetUnitProgressionByIdQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename?: 'MemberDatas' }
    & Pick<IMemberDatas, 'id'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'id'>
        & { unitId: IArtistService['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
        & { unitId: IArtistServiceFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
        & { unitId: IArtistServicesPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
        & { unitId: IAwardCategoryPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
        & { unitId: IAwardsArtist['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
        & { unitId: IAwardsCategoryMenu['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
        & { unitId: IAwardsCategoryMenuDev['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
        & { unitId: IAwardsCategoryMenuFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
        & { unitId: IAwardsCategoryMenuFolderDev['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
        & { unitId: IAwardsHomepage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
        & { unitId: ICmsPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
        & { unitId: ICategBgColor['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
        & { unitId: ICategoryPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'id'>
        & { unitId: IChannel['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
        & { unitId: IChannelFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
        & { unitId: IChoiceNugget['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'id'>
        & { unitId: ICollection['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
        & { unitId: IContentEditorFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'id'>
        & { unitId: IContentTag['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'id'>
        & { unitId: IContentTags['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
        & { unitId: IContentTagsCateg['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'id'>
        & { unitId: ICourse['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
        & { unitId: ICourseCategoriesFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
        & { unitId: ICourseCategory['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
        & { unitId: ICourseExam['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
        & { unitId: ICourseShare['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
        & { unitId: ICourseStatus['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
        & { unitId: ICourseTestProgression['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
        & { unitId: ICourseUnit['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'id'>
        & { unitId: IDiscovery['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
        & { unitId: IDiscoverySlide1['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
        & { unitId: IEntrepreunarialHub['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
        & { unitId: IFormFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'id'>
        & { unitId: IFormPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
        & { unitId: IGapfillNugget['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
        & { unitId: IHelpdeskCateg['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
        & { unitId: IHelpdeskFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
        & { unitId: IHelpdeskPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'id'>
        & { unitId: IHomePage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
        & { unitId: IJobBoardPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'id'>
        & { unitId: IJobHub['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
        & { unitId: IJobHubsFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
        & { unitId: IJobProgress['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'id'>
        & { unitId: IJobShare['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
        & { unitId: IJobTraining['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
        & { unitId: IJobTrainingFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
        & { unitId: IJobVacanciesFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
        & { unitId: IJobVacancy['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
        & { unitId: ILandingPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
        & { unitId: ILearnMenu['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
        & { unitId: ILegalsFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
        & { unitId: IListenCateg['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
        & { unitId: ILiveEvent['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
        & { unitId: ILiveEventsMenu['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
        & { unitId: ILiveEventsPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
        & { unitId: ILiveTvPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
        & { unitId: IMemberContentTypesLink['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
        & { unitId: IMemberDatas['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
        & { unitId: IMemberDownloaded['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
        & { unitId: IMemberMessage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
        & { unitId: IMemberNotify['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
        & { unitId: IMemberOpportunity['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
        & { unitId: IMemberSaved['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
        & { unitId: IMemberSearch['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
        & { unitId: IMemberWatched['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
        & { unitId: IMembersDatas['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
        & { unitId: IMiniSitesFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'id'>
        & { unitId: INavMessage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
        & { unitId: INavigationMessagesFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
        & { unitId: INetlifyDeploy['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'id'>
        & { unitId: INews['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
        & { unitId: INewsCateg['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
        & { unitId: INewsFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'id'>
        & { unitId: INewsPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
        & { unitId: IObtainedJob['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
        & { unitId: IOpportunity['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
        & { unitId: IOpportunityCenter['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
        & { unitId: IOpportunityFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'id'>
        & { unitId: IPartner['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'id'>
        & { unitId: IPartners['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
        & { unitId: IPartnersPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'id'>
        & { unitId: IPaywall['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
        & { unitId: IPaywallFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
        & { unitId: IPersonalityPages['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
        & { unitId: IPersonalityQuiz['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
        & { unitId: IPersonalityQuiz1['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
        & { unitId: IPersonalityType['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'id'>
        & { unitId: IPlaylist['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
        & { unitId: IPlaylistRadioMenu['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'id'>
        & { unitId: IPodcast['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
        & { unitId: IPodcastCateg['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
        & { unitId: IPodcastItem['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
        & { unitId: IPodcastMenu['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
        & { unitId: IPromoCode['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
        & { unitId: IPromoCodeFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
        & { unitId: IQuizPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
        & { unitId: IQuizzSurvey['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
        & { unitId: IQuizzSurveyCategory['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
        & { unitId: IQuizzSurveyCollection['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'id'>
        & { unitId: IRadio['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
        & { unitId: IRadioCateg['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'id'>
        & { unitId: IRegion['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
        & { unitId: ISectionPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'id'>
        & { unitId: ISettings['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'id'>
        & { unitId: ISpace['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'id'>
        & { unitId: ISubscription['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
        & { unitId: ISubscriptionData['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
        & { unitId: ISubscriptionDataFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
        & { unitId: ISubscriptionsFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
        & { unitId: ISumaryNugget['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
        & { unitId: ISurveyQuizzFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'id'>
        & { unitId: ITextPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
        & { unitId: IThankYouPage['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
        & { unitId: ITranslationContext['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
        & { unitId: ITranslationFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
        & { unitId: ITranslationItem['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
        & { unitId: IUmbracoTest['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
        & { unitId: IUnitNuggetAnswer['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
        & { unitId: IUnitNuggetGapFillAnswer['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'json' | 'finished' | 'id'>
        & { unitId: IUnitProgression['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'id'>
        & { unitId: IVodItem['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
        & { unitId: IVodMenu['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
        & { unitId: IVotingFolder['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
        & { unitId: IVotingRecord['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
        & { unitId: IWatchCateg['name'] }
        & { children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | (
            { __typename: 'UnitNuggetAnswer' }
            & IUnitNuggetAnswerFragmentFragment
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & IUnitNuggetGapFillAnswerFragmentFragment
          ) | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>> }
        ) }
      )>> }
    ) }
  )> }
);

export type IUnitNuggetAnswerFragmentFragment = (
  { __typename: 'UnitNuggetAnswer' }
  & Pick<IUnitNuggetAnswer, 'id' | 'value'>
  & { nuggetId: IUnitNuggetAnswer['name'] }
);

export type IUnitNuggetGapFillAnswerFragmentFragment = (
  { __typename: 'UnitNuggetGapFillAnswer' }
  & Pick<IUnitNuggetGapFillAnswer, 'id'>
  & { nuggetId: IUnitNuggetGapFillAnswer['name'] }
  & { answers?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | (
      { __typename?: 'UnitNuggetGapFillAnswerItem' }
      & IUnitNuggetGapFillAnswerItemFragmentFragment
    ) | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
  )>>> }
);

export type IUnitNuggetGapFillAnswerItemFragmentFragment = (
  { __typename: 'UnitNuggetGapFillAnswerItem' }
  & Pick<IUnitNuggetGapFillAnswerItem, 'reference' | 'value'>
);

export type ILiveEventsPageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ILiveEventsPageQuery = (
  { __typename?: 'Query' }
  & { liveEventsPage?: Maybe<(
    { __typename?: 'LiveEventsPage' }
    & ILiveEventsPageFragmentFragment
  )> }
);

export type ILiveTvPageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ILiveTvPageQuery = (
  { __typename?: 'Query' }
  & { liveTVPage?: Maybe<(
    { __typename?: 'LiveTVPage' }
    & ILiveTvPageFragmentFragment
  )> }
);

export type IMainContentByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMainContentByIdQuery = (
  { __typename?: 'Query' }
  & { content?: Maybe<(
    { __typename: 'ArtistService' }
    & Pick<IArtistService, 'url' | 'id'>
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename: 'ArtistServiceFolder' }
    & Pick<IArtistServiceFolder, 'url' | 'id'>
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename: 'ArtistServicesPage' }
    & Pick<IArtistServicesPage, 'url' | 'id'>
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename: 'AwardCategoryPage' }
    & Pick<IAwardCategoryPage, 'url' | 'id'>
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename: 'AwardsArtist' }
    & Pick<IAwardsArtist, 'url' | 'id'>
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenu' }
    & Pick<IAwardsCategoryMenu, 'url' | 'id'>
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuDev' }
    & Pick<IAwardsCategoryMenuDev, 'url' | 'id'>
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolder' }
    & Pick<IAwardsCategoryMenuFolder, 'url' | 'id'>
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename: 'AwardsCategoryMenuFolderDev' }
    & Pick<IAwardsCategoryMenuFolderDev, 'url' | 'id'>
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename: 'AwardsHomepage' }
    & Pick<IAwardsHomepage, 'url' | 'id'>
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename: 'CMSPage' }
    & Pick<ICmsPage, 'url' | 'id'>
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename: 'CategBgColor' }
    & Pick<ICategBgColor, 'url' | 'id'>
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename: 'CategoryPage' }
    & Pick<ICategoryPage, 'url' | 'id'>
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename: 'Channel' }
    & Pick<IChannel, 'url' | 'id'>
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename: 'ChannelFolder' }
    & Pick<IChannelFolder, 'url' | 'id'>
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename: 'ChoiceNugget' }
    & Pick<IChoiceNugget, 'url' | 'id'>
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename: 'Collection' }
    & Pick<ICollection, 'url' | 'id'>
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename: 'ContentEditorFolder' }
    & Pick<IContentEditorFolder, 'url' | 'id'>
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename: 'ContentTag' }
    & Pick<IContentTag, 'url' | 'id'>
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename: 'ContentTags' }
    & Pick<IContentTags, 'url' | 'id'>
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename: 'ContentTagsCateg' }
    & Pick<IContentTagsCateg, 'url' | 'id'>
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename: 'Course' }
    & Pick<ICourse, 'url' | 'id'>
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename: 'CourseCategoriesFolder' }
    & Pick<ICourseCategoriesFolder, 'url' | 'id'>
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename: 'CourseCategory' }
    & Pick<ICourseCategory, 'url' | 'id'>
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename: 'CourseExam' }
    & Pick<ICourseExam, 'url' | 'id'>
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename: 'CourseShare' }
    & Pick<ICourseShare, 'url' | 'id'>
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename: 'CourseStatus' }
    & Pick<ICourseStatus, 'url' | 'id'>
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename: 'CourseTestProgression' }
    & Pick<ICourseTestProgression, 'url' | 'id'>
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename: 'CourseUnit' }
    & Pick<ICourseUnit, 'url' | 'id'>
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename: 'Discovery' }
    & Pick<IDiscovery, 'url' | 'id'>
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename: 'DiscoverySlide1' }
    & Pick<IDiscoverySlide1, 'url' | 'id'>
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename: 'EntrepreunarialHub' }
    & Pick<IEntrepreunarialHub, 'url' | 'id'>
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename: 'FormFolder' }
    & Pick<IFormFolder, 'url' | 'id'>
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'url' | 'id'>
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename: 'GapfillNugget' }
    & Pick<IGapfillNugget, 'url' | 'id'>
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename: 'HelpdeskCateg' }
    & Pick<IHelpdeskCateg, 'url' | 'id'>
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename: 'HelpdeskFolder' }
    & Pick<IHelpdeskFolder, 'url' | 'id'>
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename: 'HelpdeskPage' }
    & Pick<IHelpdeskPage, 'url' | 'id'>
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename: 'HomePage' }
    & Pick<IHomePage, 'url' | 'id'>
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename: 'JobBoardPage' }
    & Pick<IJobBoardPage, 'url' | 'id'>
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename: 'JobHub' }
    & Pick<IJobHub, 'url' | 'id'>
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename: 'JobHubsFolder' }
    & Pick<IJobHubsFolder, 'url' | 'id'>
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename: 'JobProgress' }
    & Pick<IJobProgress, 'url' | 'id'>
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename: 'JobShare' }
    & Pick<IJobShare, 'url' | 'id'>
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename: 'JobTraining' }
    & Pick<IJobTraining, 'url' | 'id'>
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename: 'JobTrainingFolder' }
    & Pick<IJobTrainingFolder, 'url' | 'id'>
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename: 'JobVacanciesFolder' }
    & Pick<IJobVacanciesFolder, 'url' | 'id'>
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename: 'JobVacancy' }
    & Pick<IJobVacancy, 'url' | 'id'>
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename: 'LandingPage' }
    & Pick<ILandingPage, 'url' | 'id'>
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename: 'LearnMenu' }
    & Pick<ILearnMenu, 'url' | 'id'>
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename: 'LegalsFolder' }
    & Pick<ILegalsFolder, 'url' | 'id'>
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename: 'ListenCateg' }
    & Pick<IListenCateg, 'url' | 'id'>
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename: 'LiveEvent' }
    & Pick<ILiveEvent, 'url' | 'id'>
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename: 'LiveEventsMenu' }
    & Pick<ILiveEventsMenu, 'url' | 'id'>
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename: 'LiveEventsPage' }
    & Pick<ILiveEventsPage, 'url' | 'id'>
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename: 'LiveTVPage' }
    & Pick<ILiveTvPage, 'url' | 'id'>
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename: 'MemberContentTypesLink' }
    & Pick<IMemberContentTypesLink, 'url' | 'id'>
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'url' | 'id'>
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename: 'MemberDownloaded' }
    & Pick<IMemberDownloaded, 'url' | 'id'>
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename: 'MemberMessage' }
    & Pick<IMemberMessage, 'url' | 'id'>
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename: 'MemberNotify' }
    & Pick<IMemberNotify, 'url' | 'id'>
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename: 'MemberOpportunity' }
    & Pick<IMemberOpportunity, 'url' | 'id'>
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename: 'MemberSaved' }
    & Pick<IMemberSaved, 'url' | 'id'>
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename: 'MemberSearch' }
    & Pick<IMemberSearch, 'url' | 'id'>
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename: 'MemberWatched' }
    & Pick<IMemberWatched, 'url' | 'id'>
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename: 'MembersDatas' }
    & Pick<IMembersDatas, 'url' | 'id'>
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename: 'MiniSitesFolder' }
    & Pick<IMiniSitesFolder, 'url' | 'id'>
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename: 'NavMessage' }
    & Pick<INavMessage, 'url' | 'id'>
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename: 'NavigationMessagesFolder' }
    & Pick<INavigationMessagesFolder, 'url' | 'id'>
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename: 'NetlifyDeploy' }
    & Pick<INetlifyDeploy, 'url' | 'id'>
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename: 'News' }
    & Pick<INews, 'url' | 'id'>
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename: 'NewsCateg' }
    & Pick<INewsCateg, 'url' | 'id'>
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename: 'NewsFolder' }
    & Pick<INewsFolder, 'url' | 'id'>
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename: 'NewsPage' }
    & Pick<INewsPage, 'url' | 'id'>
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename: 'ObtainedJob' }
    & Pick<IObtainedJob, 'url' | 'id'>
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename: 'Opportunity' }
    & Pick<IOpportunity, 'url' | 'id'>
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename: 'OpportunityCenter' }
    & Pick<IOpportunityCenter, 'url' | 'id'>
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename: 'OpportunityFolder' }
    & Pick<IOpportunityFolder, 'url' | 'id'>
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename: 'Partner' }
    & Pick<IPartner, 'url' | 'id'>
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename: 'Partners' }
    & Pick<IPartners, 'url' | 'id'>
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename: 'PartnersPage' }
    & Pick<IPartnersPage, 'url' | 'id'>
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename: 'Paywall' }
    & Pick<IPaywall, 'url' | 'id'>
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename: 'PaywallFolder' }
    & Pick<IPaywallFolder, 'url' | 'id'>
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename: 'PersonalityPages' }
    & Pick<IPersonalityPages, 'url' | 'id'>
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename: 'PersonalityQuiz' }
    & Pick<IPersonalityQuiz, 'url' | 'id'>
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename: 'PersonalityQuiz1' }
    & Pick<IPersonalityQuiz1, 'url' | 'id'>
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename: 'PersonalityType' }
    & Pick<IPersonalityType, 'url' | 'id'>
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename: 'Playlist' }
    & Pick<IPlaylist, 'url' | 'id'>
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename: 'PlaylistRadioMenu' }
    & Pick<IPlaylistRadioMenu, 'url' | 'id'>
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename: 'Podcast' }
    & Pick<IPodcast, 'url' | 'id'>
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename: 'PodcastCateg' }
    & Pick<IPodcastCateg, 'url' | 'id'>
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename: 'PodcastItem' }
    & Pick<IPodcastItem, 'url' | 'id'>
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename: 'PodcastMenu' }
    & Pick<IPodcastMenu, 'url' | 'id'>
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename: 'PromoCode' }
    & Pick<IPromoCode, 'url' | 'id'>
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename: 'PromoCodeFolder' }
    & Pick<IPromoCodeFolder, 'url' | 'id'>
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename: 'QuizPage' }
    & Pick<IQuizPage, 'url' | 'id'>
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'url' | 'id'>
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename: 'QuizzSurveyCategory' }
    & Pick<IQuizzSurveyCategory, 'url' | 'id'>
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'url' | 'id'>
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename: 'Radio' }
    & Pick<IRadio, 'url' | 'id'>
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename: 'RadioCateg' }
    & Pick<IRadioCateg, 'url' | 'id'>
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename: 'Region' }
    & Pick<IRegion, 'url' | 'id'>
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename: 'SectionPage' }
    & Pick<ISectionPage, 'url' | 'id'>
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename: 'Settings' }
    & Pick<ISettings, 'url' | 'id'>
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename: 'Space' }
    & Pick<ISpace, 'url' | 'id'>
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename: 'Subscription' }
    & Pick<ISubscription, 'url' | 'id'>
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename: 'SubscriptionData' }
    & Pick<ISubscriptionData, 'url' | 'id'>
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename: 'SubscriptionDataFolder' }
    & Pick<ISubscriptionDataFolder, 'url' | 'id'>
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename: 'SubscriptionsFolder' }
    & Pick<ISubscriptionsFolder, 'url' | 'id'>
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename: 'SumaryNugget' }
    & Pick<ISumaryNugget, 'url' | 'id'>
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename: 'SurveyQuizzFolder' }
    & Pick<ISurveyQuizzFolder, 'url' | 'id'>
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename: 'TextPage' }
    & Pick<ITextPage, 'url' | 'id'>
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename: 'ThankYouPage' }
    & Pick<IThankYouPage, 'url' | 'id'>
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename: 'TranslationContext' }
    & Pick<ITranslationContext, 'url' | 'id'>
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename: 'TranslationFolder' }
    & Pick<ITranslationFolder, 'url' | 'id'>
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename: 'TranslationItem' }
    & Pick<ITranslationItem, 'url' | 'id'>
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename: 'UmbracoTest' }
    & Pick<IUmbracoTest, 'url' | 'id'>
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename: 'UnitNuggetAnswer' }
    & Pick<IUnitNuggetAnswer, 'url' | 'id'>
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename: 'UnitNuggetGapFillAnswer' }
    & Pick<IUnitNuggetGapFillAnswer, 'url' | 'id'>
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename: 'UnitProgression' }
    & Pick<IUnitProgression, 'url' | 'id'>
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename: 'VODItem' }
    & Pick<IVodItem, 'url' | 'id'>
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename: 'VODMenu' }
    & Pick<IVodMenu, 'url' | 'id'>
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename: 'VotingFolder' }
    & Pick<IVotingFolder, 'url' | 'id'>
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename: 'VotingRecord' }
    & Pick<IVotingRecord, 'url' | 'id'>
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename: 'WatchCateg' }
    & Pick<IWatchCateg, 'url' | 'id'>
    & IMainContentListFragment_WatchCateg_Fragment
  )> }
);

export type IAllMemberDownloadedBySourceQueryVariables = Exact<{
  memberUrl?: InputMaybe<Scalars['String']>;
  contentSource?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllMemberDownloadedBySourceQuery = (
  { __typename?: 'Query' }
  & { allMemberDownloaded: (
    { __typename?: 'MemberDownloadedConnection' }
    & { items: Array<Maybe<(
      { __typename: 'MemberDownloaded' }
      & IMemberDownloadedFragmentFragment
    )>> }
  ) }
);

export type IAllMemberSavedBySourceQueryVariables = Exact<{
  memberUrl?: InputMaybe<Scalars['String']>;
  contentSource?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllMemberSavedBySourceQuery = (
  { __typename?: 'Query' }
  & { allMemberSaved: (
    { __typename?: 'MemberSavedConnection' }
    & { items: Array<Maybe<(
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
      & IMemberSavedFragmentFragment
    )>> }
  ) }
);

export type IMemberDatasByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IMemberDatasByIdQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename?: 'MemberDatas' }
    & IMemberDatasFragmentFragment
  )> }
);

export type IMemberDatasDownloadedQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMemberDatasDownloadedQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
        & IMemberDownloadedFragmentFragment
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type IMemberDatasMessageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMemberDatasMessageQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
        & IMemberMessageFragmentFragment
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type IMemberDatasNotifyQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMemberDatasNotifyQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
        & IMemberNotifyFragmentFragment
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type IMemberDatasOpportunityQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMemberDatasOpportunityQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
        & IMemberOpportunityFragmentFragment
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type IMemberDatasSavedQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMemberDatasSavedQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
        & IMemberSavedFragmentFragment
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type IMemberDatasSearchQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IMemberDatasSearchQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
        & IMemberSearchFragmentFragment
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type IMemberDatasWatchedQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMemberDatasWatchedQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
        & IMemberWatchedFragmentFragment
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type IGetMainContentListByIdQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetMainContentListByIdQuery = (
  { __typename?: 'Query' }
  & { allContent: (
    { __typename?: 'ContentConnection' }
    & { items: Array<Maybe<(
      { __typename: 'ArtistService' }
      & Pick<IArtistService, 'id'>
      & IMainContentListFragment_ArtistService_Fragment
    ) | (
      { __typename: 'ArtistServiceFolder' }
      & Pick<IArtistServiceFolder, 'id'>
      & IMainContentListFragment_ArtistServiceFolder_Fragment
    ) | (
      { __typename: 'ArtistServicesPage' }
      & Pick<IArtistServicesPage, 'id'>
      & IMainContentListFragment_ArtistServicesPage_Fragment
    ) | (
      { __typename: 'AwardCategoryPage' }
      & Pick<IAwardCategoryPage, 'id'>
      & IMainContentListFragment_AwardCategoryPage_Fragment
    ) | (
      { __typename: 'AwardsArtist' }
      & Pick<IAwardsArtist, 'id'>
      & IMainContentListFragment_AwardsArtist_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenu' }
      & Pick<IAwardsCategoryMenu, 'id'>
      & IMainContentListFragment_AwardsCategoryMenu_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuDev' }
      & Pick<IAwardsCategoryMenuDev, 'id'>
      & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolder' }
      & Pick<IAwardsCategoryMenuFolder, 'id'>
      & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
    ) | (
      { __typename: 'AwardsCategoryMenuFolderDev' }
      & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
    ) | (
      { __typename: 'AwardsHomepage' }
      & Pick<IAwardsHomepage, 'id'>
      & IMainContentListFragment_AwardsHomepage_Fragment
    ) | (
      { __typename: 'CMSPage' }
      & Pick<ICmsPage, 'id'>
      & IMainContentListFragment_CmsPage_Fragment
    ) | (
      { __typename: 'CategBgColor' }
      & Pick<ICategBgColor, 'id'>
      & IMainContentListFragment_CategBgColor_Fragment
    ) | (
      { __typename: 'CategoryPage' }
      & Pick<ICategoryPage, 'id'>
      & IMainContentListFragment_CategoryPage_Fragment
    ) | (
      { __typename: 'Channel' }
      & Pick<IChannel, 'id'>
      & IMainContentListFragment_Channel_Fragment
    ) | (
      { __typename: 'ChannelFolder' }
      & Pick<IChannelFolder, 'id'>
      & IMainContentListFragment_ChannelFolder_Fragment
    ) | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id'>
      & IMainContentListFragment_ChoiceNugget_Fragment
    ) | (
      { __typename: 'Collection' }
      & Pick<ICollection, 'id'>
      & IMainContentListFragment_Collection_Fragment
    ) | (
      { __typename: 'ContentEditorFolder' }
      & Pick<IContentEditorFolder, 'id'>
      & IMainContentListFragment_ContentEditorFolder_Fragment
    ) | (
      { __typename: 'ContentTag' }
      & Pick<IContentTag, 'id'>
      & IMainContentListFragment_ContentTag_Fragment
    ) | (
      { __typename: 'ContentTags' }
      & Pick<IContentTags, 'id'>
      & IMainContentListFragment_ContentTags_Fragment
    ) | (
      { __typename: 'ContentTagsCateg' }
      & Pick<IContentTagsCateg, 'id'>
      & IMainContentListFragment_ContentTagsCateg_Fragment
    ) | (
      { __typename: 'Course' }
      & Pick<ICourse, 'id'>
      & IMainContentListFragment_Course_Fragment
    ) | (
      { __typename: 'CourseCategoriesFolder' }
      & Pick<ICourseCategoriesFolder, 'id'>
      & IMainContentListFragment_CourseCategoriesFolder_Fragment
    ) | (
      { __typename: 'CourseCategory' }
      & Pick<ICourseCategory, 'id'>
      & IMainContentListFragment_CourseCategory_Fragment
    ) | (
      { __typename: 'CourseExam' }
      & Pick<ICourseExam, 'id'>
      & IMainContentListFragment_CourseExam_Fragment
    ) | (
      { __typename: 'CourseShare' }
      & Pick<ICourseShare, 'id'>
      & IMainContentListFragment_CourseShare_Fragment
    ) | (
      { __typename: 'CourseStatus' }
      & Pick<ICourseStatus, 'id'>
      & IMainContentListFragment_CourseStatus_Fragment
    ) | (
      { __typename: 'CourseTestProgression' }
      & Pick<ICourseTestProgression, 'id'>
      & IMainContentListFragment_CourseTestProgression_Fragment
    ) | (
      { __typename: 'CourseUnit' }
      & Pick<ICourseUnit, 'id'>
      & IMainContentListFragment_CourseUnit_Fragment
    ) | (
      { __typename: 'Discovery' }
      & Pick<IDiscovery, 'id'>
      & IMainContentListFragment_Discovery_Fragment
    ) | (
      { __typename: 'DiscoverySlide1' }
      & Pick<IDiscoverySlide1, 'id'>
      & IMainContentListFragment_DiscoverySlide1_Fragment
    ) | (
      { __typename: 'EntrepreunarialHub' }
      & Pick<IEntrepreunarialHub, 'id'>
      & IMainContentListFragment_EntrepreunarialHub_Fragment
    ) | (
      { __typename: 'FormFolder' }
      & Pick<IFormFolder, 'id'>
      & IMainContentListFragment_FormFolder_Fragment
    ) | (
      { __typename: 'FormPage' }
      & Pick<IFormPage, 'id'>
      & IMainContentListFragment_FormPage_Fragment
    ) | (
      { __typename: 'GapfillNugget' }
      & Pick<IGapfillNugget, 'id'>
      & IMainContentListFragment_GapfillNugget_Fragment
    ) | (
      { __typename: 'HelpdeskCateg' }
      & Pick<IHelpdeskCateg, 'id'>
      & IMainContentListFragment_HelpdeskCateg_Fragment
    ) | (
      { __typename: 'HelpdeskFolder' }
      & Pick<IHelpdeskFolder, 'id'>
      & IMainContentListFragment_HelpdeskFolder_Fragment
    ) | (
      { __typename: 'HelpdeskPage' }
      & Pick<IHelpdeskPage, 'id'>
      & IMainContentListFragment_HelpdeskPage_Fragment
    ) | (
      { __typename: 'HomePage' }
      & Pick<IHomePage, 'id'>
      & IMainContentListFragment_HomePage_Fragment
    ) | (
      { __typename: 'JobBoardPage' }
      & Pick<IJobBoardPage, 'id'>
      & IMainContentListFragment_JobBoardPage_Fragment
    ) | (
      { __typename: 'JobHub' }
      & Pick<IJobHub, 'id'>
      & IMainContentListFragment_JobHub_Fragment
    ) | (
      { __typename: 'JobHubsFolder' }
      & Pick<IJobHubsFolder, 'id'>
      & IMainContentListFragment_JobHubsFolder_Fragment
    ) | (
      { __typename: 'JobProgress' }
      & Pick<IJobProgress, 'id'>
      & IMainContentListFragment_JobProgress_Fragment
    ) | (
      { __typename: 'JobShare' }
      & Pick<IJobShare, 'id'>
      & IMainContentListFragment_JobShare_Fragment
    ) | (
      { __typename: 'JobTraining' }
      & Pick<IJobTraining, 'id'>
      & IMainContentListFragment_JobTraining_Fragment
    ) | (
      { __typename: 'JobTrainingFolder' }
      & Pick<IJobTrainingFolder, 'id'>
      & IMainContentListFragment_JobTrainingFolder_Fragment
    ) | (
      { __typename: 'JobVacanciesFolder' }
      & Pick<IJobVacanciesFolder, 'id'>
      & IMainContentListFragment_JobVacanciesFolder_Fragment
    ) | (
      { __typename: 'JobVacancy' }
      & Pick<IJobVacancy, 'id'>
      & IMainContentListFragment_JobVacancy_Fragment
    ) | (
      { __typename: 'LandingPage' }
      & Pick<ILandingPage, 'id'>
      & IMainContentListFragment_LandingPage_Fragment
    ) | (
      { __typename: 'LearnMenu' }
      & Pick<ILearnMenu, 'id'>
      & IMainContentListFragment_LearnMenu_Fragment
    ) | (
      { __typename: 'LegalsFolder' }
      & Pick<ILegalsFolder, 'id'>
      & IMainContentListFragment_LegalsFolder_Fragment
    ) | (
      { __typename: 'ListenCateg' }
      & Pick<IListenCateg, 'id'>
      & IMainContentListFragment_ListenCateg_Fragment
    ) | (
      { __typename: 'LiveEvent' }
      & Pick<ILiveEvent, 'id'>
      & IMainContentListFragment_LiveEvent_Fragment
    ) | (
      { __typename: 'LiveEventsMenu' }
      & Pick<ILiveEventsMenu, 'id'>
      & IMainContentListFragment_LiveEventsMenu_Fragment
    ) | (
      { __typename: 'LiveEventsPage' }
      & Pick<ILiveEventsPage, 'id'>
      & IMainContentListFragment_LiveEventsPage_Fragment
    ) | (
      { __typename: 'LiveTVPage' }
      & Pick<ILiveTvPage, 'id'>
      & IMainContentListFragment_LiveTvPage_Fragment
    ) | (
      { __typename: 'MemberContentTypesLink' }
      & Pick<IMemberContentTypesLink, 'id'>
      & IMainContentListFragment_MemberContentTypesLink_Fragment
    ) | (
      { __typename: 'MemberDatas' }
      & Pick<IMemberDatas, 'id'>
      & IMainContentListFragment_MemberDatas_Fragment
    ) | (
      { __typename: 'MemberDownloaded' }
      & Pick<IMemberDownloaded, 'id'>
      & IMainContentListFragment_MemberDownloaded_Fragment
    ) | (
      { __typename: 'MemberMessage' }
      & Pick<IMemberMessage, 'id'>
      & IMainContentListFragment_MemberMessage_Fragment
    ) | (
      { __typename: 'MemberNotify' }
      & Pick<IMemberNotify, 'id'>
      & IMainContentListFragment_MemberNotify_Fragment
    ) | (
      { __typename: 'MemberOpportunity' }
      & Pick<IMemberOpportunity, 'id'>
      & IMainContentListFragment_MemberOpportunity_Fragment
    ) | (
      { __typename: 'MemberSaved' }
      & Pick<IMemberSaved, 'id'>
      & IMainContentListFragment_MemberSaved_Fragment
    ) | (
      { __typename: 'MemberSearch' }
      & Pick<IMemberSearch, 'id'>
      & IMainContentListFragment_MemberSearch_Fragment
    ) | (
      { __typename: 'MemberWatched' }
      & Pick<IMemberWatched, 'id'>
      & IMainContentListFragment_MemberWatched_Fragment
    ) | (
      { __typename: 'MembersDatas' }
      & Pick<IMembersDatas, 'id'>
      & IMainContentListFragment_MembersDatas_Fragment
    ) | (
      { __typename: 'MiniSitesFolder' }
      & Pick<IMiniSitesFolder, 'id'>
      & IMainContentListFragment_MiniSitesFolder_Fragment
    ) | (
      { __typename: 'NavMessage' }
      & Pick<INavMessage, 'id'>
      & IMainContentListFragment_NavMessage_Fragment
    ) | (
      { __typename: 'NavigationMessagesFolder' }
      & Pick<INavigationMessagesFolder, 'id'>
      & IMainContentListFragment_NavigationMessagesFolder_Fragment
    ) | (
      { __typename: 'NetlifyDeploy' }
      & Pick<INetlifyDeploy, 'id'>
      & IMainContentListFragment_NetlifyDeploy_Fragment
    ) | (
      { __typename: 'News' }
      & Pick<INews, 'id'>
      & IMainContentListFragment_News_Fragment
    ) | (
      { __typename: 'NewsCateg' }
      & Pick<INewsCateg, 'id'>
      & IMainContentListFragment_NewsCateg_Fragment
    ) | (
      { __typename: 'NewsFolder' }
      & Pick<INewsFolder, 'id'>
      & IMainContentListFragment_NewsFolder_Fragment
    ) | (
      { __typename: 'NewsPage' }
      & Pick<INewsPage, 'id'>
      & IMainContentListFragment_NewsPage_Fragment
    ) | (
      { __typename: 'ObtainedJob' }
      & Pick<IObtainedJob, 'id'>
      & IMainContentListFragment_ObtainedJob_Fragment
    ) | (
      { __typename: 'Opportunity' }
      & Pick<IOpportunity, 'id'>
      & IMainContentListFragment_Opportunity_Fragment
    ) | (
      { __typename: 'OpportunityCenter' }
      & Pick<IOpportunityCenter, 'id'>
      & IMainContentListFragment_OpportunityCenter_Fragment
    ) | (
      { __typename: 'OpportunityFolder' }
      & Pick<IOpportunityFolder, 'id'>
      & IMainContentListFragment_OpportunityFolder_Fragment
    ) | (
      { __typename: 'Partner' }
      & Pick<IPartner, 'id'>
      & IMainContentListFragment_Partner_Fragment
    ) | (
      { __typename: 'Partners' }
      & Pick<IPartners, 'id'>
      & IMainContentListFragment_Partners_Fragment
    ) | (
      { __typename: 'PartnersPage' }
      & Pick<IPartnersPage, 'id'>
      & IMainContentListFragment_PartnersPage_Fragment
    ) | (
      { __typename: 'Paywall' }
      & Pick<IPaywall, 'id'>
      & IMainContentListFragment_Paywall_Fragment
    ) | (
      { __typename: 'PaywallFolder' }
      & Pick<IPaywallFolder, 'id'>
      & IMainContentListFragment_PaywallFolder_Fragment
    ) | (
      { __typename: 'PersonalityPages' }
      & Pick<IPersonalityPages, 'id'>
      & IMainContentListFragment_PersonalityPages_Fragment
    ) | (
      { __typename: 'PersonalityQuiz' }
      & Pick<IPersonalityQuiz, 'id'>
      & IMainContentListFragment_PersonalityQuiz_Fragment
    ) | (
      { __typename: 'PersonalityQuiz1' }
      & Pick<IPersonalityQuiz1, 'id'>
      & IMainContentListFragment_PersonalityQuiz1_Fragment
    ) | (
      { __typename: 'PersonalityType' }
      & Pick<IPersonalityType, 'id'>
      & IMainContentListFragment_PersonalityType_Fragment
    ) | (
      { __typename: 'Playlist' }
      & Pick<IPlaylist, 'id'>
      & IMainContentListFragment_Playlist_Fragment
    ) | (
      { __typename: 'PlaylistRadioMenu' }
      & Pick<IPlaylistRadioMenu, 'id'>
      & IMainContentListFragment_PlaylistRadioMenu_Fragment
    ) | (
      { __typename: 'Podcast' }
      & Pick<IPodcast, 'id'>
      & IMainContentListFragment_Podcast_Fragment
    ) | (
      { __typename: 'PodcastCateg' }
      & Pick<IPodcastCateg, 'id'>
      & IMainContentListFragment_PodcastCateg_Fragment
    ) | (
      { __typename: 'PodcastItem' }
      & Pick<IPodcastItem, 'id'>
      & IMainContentListFragment_PodcastItem_Fragment
    ) | (
      { __typename: 'PodcastMenu' }
      & Pick<IPodcastMenu, 'id'>
      & IMainContentListFragment_PodcastMenu_Fragment
    ) | (
      { __typename: 'PromoCode' }
      & Pick<IPromoCode, 'id'>
      & IMainContentListFragment_PromoCode_Fragment
    ) | (
      { __typename: 'PromoCodeFolder' }
      & Pick<IPromoCodeFolder, 'id'>
      & IMainContentListFragment_PromoCodeFolder_Fragment
    ) | (
      { __typename: 'QuizPage' }
      & Pick<IQuizPage, 'id'>
      & IMainContentListFragment_QuizPage_Fragment
    ) | (
      { __typename: 'QuizzSurvey' }
      & Pick<IQuizzSurvey, 'id'>
      & IMainContentListFragment_QuizzSurvey_Fragment
    ) | (
      { __typename: 'QuizzSurveyCategory' }
      & Pick<IQuizzSurveyCategory, 'id'>
      & IMainContentListFragment_QuizzSurveyCategory_Fragment
    ) | (
      { __typename: 'QuizzSurveyCollection' }
      & Pick<IQuizzSurveyCollection, 'id'>
      & IMainContentListFragment_QuizzSurveyCollection_Fragment
    ) | (
      { __typename: 'Radio' }
      & Pick<IRadio, 'id'>
      & IMainContentListFragment_Radio_Fragment
    ) | (
      { __typename: 'RadioCateg' }
      & Pick<IRadioCateg, 'id'>
      & IMainContentListFragment_RadioCateg_Fragment
    ) | (
      { __typename: 'Region' }
      & Pick<IRegion, 'id'>
      & IMainContentListFragment_Region_Fragment
    ) | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
      & IMainContentListFragment_SectionPage_Fragment
    ) | (
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
      & IMainContentListFragment_Settings_Fragment
    ) | (
      { __typename: 'Space' }
      & Pick<ISpace, 'id'>
      & IMainContentListFragment_Space_Fragment
    ) | (
      { __typename: 'Subscription' }
      & Pick<ISubscription, 'id'>
      & IMainContentListFragment_Subscription_Fragment
    ) | (
      { __typename: 'SubscriptionData' }
      & Pick<ISubscriptionData, 'id'>
      & IMainContentListFragment_SubscriptionData_Fragment
    ) | (
      { __typename: 'SubscriptionDataFolder' }
      & Pick<ISubscriptionDataFolder, 'id'>
      & IMainContentListFragment_SubscriptionDataFolder_Fragment
    ) | (
      { __typename: 'SubscriptionsFolder' }
      & Pick<ISubscriptionsFolder, 'id'>
      & IMainContentListFragment_SubscriptionsFolder_Fragment
    ) | (
      { __typename: 'SumaryNugget' }
      & Pick<ISumaryNugget, 'id'>
      & IMainContentListFragment_SumaryNugget_Fragment
    ) | (
      { __typename: 'SurveyQuizzFolder' }
      & Pick<ISurveyQuizzFolder, 'id'>
      & IMainContentListFragment_SurveyQuizzFolder_Fragment
    ) | (
      { __typename: 'TextPage' }
      & Pick<ITextPage, 'id'>
      & IMainContentListFragment_TextPage_Fragment
    ) | (
      { __typename: 'ThankYouPage' }
      & Pick<IThankYouPage, 'id'>
      & IMainContentListFragment_ThankYouPage_Fragment
    ) | (
      { __typename: 'TranslationContext' }
      & Pick<ITranslationContext, 'id'>
      & IMainContentListFragment_TranslationContext_Fragment
    ) | (
      { __typename: 'TranslationFolder' }
      & Pick<ITranslationFolder, 'id'>
      & IMainContentListFragment_TranslationFolder_Fragment
    ) | (
      { __typename: 'TranslationItem' }
      & Pick<ITranslationItem, 'id'>
      & IMainContentListFragment_TranslationItem_Fragment
    ) | (
      { __typename: 'UmbracoTest' }
      & Pick<IUmbracoTest, 'id'>
      & IMainContentListFragment_UmbracoTest_Fragment
    ) | (
      { __typename: 'UnitNuggetAnswer' }
      & Pick<IUnitNuggetAnswer, 'id'>
      & IMainContentListFragment_UnitNuggetAnswer_Fragment
    ) | (
      { __typename: 'UnitNuggetGapFillAnswer' }
      & Pick<IUnitNuggetGapFillAnswer, 'id'>
      & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
    ) | (
      { __typename: 'UnitProgression' }
      & Pick<IUnitProgression, 'id'>
      & IMainContentListFragment_UnitProgression_Fragment
    ) | (
      { __typename: 'VODItem' }
      & Pick<IVodItem, 'id'>
      & IMainContentListFragment_VodItem_Fragment
    ) | (
      { __typename: 'VODMenu' }
      & Pick<IVodMenu, 'id'>
      & IMainContentListFragment_VodMenu_Fragment
    ) | (
      { __typename: 'VotingFolder' }
      & Pick<IVotingFolder, 'id'>
      & IMainContentListFragment_VotingFolder_Fragment
    ) | (
      { __typename: 'VotingRecord' }
      & Pick<IVotingRecord, 'id'>
      & IMainContentListFragment_VotingRecord_Fragment
    ) | (
      { __typename: 'WatchCateg' }
      & Pick<IWatchCateg, 'id'>
      & IMainContentListFragment_WatchCateg_Fragment
    )>> }
  ) }
);

export type IMemberUnitProgressionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type IMemberUnitProgressionQuery = (
  { __typename?: 'Query' }
  & { memberDatas?: Maybe<(
    { __typename: 'MemberDatas' }
    & Pick<IMemberDatas, 'id' | 'url'>
    & { children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'name' | 'courseId' | 'finished' | 'id'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id'>
      )>> }
    ) }
  )> }
);

export type INewsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<InputMaybe<INewsOrderByInput>> | InputMaybe<INewsOrderByInput>>;
  url_starts_with?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type INewsQuery = (
  { __typename?: 'Query' }
  & { allNews: (
    { __typename?: 'NewsConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'News' }
      & INewsFragmentFragment
    )>> }
  ) }
);

export type INewsByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type INewsByUrlQuery = (
  { __typename?: 'Query' }
  & { news?: Maybe<(
    { __typename?: 'News' }
    & INewsFragmentFragment
  )> }
);

export type INewsByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type INewsByIdQuery = (
  { __typename?: 'Query' }
  & { news?: Maybe<(
    { __typename?: 'News' }
    & INewsFragmentFragment
  )> }
);

export type INewsByUrlEndUrlQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type INewsByUrlEndUrlQuery = (
  { __typename?: 'Query' }
  & { allNews: (
    { __typename?: 'NewsConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'News' }
      & INewsFragmentFragment
    )>> }
  ) }
);

export type IPaywalByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPaywalByIdQuery = (
  { __typename?: 'Query' }
  & { paywall?: Maybe<(
    { __typename?: 'Paywall' }
    & IPaywallFragmentFragment
  )> }
);

export type IPlayListByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPlayListByUrlQuery = (
  { __typename?: 'Query' }
  & { playlist?: Maybe<(
    { __typename?: 'Playlist' }
    & IPlaylistFragmentFragment
  )> }
);

export type IPlayListByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPlayListByIdQuery = (
  { __typename?: 'Query' }
  & { playlist?: Maybe<(
    { __typename?: 'Playlist' }
    & IPlaylistFragmentFragment
  )> }
);

export type IPodCastQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPodCastQuery = (
  { __typename?: 'Query' }
  & { podcast?: Maybe<(
    { __typename?: 'Podcast' }
    & IPodcastFragmentFragment
  )> }
);

export type IPodCastByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPodCastByIdQuery = (
  { __typename?: 'Query' }
  & { podcast?: Maybe<(
    { __typename?: 'Podcast' }
    & IPodcastFragmentFragment
  )> }
);

export type IPodCastByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPodCastByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allPodcast: (
    { __typename?: 'PodcastConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Podcast' }
      & IPodcastFragmentFragment
    )>> }
  ) }
);

export type IPodCastItemQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPodCastItemQuery = (
  { __typename?: 'Query' }
  & { podcastItem?: Maybe<(
    { __typename?: 'PodcastItem' }
    & IPodcastItemFragmentFragment
  )> }
);

export type IPodCastItemByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPodCastItemByIdQuery = (
  { __typename?: 'Query' }
  & { podcastItem?: Maybe<(
    { __typename?: 'PodcastItem' }
    & IPodcastItemFragmentFragment
  )> }
);

export type IPromoCodeContentQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IPromoCodeContentQuery = (
  { __typename?: 'Query' }
  & { allSettings: (
    { __typename?: 'SettingsConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Settings' }
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | (
          { __typename: 'PromoCodeFolder' }
          & Pick<IPromoCodeFolder, 'id' | 'name' | 'title' | 'description' | 'thankYouBody' | 'thankYouTitle' | 'variantTitle' | 'variantSurtitle' | 'variantMention' | 'variantCtaLabel' | 'variantDescription' | 'variantHighlightedTitle' | 'variantHighlightedMention' | 'subscriptionTitle' | 'subscriptionDescription'>
          & { footerImage?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & { webCover: IMediaWithCrops['cropUrl'], mobileCover: IMediaWithCrops['cropUrl'] }
          )>, thankYouCover?: Maybe<Array<Maybe<(
            { __typename?: 'BlockListItem' }
            & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
              { __typename?: 'HeroVideoCover' }
              & IHeroVideoCoverFragmentFragment
            ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
          )>>>, variantCover?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & { webCover: IMediaWithCrops['cropUrl'], mobileCover: IMediaWithCrops['cropUrl'] }
          )> }
        ) | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
      ) }
    )>> }
  ) }
);

export type IQuizzSurveyByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IQuizzSurveyByIdQuery = (
  { __typename?: 'Query' }
  & { quizzSurvey?: Maybe<(
    { __typename?: 'QuizzSurvey' }
    & IQuizzSurveyFragmentFragment
  )> }
);

export type IGetQuizzSurveyByQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetQuizzSurveyByQuery = (
  { __typename?: 'Query' }
  & { quizzSurvey?: Maybe<(
    { __typename: 'QuizzSurvey' }
    & Pick<IQuizzSurvey, 'id' | 'shortDescription' | 'title' | 'vimeoHlsUrl' | 'sourceUrl' | 'ctaLabel' | 'url'>
    & { liveEventId: IQuizzSurvey['liveEventID'] }
    & { thumbnail?: Maybe<(
      { __typename?: 'MediaWithCrops' }
      & { url: IMediaWithCrops['cropUrl'], bubble: IMediaWithCrops['cropUrl'], optiUrl: IMediaWithCrops['cropUrl'] }
    )>, questions?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
  )> }
);

export type IQuizzSurveyCollectionByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IQuizzSurveyCollectionByIdQuery = (
  { __typename?: 'Query' }
  & { quizzSurveyCollection?: Maybe<(
    { __typename?: 'QuizzSurveyCollection' }
    & IQuizzSurveyCollectionFragmentFragment
  )> }
);

export type IGetSurveyCollectionByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetSurveyCollectionByIdQuery = (
  { __typename?: 'Query' }
  & { quizzSurveyCollection?: Maybe<(
    { __typename: 'QuizzSurveyCollection' }
    & Pick<IQuizzSurveyCollection, 'id' | 'shortDescription' | 'url' | 'title' | 'subtitle'>
    & { questions?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | (
      { __typename: 'ChoiceNugget' }
      & Pick<IChoiceNugget, 'id' | 'genericFeedback' | 'positiveFeedback' | 'negativeFeedback' | 'externalId'>
      & { question?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | (
          { __typename?: 'UcAudio' }
          & IUcAudioFragmentFragment
        ) | (
          { __typename?: 'UcImage' }
          & IUcImageFragmentFragment
        ) | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | (
          { __typename?: 'UcVideo' }
          & IUcVideoFragmentFragment
        ) | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | (
          { __typename: 'Wysiwyg' }
          & Pick<IWysiwyg, 'title' | 'body'>
        ) }
      )>>>, options?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | (
          { __typename?: 'ChoiceNuggerAnswer' }
          & IChoiceNuggerAnswerFragmentFragment
        ) | { __typename?: 'ChoiceNugget' } | (
          { __typename?: 'ChoiceNuggetAnswerGroup' }
          & { answersList?: Maybe<Array<Maybe<(
            { __typename?: 'BlockListItem' }
            & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | (
              { __typename: 'ChoiceNuggerAnswer' }
              & IChoiceNuggerAnswerFragmentFragment
            ) | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
          )>>> }
        ) | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
      )>>> }
    ) | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>> }
  )> }
);

export type IRadioByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IRadioByUrlQuery = (
  { __typename?: 'Query' }
  & { radio?: Maybe<(
    { __typename?: 'Radio' }
    & IRadioFragmentFragment
  )> }
);

export type IRadioByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IRadioByIdQuery = (
  { __typename?: 'Query' }
  & { radio?: Maybe<(
    { __typename?: 'Radio' }
    & IRadioFragmentFragment
  )> }
);

export type IRedirectCancelUrlSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type IRedirectCancelUrlSettingQuery = (
  { __typename?: 'Query' }
  & { allSettings: (
    { __typename?: 'SettingsConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Settings' }
      & Pick<ISettings, 'iOSCancelSubUrl' | 'huaweiCancelSubUrl' | 'androidCancelSubUrl'>
    )>> }
  ) }
);

export type IAllRegionQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllRegionQuery = (
  { __typename?: 'Query' }
  & { allRegion: (
    { __typename?: 'RegionConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Region' }
      & IRegionFragmentFragment
    )>> }
  ) }
);

export type IAllRegionWebQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllRegionWebQuery = (
  { __typename?: 'Query' }
  & { allRegion: (
    { __typename?: 'RegionConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Region' }
      & IRegionWebFragmentFragment
    )>> }
  ) }
);

export type IRegionDiscoveryByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IRegionDiscoveryByIdQuery = (
  { __typename?: 'Query' }
  & { region?: Maybe<(
    { __typename: 'Region' }
    & { discovery?: Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | (
      { __typename?: 'Discovery' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | (
      { __typename: 'SectionPage' }
      & Pick<ISectionPage, 'id'>
    ) | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }> }
  )> }
);

export type IRegionDiscoveryByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IRegionDiscoveryByUrlQuery = (
  { __typename?: 'Query' }
  & { region?: Maybe<(
    { __typename: 'Region' }
    & { discovery?: Maybe<(
      { __typename?: 'ArtistService' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ArtistServiceFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ArtistServicesPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'AwardCategoryPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'AwardsArtist' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'AwardsCategoryMenu' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'AwardsCategoryMenuDev' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'AwardsCategoryMenuFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'AwardsCategoryMenuFolderDev' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'AwardsHomepage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CMSPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CategBgColor' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CategoryPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Channel' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ChannelFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ChoiceNugget' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Collection' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ContentEditorFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ContentTag' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ContentTags' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ContentTagsCateg' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Course' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CourseCategoriesFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CourseCategory' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CourseExam' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CourseShare' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CourseStatus' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CourseTestProgression' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'CourseUnit' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Discovery' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'DiscoverySlide1' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'EntrepreunarialHub' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'FormFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'FormPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'GapfillNugget' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'HelpdeskCateg' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'HelpdeskFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'HelpdeskPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'HomePage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobBoardPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobHub' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobHubsFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobProgress' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobShare' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobTraining' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobTrainingFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobVacanciesFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'JobVacancy' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'LandingPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'LearnMenu' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'LegalsFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ListenCateg' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'LiveEvent' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'LiveEventsMenu' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'LiveEventsPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'LiveTVPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberContentTypesLink' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberDatas' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberDownloaded' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberMessage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberNotify' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberOpportunity' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberSaved' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberSearch' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MemberWatched' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MembersDatas' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'MiniSitesFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'NavMessage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'NavigationMessagesFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'NetlifyDeploy' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'News' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'NewsCateg' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'NewsFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'NewsPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ObtainedJob' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Opportunity' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'OpportunityCenter' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'OpportunityFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Partner' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Partners' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PartnersPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Paywall' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PaywallFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PersonalityPages' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PersonalityQuiz' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PersonalityQuiz1' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PersonalityType' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Playlist' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PlaylistRadioMenu' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Podcast' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PodcastCateg' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PodcastItem' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PodcastMenu' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PromoCode' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'PromoCodeFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'QuizPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'QuizzSurvey' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'QuizzSurveyCategory' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'QuizzSurveyCollection' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Radio' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'RadioCateg' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Region' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'SectionPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Settings' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Space' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'Subscription' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'SubscriptionData' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'SubscriptionDataFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'SubscriptionsFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'SumaryNugget' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'SurveyQuizzFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'TextPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'ThankYouPage' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'TranslationContext' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'TranslationFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'TranslationItem' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'UmbracoTest' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'UnitNuggetAnswer' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'UnitNuggetGapFillAnswer' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'UnitProgression' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'VODItem' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'VODMenu' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'VotingFolder' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'VotingRecord' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    ) | (
      { __typename?: 'WatchCateg' }
      & { children: (
        { __typename: 'ContentConnection' }
        & { edges: Array<Maybe<(
          { __typename: 'ContentEdge' }
          & Pick<IContentEdge, 'cursor'>
          & { node?: Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | (
            { __typename: 'DiscoverySlide1' }
            & IDiscoverySlide1FragmentFragment
          ) | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'Partner' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }> }
        )>>, pageInfo: (
          { __typename?: 'PageInfo' }
          & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
        ) }
      ) }
    )> }
  )> }
);

export type ISearchLearnQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keyWord?: InputMaybe<Scalars['String']>;
  courseCursor?: InputMaybe<Scalars['String']>;
  jobCursor?: InputMaybe<Scalars['String']>;
  partnerCursor?: InputMaybe<Scalars['String']>;
  jobVacancyCursor?: InputMaybe<Scalars['String']>;
  jobHubCursor?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ISearchLearnQuery = (
  { __typename?: 'Query' }
  & { allCourse: (
    { __typename?: 'CourseConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'CourseEdge' }
      & Pick<ICourseEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename: 'Course' }
        & Pick<ICourse, 'title' | 'id' | 'url' | 'length'>
        & { thumbnail?: Maybe<(
          { __typename?: 'MediaWithCrops' }
          & Pick<IMediaWithCrops, 'url'>
        )>, linkedPartners?: Maybe<Array<Maybe<{ __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'CMSPage' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNugget' } | { __typename: 'Collection' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseExam' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HomePage' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'LandingPage' } | { __typename: 'LearnMenu' } | { __typename: 'LegalsFolder' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MiniSitesFolder' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | (
          { __typename: 'Partner' }
          & { logo?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & Pick<IMediaWithCrops, 'url'>
          )> }
        ) | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Settings' } | { __typename: 'Space' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SumaryNugget' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'ThankYouPage' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' }>>>, children: (
          { __typename?: 'ContentConnection' }
          & { items: Array<Maybe<(
            { __typename: 'ArtistService' }
            & Pick<IArtistService, 'id'>
          ) | (
            { __typename: 'ArtistServiceFolder' }
            & Pick<IArtistServiceFolder, 'id'>
          ) | (
            { __typename: 'ArtistServicesPage' }
            & Pick<IArtistServicesPage, 'id'>
          ) | (
            { __typename: 'AwardCategoryPage' }
            & Pick<IAwardCategoryPage, 'id'>
          ) | (
            { __typename: 'AwardsArtist' }
            & Pick<IAwardsArtist, 'id'>
          ) | (
            { __typename: 'AwardsCategoryMenu' }
            & Pick<IAwardsCategoryMenu, 'id'>
          ) | (
            { __typename: 'AwardsCategoryMenuDev' }
            & Pick<IAwardsCategoryMenuDev, 'id'>
          ) | (
            { __typename: 'AwardsCategoryMenuFolder' }
            & Pick<IAwardsCategoryMenuFolder, 'id'>
          ) | (
            { __typename: 'AwardsCategoryMenuFolderDev' }
            & Pick<IAwardsCategoryMenuFolderDev, 'id'>
          ) | (
            { __typename: 'AwardsHomepage' }
            & Pick<IAwardsHomepage, 'id'>
          ) | (
            { __typename: 'CMSPage' }
            & Pick<ICmsPage, 'id'>
          ) | (
            { __typename: 'CategBgColor' }
            & Pick<ICategBgColor, 'id'>
          ) | (
            { __typename: 'CategoryPage' }
            & Pick<ICategoryPage, 'id'>
          ) | (
            { __typename: 'Channel' }
            & Pick<IChannel, 'id'>
          ) | (
            { __typename: 'ChannelFolder' }
            & Pick<IChannelFolder, 'id'>
          ) | (
            { __typename: 'ChoiceNugget' }
            & Pick<IChoiceNugget, 'id'>
          ) | (
            { __typename: 'Collection' }
            & Pick<ICollection, 'id'>
          ) | (
            { __typename: 'ContentEditorFolder' }
            & Pick<IContentEditorFolder, 'id'>
          ) | (
            { __typename: 'ContentTag' }
            & Pick<IContentTag, 'id'>
          ) | (
            { __typename: 'ContentTags' }
            & Pick<IContentTags, 'id'>
          ) | (
            { __typename: 'ContentTagsCateg' }
            & Pick<IContentTagsCateg, 'id'>
          ) | (
            { __typename: 'Course' }
            & Pick<ICourse, 'id'>
          ) | (
            { __typename: 'CourseCategoriesFolder' }
            & Pick<ICourseCategoriesFolder, 'id'>
          ) | (
            { __typename: 'CourseCategory' }
            & Pick<ICourseCategory, 'id'>
          ) | (
            { __typename: 'CourseExam' }
            & Pick<ICourseExam, 'id'>
          ) | (
            { __typename: 'CourseShare' }
            & Pick<ICourseShare, 'id'>
          ) | (
            { __typename: 'CourseStatus' }
            & Pick<ICourseStatus, 'id'>
          ) | (
            { __typename: 'CourseTestProgression' }
            & Pick<ICourseTestProgression, 'id'>
          ) | (
            { __typename: 'CourseUnit' }
            & Pick<ICourseUnit, 'id'>
          ) | (
            { __typename: 'Discovery' }
            & Pick<IDiscovery, 'id'>
          ) | (
            { __typename: 'DiscoverySlide1' }
            & Pick<IDiscoverySlide1, 'id'>
          ) | (
            { __typename: 'EntrepreunarialHub' }
            & Pick<IEntrepreunarialHub, 'id'>
          ) | (
            { __typename: 'FormFolder' }
            & Pick<IFormFolder, 'id'>
          ) | (
            { __typename: 'FormPage' }
            & Pick<IFormPage, 'id'>
          ) | (
            { __typename: 'GapfillNugget' }
            & Pick<IGapfillNugget, 'id'>
          ) | (
            { __typename: 'HelpdeskCateg' }
            & Pick<IHelpdeskCateg, 'id'>
          ) | (
            { __typename: 'HelpdeskFolder' }
            & Pick<IHelpdeskFolder, 'id'>
          ) | (
            { __typename: 'HelpdeskPage' }
            & Pick<IHelpdeskPage, 'id'>
          ) | (
            { __typename: 'HomePage' }
            & Pick<IHomePage, 'id'>
          ) | (
            { __typename: 'JobBoardPage' }
            & Pick<IJobBoardPage, 'id'>
          ) | (
            { __typename: 'JobHub' }
            & Pick<IJobHub, 'id'>
          ) | (
            { __typename: 'JobHubsFolder' }
            & Pick<IJobHubsFolder, 'id'>
          ) | (
            { __typename: 'JobProgress' }
            & Pick<IJobProgress, 'id'>
          ) | (
            { __typename: 'JobShare' }
            & Pick<IJobShare, 'id'>
          ) | (
            { __typename: 'JobTraining' }
            & Pick<IJobTraining, 'id'>
          ) | (
            { __typename: 'JobTrainingFolder' }
            & Pick<IJobTrainingFolder, 'id'>
          ) | (
            { __typename: 'JobVacanciesFolder' }
            & Pick<IJobVacanciesFolder, 'id'>
          ) | (
            { __typename: 'JobVacancy' }
            & Pick<IJobVacancy, 'id'>
          ) | (
            { __typename: 'LandingPage' }
            & Pick<ILandingPage, 'id'>
          ) | (
            { __typename: 'LearnMenu' }
            & Pick<ILearnMenu, 'id'>
          ) | (
            { __typename: 'LegalsFolder' }
            & Pick<ILegalsFolder, 'id'>
          ) | (
            { __typename: 'ListenCateg' }
            & Pick<IListenCateg, 'id'>
          ) | (
            { __typename: 'LiveEvent' }
            & Pick<ILiveEvent, 'id'>
          ) | (
            { __typename: 'LiveEventsMenu' }
            & Pick<ILiveEventsMenu, 'id'>
          ) | (
            { __typename: 'LiveEventsPage' }
            & Pick<ILiveEventsPage, 'id'>
          ) | (
            { __typename: 'LiveTVPage' }
            & Pick<ILiveTvPage, 'id'>
          ) | (
            { __typename: 'MemberContentTypesLink' }
            & Pick<IMemberContentTypesLink, 'id'>
          ) | (
            { __typename: 'MemberDatas' }
            & Pick<IMemberDatas, 'id'>
          ) | (
            { __typename: 'MemberDownloaded' }
            & Pick<IMemberDownloaded, 'id'>
          ) | (
            { __typename: 'MemberMessage' }
            & Pick<IMemberMessage, 'id'>
          ) | (
            { __typename: 'MemberNotify' }
            & Pick<IMemberNotify, 'id'>
          ) | (
            { __typename: 'MemberOpportunity' }
            & Pick<IMemberOpportunity, 'id'>
          ) | (
            { __typename: 'MemberSaved' }
            & Pick<IMemberSaved, 'id'>
          ) | (
            { __typename: 'MemberSearch' }
            & Pick<IMemberSearch, 'id'>
          ) | (
            { __typename: 'MemberWatched' }
            & Pick<IMemberWatched, 'id'>
          ) | (
            { __typename: 'MembersDatas' }
            & Pick<IMembersDatas, 'id'>
          ) | (
            { __typename: 'MiniSitesFolder' }
            & Pick<IMiniSitesFolder, 'id'>
          ) | (
            { __typename: 'NavMessage' }
            & Pick<INavMessage, 'id'>
          ) | (
            { __typename: 'NavigationMessagesFolder' }
            & Pick<INavigationMessagesFolder, 'id'>
          ) | (
            { __typename: 'NetlifyDeploy' }
            & Pick<INetlifyDeploy, 'id'>
          ) | (
            { __typename: 'News' }
            & Pick<INews, 'id'>
          ) | (
            { __typename: 'NewsCateg' }
            & Pick<INewsCateg, 'id'>
          ) | (
            { __typename: 'NewsFolder' }
            & Pick<INewsFolder, 'id'>
          ) | (
            { __typename: 'NewsPage' }
            & Pick<INewsPage, 'id'>
          ) | (
            { __typename: 'ObtainedJob' }
            & Pick<IObtainedJob, 'id'>
          ) | (
            { __typename: 'Opportunity' }
            & Pick<IOpportunity, 'id'>
          ) | (
            { __typename: 'OpportunityCenter' }
            & Pick<IOpportunityCenter, 'id'>
          ) | (
            { __typename: 'OpportunityFolder' }
            & Pick<IOpportunityFolder, 'id'>
          ) | (
            { __typename: 'Partner' }
            & Pick<IPartner, 'id'>
          ) | (
            { __typename: 'Partners' }
            & Pick<IPartners, 'id'>
          ) | (
            { __typename: 'PartnersPage' }
            & Pick<IPartnersPage, 'id'>
          ) | (
            { __typename: 'Paywall' }
            & Pick<IPaywall, 'id'>
          ) | (
            { __typename: 'PaywallFolder' }
            & Pick<IPaywallFolder, 'id'>
          ) | (
            { __typename: 'PersonalityPages' }
            & Pick<IPersonalityPages, 'id'>
          ) | (
            { __typename: 'PersonalityQuiz' }
            & Pick<IPersonalityQuiz, 'id'>
          ) | (
            { __typename: 'PersonalityQuiz1' }
            & Pick<IPersonalityQuiz1, 'id'>
          ) | (
            { __typename: 'PersonalityType' }
            & Pick<IPersonalityType, 'id'>
          ) | (
            { __typename: 'Playlist' }
            & Pick<IPlaylist, 'id'>
          ) | (
            { __typename: 'PlaylistRadioMenu' }
            & Pick<IPlaylistRadioMenu, 'id'>
          ) | (
            { __typename: 'Podcast' }
            & Pick<IPodcast, 'id'>
          ) | (
            { __typename: 'PodcastCateg' }
            & Pick<IPodcastCateg, 'id'>
          ) | (
            { __typename: 'PodcastItem' }
            & Pick<IPodcastItem, 'id'>
          ) | (
            { __typename: 'PodcastMenu' }
            & Pick<IPodcastMenu, 'id'>
          ) | (
            { __typename: 'PromoCode' }
            & Pick<IPromoCode, 'id'>
          ) | (
            { __typename: 'PromoCodeFolder' }
            & Pick<IPromoCodeFolder, 'id'>
          ) | (
            { __typename: 'QuizPage' }
            & Pick<IQuizPage, 'id'>
          ) | (
            { __typename: 'QuizzSurvey' }
            & Pick<IQuizzSurvey, 'id'>
          ) | (
            { __typename: 'QuizzSurveyCategory' }
            & Pick<IQuizzSurveyCategory, 'id'>
          ) | (
            { __typename: 'QuizzSurveyCollection' }
            & Pick<IQuizzSurveyCollection, 'id'>
          ) | (
            { __typename: 'Radio' }
            & Pick<IRadio, 'id'>
          ) | (
            { __typename: 'RadioCateg' }
            & Pick<IRadioCateg, 'id'>
          ) | (
            { __typename: 'Region' }
            & Pick<IRegion, 'id'>
          ) | (
            { __typename: 'SectionPage' }
            & Pick<ISectionPage, 'id'>
          ) | (
            { __typename: 'Settings' }
            & Pick<ISettings, 'id'>
          ) | (
            { __typename: 'Space' }
            & Pick<ISpace, 'id'>
          ) | (
            { __typename: 'Subscription' }
            & Pick<ISubscription, 'id'>
          ) | (
            { __typename: 'SubscriptionData' }
            & Pick<ISubscriptionData, 'id'>
          ) | (
            { __typename: 'SubscriptionDataFolder' }
            & Pick<ISubscriptionDataFolder, 'id'>
          ) | (
            { __typename: 'SubscriptionsFolder' }
            & Pick<ISubscriptionsFolder, 'id'>
          ) | (
            { __typename: 'SumaryNugget' }
            & Pick<ISumaryNugget, 'id'>
          ) | (
            { __typename: 'SurveyQuizzFolder' }
            & Pick<ISurveyQuizzFolder, 'id'>
          ) | (
            { __typename: 'TextPage' }
            & Pick<ITextPage, 'id'>
          ) | (
            { __typename: 'ThankYouPage' }
            & Pick<IThankYouPage, 'id'>
          ) | (
            { __typename: 'TranslationContext' }
            & Pick<ITranslationContext, 'id'>
          ) | (
            { __typename: 'TranslationFolder' }
            & Pick<ITranslationFolder, 'id'>
          ) | (
            { __typename: 'TranslationItem' }
            & Pick<ITranslationItem, 'id'>
          ) | (
            { __typename: 'UmbracoTest' }
            & Pick<IUmbracoTest, 'id'>
          ) | (
            { __typename: 'UnitNuggetAnswer' }
            & Pick<IUnitNuggetAnswer, 'id'>
          ) | (
            { __typename: 'UnitNuggetGapFillAnswer' }
            & Pick<IUnitNuggetGapFillAnswer, 'id'>
          ) | (
            { __typename: 'UnitProgression' }
            & Pick<IUnitProgression, 'id'>
          ) | (
            { __typename: 'VODItem' }
            & Pick<IVodItem, 'id'>
          ) | (
            { __typename: 'VODMenu' }
            & Pick<IVodMenu, 'id'>
          ) | (
            { __typename: 'VotingFolder' }
            & Pick<IVotingFolder, 'id'>
          ) | (
            { __typename: 'VotingRecord' }
            & Pick<IVotingRecord, 'id'>
          ) | (
            { __typename: 'WatchCateg' }
            & Pick<IWatchCateg, 'id'>
          )>> }
        ) }
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allJobTraining: (
    { __typename?: 'JobTrainingConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'JobTrainingEdge' }
      & Pick<IJobTrainingEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'url' | 'title' | 'length'>
        & { partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
          { __typename?: 'Partner' }
          & { logo?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & Pick<IMediaWithCrops, 'url'>
          )> }
        ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>>, cover?: Maybe<Array<Maybe<(
          { __typename?: 'BlockListItem' }
          & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | (
            { __typename?: 'HeroVideoCover' }
            & IHeroVideoCoverFragmentFragment
          ) | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'TutorialSlide' } | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
        )>>>, courses?: Maybe<Array<Maybe<(
          { __typename: 'ArtistService' }
          & Pick<IArtistService, 'id'>
        ) | (
          { __typename: 'ArtistServiceFolder' }
          & Pick<IArtistServiceFolder, 'id'>
        ) | (
          { __typename: 'ArtistServicesPage' }
          & Pick<IArtistServicesPage, 'id'>
        ) | (
          { __typename: 'AwardCategoryPage' }
          & Pick<IAwardCategoryPage, 'id'>
        ) | (
          { __typename: 'AwardsArtist' }
          & Pick<IAwardsArtist, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenu' }
          & Pick<IAwardsCategoryMenu, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuDev' }
          & Pick<IAwardsCategoryMenuDev, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolder' }
          & Pick<IAwardsCategoryMenuFolder, 'id'>
        ) | (
          { __typename: 'AwardsCategoryMenuFolderDev' }
          & Pick<IAwardsCategoryMenuFolderDev, 'id'>
        ) | (
          { __typename: 'AwardsHomepage' }
          & Pick<IAwardsHomepage, 'id'>
        ) | (
          { __typename: 'CMSPage' }
          & Pick<ICmsPage, 'id'>
        ) | (
          { __typename: 'CategBgColor' }
          & Pick<ICategBgColor, 'id'>
        ) | (
          { __typename: 'CategoryPage' }
          & Pick<ICategoryPage, 'id'>
        ) | (
          { __typename: 'Channel' }
          & Pick<IChannel, 'id'>
        ) | (
          { __typename: 'ChannelFolder' }
          & Pick<IChannelFolder, 'id'>
        ) | (
          { __typename: 'ChoiceNugget' }
          & Pick<IChoiceNugget, 'id'>
        ) | (
          { __typename: 'Collection' }
          & Pick<ICollection, 'id'>
        ) | (
          { __typename: 'ContentEditorFolder' }
          & Pick<IContentEditorFolder, 'id'>
        ) | (
          { __typename: 'ContentTag' }
          & Pick<IContentTag, 'id'>
        ) | (
          { __typename: 'ContentTags' }
          & Pick<IContentTags, 'id'>
        ) | (
          { __typename: 'ContentTagsCateg' }
          & Pick<IContentTagsCateg, 'id'>
        ) | (
          { __typename: 'Course' }
          & Pick<ICourse, 'id'>
        ) | (
          { __typename: 'CourseCategoriesFolder' }
          & Pick<ICourseCategoriesFolder, 'id'>
        ) | (
          { __typename: 'CourseCategory' }
          & Pick<ICourseCategory, 'id'>
        ) | (
          { __typename: 'CourseExam' }
          & Pick<ICourseExam, 'id'>
        ) | (
          { __typename: 'CourseShare' }
          & Pick<ICourseShare, 'id'>
        ) | (
          { __typename: 'CourseStatus' }
          & Pick<ICourseStatus, 'id'>
        ) | (
          { __typename: 'CourseTestProgression' }
          & Pick<ICourseTestProgression, 'id'>
        ) | (
          { __typename: 'CourseUnit' }
          & Pick<ICourseUnit, 'id'>
        ) | (
          { __typename: 'Discovery' }
          & Pick<IDiscovery, 'id'>
        ) | (
          { __typename: 'DiscoverySlide1' }
          & Pick<IDiscoverySlide1, 'id'>
        ) | (
          { __typename: 'EntrepreunarialHub' }
          & Pick<IEntrepreunarialHub, 'id'>
        ) | (
          { __typename: 'FormFolder' }
          & Pick<IFormFolder, 'id'>
        ) | (
          { __typename: 'FormPage' }
          & Pick<IFormPage, 'id'>
        ) | (
          { __typename: 'GapfillNugget' }
          & Pick<IGapfillNugget, 'id'>
        ) | (
          { __typename: 'HelpdeskCateg' }
          & Pick<IHelpdeskCateg, 'id'>
        ) | (
          { __typename: 'HelpdeskFolder' }
          & Pick<IHelpdeskFolder, 'id'>
        ) | (
          { __typename: 'HelpdeskPage' }
          & Pick<IHelpdeskPage, 'id'>
        ) | (
          { __typename: 'HomePage' }
          & Pick<IHomePage, 'id'>
        ) | (
          { __typename: 'JobBoardPage' }
          & Pick<IJobBoardPage, 'id'>
        ) | (
          { __typename: 'JobHub' }
          & Pick<IJobHub, 'id'>
        ) | (
          { __typename: 'JobHubsFolder' }
          & Pick<IJobHubsFolder, 'id'>
        ) | (
          { __typename: 'JobProgress' }
          & Pick<IJobProgress, 'id'>
        ) | (
          { __typename: 'JobShare' }
          & Pick<IJobShare, 'id'>
        ) | (
          { __typename: 'JobTraining' }
          & Pick<IJobTraining, 'id'>
        ) | (
          { __typename: 'JobTrainingFolder' }
          & Pick<IJobTrainingFolder, 'id'>
        ) | (
          { __typename: 'JobVacanciesFolder' }
          & Pick<IJobVacanciesFolder, 'id'>
        ) | (
          { __typename: 'JobVacancy' }
          & Pick<IJobVacancy, 'id'>
        ) | (
          { __typename: 'LandingPage' }
          & Pick<ILandingPage, 'id'>
        ) | (
          { __typename: 'LearnMenu' }
          & Pick<ILearnMenu, 'id'>
        ) | (
          { __typename: 'LegalsFolder' }
          & Pick<ILegalsFolder, 'id'>
        ) | (
          { __typename: 'ListenCateg' }
          & Pick<IListenCateg, 'id'>
        ) | (
          { __typename: 'LiveEvent' }
          & Pick<ILiveEvent, 'id'>
        ) | (
          { __typename: 'LiveEventsMenu' }
          & Pick<ILiveEventsMenu, 'id'>
        ) | (
          { __typename: 'LiveEventsPage' }
          & Pick<ILiveEventsPage, 'id'>
        ) | (
          { __typename: 'LiveTVPage' }
          & Pick<ILiveTvPage, 'id'>
        ) | (
          { __typename: 'MemberContentTypesLink' }
          & Pick<IMemberContentTypesLink, 'id'>
        ) | (
          { __typename: 'MemberDatas' }
          & Pick<IMemberDatas, 'id'>
        ) | (
          { __typename: 'MemberDownloaded' }
          & Pick<IMemberDownloaded, 'id'>
        ) | (
          { __typename: 'MemberMessage' }
          & Pick<IMemberMessage, 'id'>
        ) | (
          { __typename: 'MemberNotify' }
          & Pick<IMemberNotify, 'id'>
        ) | (
          { __typename: 'MemberOpportunity' }
          & Pick<IMemberOpportunity, 'id'>
        ) | (
          { __typename: 'MemberSaved' }
          & Pick<IMemberSaved, 'id'>
        ) | (
          { __typename: 'MemberSearch' }
          & Pick<IMemberSearch, 'id'>
        ) | (
          { __typename: 'MemberWatched' }
          & Pick<IMemberWatched, 'id'>
        ) | (
          { __typename: 'MembersDatas' }
          & Pick<IMembersDatas, 'id'>
        ) | (
          { __typename: 'MiniSitesFolder' }
          & Pick<IMiniSitesFolder, 'id'>
        ) | (
          { __typename: 'NavMessage' }
          & Pick<INavMessage, 'id'>
        ) | (
          { __typename: 'NavigationMessagesFolder' }
          & Pick<INavigationMessagesFolder, 'id'>
        ) | (
          { __typename: 'NetlifyDeploy' }
          & Pick<INetlifyDeploy, 'id'>
        ) | (
          { __typename: 'News' }
          & Pick<INews, 'id'>
        ) | (
          { __typename: 'NewsCateg' }
          & Pick<INewsCateg, 'id'>
        ) | (
          { __typename: 'NewsFolder' }
          & Pick<INewsFolder, 'id'>
        ) | (
          { __typename: 'NewsPage' }
          & Pick<INewsPage, 'id'>
        ) | (
          { __typename: 'ObtainedJob' }
          & Pick<IObtainedJob, 'id'>
        ) | (
          { __typename: 'Opportunity' }
          & Pick<IOpportunity, 'id'>
        ) | (
          { __typename: 'OpportunityCenter' }
          & Pick<IOpportunityCenter, 'id'>
        ) | (
          { __typename: 'OpportunityFolder' }
          & Pick<IOpportunityFolder, 'id'>
        ) | (
          { __typename: 'Partner' }
          & Pick<IPartner, 'id'>
        ) | (
          { __typename: 'Partners' }
          & Pick<IPartners, 'id'>
        ) | (
          { __typename: 'PartnersPage' }
          & Pick<IPartnersPage, 'id'>
        ) | (
          { __typename: 'Paywall' }
          & Pick<IPaywall, 'id'>
        ) | (
          { __typename: 'PaywallFolder' }
          & Pick<IPaywallFolder, 'id'>
        ) | (
          { __typename: 'PersonalityPages' }
          & Pick<IPersonalityPages, 'id'>
        ) | (
          { __typename: 'PersonalityQuiz' }
          & Pick<IPersonalityQuiz, 'id'>
        ) | (
          { __typename: 'PersonalityQuiz1' }
          & Pick<IPersonalityQuiz1, 'id'>
        ) | (
          { __typename: 'PersonalityType' }
          & Pick<IPersonalityType, 'id'>
        ) | (
          { __typename: 'Playlist' }
          & Pick<IPlaylist, 'id'>
        ) | (
          { __typename: 'PlaylistRadioMenu' }
          & Pick<IPlaylistRadioMenu, 'id'>
        ) | (
          { __typename: 'Podcast' }
          & Pick<IPodcast, 'id'>
        ) | (
          { __typename: 'PodcastCateg' }
          & Pick<IPodcastCateg, 'id'>
        ) | (
          { __typename: 'PodcastItem' }
          & Pick<IPodcastItem, 'id'>
        ) | (
          { __typename: 'PodcastMenu' }
          & Pick<IPodcastMenu, 'id'>
        ) | (
          { __typename: 'PromoCode' }
          & Pick<IPromoCode, 'id'>
        ) | (
          { __typename: 'PromoCodeFolder' }
          & Pick<IPromoCodeFolder, 'id'>
        ) | (
          { __typename: 'QuizPage' }
          & Pick<IQuizPage, 'id'>
        ) | (
          { __typename: 'QuizzSurvey' }
          & Pick<IQuizzSurvey, 'id'>
        ) | (
          { __typename: 'QuizzSurveyCategory' }
          & Pick<IQuizzSurveyCategory, 'id'>
        ) | (
          { __typename: 'QuizzSurveyCollection' }
          & Pick<IQuizzSurveyCollection, 'id'>
        ) | (
          { __typename: 'Radio' }
          & Pick<IRadio, 'id'>
        ) | (
          { __typename: 'RadioCateg' }
          & Pick<IRadioCateg, 'id'>
        ) | (
          { __typename: 'Region' }
          & Pick<IRegion, 'id'>
        ) | (
          { __typename: 'SectionPage' }
          & Pick<ISectionPage, 'id'>
        ) | (
          { __typename: 'Settings' }
          & Pick<ISettings, 'id'>
        ) | (
          { __typename: 'Space' }
          & Pick<ISpace, 'id'>
        ) | (
          { __typename: 'Subscription' }
          & Pick<ISubscription, 'id'>
        ) | (
          { __typename: 'SubscriptionData' }
          & Pick<ISubscriptionData, 'id'>
        ) | (
          { __typename: 'SubscriptionDataFolder' }
          & Pick<ISubscriptionDataFolder, 'id'>
        ) | (
          { __typename: 'SubscriptionsFolder' }
          & Pick<ISubscriptionsFolder, 'id'>
        ) | (
          { __typename: 'SumaryNugget' }
          & Pick<ISumaryNugget, 'id'>
        ) | (
          { __typename: 'SurveyQuizzFolder' }
          & Pick<ISurveyQuizzFolder, 'id'>
        ) | (
          { __typename: 'TextPage' }
          & Pick<ITextPage, 'id'>
        ) | (
          { __typename: 'ThankYouPage' }
          & Pick<IThankYouPage, 'id'>
        ) | (
          { __typename: 'TranslationContext' }
          & Pick<ITranslationContext, 'id'>
        ) | (
          { __typename: 'TranslationFolder' }
          & Pick<ITranslationFolder, 'id'>
        ) | (
          { __typename: 'TranslationItem' }
          & Pick<ITranslationItem, 'id'>
        ) | (
          { __typename: 'UmbracoTest' }
          & Pick<IUmbracoTest, 'id'>
        ) | (
          { __typename: 'UnitNuggetAnswer' }
          & Pick<IUnitNuggetAnswer, 'id'>
        ) | (
          { __typename: 'UnitNuggetGapFillAnswer' }
          & Pick<IUnitNuggetGapFillAnswer, 'id'>
        ) | (
          { __typename: 'UnitProgression' }
          & Pick<IUnitProgression, 'id'>
        ) | (
          { __typename: 'VODItem' }
          & Pick<IVodItem, 'id'>
        ) | (
          { __typename: 'VODMenu' }
          & Pick<IVodMenu, 'id'>
        ) | (
          { __typename: 'VotingFolder' }
          & Pick<IVotingFolder, 'id'>
        ) | (
          { __typename: 'VotingRecord' }
          & Pick<IVotingRecord, 'id'>
        ) | (
          { __typename: 'WatchCateg' }
          & Pick<IWatchCateg, 'id'>
        )>>> }
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allPartner: (
    { __typename?: 'PartnerConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'PartnerEdge' }
      & Pick<IPartnerEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Partner' }
        & IPartnerFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allJobHub: (
    { __typename?: 'JobHubConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'JobHubEdge' }
      & Pick<IJobHubEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'JobHub' }
        & IJobHubFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allJobVacancy: (
    { __typename?: 'JobVacancyConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'JobVacancyEdge' }
      & Pick<IJobVacancyEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'title' | 'shortDescription' | 'id' | 'url' | 'link'>
        & { thumbnail?: Maybe<(
          { __typename?: 'MediaWithCrops' }
          & Pick<IMediaWithCrops, 'url'>
        )>, partners?: Maybe<Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | (
          { __typename: 'Partner' }
          & Pick<IPartner, 'id'>
          & { logo?: Maybe<(
            { __typename?: 'MediaWithCrops' }
            & Pick<IMediaWithCrops, 'url'>
          )> }
        ) | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>>> }
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type ISearchWatchQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keyWord?: InputMaybe<Scalars['String']>;
  vodCursor?: InputMaybe<Scalars['String']>;
  collectionCursor?: InputMaybe<Scalars['String']>;
  liveEventCursor?: InputMaybe<Scalars['String']>;
  newsCursor?: InputMaybe<Scalars['String']>;
  channelCursor?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ISearchWatchQuery = (
  { __typename?: 'Query' }
  & { allVODItem: (
    { __typename?: 'VODItemConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'VODItemEdge' }
      & Pick<IVodItemEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'VODItem' }
        & IVodItemFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allCollection: (
    { __typename?: 'CollectionConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'CollectionEdge' }
      & Pick<ICollectionEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Collection' }
        & ICollectionFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allLiveEvent: (
    { __typename?: 'LiveEventConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'LiveEventEdge' }
      & Pick<ILiveEventEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'LiveEvent' }
        & ILiveEventFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allNews: (
    { __typename?: 'NewsConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'NewsEdge' }
      & Pick<INewsEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'News' }
        & INewsFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allChannel: (
    { __typename?: 'ChannelConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'ChannelEdge' }
      & Pick<IChannelEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Channel' }
        & IChannelFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type ISearchListenQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  keyWord?: InputMaybe<Scalars['String']>;
  playlistCursor?: InputMaybe<Scalars['String']>;
  radioCursor?: InputMaybe<Scalars['String']>;
  podcastCursor?: InputMaybe<Scalars['String']>;
  podcastItemCursor?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ISearchListenQuery = (
  { __typename?: 'Query' }
  & { allPlaylist: (
    { __typename?: 'PlaylistConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'PlaylistEdge' }
      & Pick<IPlaylistEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Playlist' }
        & IPlaylistFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allRadio: (
    { __typename?: 'RadioConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'RadioEdge' }
      & Pick<IRadioEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Radio' }
        & IRadioFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allPodcast: (
    { __typename?: 'PodcastConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'PodcastEdge' }
      & Pick<IPodcastEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'Podcast' }
        & IPodcastFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ), allPodcastItem: (
    { __typename?: 'PodcastItemConnection' }
    & { edges: Array<Maybe<(
      { __typename: 'PodcastItemEdge' }
      & Pick<IPodcastItemEdge, 'cursor'>
      & { node?: Maybe<(
        { __typename?: 'PodcastItem' }
        & IPodcastItemFragmentFragment
      )> }
    )>>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<IPageInfo, 'hasPreviousPage' | 'hasNextPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type ISectionPageByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ISectionPageByUrlQuery = (
  { __typename?: 'Query' }
  & { sectionPage?: Maybe<(
    { __typename?: 'SectionPage' }
    & ISectionPageFragmentFragment
  )> }
);

export type ISectionPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ISectionPageByIdQuery = (
  { __typename?: 'Query' }
  & { sectionPage?: Maybe<(
    { __typename?: 'SectionPage' }
    & ISectionPageFragmentFragment
  )> }
);

export type ISectionPageContentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ISectionPageContentQuery = (
  { __typename?: 'Query' }
  & { sectionPage?: Maybe<(
    { __typename?: 'SectionPage' }
    & ISectionPageContentFragmentFragment
  )> }
);

export type ISectionPageTopMenuQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type ISectionPageTopMenuQuery = (
  { __typename?: 'Query' }
  & { sectionPage?: Maybe<(
    { __typename?: 'SectionPage' }
    & ISectionPageTopMenuFragmentFragment
  )> }
);

export type ISectionPageTopMenuFragmentFragment = (
  { __typename: 'SectionPage' }
  & Pick<ISectionPage, 'id'>
  & { topMenu?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | (
      { __typename: 'ExpandMenu' }
      & IExpandMenuFragmentFragment
    ) | (
      { __typename: 'ExternalLink' }
      & IExternalLinkFragmentFragment
    ) | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | (
      { __typename: 'LinkPicker' }
      & ILinkPickerFragmentFragment
    ) | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IServiceFromByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IServiceFromByUrlQuery = (
  { __typename?: 'Query' }
  & { formPage?: Maybe<(
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'form' | 'name' | 'url' | 'title' | 'subtitle' | 'id'>
    & { cover?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: (
        { __typename?: 'Accordions' }
        & Pick<IAccordions, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Advantage' }
        & Pick<IAdvantage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AdvantagesList' }
        & Pick<IAdvantagesList, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Article' }
        & Pick<IArticle, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Author' }
        & Pick<IAuthor, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Button' }
        & Pick<IButton, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CTASlide' }
        & Pick<ICtaSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CTASlider' }
        & Pick<ICtaSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Card' }
        & Pick<ICard, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CardIcon' }
        & Pick<ICardIcon, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CardLink' }
        & Pick<ICardLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CardList' }
        & Pick<ICardList, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CategorySlider' }
        & Pick<ICategorySlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CategorySliderHighlight' }
        & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChoiceNuggerAnswer' }
        & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChoiceNuggetAnswerGroup' }
        & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChoiceNuggetQuestion' }
        & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ColorTag' }
        & Pick<IColorTag, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentAudioFileCmp' }
        & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentAudioVimeoCmp' }
        & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentCategCmp' }
        & Pick<IContentCategCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentEPGProgramFileCmp' }
        & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentLink' }
        & Pick<IContentLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentSlider' }
        & Pick<IContentSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentSliderHighlight' }
        & Pick<IContentSliderHighlight, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContextualContentSlider' }
        & Pick<IContextualContentSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseCategorySlider' }
        & Pick<ICourseCategorySlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseItemsSlider' }
        & Pick<ICourseItemsSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseNugget' }
        & Pick<ICourseNugget, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CoursePage' }
        & Pick<ICoursePage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'contentTypeAlias'>
      ) | (
        { __typename?: 'DiscoverySlide' }
        & Pick<IDiscoverySlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'EditoSlider' }
        & Pick<IEditoSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ExpandMenu' }
        & Pick<IExpandMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ExternalLink' }
        & Pick<IExternalLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'FaqItem' }
        & Pick<IFaqItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'FaqPageLink' }
        & Pick<IFaqPageLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Gallery' }
        & Pick<IGallery, 'contentTypeAlias'>
      ) | (
        { __typename?: 'GapFillNuggetAnswer' }
        & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'GapFillNuggetImageAnswer' }
        & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroBanner' }
        & Pick<IHeroBanner, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroBanner1' }
        & Pick<IHeroBanner1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroServices' }
        & Pick<IHeroServices, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroSlide' }
        & Pick<IHeroSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroVideoCover' }
        & Pick<IHeroVideoCover, 'contentTypeAlias'>
        & IHeroVideoCoverFragmentFragment
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'IconSlide' }
        & Pick<IIconSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'InternalLink' }
        & Pick<IInternalLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'contentTypeAlias'>
      ) | (
        { __typename?: 'KeyFigure' }
        & Pick<IKeyFigure, 'contentTypeAlias'>
      ) | (
        { __typename?: 'KeyFigures' }
        & Pick<IKeyFigures, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LandingAbout' }
        & Pick<ILandingAbout, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LearnHeroSlide' }
        & Pick<ILearnHeroSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LegalPageLink' }
        & Pick<ILegalPageLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LinkIcon' }
        & Pick<ILinkIcon, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LinkPicker' }
        & Pick<ILinkPicker, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LogoLink' }
        & Pick<ILogoLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LogoSlider' }
        & Pick<ILogoSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MenuColumn' }
        & Pick<IMenuColumn, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetadatasLanguages' }
        & Pick<IMetadatasLanguages, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetadatasVODLanguage' }
        & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetasExclusives' }
        & Pick<IMetasExclusives, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetasPublicationDate' }
        & Pick<IMetasPublicationDate, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetasTrailerCmp' }
        & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MultiSlider' }
        & Pick<IMultiSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MulticategoriesSlider' }
        & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'contentTypeAlias'>
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NuggetsTextAnswerOption' }
        & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'contentTypeAlias'>
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'contentTypeAlias'>
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PageSEO' }
        & Pick<IPageSeo, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PagecontentSlider' }
        & Pick<IPagecontentSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PartnerSlider' }
        & Pick<IPartnerSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityPush' }
        & Pick<IPersonalityPush, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityQuizQuestion' }
        & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Push' }
        & Pick<IPush, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizItemsSlider' }
        & Pick<IQuizItemsSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'contentTypeAlias'>
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Service' }
        & Pick<IService, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ServicesList' }
        & Pick<IServicesList, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsAccessRestrictionCmp' }
        & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsAccessRestrictionCmp1' }
        & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsAccessRestrictionCmp2' }
        & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsDateCmp' }
        & Pick<ISettingsDateCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsExternalId' }
        & Pick<ISettingsExternalId, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'contentTypeAlias'>
      ) | (
        { __typename?: 'StaticPageLink' }
        & Pick<IStaticPageLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SubscriptionsList' }
        & Pick<ISubscriptionsList, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SummaryNuggetStatement' }
        & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TextSlide1' }
        & Pick<ITextSlide1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TitleSlider' }
        & Pick<ITitleSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Top10Song' }
        & Pick<ITop10Song, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TutorialSlide' }
        & Pick<ITutorialSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcAudio' }
        & Pick<IUcAudio, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcImage' }
        & Pick<IUcImage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcLineBreak' }
        & Pick<IUcLineBreak, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcText' }
        & Pick<IUcText, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcVideo' }
        & Pick<IUcVideo, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswerItem' }
        & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'contentTypeAlias'>
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ValidationElement' }
        & Pick<IValidationElement, 'contentTypeAlias'>
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'contentTypeAlias'>
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'WatchedContent' }
        & Pick<IWatchedContent, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Wysiwyg' }
        & Pick<IWysiwyg, 'contentTypeAlias'>
      ) }
    )>>>, children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'url'>
      )>> }
    ) }
  )> }
);

export type IServiceFromByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IServiceFromByIdQuery = (
  { __typename?: 'Query' }
  & { formPage?: Maybe<(
    { __typename: 'FormPage' }
    & Pick<IFormPage, 'form' | 'name' | 'url' | 'title' | 'subtitle' | 'id'>
    & { cover?: Maybe<Array<Maybe<(
      { __typename?: 'BlockListItem' }
      & { content: (
        { __typename?: 'Accordions' }
        & Pick<IAccordions, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Advantage' }
        & Pick<IAdvantage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AdvantagesList' }
        & Pick<IAdvantagesList, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Article' }
        & Pick<IArticle, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ArtistService' }
        & Pick<IArtistService, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Author' }
        & Pick<IAuthor, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'contentTypeAlias'>
      ) | (
        { __typename?: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Button' }
        & Pick<IButton, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CMSPage' }
        & Pick<ICmsPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CTASlide' }
        & Pick<ICtaSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CTASlider' }
        & Pick<ICtaSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Card' }
        & Pick<ICard, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CardIcon' }
        & Pick<ICardIcon, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CardLink' }
        & Pick<ICardLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CardList' }
        & Pick<ICardList, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CategBgColor' }
        & Pick<ICategBgColor, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CategoryPage' }
        & Pick<ICategoryPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CategorySlider' }
        & Pick<ICategorySlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CategorySliderHighlight' }
        & Pick<ICategorySliderHighlight, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Channel' }
        & Pick<IChannel, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChannelFolder' }
        & Pick<IChannelFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChoiceNuggerAnswer' }
        & Pick<IChoiceNuggerAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChoiceNuggetAnswerGroup' }
        & Pick<IChoiceNuggetAnswerGroup, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ChoiceNuggetQuestion' }
        & Pick<IChoiceNuggetQuestion, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Collection' }
        & Pick<ICollection, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ColorTag' }
        & Pick<IColorTag, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentAudioFileCmp' }
        & Pick<IContentAudioFileCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentAudioVimeoCmp' }
        & Pick<IContentAudioVimeoCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentCategCmp' }
        & Pick<IContentCategCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentEPGProgramFileCmp' }
        & Pick<IContentEpgProgramFileCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentLink' }
        & Pick<IContentLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentSlider' }
        & Pick<IContentSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentSliderHighlight' }
        & Pick<IContentSliderHighlight, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentTag' }
        & Pick<IContentTag, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentTags' }
        & Pick<IContentTags, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ContextualContentSlider' }
        & Pick<IContextualContentSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Course' }
        & Pick<ICourse, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseCategory' }
        & Pick<ICourseCategory, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseCategorySlider' }
        & Pick<ICourseCategorySlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseExam' }
        & Pick<ICourseExam, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseItemsSlider' }
        & Pick<ICourseItemsSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseNugget' }
        & Pick<ICourseNugget, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CoursePage' }
        & Pick<ICoursePage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseShare' }
        & Pick<ICourseShare, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseStatus' }
        & Pick<ICourseStatus, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'contentTypeAlias'>
      ) | (
        { __typename?: 'CourseUnit' }
        & Pick<ICourseUnit, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Discovery' }
        & Pick<IDiscovery, 'contentTypeAlias'>
      ) | (
        { __typename?: 'DiscoverySlide' }
        & Pick<IDiscoverySlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'EditoSlider' }
        & Pick<IEditoSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ExpandMenu' }
        & Pick<IExpandMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ExternalLink' }
        & Pick<IExternalLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'FaqItem' }
        & Pick<IFaqItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'FaqPageLink' }
        & Pick<IFaqPageLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'FormFolder' }
        & Pick<IFormFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'FormPage' }
        & Pick<IFormPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Gallery' }
        & Pick<IGallery, 'contentTypeAlias'>
      ) | (
        { __typename?: 'GapFillNuggetAnswer' }
        & Pick<IGapFillNuggetAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'GapFillNuggetImageAnswer' }
        & Pick<IGapFillNuggetImageAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroBanner' }
        & Pick<IHeroBanner, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroBanner1' }
        & Pick<IHeroBanner1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroServices' }
        & Pick<IHeroServices, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroSlide' }
        & Pick<IHeroSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'HeroVideoCover' }
        & Pick<IHeroVideoCover, 'contentTypeAlias'>
        & IHeroVideoCoverFragmentFragment
      ) | (
        { __typename?: 'HomePage' }
        & Pick<IHomePage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'IconSlide' }
        & Pick<IIconSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'InternalLink' }
        & Pick<IInternalLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobHub' }
        & Pick<IJobHub, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobProgress' }
        & Pick<IJobProgress, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobShare' }
        & Pick<IJobShare, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobTraining' }
        & Pick<IJobTraining, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'JobVacancy' }
        & Pick<IJobVacancy, 'contentTypeAlias'>
      ) | (
        { __typename?: 'KeyFigure' }
        & Pick<IKeyFigure, 'contentTypeAlias'>
      ) | (
        { __typename?: 'KeyFigures' }
        & Pick<IKeyFigures, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LandingAbout' }
        & Pick<ILandingAbout, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LandingPage' }
        & Pick<ILandingPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LearnHeroSlide' }
        & Pick<ILearnHeroSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LearnMenu' }
        & Pick<ILearnMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LegalPageLink' }
        & Pick<ILegalPageLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LinkIcon' }
        & Pick<ILinkIcon, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LinkPicker' }
        & Pick<ILinkPicker, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ListenCateg' }
        & Pick<IListenCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LiveEvent' }
        & Pick<ILiveEvent, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LogoLink' }
        & Pick<ILogoLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'LogoSlider' }
        & Pick<ILogoSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberDatas' }
        & Pick<IMemberDatas, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberMessage' }
        & Pick<IMemberMessage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberNotify' }
        & Pick<IMemberNotify, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberSaved' }
        & Pick<IMemberSaved, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberSearch' }
        & Pick<IMemberSearch, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MemberWatched' }
        & Pick<IMemberWatched, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MembersDatas' }
        & Pick<IMembersDatas, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MenuColumn' }
        & Pick<IMenuColumn, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetadatasLanguages' }
        & Pick<IMetadatasLanguages, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetadatasVODLanguage' }
        & Pick<IMetadatasVodLanguage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetasExclusives' }
        & Pick<IMetasExclusives, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetasPublicationDate' }
        & Pick<IMetasPublicationDate, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MetasTrailerCmp' }
        & Pick<IMetasTrailerCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MultiSlider' }
        & Pick<IMultiSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'MulticategoriesSlider' }
        & Pick<IMulticategoriesSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NavMessage' }
        & Pick<INavMessage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'contentTypeAlias'>
      ) | (
        { __typename?: 'News' }
        & Pick<INews, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NewsCateg' }
        & Pick<INewsCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NewsFolder' }
        & Pick<INewsFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NewsPage' }
        & Pick<INewsPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'NuggetsTextAnswerOption' }
        & Pick<INuggetsTextAnswerOption, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ObtainedJob' }
        & Pick<IObtainedJob, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Opportunity' }
        & Pick<IOpportunity, 'contentTypeAlias'>
      ) | (
        { __typename?: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'contentTypeAlias'>
      ) | (
        { __typename?: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PageSEO' }
        & Pick<IPageSeo, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PagecontentSlider' }
        & Pick<IPagecontentSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Partner' }
        & Pick<IPartner, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PartnerSlider' }
        & Pick<IPartnerSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Partners' }
        & Pick<IPartners, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PartnersPage' }
        & Pick<IPartnersPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Paywall' }
        & Pick<IPaywall, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityPush' }
        & Pick<IPersonalityPush, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityQuizQuestion' }
        & Pick<IPersonalityQuizQuestion, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PersonalityType' }
        & Pick<IPersonalityType, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Playlist' }
        & Pick<IPlaylist, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Podcast' }
        & Pick<IPodcast, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PodcastItem' }
        & Pick<IPodcastItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PromoCode' }
        & Pick<IPromoCode, 'contentTypeAlias'>
      ) | (
        { __typename?: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Push' }
        & Pick<IPush, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizItemsSlider' }
        & Pick<IQuizItemsSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizPage' }
        & Pick<IQuizPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'contentTypeAlias'>
      ) | (
        { __typename?: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Radio' }
        & Pick<IRadio, 'contentTypeAlias'>
      ) | (
        { __typename?: 'RadioCateg' }
        & Pick<IRadioCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Region' }
        & Pick<IRegion, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SectionPage' }
        & Pick<ISectionPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Service' }
        & Pick<IService, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ServicesList' }
        & Pick<IServicesList, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Settings' }
        & Pick<ISettings, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsAccessRestrictionCmp' }
        & Pick<ISettingsAccessRestrictionCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsAccessRestrictionCmp1' }
        & Pick<ISettingsAccessRestrictionCmp1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsAccessRestrictionCmp2' }
        & Pick<ISettingsAccessRestrictionCmp2, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsDateCmp' }
        & Pick<ISettingsDateCmp, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SettingsExternalId' }
        & Pick<ISettingsExternalId, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Space' }
        & Pick<ISpace, 'contentTypeAlias'>
      ) | (
        { __typename?: 'StaticPageLink' }
        & Pick<IStaticPageLink, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Subscription' }
        & Pick<ISubscription, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SubscriptionsList' }
        & Pick<ISubscriptionsList, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SummaryNuggetStatement' }
        & Pick<ISummaryNuggetStatement, 'contentTypeAlias'>
      ) | (
        { __typename?: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TextPage' }
        & Pick<ITextPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TextSlide1' }
        & Pick<ITextSlide1, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ThankYouPage' }
        & Pick<IThankYouPage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TitleSlider' }
        & Pick<ITitleSlider, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Top10Song' }
        & Pick<ITop10Song, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TranslationContext' }
        & Pick<ITranslationContext, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TranslationItem' }
        & Pick<ITranslationItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'TutorialSlide' }
        & Pick<ITutorialSlide, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcAudio' }
        & Pick<IUcAudio, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcImage' }
        & Pick<IUcImage, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcLineBreak' }
        & Pick<IUcLineBreak, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcText' }
        & Pick<IUcText, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UcVideo' }
        & Pick<IUcVideo, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UnitNuggetGapFillAnswerItem' }
        & Pick<IUnitNuggetGapFillAnswerItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'UnitProgression' }
        & Pick<IUnitProgression, 'contentTypeAlias'>
      ) | (
        { __typename?: 'VODItem' }
        & Pick<IVodItem, 'contentTypeAlias'>
      ) | (
        { __typename?: 'VODMenu' }
        & Pick<IVodMenu, 'contentTypeAlias'>
      ) | (
        { __typename?: 'ValidationElement' }
        & Pick<IValidationElement, 'contentTypeAlias'>
      ) | (
        { __typename?: 'VotingFolder' }
        & Pick<IVotingFolder, 'contentTypeAlias'>
      ) | (
        { __typename?: 'VotingRecord' }
        & Pick<IVotingRecord, 'contentTypeAlias'>
      ) | (
        { __typename?: 'WatchCateg' }
        & Pick<IWatchCateg, 'contentTypeAlias'>
      ) | (
        { __typename?: 'WatchedContent' }
        & Pick<IWatchedContent, 'contentTypeAlias'>
      ) | (
        { __typename?: 'Wysiwyg' }
        & Pick<IWysiwyg, 'contentTypeAlias'>
      ) }
    )>>>, children: (
      { __typename?: 'ContentConnection' }
      & { items: Array<Maybe<(
        { __typename: 'ArtistService' }
        & Pick<IArtistService, 'id' | 'url'>
      ) | (
        { __typename: 'ArtistServiceFolder' }
        & Pick<IArtistServiceFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ArtistServicesPage' }
        & Pick<IArtistServicesPage, 'id' | 'url'>
      ) | (
        { __typename: 'AwardCategoryPage' }
        & Pick<IAwardCategoryPage, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsArtist' }
        & Pick<IAwardsArtist, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenu' }
        & Pick<IAwardsCategoryMenu, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuDev' }
        & Pick<IAwardsCategoryMenuDev, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolder' }
        & Pick<IAwardsCategoryMenuFolder, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsCategoryMenuFolderDev' }
        & Pick<IAwardsCategoryMenuFolderDev, 'id' | 'url'>
      ) | (
        { __typename: 'AwardsHomepage' }
        & Pick<IAwardsHomepage, 'id' | 'url'>
      ) | (
        { __typename: 'CMSPage' }
        & Pick<ICmsPage, 'id' | 'url'>
      ) | (
        { __typename: 'CategBgColor' }
        & Pick<ICategBgColor, 'id' | 'url'>
      ) | (
        { __typename: 'CategoryPage' }
        & Pick<ICategoryPage, 'id' | 'url'>
      ) | (
        { __typename: 'Channel' }
        & Pick<IChannel, 'id' | 'url'>
      ) | (
        { __typename: 'ChannelFolder' }
        & Pick<IChannelFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ChoiceNugget' }
        & Pick<IChoiceNugget, 'id' | 'url'>
      ) | (
        { __typename: 'Collection' }
        & Pick<ICollection, 'id' | 'url'>
      ) | (
        { __typename: 'ContentEditorFolder' }
        & Pick<IContentEditorFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTag' }
        & Pick<IContentTag, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTags' }
        & Pick<IContentTags, 'id' | 'url'>
      ) | (
        { __typename: 'ContentTagsCateg' }
        & Pick<IContentTagsCateg, 'id' | 'url'>
      ) | (
        { __typename: 'Course' }
        & Pick<ICourse, 'id' | 'url'>
      ) | (
        { __typename: 'CourseCategoriesFolder' }
        & Pick<ICourseCategoriesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'CourseCategory' }
        & Pick<ICourseCategory, 'id' | 'url'>
      ) | (
        { __typename: 'CourseExam' }
        & Pick<ICourseExam, 'id' | 'url'>
      ) | (
        { __typename: 'CourseShare' }
        & Pick<ICourseShare, 'id' | 'url'>
      ) | (
        { __typename: 'CourseStatus' }
        & Pick<ICourseStatus, 'id' | 'url'>
      ) | (
        { __typename: 'CourseTestProgression' }
        & Pick<ICourseTestProgression, 'id' | 'url'>
      ) | (
        { __typename: 'CourseUnit' }
        & Pick<ICourseUnit, 'id' | 'url'>
      ) | (
        { __typename: 'Discovery' }
        & Pick<IDiscovery, 'id' | 'url'>
      ) | (
        { __typename: 'DiscoverySlide1' }
        & Pick<IDiscoverySlide1, 'id' | 'url'>
      ) | (
        { __typename: 'EntrepreunarialHub' }
        & Pick<IEntrepreunarialHub, 'id' | 'url'>
      ) | (
        { __typename: 'FormFolder' }
        & Pick<IFormFolder, 'id' | 'url'>
      ) | (
        { __typename: 'FormPage' }
        & Pick<IFormPage, 'id' | 'url'>
      ) | (
        { __typename: 'GapfillNugget' }
        & Pick<IGapfillNugget, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskCateg' }
        & Pick<IHelpdeskCateg, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskFolder' }
        & Pick<IHelpdeskFolder, 'id' | 'url'>
      ) | (
        { __typename: 'HelpdeskPage' }
        & Pick<IHelpdeskPage, 'id' | 'url'>
      ) | (
        { __typename: 'HomePage' }
        & Pick<IHomePage, 'id' | 'url'>
      ) | (
        { __typename: 'JobBoardPage' }
        & Pick<IJobBoardPage, 'id' | 'url'>
      ) | (
        { __typename: 'JobHub' }
        & Pick<IJobHub, 'id' | 'url'>
      ) | (
        { __typename: 'JobHubsFolder' }
        & Pick<IJobHubsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobProgress' }
        & Pick<IJobProgress, 'id' | 'url'>
      ) | (
        { __typename: 'JobShare' }
        & Pick<IJobShare, 'id' | 'url'>
      ) | (
        { __typename: 'JobTraining' }
        & Pick<IJobTraining, 'id' | 'url'>
      ) | (
        { __typename: 'JobTrainingFolder' }
        & Pick<IJobTrainingFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobVacanciesFolder' }
        & Pick<IJobVacanciesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'JobVacancy' }
        & Pick<IJobVacancy, 'id' | 'url'>
      ) | (
        { __typename: 'LandingPage' }
        & Pick<ILandingPage, 'id' | 'url'>
      ) | (
        { __typename: 'LearnMenu' }
        & Pick<ILearnMenu, 'id' | 'url'>
      ) | (
        { __typename: 'LegalsFolder' }
        & Pick<ILegalsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'ListenCateg' }
        & Pick<IListenCateg, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEvent' }
        & Pick<ILiveEvent, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEventsMenu' }
        & Pick<ILiveEventsMenu, 'id' | 'url'>
      ) | (
        { __typename: 'LiveEventsPage' }
        & Pick<ILiveEventsPage, 'id' | 'url'>
      ) | (
        { __typename: 'LiveTVPage' }
        & Pick<ILiveTvPage, 'id' | 'url'>
      ) | (
        { __typename: 'MemberContentTypesLink' }
        & Pick<IMemberContentTypesLink, 'id' | 'url'>
      ) | (
        { __typename: 'MemberDatas' }
        & Pick<IMemberDatas, 'id' | 'url'>
      ) | (
        { __typename: 'MemberDownloaded' }
        & Pick<IMemberDownloaded, 'id' | 'url'>
      ) | (
        { __typename: 'MemberMessage' }
        & Pick<IMemberMessage, 'id' | 'url'>
      ) | (
        { __typename: 'MemberNotify' }
        & Pick<IMemberNotify, 'id' | 'url'>
      ) | (
        { __typename: 'MemberOpportunity' }
        & Pick<IMemberOpportunity, 'id' | 'url'>
      ) | (
        { __typename: 'MemberSaved' }
        & Pick<IMemberSaved, 'id' | 'url'>
      ) | (
        { __typename: 'MemberSearch' }
        & Pick<IMemberSearch, 'id' | 'url'>
      ) | (
        { __typename: 'MemberWatched' }
        & Pick<IMemberWatched, 'id' | 'url'>
      ) | (
        { __typename: 'MembersDatas' }
        & Pick<IMembersDatas, 'id' | 'url'>
      ) | (
        { __typename: 'MiniSitesFolder' }
        & Pick<IMiniSitesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NavMessage' }
        & Pick<INavMessage, 'id' | 'url'>
      ) | (
        { __typename: 'NavigationMessagesFolder' }
        & Pick<INavigationMessagesFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NetlifyDeploy' }
        & Pick<INetlifyDeploy, 'id' | 'url'>
      ) | (
        { __typename: 'News' }
        & Pick<INews, 'id' | 'url'>
      ) | (
        { __typename: 'NewsCateg' }
        & Pick<INewsCateg, 'id' | 'url'>
      ) | (
        { __typename: 'NewsFolder' }
        & Pick<INewsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'NewsPage' }
        & Pick<INewsPage, 'id' | 'url'>
      ) | (
        { __typename: 'ObtainedJob' }
        & Pick<IObtainedJob, 'id' | 'url'>
      ) | (
        { __typename: 'Opportunity' }
        & Pick<IOpportunity, 'id' | 'url'>
      ) | (
        { __typename: 'OpportunityCenter' }
        & Pick<IOpportunityCenter, 'id' | 'url'>
      ) | (
        { __typename: 'OpportunityFolder' }
        & Pick<IOpportunityFolder, 'id' | 'url'>
      ) | (
        { __typename: 'Partner' }
        & Pick<IPartner, 'id' | 'url'>
      ) | (
        { __typename: 'Partners' }
        & Pick<IPartners, 'id' | 'url'>
      ) | (
        { __typename: 'PartnersPage' }
        & Pick<IPartnersPage, 'id' | 'url'>
      ) | (
        { __typename: 'Paywall' }
        & Pick<IPaywall, 'id' | 'url'>
      ) | (
        { __typename: 'PaywallFolder' }
        & Pick<IPaywallFolder, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityPages' }
        & Pick<IPersonalityPages, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz' }
        & Pick<IPersonalityQuiz, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityQuiz1' }
        & Pick<IPersonalityQuiz1, 'id' | 'url'>
      ) | (
        { __typename: 'PersonalityType' }
        & Pick<IPersonalityType, 'id' | 'url'>
      ) | (
        { __typename: 'Playlist' }
        & Pick<IPlaylist, 'id' | 'url'>
      ) | (
        { __typename: 'PlaylistRadioMenu' }
        & Pick<IPlaylistRadioMenu, 'id' | 'url'>
      ) | (
        { __typename: 'Podcast' }
        & Pick<IPodcast, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastCateg' }
        & Pick<IPodcastCateg, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastItem' }
        & Pick<IPodcastItem, 'id' | 'url'>
      ) | (
        { __typename: 'PodcastMenu' }
        & Pick<IPodcastMenu, 'id' | 'url'>
      ) | (
        { __typename: 'PromoCode' }
        & Pick<IPromoCode, 'id' | 'url'>
      ) | (
        { __typename: 'PromoCodeFolder' }
        & Pick<IPromoCodeFolder, 'id' | 'url'>
      ) | (
        { __typename: 'QuizPage' }
        & Pick<IQuizPage, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurvey' }
        & Pick<IQuizzSurvey, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCategory' }
        & Pick<IQuizzSurveyCategory, 'id' | 'url'>
      ) | (
        { __typename: 'QuizzSurveyCollection' }
        & Pick<IQuizzSurveyCollection, 'id' | 'url'>
      ) | (
        { __typename: 'Radio' }
        & Pick<IRadio, 'id' | 'url'>
      ) | (
        { __typename: 'RadioCateg' }
        & Pick<IRadioCateg, 'id' | 'url'>
      ) | (
        { __typename: 'Region' }
        & Pick<IRegion, 'id' | 'url'>
      ) | (
        { __typename: 'SectionPage' }
        & Pick<ISectionPage, 'id' | 'url'>
      ) | (
        { __typename: 'Settings' }
        & Pick<ISettings, 'id' | 'url'>
      ) | (
        { __typename: 'Space' }
        & Pick<ISpace, 'id' | 'url'>
      ) | (
        { __typename: 'Subscription' }
        & Pick<ISubscription, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionData' }
        & Pick<ISubscriptionData, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionDataFolder' }
        & Pick<ISubscriptionDataFolder, 'id' | 'url'>
      ) | (
        { __typename: 'SubscriptionsFolder' }
        & Pick<ISubscriptionsFolder, 'id' | 'url'>
      ) | (
        { __typename: 'SumaryNugget' }
        & Pick<ISumaryNugget, 'id' | 'url'>
      ) | (
        { __typename: 'SurveyQuizzFolder' }
        & Pick<ISurveyQuizzFolder, 'id' | 'url'>
      ) | (
        { __typename: 'TextPage' }
        & Pick<ITextPage, 'id' | 'url'>
      ) | (
        { __typename: 'ThankYouPage' }
        & Pick<IThankYouPage, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationContext' }
        & Pick<ITranslationContext, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationFolder' }
        & Pick<ITranslationFolder, 'id' | 'url'>
      ) | (
        { __typename: 'TranslationItem' }
        & Pick<ITranslationItem, 'id' | 'url'>
      ) | (
        { __typename: 'UmbracoTest' }
        & Pick<IUmbracoTest, 'id' | 'url'>
      ) | (
        { __typename: 'UnitNuggetAnswer' }
        & Pick<IUnitNuggetAnswer, 'id' | 'url'>
      ) | (
        { __typename: 'UnitNuggetGapFillAnswer' }
        & Pick<IUnitNuggetGapFillAnswer, 'id' | 'url'>
      ) | (
        { __typename: 'UnitProgression' }
        & Pick<IUnitProgression, 'id' | 'url'>
      ) | (
        { __typename: 'VODItem' }
        & Pick<IVodItem, 'id' | 'url'>
      ) | (
        { __typename: 'VODMenu' }
        & Pick<IVodMenu, 'id' | 'url'>
      ) | (
        { __typename: 'VotingFolder' }
        & Pick<IVotingFolder, 'id' | 'url'>
      ) | (
        { __typename: 'VotingRecord' }
        & Pick<IVotingRecord, 'id' | 'url'>
      ) | (
        { __typename: 'WatchCateg' }
        & Pick<IWatchCateg, 'id' | 'url'>
      )>> }
    ) }
  )> }
);

export type ISettingsQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ISettingsQuery = (
  { __typename?: 'Query' }
  & { allSettings: (
    { __typename?: 'SettingsConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Settings' }
      & { passwordValidation?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | { __typename: 'HeroVideoCover' } | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | (
          { __typename: 'ValidationElement' }
          & Pick<IValidationElement, 'label' | 'regex'>
        ) | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
      )>>> }
      & ISettingsFragmentFragment
    )>> }
  ) }
);

export type ISlideContentQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type ISlideContentQuery = (
  { __typename?: 'Query' }
  & { content?: Maybe<(
    { __typename?: 'ArtistService' }
    & IMainContentListFragment_ArtistService_Fragment
  ) | (
    { __typename?: 'ArtistServiceFolder' }
    & IMainContentListFragment_ArtistServiceFolder_Fragment
  ) | (
    { __typename?: 'ArtistServicesPage' }
    & IMainContentListFragment_ArtistServicesPage_Fragment
  ) | (
    { __typename?: 'AwardCategoryPage' }
    & IMainContentListFragment_AwardCategoryPage_Fragment
  ) | (
    { __typename?: 'AwardsArtist' }
    & IMainContentListFragment_AwardsArtist_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenu' }
    & IMainContentListFragment_AwardsCategoryMenu_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuDev' }
    & IMainContentListFragment_AwardsCategoryMenuDev_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolder' }
    & IMainContentListFragment_AwardsCategoryMenuFolder_Fragment
  ) | (
    { __typename?: 'AwardsCategoryMenuFolderDev' }
    & IMainContentListFragment_AwardsCategoryMenuFolderDev_Fragment
  ) | (
    { __typename?: 'AwardsHomepage' }
    & IMainContentListFragment_AwardsHomepage_Fragment
  ) | (
    { __typename?: 'CMSPage' }
    & IMainContentListFragment_CmsPage_Fragment
  ) | (
    { __typename?: 'CategBgColor' }
    & IMainContentListFragment_CategBgColor_Fragment
  ) | (
    { __typename?: 'CategoryPage' }
    & IMainContentListFragment_CategoryPage_Fragment
  ) | (
    { __typename?: 'Channel' }
    & IMainContentListFragment_Channel_Fragment
  ) | (
    { __typename?: 'ChannelFolder' }
    & IMainContentListFragment_ChannelFolder_Fragment
  ) | (
    { __typename?: 'ChoiceNugget' }
    & IMainContentListFragment_ChoiceNugget_Fragment
  ) | (
    { __typename?: 'Collection' }
    & IMainContentListFragment_Collection_Fragment
  ) | (
    { __typename?: 'ContentEditorFolder' }
    & IMainContentListFragment_ContentEditorFolder_Fragment
  ) | (
    { __typename?: 'ContentTag' }
    & IMainContentListFragment_ContentTag_Fragment
  ) | (
    { __typename?: 'ContentTags' }
    & IMainContentListFragment_ContentTags_Fragment
  ) | (
    { __typename?: 'ContentTagsCateg' }
    & IMainContentListFragment_ContentTagsCateg_Fragment
  ) | (
    { __typename?: 'Course' }
    & IMainContentListFragment_Course_Fragment
  ) | (
    { __typename?: 'CourseCategoriesFolder' }
    & IMainContentListFragment_CourseCategoriesFolder_Fragment
  ) | (
    { __typename?: 'CourseCategory' }
    & IMainContentListFragment_CourseCategory_Fragment
  ) | (
    { __typename?: 'CourseExam' }
    & IMainContentListFragment_CourseExam_Fragment
  ) | (
    { __typename?: 'CourseShare' }
    & IMainContentListFragment_CourseShare_Fragment
  ) | (
    { __typename?: 'CourseStatus' }
    & IMainContentListFragment_CourseStatus_Fragment
  ) | (
    { __typename?: 'CourseTestProgression' }
    & IMainContentListFragment_CourseTestProgression_Fragment
  ) | (
    { __typename?: 'CourseUnit' }
    & IMainContentListFragment_CourseUnit_Fragment
  ) | (
    { __typename?: 'Discovery' }
    & IMainContentListFragment_Discovery_Fragment
  ) | (
    { __typename?: 'DiscoverySlide1' }
    & IMainContentListFragment_DiscoverySlide1_Fragment
  ) | (
    { __typename?: 'EntrepreunarialHub' }
    & IMainContentListFragment_EntrepreunarialHub_Fragment
  ) | (
    { __typename?: 'FormFolder' }
    & IMainContentListFragment_FormFolder_Fragment
  ) | (
    { __typename?: 'FormPage' }
    & IMainContentListFragment_FormPage_Fragment
  ) | (
    { __typename?: 'GapfillNugget' }
    & IMainContentListFragment_GapfillNugget_Fragment
  ) | (
    { __typename?: 'HelpdeskCateg' }
    & IMainContentListFragment_HelpdeskCateg_Fragment
  ) | (
    { __typename?: 'HelpdeskFolder' }
    & IMainContentListFragment_HelpdeskFolder_Fragment
  ) | (
    { __typename?: 'HelpdeskPage' }
    & IMainContentListFragment_HelpdeskPage_Fragment
  ) | (
    { __typename?: 'HomePage' }
    & IMainContentListFragment_HomePage_Fragment
  ) | (
    { __typename?: 'JobBoardPage' }
    & IMainContentListFragment_JobBoardPage_Fragment
  ) | (
    { __typename?: 'JobHub' }
    & IMainContentListFragment_JobHub_Fragment
  ) | (
    { __typename?: 'JobHubsFolder' }
    & IMainContentListFragment_JobHubsFolder_Fragment
  ) | (
    { __typename?: 'JobProgress' }
    & IMainContentListFragment_JobProgress_Fragment
  ) | (
    { __typename?: 'JobShare' }
    & IMainContentListFragment_JobShare_Fragment
  ) | (
    { __typename?: 'JobTraining' }
    & IMainContentListFragment_JobTraining_Fragment
  ) | (
    { __typename?: 'JobTrainingFolder' }
    & IMainContentListFragment_JobTrainingFolder_Fragment
  ) | (
    { __typename?: 'JobVacanciesFolder' }
    & IMainContentListFragment_JobVacanciesFolder_Fragment
  ) | (
    { __typename?: 'JobVacancy' }
    & IMainContentListFragment_JobVacancy_Fragment
  ) | (
    { __typename?: 'LandingPage' }
    & IMainContentListFragment_LandingPage_Fragment
  ) | (
    { __typename?: 'LearnMenu' }
    & IMainContentListFragment_LearnMenu_Fragment
  ) | (
    { __typename?: 'LegalsFolder' }
    & IMainContentListFragment_LegalsFolder_Fragment
  ) | (
    { __typename?: 'ListenCateg' }
    & IMainContentListFragment_ListenCateg_Fragment
  ) | (
    { __typename?: 'LiveEvent' }
    & IMainContentListFragment_LiveEvent_Fragment
  ) | (
    { __typename?: 'LiveEventsMenu' }
    & IMainContentListFragment_LiveEventsMenu_Fragment
  ) | (
    { __typename?: 'LiveEventsPage' }
    & IMainContentListFragment_LiveEventsPage_Fragment
  ) | (
    { __typename?: 'LiveTVPage' }
    & IMainContentListFragment_LiveTvPage_Fragment
  ) | (
    { __typename?: 'MemberContentTypesLink' }
    & IMainContentListFragment_MemberContentTypesLink_Fragment
  ) | (
    { __typename?: 'MemberDatas' }
    & IMainContentListFragment_MemberDatas_Fragment
  ) | (
    { __typename?: 'MemberDownloaded' }
    & IMainContentListFragment_MemberDownloaded_Fragment
  ) | (
    { __typename?: 'MemberMessage' }
    & IMainContentListFragment_MemberMessage_Fragment
  ) | (
    { __typename?: 'MemberNotify' }
    & IMainContentListFragment_MemberNotify_Fragment
  ) | (
    { __typename?: 'MemberOpportunity' }
    & IMainContentListFragment_MemberOpportunity_Fragment
  ) | (
    { __typename?: 'MemberSaved' }
    & IMainContentListFragment_MemberSaved_Fragment
  ) | (
    { __typename?: 'MemberSearch' }
    & IMainContentListFragment_MemberSearch_Fragment
  ) | (
    { __typename?: 'MemberWatched' }
    & IMainContentListFragment_MemberWatched_Fragment
  ) | (
    { __typename?: 'MembersDatas' }
    & IMainContentListFragment_MembersDatas_Fragment
  ) | (
    { __typename?: 'MiniSitesFolder' }
    & IMainContentListFragment_MiniSitesFolder_Fragment
  ) | (
    { __typename?: 'NavMessage' }
    & IMainContentListFragment_NavMessage_Fragment
  ) | (
    { __typename?: 'NavigationMessagesFolder' }
    & IMainContentListFragment_NavigationMessagesFolder_Fragment
  ) | (
    { __typename?: 'NetlifyDeploy' }
    & IMainContentListFragment_NetlifyDeploy_Fragment
  ) | (
    { __typename?: 'News' }
    & IMainContentListFragment_News_Fragment
  ) | (
    { __typename?: 'NewsCateg' }
    & IMainContentListFragment_NewsCateg_Fragment
  ) | (
    { __typename?: 'NewsFolder' }
    & IMainContentListFragment_NewsFolder_Fragment
  ) | (
    { __typename?: 'NewsPage' }
    & IMainContentListFragment_NewsPage_Fragment
  ) | (
    { __typename?: 'ObtainedJob' }
    & IMainContentListFragment_ObtainedJob_Fragment
  ) | (
    { __typename?: 'Opportunity' }
    & IMainContentListFragment_Opportunity_Fragment
  ) | (
    { __typename?: 'OpportunityCenter' }
    & IMainContentListFragment_OpportunityCenter_Fragment
  ) | (
    { __typename?: 'OpportunityFolder' }
    & IMainContentListFragment_OpportunityFolder_Fragment
  ) | (
    { __typename?: 'Partner' }
    & IMainContentListFragment_Partner_Fragment
  ) | (
    { __typename?: 'Partners' }
    & IMainContentListFragment_Partners_Fragment
  ) | (
    { __typename?: 'PartnersPage' }
    & IMainContentListFragment_PartnersPage_Fragment
  ) | (
    { __typename?: 'Paywall' }
    & IMainContentListFragment_Paywall_Fragment
  ) | (
    { __typename?: 'PaywallFolder' }
    & IMainContentListFragment_PaywallFolder_Fragment
  ) | (
    { __typename?: 'PersonalityPages' }
    & IMainContentListFragment_PersonalityPages_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz' }
    & IMainContentListFragment_PersonalityQuiz_Fragment
  ) | (
    { __typename?: 'PersonalityQuiz1' }
    & IMainContentListFragment_PersonalityQuiz1_Fragment
  ) | (
    { __typename?: 'PersonalityType' }
    & IMainContentListFragment_PersonalityType_Fragment
  ) | (
    { __typename?: 'Playlist' }
    & IMainContentListFragment_Playlist_Fragment
  ) | (
    { __typename?: 'PlaylistRadioMenu' }
    & IMainContentListFragment_PlaylistRadioMenu_Fragment
  ) | (
    { __typename?: 'Podcast' }
    & IMainContentListFragment_Podcast_Fragment
  ) | (
    { __typename?: 'PodcastCateg' }
    & IMainContentListFragment_PodcastCateg_Fragment
  ) | (
    { __typename?: 'PodcastItem' }
    & IMainContentListFragment_PodcastItem_Fragment
  ) | (
    { __typename?: 'PodcastMenu' }
    & IMainContentListFragment_PodcastMenu_Fragment
  ) | (
    { __typename?: 'PromoCode' }
    & IMainContentListFragment_PromoCode_Fragment
  ) | (
    { __typename?: 'PromoCodeFolder' }
    & IMainContentListFragment_PromoCodeFolder_Fragment
  ) | (
    { __typename?: 'QuizPage' }
    & IMainContentListFragment_QuizPage_Fragment
  ) | (
    { __typename?: 'QuizzSurvey' }
    & IMainContentListFragment_QuizzSurvey_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCategory' }
    & IMainContentListFragment_QuizzSurveyCategory_Fragment
  ) | (
    { __typename?: 'QuizzSurveyCollection' }
    & IMainContentListFragment_QuizzSurveyCollection_Fragment
  ) | (
    { __typename?: 'Radio' }
    & IMainContentListFragment_Radio_Fragment
  ) | (
    { __typename?: 'RadioCateg' }
    & IMainContentListFragment_RadioCateg_Fragment
  ) | (
    { __typename?: 'Region' }
    & IMainContentListFragment_Region_Fragment
  ) | (
    { __typename?: 'SectionPage' }
    & IMainContentListFragment_SectionPage_Fragment
  ) | (
    { __typename?: 'Settings' }
    & IMainContentListFragment_Settings_Fragment
  ) | (
    { __typename?: 'Space' }
    & IMainContentListFragment_Space_Fragment
  ) | (
    { __typename?: 'Subscription' }
    & IMainContentListFragment_Subscription_Fragment
  ) | (
    { __typename?: 'SubscriptionData' }
    & IMainContentListFragment_SubscriptionData_Fragment
  ) | (
    { __typename?: 'SubscriptionDataFolder' }
    & IMainContentListFragment_SubscriptionDataFolder_Fragment
  ) | (
    { __typename?: 'SubscriptionsFolder' }
    & IMainContentListFragment_SubscriptionsFolder_Fragment
  ) | (
    { __typename?: 'SumaryNugget' }
    & IMainContentListFragment_SumaryNugget_Fragment
  ) | (
    { __typename?: 'SurveyQuizzFolder' }
    & IMainContentListFragment_SurveyQuizzFolder_Fragment
  ) | (
    { __typename?: 'TextPage' }
    & IMainContentListFragment_TextPage_Fragment
  ) | (
    { __typename?: 'ThankYouPage' }
    & IMainContentListFragment_ThankYouPage_Fragment
  ) | (
    { __typename?: 'TranslationContext' }
    & IMainContentListFragment_TranslationContext_Fragment
  ) | (
    { __typename?: 'TranslationFolder' }
    & IMainContentListFragment_TranslationFolder_Fragment
  ) | (
    { __typename?: 'TranslationItem' }
    & IMainContentListFragment_TranslationItem_Fragment
  ) | (
    { __typename?: 'UmbracoTest' }
    & IMainContentListFragment_UmbracoTest_Fragment
  ) | (
    { __typename?: 'UnitNuggetAnswer' }
    & IMainContentListFragment_UnitNuggetAnswer_Fragment
  ) | (
    { __typename?: 'UnitNuggetGapFillAnswer' }
    & IMainContentListFragment_UnitNuggetGapFillAnswer_Fragment
  ) | (
    { __typename?: 'UnitProgression' }
    & IMainContentListFragment_UnitProgression_Fragment
  ) | (
    { __typename?: 'VODItem' }
    & IMainContentListFragment_VodItem_Fragment
  ) | (
    { __typename?: 'VODMenu' }
    & IMainContentListFragment_VodMenu_Fragment
  ) | (
    { __typename?: 'VotingFolder' }
    & IMainContentListFragment_VotingFolder_Fragment
  ) | (
    { __typename?: 'VotingRecord' }
    & IMainContentListFragment_VotingRecord_Fragment
  ) | (
    { __typename?: 'WatchCateg' }
    & IMainContentListFragment_WatchCateg_Fragment
  )> }
);

export type IAllSubscriptionQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IAllSubscriptionQuery = (
  { __typename?: 'Query' }
  & { allSubscription: (
    { __typename?: 'SubscriptionConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'Subscription' }
      & ISubscriptionFragmentFragment
    )>> }
  ) }
);

export type IMemberSubscriptionQueryVariables = Exact<{
  memberId?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IMemberSubscriptionQuery = (
  { __typename?: 'Query' }
  & { allSubscriptionData: (
    { __typename: 'SubscriptionDataConnection' }
    & { items: Array<Maybe<(
      { __typename: 'SubscriptionData' }
      & ISubscriptionDataFragmentFragment
    )>> }
  ) }
);

export type IThankYouPageByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IThankYouPageByIdQuery = (
  { __typename?: 'Query' }
  & { thankYouPage?: Maybe<(
    { __typename?: 'ThankYouPage' }
    & IThankYouPageFragmentFragment
  )> }
);

export type ITranslationContextQueryVariables = Exact<{
  context?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
}>;


export type ITranslationContextQuery = (
  { __typename?: 'Query' }
  & { allTranslationContext: (
    { __typename?: 'TranslationContextConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'TranslationContext' }
      & Pick<ITranslationContext, 'name' | 'id'>
      & { children: (
        { __typename?: 'ContentConnection' }
        & { items: Array<Maybe<{ __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'CMSPage' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'Collection' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HomePage' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalsFolder' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'Partner' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Settings' } | { __typename?: 'Space' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | (
          { __typename?: 'TranslationItem' }
          & ITranslationItemFragmentFragment
        ) | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' }>> }
      ) }
    )>> }
  ) }
);

export type ITranslationContextCheckQueryVariables = Exact<{
  context?: InputMaybe<Scalars['String']>;
}>;


export type ITranslationContextCheckQuery = (
  { __typename?: 'Query' }
  & { allTranslationContext: (
    { __typename?: 'TranslationContextConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'TranslationContext' }
      & Pick<ITranslationContext, 'name' | 'id'>
    )>> }
  ) }
);

export type ITranslationItemByNameQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type ITranslationItemByNameQuery = (
  { __typename?: 'Query' }
  & { allTranslationItem: (
    { __typename?: 'TranslationItemConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'TranslationItem' }
      & ITranslationItemFragmentFragment
    )>> }
  ) }
);

export type IGetTutorialQueryVariables = Exact<{
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IGetTutorialQuery = (
  { __typename?: 'Query' }
  & { allSettings: (
    { __typename?: 'SettingsConnection' }
    & { items: Array<Maybe<(
      { __typename: 'Settings' }
      & Pick<ISettings, 'id'>
      & { tutorialSlides?: Maybe<Array<Maybe<(
        { __typename?: 'BlockListItem' }
        & { content: { __typename?: 'Accordions' } | { __typename?: 'Advantage' } | { __typename?: 'AdvantagesList' } | { __typename?: 'Article' } | { __typename?: 'ArtistService' } | { __typename?: 'ArtistServiceFolder' } | { __typename?: 'ArtistServicesPage' } | { __typename?: 'Author' } | { __typename?: 'AwardCategoryPage' } | { __typename?: 'AwardsArtist' } | { __typename?: 'AwardsCategoryMenu' } | { __typename?: 'AwardsCategoryMenuDev' } | { __typename?: 'AwardsCategoryMenuFolder' } | { __typename?: 'AwardsCategoryMenuFolderDev' } | { __typename?: 'AwardsHomepage' } | { __typename?: 'Button' } | { __typename?: 'CMSPage' } | { __typename?: 'CTASlide' } | { __typename?: 'CTASlider' } | { __typename?: 'Card' } | { __typename?: 'CardIcon' } | { __typename?: 'CardLink' } | { __typename?: 'CardList' } | { __typename?: 'CategBgColor' } | { __typename?: 'CategoryPage' } | { __typename?: 'CategorySlider' } | { __typename?: 'CategorySliderHighlight' } | { __typename?: 'Channel' } | { __typename?: 'ChannelFolder' } | { __typename?: 'ChoiceNuggerAnswer' } | { __typename?: 'ChoiceNugget' } | { __typename?: 'ChoiceNuggetAnswerGroup' } | { __typename?: 'ChoiceNuggetQuestion' } | { __typename?: 'Collection' } | { __typename?: 'ColorTag' } | { __typename?: 'ContentAudioFileCmp' } | { __typename?: 'ContentAudioVimeoCmp' } | { __typename?: 'ContentCategCmp' } | { __typename?: 'ContentEPGProgramFileCmp' } | { __typename?: 'ContentEditorFolder' } | { __typename?: 'ContentLink' } | { __typename?: 'ContentSlider' } | { __typename?: 'ContentSliderHighlight' } | { __typename?: 'ContentTag' } | { __typename?: 'ContentTags' } | { __typename?: 'ContentTagsCateg' } | { __typename?: 'ContextualContentSlider' } | { __typename?: 'Course' } | { __typename?: 'CourseCategoriesFolder' } | { __typename?: 'CourseCategory' } | { __typename?: 'CourseCategorySlider' } | { __typename?: 'CourseExam' } | { __typename?: 'CourseItemsSlider' } | { __typename?: 'CourseNugget' } | { __typename?: 'CoursePage' } | { __typename?: 'CourseShare' } | { __typename?: 'CourseStatus' } | { __typename?: 'CourseTestProgression' } | { __typename?: 'CourseUnit' } | { __typename?: 'Discovery' } | { __typename?: 'DiscoverySlide' } | { __typename?: 'DiscoverySlide1' } | { __typename?: 'EditoSlider' } | { __typename?: 'EntrepreunarialHub' } | { __typename?: 'ExpandMenu' } | { __typename?: 'ExternalLink' } | { __typename?: 'FaqItem' } | { __typename?: 'FaqPageLink' } | { __typename?: 'FormFolder' } | { __typename?: 'FormPage' } | { __typename?: 'Gallery' } | { __typename?: 'GapFillNuggetAnswer' } | { __typename?: 'GapFillNuggetImageAnswer' } | { __typename?: 'GapfillNugget' } | { __typename?: 'HelpdeskCateg' } | { __typename?: 'HelpdeskFolder' } | { __typename?: 'HelpdeskPage' } | { __typename?: 'HeroBanner' } | { __typename?: 'HeroBanner1' } | { __typename?: 'HeroServices' } | { __typename?: 'HeroSlide' } | { __typename?: 'HeroVideoCover' } | { __typename?: 'HomePage' } | { __typename?: 'IconSlide' } | { __typename?: 'InternalLink' } | { __typename?: 'JobBoardPage' } | { __typename?: 'JobHub' } | { __typename?: 'JobHubsFolder' } | { __typename?: 'JobProgress' } | { __typename?: 'JobShare' } | { __typename?: 'JobTraining' } | { __typename?: 'JobTrainingFolder' } | { __typename?: 'JobVacanciesFolder' } | { __typename?: 'JobVacancy' } | { __typename?: 'KeyFigure' } | { __typename?: 'KeyFigures' } | { __typename?: 'LandingAbout' } | { __typename?: 'LandingPage' } | { __typename?: 'LearnHeroSlide' } | { __typename?: 'LearnMenu' } | { __typename?: 'LegalPageLink' } | { __typename?: 'LegalsFolder' } | { __typename?: 'LinkIcon' } | { __typename?: 'LinkPicker' } | { __typename?: 'ListenCateg' } | { __typename?: 'LiveEvent' } | { __typename?: 'LiveEventsMenu' } | { __typename?: 'LiveEventsPage' } | { __typename?: 'LiveTVPage' } | { __typename?: 'LogoLink' } | { __typename?: 'LogoSlider' } | { __typename?: 'MemberContentTypesLink' } | { __typename?: 'MemberDatas' } | { __typename?: 'MemberDownloaded' } | { __typename?: 'MemberMessage' } | { __typename?: 'MemberNotify' } | { __typename?: 'MemberOpportunity' } | { __typename?: 'MemberSaved' } | { __typename?: 'MemberSearch' } | { __typename?: 'MemberWatched' } | { __typename?: 'MembersDatas' } | { __typename?: 'MenuColumn' } | { __typename?: 'MetadatasLanguages' } | { __typename?: 'MetadatasVODLanguage' } | { __typename?: 'MetasExclusives' } | { __typename?: 'MetasPublicationDate' } | { __typename?: 'MetasTrailerCmp' } | { __typename?: 'MiniSitesFolder' } | { __typename?: 'MultiSlider' } | { __typename?: 'MulticategoriesSlider' } | { __typename?: 'NavMessage' } | { __typename?: 'NavigationMessagesFolder' } | { __typename?: 'NetlifyDeploy' } | { __typename?: 'News' } | { __typename?: 'NewsCateg' } | { __typename?: 'NewsFolder' } | { __typename?: 'NewsPage' } | { __typename?: 'NuggetsTextAnswerOption' } | { __typename?: 'ObtainedJob' } | { __typename?: 'Opportunity' } | { __typename?: 'OpportunityCenter' } | { __typename?: 'OpportunityFolder' } | { __typename?: 'PageSEO' } | { __typename?: 'PagecontentSlider' } | { __typename?: 'Partner' } | { __typename?: 'PartnerSlider' } | { __typename?: 'Partners' } | { __typename?: 'PartnersPage' } | { __typename?: 'Paywall' } | { __typename?: 'PaywallFolder' } | { __typename?: 'PersonalityPages' } | { __typename?: 'PersonalityPush' } | { __typename?: 'PersonalityQuiz' } | { __typename?: 'PersonalityQuiz1' } | { __typename?: 'PersonalityQuizQuestion' } | { __typename?: 'PersonalityType' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistRadioMenu' } | { __typename?: 'Podcast' } | { __typename?: 'PodcastCateg' } | { __typename?: 'PodcastItem' } | { __typename?: 'PodcastMenu' } | { __typename?: 'PromoCode' } | { __typename?: 'PromoCodeFolder' } | { __typename?: 'Push' } | { __typename?: 'QuizItemsSlider' } | { __typename?: 'QuizPage' } | { __typename?: 'QuizzSurvey' } | { __typename?: 'QuizzSurveyCategory' } | { __typename?: 'QuizzSurveyCollection' } | { __typename?: 'Radio' } | { __typename?: 'RadioCateg' } | { __typename?: 'Region' } | { __typename?: 'SectionPage' } | { __typename?: 'Service' } | { __typename?: 'ServicesList' } | { __typename?: 'Settings' } | { __typename?: 'SettingsAccessRestrictionCmp' } | { __typename?: 'SettingsAccessRestrictionCmp1' } | { __typename?: 'SettingsAccessRestrictionCmp2' } | { __typename?: 'SettingsDateCmp' } | { __typename?: 'SettingsExternalId' } | { __typename?: 'Space' } | { __typename?: 'StaticPageLink' } | { __typename?: 'Subscription' } | { __typename?: 'SubscriptionData' } | { __typename?: 'SubscriptionDataFolder' } | { __typename?: 'SubscriptionsFolder' } | { __typename?: 'SubscriptionsList' } | { __typename?: 'SumaryNugget' } | { __typename?: 'SummaryNuggetStatement' } | { __typename?: 'SurveyQuizzFolder' } | { __typename?: 'TextPage' } | { __typename?: 'TextSlide1' } | { __typename?: 'ThankYouPage' } | { __typename?: 'TitleSlider' } | { __typename?: 'Top10Song' } | { __typename?: 'TranslationContext' } | { __typename?: 'TranslationFolder' } | { __typename?: 'TranslationItem' } | (
          { __typename?: 'TutorialSlide' }
          & ITutorialSlideFragmentFragment
        ) | { __typename?: 'UcAudio' } | { __typename?: 'UcImage' } | { __typename?: 'UcLineBreak' } | { __typename?: 'UcText' } | { __typename?: 'UcVideo' } | { __typename?: 'UmbracoTest' } | { __typename?: 'UnitNuggetAnswer' } | { __typename?: 'UnitNuggetGapFillAnswer' } | { __typename?: 'UnitNuggetGapFillAnswerItem' } | { __typename?: 'UnitProgression' } | { __typename?: 'VODItem' } | { __typename?: 'VODMenu' } | { __typename?: 'ValidationElement' } | { __typename?: 'VotingFolder' } | { __typename?: 'VotingRecord' } | { __typename?: 'WatchCateg' } | { __typename?: 'WatchedContent' } | { __typename?: 'Wysiwyg' } }
      )>>> }
    )>> }
  ) }
);

export type ITutorialSlideFragmentFragment = (
  { __typename: 'TutorialSlide' }
  & Pick<ITutorialSlide, 'title' | 'description'>
  & { cover?: Maybe<Array<Maybe<(
    { __typename?: 'BlockListItem' }
    & { content: { __typename: 'Accordions' } | { __typename: 'Advantage' } | { __typename: 'AdvantagesList' } | { __typename: 'Article' } | { __typename: 'ArtistService' } | { __typename: 'ArtistServiceFolder' } | { __typename: 'ArtistServicesPage' } | { __typename: 'Author' } | { __typename: 'AwardCategoryPage' } | { __typename: 'AwardsArtist' } | { __typename: 'AwardsCategoryMenu' } | { __typename: 'AwardsCategoryMenuDev' } | { __typename: 'AwardsCategoryMenuFolder' } | { __typename: 'AwardsCategoryMenuFolderDev' } | { __typename: 'AwardsHomepage' } | { __typename: 'Button' } | { __typename: 'CMSPage' } | { __typename: 'CTASlide' } | { __typename: 'CTASlider' } | { __typename: 'Card' } | { __typename: 'CardIcon' } | { __typename: 'CardLink' } | { __typename: 'CardList' } | { __typename: 'CategBgColor' } | { __typename: 'CategoryPage' } | { __typename: 'CategorySlider' } | { __typename: 'CategorySliderHighlight' } | { __typename: 'Channel' } | { __typename: 'ChannelFolder' } | { __typename: 'ChoiceNuggerAnswer' } | { __typename: 'ChoiceNugget' } | { __typename: 'ChoiceNuggetAnswerGroup' } | { __typename: 'ChoiceNuggetQuestion' } | { __typename: 'Collection' } | { __typename: 'ColorTag' } | { __typename: 'ContentAudioFileCmp' } | { __typename: 'ContentAudioVimeoCmp' } | { __typename: 'ContentCategCmp' } | { __typename: 'ContentEPGProgramFileCmp' } | { __typename: 'ContentEditorFolder' } | { __typename: 'ContentLink' } | { __typename: 'ContentSlider' } | { __typename: 'ContentSliderHighlight' } | { __typename: 'ContentTag' } | { __typename: 'ContentTags' } | { __typename: 'ContentTagsCateg' } | { __typename: 'ContextualContentSlider' } | { __typename: 'Course' } | { __typename: 'CourseCategoriesFolder' } | { __typename: 'CourseCategory' } | { __typename: 'CourseCategorySlider' } | { __typename: 'CourseExam' } | { __typename: 'CourseItemsSlider' } | { __typename: 'CourseNugget' } | { __typename: 'CoursePage' } | { __typename: 'CourseShare' } | { __typename: 'CourseStatus' } | { __typename: 'CourseTestProgression' } | { __typename: 'CourseUnit' } | { __typename: 'Discovery' } | { __typename: 'DiscoverySlide' } | { __typename: 'DiscoverySlide1' } | { __typename: 'EditoSlider' } | { __typename: 'EntrepreunarialHub' } | { __typename: 'ExpandMenu' } | { __typename: 'ExternalLink' } | { __typename: 'FaqItem' } | { __typename: 'FaqPageLink' } | { __typename: 'FormFolder' } | { __typename: 'FormPage' } | { __typename: 'Gallery' } | { __typename: 'GapFillNuggetAnswer' } | { __typename: 'GapFillNuggetImageAnswer' } | { __typename: 'GapfillNugget' } | { __typename: 'HelpdeskCateg' } | { __typename: 'HelpdeskFolder' } | { __typename: 'HelpdeskPage' } | { __typename: 'HeroBanner' } | { __typename: 'HeroBanner1' } | { __typename: 'HeroServices' } | { __typename: 'HeroSlide' } | (
      { __typename: 'HeroVideoCover' }
      & IHeroVideoCoverFragmentFragment
    ) | { __typename: 'HomePage' } | { __typename: 'IconSlide' } | { __typename: 'InternalLink' } | { __typename: 'JobBoardPage' } | { __typename: 'JobHub' } | { __typename: 'JobHubsFolder' } | { __typename: 'JobProgress' } | { __typename: 'JobShare' } | { __typename: 'JobTraining' } | { __typename: 'JobTrainingFolder' } | { __typename: 'JobVacanciesFolder' } | { __typename: 'JobVacancy' } | { __typename: 'KeyFigure' } | { __typename: 'KeyFigures' } | { __typename: 'LandingAbout' } | { __typename: 'LandingPage' } | { __typename: 'LearnHeroSlide' } | { __typename: 'LearnMenu' } | { __typename: 'LegalPageLink' } | { __typename: 'LegalsFolder' } | { __typename: 'LinkIcon' } | { __typename: 'LinkPicker' } | { __typename: 'ListenCateg' } | { __typename: 'LiveEvent' } | { __typename: 'LiveEventsMenu' } | { __typename: 'LiveEventsPage' } | { __typename: 'LiveTVPage' } | { __typename: 'LogoLink' } | { __typename: 'LogoSlider' } | { __typename: 'MemberContentTypesLink' } | { __typename: 'MemberDatas' } | { __typename: 'MemberDownloaded' } | { __typename: 'MemberMessage' } | { __typename: 'MemberNotify' } | { __typename: 'MemberOpportunity' } | { __typename: 'MemberSaved' } | { __typename: 'MemberSearch' } | { __typename: 'MemberWatched' } | { __typename: 'MembersDatas' } | { __typename: 'MenuColumn' } | { __typename: 'MetadatasLanguages' } | { __typename: 'MetadatasVODLanguage' } | { __typename: 'MetasExclusives' } | { __typename: 'MetasPublicationDate' } | { __typename: 'MetasTrailerCmp' } | { __typename: 'MiniSitesFolder' } | { __typename: 'MultiSlider' } | { __typename: 'MulticategoriesSlider' } | { __typename: 'NavMessage' } | { __typename: 'NavigationMessagesFolder' } | { __typename: 'NetlifyDeploy' } | { __typename: 'News' } | { __typename: 'NewsCateg' } | { __typename: 'NewsFolder' } | { __typename: 'NewsPage' } | { __typename: 'NuggetsTextAnswerOption' } | { __typename: 'ObtainedJob' } | { __typename: 'Opportunity' } | { __typename: 'OpportunityCenter' } | { __typename: 'OpportunityFolder' } | { __typename: 'PageSEO' } | { __typename: 'PagecontentSlider' } | { __typename: 'Partner' } | { __typename: 'PartnerSlider' } | { __typename: 'Partners' } | { __typename: 'PartnersPage' } | { __typename: 'Paywall' } | { __typename: 'PaywallFolder' } | { __typename: 'PersonalityPages' } | { __typename: 'PersonalityPush' } | { __typename: 'PersonalityQuiz' } | { __typename: 'PersonalityQuiz1' } | { __typename: 'PersonalityQuizQuestion' } | { __typename: 'PersonalityType' } | { __typename: 'Playlist' } | { __typename: 'PlaylistRadioMenu' } | { __typename: 'Podcast' } | { __typename: 'PodcastCateg' } | { __typename: 'PodcastItem' } | { __typename: 'PodcastMenu' } | { __typename: 'PromoCode' } | { __typename: 'PromoCodeFolder' } | { __typename: 'Push' } | { __typename: 'QuizItemsSlider' } | { __typename: 'QuizPage' } | { __typename: 'QuizzSurvey' } | { __typename: 'QuizzSurveyCategory' } | { __typename: 'QuizzSurveyCollection' } | { __typename: 'Radio' } | { __typename: 'RadioCateg' } | { __typename: 'Region' } | { __typename: 'SectionPage' } | { __typename: 'Service' } | { __typename: 'ServicesList' } | { __typename: 'Settings' } | { __typename: 'SettingsAccessRestrictionCmp' } | { __typename: 'SettingsAccessRestrictionCmp1' } | { __typename: 'SettingsAccessRestrictionCmp2' } | { __typename: 'SettingsDateCmp' } | { __typename: 'SettingsExternalId' } | { __typename: 'Space' } | { __typename: 'StaticPageLink' } | { __typename: 'Subscription' } | { __typename: 'SubscriptionData' } | { __typename: 'SubscriptionDataFolder' } | { __typename: 'SubscriptionsFolder' } | { __typename: 'SubscriptionsList' } | { __typename: 'SumaryNugget' } | { __typename: 'SummaryNuggetStatement' } | { __typename: 'SurveyQuizzFolder' } | { __typename: 'TextPage' } | { __typename: 'TextSlide1' } | { __typename: 'ThankYouPage' } | { __typename: 'TitleSlider' } | { __typename: 'Top10Song' } | { __typename: 'TranslationContext' } | { __typename: 'TranslationFolder' } | { __typename: 'TranslationItem' } | { __typename: 'TutorialSlide' } | { __typename: 'UcAudio' } | { __typename: 'UcImage' } | { __typename: 'UcLineBreak' } | { __typename: 'UcText' } | { __typename: 'UcVideo' } | { __typename: 'UmbracoTest' } | { __typename: 'UnitNuggetAnswer' } | { __typename: 'UnitNuggetGapFillAnswer' } | { __typename: 'UnitNuggetGapFillAnswerItem' } | { __typename: 'UnitProgression' } | { __typename: 'VODItem' } | { __typename: 'VODMenu' } | { __typename: 'ValidationElement' } | { __typename: 'VotingFolder' } | { __typename: 'VotingRecord' } | { __typename: 'WatchCateg' } | { __typename: 'WatchedContent' } | { __typename: 'Wysiwyg' } }
  )>>> }
);

export type IVodItemByUrlQueryVariables = Exact<{
  url?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IVodItemByUrlQuery = (
  { __typename?: 'Query' }
  & { vODItem?: Maybe<(
    { __typename?: 'VODItem' }
    & IVodItemFragmentFragment
  )> }
);

export type IVodItemByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IVodItemByIdQuery = (
  { __typename?: 'Query' }
  & { vODItem?: Maybe<(
    { __typename?: 'VODItem' }
    & IVodItemFragmentFragment
  )> }
);

export type IVodItemByUrlEndQueryVariables = Exact<{
  endUrl?: InputMaybe<Scalars['String']>;
  culture?: InputMaybe<Scalars['String']>;
  imageFormat?: InputMaybe<IImageCropFormat>;
}>;


export type IVodItemByUrlEndQuery = (
  { __typename?: 'Query' }
  & { allVODItem: (
    { __typename?: 'VODItemConnection' }
    & { items: Array<Maybe<(
      { __typename?: 'VODItem' }
      & IVodItemFragmentFragment
    )>> }
  ) }
);

export declare const ContentFragment: import("graphql").DocumentNode;
export declare const AwardsArtistFragment: import("graphql").DocumentNode;
export declare const CTASlideFragment: import("graphql").DocumentNode;
export declare const CardLinkFragment: import("graphql").DocumentNode;
export declare const ChannelFragment: import("graphql").DocumentNode;
export declare const CollectionFragment: import("graphql").DocumentNode;
export declare const ContentEdgeFragment: import("graphql").DocumentNode;
export declare const ContentRestrictedCountries: import("graphql").DocumentNode;
export declare const ContentTagFragment: import("graphql").DocumentNode;
export declare const FormPageFragment: import("graphql").DocumentNode;
export declare const HelpdeskCategFragment: import("graphql").DocumentNode;
export declare const IconSlideFragment: import("graphql").DocumentNode;
export declare const KeyFigureFragment: import("graphql").DocumentNode;
export declare const ChoiceNuggerAnswerFragment: import("graphql").DocumentNode;
export declare const ChoiceNuggetFragment: import("graphql").DocumentNode;
export declare const CourseFragment: import("graphql").DocumentNode;
export declare const CourseCategoryFragment: import("graphql").DocumentNode;
export declare const CourseExamFragment: import("graphql").DocumentNode;
export declare const CourseItemsSliderFragment: import("graphql").DocumentNode;
export declare const CourseNuggetFragment: import("graphql").DocumentNode;
export declare const CoursePageFragment: import("graphql").DocumentNode;
export declare const CourseUnitFragment: import("graphql").DocumentNode;
export declare const DownloadCourseFragment: import("graphql").DocumentNode;
export declare const DownloadJobTrainingFragment: import("graphql").DocumentNode;
export declare const GapfillNuggetFragment: import("graphql").DocumentNode;
export declare const EntrepreunarialHubFragment: import("graphql").DocumentNode;
export declare const JobBoardPageFragment: import("graphql").DocumentNode;
export declare const JobHubFragment: import("graphql").DocumentNode;
export declare const JobVacancyFragment: import("graphql").DocumentNode;
export declare const JobTrainingFragment: import("graphql").DocumentNode;
export declare const LearnHeroSildeFragment: import("graphql").DocumentNode;
export declare const NavMessageFragment: import("graphql").DocumentNode;
export declare const PartCourseFragment: import("graphql").DocumentNode;
export declare const PartnersPageFragment: import("graphql").DocumentNode;
export declare const PersonalityPagesFragment: import("graphql").DocumentNode;
export declare const PersonalityPushFragment: import("graphql").DocumentNode;
export declare const PersonalityQuizFragment: import("graphql").DocumentNode;
export declare const PersonalityQuizQuestionFragment: import("graphql").DocumentNode;
export declare const QuizPageFragment: import("graphql").DocumentNode;
export declare const SummaryNuggetFragment: import("graphql").DocumentNode;
export declare const UcAudioFragment: import("graphql").DocumentNode;
export declare const UcImageFragment: import("graphql").DocumentNode;
export declare const UcLineBreakFragment: import("graphql").DocumentNode;
export declare const UcVideoFragment: import("graphql").DocumentNode;
export declare const LiveEventFragment: import("graphql").DocumentNode;
export declare const LogoLinkFragment: import("graphql").DocumentNode;
export declare const MemberDatasFragment: import("graphql").DocumentNode;
export declare const MemberDownloadedFragment: import("graphql").DocumentNode;
export declare const MemberMessageFragment: import("graphql").DocumentNode;
export declare const MemberNotifyFragment: import("graphql").DocumentNode;
export declare const MemberOpportunityFragment: import("graphql").DocumentNode;
export declare const MemberSavedFragment: import("graphql").DocumentNode;
export declare const MemberSearchFragment: import("graphql").DocumentNode;
export declare const MemberWatchedFragment: import("graphql").DocumentNode;
export declare const NewsFragment: import("graphql").DocumentNode;
export declare const NewsCategFragment: import("graphql").DocumentNode;
export declare const NewsFolderFragment: import("graphql").DocumentNode;
export declare const OpportunityFragment: import("graphql").DocumentNode;
export declare const ParentInfo: import("graphql").DocumentNode;
export declare const PartnerFragment: import("graphql").DocumentNode;
export declare const PaywallPreviewFragment: import("graphql").DocumentNode;
export declare const PaywallFragment: import("graphql").DocumentNode;
export declare const PlaylistFragment: import("graphql").DocumentNode;
export declare const PodcastFragment: import("graphql").DocumentNode;
export declare const PodcastCategFragment: import("graphql").DocumentNode;
export declare const PodcastItemFragment: import("graphql").DocumentNode;
export declare const QuizItemsSliderFragment: import("graphql").DocumentNode;
export declare const QuizzSurveyFragment: import("graphql").DocumentNode;
export declare const QuizzSurveyCategoryFragment: import("graphql").DocumentNode;
export declare const QuizzSurveyCollectionFragment: import("graphql").DocumentNode;
export declare const QuizzSurveyCollectionLiteFragment: import("graphql").DocumentNode;
export declare const QuizzSurveyLiteFragment: import("graphql").DocumentNode;
export declare const QuizzSurveyRelatedContent: import("graphql").DocumentNode;
export declare const RadioFragment: import("graphql").DocumentNode;
export declare const RadioCategFragment: import("graphql").DocumentNode;
export declare const RegionFragment: import("graphql").DocumentNode;
export declare const RegionWebFragment: import("graphql").DocumentNode;
export declare const SettingsFragment: import("graphql").DocumentNode;
export declare const SubscriptionFragment: import("graphql").DocumentNode;
export declare const SubscriptionDataFragment: import("graphql").DocumentNode;
export declare const TopTenFragment: import("graphql").DocumentNode;
export declare const TranslationItemFragment: import("graphql").DocumentNode;
export declare const VODItemFragment: import("graphql").DocumentNode;
export declare const WatchCategFragment: import("graphql").DocumentNode;
export declare const MainContentListFragment: import("graphql").DocumentNode;
export declare const ContentItemsFragment: import("graphql").DocumentNode;
export declare const ElementFragment: import("graphql").DocumentNode;
export declare const AccordionsFragment: import("graphql").DocumentNode;
export declare const AdvantageFragment: import("graphql").DocumentNode;
export declare const AdvantagesListFragment: import("graphql").DocumentNode;
export declare const ArticleFragment: import("graphql").DocumentNode;
export declare const AuthorFragment: import("graphql").DocumentNode;
export declare const AwardsCategoryMenuFragment: import("graphql").DocumentNode;
export declare const ButtonFragment: import("graphql").DocumentNode;
export declare const CTASliderFragment: import("graphql").DocumentNode;
export declare const ContentLinkFragment: import("graphql").DocumentNode;
export declare const DiscoverySlideFragment: import("graphql").DocumentNode;
export declare const DiscoverySlide1Fragment: import("graphql").DocumentNode;
export declare const ExpandMenuFragment: import("graphql").DocumentNode;
export declare const ExternalLinkFragment: import("graphql").DocumentNode;
export declare const FaqItemFragment: import("graphql").DocumentNode;
export declare const HeroVideoCoverFragment: import("graphql").DocumentNode;
export declare const InternalLinkFragment: import("graphql").DocumentNode;
export declare const KeyFiguresFragment: import("graphql").DocumentNode;
export declare const LinkIconFragment: import("graphql").DocumentNode;
export declare const LinkPickerFragment: import("graphql").DocumentNode;
export declare const LogoSliderFragment: import("graphql").DocumentNode;
export declare const MultiSliderFragment: import("graphql").DocumentNode;
export declare const MulticategoriesSliderFragment: import("graphql").DocumentNode;
export declare const PagecontentSliderFragment: import("graphql").DocumentNode;
export declare const PartnerSliderFragment: import("graphql").DocumentNode;
export declare const PushFragment: import("graphql").DocumentNode;
export declare const ServiceFragment: import("graphql").DocumentNode;
export declare const ServicesListFragment: import("graphql").DocumentNode;
export declare const SubscriptionsListFragment: import("graphql").DocumentNode;
export declare const TextPageFragment: import("graphql").DocumentNode;
export declare const TextSlide1Fragment: import("graphql").DocumentNode;
export declare const TitleSliderFragment: import("graphql").DocumentNode;
export declare const ValidationElementFragment: import("graphql").DocumentNode;
export declare const WysiwygFragment: import("graphql").DocumentNode;
export declare const HeroSlideFragment: import("graphql").DocumentNode;
export declare const ArtistServiceFragment: import("graphql").DocumentNode;
export declare const ArtistServicesPageFragment: import("graphql").DocumentNode;
export declare const AwardCategoryPageFragment: import("graphql").DocumentNode;
export declare const AwardHomePageFragment: import("graphql").DocumentNode;
export declare const CategoryPageFragment: import("graphql").DocumentNode;
export declare const HelpdeskPageFragment: import("graphql").DocumentNode;
export declare const HomePageFragment: import("graphql").DocumentNode;
export declare const LiveEventsPageFragment: import("graphql").DocumentNode;
export declare const LiveTVPageFragment: import("graphql").DocumentNode;
export declare const SectionPageFragment: import("graphql").DocumentNode;
export declare const SectionPageContentFragment: import("graphql").DocumentNode;
export declare const ThankYouPageFragment: import("graphql").DocumentNode;
export declare const AllChannel: import("graphql").DocumentNode;
export declare const AllInterestPerLang: import("graphql").DocumentNode;
export declare const AllLiveEvent: import("graphql").DocumentNode;
export declare const AllMusicGenrePerLang: import("graphql").DocumentNode;
export declare const AllTranslationFolder: import("graphql").DocumentNode;
export declare const AppVersionQuery: import("graphql").DocumentNode;
export declare const ArtistServiceByUrl: import("graphql").DocumentNode;
export declare const ArtistServiceById: import("graphql").DocumentNode;
export declare const AristServiceById: import("graphql").DocumentNode;
export declare const ArtistServicesPageByUrl: import("graphql").DocumentNode;
export declare const ArtistServicesPageById: import("graphql").DocumentNode;
export declare const AwardsArtistById: import("graphql").DocumentNode;
export declare const AwardsArtistByName: import("graphql").DocumentNode;
export declare const AwardCategoryPageById: import("graphql").DocumentNode;
export declare const AwardHomePageByUrl: import("graphql").DocumentNode;
export declare const AwardHomePageById: import("graphql").DocumentNode;
export declare const AwardSettingsFragment: import("graphql").DocumentNode;
export declare const AwardSettings: import("graphql").DocumentNode;
export declare const Cgv: import("graphql").DocumentNode;
export declare const AllCategoryMenu: import("graphql").DocumentNode;
export declare const AllRegionCategoryTags: import("graphql").DocumentNode;
export declare const CategoryChildrenById: import("graphql").DocumentNode;
export declare const NewsConnectionFragment: import("graphql").DocumentNode;
export declare const NewsCategoryByUrl: import("graphql").DocumentNode;
export declare const NewsCategoryByUrlWithRegion: import("graphql").DocumentNode;
export declare const RelatedCAtegory: import("graphql").DocumentNode;
export declare const VODItemRelatedContent: import("graphql").DocumentNode;
export declare const CategoryPageByUrl: import("graphql").DocumentNode;
export declare const CategoryPageById: import("graphql").DocumentNode;
export declare const ChannelById: import("graphql").DocumentNode;
export declare const CollectionByUrl: import("graphql").DocumentNode;
export declare const CollectionById: import("graphql").DocumentNode;
export declare const CollectionByUrlEnd: import("graphql").DocumentNode;
export declare const AllContentByListId: import("graphql").DocumentNode;
export declare const DeepLinkContentFragment: import("graphql").DocumentNode;
export declare const ContentIdByEndUrl: import("graphql").DocumentNode;
export declare const ContentUrlById: import("graphql").DocumentNode;
export declare const CountMemberSavedByContentId: import("graphql").DocumentNode;
export declare const CountMemberUnitProgression: import("graphql").DocumentNode;
export declare const GetContentById: import("graphql").DocumentNode;
export declare const ContentById: import("graphql").DocumentNode;
export declare const ContentByUrlEnd: import("graphql").DocumentNode;
export declare const ContentByUrl: import("graphql").DocumentNode;
export declare const FileUploadSetting: import("graphql").DocumentNode;
export declare const FormPageById: import("graphql").DocumentNode;
export declare const FormPageByUrlEnd: import("graphql").DocumentNode;
export declare const AllHelpdeskFolder: import("graphql").DocumentNode;
export declare const HelpdeskPageByUrl: import("graphql").DocumentNode;
export declare const HelpdeskPageByHomepageId: import("graphql").DocumentNode;
export declare const HelpdeskPageByRegionId: import("graphql").DocumentNode;
export declare const HomePage: import("graphql").DocumentNode;
export declare const AllCourseByPartner: import("graphql").DocumentNode;
export declare const AllCourseBySomeIds: import("graphql").DocumentNode;
export declare const AllCourseCompleted: import("graphql").DocumentNode;
export declare const AllJobHub: import("graphql").DocumentNode;
export declare const AllJobTrainingByCourse: import("graphql").DocumentNode;
export declare const JobTrainingByCourse: import("graphql").DocumentNode;
export declare const AllJobTrainingBySomeCourse: import("graphql").DocumentNode;
export declare const AllJobTrainingBySomeIds: import("graphql").DocumentNode;
export declare const GetAllJobVacancy: import("graphql").DocumentNode;
export declare const GetAllOpportunity: import("graphql").DocumentNode;
export declare const AllOpportunityByJobs: import("graphql").DocumentNode;
export declare const AllOpportunityByPartner: import("graphql").DocumentNode;
export declare const AllOpportunityById: import("graphql").DocumentNode;
export declare const AllPartner: import("graphql").DocumentNode;
export declare const CountCourseUnitProgression: import("graphql").DocumentNode;
export declare const CourseByUrl: import("graphql").DocumentNode;
export declare const CourseById: import("graphql").DocumentNode;
export declare const CourseByEndUrl: import("graphql").DocumentNode;
export declare const CourseOverviewFragment: import("graphql").DocumentNode;
export declare const CourseExamOverviewFragment: import("graphql").DocumentNode;
export declare const CourseNuggetOverviewFragment: import("graphql").DocumentNode;
export declare const CoursePageOverviewFragment: import("graphql").DocumentNode;
export declare const CourseUnitOverviewFragment: import("graphql").DocumentNode;
export declare const CourseExamById: import("graphql").DocumentNode;
export declare const CourseExamByUrlEnd: import("graphql").DocumentNode;
export declare const CourseOverviewById: import("graphql").DocumentNode;
export declare const CourseUnitByEndUrl: import("graphql").DocumentNode;
export declare const CourseByUnitId: import("graphql").DocumentNode;
export declare const GetCourseDownload: import("graphql").DocumentNode;
export declare const GetJobDownload: import("graphql").DocumentNode;
export declare const EntrepreneurialHubById: import("graphql").DocumentNode;
export declare const EntrepreneurialHubByUrlEnd: import("graphql").DocumentNode;
export declare const GetExamOverview: import("graphql").DocumentNode;
export declare const GetExamResult: import("graphql").DocumentNode;
export declare const GetOpportunityCenter: import("graphql").DocumentNode;
export declare const GetOpportunityCenterByUrlEnd: import("graphql").DocumentNode;
export declare const JobBoardPageById: import("graphql").DocumentNode;
export declare const JobBoardPageByUrlEnd: import("graphql").DocumentNode;
export declare const JobTrainingById: import("graphql").DocumentNode;
export declare const JobTrainingByUrlEnd: import("graphql").DocumentNode;
export declare const JobTrainingOverviewFragment: import("graphql").DocumentNode;
export declare const JobTrainingOverviewById: import("graphql").DocumentNode;
export declare const JobTrainingOverviewByUrlEnd: import("graphql").DocumentNode;
export declare const OpportunityById: import("graphql").DocumentNode;
export declare const OpportunityByUrlEnd: import("graphql").DocumentNode;
export declare const PartnerById: import("graphql").DocumentNode;
export declare const PartnerByUrl: import("graphql").DocumentNode;
export declare const PartnerByUrlEnd: import("graphql").DocumentNode;
export declare const PartnerRelatedContent: import("graphql").DocumentNode;
export declare const PartnersPageById: import("graphql").DocumentNode;
export declare const AllCourseByPersonality: import("graphql").DocumentNode;
export declare const GetAllPersonalityPagesById: import("graphql").DocumentNode;
export declare const GetAllPersonalityPagesByUrlEnd: import("graphql").DocumentNode;
export declare const GetPersonalityById: import("graphql").DocumentNode;
export declare const GetPersonalityPage: import("graphql").DocumentNode;
export declare const GetPersonalityQuizResult: import("graphql").DocumentNode;
export declare const QuizResultById: import("graphql").DocumentNode;
export declare const QuizResultByUrlEnd: import("graphql").DocumentNode;
export declare const MethodologyQuiz: import("graphql").DocumentNode;
export declare const MethodologyQuizByUrlEnd: import("graphql").DocumentNode;
export declare const PersonalityQuizById: import("graphql").DocumentNode;
export declare const PersonalityQuizQuestionById: import("graphql").DocumentNode;
export declare const QuizPageQuestionById: import("graphql").DocumentNode;
export declare const QuizPageQuestionByUrlEnd: import("graphql").DocumentNode;
export declare const QuizPageById: import("graphql").DocumentNode;
export declare const coursesByPersonalityIds: import("graphql").DocumentNode;
export declare const GetAllUnitProgression: import("graphql").DocumentNode;
export declare const GetCourseTestProgressionById: import("graphql").DocumentNode;
export declare const GetUnitProgressionById: import("graphql").DocumentNode;
export declare const UnitNuggetAnswerFragment: import("graphql").DocumentNode;
export declare const UnitNuggetGapFillAnswerFragment: import("graphql").DocumentNode;
export declare const UnitNuggetGapFillAnswerItemFragment: import("graphql").DocumentNode;
export declare const LiveEventsPage: import("graphql").DocumentNode;
export declare const LiveTVPage: import("graphql").DocumentNode;
export declare const MainContentById: import("graphql").DocumentNode;
export declare const AllMemberDownloadedBySource: import("graphql").DocumentNode;
export declare const AllMemberSavedBySource: import("graphql").DocumentNode;
export declare const MemberDatasById: import("graphql").DocumentNode;
export declare const MemberDatasDownloaded: import("graphql").DocumentNode;
export declare const MemberDatasMessage: import("graphql").DocumentNode;
export declare const MemberDatasNotify: import("graphql").DocumentNode;
export declare const MemberDatasOpportunity: import("graphql").DocumentNode;
export declare const MemberDatasSaved: import("graphql").DocumentNode;
export declare const MemberDatasSearch: import("graphql").DocumentNode;
export declare const MemberDatasWatched: import("graphql").DocumentNode;
export declare const GetMainContentListById: import("graphql").DocumentNode;
export declare const MemberUnitProgression: import("graphql").DocumentNode;
export declare const News: import("graphql").DocumentNode;
export declare const NewsByUrl: import("graphql").DocumentNode;
export declare const NewsById: import("graphql").DocumentNode;
export declare const NewsByUrlEndUrl: import("graphql").DocumentNode;
export declare const PaywalById: import("graphql").DocumentNode;
export declare const PlayListByUrl: import("graphql").DocumentNode;
export declare const PlayListById: import("graphql").DocumentNode;
export declare const PodCast: import("graphql").DocumentNode;
export declare const PodCastById: import("graphql").DocumentNode;
export declare const PodCastByUrlEnd: import("graphql").DocumentNode;
export declare const PodCastItem: import("graphql").DocumentNode;
export declare const PodCastItemById: import("graphql").DocumentNode;
export declare const PromoCodeContent: import("graphql").DocumentNode;
export declare const QuizzSurveyById: import("graphql").DocumentNode;
export declare const GetQuizzSurveyBy: import("graphql").DocumentNode;
export declare const QuizzSurveyCollectionById: import("graphql").DocumentNode;
export declare const GetSurveyCollectionById: import("graphql").DocumentNode;
export declare const RadioByUrl: import("graphql").DocumentNode;
export declare const RadioById: import("graphql").DocumentNode;
export declare const RedirectCancelUrlSetting: import("graphql").DocumentNode;
export declare const AllRegion: import("graphql").DocumentNode;
export declare const AllRegionWeb: import("graphql").DocumentNode;
export declare const RegionDiscoveryById: import("graphql").DocumentNode;
export declare const RegionDiscoveryByUrl: import("graphql").DocumentNode;
export declare const SearchLearn: import("graphql").DocumentNode;
export declare const SearchWatch: import("graphql").DocumentNode;
export declare const SearchListen: import("graphql").DocumentNode;
export declare const SectionPageByUrl: import("graphql").DocumentNode;
export declare const SectionPageById: import("graphql").DocumentNode;
export declare const SectionPageContent: import("graphql").DocumentNode;
export declare const SectionPageTopMenu: import("graphql").DocumentNode;
export declare const SectionPageTopMenuFragment: import("graphql").DocumentNode;
export declare const ServiceFromByUrl: import("graphql").DocumentNode;
export declare const ServiceFromById: import("graphql").DocumentNode;
export declare const Settings: import("graphql").DocumentNode;
export declare const SlideContent: import("graphql").DocumentNode;
export declare const AllSubscription: import("graphql").DocumentNode;
export declare const MemberSubscription: import("graphql").DocumentNode;
export declare const ThankYouPageById: import("graphql").DocumentNode;
export declare const TranslationContext: import("graphql").DocumentNode;
export declare const TranslationContextCheck: import("graphql").DocumentNode;
export declare const TranslationItemByName: import("graphql").DocumentNode;
export declare const GetTutorial: import("graphql").DocumentNode;
export declare const TutorialSlideFragment: import("graphql").DocumentNode;
export declare const VodItemByUrl: import("graphql").DocumentNode;
export declare const VodItemById: import("graphql").DocumentNode;
export declare const VodItemByUrlEnd: import("graphql").DocumentNode;
export const HeroVideoCoverFragmentFragmentDoc = gql`
    fragment HeroVideoCoverFragment on HeroVideoCover {
  __typename
  image {
    url: cropUrl(alias: "default", quality: 50, format: $imageFormat)
    bubble: cropUrl(alias: "bubble")
    cropUrl(alias: "default", quality: 50, format: JPG)
    mobileCover: cropUrl(alias: "mobileCover", format: $imageFormat, quality: 50)
    webCover: cropUrl(alias: "webCover", format: $imageFormat, quality: 50)
  }
  desktopImage {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  vimeoVideoId
  vimeoHlsUrl
  videoCenter
}
    `;
export const PartnerFragmentFragmentDoc = gql`
    fragment PartnerFragment on Partner {
  __typename
  id
  url
  title
  subtitle
  logo {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  partnerName
  partnerUrl
  description
  shortDescription
  cover {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  updateDate
}
    `;
export const AdvantageFragmentFragmentDoc = gql`
    fragment AdvantageFragment on Advantage {
  description
  image {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  title
  __typename
}
    `;
export const NavMessageFragmentFragmentDoc = gql`
    fragment NavMessageFragment on NavMessage {
  description
  image {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  title
  __typename
  updateDate
}
    `;
export const UcLineBreakFragmentFragmentDoc = gql`
    fragment UcLineBreakFragment on UcLineBreak {
  __typename
  text
  lineBreakBody: body
}
    `;
export const UcImageFragmentFragmentDoc = gql`
    fragment UcImageFragment on UcImage {
  __typename
  image {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  text
}
    `;
export const UcVideoFragmentFragmentDoc = gql`
    fragment UcVideoFragment on UcVideo {
  __typename
  title
  subtitle
  liveEventId: liveEventID
  vimeoURL
  sourceUrl
}
    `;
export const UcAudioFragmentFragmentDoc = gql`
    fragment UcAudioFragment on UcAudio {
  __typename
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  liveEventId: liveEventID
  sourceUrl
}
    `;
export const CoursePageFragmentFragmentDoc = gql`
    fragment CoursePageFragment on CoursePage {
  title
  subtitle
  announce {
    __typename
    content {
      __typename
      ... on Advantage {
        ...AdvantageFragment
      }
    }
  }
  navMessage {
    __typename
    ... on NavMessage {
      ...NavMessageFragment
    }
  }
  blocks {
    __typename
    content {
      __typename
      ... on UcLineBreak {
        ...UcLineBreakFragment
      }
      ... on UcImage {
        ...UcImageFragment
      }
      ... on Wysiwyg {
        __typename
        title
        body
      }
      ... on UcVideo {
        ...UcVideoFragment
      }
      ... on UcAudio {
        ...UcAudioFragment
      }
    }
  }
  cover {
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
}
    `;
export const ChoiceNuggerAnswerFragmentFragmentDoc = gql`
    fragment ChoiceNuggerAnswerFragment on ChoiceNuggerAnswer {
  __typename
  value
  description
  feedback
  isCorrect
  image {
    url: cropUrl(format: $imageFormat, quality: 50)
    cropUrl(alias: "default", quality: 50, format: JPG)
  }
}
    `;
export const ChoiceNuggetFragmentFragmentDoc = gql`
    fragment ChoiceNuggetFragment on ChoiceNugget {
  id
  __typename
  genericFeedback
  positiveFeedback
  negativeFeedback
  externalId
  question {
    content {
      ... on Wysiwyg {
        __typename
        title
        body
      }
      ... on UcImage {
        ...UcImageFragment
      }
      ... on UcVideo {
        ...UcVideoFragment
      }
      ... on UcAudio {
        ...UcAudioFragment
      }
    }
  }
  options {
    content {
      ... on ChoiceNuggetAnswerGroup {
        answersList {
          content {
            __typename
            ... on ChoiceNuggerAnswer {
              ...ChoiceNuggerAnswerFragment
            }
          }
        }
      }
      ... on ChoiceNuggerAnswer {
        ...ChoiceNuggerAnswerFragment
      }
    }
  }
  parent {
    __typename
    ... on CourseUnit {
      name
      parent {
        __typename
        ... on Course {
          id
          name
          linkedPartners {
            __typename
            ... on Partner {
              ...PartnerFragment
            }
          }
        }
      }
    }
  }
  updateDate
}
    `;
export const GapfillNuggetFragmentFragmentDoc = gql`
    fragment GapfillNuggetFragment on GapfillNugget {
  id
  __typename
  title
  body
  gapFillText: question
  externalId
  options {
    content {
      __typename
      ... on GapFillNuggetAnswer {
        reference
        values {
          content {
            __typename
            ... on NuggetsTextAnswerOption {
              value
              isCorrect
              image {
                url: cropUrl(format: $imageFormat, quality: 50)
                cropUrl(alias: "default", quality: 50, format: JPG)
              }
            }
          }
        }
        positiveFeedback
        negativeFeedback
      }
      ... on GapFillNuggetImageAnswer {
        reference
        referenceImage {
          url: cropUrl(format: $imageFormat, quality: 50)
          cropUrl(alias: "default", quality: 50, format: JPG)
        }
        values {
          content {
            __typename
            ... on NuggetsTextAnswerOption {
              value
              isCorrect
              image {
                url: cropUrl(format: $imageFormat, quality: 50)
                cropUrl(alias: "default", quality: 50, format: JPG)
              }
            }
          }
        }
        positiveFeedback
        negativeFeedback
      }
    }
  }
  genericFeedback
  positiveFeedback
  negativeFeedback
  parent {
    __typename
    ... on CourseUnit {
      name
      parent {
        __typename
        ... on Course {
          id
          name
          linkedPartners {
            __typename
            ... on Partner {
              ...PartnerFragment
            }
          }
        }
      }
    }
  }
  updateDate
}
    `;
export const SummaryNuggetFragmentFragmentDoc = gql`
    fragment SummaryNuggetFragment on SumaryNugget {
  id
  __typename
  genericFeedback
  positiveFeedback
  negativeFeedback
  externalId
  title
  statements {
    content {
      __typename
      ... on SummaryNuggetStatement {
        options {
          content {
            __typename
            ... on ChoiceNuggerAnswer {
              ...ChoiceNuggerAnswerFragment
            }
          }
        }
      }
    }
  }
  parent {
    __typename
    ... on CourseUnit {
      name
      parent {
        __typename
        ... on Course {
          id
          name
          linkedPartners {
            __typename
            ... on Partner {
              ...PartnerFragment
            }
          }
        }
      }
    }
  }
  updateDate
}
    `;
export const CourseNuggetFragmentFragmentDoc = gql`
    fragment CourseNuggetFragment on CourseNugget {
  __typename
  nuggets {
    id
    name
    __typename
    ... on ChoiceNugget {
      ...ChoiceNuggetFragment
    }
    ... on GapfillNugget {
      ...GapfillNuggetFragment
    }
    ... on SumaryNugget {
      ...SummaryNuggetFragment
    }
  }
}
    `;
export const CourseUnitFragmentFragmentDoc = gql`
    fragment CourseUnitFragment on CourseUnit {
  __typename
  id
  url
  title
  description
  name
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    cropUrl(alias: "default", quality: 50, format: JPG)
  }
  length
  pages {
    content {
      __typename
      ... on CoursePage {
        ...CoursePageFragment
      }
      ... on CourseNugget {
        ...CourseNuggetFragment
      }
    }
  }
  parent {
    __typename
    ... on Course {
      id
      url
      name
      linkedPartners {
        __typename
        ... on Partner {
          ...PartnerFragment
        }
      }
      interests {
        id
        __typename
        name
      }
      children {
        __typename
        items {
          __typename
          id
          url
        }
      }
    }
  }
  updateDate
}
    `;
export const CourseExamFragmentFragmentDoc = gql`
    fragment CourseExamFragment on CourseExam {
  __typename
  id
  url
  description
  title
  examNuggets {
    __typename
    ... on ChoiceNugget {
      ...ChoiceNuggetFragment
    }
    ... on GapfillNugget {
      ...GapfillNuggetFragment
    }
    ... on SumaryNugget {
      ...SummaryNuggetFragment
    }
  }
  attemptDelay
  gradingPolicy
  allowedAttempts
  length
  before {
    content {
      __typename
      ... on CoursePage {
        ...CoursePageFragment
      }
    }
  }
  parent {
    __typename
    ... on Course {
      id
      title
      name
      linkedPartners {
        __typename
        ... on Partner {
          ...PartnerFragment
        }
      }
      interests {
        id
        __typename
        name
      }
      children {
        __typename
        items {
          __typename
          id
        }
      }
    }
  }
  updateDate
  limitedAttempts
}
    `;
export const DownloadCourseFragmentFragmentDoc = gql`
    fragment DownloadCourseFragment on Course {
  __typename
  id
  url
  name
  title
  trailer
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  description
  linkedPartners {
    __typename
    ... on Partner {
      ...PartnerFragment
    }
  }
  children {
    __typename
    items {
      __typename
      ... on CourseUnit {
        ...CourseUnitFragment
      }
      ... on CourseExam {
        ...CourseExamFragment
      }
    }
  }
  interests {
    id
    __typename
    name
  }
  updateDate
}
    `;
export const DownloadJobTrainingFragmentFragmentDoc = gql`
    fragment DownloadJobTrainingFragment on JobTraining {
  __typename
  updateDate
  id
  url
  name
  title
  description
  length
  videosCount
  multimediaUnits
  quizzes
  coursesCertificates
  trailer
  cover {
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  partners {
    ... on Partner {
      ...PartnerFragment
    }
  }
  courses {
    ... on Course {
      ...DownloadCourseFragment
    }
  }
}
    `;
export const CourseCategoryFragmentFragmentDoc = gql`
    fragment CourseCategoryFragment on CourseCategory {
  id
  url
  name
  __typename
  children(first: 6, culture: $culture) {
    __typename
    items {
      __typename
      ... on Course {
        title
        id
        url
        thumbnail {
          url: cropUrl(format: $imageFormat, quality: 50)
          cropUrl(alias: "default", quality: 50, format: JPG)
        }
        length
        linkedPartners {
          __typename
          ... on Partner {
            logo {
              url: cropUrl(format: $imageFormat, quality: 50)
            }
          }
        }
        __typename
        children {
          items {
            __typename
            id
          }
        }
      }
    }
  }
}
    `;
export const InternalLinkFragmentFragmentDoc = gql`
    fragment InternalLinkFragment on InternalLink {
  __typename
  link {
    id
    url
    name
    __typename
    ... on Channel {
      liveEventId: vimeoEventId
      sourceUrl
    }
  }
}
    `;
export const ContentRestrictedCountriesFragmentDoc = gql`
    fragment ContentRestrictedCountries on Content {
  ... on Collection {
    countriesRestriction
  }
  ... on Channel {
    countriesRestriction
  }
  ... on Opportunity {
    countriesRestriction
  }
  ... on News {
    countriesRestriction
  }
  ... on Podcast {
    countriesRestriction
  }
  ... on Playlist {
    countriesRestriction
  }
  ... on LiveEvent {
    countriesRestriction
  }
  ... on VODItem {
    countriesRestriction
  }
  ... on Radio {
    countriesRestriction
  }
}
    `;
export const ContentLinkFragmentFragmentDoc = gql`
    fragment ContentLinkFragment on ContentLink {
  __typename
  link {
    __typename
    url
    id
    name
    ...ContentRestrictedCountries
    ... on Channel {
      liveEventId: vimeoEventId
      sourceUrl
    }
    ... on LiveEvent {
      liveEventId: liveEventID
      sourceUrl
    }
  }
}
    `;
export const ExternalLinkFragmentFragmentDoc = gql`
    fragment ExternalLinkFragment on ExternalLink {
  __typename
  title
  externalUrl
}
    `;
export const ButtonFragmentFragmentDoc = gql`
    fragment ButtonFragment on Button {
  __typename
  icon
  size
  title
  variant
  link_to {
    content {
      contentTypeAlias
      ... on InternalLink {
        ...InternalLinkFragment
      }
      ... on ContentLink {
        ...ContentLinkFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
}
    `;
export const CardLinkFragmentFragmentDoc = gql`
    fragment CardLinkFragment on CardLink {
  title
  description
  image {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  links {
    content {
      __typename
      ... on Button {
        ...ButtonFragment
      }
    }
  }
}
    `;
export const EntrepreunarialHubFragmentFragmentDoc = gql`
    fragment EntrepreunarialHubFragment on EntrepreunarialHub {
  id
  __typename
  hubTitle
  hubCourses {
    __typename
    ... on CourseCategory {
      ...CourseCategoryFragment
    }
  }
  tips {
    content {
      __typename
      ... on CardLink {
        ...CardLinkFragment
      }
    }
  }
}
    `;
export const HeroSlideFragmentFragmentDoc = gql`
    fragment HeroSlideFragment on HeroSlide {
  __typename
  highlights
  title
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  button {
    content {
      ... on Button {
        ...ButtonFragment
      }
    }
  }
}
    `;
export const TextSlide1FragmentFragmentDoc = gql`
    fragment TextSlide1Fragment on TextSlide1 {
  title
  description
  overtitle
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  linkTo {
    content {
      ... on InternalLink {
        ...InternalLinkFragment
      }
      ... on ContentLink {
        ...ContentLinkFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
}
    `;
export const IconSlideFragmentFragmentDoc = gql`
    fragment IconSlideFragment on IconSlide {
  title
  overtitle
  icon {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
}
    `;
export const CtaSlideFragmentFragmentDoc = gql`
    fragment CTASlideFragment on CTASlide {
  __typename
  title
  description
  button {
    content {
      __typename
      ... on Button {
        ...ButtonFragment
      }
    }
  }
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
}
    `;
export const JobHubFragmentFragmentDoc = gql`
    fragment JobHubFragment on JobHub {
  __typename
  id
  url
  title
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  shortDescription
  longDescription
  country
  link
}
    `;
export const PushFragmentFragmentDoc = gql`
    fragment PushFragment on Push {
  __typename
  topTitle
  title
  description
  style
  isPremium
  icon {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  background {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  backgroundDesktop {
    url: cropUrl(format: $imageFormat, quality: 70)
  }
  link {
    content {
      __typename
      contentTypeAlias
      ... on InternalLink {
        ...InternalLinkFragment
      }
      ... on ContentLink {
        ...ContentLinkFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
}
    `;
export const LinkPickerFragmentFragmentDoc = gql`
    fragment LinkPickerFragment on LinkPicker {
  title
  subtitle
  link {
    content {
      __typename
      ... on InternalLink {
        ...InternalLinkFragment
      }
      ... on ContentLink {
        ...ContentLinkFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
}
    `;
export const ExpandMenuFragmentFragmentDoc = gql`
    fragment ExpandMenuFragment on ExpandMenu {
  title
  links {
    content {
      __typename
      ... on LinkPicker {
        ...LinkPickerFragment
      }
    }
  }
}
    `;
export const JobBoardPageFragmentFragmentDoc = gql`
    fragment JobBoardPageFragment on JobBoardPage {
  __typename
  id
  url
  autoloop
  loopDelay
  heroSlider {
    content {
      ... on HeroSlide {
        ...HeroSlideFragment
      }
    }
  }
  tipsSlides {
    content {
      ... on TextSlide1 {
        ...TextSlide1Fragment
      }
      ... on IconSlide {
        ...IconSlideFragment
      }
      ... on CTASlide {
        ...CTASlideFragment
      }
    }
  }
  jobHubs {
    ...JobHubFragment
  }
  jobVancancies {
    __typename
    ... on JobVacancy {
      title
      shortDescription
      thumbnail {
        url
      }
      id
      __typename
      url
      partners {
        ... on Partner {
          ...PartnerFragment
        }
      }
      link
    }
  }
  activeOppotunities {
    __typename
    ... on Opportunity {
      title
      shortDescription
      thumbnail {
        url
      }
      startDate
      id
      __typename
      url
      partners {
        ... on Partner {
          ...PartnerFragment
        }
      }
    }
  }
  partners {
    ...PartnerFragment
  }
  push {
    content {
      ... on Push {
        ...PushFragment
      }
    }
  }
  topMenu(culture: $culture) {
    content {
      __typename
      ... on LinkPicker {
        ...LinkPickerFragment
      }
      ... on ExpandMenu {
        ...ExpandMenuFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
  children {
    items {
      __typename
      id
      url
    }
  }
}
    `;
export const ContentTagFragmentFragmentDoc = gql`
    fragment ContentTagFragment on ContentTag {
  name
  id
  url
  color
  __typename
}
    `;
export const JobVacancyFragmentFragmentDoc = gql`
    fragment JobVacancyFragment on JobVacancy {
  __typename
  id
  url
  title
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    cropUrl(alias: "default", quality: 50, format: JPG)
  }
  link
  shortDescription
  companyName
  contractType
  location
  country
  certificate {
    __typename
    ... on JobTraining {
      __typename
      id
      url
      title
    }
  }
  partners {
    ... on Partner {
      ...PartnerFragment
    }
  }
  personalities {
    __typename
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  interests {
    __typename
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  themes {
    __typename
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
}
    `;
export const PartnersPageFragmentFragmentDoc = gql`
    fragment PartnersPageFragment on PartnersPage {
  __typename
  id
  url
  title
  subtitle
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  list {
    ... on Partner {
      ...PartnerFragment
    }
  }
}
    `;
export const WysiwygFragmentFragmentDoc = gql`
    fragment WysiwygFragment on Wysiwyg {
  title
  body
}
    `;
export const PersonalityPagesFragmentFragmentDoc = gql`
    fragment PersonalityPagesFragment on PersonalityPages {
  __typename
  id
  url
  icon {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  title
  subtitle
  introduction
  cover {
    __typename
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  linkedTag {
    __typename
    id
    ... on ContentTag {
      color
      name
    }
  }
  body {
    content {
      ... on Wysiwyg {
        ...WysiwygFragment
      }
      ... on UcImage {
        ...UcImageFragment
      }
    }
  }
}
    `;
export const PersonalityPushFragmentFragmentDoc = gql`
    fragment PersonalityPushFragment on PersonalityPush {
  __typename
  title
  description
  icon {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
}
    `;
export const PersonalityQuizFragmentFragmentDoc = gql`
    fragment PersonalityQuizFragment on PersonalityQuiz {
  __typename
  id
  url
  title
  subtitle
  cover {
    __typename
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  ctaLabel
  children(first: 2) {
    items {
      ... on PersonalityPages {
        __typename
        id
        url
        icon {
          url
        }
        title
        subtitle
        introduction
      }
    }
  }
  personalitiesPush {
    content {
      __typename
      ... on PersonalityPush {
        ...PersonalityPushFragment
      }
    }
  }
  methodologyPush {
    content {
      __typename
      ... on PersonalityPush {
        ...PersonalityPushFragment
      }
    }
  }
}
    `;
export const PersonalityQuizQuestionFragmentFragmentDoc = gql`
    fragment PersonalityQuizQuestionFragment on PersonalityQuizQuestion {
  weight
  label
  linkedPersonalities {
    ... on PersonalityPages {
      __typename
      id
      icon {
        urlOld: url
        url: cropUrl(format: $imageFormat, quality: 50)
      }
      title
      subtitle
      introduction
      linkedTag {
        __typename
        id
        ... on ContentTag {
          color
          name
        }
      }
    }
  }
}
    `;
export const QuizPageFragmentFragmentDoc = gql`
    fragment QuizPageFragment on QuizPage {
  __typename
  id
  url
  title
  subtitle
  cover {
    __typename
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  ctaLabel
  personalitiesPush {
    content {
      __typename
      ... on PersonalityPush {
        ...PersonalityPushFragment
      }
    }
  }
  methodologyPush {
    content {
      __typename
      ... on PersonalityPush {
        ...PersonalityPushFragment
      }
    }
  }
}
    `;
export const MemberDatasFragmentFragmentDoc = gql`
    fragment MemberDatasFragment on MemberDatas {
  id
  url
  __typename
}
    `;
export const ContentItemsFragmentFragmentDoc = gql`
    fragment ContentItemsFragment on ContentItems {
  title
  subtitle
  countriesRestriction
  __typename
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
}
    `;
export const SubscriptionFragmentFragmentDoc = gql`
    fragment SubscriptionFragment on Subscription {
  __typename
  url
  id
  name
  description
  title
  subtitle
  shortDescription
  productID
  tag {
    content {
      __typename
      ... on ColorTag {
        color
        value
      }
    }
  }
  icon {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  thankYouTitle
  thankYouBody
  thankYouCover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
}
    `;
export const PaywallPreviewFragmentFragmentDoc = gql`
    fragment PaywallPreviewFragment on Paywall {
  previewDurationVod
  previewDurationTv
  playerPremiumText
  disabledPreview
  previewTitle
  previewSubtitle
  previewAnimatedTitle
  previewCoverMobile {
    url: cropUrl(alias: "webCover")
  }
  previewCoverDesktop {
    url: cropUrl(alias: "desktopCover")
  }
  previewLabelCta
  previewCancelMention
  previewMentionFooter
  previewAnimationDuration
  previewHighlightedSubtitle
  previewIcon {
    url
  }
}
    `;
export const AdvantagesListFragmentFragmentDoc = gql`
    fragment AdvantagesListFragment on AdvantagesList {
  template
  advantages {
    content {
      __typename
      ... on Advantage {
        ...AdvantageFragment
      }
    }
  }
}
    `;
export const ServiceFragmentFragmentDoc = gql`
    fragment ServiceFragment on Service {
  text
  icon {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  __typename
}
    `;
export const ServicesListFragmentFragmentDoc = gql`
    fragment ServicesListFragment on ServicesList {
  title
  __typename
  services {
    content {
      __typename
      ... on Service {
        ...ServiceFragment
      }
    }
  }
}
    `;
export const SubscriptionsListFragmentFragmentDoc = gql`
    fragment SubscriptionsListFragment on SubscriptionsList {
  __typename
  subscriptionsList {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
}
    `;
export const PaywallFragmentFragmentDoc = gql`
    fragment PaywallFragment on Paywall {
  id
  __typename
  title
  subtitle
  previewDurationVod
  previewDurationTv
  playerPremiumText
  disabledPreview
  ...PaywallPreviewFragment
  cover {
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  url
  pageBlocks {
    content {
      __typename
      ... on AdvantagesList {
        ...AdvantagesListFragment
      }
      ... on ServicesList {
        ...ServicesListFragment
      }
      ... on SubscriptionsList {
        ...SubscriptionsListFragment
      }
    }
  }
}
    `;
export const ParentInfoFragmentDoc = gql`
    fragment ParentInfo on Content {
  parent {
    name
    url
    id
    __typename
    ... on Collection {
      countryOfProduction
      accessType {
        ... on Subscription {
          ...SubscriptionFragment
        }
      }
      paywall {
        ...PaywallFragment
      }
    }
  }
}
    `;
export const CollectionFragmentFragmentDoc = gql`
    fragment CollectionFragment on Collection {
  countryOfProduction
  id
  startDate
  updateDate
  sortOrder
  shortDescription
  description
  releaseDate
  url
  __typename
  public
  countriesRestriction
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  ...ContentItemsFragment
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  regions {
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  trailer
  availableRegions {
    id
  }
  interests {
    id
    __typename
    name
  }
  ...ParentInfo
  musicGenre {
    id
    __typename
    name
  }
}
    `;
export const VodItemFragmentFragmentDoc = gql`
    fragment VODItemFragment on VODItem {
  id
  endDate
  updateDate
  shortDescription
  sortOrder
  releaseDate
  url
  __typename
  productionCountry
  ...ContentItemsFragment
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  name
  title
  trailer
  description
  createDate
  updateDate
  subtitle
  channel {
    url
    name
    __typename
  }
  liveEventId: liveEventID
  byteplusVideoID
  youtubeId
  sourceUrl
  vimeoHlsUrl
  length
  public
  countriesRestriction
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  regions {
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  availableRegions {
    id
  }
  ...ParentInfo
  episodeNumber
  seasonNumber
  trailer
  interests {
    id
    __typename
    name
  }
  musicGenre {
    id
    name
  }
}
    `;
export const TopTenFragmentFragmentDoc = gql`
    fragment TopTenFragment on Top10Song {
  __typename
  subtitle
  title
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
}
    `;
export const RadioFragmentFragmentDoc = gql`
    fragment RadioFragment on Radio {
  id
  startDate
  updateDate
  sortOrder
  url
  __typename
  ...ContentItemsFragment
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  epg
  hls
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  description
  top10Title
  countriesRestriction
  top10 {
    __typename
    content {
      __typename
      ... on Top10Song {
        ...TopTenFragment
      }
    }
  }
  regions {
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  availableRegions {
    id
  }
  interests {
    id
    __typename
    name
  }
  musicGenre {
    id
    __typename
    name
  }
  ...ParentInfo
}
    `;
export const AuthorFragmentFragmentDoc = gql`
    fragment AuthorFragment on Author {
  authorImage {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  authorName
  __typename
}
    `;
export const PodcastItemFragmentFragmentDoc = gql`
    fragment PodcastItemFragment on PodcastItem {
  id
  updateDate
  sortOrder
  public
  url
  __typename
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  title
  shortDescription
  description
  length
  releaseDate
  name
  vimeoId
  vimeoHlsUrl
  parent {
    __typename
    ... on Podcast {
      title
      id
      url
    }
  }
}
    `;
export const ContentEdgeFragmentFragmentDoc = gql`
    fragment ContentEdgeFragment on ContentEdge {
  __typename
  cursor
  node {
    __typename
    ... on PodcastItem {
      ...PodcastItemFragment
    }
  }
}
    `;
export const PodcastFragmentFragmentDoc = gql`
    fragment PodcastFragment on Podcast {
  id
  author {
    content {
      __typename
      ... on Author {
        ...AuthorFragment
      }
    }
  }
  episodesCount
  seasonsCount
  releaseDate
  length
  url
  countriesRestriction
  __typename
  ...ContentItemsFragment
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  description
  children {
    items {
      __typename
      ... on PodcastItem {
        ...PodcastItemFragment
      }
    }
    edges {
      ...ContentEdgeFragment
    }
  }
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  regions {
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  availableRegions {
    id
  }
  trailer
  interests {
    id
    __typename
    name
  }
  ...ParentInfo
}
    `;
export const PlaylistFragmentFragmentDoc = gql`
    fragment PlaylistFragment on Playlist {
  id
  startDate
  updateDate
  sortOrder
  url
  __typename
  ...ContentItemsFragment
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  epg
  hls
  countriesRestriction
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  regions {
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  availableRegions {
    id
  }
  interests {
    id
    __typename
    name
  }
  musicGenre {
    id
    __typename
    name
  }
  ...ParentInfo
}
    `;
export const ChannelFragmentFragmentDoc = gql`
    fragment ChannelFragment on Channel {
  id
  createDate
  epg
  title
  liveEventId: vimeoEventId
  sourceUrl
  logo {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  name
  sortOrder
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  countriesRestriction
  url
  __typename
  updateDate
  shortDescription
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  regions {
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  availableRegions {
    id
  }
  interests {
    id
    __typename
    name
  }
  ...ParentInfo
  musicGenre {
    id
    __typename
    name
  }
}
    `;
export const LiveEventFragmentFragmentDoc = gql`
    fragment LiveEventFragment on LiveEvent {
  id
  startDate
  endDate
  createDate
  description
  liveEventId: liveEventID
  sourceUrl
  name
  countriesRestriction
  shortDescription
  subtitle
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  title
  url
  __typename
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  regions {
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  channel {
    ... on Channel {
      ...ChannelFragment
    }
  }
  availableRegions {
    id
  }
  interests {
    id
    __typename
    name
  }
  ...ParentInfo
  musicGenre {
    id
    __typename
    name
  }
}
    `;
export const NewsFragmentFragmentDoc = gql`
    fragment NewsFragment on News {
  id
  url
  __typename
  video
  vimeoId
  vimeoHlsUrl
  sourceUrl
  title
  startDate
  pubDate
  shortDescription
  countriesRestriction
  endDate
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  author {
    content {
      ... on Author {
        ...AuthorFragment
      }
      __typename
    }
  }
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  regions {
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  interests {
    id
    __typename
    name
  }
  musicGenre {
    id
    __typename
    name
  }
  ...ParentInfo
}
    `;
export const PartCourseFragmentFragmentDoc = gql`
    fragment PartCourseFragment on Course {
  title
  id
  url
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    cropUrl(alias: "default", quality: 50, format: JPG)
  }
  linkedPartners {
    __typename
    ... on Partner {
      ...PartnerFragment
    }
  }
  __typename
  length
  description
}
    `;
export const JobTrainingFragmentFragmentDoc = gql`
    fragment JobTrainingFragment on JobTraining {
  __typename
  updateDate
  id
  url
  name
  title
  description
  length
  videosCount
  multimediaUnits
  quizzes
  coursesCertificates
  trailer
  cover {
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  partners {
    ... on Partner {
      ...PartnerFragment
    }
  }
  courses {
    ... on Course {
      ...PartCourseFragment
    }
  }
}
    `;
export const CourseFragmentFragmentDoc = gql`
    fragment CourseFragment on Course {
  __typename
  id
  url
  name
  title
  trailer
  length
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
    cropUrl(alias: "default", quality: 50, format: JPG)
    bubble: cropUrl(alias: "bubble")
  }
  description
  linkedPartners {
    __typename
    ... on Partner {
      ...PartnerFragment
    }
  }
  cover {
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  children {
    __typename
    items {
      __typename
      ... on CourseUnit {
        title
        length
        thumbnail {
          url: cropUrl(format: $imageFormat, quality: 50)
          cropUrl(alias: "default", quality: 50, format: JPG)
        }
        id
        url
      }
      ... on CourseExam {
        __typename
        id
        url
        gradingPolicy
      }
    }
  }
  interests {
    id
    __typename
    name
  }
  updateDate
}
    `;
export const QuizzSurveyLiteFragmentFragmentDoc = gql`
    fragment QuizzSurveyLiteFragment on QuizzSurvey {
  id
  url
  __typename
  shortDescription
  title
  vimeoHlsUrl
  liveEventId: liveEventID
  sourceUrl
  thumbnail {
    url
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
}
    `;
export const QuizzSurveyCollectionLiteFragmentFragmentDoc = gql`
    fragment QuizzSurveyCollectionLiteFragment on QuizzSurveyCollection {
  id
  shortDescription
  url
  __typename
  title
  subtitle
  thumbnail {
    url
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
}
    `;
export const MainContentListFragmentFragmentDoc = gql`
    fragment MainContentListFragment on Content {
  ... on ContentItems {
    ...ContentItemsFragment
  }
  ... on Collection {
    ...CollectionFragment
  }
  ... on VODItem {
    ...VODItemFragment
  }
  ... on Radio {
    ...RadioFragment
  }
  ... on Podcast {
    ...PodcastFragment
  }
  ... on Playlist {
    ...PlaylistFragment
  }
  ... on PodcastItem {
    ...PodcastItemFragment
  }
  ... on LiveEvent {
    ...LiveEventFragment
  }
  ... on News {
    ...NewsFragment
  }
  ... on Channel {
    ...ChannelFragment
  }
  ... on JobTraining {
    ...JobTrainingFragment
  }
  ... on Course {
    ...CourseFragment
  }
  ... on QuizzSurvey {
    ...QuizzSurveyLiteFragment
  }
  ... on QuizzSurveyCollection {
    ...QuizzSurveyCollectionLiteFragment
  }
}
    `;
export const MemberDownloadedFragmentFragmentDoc = gql`
    fragment MemberDownloadedFragment on MemberDownloaded {
  __typename
  id
  createDate
  updateDate
  contentLink {
    ...MainContentListFragment
  }
}
    `;
export const MemberMessageFragmentFragmentDoc = gql`
    fragment MemberMessageFragment on MemberMessage {
  __typename
  id
  message
  title
  url
  createDate
  updateDate
  read
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
}
    `;
export const MemberNotifyFragmentFragmentDoc = gql`
    fragment MemberNotifyFragment on MemberNotify {
  __typename
  id
  createDate
  updateDate
  read
  contentLink {
    ...MainContentListFragment
  }
  contentSource
}
    `;
export const OpportunityFragmentFragmentDoc = gql`
    fragment OpportunityFragment on Opportunity {
  id
  __typename
  url
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  title
  name
  startDate
  endDate
  createDate
  shortDescription
  partners {
    ... on Partner {
      ...PartnerFragment
    }
  }
  countriesRestriction
  accessType {
    ... on Subscription {
      ...SubscriptionFragment
    }
  }
  paywall {
    ...PaywallFragment
  }
  availableRegions {
    id
  }
  location
  pageContent
  contractType
  pageCover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  certificate {
    __typename
    ... on JobTraining {
      __typename
      id
      url
      title
    }
  }
  ...ParentInfo
  personalities {
    __typename
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  interests {
    __typename
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
  themes {
    __typename
    ... on ContentTag {
      ...ContentTagFragment
    }
  }
}
    `;
export const MemberOpportunityFragmentFragmentDoc = gql`
    fragment MemberOpportunityFragment on MemberOpportunity {
  id
  __typename
  name
  read
  updateDate
  createDate
  contentLink {
    ... on Opportunity {
      ...OpportunityFragment
    }
  }
}
    `;
export const MemberSavedFragmentFragmentDoc = gql`
    fragment MemberSavedFragment on MemberSaved {
  __typename
  id
  createDate
  updateDate
  contentLink {
    ...MainContentListFragment
  }
}
    `;
export const MemberSearchFragmentFragmentDoc = gql`
    fragment MemberSearchFragment on MemberSearch {
  __typename
  id
  url
  createDate
  updateDate
  text
}
    `;
export const MemberWatchedFragmentFragmentDoc = gql`
    fragment MemberWatchedFragment on MemberWatched {
  __typename
  id
  watchedTimestamp
  createDate
  updateDate
  length
  contentLink {
    ...MainContentListFragment
  }
  contentSource
}
    `;
export const NewsFolderFragmentFragmentDoc = gql`
    fragment NewsFolderFragment on NewsFolder {
  id
  name
  url
  createDate
  updateDate
  __typename
  children {
    __typename
    items {
      __typename
      ... on News {
        ...NewsFragment
      }
    }
  }
}
    `;
export const QuizzSurveyFragmentFragmentDoc = gql`
    fragment QuizzSurveyFragment on QuizzSurvey {
  id
  url
  __typename
  shortDescription
  title
  vimeoHlsUrl
  liveEventId: liveEventID
  sourceUrl
  ctaLabel
  thumbnail {
    url: cropUrl(alias: "default", quality: 80, format: $imageFormat)
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: $imageFormat)
  }
  questions {
    __typename
    ... on ChoiceNugget {
      id
      __typename
      genericFeedback
      positiveFeedback
      negativeFeedback
      externalId
      question {
        content {
          ... on Wysiwyg {
            __typename
            title
            body
          }
          ... on UcImage {
            ...UcImageFragment
          }
          ... on UcVideo {
            ...UcVideoFragment
          }
          ... on UcAudio {
            ...UcAudioFragment
          }
        }
      }
      options {
        content {
          ... on ChoiceNuggetAnswerGroup {
            answersList {
              content {
                __typename
                ... on ChoiceNuggerAnswer {
                  ...ChoiceNuggerAnswerFragment
                }
              }
            }
          }
          ... on ChoiceNuggerAnswer {
            ...ChoiceNuggerAnswerFragment
          }
        }
      }
    }
  }
}
    `;
export const QuizzSurveyCollectionFragmentFragmentDoc = gql`
    fragment QuizzSurveyCollectionFragment on QuizzSurveyCollection {
  id
  updateDate
  sortOrder
  shortDescription
  url
  __typename
  title
  subtitle
  thumbnail {
    url
    bubble: cropUrl(alias: "bubble")
    optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
  }
  quizzCTALabel
  playerCTALabel
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  children {
    items {
      __typename
      ... on QuizzSurvey {
        vimeoHlsUrl
        liveEventId: liveEventID
        sourceUrl
        __typename
        title
        id
        url
        ctaLabel
        shortDescription
        thumbnail {
          url
          bubble: cropUrl(alias: "bubble")
          optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
        }
        questions {
          __typename
        }
      }
    }
  }
  questions {
    __typename
  }
}
    `;
export const LinkIconFragmentFragmentDoc = gql`
    fragment LinkIconFragment on LinkIcon {
  __typename
  icon
  title
  link {
    content {
      ... on InternalLink {
        ...InternalLinkFragment
      }
      ... on ContentLink {
        ...ContentLinkFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
}
    `;
export const CategoryPageFragmentFragmentDoc = gql`
    fragment CategoryPageFragment on CategoryPage {
  id
  url
  name
  backgroundColor
  __typename
  categoryContent {
    contentTypeAlias
    __typename
    ... on ContentItems {
      __typename
      title
      subtitle
      countriesRestriction
    }
    ...MainContentListFragment
  }
}
    `;
export const LiveTvPageFragmentFragmentDoc = gql`
    fragment LiveTVPageFragment on LiveTVPage {
  id
  url
  name
  __typename
  liveTVContent {
    __typename
    ...ChannelFragment
  }
}
    `;
export const LiveEventsPageFragmentFragmentDoc = gql`
    fragment LiveEventsPageFragment on LiveEventsPage {
  id
  name
  url
  __typename
  liveEventsContent {
    __typename
    url
    name
    ... on LiveEvent {
      ...LiveEventFragment
    }
  }
}
    `;
export const NewsCategFragmentFragmentDoc = gql`
    fragment NewsCategFragment on NewsCateg {
  id
  name
  url
  createDate
  updateDate
  __typename
  children(first: 6) {
    __typename
    items {
      __typename
      ... on News {
        ...NewsFragment
      }
    }
  }
}
    `;
export const WatchCategFragmentFragmentDoc = gql`
    fragment WatchCategFragment on WatchCateg {
  id
  url
  name
  backgroundColor
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  isExpand
  __typename
  children(first: 6) {
    __typename
    items {
      __typename
      ... on ContentItems {
        __typename
        title
        subtitle
        countriesRestriction
      }
      ...MainContentListFragment
    }
  }
}
    `;
export const RadioCategFragmentFragmentDoc = gql`
    fragment RadioCategFragment on RadioCateg {
  id
  url
  name
  __typename
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  children(first: 6) {
    __typename
    items {
      __typename
      ... on ContentItems {
        __typename
        title
        subtitle
        countriesRestriction
      }
      ...MainContentListFragment
    }
  }
}
    `;
export const PodcastCategFragmentFragmentDoc = gql`
    fragment PodcastCategFragment on PodcastCateg {
  id
  url
  name
  thumbnail {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  __typename
  children(first: 6) {
    __typename
    items {
      __typename
      ... on ContentItems {
        __typename
        title
        subtitle
        countriesRestriction
      }
      ...MainContentListFragment
    }
  }
}
    `;
export const QuizzSurveyCategoryFragmentFragmentDoc = gql`
    fragment QuizzSurveyCategoryFragment on QuizzSurveyCategory {
  id
  url
  name
  backgroundColor
  __typename
  children(first: 6) {
    __typename
    items {
      __typename
      ...MainContentListFragment
    }
  }
}
    `;
export const MulticategoriesSliderFragmentFragmentDoc = gql`
    fragment MulticategoriesSliderFragment on MulticategoriesSlider {
  title
  template
  showThumbnailTitle
  showThumbnailsSubtitle
  categories {
    id
    url
    name
    __typename
    ... on WatchCateg {
      id
      backgroundColor
      thumbnail {
        url: cropUrl(format: $imageFormat, quality: 50)
        optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
      }
    }
    ... on PodcastCateg {
      thumbnail {
        url: cropUrl(format: $imageFormat, quality: 50)
        optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
      }
    }
    ... on RadioCateg {
      thumbnail {
        url: cropUrl(format: $imageFormat, quality: 50)
        optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
      }
    }
  }
}
    `;
export const KeyFigureFragmentFragmentDoc = gql`
    fragment KeyFigureFragment on KeyFigure {
  __typename
  figure
  description
}
    `;
export const KeyFiguresFragmentFragmentDoc = gql`
    fragment KeyFiguresFragment on KeyFigures {
  __typename
  list {
    __typename
    content {
      __typename
      ... on KeyFigure {
        ...KeyFigureFragment
      }
    }
  }
}
    `;
export const TitleSliderFragmentFragmentDoc = gql`
    fragment TitleSliderFragment on TitleSlider {
  __typename
  title
  subtitle
  slides {
    __typename
    content {
      __typename
      ... on TextSlide1 {
        ...TextSlide1Fragment
      }
      ... on IconSlide {
        ...IconSlideFragment
      }
      ... on CTASlide {
        ...CTASlideFragment
      }
    }
  }
}
    `;
export const MultiSliderFragmentFragmentDoc = gql`
    fragment MultiSliderFragment on MultiSlider {
  title
  description
  template
  sliders {
    __typename
    content {
      __typename
      ... on TitleSlider {
        ...TitleSliderFragment
      }
    }
  }
}
    `;
export const LogoLinkFragmentFragmentDoc = gql`
    fragment LogoLinkFragment on LogoLink {
  __typename
  logo {
    url: cropUrl(format: $imageFormat, quality: 50)
    cropUrl
  }
  link: link_to {
    content {
      __typename
      ... on InternalLink {
        ...InternalLinkFragment
      }
      ... on ContentLink {
        ...ContentLinkFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
}
    `;
export const LogoSliderFragmentFragmentDoc = gql`
    fragment LogoSliderFragment on LogoSlider {
  __typename
  title
  slides {
    __typename
    content {
      ... on LogoLink {
        ...LogoLinkFragment
      }
    }
  }
}
    `;
export const FaqItemFragmentFragmentDoc = gql`
    fragment FaqItemFragment on FaqItem {
  __typename
  title
  htmlContent
  showForm
}
    `;
export const AccordionsFragmentFragmentDoc = gql`
    fragment AccordionsFragment on Accordions {
  __typename
  title
  accordions {
    __typename
    content {
      __typename
      ... on FaqItem {
        ...FaqItemFragment
      }
    }
  }
}
    `;
export const PartnerSliderFragmentFragmentDoc = gql`
    fragment PartnerSliderFragment on PartnerSlider {
  __typename
  title
  partnerLink: isLink {
    __typename
    ... on PartnersPage {
      __typename
      id
      url
    }
  }
  slider {
    __typename
    ... on Partner {
      ...PartnerFragment
    }
  }
}
    `;
export const ContentFragmentFragmentDoc = gql`
    fragment ContentFragment on Content {
  name
  url
  __typename
  ... on ContentItems {
    ...ContentItemsFragment
  }
  ... on Collection {
    ...CollectionFragment
  }
  ... on VODItem {
    ...VODItemFragment
  }
  ... on Radio {
    ...RadioFragment
  }
  ... on Podcast {
    ...PodcastFragment
  }
  ... on Playlist {
    ...PlaylistFragment
  }
  ... on PodcastItem {
    ...PodcastItemFragment
  }
  ... on LiveEvent {
    ...LiveEventFragment
  }
  ... on CategoryPage {
    ...CategoryPageFragment
  }
  ... on LiveTVPage {
    ...LiveTVPageFragment
  }
  ... on LiveEventsPage {
    ...LiveEventsPageFragment
  }
}
    `;
export const PagecontentSliderFragmentFragmentDoc = gql`
    fragment PagecontentSliderFragment on PagecontentSlider {
  isLink
  template
  title
  __typename
  showThumbnailTitle
  showThumbnailsSubtitle
  page {
    id
    name
    __typename
    url
    ...ContentFragment
  }
}
    `;
export const CourseItemsSliderFragmentFragmentDoc = gql`
    fragment CourseItemsSliderFragment on CourseItemsSlider {
  title
  template
  contentItems {
    __typename
    ... on Course {
      title
      id
      url(culture: $culture)
      thumbnail {
        url: cropUrl(format: $imageFormat, quality: 50)
        cropUrl(alias: "default", quality: 50, format: JPG)
      }
      length
      linkedPartners {
        __typename
        ... on Partner {
          logo {
            url: cropUrl(format: $imageFormat, quality: 50)
          }
        }
      }
      __typename
      children {
        items {
          __typename
          id
        }
      }
    }
    ... on JobTraining {
      __typename
      id
      url
      title
      length
      partners {
        ... on Partner {
          logo {
            url: cropUrl(format: $imageFormat, quality: 50)
          }
        }
      }
      cover {
        content {
          ... on HeroVideoCover {
            ...HeroVideoCoverFragment
          }
        }
      }
      courses {
        id
        __typename
      }
    }
  }
}
    `;
export const QuizItemsSliderFragmentFragmentDoc = gql`
    fragment QuizItemsSliderFragment on QuizItemsSlider {
  __typename
  title
  template
  showThumbnailTitle
  showThumbnailsSubtitle
  contentItems {
    __typename
    ... on QuizzSurvey {
      __typename
      title
      id
      thumbnail {
        url
        bubble: cropUrl(alias: "bubble")
        optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
      }
      shortDescription
    }
    ... on QuizzSurveyCollection {
      title
      id
      thumbnail {
        url
        bubble: cropUrl(alias: "bubble")
        optiUrl: cropUrl(alias: "default", quality: 80, format: JPG)
      }
      shortDescription
    }
  }
}
    `;
export const ElementFragmentFragmentDoc = gql`
    fragment ElementFragment on Element {
  contentTypeAlias
  __typename
  ... on ContentSliderHighlight {
    showThumbnailTitle
    showThumbnailsSubtitle
    description
    surtitle
    title
    template
    background {
      url: cropUrl(format: $imageFormat, quality: 50)
    }
    backgroundDesktop {
      url: cropUrl(format: $imageFormat, quality: 70)
      mobileCover: cropUrl(alias: "mobileCover")
    }
    contentItems {
      url
      name
      __typename
      ...ContentItemsFragment
      ...MainContentListFragment
      ... on CategoryPage {
        ...CategoryPageFragment
      }
      ... on LiveTVPage {
        ...LiveTVPageFragment
      }
      ... on LiveEventsPage {
        ...LiveEventsPageFragment
      }
    }
  }
  ... on CategorySliderHighlight {
    showThumbnailTitle
    showThumbnailsSubtitle
    description
    surtitle
    title
    template
    isLink
    background {
      url: cropUrl(format: $imageFormat, quality: 50)
    }
    backgroundDesktop {
      url: cropUrl(format: $imageFormat, quality: 70)
      mobileCover: cropUrl(alias: "mobileCover")
    }
    category {
      ... on NewsCateg {
        ...NewsCategFragment
      }
      ... on WatchCateg {
        ...WatchCategFragment
      }
      ... on RadioCateg {
        ...RadioCategFragment
      }
      ... on PodcastCateg {
        ...PodcastCategFragment
      }
    }
  }
  ... on Push {
    ...PushFragment
  }
  ... on CategorySlider {
    showThumbnailTitle
    showThumbnailsSubtitle
    title
    category {
      ... on NewsCateg {
        ...NewsCategFragment
      }
      ... on WatchCateg {
        ...WatchCategFragment
      }
      ... on RadioCateg {
        ...RadioCategFragment
      }
      ... on PodcastCateg {
        ...PodcastCategFragment
      }
      ... on QuizzSurveyCategory {
        ...QuizzSurveyCategoryFragment
      }
    }
    template
    isLink
  }
  ... on ContentSlider {
    showThumbnailTitle
    showThumbnailsSubtitle
    template
    title
    contentItems {
      url
      name
      __typename
      ...MainContentListFragment
      ... on CategoryPage {
        ...CategoryPageFragment
      }
      ... on LiveTVPage {
        ...LiveTVPageFragment
      }
      ... on LiveEventsPage {
        ...LiveEventsPageFragment
      }
    }
  }
  ... on MulticategoriesSlider {
    ...MulticategoriesSliderFragment
  }
  ... on Wysiwyg {
    ...WysiwygFragment
  }
  ... on KeyFigures {
    ...KeyFiguresFragment
  }
  ... on MultiSlider {
    ...MultiSliderFragment
  }
  ... on LogoSlider {
    ...LogoSliderFragment
  }
  ... on Accordions {
    ...AccordionsFragment
  }
  ... on PartnerSlider {
    ...PartnerSliderFragment
  }
  ... on ContextualContentSlider {
    showThumbnailTitle
    showThumbnailsSubtitle
    __typename
    template
    type
    title
  }
  ... on PagecontentSlider {
    ...PagecontentSliderFragment
  }
  ... on CourseCategorySlider {
    title
    template
    isLink
    category {
      __typename
      ... on CourseCategory {
        ...CourseCategoryFragment
      }
    }
  }
  ... on CourseItemsSlider {
    ...CourseItemsSliderFragment
  }
  ... on PartnerSlider {
    ...PartnerSliderFragment
  }
  ... on HeroBanner {
    title
    subtitle
    cTA {
      content {
        ... on Button {
          ...ButtonFragment
        }
      }
    }
    backgroundImage {
      url: cropUrl(format: $imageFormat, quality: 70)
    }
    backgroundImageMobile {
      url: cropUrl(format: $imageFormat, quality: 50)
    }
  }
  ... on HeroVideoCover {
    ...HeroVideoCoverFragment
  }
  ... on QuizItemsSlider {
    ...QuizItemsSliderFragment
  }
}
    `;
export const RegionFragmentFragmentDoc = gql`
    fragment RegionFragment on Region {
  id
  name
  url
  defaultLanguage
  discovery {
    id
    __typename
  }
  searchTopBlocks(culture: $culture) {
    __typename
    content {
      __typename
      ... on LinkIcon {
        ...LinkIconFragment
      }
    }
  }
  searchPageBlocks(culture: $culture) {
    __typename
    content {
      ...ElementFragment
    }
  }
  homepageUrl: homepage {
    id
    url
    __typename
  }
  watchHomepage {
    __typename
    id
    url
    children {
      items {
        id
        name
        url
        __typename
      }
    }
  }
  listenHomepage {
    __typename
    id
    url
    children {
      items {
        id
        name
        url
        __typename
      }
    }
  }
  learnHomepage {
    __typename
    id
    url
    children {
      items {
        id
        name
        url
        __typename
      }
    }
  }
  topMenu {
    content {
      ... on LinkPicker {
        ...LinkPickerFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
  subMenu {
    content {
      ... on LinkIcon {
        ...LinkIconFragment
      }
    }
  }
  push {
    content {
      ...PushFragment
    }
  }
  accountPush {
    content {
      ...PushFragment
    }
  }
  defaultPaywall {
    ...PaywallFragment
  }
}
    `;
export const RegionWebFragmentFragmentDoc = gql`
    fragment RegionWebFragment on Region {
  id
  name
  url
  defaultLanguage
  searchTopBlocks(culture: $culture) {
    __typename
    content {
      __typename
      ... on LinkIcon {
        ...LinkIconFragment
      }
    }
  }
  searchPageBlocks(culture: $culture) {
    __typename
    content {
      ...ElementFragment
    }
  }
  homepageUrl: webHomepage {
    id
    url
    __typename
  }
  watchHomepage: webWatchHome {
    __typename
    id
    url
    children {
      items {
        id
        name
        url
        __typename
      }
    }
  }
  listenHomepage: webListenHome {
    __typename
    id
    url
    children {
      items {
        id
        name
        url
        __typename
      }
    }
  }
  learnHomepage: webLearnHome {
    __typename
    id
    url
    children {
      items {
        id
        name
        url
        __typename
      }
    }
  }
  webArtistHome {
    id
    __typename
    url
  }
  topMenu: webTopMenu {
    content {
      ... on LinkPicker {
        ...LinkPickerFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
  subMenu: webBottomMenu {
    content {
      ... on LinkIcon {
        ...LinkIconFragment
      }
    }
  }
  push: webPush {
    content {
      ...PushFragment
    }
  }
  defaultPaywall {
    ...PaywallFragment
  }
}
    `;
export const FormPageFragmentFragmentDoc = gql`
    fragment FormPageFragment on FormPage {
  id
  url
  title
  subtitle
  cover {
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  form
}
    `;
export const ValidationElementFragmentFragmentDoc = gql`
    fragment ValidationElementFragment on ValidationElement {
  label
  regex
  __typename
}
    `;
export const SettingsFragmentFragmentDoc = gql`
    fragment SettingsFragment on Settings {
  __typename
  id
  url
  androidRedirectURL
  androidRequiredVersion
  androidCurrentVersion
  iOSRedirectUrl
  iOSCurrentVersion
  iOSRequiredVersion
  huaweiRedirectUrl
  huaweiCurrentVersion
  huaweiRequiredVersion
  signupForm
  signupSteps {
    ... on FormPage {
      ...FormPageFragment
    }
  }
  passwordValidation {
    content {
      __typename
      ... on ValidationElement {
        ...ValidationElementFragment
      }
    }
  }
  cover {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  webCover {
    url: cropUrl(format: $imageFormat, quality: 70)
  }
  title
  subtitle
  cTALabel
  defaultHeaderImage {
    url: cropUrl(format: $imageFormat, quality: 70)
  }
  sessionAlertMessage
}
    `;
export const SubscriptionDataFragmentFragmentDoc = gql`
    fragment SubscriptionDataFragment on SubscriptionData {
  __typename
  subscriptionPrice
  subscriptionStart
  subscriptionEnd
  id
  name
  deviceType
  subscriptionType {
    ...SubscriptionFragment
  }
}
    `;
export const TranslationItemFragmentFragmentDoc = gql`
    fragment TranslationItemFragment on TranslationItem {
  id
  name
  value
}
    `;
export const ArticleFragmentFragmentDoc = gql`
    fragment ArticleFragment on Article {
  __typename
  title
  description
}
    `;
export const CtaSliderFragmentFragmentDoc = gql`
    fragment CTASliderFragment on MultiSlider {
  title
  description
  template
  sliders {
    __typename
    content {
      __typename
      ... on TitleSlider {
        ...TitleSliderFragment
      }
    }
  }
}
    `;
export const DiscoverySlideFragmentFragmentDoc = gql`
    fragment DiscoverySlideFragment on DiscoverySlide {
  __typename
  button_label
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  shortDescription
  slideContent {
    ...MainContentListFragment
  }
  title
}
    `;
export const DiscoverySlide1FragmentFragmentDoc = gql`
    fragment DiscoverySlide1Fragment on DiscoverySlide1 {
  __typename
  id
  button_label
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  shortDescription
  slideContent {
    ...MainContentListFragment
  }
  title
}
    `;
export const TextPageFragmentFragmentDoc = gql`
    fragment TextPageFragment on TextPage {
  url
  title
  body
  id
  __typename
  name
}
    `;
export const ArtistServiceFragmentFragmentDoc = gql`
    fragment ArtistServiceFragment on ArtistService {
  __typename
  id
  title
  subtitle
  url
  cover {
    content {
      contentTypeAlias
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  button {
    content {
      __typename
      ... on Button {
        ...ButtonFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
  pageBlocks {
    content {
      ...ElementFragment
    }
  }
}
    `;
export const ArtistServicesPageFragmentFragmentDoc = gql`
    fragment ArtistServicesPageFragment on ArtistServicesPage {
  __typename
  id
  title
  subtitle
  url
  cover {
    content {
      contentTypeAlias
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  button {
    content {
      __typename
      ... on Button {
        ...ButtonFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
  children {
    items {
      __typename
      ... on ArtistService {
        id
        title
        url
      }
      ... on FormPage {
        id
        url
        id
      }
    }
  }
  services {
    ... on ArtistService {
      id
      title
      url
    }
  }
  pageBlocks {
    content {
      ...ElementFragment
    }
  }
}
    `;
export const AwardsArtistFragmentFragmentDoc = gql`
    fragment AwardsArtistFragment on AwardsArtist {
  id
  __typename
  name
  subtitle
  title
  description
  cover {
    content {
      contentTypeAlias
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  exportID
  button {
    content {
      ... on Button {
        ...ButtonFragment
      }
    }
  }
  parent {
    ... on AwardCategoryPage {
      id
    }
  }
}
    `;
export const AwardsCategoryMenuFragmentFragmentDoc = gql`
    fragment AwardsCategoryMenuFragment on AwardsCategoryMenu {
  id
  name
  title
  menu {
    content {
      __typename
      ... on LinkPicker {
        ...LinkPickerFragment
      }
    }
  }
}
    `;
export const AwardCategoryPageFragmentFragmentDoc = gql`
    fragment AwardCategoryPageFragment on AwardCategoryPage {
  id
  __typename
  title
  categTitle
  description
  subtitle
  url
  urlRewrite
  metaTitle
  metaDescription
  cover {
    content {
      contentTypeAlias
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  footerBlocks {
    content {
      ...ElementFragment
    }
  }
  children {
    items {
      ... on AwardsArtist {
        ...AwardsArtistFragment
      }
    }
  }
  menu {
    id
    __typename
    name
    ... on AwardsCategoryMenu {
      ...AwardsCategoryMenuFragment
    }
  }
}
    `;
export const AwardHomePageFragmentFragmentDoc = gql`
    fragment AwardHomePageFragment on AwardsHomepage {
  __typename
  id
  title
  introduction
  url
  logo {
    url: cropUrl(format: $imageFormat, quality: 50)
  }
  cover {
    content {
      contentTypeAlias
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  cTA {
    content {
      __typename
      ... on Button {
        ...ButtonFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
  pageBlocks {
    content {
      ...ElementFragment
    }
  }
}
    `;
export const HelpdeskCategFragmentFragmentDoc = gql`
    fragment HelpdeskCategFragment on HelpdeskCateg {
  __typename
  url
  title
  name
  faqItems {
    content {
      __typename
      ... on FaqItem {
        ...FaqItemFragment
      }
    }
  }
}
    `;
export const HelpdeskPageFragmentFragmentDoc = gql`
    fragment HelpdeskPageFragment on HelpdeskPage {
  name
  url
  __typename
  push {
    content {
      __typename
      ... on Push {
        ...PushFragment
      }
    }
  }
  topics {
    id
    name
    __typename
    ... on HelpdeskCateg {
      ...HelpdeskCategFragment
    }
  }
}
    `;
export const HomePageFragmentFragmentDoc = gql`
    fragment HomePageFragment on HomePage {
  __typename
  id
  url
  autoloop
  loopDelay
}
    `;
export const SectionPageFragmentFragmentDoc = gql`
    fragment SectionPageFragment on SectionPage {
  id
  __typename
  url
  autoloop
  loopDelay
  heroSlider {
    content {
      ... on HeroSlide {
        ...HeroSlideFragment
      }
    }
  }
  pageBlocks {
    content {
      ...ElementFragment
    }
  }
}
    `;
export const LearnHeroSildeFragmentFragmentDoc = gql`
    fragment LearnHeroSildeFragment on LearnHeroSlide {
  __typename
  title
  cover {
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  button {
    content {
      ... on Button {
        ...ButtonFragment
      }
    }
  }
  partners {
    __typename
    ... on Partner {
      ...PartnerFragment
    }
  }
}
    `;
export const SectionPageContentFragmentFragmentDoc = gql`
    fragment SectionPageContentFragment on SectionPage {
  id
  __typename
  url
  autoloop
  loopDelay
  heroSlider(culture: $culture) {
    content {
      ... on HeroSlide {
        ...HeroSlideFragment
      }
      ... on LearnHeroSlide {
        ...LearnHeroSildeFragment
      }
    }
  }
  pageBlocks(culture: $culture) {
    content {
      ...ElementFragment
    }
  }
}
    `;
export const ThankYouPageFragmentFragmentDoc = gql`
    fragment ThankYouPageFragment on ThankYouPage {
  __typename
  url
  id
  title
  subtitle
  body
  cover {
    content {
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  cTA {
    __typename
    content {
      ... on Button {
        ...ButtonFragment
      }
    }
  }
}
    `;
export const AwardSettingsFragmentFragmentDoc = gql`
    fragment AwardSettingsFragment on AwardsHomepage {
  id
  logo {
    url: cropUrl(format: $imageFormat, quality: 60)
  }
  __typename
  urlRewrite
  metaTitle
  metaDescription
  formTitle
  formLabel
  formIntroduction
  form
  backgroundImage {
    url: cropUrl(format: $imageFormat, quality: 60)
  }
  comingSoonPage {
    id
  }
}
    `;
export const NewsConnectionFragmentFragmentDoc = gql`
    fragment NewsConnectionFragment on NewsConnection {
  edges {
    cursor
    node {
      ...NewsFragment
    }
  }
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
    __typename
  }
}
    `;
export const DeepLinkContentFragmentFragmentDoc = gql`
    fragment DeepLinkContentFragment on Content {
  ... on Collection {
    title
  }
  ... on VODItem {
    title
  }
  ... on Radio {
    title
  }
  ... on Podcast {
    title
  }
  ... on Playlist {
    title
  }
  ... on PodcastItem {
    title
  }
  ... on LiveEvent {
    title
  }
  ... on News {
    title
  }
  ... on Channel {
    title
  }
  ... on JobTraining {
    title
  }
  ... on Course {
    title
  }
  ... on QuizzSurvey {
    title
  }
  ... on QuizzSurveyCollection {
    title
  }
}
    `;
export const CoursePageOverviewFragmentFragmentDoc = gql`
    fragment CoursePageOverviewFragment on CoursePage {
  __typename
  blocks {
    content {
      __typename
    }
  }
}
    `;
export const CourseNuggetOverviewFragmentFragmentDoc = gql`
    fragment CourseNuggetOverviewFragment on CourseNugget {
  __typename
  nuggets {
    __typename
    id
  }
}
    `;
export const CourseUnitOverviewFragmentFragmentDoc = gql`
    fragment CourseUnitOverviewFragment on CourseUnit {
  __typename
  id
  length
  pages {
    content {
      ... on CoursePage {
        ...CoursePageOverviewFragment
      }
      ... on CourseNugget {
        ...CourseNuggetOverviewFragment
      }
    }
  }
}
    `;
export const CourseExamOverviewFragmentFragmentDoc = gql`
    fragment CourseExamOverviewFragment on CourseExam {
  __typename
  id
  length
}
    `;
export const CourseOverviewFragmentFragmentDoc = gql`
    fragment CourseOverviewFragment on Course {
  id
  __typename
  name
  children {
    items {
      ... on CourseUnit {
        ...CourseUnitOverviewFragment
      }
      ... on CourseExam {
        ...CourseExamOverviewFragment
      }
    }
  }
}
    `;
export const JobTrainingOverviewFragmentFragmentDoc = gql`
    fragment JobTrainingOverviewFragment on JobTraining {
  id
  url
  __typename
  name
  quizzes
  courses {
    ... on Course {
      ...CourseOverviewFragment
    }
  }
}
    `;
export const UnitNuggetAnswerFragmentFragmentDoc = gql`
    fragment UnitNuggetAnswerFragment on UnitNuggetAnswer {
  id
  __typename
  nuggetId: name
  value
}
    `;
export const UnitNuggetGapFillAnswerItemFragmentFragmentDoc = gql`
    fragment UnitNuggetGapFillAnswerItemFragment on UnitNuggetGapFillAnswerItem {
  __typename
  reference
  value
}
    `;
export const UnitNuggetGapFillAnswerFragmentFragmentDoc = gql`
    fragment UnitNuggetGapFillAnswerFragment on UnitNuggetGapFillAnswer {
  id
  nuggetId: name
  __typename
  answers {
    content {
      ... on UnitNuggetGapFillAnswerItem {
        ...UnitNuggetGapFillAnswerItemFragment
      }
    }
  }
}
    `;
export const SectionPageTopMenuFragmentFragmentDoc = gql`
    fragment SectionPageTopMenuFragment on SectionPage {
  id
  __typename
  topMenu(culture: $culture) {
    content {
      __typename
      ... on LinkPicker {
        ...LinkPickerFragment
      }
      ... on ExpandMenu {
        ...ExpandMenuFragment
      }
      ... on ExternalLink {
        ...ExternalLinkFragment
      }
    }
  }
}
    `;
export const TutorialSlideFragmentFragmentDoc = gql`
    fragment TutorialSlideFragment on TutorialSlide {
  __typename
  cover {
    content {
      __typename
      ... on HeroVideoCover {
        ...HeroVideoCoverFragment
      }
    }
  }
  title
  description
}
    `;
export const QuizzSurveyRelatedContentDocument = gql`
    query QuizzSurveyRelatedContent($id: ID, $culture: String, $first: Int = 10, $imageFormat: ImageCropFormat) {
  quizzSurveyCollection(id: $id, culture: $culture) {
    __typename
    parent {
      id
      __typename
      ... on QuizzSurveyCategory {
        id
        url
        name
        backgroundColor
        __typename
        children(first: $first) {
          __typename
          items {
            __typename
            ...MainContentListFragment
          }
        }
      }
    }
  }
}
    ${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useQuizzSurveyRelatedContentQuery__
 *
 * To run a query within a React component, call `useQuizzSurveyRelatedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizzSurveyRelatedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizzSurveyRelatedContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      first: // value for 'first'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useQuizzSurveyRelatedContentQuery(baseOptions?: Apollo.QueryHookOptions<IQuizzSurveyRelatedContentQuery, IQuizzSurveyRelatedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IQuizzSurveyRelatedContentQuery, IQuizzSurveyRelatedContentQueryVariables>(QuizzSurveyRelatedContentDocument, options);
      }
export function useQuizzSurveyRelatedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IQuizzSurveyRelatedContentQuery, IQuizzSurveyRelatedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IQuizzSurveyRelatedContentQuery, IQuizzSurveyRelatedContentQueryVariables>(QuizzSurveyRelatedContentDocument, options);
        }
export type QuizzSurveyRelatedContentQueryHookResult = ReturnType<typeof useQuizzSurveyRelatedContentQuery>;
export type QuizzSurveyRelatedContentLazyQueryHookResult = ReturnType<typeof useQuizzSurveyRelatedContentLazyQuery>;
export type QuizzSurveyRelatedContentQueryResult = Apollo.QueryResult<IQuizzSurveyRelatedContentQuery, IQuizzSurveyRelatedContentQueryVariables>;
export const AllChannelDocument = gql`
    query AllChannel($culture: String, $imageFormat: ImageCropFormat) {
  allChannel(culture: $culture) {
    items {
      ...ChannelFragment
    }
  }
}
    ${ChannelFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useAllChannelQuery__
 *
 * To run a query within a React component, call `useAllChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChannelQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllChannelQuery(baseOptions?: Apollo.QueryHookOptions<IAllChannelQuery, IAllChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllChannelQuery, IAllChannelQueryVariables>(AllChannelDocument, options);
      }
export function useAllChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllChannelQuery, IAllChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllChannelQuery, IAllChannelQueryVariables>(AllChannelDocument, options);
        }
export type AllChannelQueryHookResult = ReturnType<typeof useAllChannelQuery>;
export type AllChannelLazyQueryHookResult = ReturnType<typeof useAllChannelLazyQuery>;
export type AllChannelQueryResult = Apollo.QueryResult<IAllChannelQuery, IAllChannelQueryVariables>;
export const AllInterestPerLangDocument = gql`
    query AllInterestPerLang {
  frTag: contentTagsCateg(
    id: "520db14c-6ee5-4d7a-a961-e08b43262ae6"
    culture: "fr"
  ) {
    contentTypeAlias
    children(culture: "fr") {
      items {
        id
        name
      }
    }
  }
  enTag: contentTagsCateg(
    id: "520db14c-6ee5-4d7a-a961-e08b43262ae6"
    culture: "en-US"
  ) {
    contentTypeAlias
    children(culture: "en-US") {
      items {
        id
        name
      }
    }
  }
  ptTag: contentTagsCateg(
    id: "520db14c-6ee5-4d7a-a961-e08b43262ae6"
    culture: "pt-BR"
  ) {
    contentTypeAlias
    children(culture: "pt-BR") {
      items {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAllInterestPerLangQuery__
 *
 * To run a query within a React component, call `useAllInterestPerLangQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInterestPerLangQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInterestPerLangQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllInterestPerLangQuery(baseOptions?: Apollo.QueryHookOptions<IAllInterestPerLangQuery, IAllInterestPerLangQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllInterestPerLangQuery, IAllInterestPerLangQueryVariables>(AllInterestPerLangDocument, options);
      }
export function useAllInterestPerLangLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllInterestPerLangQuery, IAllInterestPerLangQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllInterestPerLangQuery, IAllInterestPerLangQueryVariables>(AllInterestPerLangDocument, options);
        }
export type AllInterestPerLangQueryHookResult = ReturnType<typeof useAllInterestPerLangQuery>;
export type AllInterestPerLangLazyQueryHookResult = ReturnType<typeof useAllInterestPerLangLazyQuery>;
export type AllInterestPerLangQueryResult = Apollo.QueryResult<IAllInterestPerLangQuery, IAllInterestPerLangQueryVariables>;
export const AllLiveEventDocument = gql`
    query AllLiveEvent($culture: String, $imageFormat: ImageCropFormat) {
  allLiveEvent(culture: $culture) {
    items {
      ...LiveEventFragment
    }
  }
}
    ${LiveEventFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useAllLiveEventQuery__
 *
 * To run a query within a React component, call `useAllLiveEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLiveEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLiveEventQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllLiveEventQuery(baseOptions?: Apollo.QueryHookOptions<IAllLiveEventQuery, IAllLiveEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllLiveEventQuery, IAllLiveEventQueryVariables>(AllLiveEventDocument, options);
      }
export function useAllLiveEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllLiveEventQuery, IAllLiveEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllLiveEventQuery, IAllLiveEventQueryVariables>(AllLiveEventDocument, options);
        }
export type AllLiveEventQueryHookResult = ReturnType<typeof useAllLiveEventQuery>;
export type AllLiveEventLazyQueryHookResult = ReturnType<typeof useAllLiveEventLazyQuery>;
export type AllLiveEventQueryResult = Apollo.QueryResult<IAllLiveEventQuery, IAllLiveEventQueryVariables>;
export const AllMusicGenrePerLangDocument = gql`
    query AllMusicGenrePerLang {
  frTag: contentTagsCateg(
    id: "d8d93757-2a0c-4ab8-a2f2-30b0fcc023e3"
    culture: "fr"
  ) {
    contentTypeAlias
    children(culture: "fr") {
      items {
        id
        name
      }
    }
  }
  enTag: contentTagsCateg(
    id: "d8d93757-2a0c-4ab8-a2f2-30b0fcc023e3"
    culture: "en-US"
  ) {
    contentTypeAlias
    children(culture: "en-US") {
      items {
        id
        name
      }
    }
  }
  ptTag: contentTagsCateg(
    id: "d8d93757-2a0c-4ab8-a2f2-30b0fcc023e3"
    culture: "pt-BR"
  ) {
    contentTypeAlias
    children(culture: "pt-BR") {
      items {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAllMusicGenrePerLangQuery__
 *
 * To run a query within a React component, call `useAllMusicGenrePerLangQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMusicGenrePerLangQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMusicGenrePerLangQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMusicGenrePerLangQuery(baseOptions?: Apollo.QueryHookOptions<IAllMusicGenrePerLangQuery, IAllMusicGenrePerLangQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllMusicGenrePerLangQuery, IAllMusicGenrePerLangQueryVariables>(AllMusicGenrePerLangDocument, options);
      }
export function useAllMusicGenrePerLangLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllMusicGenrePerLangQuery, IAllMusicGenrePerLangQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllMusicGenrePerLangQuery, IAllMusicGenrePerLangQueryVariables>(AllMusicGenrePerLangDocument, options);
        }
export type AllMusicGenrePerLangQueryHookResult = ReturnType<typeof useAllMusicGenrePerLangQuery>;
export type AllMusicGenrePerLangLazyQueryHookResult = ReturnType<typeof useAllMusicGenrePerLangLazyQuery>;
export type AllMusicGenrePerLangQueryResult = Apollo.QueryResult<IAllMusicGenrePerLangQuery, IAllMusicGenrePerLangQueryVariables>;
export const AllTranslationFolderDocument = gql`
    query AllTranslationFolder($culture: String) {
  allTranslationFolder(culture: $culture) {
    items {
      __typename
      ... on TranslationFolder {
        children {
          items {
            __typename
            ... on TranslationContext {
              id
              name
              children {
                items {
                  ... on TranslationItem {
                    ...TranslationItemFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${TranslationItemFragmentFragmentDoc}`;

/**
 * __useAllTranslationFolderQuery__
 *
 * To run a query within a React component, call `useAllTranslationFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTranslationFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTranslationFolderQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useAllTranslationFolderQuery(baseOptions?: Apollo.QueryHookOptions<IAllTranslationFolderQuery, IAllTranslationFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllTranslationFolderQuery, IAllTranslationFolderQueryVariables>(AllTranslationFolderDocument, options);
      }
export function useAllTranslationFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllTranslationFolderQuery, IAllTranslationFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllTranslationFolderQuery, IAllTranslationFolderQueryVariables>(AllTranslationFolderDocument, options);
        }
export type AllTranslationFolderQueryHookResult = ReturnType<typeof useAllTranslationFolderQuery>;
export type AllTranslationFolderLazyQueryHookResult = ReturnType<typeof useAllTranslationFolderLazyQuery>;
export type AllTranslationFolderQueryResult = Apollo.QueryResult<IAllTranslationFolderQuery, IAllTranslationFolderQueryVariables>;
export const AppVersionQueryDocument = gql`
    query AppVersionQuery($culture: String, $imageFormat: ImageCropFormat) {
  settings(url: "/settings/", culture: $culture) {
    ...SettingsFragment
  }
}
    ${SettingsFragmentFragmentDoc}
${FormPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ValidationElementFragmentFragmentDoc}`;

/**
 * __useAppVersionQueryQuery__
 *
 * To run a query within a React component, call `useAppVersionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppVersionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppVersionQueryQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAppVersionQueryQuery(baseOptions?: Apollo.QueryHookOptions<IAppVersionQueryQuery, IAppVersionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAppVersionQueryQuery, IAppVersionQueryQueryVariables>(AppVersionQueryDocument, options);
      }
export function useAppVersionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAppVersionQueryQuery, IAppVersionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAppVersionQueryQuery, IAppVersionQueryQueryVariables>(AppVersionQueryDocument, options);
        }
export type AppVersionQueryQueryHookResult = ReturnType<typeof useAppVersionQueryQuery>;
export type AppVersionQueryLazyQueryHookResult = ReturnType<typeof useAppVersionQueryLazyQuery>;
export type AppVersionQueryQueryResult = Apollo.QueryResult<IAppVersionQueryQuery, IAppVersionQueryQueryVariables>;
export const ArtistServiceByUrlDocument = gql`
    query ArtistServiceByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  artistService(url: $url, culture: $culture) {
    __typename
    ... on ArtistService {
      ...ArtistServiceFragment
    }
  }
}
    ${ArtistServiceFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useArtistServiceByUrlQuery__
 *
 * To run a query within a React component, call `useArtistServiceByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtistServiceByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtistServiceByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useArtistServiceByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IArtistServiceByUrlQuery, IArtistServiceByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IArtistServiceByUrlQuery, IArtistServiceByUrlQueryVariables>(ArtistServiceByUrlDocument, options);
      }
export function useArtistServiceByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IArtistServiceByUrlQuery, IArtistServiceByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IArtistServiceByUrlQuery, IArtistServiceByUrlQueryVariables>(ArtistServiceByUrlDocument, options);
        }
export type ArtistServiceByUrlQueryHookResult = ReturnType<typeof useArtistServiceByUrlQuery>;
export type ArtistServiceByUrlLazyQueryHookResult = ReturnType<typeof useArtistServiceByUrlLazyQuery>;
export type ArtistServiceByUrlQueryResult = Apollo.QueryResult<IArtistServiceByUrlQuery, IArtistServiceByUrlQueryVariables>;
export const ArtistServiceByIdDocument = gql`
    query ArtistServiceById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  artistService(id: $id, culture: $culture) {
    __typename
    ... on ArtistService {
      ...ArtistServiceFragment
    }
  }
}
    ${ArtistServiceFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useArtistServiceByIdQuery__
 *
 * To run a query within a React component, call `useArtistServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtistServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtistServiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useArtistServiceByIdQuery(baseOptions?: Apollo.QueryHookOptions<IArtistServiceByIdQuery, IArtistServiceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IArtistServiceByIdQuery, IArtistServiceByIdQueryVariables>(ArtistServiceByIdDocument, options);
      }
export function useArtistServiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IArtistServiceByIdQuery, IArtistServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IArtistServiceByIdQuery, IArtistServiceByIdQueryVariables>(ArtistServiceByIdDocument, options);
        }
export type ArtistServiceByIdQueryHookResult = ReturnType<typeof useArtistServiceByIdQuery>;
export type ArtistServiceByIdLazyQueryHookResult = ReturnType<typeof useArtistServiceByIdLazyQuery>;
export type ArtistServiceByIdQueryResult = Apollo.QueryResult<IArtistServiceByIdQuery, IArtistServiceByIdQueryVariables>;
export const AristServiceByIdDocument = gql`
    query AristServiceById($id: [ID], $culture: String, $imageFormat: ImageCropFormat) {
  allContent(where: {id_any: $id}, culture: $culture) {
    items {
      __typename
      ... on ArtistService {
        id
        title
        subtitle
      }
    }
  }
}
    `;

/**
 * __useAristServiceByIdQuery__
 *
 * To run a query within a React component, call `useAristServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAristServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAristServiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAristServiceByIdQuery(baseOptions?: Apollo.QueryHookOptions<IAristServiceByIdQuery, IAristServiceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAristServiceByIdQuery, IAristServiceByIdQueryVariables>(AristServiceByIdDocument, options);
      }
export function useAristServiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAristServiceByIdQuery, IAristServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAristServiceByIdQuery, IAristServiceByIdQueryVariables>(AristServiceByIdDocument, options);
        }
export type AristServiceByIdQueryHookResult = ReturnType<typeof useAristServiceByIdQuery>;
export type AristServiceByIdLazyQueryHookResult = ReturnType<typeof useAristServiceByIdLazyQuery>;
export type AristServiceByIdQueryResult = Apollo.QueryResult<IAristServiceByIdQuery, IAristServiceByIdQueryVariables>;
export const ArtistServicesPageByUrlDocument = gql`
    query ArtistServicesPageByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  artistServicesPage(url: $url, culture: $culture) {
    ...ArtistServicesPageFragment
  }
}
    ${ArtistServicesPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useArtistServicesPageByUrlQuery__
 *
 * To run a query within a React component, call `useArtistServicesPageByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtistServicesPageByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtistServicesPageByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useArtistServicesPageByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IArtistServicesPageByUrlQuery, IArtistServicesPageByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IArtistServicesPageByUrlQuery, IArtistServicesPageByUrlQueryVariables>(ArtistServicesPageByUrlDocument, options);
      }
export function useArtistServicesPageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IArtistServicesPageByUrlQuery, IArtistServicesPageByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IArtistServicesPageByUrlQuery, IArtistServicesPageByUrlQueryVariables>(ArtistServicesPageByUrlDocument, options);
        }
export type ArtistServicesPageByUrlQueryHookResult = ReturnType<typeof useArtistServicesPageByUrlQuery>;
export type ArtistServicesPageByUrlLazyQueryHookResult = ReturnType<typeof useArtistServicesPageByUrlLazyQuery>;
export type ArtistServicesPageByUrlQueryResult = Apollo.QueryResult<IArtistServicesPageByUrlQuery, IArtistServicesPageByUrlQueryVariables>;
export const ArtistServicesPageByIdDocument = gql`
    query ArtistServicesPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  artistServicesPage(id: $id, culture: $culture) {
    ...ArtistServicesPageFragment
  }
}
    ${ArtistServicesPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useArtistServicesPageByIdQuery__
 *
 * To run a query within a React component, call `useArtistServicesPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtistServicesPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtistServicesPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useArtistServicesPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<IArtistServicesPageByIdQuery, IArtistServicesPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IArtistServicesPageByIdQuery, IArtistServicesPageByIdQueryVariables>(ArtistServicesPageByIdDocument, options);
      }
export function useArtistServicesPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IArtistServicesPageByIdQuery, IArtistServicesPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IArtistServicesPageByIdQuery, IArtistServicesPageByIdQueryVariables>(ArtistServicesPageByIdDocument, options);
        }
export type ArtistServicesPageByIdQueryHookResult = ReturnType<typeof useArtistServicesPageByIdQuery>;
export type ArtistServicesPageByIdLazyQueryHookResult = ReturnType<typeof useArtistServicesPageByIdLazyQuery>;
export type ArtistServicesPageByIdQueryResult = Apollo.QueryResult<IArtistServicesPageByIdQuery, IArtistServicesPageByIdQueryVariables>;
export const AwardsArtistByIdDocument = gql`
    query AwardsArtistById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  awardsArtist(id: $id, culture: $culture) {
    ... on AwardsArtist {
      ...AwardsArtistFragment
    }
  }
}
    ${AwardsArtistFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useAwardsArtistByIdQuery__
 *
 * To run a query within a React component, call `useAwardsArtistByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardsArtistByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardsArtistByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAwardsArtistByIdQuery(baseOptions?: Apollo.QueryHookOptions<IAwardsArtistByIdQuery, IAwardsArtistByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAwardsArtistByIdQuery, IAwardsArtistByIdQueryVariables>(AwardsArtistByIdDocument, options);
      }
export function useAwardsArtistByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAwardsArtistByIdQuery, IAwardsArtistByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAwardsArtistByIdQuery, IAwardsArtistByIdQueryVariables>(AwardsArtistByIdDocument, options);
        }
export type AwardsArtistByIdQueryHookResult = ReturnType<typeof useAwardsArtistByIdQuery>;
export type AwardsArtistByIdLazyQueryHookResult = ReturnType<typeof useAwardsArtistByIdLazyQuery>;
export type AwardsArtistByIdQueryResult = Apollo.QueryResult<IAwardsArtistByIdQuery, IAwardsArtistByIdQueryVariables>;
export const AwardsArtistByNameDocument = gql`
    query AwardsArtistByName($name: String, $culture: String, $imageFormat: ImageCropFormat) {
  allAwardsArtist(culture: $culture, where: {name: $name}) {
    items {
      ... on AwardsArtist {
        ...AwardsArtistFragment
      }
    }
  }
}
    ${AwardsArtistFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useAwardsArtistByNameQuery__
 *
 * To run a query within a React component, call `useAwardsArtistByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardsArtistByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardsArtistByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAwardsArtistByNameQuery(baseOptions?: Apollo.QueryHookOptions<IAwardsArtistByNameQuery, IAwardsArtistByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAwardsArtistByNameQuery, IAwardsArtistByNameQueryVariables>(AwardsArtistByNameDocument, options);
      }
export function useAwardsArtistByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAwardsArtistByNameQuery, IAwardsArtistByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAwardsArtistByNameQuery, IAwardsArtistByNameQueryVariables>(AwardsArtistByNameDocument, options);
        }
export type AwardsArtistByNameQueryHookResult = ReturnType<typeof useAwardsArtistByNameQuery>;
export type AwardsArtistByNameLazyQueryHookResult = ReturnType<typeof useAwardsArtistByNameLazyQuery>;
export type AwardsArtistByNameQueryResult = Apollo.QueryResult<IAwardsArtistByNameQuery, IAwardsArtistByNameQueryVariables>;
export const AwardCategoryPageByIdDocument = gql`
    query AwardCategoryPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  awardCategoryPage(id: $id, culture: $culture) {
    ...AwardCategoryPageFragment
  }
}
    ${AwardCategoryPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}
${AwardsArtistFragmentFragmentDoc}
${AwardsCategoryMenuFragmentFragmentDoc}
${LinkPickerFragmentFragmentDoc}`;

/**
 * __useAwardCategoryPageByIdQuery__
 *
 * To run a query within a React component, call `useAwardCategoryPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardCategoryPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardCategoryPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAwardCategoryPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<IAwardCategoryPageByIdQuery, IAwardCategoryPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAwardCategoryPageByIdQuery, IAwardCategoryPageByIdQueryVariables>(AwardCategoryPageByIdDocument, options);
      }
export function useAwardCategoryPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAwardCategoryPageByIdQuery, IAwardCategoryPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAwardCategoryPageByIdQuery, IAwardCategoryPageByIdQueryVariables>(AwardCategoryPageByIdDocument, options);
        }
export type AwardCategoryPageByIdQueryHookResult = ReturnType<typeof useAwardCategoryPageByIdQuery>;
export type AwardCategoryPageByIdLazyQueryHookResult = ReturnType<typeof useAwardCategoryPageByIdLazyQuery>;
export type AwardCategoryPageByIdQueryResult = Apollo.QueryResult<IAwardCategoryPageByIdQuery, IAwardCategoryPageByIdQueryVariables>;
export const AwardHomePageByUrlDocument = gql`
    query AwardHomePageByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  awardsHomepage(url: $url, culture: $culture) {
    ...AwardHomePageFragment
  }
}
    ${AwardHomePageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useAwardHomePageByUrlQuery__
 *
 * To run a query within a React component, call `useAwardHomePageByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardHomePageByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardHomePageByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAwardHomePageByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IAwardHomePageByUrlQuery, IAwardHomePageByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAwardHomePageByUrlQuery, IAwardHomePageByUrlQueryVariables>(AwardHomePageByUrlDocument, options);
      }
export function useAwardHomePageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAwardHomePageByUrlQuery, IAwardHomePageByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAwardHomePageByUrlQuery, IAwardHomePageByUrlQueryVariables>(AwardHomePageByUrlDocument, options);
        }
export type AwardHomePageByUrlQueryHookResult = ReturnType<typeof useAwardHomePageByUrlQuery>;
export type AwardHomePageByUrlLazyQueryHookResult = ReturnType<typeof useAwardHomePageByUrlLazyQuery>;
export type AwardHomePageByUrlQueryResult = Apollo.QueryResult<IAwardHomePageByUrlQuery, IAwardHomePageByUrlQueryVariables>;
export const AwardHomePageByIdDocument = gql`
    query AwardHomePageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  awardsHomepage(id: $id, culture: $culture) {
    ...AwardHomePageFragment
  }
}
    ${AwardHomePageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useAwardHomePageByIdQuery__
 *
 * To run a query within a React component, call `useAwardHomePageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardHomePageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardHomePageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAwardHomePageByIdQuery(baseOptions?: Apollo.QueryHookOptions<IAwardHomePageByIdQuery, IAwardHomePageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAwardHomePageByIdQuery, IAwardHomePageByIdQueryVariables>(AwardHomePageByIdDocument, options);
      }
export function useAwardHomePageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAwardHomePageByIdQuery, IAwardHomePageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAwardHomePageByIdQuery, IAwardHomePageByIdQueryVariables>(AwardHomePageByIdDocument, options);
        }
export type AwardHomePageByIdQueryHookResult = ReturnType<typeof useAwardHomePageByIdQuery>;
export type AwardHomePageByIdLazyQueryHookResult = ReturnType<typeof useAwardHomePageByIdLazyQuery>;
export type AwardHomePageByIdQueryResult = Apollo.QueryResult<IAwardHomePageByIdQuery, IAwardHomePageByIdQueryVariables>;
export const AwardSettingsDocument = gql`
    query AwardSettings($culture: String, $imageFormat: ImageCropFormat) {
  allAwardsHomepage(culture: $culture, first: 1) {
    items {
      ...AwardSettingsFragment
    }
  }
}
    ${AwardSettingsFragmentFragmentDoc}`;

/**
 * __useAwardSettingsQuery__
 *
 * To run a query within a React component, call `useAwardSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwardSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwardSettingsQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAwardSettingsQuery(baseOptions?: Apollo.QueryHookOptions<IAwardSettingsQuery, IAwardSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAwardSettingsQuery, IAwardSettingsQueryVariables>(AwardSettingsDocument, options);
      }
export function useAwardSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAwardSettingsQuery, IAwardSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAwardSettingsQuery, IAwardSettingsQueryVariables>(AwardSettingsDocument, options);
        }
export type AwardSettingsQueryHookResult = ReturnType<typeof useAwardSettingsQuery>;
export type AwardSettingsLazyQueryHookResult = ReturnType<typeof useAwardSettingsLazyQuery>;
export type AwardSettingsQueryResult = Apollo.QueryResult<IAwardSettingsQuery, IAwardSettingsQueryVariables>;
export const CgvDocument = gql`
    query Cgv($culture: String) {
  allSettings(culture: $culture) {
    items {
      __typename
      termsConditions {
        __typename
        ... on TextPage {
          ...TextPageFragment
        }
      }
      privacyPolicies {
        __typename
        ... on TextPage {
          ...TextPageFragment
        }
      }
    }
  }
}
    ${TextPageFragmentFragmentDoc}`;

/**
 * __useCgvQuery__
 *
 * To run a query within a React component, call `useCgvQuery` and pass it any options that fit your needs.
 * When your component renders, `useCgvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCgvQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useCgvQuery(baseOptions?: Apollo.QueryHookOptions<ICgvQuery, ICgvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICgvQuery, ICgvQueryVariables>(CgvDocument, options);
      }
export function useCgvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICgvQuery, ICgvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICgvQuery, ICgvQueryVariables>(CgvDocument, options);
        }
export type CgvQueryHookResult = ReturnType<typeof useCgvQuery>;
export type CgvLazyQueryHookResult = ReturnType<typeof useCgvLazyQuery>;
export type CgvQueryResult = Apollo.QueryResult<ICgvQuery, ICgvQueryVariables>;
export const AllCategoryMenuDocument = gql`
    query AllCategoryMenu($contentTypeAlias: String, $culture: String) {
  allCategoryPage: allContent(
    where: {contentTypeAlias: $contentTypeAlias}
    culture: $culture
  ) {
    items {
      id
      __typename
      name
      url
      ... on WatchCateg {
        id
        name
        url
        __typename
        isExpand
      }
    }
  }
}
    `;

/**
 * __useAllCategoryMenuQuery__
 *
 * To run a query within a React component, call `useAllCategoryMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCategoryMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCategoryMenuQuery({
 *   variables: {
 *      contentTypeAlias: // value for 'contentTypeAlias'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useAllCategoryMenuQuery(baseOptions?: Apollo.QueryHookOptions<IAllCategoryMenuQuery, IAllCategoryMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllCategoryMenuQuery, IAllCategoryMenuQueryVariables>(AllCategoryMenuDocument, options);
      }
export function useAllCategoryMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllCategoryMenuQuery, IAllCategoryMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllCategoryMenuQuery, IAllCategoryMenuQueryVariables>(AllCategoryMenuDocument, options);
        }
export type AllCategoryMenuQueryHookResult = ReturnType<typeof useAllCategoryMenuQuery>;
export type AllCategoryMenuLazyQueryHookResult = ReturnType<typeof useAllCategoryMenuLazyQuery>;
export type AllCategoryMenuQueryResult = Apollo.QueryResult<IAllCategoryMenuQuery, IAllCategoryMenuQueryVariables>;
export const AllRegionCategoryTagsDocument = gql`
    query AllRegionCategoryTags($id: ID!, $culture: String) {
  content(id: $id, culture: $culture) {
    children {
      items {
        ... on ContentTag {
          ...ContentTagFragment
        }
      }
    }
  }
}
    ${ContentTagFragmentFragmentDoc}`;

/**
 * __useAllRegionCategoryTagsQuery__
 *
 * To run a query within a React component, call `useAllRegionCategoryTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRegionCategoryTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRegionCategoryTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useAllRegionCategoryTagsQuery(baseOptions: Apollo.QueryHookOptions<IAllRegionCategoryTagsQuery, IAllRegionCategoryTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllRegionCategoryTagsQuery, IAllRegionCategoryTagsQueryVariables>(AllRegionCategoryTagsDocument, options);
      }
export function useAllRegionCategoryTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllRegionCategoryTagsQuery, IAllRegionCategoryTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllRegionCategoryTagsQuery, IAllRegionCategoryTagsQueryVariables>(AllRegionCategoryTagsDocument, options);
        }
export type AllRegionCategoryTagsQueryHookResult = ReturnType<typeof useAllRegionCategoryTagsQuery>;
export type AllRegionCategoryTagsLazyQueryHookResult = ReturnType<typeof useAllRegionCategoryTagsLazyQuery>;
export type AllRegionCategoryTagsQueryResult = Apollo.QueryResult<IAllRegionCategoryTagsQuery, IAllRegionCategoryTagsQueryVariables>;
export const CategoryChildrenByIdDocument = gql`
    query CategoryChildrenById($id: ID, $first: Int, $after: String, $culture: String, $orderBy: [ContentOrderByInput], $imageFormat: ImageCropFormat) {
  category: content(id: $id, culture: $culture) {
    children(first: $first, after: $after, orderBy: $orderBy) {
      edges {
        cursor
        node {
          ...MainContentListFragment
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        __typename
      }
    }
  }
}
    ${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useCategoryChildrenByIdQuery__
 *
 * To run a query within a React component, call `useCategoryChildrenByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryChildrenByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryChildrenByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      culture: // value for 'culture'
 *      orderBy: // value for 'orderBy'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCategoryChildrenByIdQuery(baseOptions?: Apollo.QueryHookOptions<ICategoryChildrenByIdQuery, ICategoryChildrenByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICategoryChildrenByIdQuery, ICategoryChildrenByIdQueryVariables>(CategoryChildrenByIdDocument, options);
      }
export function useCategoryChildrenByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICategoryChildrenByIdQuery, ICategoryChildrenByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICategoryChildrenByIdQuery, ICategoryChildrenByIdQueryVariables>(CategoryChildrenByIdDocument, options);
        }
export type CategoryChildrenByIdQueryHookResult = ReturnType<typeof useCategoryChildrenByIdQuery>;
export type CategoryChildrenByIdLazyQueryHookResult = ReturnType<typeof useCategoryChildrenByIdLazyQuery>;
export type CategoryChildrenByIdQueryResult = Apollo.QueryResult<ICategoryChildrenByIdQuery, ICategoryChildrenByIdQueryVariables>;
export const NewsCategoryByUrlDocument = gql`
    query NewsCategoryByUrl($categoryUrl: String, $first: Int, $after: String, $culture: String, $orderBy: [NewsOrderByInput], $imageFormat: ImageCropFormat) {
  category: allNews(
    where: {url_starts_with: $categoryUrl}
    culture: $culture
    first: $first
    after: $after
    orderBy: $orderBy
  ) {
    edges {
      cursor
      node {
        ...NewsFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      __typename
    }
  }
}
    ${NewsFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useNewsCategoryByUrlQuery__
 *
 * To run a query within a React component, call `useNewsCategoryByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsCategoryByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsCategoryByUrlQuery({
 *   variables: {
 *      categoryUrl: // value for 'categoryUrl'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      culture: // value for 'culture'
 *      orderBy: // value for 'orderBy'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useNewsCategoryByUrlQuery(baseOptions?: Apollo.QueryHookOptions<INewsCategoryByUrlQuery, INewsCategoryByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<INewsCategoryByUrlQuery, INewsCategoryByUrlQueryVariables>(NewsCategoryByUrlDocument, options);
      }
export function useNewsCategoryByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<INewsCategoryByUrlQuery, INewsCategoryByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<INewsCategoryByUrlQuery, INewsCategoryByUrlQueryVariables>(NewsCategoryByUrlDocument, options);
        }
export type NewsCategoryByUrlQueryHookResult = ReturnType<typeof useNewsCategoryByUrlQuery>;
export type NewsCategoryByUrlLazyQueryHookResult = ReturnType<typeof useNewsCategoryByUrlLazyQuery>;
export type NewsCategoryByUrlQueryResult = Apollo.QueryResult<INewsCategoryByUrlQuery, INewsCategoryByUrlQueryVariables>;
export const NewsCategoryByUrlWithRegionDocument = gql`
    query NewsCategoryByUrlWithRegion($categoryUrl: String, $first: Int, $after: String, $culture: String, $orderBy: [NewsOrderByInput], $regionTag: ID, $imageFormat: ImageCropFormat) {
  category: allNews(
    where: {regions_some: {id: $regionTag}, url_starts_with: $categoryUrl}
    culture: $culture
    first: $first
    after: $after
    orderBy: $orderBy
  ) {
    edges {
      cursor
      node {
        ...NewsFragment
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      __typename
    }
  }
}
    ${NewsFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useNewsCategoryByUrlWithRegionQuery__
 *
 * To run a query within a React component, call `useNewsCategoryByUrlWithRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsCategoryByUrlWithRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsCategoryByUrlWithRegionQuery({
 *   variables: {
 *      categoryUrl: // value for 'categoryUrl'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      culture: // value for 'culture'
 *      orderBy: // value for 'orderBy'
 *      regionTag: // value for 'regionTag'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useNewsCategoryByUrlWithRegionQuery(baseOptions?: Apollo.QueryHookOptions<INewsCategoryByUrlWithRegionQuery, INewsCategoryByUrlWithRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<INewsCategoryByUrlWithRegionQuery, INewsCategoryByUrlWithRegionQueryVariables>(NewsCategoryByUrlWithRegionDocument, options);
      }
export function useNewsCategoryByUrlWithRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<INewsCategoryByUrlWithRegionQuery, INewsCategoryByUrlWithRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<INewsCategoryByUrlWithRegionQuery, INewsCategoryByUrlWithRegionQueryVariables>(NewsCategoryByUrlWithRegionDocument, options);
        }
export type NewsCategoryByUrlWithRegionQueryHookResult = ReturnType<typeof useNewsCategoryByUrlWithRegionQuery>;
export type NewsCategoryByUrlWithRegionLazyQueryHookResult = ReturnType<typeof useNewsCategoryByUrlWithRegionLazyQuery>;
export type NewsCategoryByUrlWithRegionQueryResult = Apollo.QueryResult<INewsCategoryByUrlWithRegionQuery, INewsCategoryByUrlWithRegionQueryVariables>;
export const RelatedCAtegoryDocument = gql`
    query RelatedCAtegory($id: ID, $first: Int, $url_starts_with: String, $culture: String, $imageFormat: ImageCropFormat) {
  allCategoryPage(
    where: {categoryContent_some: {id: $id}, AND: {url_starts_with: $url_starts_with}}
    first: $first
    culture: $culture
  ) {
    items {
      ...CategoryPageFragment
    }
  }
}
    ${CategoryPageFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useRelatedCAtegoryQuery__
 *
 * To run a query within a React component, call `useRelatedCAtegoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedCAtegoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedCAtegoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      url_starts_with: // value for 'url_starts_with'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useRelatedCAtegoryQuery(baseOptions?: Apollo.QueryHookOptions<IRelatedCAtegoryQuery, IRelatedCAtegoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRelatedCAtegoryQuery, IRelatedCAtegoryQueryVariables>(RelatedCAtegoryDocument, options);
      }
export function useRelatedCAtegoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRelatedCAtegoryQuery, IRelatedCAtegoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRelatedCAtegoryQuery, IRelatedCAtegoryQueryVariables>(RelatedCAtegoryDocument, options);
        }
export type RelatedCAtegoryQueryHookResult = ReturnType<typeof useRelatedCAtegoryQuery>;
export type RelatedCAtegoryLazyQueryHookResult = ReturnType<typeof useRelatedCAtegoryLazyQuery>;
export type RelatedCAtegoryQueryResult = Apollo.QueryResult<IRelatedCAtegoryQuery, IRelatedCAtegoryQueryVariables>;
export const VodItemRelatedContentDocument = gql`
    query VODItemRelatedContent($id: ID, $culture: String, $first: Int = 10, $imageFormat: ImageCropFormat) {
  vODItem(id: $id, culture: $culture) {
    __typename
    parent {
      id
      __typename
      ... on WatchCateg {
        id
        url
        name
        backgroundColor
        __typename
        children(first: $first) {
          __typename
          items {
            __typename
            ... on ContentItems {
              __typename
              title
              subtitle
              countriesRestriction
            }
            ...MainContentListFragment
          }
        }
      }
      ... on Collection {
        ...CollectionFragment
        children(first: $first) {
          items {
            name
            url
            __typename
            ... on VODItem {
              ...VODItemFragment
            }
          }
        }
      }
    }
  }
}
    ${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useVodItemRelatedContentQuery__
 *
 * To run a query within a React component, call `useVodItemRelatedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useVodItemRelatedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVodItemRelatedContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      first: // value for 'first'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useVodItemRelatedContentQuery(baseOptions?: Apollo.QueryHookOptions<IVodItemRelatedContentQuery, IVodItemRelatedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IVodItemRelatedContentQuery, IVodItemRelatedContentQueryVariables>(VodItemRelatedContentDocument, options);
      }
export function useVodItemRelatedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IVodItemRelatedContentQuery, IVodItemRelatedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IVodItemRelatedContentQuery, IVodItemRelatedContentQueryVariables>(VodItemRelatedContentDocument, options);
        }
export type VodItemRelatedContentQueryHookResult = ReturnType<typeof useVodItemRelatedContentQuery>;
export type VodItemRelatedContentLazyQueryHookResult = ReturnType<typeof useVodItemRelatedContentLazyQuery>;
export type VodItemRelatedContentQueryResult = Apollo.QueryResult<IVodItemRelatedContentQuery, IVodItemRelatedContentQueryVariables>;
export const CategoryPageByUrlDocument = gql`
    query CategoryPageByUrl($url: String, $imageFormat: ImageCropFormat) {
  categoryPage(url: $url) {
    ... on CategoryPage {
      ...CategoryPageFragment
    }
  }
}
    ${CategoryPageFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useCategoryPageByUrlQuery__
 *
 * To run a query within a React component, call `useCategoryPageByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryPageByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryPageByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCategoryPageByUrlQuery(baseOptions?: Apollo.QueryHookOptions<ICategoryPageByUrlQuery, ICategoryPageByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICategoryPageByUrlQuery, ICategoryPageByUrlQueryVariables>(CategoryPageByUrlDocument, options);
      }
export function useCategoryPageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICategoryPageByUrlQuery, ICategoryPageByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICategoryPageByUrlQuery, ICategoryPageByUrlQueryVariables>(CategoryPageByUrlDocument, options);
        }
export type CategoryPageByUrlQueryHookResult = ReturnType<typeof useCategoryPageByUrlQuery>;
export type CategoryPageByUrlLazyQueryHookResult = ReturnType<typeof useCategoryPageByUrlLazyQuery>;
export type CategoryPageByUrlQueryResult = Apollo.QueryResult<ICategoryPageByUrlQuery, ICategoryPageByUrlQueryVariables>;
export const CategoryPageByIdDocument = gql`
    query CategoryPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  categoryPage(id: $id, culture: $culture) {
    ... on CategoryPage {
      ...CategoryPageFragment
    }
  }
}
    ${CategoryPageFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useCategoryPageByIdQuery__
 *
 * To run a query within a React component, call `useCategoryPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCategoryPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<ICategoryPageByIdQuery, ICategoryPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICategoryPageByIdQuery, ICategoryPageByIdQueryVariables>(CategoryPageByIdDocument, options);
      }
export function useCategoryPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICategoryPageByIdQuery, ICategoryPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICategoryPageByIdQuery, ICategoryPageByIdQueryVariables>(CategoryPageByIdDocument, options);
        }
export type CategoryPageByIdQueryHookResult = ReturnType<typeof useCategoryPageByIdQuery>;
export type CategoryPageByIdLazyQueryHookResult = ReturnType<typeof useCategoryPageByIdLazyQuery>;
export type CategoryPageByIdQueryResult = Apollo.QueryResult<ICategoryPageByIdQuery, ICategoryPageByIdQueryVariables>;
export const ChannelByIdDocument = gql`
    query ChannelById($id: [ID], $culture: String, $imageFormat: ImageCropFormat) {
  allContent(where: {id_any: $id}, culture: $culture) {
    items {
      __typename
      ... on Channel {
        ...ChannelFragment
      }
    }
  }
}
    ${ChannelFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useChannelByIdQuery__
 *
 * To run a query within a React component, call `useChannelByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useChannelByIdQuery(baseOptions?: Apollo.QueryHookOptions<IChannelByIdQuery, IChannelByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IChannelByIdQuery, IChannelByIdQueryVariables>(ChannelByIdDocument, options);
      }
export function useChannelByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IChannelByIdQuery, IChannelByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IChannelByIdQuery, IChannelByIdQueryVariables>(ChannelByIdDocument, options);
        }
export type ChannelByIdQueryHookResult = ReturnType<typeof useChannelByIdQuery>;
export type ChannelByIdLazyQueryHookResult = ReturnType<typeof useChannelByIdLazyQuery>;
export type ChannelByIdQueryResult = Apollo.QueryResult<IChannelByIdQuery, IChannelByIdQueryVariables>;
export const CollectionByUrlDocument = gql`
    query CollectionByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  collection(url: $url, culture: $culture) {
    ...CollectionFragment
    children {
      items {
        name
        url
        __typename
        ... on VODItem {
          ...VODItemFragment
        }
      }
    }
  }
}
    ${CollectionFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}`;

/**
 * __useCollectionByUrlQuery__
 *
 * To run a query within a React component, call `useCollectionByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCollectionByUrlQuery(baseOptions?: Apollo.QueryHookOptions<ICollectionByUrlQuery, ICollectionByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICollectionByUrlQuery, ICollectionByUrlQueryVariables>(CollectionByUrlDocument, options);
      }
export function useCollectionByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICollectionByUrlQuery, ICollectionByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICollectionByUrlQuery, ICollectionByUrlQueryVariables>(CollectionByUrlDocument, options);
        }
export type CollectionByUrlQueryHookResult = ReturnType<typeof useCollectionByUrlQuery>;
export type CollectionByUrlLazyQueryHookResult = ReturnType<typeof useCollectionByUrlLazyQuery>;
export type CollectionByUrlQueryResult = Apollo.QueryResult<ICollectionByUrlQuery, ICollectionByUrlQueryVariables>;
export const CollectionByIdDocument = gql`
    query CollectionById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  collection(id: $id, culture: $culture) {
    ...CollectionFragment
    children {
      items {
        name
        url
        __typename
        ... on VODItem {
          ...VODItemFragment
        }
      }
    }
  }
}
    ${CollectionFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}`;

/**
 * __useCollectionByIdQuery__
 *
 * To run a query within a React component, call `useCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCollectionByIdQuery(baseOptions?: Apollo.QueryHookOptions<ICollectionByIdQuery, ICollectionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICollectionByIdQuery, ICollectionByIdQueryVariables>(CollectionByIdDocument, options);
      }
export function useCollectionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICollectionByIdQuery, ICollectionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICollectionByIdQuery, ICollectionByIdQueryVariables>(CollectionByIdDocument, options);
        }
export type CollectionByIdQueryHookResult = ReturnType<typeof useCollectionByIdQuery>;
export type CollectionByIdLazyQueryHookResult = ReturnType<typeof useCollectionByIdLazyQuery>;
export type CollectionByIdQueryResult = Apollo.QueryResult<ICollectionByIdQuery, ICollectionByIdQueryVariables>;
export const CollectionByUrlEndDocument = gql`
    query CollectionByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allCollection(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      ...CollectionFragment
      children {
        items {
          name
          url
          __typename
          ... on VODItem {
            ...VODItemFragment
          }
        }
      }
    }
  }
}
    ${CollectionFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}`;

/**
 * __useCollectionByUrlEndQuery__
 *
 * To run a query within a React component, call `useCollectionByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCollectionByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<ICollectionByUrlEndQuery, ICollectionByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICollectionByUrlEndQuery, ICollectionByUrlEndQueryVariables>(CollectionByUrlEndDocument, options);
      }
export function useCollectionByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICollectionByUrlEndQuery, ICollectionByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICollectionByUrlEndQuery, ICollectionByUrlEndQueryVariables>(CollectionByUrlEndDocument, options);
        }
export type CollectionByUrlEndQueryHookResult = ReturnType<typeof useCollectionByUrlEndQuery>;
export type CollectionByUrlEndLazyQueryHookResult = ReturnType<typeof useCollectionByUrlEndLazyQuery>;
export type CollectionByUrlEndQueryResult = Apollo.QueryResult<ICollectionByUrlEndQuery, ICollectionByUrlEndQueryVariables>;
export const AllContentByListIdDocument = gql`
    query AllContentByListId($id: [ID], $culture: String, $imageFormat: ImageCropFormat) {
  allContent(where: {id_any: $id}, culture: $culture) {
    items {
      __typename
      id
      name
      ... on VODItem {
        ...VODItemFragment
      }
      ... on PodcastItem {
        ...PodcastItemFragment
      }
    }
  }
}
    ${VodItemFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${PodcastItemFragmentFragmentDoc}`;

/**
 * __useAllContentByListIdQuery__
 *
 * To run a query within a React component, call `useAllContentByListIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllContentByListIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllContentByListIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllContentByListIdQuery(baseOptions?: Apollo.QueryHookOptions<IAllContentByListIdQuery, IAllContentByListIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllContentByListIdQuery, IAllContentByListIdQueryVariables>(AllContentByListIdDocument, options);
      }
export function useAllContentByListIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllContentByListIdQuery, IAllContentByListIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllContentByListIdQuery, IAllContentByListIdQueryVariables>(AllContentByListIdDocument, options);
        }
export type AllContentByListIdQueryHookResult = ReturnType<typeof useAllContentByListIdQuery>;
export type AllContentByListIdLazyQueryHookResult = ReturnType<typeof useAllContentByListIdLazyQuery>;
export type AllContentByListIdQueryResult = Apollo.QueryResult<IAllContentByListIdQuery, IAllContentByListIdQueryVariables>;
export const ContentIdByEndUrlDocument = gql`
    query ContentIdByEndUrl($endUrl: String, $contentTypeAlias: String) {
  en: allContent(
    where: {url_ends_with: $endUrl, contentTypeAlias: $contentTypeAlias}
    culture: "en-US"
  ) {
    items {
      id
      __typename
      ...DeepLinkContentFragment
      ... on Channel {
        liveEventId: vimeoEventId
        sourceUrl
      }
    }
  }
  fr: allContent(
    where: {url_ends_with: $endUrl, contentTypeAlias: $contentTypeAlias}
    culture: "fr"
  ) {
    items {
      id
      __typename
      ...DeepLinkContentFragment
      ... on Channel {
        liveEventId: vimeoEventId
        sourceUrl
      }
    }
  }
  pt: allContent(
    where: {url_ends_with: $endUrl, contentTypeAlias: $contentTypeAlias}
    culture: "pt-BR"
  ) {
    items {
      id
      __typename
      ...DeepLinkContentFragment
      ... on Channel {
        liveEventId: vimeoEventId
        sourceUrl
      }
    }
  }
}
    ${DeepLinkContentFragmentFragmentDoc}`;

/**
 * __useContentIdByEndUrlQuery__
 *
 * To run a query within a React component, call `useContentIdByEndUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentIdByEndUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentIdByEndUrlQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      contentTypeAlias: // value for 'contentTypeAlias'
 *   },
 * });
 */
export function useContentIdByEndUrlQuery(baseOptions?: Apollo.QueryHookOptions<IContentIdByEndUrlQuery, IContentIdByEndUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContentIdByEndUrlQuery, IContentIdByEndUrlQueryVariables>(ContentIdByEndUrlDocument, options);
      }
export function useContentIdByEndUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContentIdByEndUrlQuery, IContentIdByEndUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContentIdByEndUrlQuery, IContentIdByEndUrlQueryVariables>(ContentIdByEndUrlDocument, options);
        }
export type ContentIdByEndUrlQueryHookResult = ReturnType<typeof useContentIdByEndUrlQuery>;
export type ContentIdByEndUrlLazyQueryHookResult = ReturnType<typeof useContentIdByEndUrlLazyQuery>;
export type ContentIdByEndUrlQueryResult = Apollo.QueryResult<IContentIdByEndUrlQuery, IContentIdByEndUrlQueryVariables>;
export const ContentUrlByIdDocument = gql`
    query ContentUrlById($id: ID, $culture: String) {
  content(id: $id, culture: $culture) {
    id
    url
    __typename
  }
}
    `;

/**
 * __useContentUrlByIdQuery__
 *
 * To run a query within a React component, call `useContentUrlByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentUrlByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentUrlByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useContentUrlByIdQuery(baseOptions?: Apollo.QueryHookOptions<IContentUrlByIdQuery, IContentUrlByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContentUrlByIdQuery, IContentUrlByIdQueryVariables>(ContentUrlByIdDocument, options);
      }
export function useContentUrlByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContentUrlByIdQuery, IContentUrlByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContentUrlByIdQuery, IContentUrlByIdQueryVariables>(ContentUrlByIdDocument, options);
        }
export type ContentUrlByIdQueryHookResult = ReturnType<typeof useContentUrlByIdQuery>;
export type ContentUrlByIdLazyQueryHookResult = ReturnType<typeof useContentUrlByIdLazyQuery>;
export type ContentUrlByIdQueryResult = Apollo.QueryResult<IContentUrlByIdQuery, IContentUrlByIdQueryVariables>;
export const CountMemberSavedByContentIdDocument = gql`
    query CountMemberSavedByContentId($contentId: ID) {
  allMemberSaved(where: {contentLink: {id: $contentId}}) {
    items {
      id
    }
  }
}
    `;

/**
 * __useCountMemberSavedByContentIdQuery__
 *
 * To run a query within a React component, call `useCountMemberSavedByContentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMemberSavedByContentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMemberSavedByContentIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useCountMemberSavedByContentIdQuery(baseOptions?: Apollo.QueryHookOptions<ICountMemberSavedByContentIdQuery, ICountMemberSavedByContentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICountMemberSavedByContentIdQuery, ICountMemberSavedByContentIdQueryVariables>(CountMemberSavedByContentIdDocument, options);
      }
export function useCountMemberSavedByContentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICountMemberSavedByContentIdQuery, ICountMemberSavedByContentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICountMemberSavedByContentIdQuery, ICountMemberSavedByContentIdQueryVariables>(CountMemberSavedByContentIdDocument, options);
        }
export type CountMemberSavedByContentIdQueryHookResult = ReturnType<typeof useCountMemberSavedByContentIdQuery>;
export type CountMemberSavedByContentIdLazyQueryHookResult = ReturnType<typeof useCountMemberSavedByContentIdLazyQuery>;
export type CountMemberSavedByContentIdQueryResult = Apollo.QueryResult<ICountMemberSavedByContentIdQuery, ICountMemberSavedByContentIdQueryVariables>;
export const CountMemberUnitProgressionDocument = gql`
    query CountMemberUnitProgression($memberDatasId: ID) {
  memberDatas(id: $memberDatasId) {
    children(where: {contentTypeAlias: "unitProgression"}) {
      items {
        __typename
        ... on UnitProgression {
          finished
          id
          __typename
        }
      }
    }
  }
}
    `;

/**
 * __useCountMemberUnitProgressionQuery__
 *
 * To run a query within a React component, call `useCountMemberUnitProgressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountMemberUnitProgressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountMemberUnitProgressionQuery({
 *   variables: {
 *      memberDatasId: // value for 'memberDatasId'
 *   },
 * });
 */
export function useCountMemberUnitProgressionQuery(baseOptions?: Apollo.QueryHookOptions<ICountMemberUnitProgressionQuery, ICountMemberUnitProgressionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICountMemberUnitProgressionQuery, ICountMemberUnitProgressionQueryVariables>(CountMemberUnitProgressionDocument, options);
      }
export function useCountMemberUnitProgressionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICountMemberUnitProgressionQuery, ICountMemberUnitProgressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICountMemberUnitProgressionQuery, ICountMemberUnitProgressionQueryVariables>(CountMemberUnitProgressionDocument, options);
        }
export type CountMemberUnitProgressionQueryHookResult = ReturnType<typeof useCountMemberUnitProgressionQuery>;
export type CountMemberUnitProgressionLazyQueryHookResult = ReturnType<typeof useCountMemberUnitProgressionLazyQuery>;
export type CountMemberUnitProgressionQueryResult = Apollo.QueryResult<ICountMemberUnitProgressionQuery, ICountMemberUnitProgressionQueryVariables>;
export const GetContentByIdDocument = gql`
    query GetContentById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  content(id: $id, culture: $culture) {
    ... on Channel {
      ...ChannelFragment
    }
    ... on VODItem {
      ...VODItemFragment
    }
    ... on LiveEvent {
      ...LiveEventFragment
    }
  }
}
    ${ChannelFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}`;

/**
 * __useGetContentByIdQuery__
 *
 * To run a query within a React component, call `useGetContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetContentByIdQuery(baseOptions?: Apollo.QueryHookOptions<IGetContentByIdQuery, IGetContentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetContentByIdQuery, IGetContentByIdQueryVariables>(GetContentByIdDocument, options);
      }
export function useGetContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetContentByIdQuery, IGetContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetContentByIdQuery, IGetContentByIdQueryVariables>(GetContentByIdDocument, options);
        }
export type GetContentByIdQueryHookResult = ReturnType<typeof useGetContentByIdQuery>;
export type GetContentByIdLazyQueryHookResult = ReturnType<typeof useGetContentByIdLazyQuery>;
export type GetContentByIdQueryResult = Apollo.QueryResult<IGetContentByIdQuery, IGetContentByIdQueryVariables>;
export const ContentByIdDocument = gql`
    query ContentById($id: ID, $culture: String) {
  content(id: $id, culture: $culture) {
    __typename
    url
    id
  }
}
    `;

/**
 * __useContentByIdQuery__
 *
 * To run a query within a React component, call `useContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useContentByIdQuery(baseOptions?: Apollo.QueryHookOptions<IContentByIdQuery, IContentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContentByIdQuery, IContentByIdQueryVariables>(ContentByIdDocument, options);
      }
export function useContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContentByIdQuery, IContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContentByIdQuery, IContentByIdQueryVariables>(ContentByIdDocument, options);
        }
export type ContentByIdQueryHookResult = ReturnType<typeof useContentByIdQuery>;
export type ContentByIdLazyQueryHookResult = ReturnType<typeof useContentByIdLazyQuery>;
export type ContentByIdQueryResult = Apollo.QueryResult<IContentByIdQuery, IContentByIdQueryVariables>;
export const ContentByUrlEndDocument = gql`
    query ContentByUrlEnd($urlEnd: String, $culture: String) {
  allContent(where: {url_ends_with: $urlEnd}, culture: $culture) {
    items {
      __typename
      url
      id
    }
  }
}
    `;

/**
 * __useContentByUrlEndQuery__
 *
 * To run a query within a React component, call `useContentByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentByUrlEndQuery({
 *   variables: {
 *      urlEnd: // value for 'urlEnd'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useContentByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IContentByUrlEndQuery, IContentByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContentByUrlEndQuery, IContentByUrlEndQueryVariables>(ContentByUrlEndDocument, options);
      }
export function useContentByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContentByUrlEndQuery, IContentByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContentByUrlEndQuery, IContentByUrlEndQueryVariables>(ContentByUrlEndDocument, options);
        }
export type ContentByUrlEndQueryHookResult = ReturnType<typeof useContentByUrlEndQuery>;
export type ContentByUrlEndLazyQueryHookResult = ReturnType<typeof useContentByUrlEndLazyQuery>;
export type ContentByUrlEndQueryResult = Apollo.QueryResult<IContentByUrlEndQuery, IContentByUrlEndQueryVariables>;
export const ContentByUrlDocument = gql`
    query ContentByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  content(url: $url, culture: $culture) {
    __typename
    id
    url
    level
    name
    contentTypeAlias
    ... on SectionPage {
      ...SectionPageFragment
    }
    ... on CategoryPage {
      ...CategoryPageFragment
    }
  }
}
    ${SectionPageFragmentFragmentDoc}
${HeroSlideFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useContentByUrlQuery__
 *
 * To run a query within a React component, call `useContentByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useContentByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IContentByUrlQuery, IContentByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IContentByUrlQuery, IContentByUrlQueryVariables>(ContentByUrlDocument, options);
      }
export function useContentByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IContentByUrlQuery, IContentByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IContentByUrlQuery, IContentByUrlQueryVariables>(ContentByUrlDocument, options);
        }
export type ContentByUrlQueryHookResult = ReturnType<typeof useContentByUrlQuery>;
export type ContentByUrlLazyQueryHookResult = ReturnType<typeof useContentByUrlLazyQuery>;
export type ContentByUrlQueryResult = Apollo.QueryResult<IContentByUrlQuery, IContentByUrlQueryVariables>;
export const FileUploadSettingDocument = gql`
    query FileUploadSetting {
  allSettings {
    items {
      __typename
      imageUploadParentId
      audioUploadParentId
    }
  }
}
    `;

/**
 * __useFileUploadSettingQuery__
 *
 * To run a query within a React component, call `useFileUploadSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileUploadSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileUploadSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useFileUploadSettingQuery(baseOptions?: Apollo.QueryHookOptions<IFileUploadSettingQuery, IFileUploadSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFileUploadSettingQuery, IFileUploadSettingQueryVariables>(FileUploadSettingDocument, options);
      }
export function useFileUploadSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFileUploadSettingQuery, IFileUploadSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFileUploadSettingQuery, IFileUploadSettingQueryVariables>(FileUploadSettingDocument, options);
        }
export type FileUploadSettingQueryHookResult = ReturnType<typeof useFileUploadSettingQuery>;
export type FileUploadSettingLazyQueryHookResult = ReturnType<typeof useFileUploadSettingLazyQuery>;
export type FileUploadSettingQueryResult = Apollo.QueryResult<IFileUploadSettingQuery, IFileUploadSettingQueryVariables>;
export const FormPageByIdDocument = gql`
    query FormPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  formPage(id: $id, culture: $culture) {
    ...FormPageFragment
  }
}
    ${FormPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useFormPageByIdQuery__
 *
 * To run a query within a React component, call `useFormPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useFormPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<IFormPageByIdQuery, IFormPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFormPageByIdQuery, IFormPageByIdQueryVariables>(FormPageByIdDocument, options);
      }
export function useFormPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFormPageByIdQuery, IFormPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFormPageByIdQuery, IFormPageByIdQueryVariables>(FormPageByIdDocument, options);
        }
export type FormPageByIdQueryHookResult = ReturnType<typeof useFormPageByIdQuery>;
export type FormPageByIdLazyQueryHookResult = ReturnType<typeof useFormPageByIdLazyQuery>;
export type FormPageByIdQueryResult = Apollo.QueryResult<IFormPageByIdQuery, IFormPageByIdQueryVariables>;
export const FormPageByUrlEndDocument = gql`
    query FormPageByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allFormPage(where: {url_ends_with: $endUrl}, culture: $culture) {
    items {
      ...FormPageFragment
    }
  }
}
    ${FormPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useFormPageByUrlEndQuery__
 *
 * To run a query within a React component, call `useFormPageByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormPageByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormPageByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useFormPageByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IFormPageByUrlEndQuery, IFormPageByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IFormPageByUrlEndQuery, IFormPageByUrlEndQueryVariables>(FormPageByUrlEndDocument, options);
      }
export function useFormPageByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IFormPageByUrlEndQuery, IFormPageByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IFormPageByUrlEndQuery, IFormPageByUrlEndQueryVariables>(FormPageByUrlEndDocument, options);
        }
export type FormPageByUrlEndQueryHookResult = ReturnType<typeof useFormPageByUrlEndQuery>;
export type FormPageByUrlEndLazyQueryHookResult = ReturnType<typeof useFormPageByUrlEndLazyQuery>;
export type FormPageByUrlEndQueryResult = Apollo.QueryResult<IFormPageByUrlEndQuery, IFormPageByUrlEndQueryVariables>;
export const AllHelpdeskFolderDocument = gql`
    query AllHelpdeskFolder($culture: String) {
  allHelpdeskFolder(culture: $culture, first: 1) {
    items {
      zendeskForm
      url
      id
    }
  }
}
    `;

/**
 * __useAllHelpdeskFolderQuery__
 *
 * To run a query within a React component, call `useAllHelpdeskFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHelpdeskFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHelpdeskFolderQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useAllHelpdeskFolderQuery(baseOptions?: Apollo.QueryHookOptions<IAllHelpdeskFolderQuery, IAllHelpdeskFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllHelpdeskFolderQuery, IAllHelpdeskFolderQueryVariables>(AllHelpdeskFolderDocument, options);
      }
export function useAllHelpdeskFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllHelpdeskFolderQuery, IAllHelpdeskFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllHelpdeskFolderQuery, IAllHelpdeskFolderQueryVariables>(AllHelpdeskFolderDocument, options);
        }
export type AllHelpdeskFolderQueryHookResult = ReturnType<typeof useAllHelpdeskFolderQuery>;
export type AllHelpdeskFolderLazyQueryHookResult = ReturnType<typeof useAllHelpdeskFolderLazyQuery>;
export type AllHelpdeskFolderQueryResult = Apollo.QueryResult<IAllHelpdeskFolderQuery, IAllHelpdeskFolderQueryVariables>;
export const HelpdeskPageByUrlDocument = gql`
    query HelpdeskPageByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  helpdeskPage(url: $url, culture: $culture) {
    ...HelpdeskPageFragment
  }
}
    ${HelpdeskPageFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${HelpdeskCategFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}`;

/**
 * __useHelpdeskPageByUrlQuery__
 *
 * To run a query within a React component, call `useHelpdeskPageByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpdeskPageByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpdeskPageByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useHelpdeskPageByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IHelpdeskPageByUrlQuery, IHelpdeskPageByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IHelpdeskPageByUrlQuery, IHelpdeskPageByUrlQueryVariables>(HelpdeskPageByUrlDocument, options);
      }
export function useHelpdeskPageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IHelpdeskPageByUrlQuery, IHelpdeskPageByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IHelpdeskPageByUrlQuery, IHelpdeskPageByUrlQueryVariables>(HelpdeskPageByUrlDocument, options);
        }
export type HelpdeskPageByUrlQueryHookResult = ReturnType<typeof useHelpdeskPageByUrlQuery>;
export type HelpdeskPageByUrlLazyQueryHookResult = ReturnType<typeof useHelpdeskPageByUrlLazyQuery>;
export type HelpdeskPageByUrlQueryResult = Apollo.QueryResult<IHelpdeskPageByUrlQuery, IHelpdeskPageByUrlQueryVariables>;
export const HelpdeskPageByHomepageIdDocument = gql`
    query HelpdeskPageByHomepageId($homepageId: ID, $culture: String, $imageFormat: ImageCropFormat) {
  homePage(id: $homepageId, culture: $culture) {
    children(where: {contentTypeAlias: "helpdeskPage"}) {
      items {
        ... on HelpdeskPage {
          ...HelpdeskPageFragment
        }
      }
    }
  }
}
    ${HelpdeskPageFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${HelpdeskCategFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}`;

/**
 * __useHelpdeskPageByHomepageIdQuery__
 *
 * To run a query within a React component, call `useHelpdeskPageByHomepageIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpdeskPageByHomepageIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpdeskPageByHomepageIdQuery({
 *   variables: {
 *      homepageId: // value for 'homepageId'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useHelpdeskPageByHomepageIdQuery(baseOptions?: Apollo.QueryHookOptions<IHelpdeskPageByHomepageIdQuery, IHelpdeskPageByHomepageIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IHelpdeskPageByHomepageIdQuery, IHelpdeskPageByHomepageIdQueryVariables>(HelpdeskPageByHomepageIdDocument, options);
      }
export function useHelpdeskPageByHomepageIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IHelpdeskPageByHomepageIdQuery, IHelpdeskPageByHomepageIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IHelpdeskPageByHomepageIdQuery, IHelpdeskPageByHomepageIdQueryVariables>(HelpdeskPageByHomepageIdDocument, options);
        }
export type HelpdeskPageByHomepageIdQueryHookResult = ReturnType<typeof useHelpdeskPageByHomepageIdQuery>;
export type HelpdeskPageByHomepageIdLazyQueryHookResult = ReturnType<typeof useHelpdeskPageByHomepageIdLazyQuery>;
export type HelpdeskPageByHomepageIdQueryResult = Apollo.QueryResult<IHelpdeskPageByHomepageIdQuery, IHelpdeskPageByHomepageIdQueryVariables>;
export const HelpdeskPageByRegionIdDocument = gql`
    query HelpdeskPageByRegionId($regionId: ID, $culture: String, $imageFormat: ImageCropFormat) {
  region(id: $regionId, culture: $culture) {
    children(first: 1, culture: $culture) {
      items {
        children(where: {contentTypeAlias: "helpdeskPage"}) {
          items {
            ... on HelpdeskPage {
              ...HelpdeskPageFragment
            }
          }
        }
      }
    }
  }
}
    ${HelpdeskPageFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${HelpdeskCategFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}`;

/**
 * __useHelpdeskPageByRegionIdQuery__
 *
 * To run a query within a React component, call `useHelpdeskPageByRegionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHelpdeskPageByRegionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHelpdeskPageByRegionIdQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useHelpdeskPageByRegionIdQuery(baseOptions?: Apollo.QueryHookOptions<IHelpdeskPageByRegionIdQuery, IHelpdeskPageByRegionIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IHelpdeskPageByRegionIdQuery, IHelpdeskPageByRegionIdQueryVariables>(HelpdeskPageByRegionIdDocument, options);
      }
export function useHelpdeskPageByRegionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IHelpdeskPageByRegionIdQuery, IHelpdeskPageByRegionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IHelpdeskPageByRegionIdQuery, IHelpdeskPageByRegionIdQueryVariables>(HelpdeskPageByRegionIdDocument, options);
        }
export type HelpdeskPageByRegionIdQueryHookResult = ReturnType<typeof useHelpdeskPageByRegionIdQuery>;
export type HelpdeskPageByRegionIdLazyQueryHookResult = ReturnType<typeof useHelpdeskPageByRegionIdLazyQuery>;
export type HelpdeskPageByRegionIdQueryResult = Apollo.QueryResult<IHelpdeskPageByRegionIdQuery, IHelpdeskPageByRegionIdQueryVariables>;
export const HomePageDocument = gql`
    query HomePage($id: ID, $culture: String) {
  homePage(id: $id, culture: $culture) {
    ...HomePageFragment
  }
}
    ${HomePageFragmentFragmentDoc}`;

/**
 * __useHomePageQuery__
 *
 * To run a query within a React component, call `useHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useHomePageQuery(baseOptions?: Apollo.QueryHookOptions<IHomePageQuery, IHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IHomePageQuery, IHomePageQueryVariables>(HomePageDocument, options);
      }
export function useHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IHomePageQuery, IHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IHomePageQuery, IHomePageQueryVariables>(HomePageDocument, options);
        }
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageLazyQueryHookResult = ReturnType<typeof useHomePageLazyQuery>;
export type HomePageQueryResult = Apollo.QueryResult<IHomePageQuery, IHomePageQueryVariables>;
export const AllCourseByPartnerDocument = gql`
    query AllCourseByPartner($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  allCourse(where: {linkedPartners_some: {id: $id}}, culture: $culture) {
    items {
      ...PartCourseFragment
    }
  }
}
    ${PartCourseFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}`;

/**
 * __useAllCourseByPartnerQuery__
 *
 * To run a query within a React component, call `useAllCourseByPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCourseByPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCourseByPartnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllCourseByPartnerQuery(baseOptions?: Apollo.QueryHookOptions<IAllCourseByPartnerQuery, IAllCourseByPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllCourseByPartnerQuery, IAllCourseByPartnerQueryVariables>(AllCourseByPartnerDocument, options);
      }
export function useAllCourseByPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllCourseByPartnerQuery, IAllCourseByPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllCourseByPartnerQuery, IAllCourseByPartnerQueryVariables>(AllCourseByPartnerDocument, options);
        }
export type AllCourseByPartnerQueryHookResult = ReturnType<typeof useAllCourseByPartnerQuery>;
export type AllCourseByPartnerLazyQueryHookResult = ReturnType<typeof useAllCourseByPartnerLazyQuery>;
export type AllCourseByPartnerQueryResult = Apollo.QueryResult<IAllCourseByPartnerQuery, IAllCourseByPartnerQueryVariables>;
export const AllCourseBySomeIdsDocument = gql`
    query AllCourseBySomeIds($ids: [ID], $culture: String) {
  courses: allCourse(where: {id_any: $ids}, culture: $culture) {
    items {
      title
      id
      url(culture: $culture)
      thumbnail {
        url
        cropUrl(alias: "default", quality: 50, format: JPG)
      }
      length
      description
      linkedPartners {
        __typename
        ... on Partner {
          id
          url
          partnerUrl
          logo {
            url
          }
        }
      }
      __typename
      children {
        items {
          __typename
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAllCourseBySomeIdsQuery__
 *
 * To run a query within a React component, call `useAllCourseBySomeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCourseBySomeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCourseBySomeIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useAllCourseBySomeIdsQuery(baseOptions?: Apollo.QueryHookOptions<IAllCourseBySomeIdsQuery, IAllCourseBySomeIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllCourseBySomeIdsQuery, IAllCourseBySomeIdsQueryVariables>(AllCourseBySomeIdsDocument, options);
      }
export function useAllCourseBySomeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllCourseBySomeIdsQuery, IAllCourseBySomeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllCourseBySomeIdsQuery, IAllCourseBySomeIdsQueryVariables>(AllCourseBySomeIdsDocument, options);
        }
export type AllCourseBySomeIdsQueryHookResult = ReturnType<typeof useAllCourseBySomeIdsQuery>;
export type AllCourseBySomeIdsLazyQueryHookResult = ReturnType<typeof useAllCourseBySomeIdsLazyQuery>;
export type AllCourseBySomeIdsQueryResult = Apollo.QueryResult<IAllCourseBySomeIdsQuery, IAllCourseBySomeIdsQueryVariables>;
export const AllCourseCompletedDocument = gql`
    query AllCourseCompleted($id: ID, $imageFormat: ImageCropFormat) {
  memberDatas(id: $id) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "courseStatus"}) {
      items {
        id
        __typename
        ... on CourseStatus {
          finished
          course {
            __typename
            ... on Course {
              ...PartCourseFragment
            }
          }
        }
      }
    }
  }
}
    ${PartCourseFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}`;

/**
 * __useAllCourseCompletedQuery__
 *
 * To run a query within a React component, call `useAllCourseCompletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCourseCompletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCourseCompletedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllCourseCompletedQuery(baseOptions?: Apollo.QueryHookOptions<IAllCourseCompletedQuery, IAllCourseCompletedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllCourseCompletedQuery, IAllCourseCompletedQueryVariables>(AllCourseCompletedDocument, options);
      }
export function useAllCourseCompletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllCourseCompletedQuery, IAllCourseCompletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllCourseCompletedQuery, IAllCourseCompletedQueryVariables>(AllCourseCompletedDocument, options);
        }
export type AllCourseCompletedQueryHookResult = ReturnType<typeof useAllCourseCompletedQuery>;
export type AllCourseCompletedLazyQueryHookResult = ReturnType<typeof useAllCourseCompletedLazyQuery>;
export type AllCourseCompletedQueryResult = Apollo.QueryResult<IAllCourseCompletedQuery, IAllCourseCompletedQueryVariables>;
export const AllJobHubDocument = gql`
    query AllJobHub($culture: String, $imageFormat: ImageCropFormat) {
  allJobHub(culture: $culture) {
    items {
      ...JobHubFragment
    }
  }
}
    ${JobHubFragmentFragmentDoc}`;

/**
 * __useAllJobHubQuery__
 *
 * To run a query within a React component, call `useAllJobHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllJobHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllJobHubQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllJobHubQuery(baseOptions?: Apollo.QueryHookOptions<IAllJobHubQuery, IAllJobHubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllJobHubQuery, IAllJobHubQueryVariables>(AllJobHubDocument, options);
      }
export function useAllJobHubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllJobHubQuery, IAllJobHubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllJobHubQuery, IAllJobHubQueryVariables>(AllJobHubDocument, options);
        }
export type AllJobHubQueryHookResult = ReturnType<typeof useAllJobHubQuery>;
export type AllJobHubLazyQueryHookResult = ReturnType<typeof useAllJobHubLazyQuery>;
export type AllJobHubQueryResult = Apollo.QueryResult<IAllJobHubQuery, IAllJobHubQueryVariables>;
export const AllJobTrainingByCourseDocument = gql`
    query AllJobTrainingByCourse($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  allJobTraining(where: {courses_some: {id: $id}}, culture: $culture) {
    items {
      ... on JobTraining {
        title
        cover {
          content {
            ... on HeroVideoCover {
              ...HeroVideoCoverFragment
            }
          }
        }
        id
        url
        partners {
          ... on Partner {
            ...PartnerFragment
          }
        }
        length
        courses {
          id
          __typename
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}`;

/**
 * __useAllJobTrainingByCourseQuery__
 *
 * To run a query within a React component, call `useAllJobTrainingByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllJobTrainingByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllJobTrainingByCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllJobTrainingByCourseQuery(baseOptions?: Apollo.QueryHookOptions<IAllJobTrainingByCourseQuery, IAllJobTrainingByCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllJobTrainingByCourseQuery, IAllJobTrainingByCourseQueryVariables>(AllJobTrainingByCourseDocument, options);
      }
export function useAllJobTrainingByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllJobTrainingByCourseQuery, IAllJobTrainingByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllJobTrainingByCourseQuery, IAllJobTrainingByCourseQueryVariables>(AllJobTrainingByCourseDocument, options);
        }
export type AllJobTrainingByCourseQueryHookResult = ReturnType<typeof useAllJobTrainingByCourseQuery>;
export type AllJobTrainingByCourseLazyQueryHookResult = ReturnType<typeof useAllJobTrainingByCourseLazyQuery>;
export type AllJobTrainingByCourseQueryResult = Apollo.QueryResult<IAllJobTrainingByCourseQuery, IAllJobTrainingByCourseQueryVariables>;
export const JobTrainingByCourseDocument = gql`
    query JobTrainingByCourse($id: ID, $culture: String) {
  allJobTraining(where: {courses_some: {id: $id}}, culture: $culture, first: 1) {
    items {
      __typename
      ... on JobTraining {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useJobTrainingByCourseQuery__
 *
 * To run a query within a React component, call `useJobTrainingByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTrainingByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTrainingByCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useJobTrainingByCourseQuery(baseOptions?: Apollo.QueryHookOptions<IJobTrainingByCourseQuery, IJobTrainingByCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IJobTrainingByCourseQuery, IJobTrainingByCourseQueryVariables>(JobTrainingByCourseDocument, options);
      }
export function useJobTrainingByCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IJobTrainingByCourseQuery, IJobTrainingByCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IJobTrainingByCourseQuery, IJobTrainingByCourseQueryVariables>(JobTrainingByCourseDocument, options);
        }
export type JobTrainingByCourseQueryHookResult = ReturnType<typeof useJobTrainingByCourseQuery>;
export type JobTrainingByCourseLazyQueryHookResult = ReturnType<typeof useJobTrainingByCourseLazyQuery>;
export type JobTrainingByCourseQueryResult = Apollo.QueryResult<IJobTrainingByCourseQuery, IJobTrainingByCourseQueryVariables>;
export const AllJobTrainingBySomeCourseDocument = gql`
    query AllJobTrainingBySomeCourse($ids: [ID], $culture: String, $imageFormat: ImageCropFormat) {
  jobs: allJobTraining(where: {courses_some: {id_any: $ids}}, culture: $culture) {
    items {
      ... on JobTraining {
        title
        cover {
          content {
            ... on HeroVideoCover {
              ...HeroVideoCoverFragment
            }
          }
        }
        id
        url
        partners {
          ... on Partner {
            ...PartnerFragment
          }
        }
        length
        courses {
          id
          __typename
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}`;

/**
 * __useAllJobTrainingBySomeCourseQuery__
 *
 * To run a query within a React component, call `useAllJobTrainingBySomeCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllJobTrainingBySomeCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllJobTrainingBySomeCourseQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllJobTrainingBySomeCourseQuery(baseOptions?: Apollo.QueryHookOptions<IAllJobTrainingBySomeCourseQuery, IAllJobTrainingBySomeCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllJobTrainingBySomeCourseQuery, IAllJobTrainingBySomeCourseQueryVariables>(AllJobTrainingBySomeCourseDocument, options);
      }
export function useAllJobTrainingBySomeCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllJobTrainingBySomeCourseQuery, IAllJobTrainingBySomeCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllJobTrainingBySomeCourseQuery, IAllJobTrainingBySomeCourseQueryVariables>(AllJobTrainingBySomeCourseDocument, options);
        }
export type AllJobTrainingBySomeCourseQueryHookResult = ReturnType<typeof useAllJobTrainingBySomeCourseQuery>;
export type AllJobTrainingBySomeCourseLazyQueryHookResult = ReturnType<typeof useAllJobTrainingBySomeCourseLazyQuery>;
export type AllJobTrainingBySomeCourseQueryResult = Apollo.QueryResult<IAllJobTrainingBySomeCourseQuery, IAllJobTrainingBySomeCourseQueryVariables>;
export const AllJobTrainingBySomeIdsDocument = gql`
    query AllJobTrainingBySomeIds($ids: [ID], $culture: String, $imageFormat: ImageCropFormat) {
  allJobTraining(where: {id_any: $ids}, culture: $culture) {
    items {
      ... on JobTraining {
        title
        cover {
          content {
            ... on HeroVideoCover {
              ...HeroVideoCoverFragment
            }
          }
        }
        id
        url
        partners {
          ... on Partner {
            ...PartnerFragment
          }
        }
        length
        courses {
          id
          __typename
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}`;

/**
 * __useAllJobTrainingBySomeIdsQuery__
 *
 * To run a query within a React component, call `useAllJobTrainingBySomeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllJobTrainingBySomeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllJobTrainingBySomeIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllJobTrainingBySomeIdsQuery(baseOptions?: Apollo.QueryHookOptions<IAllJobTrainingBySomeIdsQuery, IAllJobTrainingBySomeIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllJobTrainingBySomeIdsQuery, IAllJobTrainingBySomeIdsQueryVariables>(AllJobTrainingBySomeIdsDocument, options);
      }
export function useAllJobTrainingBySomeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllJobTrainingBySomeIdsQuery, IAllJobTrainingBySomeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllJobTrainingBySomeIdsQuery, IAllJobTrainingBySomeIdsQueryVariables>(AllJobTrainingBySomeIdsDocument, options);
        }
export type AllJobTrainingBySomeIdsQueryHookResult = ReturnType<typeof useAllJobTrainingBySomeIdsQuery>;
export type AllJobTrainingBySomeIdsLazyQueryHookResult = ReturnType<typeof useAllJobTrainingBySomeIdsLazyQuery>;
export type AllJobTrainingBySomeIdsQueryResult = Apollo.QueryResult<IAllJobTrainingBySomeIdsQuery, IAllJobTrainingBySomeIdsQueryVariables>;
export const GetAllJobVacancyDocument = gql`
    query GetAllJobVacancy($culture: String, $orderBy: [JobVacancyOrderByInput], $imageFormat: ImageCropFormat) {
  allJobVacancy(culture: $culture, orderBy: $orderBy) {
    items {
      ...JobVacancyFragment
    }
  }
}
    ${JobVacancyFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}`;

/**
 * __useGetAllJobVacancyQuery__
 *
 * To run a query within a React component, call `useGetAllJobVacancyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllJobVacancyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllJobVacancyQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      orderBy: // value for 'orderBy'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetAllJobVacancyQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllJobVacancyQuery, IGetAllJobVacancyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllJobVacancyQuery, IGetAllJobVacancyQueryVariables>(GetAllJobVacancyDocument, options);
      }
export function useGetAllJobVacancyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllJobVacancyQuery, IGetAllJobVacancyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllJobVacancyQuery, IGetAllJobVacancyQueryVariables>(GetAllJobVacancyDocument, options);
        }
export type GetAllJobVacancyQueryHookResult = ReturnType<typeof useGetAllJobVacancyQuery>;
export type GetAllJobVacancyLazyQueryHookResult = ReturnType<typeof useGetAllJobVacancyLazyQuery>;
export type GetAllJobVacancyQueryResult = Apollo.QueryResult<IGetAllJobVacancyQuery, IGetAllJobVacancyQueryVariables>;
export const GetAllOpportunityDocument = gql`
    query GetAllOpportunity($culture: String, $orderBy: [OpportunityOrderByInput], $imageFormat: ImageCropFormat) {
  allOpportunity(culture: $culture, orderBy: $orderBy) {
    items {
      ...OpportunityFragment
    }
  }
}
    ${OpportunityFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${ContentTagFragmentFragmentDoc}`;

/**
 * __useGetAllOpportunityQuery__
 *
 * To run a query within a React component, call `useGetAllOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOpportunityQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      orderBy: // value for 'orderBy'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetAllOpportunityQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllOpportunityQuery, IGetAllOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllOpportunityQuery, IGetAllOpportunityQueryVariables>(GetAllOpportunityDocument, options);
      }
export function useGetAllOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllOpportunityQuery, IGetAllOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllOpportunityQuery, IGetAllOpportunityQueryVariables>(GetAllOpportunityDocument, options);
        }
export type GetAllOpportunityQueryHookResult = ReturnType<typeof useGetAllOpportunityQuery>;
export type GetAllOpportunityLazyQueryHookResult = ReturnType<typeof useGetAllOpportunityLazyQuery>;
export type GetAllOpportunityQueryResult = Apollo.QueryResult<IGetAllOpportunityQuery, IGetAllOpportunityQueryVariables>;
export const AllOpportunityByJobsDocument = gql`
    query AllOpportunityByJobs($id: [ID], $culture: String) {
  allOpportunity(where: {certificate_some: {id_any: $id}}, culture: $culture) {
    items {
      title
      shortDescription
      thumbnail {
        url
      }
      startDate
      id
      endDate
      __typename
      url
      partners {
        __typename
        id
        ... on Partner {
          logo {
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAllOpportunityByJobsQuery__
 *
 * To run a query within a React component, call `useAllOpportunityByJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOpportunityByJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOpportunityByJobsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useAllOpportunityByJobsQuery(baseOptions?: Apollo.QueryHookOptions<IAllOpportunityByJobsQuery, IAllOpportunityByJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllOpportunityByJobsQuery, IAllOpportunityByJobsQueryVariables>(AllOpportunityByJobsDocument, options);
      }
export function useAllOpportunityByJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllOpportunityByJobsQuery, IAllOpportunityByJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllOpportunityByJobsQuery, IAllOpportunityByJobsQueryVariables>(AllOpportunityByJobsDocument, options);
        }
export type AllOpportunityByJobsQueryHookResult = ReturnType<typeof useAllOpportunityByJobsQuery>;
export type AllOpportunityByJobsLazyQueryHookResult = ReturnType<typeof useAllOpportunityByJobsLazyQuery>;
export type AllOpportunityByJobsQueryResult = Apollo.QueryResult<IAllOpportunityByJobsQuery, IAllOpportunityByJobsQueryVariables>;
export const AllOpportunityByPartnerDocument = gql`
    query AllOpportunityByPartner($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  allOpportunity(where: {partners_some: {id: $id}}, culture: $culture) {
    items {
      ...OpportunityFragment
    }
  }
}
    ${OpportunityFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${ContentTagFragmentFragmentDoc}`;

/**
 * __useAllOpportunityByPartnerQuery__
 *
 * To run a query within a React component, call `useAllOpportunityByPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOpportunityByPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOpportunityByPartnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllOpportunityByPartnerQuery(baseOptions?: Apollo.QueryHookOptions<IAllOpportunityByPartnerQuery, IAllOpportunityByPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllOpportunityByPartnerQuery, IAllOpportunityByPartnerQueryVariables>(AllOpportunityByPartnerDocument, options);
      }
export function useAllOpportunityByPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllOpportunityByPartnerQuery, IAllOpportunityByPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllOpportunityByPartnerQuery, IAllOpportunityByPartnerQueryVariables>(AllOpportunityByPartnerDocument, options);
        }
export type AllOpportunityByPartnerQueryHookResult = ReturnType<typeof useAllOpportunityByPartnerQuery>;
export type AllOpportunityByPartnerLazyQueryHookResult = ReturnType<typeof useAllOpportunityByPartnerLazyQuery>;
export type AllOpportunityByPartnerQueryResult = Apollo.QueryResult<IAllOpportunityByPartnerQuery, IAllOpportunityByPartnerQueryVariables>;
export const AllOpportunityByIdDocument = gql`
    query AllOpportunityById($id: [ID], $culture: String) {
  allOpportunity(where: {id_any: $id}, culture: $culture) {
    items {
      title
      shortDescription
      thumbnail {
        url
      }
      startDate
      id
      endDate
      __typename
      url
      partners {
        __typename
        id
        ... on Partner {
          logo {
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAllOpportunityByIdQuery__
 *
 * To run a query within a React component, call `useAllOpportunityByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOpportunityByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOpportunityByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useAllOpportunityByIdQuery(baseOptions?: Apollo.QueryHookOptions<IAllOpportunityByIdQuery, IAllOpportunityByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllOpportunityByIdQuery, IAllOpportunityByIdQueryVariables>(AllOpportunityByIdDocument, options);
      }
export function useAllOpportunityByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllOpportunityByIdQuery, IAllOpportunityByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllOpportunityByIdQuery, IAllOpportunityByIdQueryVariables>(AllOpportunityByIdDocument, options);
        }
export type AllOpportunityByIdQueryHookResult = ReturnType<typeof useAllOpportunityByIdQuery>;
export type AllOpportunityByIdLazyQueryHookResult = ReturnType<typeof useAllOpportunityByIdLazyQuery>;
export type AllOpportunityByIdQueryResult = Apollo.QueryResult<IAllOpportunityByIdQuery, IAllOpportunityByIdQueryVariables>;
export const AllPartnerDocument = gql`
    query AllPartner($culture: String, $imageFormat: ImageCropFormat) {
  allPartner(first: 6, culture: $culture) {
    items {
      ...PartnerFragment
    }
  }
}
    ${PartnerFragmentFragmentDoc}`;

/**
 * __useAllPartnerQuery__
 *
 * To run a query within a React component, call `useAllPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPartnerQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllPartnerQuery(baseOptions?: Apollo.QueryHookOptions<IAllPartnerQuery, IAllPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllPartnerQuery, IAllPartnerQueryVariables>(AllPartnerDocument, options);
      }
export function useAllPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllPartnerQuery, IAllPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllPartnerQuery, IAllPartnerQueryVariables>(AllPartnerDocument, options);
        }
export type AllPartnerQueryHookResult = ReturnType<typeof useAllPartnerQuery>;
export type AllPartnerLazyQueryHookResult = ReturnType<typeof useAllPartnerLazyQuery>;
export type AllPartnerQueryResult = Apollo.QueryResult<IAllPartnerQuery, IAllPartnerQueryVariables>;
export const CountCourseUnitProgressionDocument = gql`
    query CountCourseUnitProgression($id: ID, $courseUnits: [String], $courseId: String) {
  memberDatas(id: $id) {
    id
    url
    __typename
    children(where: {name_any: $courseUnits}) {
      items {
        id
        __typename
        ... on UnitProgression {
          name
          finished
        }
      }
    }
  }
  courseStatus: memberDatas(id: $id) {
    id
    url
    __typename
    children(where: {name: $courseId}) {
      items {
        id
        __typename
        ... on CourseStatus {
          finished
          course {
            id
            __typename
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCountCourseUnitProgressionQuery__
 *
 * To run a query within a React component, call `useCountCourseUnitProgressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCourseUnitProgressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCourseUnitProgressionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      courseUnits: // value for 'courseUnits'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCountCourseUnitProgressionQuery(baseOptions?: Apollo.QueryHookOptions<ICountCourseUnitProgressionQuery, ICountCourseUnitProgressionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICountCourseUnitProgressionQuery, ICountCourseUnitProgressionQueryVariables>(CountCourseUnitProgressionDocument, options);
      }
export function useCountCourseUnitProgressionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICountCourseUnitProgressionQuery, ICountCourseUnitProgressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICountCourseUnitProgressionQuery, ICountCourseUnitProgressionQueryVariables>(CountCourseUnitProgressionDocument, options);
        }
export type CountCourseUnitProgressionQueryHookResult = ReturnType<typeof useCountCourseUnitProgressionQuery>;
export type CountCourseUnitProgressionLazyQueryHookResult = ReturnType<typeof useCountCourseUnitProgressionLazyQuery>;
export type CountCourseUnitProgressionQueryResult = Apollo.QueryResult<ICountCourseUnitProgressionQuery, ICountCourseUnitProgressionQueryVariables>;
export const CourseByUrlDocument = gql`
    query CourseByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  course(url: $url, culture: $culture) {
    ...CourseFragment
  }
}
    ${CourseFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useCourseByUrlQuery__
 *
 * To run a query within a React component, call `useCourseByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCourseByUrlQuery(baseOptions?: Apollo.QueryHookOptions<ICourseByUrlQuery, ICourseByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICourseByUrlQuery, ICourseByUrlQueryVariables>(CourseByUrlDocument, options);
      }
export function useCourseByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICourseByUrlQuery, ICourseByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICourseByUrlQuery, ICourseByUrlQueryVariables>(CourseByUrlDocument, options);
        }
export type CourseByUrlQueryHookResult = ReturnType<typeof useCourseByUrlQuery>;
export type CourseByUrlLazyQueryHookResult = ReturnType<typeof useCourseByUrlLazyQuery>;
export type CourseByUrlQueryResult = Apollo.QueryResult<ICourseByUrlQuery, ICourseByUrlQueryVariables>;
export const CourseByIdDocument = gql`
    query CourseById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  course(id: $id, culture: $culture) {
    ...CourseFragment
  }
}
    ${CourseFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useCourseByIdQuery__
 *
 * To run a query within a React component, call `useCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCourseByIdQuery(baseOptions?: Apollo.QueryHookOptions<ICourseByIdQuery, ICourseByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICourseByIdQuery, ICourseByIdQueryVariables>(CourseByIdDocument, options);
      }
export function useCourseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICourseByIdQuery, ICourseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICourseByIdQuery, ICourseByIdQueryVariables>(CourseByIdDocument, options);
        }
export type CourseByIdQueryHookResult = ReturnType<typeof useCourseByIdQuery>;
export type CourseByIdLazyQueryHookResult = ReturnType<typeof useCourseByIdLazyQuery>;
export type CourseByIdQueryResult = Apollo.QueryResult<ICourseByIdQuery, ICourseByIdQueryVariables>;
export const CourseByEndUrlDocument = gql`
    query CourseByEndUrl($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allCourse(culture: $culture, where: {url_ends_with: $endUrl}) {
    items {
      ...CourseFragment
    }
  }
}
    ${CourseFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useCourseByEndUrlQuery__
 *
 * To run a query within a React component, call `useCourseByEndUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByEndUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByEndUrlQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCourseByEndUrlQuery(baseOptions?: Apollo.QueryHookOptions<ICourseByEndUrlQuery, ICourseByEndUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICourseByEndUrlQuery, ICourseByEndUrlQueryVariables>(CourseByEndUrlDocument, options);
      }
export function useCourseByEndUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICourseByEndUrlQuery, ICourseByEndUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICourseByEndUrlQuery, ICourseByEndUrlQueryVariables>(CourseByEndUrlDocument, options);
        }
export type CourseByEndUrlQueryHookResult = ReturnType<typeof useCourseByEndUrlQuery>;
export type CourseByEndUrlLazyQueryHookResult = ReturnType<typeof useCourseByEndUrlLazyQuery>;
export type CourseByEndUrlQueryResult = Apollo.QueryResult<ICourseByEndUrlQuery, ICourseByEndUrlQueryVariables>;
export const CourseExamByIdDocument = gql`
    query CourseExamById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  courseExam(id: $id, culture: $culture) {
    ...CourseExamFragment
  }
}
    ${CourseExamFragmentFragmentDoc}
${ChoiceNuggetFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${UcVideoFragmentFragmentDoc}
${UcAudioFragmentFragmentDoc}
${ChoiceNuggerAnswerFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${GapfillNuggetFragmentFragmentDoc}
${SummaryNuggetFragmentFragmentDoc}
${CoursePageFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${NavMessageFragmentFragmentDoc}
${UcLineBreakFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useCourseExamByIdQuery__
 *
 * To run a query within a React component, call `useCourseExamByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseExamByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseExamByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCourseExamByIdQuery(baseOptions?: Apollo.QueryHookOptions<ICourseExamByIdQuery, ICourseExamByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICourseExamByIdQuery, ICourseExamByIdQueryVariables>(CourseExamByIdDocument, options);
      }
export function useCourseExamByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICourseExamByIdQuery, ICourseExamByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICourseExamByIdQuery, ICourseExamByIdQueryVariables>(CourseExamByIdDocument, options);
        }
export type CourseExamByIdQueryHookResult = ReturnType<typeof useCourseExamByIdQuery>;
export type CourseExamByIdLazyQueryHookResult = ReturnType<typeof useCourseExamByIdLazyQuery>;
export type CourseExamByIdQueryResult = Apollo.QueryResult<ICourseExamByIdQuery, ICourseExamByIdQueryVariables>;
export const CourseExamByUrlEndDocument = gql`
    query CourseExamByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allCourseExam(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      ...CourseExamFragment
    }
  }
}
    ${CourseExamFragmentFragmentDoc}
${ChoiceNuggetFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${UcVideoFragmentFragmentDoc}
${UcAudioFragmentFragmentDoc}
${ChoiceNuggerAnswerFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${GapfillNuggetFragmentFragmentDoc}
${SummaryNuggetFragmentFragmentDoc}
${CoursePageFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${NavMessageFragmentFragmentDoc}
${UcLineBreakFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useCourseExamByUrlEndQuery__
 *
 * To run a query within a React component, call `useCourseExamByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseExamByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseExamByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCourseExamByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<ICourseExamByUrlEndQuery, ICourseExamByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICourseExamByUrlEndQuery, ICourseExamByUrlEndQueryVariables>(CourseExamByUrlEndDocument, options);
      }
export function useCourseExamByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICourseExamByUrlEndQuery, ICourseExamByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICourseExamByUrlEndQuery, ICourseExamByUrlEndQueryVariables>(CourseExamByUrlEndDocument, options);
        }
export type CourseExamByUrlEndQueryHookResult = ReturnType<typeof useCourseExamByUrlEndQuery>;
export type CourseExamByUrlEndLazyQueryHookResult = ReturnType<typeof useCourseExamByUrlEndLazyQuery>;
export type CourseExamByUrlEndQueryResult = Apollo.QueryResult<ICourseExamByUrlEndQuery, ICourseExamByUrlEndQueryVariables>;
export const CourseOverviewByIdDocument = gql`
    query CourseOverviewById($id: ID, $culture: String) {
  course(id: $id, culture: $culture) {
    ...CourseOverviewFragment
  }
}
    ${CourseOverviewFragmentFragmentDoc}
${CourseUnitOverviewFragmentFragmentDoc}
${CoursePageOverviewFragmentFragmentDoc}
${CourseNuggetOverviewFragmentFragmentDoc}
${CourseExamOverviewFragmentFragmentDoc}`;

/**
 * __useCourseOverviewByIdQuery__
 *
 * To run a query within a React component, call `useCourseOverviewByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseOverviewByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseOverviewByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useCourseOverviewByIdQuery(baseOptions?: Apollo.QueryHookOptions<ICourseOverviewByIdQuery, ICourseOverviewByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICourseOverviewByIdQuery, ICourseOverviewByIdQueryVariables>(CourseOverviewByIdDocument, options);
      }
export function useCourseOverviewByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICourseOverviewByIdQuery, ICourseOverviewByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICourseOverviewByIdQuery, ICourseOverviewByIdQueryVariables>(CourseOverviewByIdDocument, options);
        }
export type CourseOverviewByIdQueryHookResult = ReturnType<typeof useCourseOverviewByIdQuery>;
export type CourseOverviewByIdLazyQueryHookResult = ReturnType<typeof useCourseOverviewByIdLazyQuery>;
export type CourseOverviewByIdQueryResult = Apollo.QueryResult<ICourseOverviewByIdQuery, ICourseOverviewByIdQueryVariables>;
export const CourseUnitByEndUrlDocument = gql`
    query CourseUnitByEndUrl($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allCourseUnit(where: {url_ends_with: $endUrl}, culture: $culture) {
    items {
      ...CourseUnitFragment
    }
  }
}
    ${CourseUnitFragmentFragmentDoc}
${CoursePageFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${NavMessageFragmentFragmentDoc}
${UcLineBreakFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${UcVideoFragmentFragmentDoc}
${UcAudioFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CourseNuggetFragmentFragmentDoc}
${ChoiceNuggetFragmentFragmentDoc}
${ChoiceNuggerAnswerFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${GapfillNuggetFragmentFragmentDoc}
${SummaryNuggetFragmentFragmentDoc}`;

/**
 * __useCourseUnitByEndUrlQuery__
 *
 * To run a query within a React component, call `useCourseUnitByEndUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseUnitByEndUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseUnitByEndUrlQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCourseUnitByEndUrlQuery(baseOptions?: Apollo.QueryHookOptions<ICourseUnitByEndUrlQuery, ICourseUnitByEndUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICourseUnitByEndUrlQuery, ICourseUnitByEndUrlQueryVariables>(CourseUnitByEndUrlDocument, options);
      }
export function useCourseUnitByEndUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICourseUnitByEndUrlQuery, ICourseUnitByEndUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICourseUnitByEndUrlQuery, ICourseUnitByEndUrlQueryVariables>(CourseUnitByEndUrlDocument, options);
        }
export type CourseUnitByEndUrlQueryHookResult = ReturnType<typeof useCourseUnitByEndUrlQuery>;
export type CourseUnitByEndUrlLazyQueryHookResult = ReturnType<typeof useCourseUnitByEndUrlLazyQuery>;
export type CourseUnitByEndUrlQueryResult = Apollo.QueryResult<ICourseUnitByEndUrlQuery, ICourseUnitByEndUrlQueryVariables>;
export const CourseByUnitIdDocument = gql`
    query CourseByUnitId($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  courseUnit(id: $id, culture: $culture) {
    ...CourseUnitFragment
  }
}
    ${CourseUnitFragmentFragmentDoc}
${CoursePageFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${NavMessageFragmentFragmentDoc}
${UcLineBreakFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${UcVideoFragmentFragmentDoc}
${UcAudioFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CourseNuggetFragmentFragmentDoc}
${ChoiceNuggetFragmentFragmentDoc}
${ChoiceNuggerAnswerFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${GapfillNuggetFragmentFragmentDoc}
${SummaryNuggetFragmentFragmentDoc}`;

/**
 * __useCourseByUnitIdQuery__
 *
 * To run a query within a React component, call `useCourseByUnitIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseByUnitIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseByUnitIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCourseByUnitIdQuery(baseOptions?: Apollo.QueryHookOptions<ICourseByUnitIdQuery, ICourseByUnitIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICourseByUnitIdQuery, ICourseByUnitIdQueryVariables>(CourseByUnitIdDocument, options);
      }
export function useCourseByUnitIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICourseByUnitIdQuery, ICourseByUnitIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICourseByUnitIdQuery, ICourseByUnitIdQueryVariables>(CourseByUnitIdDocument, options);
        }
export type CourseByUnitIdQueryHookResult = ReturnType<typeof useCourseByUnitIdQuery>;
export type CourseByUnitIdLazyQueryHookResult = ReturnType<typeof useCourseByUnitIdLazyQuery>;
export type CourseByUnitIdQueryResult = Apollo.QueryResult<ICourseByUnitIdQuery, ICourseByUnitIdQueryVariables>;
export const GetCourseDownloadDocument = gql`
    query GetCourseDownload($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  course(id: $id, culture: $culture) {
    ...DownloadCourseFragment
  }
}
    ${DownloadCourseFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${CourseUnitFragmentFragmentDoc}
${CoursePageFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${NavMessageFragmentFragmentDoc}
${UcLineBreakFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${UcVideoFragmentFragmentDoc}
${UcAudioFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CourseNuggetFragmentFragmentDoc}
${ChoiceNuggetFragmentFragmentDoc}
${ChoiceNuggerAnswerFragmentFragmentDoc}
${GapfillNuggetFragmentFragmentDoc}
${SummaryNuggetFragmentFragmentDoc}
${CourseExamFragmentFragmentDoc}`;

/**
 * __useGetCourseDownloadQuery__
 *
 * To run a query within a React component, call `useGetCourseDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseDownloadQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetCourseDownloadQuery(baseOptions?: Apollo.QueryHookOptions<IGetCourseDownloadQuery, IGetCourseDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCourseDownloadQuery, IGetCourseDownloadQueryVariables>(GetCourseDownloadDocument, options);
      }
export function useGetCourseDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCourseDownloadQuery, IGetCourseDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCourseDownloadQuery, IGetCourseDownloadQueryVariables>(GetCourseDownloadDocument, options);
        }
export type GetCourseDownloadQueryHookResult = ReturnType<typeof useGetCourseDownloadQuery>;
export type GetCourseDownloadLazyQueryHookResult = ReturnType<typeof useGetCourseDownloadLazyQuery>;
export type GetCourseDownloadQueryResult = Apollo.QueryResult<IGetCourseDownloadQuery, IGetCourseDownloadQueryVariables>;
export const GetJobDownloadDocument = gql`
    query GetJobDownload($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  jobTraining(id: $id, culture: $culture) {
    ...DownloadJobTrainingFragment
  }
}
    ${DownloadJobTrainingFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${DownloadCourseFragmentFragmentDoc}
${CourseUnitFragmentFragmentDoc}
${CoursePageFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${NavMessageFragmentFragmentDoc}
${UcLineBreakFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${UcVideoFragmentFragmentDoc}
${UcAudioFragmentFragmentDoc}
${CourseNuggetFragmentFragmentDoc}
${ChoiceNuggetFragmentFragmentDoc}
${ChoiceNuggerAnswerFragmentFragmentDoc}
${GapfillNuggetFragmentFragmentDoc}
${SummaryNuggetFragmentFragmentDoc}
${CourseExamFragmentFragmentDoc}`;

/**
 * __useGetJobDownloadQuery__
 *
 * To run a query within a React component, call `useGetJobDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobDownloadQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetJobDownloadQuery(baseOptions?: Apollo.QueryHookOptions<IGetJobDownloadQuery, IGetJobDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetJobDownloadQuery, IGetJobDownloadQueryVariables>(GetJobDownloadDocument, options);
      }
export function useGetJobDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetJobDownloadQuery, IGetJobDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetJobDownloadQuery, IGetJobDownloadQueryVariables>(GetJobDownloadDocument, options);
        }
export type GetJobDownloadQueryHookResult = ReturnType<typeof useGetJobDownloadQuery>;
export type GetJobDownloadLazyQueryHookResult = ReturnType<typeof useGetJobDownloadLazyQuery>;
export type GetJobDownloadQueryResult = Apollo.QueryResult<IGetJobDownloadQuery, IGetJobDownloadQueryVariables>;
export const EntrepreneurialHubByIdDocument = gql`
    query EntrepreneurialHubById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  entrepreunarialHub(id: $id, culture: $culture) {
    ...EntrepreunarialHubFragment
  }
}
    ${EntrepreunarialHubFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CardLinkFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useEntrepreneurialHubByIdQuery__
 *
 * To run a query within a React component, call `useEntrepreneurialHubByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntrepreneurialHubByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntrepreneurialHubByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useEntrepreneurialHubByIdQuery(baseOptions?: Apollo.QueryHookOptions<IEntrepreneurialHubByIdQuery, IEntrepreneurialHubByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IEntrepreneurialHubByIdQuery, IEntrepreneurialHubByIdQueryVariables>(EntrepreneurialHubByIdDocument, options);
      }
export function useEntrepreneurialHubByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEntrepreneurialHubByIdQuery, IEntrepreneurialHubByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IEntrepreneurialHubByIdQuery, IEntrepreneurialHubByIdQueryVariables>(EntrepreneurialHubByIdDocument, options);
        }
export type EntrepreneurialHubByIdQueryHookResult = ReturnType<typeof useEntrepreneurialHubByIdQuery>;
export type EntrepreneurialHubByIdLazyQueryHookResult = ReturnType<typeof useEntrepreneurialHubByIdLazyQuery>;
export type EntrepreneurialHubByIdQueryResult = Apollo.QueryResult<IEntrepreneurialHubByIdQuery, IEntrepreneurialHubByIdQueryVariables>;
export const EntrepreneurialHubByUrlEndDocument = gql`
    query EntrepreneurialHubByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allEntrepreunarialHub(
    where: {url_ends_with: $endUrl}
    culture: $culture
    first: 1
  ) {
    items {
      ...EntrepreunarialHubFragment
    }
  }
}
    ${EntrepreunarialHubFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CardLinkFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useEntrepreneurialHubByUrlEndQuery__
 *
 * To run a query within a React component, call `useEntrepreneurialHubByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntrepreneurialHubByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntrepreneurialHubByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useEntrepreneurialHubByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IEntrepreneurialHubByUrlEndQuery, IEntrepreneurialHubByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IEntrepreneurialHubByUrlEndQuery, IEntrepreneurialHubByUrlEndQueryVariables>(EntrepreneurialHubByUrlEndDocument, options);
      }
export function useEntrepreneurialHubByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IEntrepreneurialHubByUrlEndQuery, IEntrepreneurialHubByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IEntrepreneurialHubByUrlEndQuery, IEntrepreneurialHubByUrlEndQueryVariables>(EntrepreneurialHubByUrlEndDocument, options);
        }
export type EntrepreneurialHubByUrlEndQueryHookResult = ReturnType<typeof useEntrepreneurialHubByUrlEndQuery>;
export type EntrepreneurialHubByUrlEndLazyQueryHookResult = ReturnType<typeof useEntrepreneurialHubByUrlEndLazyQuery>;
export type EntrepreneurialHubByUrlEndQueryResult = Apollo.QueryResult<IEntrepreneurialHubByUrlEndQuery, IEntrepreneurialHubByUrlEndQueryVariables>;
export const GetExamOverviewDocument = gql`
    query GetExamOverview($culture: String, $imageFormat: ImageCropFormat) {
  allLearnMenu(first: 1, culture: $culture) {
    items {
      __typename
      ... on LearnMenu {
        pageContent
        cover {
          content {
            ... on HeroVideoCover {
              ...HeroVideoCoverFragment
            }
          }
        }
        subtitle
        positiveResult {
          content {
            __typename
            ... on Wysiwyg {
              ...WysiwygFragment
            }
          }
        }
        negativeResult {
          content {
            __typename
            ... on Wysiwyg {
              ...WysiwygFragment
            }
          }
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}`;

/**
 * __useGetExamOverviewQuery__
 *
 * To run a query within a React component, call `useGetExamOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamOverviewQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetExamOverviewQuery(baseOptions?: Apollo.QueryHookOptions<IGetExamOverviewQuery, IGetExamOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetExamOverviewQuery, IGetExamOverviewQueryVariables>(GetExamOverviewDocument, options);
      }
export function useGetExamOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetExamOverviewQuery, IGetExamOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetExamOverviewQuery, IGetExamOverviewQueryVariables>(GetExamOverviewDocument, options);
        }
export type GetExamOverviewQueryHookResult = ReturnType<typeof useGetExamOverviewQuery>;
export type GetExamOverviewLazyQueryHookResult = ReturnType<typeof useGetExamOverviewLazyQuery>;
export type GetExamOverviewQueryResult = Apollo.QueryResult<IGetExamOverviewQuery, IGetExamOverviewQueryVariables>;
export const GetExamResultDocument = gql`
    query GetExamResult($culture: String) {
  allLearnMenu(first: 1, culture: $culture) {
    items {
      __typename
      ... on LearnMenu {
        positiveResult {
          content {
            __typename
            ... on Wysiwyg {
              ...WysiwygFragment
            }
          }
        }
        negativeResult {
          content {
            __typename
            ... on Wysiwyg {
              ...WysiwygFragment
            }
          }
        }
      }
    }
  }
}
    ${WysiwygFragmentFragmentDoc}`;

/**
 * __useGetExamResultQuery__
 *
 * To run a query within a React component, call `useGetExamResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamResultQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useGetExamResultQuery(baseOptions?: Apollo.QueryHookOptions<IGetExamResultQuery, IGetExamResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetExamResultQuery, IGetExamResultQueryVariables>(GetExamResultDocument, options);
      }
export function useGetExamResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetExamResultQuery, IGetExamResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetExamResultQuery, IGetExamResultQueryVariables>(GetExamResultDocument, options);
        }
export type GetExamResultQueryHookResult = ReturnType<typeof useGetExamResultQuery>;
export type GetExamResultLazyQueryHookResult = ReturnType<typeof useGetExamResultLazyQuery>;
export type GetExamResultQueryResult = Apollo.QueryResult<IGetExamResultQuery, IGetExamResultQueryVariables>;
export const GetOpportunityCenterDocument = gql`
    query GetOpportunityCenter($id: ID, $culture: String) {
  opportunityCenter(id: $id, culture: $culture) {
    id
    __typename
    url
    opportunityTitle
    opportunitySubtitle
  }
}
    `;

/**
 * __useGetOpportunityCenterQuery__
 *
 * To run a query within a React component, call `useGetOpportunityCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityCenterQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useGetOpportunityCenterQuery(baseOptions?: Apollo.QueryHookOptions<IGetOpportunityCenterQuery, IGetOpportunityCenterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetOpportunityCenterQuery, IGetOpportunityCenterQueryVariables>(GetOpportunityCenterDocument, options);
      }
export function useGetOpportunityCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetOpportunityCenterQuery, IGetOpportunityCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetOpportunityCenterQuery, IGetOpportunityCenterQueryVariables>(GetOpportunityCenterDocument, options);
        }
export type GetOpportunityCenterQueryHookResult = ReturnType<typeof useGetOpportunityCenterQuery>;
export type GetOpportunityCenterLazyQueryHookResult = ReturnType<typeof useGetOpportunityCenterLazyQuery>;
export type GetOpportunityCenterQueryResult = Apollo.QueryResult<IGetOpportunityCenterQuery, IGetOpportunityCenterQueryVariables>;
export const GetOpportunityCenterByUrlEndDocument = gql`
    query GetOpportunityCenterByUrlEnd($urlEnd: String, $culture: String) {
  allOpportunityCenter(where: {url_ends_with: $urlEnd}, culture: $culture) {
    items {
      id
      __typename
      url
      opportunityTitle
      opportunitySubtitle
    }
  }
}
    `;

/**
 * __useGetOpportunityCenterByUrlEndQuery__
 *
 * To run a query within a React component, call `useGetOpportunityCenterByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityCenterByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityCenterByUrlEndQuery({
 *   variables: {
 *      urlEnd: // value for 'urlEnd'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useGetOpportunityCenterByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IGetOpportunityCenterByUrlEndQuery, IGetOpportunityCenterByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetOpportunityCenterByUrlEndQuery, IGetOpportunityCenterByUrlEndQueryVariables>(GetOpportunityCenterByUrlEndDocument, options);
      }
export function useGetOpportunityCenterByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetOpportunityCenterByUrlEndQuery, IGetOpportunityCenterByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetOpportunityCenterByUrlEndQuery, IGetOpportunityCenterByUrlEndQueryVariables>(GetOpportunityCenterByUrlEndDocument, options);
        }
export type GetOpportunityCenterByUrlEndQueryHookResult = ReturnType<typeof useGetOpportunityCenterByUrlEndQuery>;
export type GetOpportunityCenterByUrlEndLazyQueryHookResult = ReturnType<typeof useGetOpportunityCenterByUrlEndLazyQuery>;
export type GetOpportunityCenterByUrlEndQueryResult = Apollo.QueryResult<IGetOpportunityCenterByUrlEndQuery, IGetOpportunityCenterByUrlEndQueryVariables>;
export const JobBoardPageByIdDocument = gql`
    query JobBoardPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  jobBoardPage(id: $id, culture: $culture) {
    ...JobBoardPageFragment
  }
}
    ${JobBoardPageFragmentFragmentDoc}
${HeroSlideFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${JobHubFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${LinkPickerFragmentFragmentDoc}
${ExpandMenuFragmentFragmentDoc}`;

/**
 * __useJobBoardPageByIdQuery__
 *
 * To run a query within a React component, call `useJobBoardPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobBoardPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobBoardPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useJobBoardPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<IJobBoardPageByIdQuery, IJobBoardPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IJobBoardPageByIdQuery, IJobBoardPageByIdQueryVariables>(JobBoardPageByIdDocument, options);
      }
export function useJobBoardPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IJobBoardPageByIdQuery, IJobBoardPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IJobBoardPageByIdQuery, IJobBoardPageByIdQueryVariables>(JobBoardPageByIdDocument, options);
        }
export type JobBoardPageByIdQueryHookResult = ReturnType<typeof useJobBoardPageByIdQuery>;
export type JobBoardPageByIdLazyQueryHookResult = ReturnType<typeof useJobBoardPageByIdLazyQuery>;
export type JobBoardPageByIdQueryResult = Apollo.QueryResult<IJobBoardPageByIdQuery, IJobBoardPageByIdQueryVariables>;
export const JobBoardPageByUrlEndDocument = gql`
    query JobBoardPageByUrlEnd($urlEnd: String, $culture: String, $imageFormat: ImageCropFormat) {
  allJobBoardPage(where: {url_ends_with: $urlEnd}, culture: $culture) {
    items {
      ...JobBoardPageFragment
    }
  }
}
    ${JobBoardPageFragmentFragmentDoc}
${HeroSlideFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${JobHubFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${LinkPickerFragmentFragmentDoc}
${ExpandMenuFragmentFragmentDoc}`;

/**
 * __useJobBoardPageByUrlEndQuery__
 *
 * To run a query within a React component, call `useJobBoardPageByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobBoardPageByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobBoardPageByUrlEndQuery({
 *   variables: {
 *      urlEnd: // value for 'urlEnd'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useJobBoardPageByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IJobBoardPageByUrlEndQuery, IJobBoardPageByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IJobBoardPageByUrlEndQuery, IJobBoardPageByUrlEndQueryVariables>(JobBoardPageByUrlEndDocument, options);
      }
export function useJobBoardPageByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IJobBoardPageByUrlEndQuery, IJobBoardPageByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IJobBoardPageByUrlEndQuery, IJobBoardPageByUrlEndQueryVariables>(JobBoardPageByUrlEndDocument, options);
        }
export type JobBoardPageByUrlEndQueryHookResult = ReturnType<typeof useJobBoardPageByUrlEndQuery>;
export type JobBoardPageByUrlEndLazyQueryHookResult = ReturnType<typeof useJobBoardPageByUrlEndLazyQuery>;
export type JobBoardPageByUrlEndQueryResult = Apollo.QueryResult<IJobBoardPageByUrlEndQuery, IJobBoardPageByUrlEndQueryVariables>;
export const JobTrainingByIdDocument = gql`
    query JobTrainingById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  jobTraining(id: $id, culture: $culture) {
    ...JobTrainingFragment
  }
}
    ${JobTrainingFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}`;

/**
 * __useJobTrainingByIdQuery__
 *
 * To run a query within a React component, call `useJobTrainingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTrainingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTrainingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useJobTrainingByIdQuery(baseOptions?: Apollo.QueryHookOptions<IJobTrainingByIdQuery, IJobTrainingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IJobTrainingByIdQuery, IJobTrainingByIdQueryVariables>(JobTrainingByIdDocument, options);
      }
export function useJobTrainingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IJobTrainingByIdQuery, IJobTrainingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IJobTrainingByIdQuery, IJobTrainingByIdQueryVariables>(JobTrainingByIdDocument, options);
        }
export type JobTrainingByIdQueryHookResult = ReturnType<typeof useJobTrainingByIdQuery>;
export type JobTrainingByIdLazyQueryHookResult = ReturnType<typeof useJobTrainingByIdLazyQuery>;
export type JobTrainingByIdQueryResult = Apollo.QueryResult<IJobTrainingByIdQuery, IJobTrainingByIdQueryVariables>;
export const JobTrainingByUrlEndDocument = gql`
    query JobTrainingByUrlEnd($urlEnd: String, $culture: String, $imageFormat: ImageCropFormat) {
  allJobTraining(where: {url_ends_with: $urlEnd}, culture: $culture, first: 1) {
    items {
      ...JobTrainingFragment
    }
  }
}
    ${JobTrainingFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}`;

/**
 * __useJobTrainingByUrlEndQuery__
 *
 * To run a query within a React component, call `useJobTrainingByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTrainingByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTrainingByUrlEndQuery({
 *   variables: {
 *      urlEnd: // value for 'urlEnd'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useJobTrainingByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IJobTrainingByUrlEndQuery, IJobTrainingByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IJobTrainingByUrlEndQuery, IJobTrainingByUrlEndQueryVariables>(JobTrainingByUrlEndDocument, options);
      }
export function useJobTrainingByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IJobTrainingByUrlEndQuery, IJobTrainingByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IJobTrainingByUrlEndQuery, IJobTrainingByUrlEndQueryVariables>(JobTrainingByUrlEndDocument, options);
        }
export type JobTrainingByUrlEndQueryHookResult = ReturnType<typeof useJobTrainingByUrlEndQuery>;
export type JobTrainingByUrlEndLazyQueryHookResult = ReturnType<typeof useJobTrainingByUrlEndLazyQuery>;
export type JobTrainingByUrlEndQueryResult = Apollo.QueryResult<IJobTrainingByUrlEndQuery, IJobTrainingByUrlEndQueryVariables>;
export const JobTrainingOverviewByIdDocument = gql`
    query JobTrainingOverviewById($id: ID, $culture: String) {
  jobTraining(id: $id, culture: $culture) {
    ...JobTrainingOverviewFragment
  }
}
    ${JobTrainingOverviewFragmentFragmentDoc}
${CourseOverviewFragmentFragmentDoc}
${CourseUnitOverviewFragmentFragmentDoc}
${CoursePageOverviewFragmentFragmentDoc}
${CourseNuggetOverviewFragmentFragmentDoc}
${CourseExamOverviewFragmentFragmentDoc}`;

/**
 * __useJobTrainingOverviewByIdQuery__
 *
 * To run a query within a React component, call `useJobTrainingOverviewByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTrainingOverviewByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTrainingOverviewByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useJobTrainingOverviewByIdQuery(baseOptions?: Apollo.QueryHookOptions<IJobTrainingOverviewByIdQuery, IJobTrainingOverviewByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IJobTrainingOverviewByIdQuery, IJobTrainingOverviewByIdQueryVariables>(JobTrainingOverviewByIdDocument, options);
      }
export function useJobTrainingOverviewByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IJobTrainingOverviewByIdQuery, IJobTrainingOverviewByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IJobTrainingOverviewByIdQuery, IJobTrainingOverviewByIdQueryVariables>(JobTrainingOverviewByIdDocument, options);
        }
export type JobTrainingOverviewByIdQueryHookResult = ReturnType<typeof useJobTrainingOverviewByIdQuery>;
export type JobTrainingOverviewByIdLazyQueryHookResult = ReturnType<typeof useJobTrainingOverviewByIdLazyQuery>;
export type JobTrainingOverviewByIdQueryResult = Apollo.QueryResult<IJobTrainingOverviewByIdQuery, IJobTrainingOverviewByIdQueryVariables>;
export const JobTrainingOverviewByUrlEndDocument = gql`
    query JobTrainingOverviewByUrlEnd($urlEnd: String, $culture: String) {
  allJobTraining(where: {url_ends_with: $urlEnd}, culture: $culture, first: 1) {
    items {
      ...JobTrainingOverviewFragment
    }
  }
}
    ${JobTrainingOverviewFragmentFragmentDoc}
${CourseOverviewFragmentFragmentDoc}
${CourseUnitOverviewFragmentFragmentDoc}
${CoursePageOverviewFragmentFragmentDoc}
${CourseNuggetOverviewFragmentFragmentDoc}
${CourseExamOverviewFragmentFragmentDoc}`;

/**
 * __useJobTrainingOverviewByUrlEndQuery__
 *
 * To run a query within a React component, call `useJobTrainingOverviewByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTrainingOverviewByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTrainingOverviewByUrlEndQuery({
 *   variables: {
 *      urlEnd: // value for 'urlEnd'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useJobTrainingOverviewByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IJobTrainingOverviewByUrlEndQuery, IJobTrainingOverviewByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IJobTrainingOverviewByUrlEndQuery, IJobTrainingOverviewByUrlEndQueryVariables>(JobTrainingOverviewByUrlEndDocument, options);
      }
export function useJobTrainingOverviewByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IJobTrainingOverviewByUrlEndQuery, IJobTrainingOverviewByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IJobTrainingOverviewByUrlEndQuery, IJobTrainingOverviewByUrlEndQueryVariables>(JobTrainingOverviewByUrlEndDocument, options);
        }
export type JobTrainingOverviewByUrlEndQueryHookResult = ReturnType<typeof useJobTrainingOverviewByUrlEndQuery>;
export type JobTrainingOverviewByUrlEndLazyQueryHookResult = ReturnType<typeof useJobTrainingOverviewByUrlEndLazyQuery>;
export type JobTrainingOverviewByUrlEndQueryResult = Apollo.QueryResult<IJobTrainingOverviewByUrlEndQuery, IJobTrainingOverviewByUrlEndQueryVariables>;
export const OpportunityByIdDocument = gql`
    query OpportunityById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  opportunity(id: $id, culture: $culture) {
    ...OpportunityFragment
  }
}
    ${OpportunityFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${ContentTagFragmentFragmentDoc}`;

/**
 * __useOpportunityByIdQuery__
 *
 * To run a query within a React component, call `useOpportunityByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useOpportunityByIdQuery(baseOptions?: Apollo.QueryHookOptions<IOpportunityByIdQuery, IOpportunityByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOpportunityByIdQuery, IOpportunityByIdQueryVariables>(OpportunityByIdDocument, options);
      }
export function useOpportunityByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOpportunityByIdQuery, IOpportunityByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOpportunityByIdQuery, IOpportunityByIdQueryVariables>(OpportunityByIdDocument, options);
        }
export type OpportunityByIdQueryHookResult = ReturnType<typeof useOpportunityByIdQuery>;
export type OpportunityByIdLazyQueryHookResult = ReturnType<typeof useOpportunityByIdLazyQuery>;
export type OpportunityByIdQueryResult = Apollo.QueryResult<IOpportunityByIdQuery, IOpportunityByIdQueryVariables>;
export const OpportunityByUrlEndDocument = gql`
    query OpportunityByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allOpportunity(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      ...OpportunityFragment
    }
  }
}
    ${OpportunityFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${ContentTagFragmentFragmentDoc}`;

/**
 * __useOpportunityByUrlEndQuery__
 *
 * To run a query within a React component, call `useOpportunityByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useOpportunityByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IOpportunityByUrlEndQuery, IOpportunityByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOpportunityByUrlEndQuery, IOpportunityByUrlEndQueryVariables>(OpportunityByUrlEndDocument, options);
      }
export function useOpportunityByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOpportunityByUrlEndQuery, IOpportunityByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOpportunityByUrlEndQuery, IOpportunityByUrlEndQueryVariables>(OpportunityByUrlEndDocument, options);
        }
export type OpportunityByUrlEndQueryHookResult = ReturnType<typeof useOpportunityByUrlEndQuery>;
export type OpportunityByUrlEndLazyQueryHookResult = ReturnType<typeof useOpportunityByUrlEndLazyQuery>;
export type OpportunityByUrlEndQueryResult = Apollo.QueryResult<IOpportunityByUrlEndQuery, IOpportunityByUrlEndQueryVariables>;
export const PartnerByIdDocument = gql`
    query PartnerById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  partner(id: $id, culture: $culture) {
    ...PartnerFragment
  }
}
    ${PartnerFragmentFragmentDoc}`;

/**
 * __usePartnerByIdQuery__
 *
 * To run a query within a React component, call `usePartnerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePartnerByIdQuery(baseOptions?: Apollo.QueryHookOptions<IPartnerByIdQuery, IPartnerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPartnerByIdQuery, IPartnerByIdQueryVariables>(PartnerByIdDocument, options);
      }
export function usePartnerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPartnerByIdQuery, IPartnerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPartnerByIdQuery, IPartnerByIdQueryVariables>(PartnerByIdDocument, options);
        }
export type PartnerByIdQueryHookResult = ReturnType<typeof usePartnerByIdQuery>;
export type PartnerByIdLazyQueryHookResult = ReturnType<typeof usePartnerByIdLazyQuery>;
export type PartnerByIdQueryResult = Apollo.QueryResult<IPartnerByIdQuery, IPartnerByIdQueryVariables>;
export const PartnerByUrlDocument = gql`
    query PartnerByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  partner(url: $url, culture: $culture) {
    ...PartnerFragment
  }
}
    ${PartnerFragmentFragmentDoc}`;

/**
 * __usePartnerByUrlQuery__
 *
 * To run a query within a React component, call `usePartnerByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePartnerByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IPartnerByUrlQuery, IPartnerByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPartnerByUrlQuery, IPartnerByUrlQueryVariables>(PartnerByUrlDocument, options);
      }
export function usePartnerByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPartnerByUrlQuery, IPartnerByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPartnerByUrlQuery, IPartnerByUrlQueryVariables>(PartnerByUrlDocument, options);
        }
export type PartnerByUrlQueryHookResult = ReturnType<typeof usePartnerByUrlQuery>;
export type PartnerByUrlLazyQueryHookResult = ReturnType<typeof usePartnerByUrlLazyQuery>;
export type PartnerByUrlQueryResult = Apollo.QueryResult<IPartnerByUrlQuery, IPartnerByUrlQueryVariables>;
export const PartnerByUrlEndDocument = gql`
    query PartnerByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allPartner(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      ...PartnerFragment
    }
  }
}
    ${PartnerFragmentFragmentDoc}`;

/**
 * __usePartnerByUrlEndQuery__
 *
 * To run a query within a React component, call `usePartnerByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePartnerByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IPartnerByUrlEndQuery, IPartnerByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPartnerByUrlEndQuery, IPartnerByUrlEndQueryVariables>(PartnerByUrlEndDocument, options);
      }
export function usePartnerByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPartnerByUrlEndQuery, IPartnerByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPartnerByUrlEndQuery, IPartnerByUrlEndQueryVariables>(PartnerByUrlEndDocument, options);
        }
export type PartnerByUrlEndQueryHookResult = ReturnType<typeof usePartnerByUrlEndQuery>;
export type PartnerByUrlEndLazyQueryHookResult = ReturnType<typeof usePartnerByUrlEndLazyQuery>;
export type PartnerByUrlEndQueryResult = Apollo.QueryResult<IPartnerByUrlEndQuery, IPartnerByUrlEndQueryVariables>;
export const PartnerRelatedContentDocument = gql`
    query PartnerRelatedContent($id: ID, $culture: String, $first: Int = 10, $imageFormat: ImageCropFormat) {
  partner(id: $id, culture: $culture) {
    __typename
    parent {
      __typename
      id
      ... on Partners {
        children(first: $first) {
          items {
            __typename
            ... on Partner {
              ...PartnerFragment
            }
          }
        }
      }
    }
  }
}
    ${PartnerFragmentFragmentDoc}`;

/**
 * __usePartnerRelatedContentQuery__
 *
 * To run a query within a React component, call `usePartnerRelatedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerRelatedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerRelatedContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      first: // value for 'first'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePartnerRelatedContentQuery(baseOptions?: Apollo.QueryHookOptions<IPartnerRelatedContentQuery, IPartnerRelatedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPartnerRelatedContentQuery, IPartnerRelatedContentQueryVariables>(PartnerRelatedContentDocument, options);
      }
export function usePartnerRelatedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPartnerRelatedContentQuery, IPartnerRelatedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPartnerRelatedContentQuery, IPartnerRelatedContentQueryVariables>(PartnerRelatedContentDocument, options);
        }
export type PartnerRelatedContentQueryHookResult = ReturnType<typeof usePartnerRelatedContentQuery>;
export type PartnerRelatedContentLazyQueryHookResult = ReturnType<typeof usePartnerRelatedContentLazyQuery>;
export type PartnerRelatedContentQueryResult = Apollo.QueryResult<IPartnerRelatedContentQuery, IPartnerRelatedContentQueryVariables>;
export const PartnersPageByIdDocument = gql`
    query PartnersPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  partnersPage(id: $id, culture: $culture) {
    __typename
    ... on PartnersPage {
      ...PartnersPageFragment
    }
  }
}
    ${PartnersPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}`;

/**
 * __usePartnersPageByIdQuery__
 *
 * To run a query within a React component, call `usePartnersPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnersPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnersPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePartnersPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<IPartnersPageByIdQuery, IPartnersPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPartnersPageByIdQuery, IPartnersPageByIdQueryVariables>(PartnersPageByIdDocument, options);
      }
export function usePartnersPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPartnersPageByIdQuery, IPartnersPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPartnersPageByIdQuery, IPartnersPageByIdQueryVariables>(PartnersPageByIdDocument, options);
        }
export type PartnersPageByIdQueryHookResult = ReturnType<typeof usePartnersPageByIdQuery>;
export type PartnersPageByIdLazyQueryHookResult = ReturnType<typeof usePartnersPageByIdLazyQuery>;
export type PartnersPageByIdQueryResult = Apollo.QueryResult<IPartnersPageByIdQuery, IPartnersPageByIdQueryVariables>;
export const AllCourseByPersonalityDocument = gql`
    query AllCourseByPersonality($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  allCourse(
    where: {linkedPersonalities_some: {id: $id}}
    first: 6
    culture: $culture
  ) {
    items {
      __typename
      id
      url
      name
      title
      trailer
      thumbnail {
        url
      }
      description
      linkedPartners {
        __typename
        ... on Partner {
          ...PartnerFragment
        }
      }
    }
  }
}
    ${PartnerFragmentFragmentDoc}`;

/**
 * __useAllCourseByPersonalityQuery__
 *
 * To run a query within a React component, call `useAllCourseByPersonalityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCourseByPersonalityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCourseByPersonalityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllCourseByPersonalityQuery(baseOptions?: Apollo.QueryHookOptions<IAllCourseByPersonalityQuery, IAllCourseByPersonalityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllCourseByPersonalityQuery, IAllCourseByPersonalityQueryVariables>(AllCourseByPersonalityDocument, options);
      }
export function useAllCourseByPersonalityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllCourseByPersonalityQuery, IAllCourseByPersonalityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllCourseByPersonalityQuery, IAllCourseByPersonalityQueryVariables>(AllCourseByPersonalityDocument, options);
        }
export type AllCourseByPersonalityQueryHookResult = ReturnType<typeof useAllCourseByPersonalityQuery>;
export type AllCourseByPersonalityLazyQueryHookResult = ReturnType<typeof useAllCourseByPersonalityLazyQuery>;
export type AllCourseByPersonalityQueryResult = Apollo.QueryResult<IAllCourseByPersonalityQuery, IAllCourseByPersonalityQueryVariables>;
export const GetAllPersonalityPagesByIdDocument = gql`
    query GetAllPersonalityPagesById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizPage(id: $id, culture: $culture) {
    id
    __typename
    url
    personalitiesTitle
    personalitiesSubtitle
    personalitiesCover {
      content {
        ... on HeroVideoCover {
          ...HeroVideoCoverFragment
        }
      }
    }
    personalitiesCTALabel
    quizz {
      id
      __typename
      ... on PersonalityQuiz1 {
        children {
          items {
            __typename
            ... on PersonalityPages {
              __typename
              id
              url
              icon {
                url
              }
              title
              subtitle
              introduction
            }
          }
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useGetAllPersonalityPagesByIdQuery__
 *
 * To run a query within a React component, call `useGetAllPersonalityPagesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPersonalityPagesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPersonalityPagesByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetAllPersonalityPagesByIdQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllPersonalityPagesByIdQuery, IGetAllPersonalityPagesByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllPersonalityPagesByIdQuery, IGetAllPersonalityPagesByIdQueryVariables>(GetAllPersonalityPagesByIdDocument, options);
      }
export function useGetAllPersonalityPagesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllPersonalityPagesByIdQuery, IGetAllPersonalityPagesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllPersonalityPagesByIdQuery, IGetAllPersonalityPagesByIdQueryVariables>(GetAllPersonalityPagesByIdDocument, options);
        }
export type GetAllPersonalityPagesByIdQueryHookResult = ReturnType<typeof useGetAllPersonalityPagesByIdQuery>;
export type GetAllPersonalityPagesByIdLazyQueryHookResult = ReturnType<typeof useGetAllPersonalityPagesByIdLazyQuery>;
export type GetAllPersonalityPagesByIdQueryResult = Apollo.QueryResult<IGetAllPersonalityPagesByIdQuery, IGetAllPersonalityPagesByIdQueryVariables>;
export const GetAllPersonalityPagesByUrlEndDocument = gql`
    query GetAllPersonalityPagesByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allQuizPage(where: {url_ends_with: $endUrl}, culture: $culture) {
    items {
      id
      __typename
      url
      personalitiesTitle
      personalitiesSubtitle
      personalitiesCover {
        content {
          ... on HeroVideoCover {
            ...HeroVideoCoverFragment
          }
        }
      }
      personalitiesCTALabel
      quizz {
        id
        __typename
        ... on PersonalityQuiz1 {
          children {
            items {
              __typename
              ... on PersonalityPages {
                __typename
                id
                url
                icon {
                  url
                }
                title
                subtitle
                introduction
              }
            }
          }
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useGetAllPersonalityPagesByUrlEndQuery__
 *
 * To run a query within a React component, call `useGetAllPersonalityPagesByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPersonalityPagesByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPersonalityPagesByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetAllPersonalityPagesByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllPersonalityPagesByUrlEndQuery, IGetAllPersonalityPagesByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllPersonalityPagesByUrlEndQuery, IGetAllPersonalityPagesByUrlEndQueryVariables>(GetAllPersonalityPagesByUrlEndDocument, options);
      }
export function useGetAllPersonalityPagesByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllPersonalityPagesByUrlEndQuery, IGetAllPersonalityPagesByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllPersonalityPagesByUrlEndQuery, IGetAllPersonalityPagesByUrlEndQueryVariables>(GetAllPersonalityPagesByUrlEndDocument, options);
        }
export type GetAllPersonalityPagesByUrlEndQueryHookResult = ReturnType<typeof useGetAllPersonalityPagesByUrlEndQuery>;
export type GetAllPersonalityPagesByUrlEndLazyQueryHookResult = ReturnType<typeof useGetAllPersonalityPagesByUrlEndLazyQuery>;
export type GetAllPersonalityPagesByUrlEndQueryResult = Apollo.QueryResult<IGetAllPersonalityPagesByUrlEndQuery, IGetAllPersonalityPagesByUrlEndQueryVariables>;
export const GetPersonalityByIdDocument = gql`
    query GetPersonalityById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  personalityQuiz(id: $id, culture: $culture) {
    id
    __typename
    url
    personalitiesTitle
    personalitiesSubtitle
    personalitiesCover {
      content {
        ... on HeroVideoCover {
          ...HeroVideoCoverFragment
        }
      }
    }
    personalitiesCTALabel
    children {
      items {
        ... on PersonalityPages {
          __typename
          id
          url
          icon {
            url
          }
          title
          subtitle
          introduction
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useGetPersonalityByIdQuery__
 *
 * To run a query within a React component, call `useGetPersonalityByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalityByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalityByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetPersonalityByIdQuery(baseOptions?: Apollo.QueryHookOptions<IGetPersonalityByIdQuery, IGetPersonalityByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPersonalityByIdQuery, IGetPersonalityByIdQueryVariables>(GetPersonalityByIdDocument, options);
      }
export function useGetPersonalityByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPersonalityByIdQuery, IGetPersonalityByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPersonalityByIdQuery, IGetPersonalityByIdQueryVariables>(GetPersonalityByIdDocument, options);
        }
export type GetPersonalityByIdQueryHookResult = ReturnType<typeof useGetPersonalityByIdQuery>;
export type GetPersonalityByIdLazyQueryHookResult = ReturnType<typeof useGetPersonalityByIdLazyQuery>;
export type GetPersonalityByIdQueryResult = Apollo.QueryResult<IGetPersonalityByIdQuery, IGetPersonalityByIdQueryVariables>;
export const GetPersonalityPageDocument = gql`
    query GetPersonalityPage($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  personalityPages(id: $id, culture: $culture) {
    ...PersonalityPagesFragment
    parent {
      __typename
      id
      ... on PersonalityQuiz1 {
        children(first: 3) {
          items {
            ... on PersonalityPages {
              __typename
              id
              url
              icon {
                url
              }
              title
              subtitle
              introduction
            }
          }
        }
      }
    }
  }
}
    ${PersonalityPagesFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}`;

/**
 * __useGetPersonalityPageQuery__
 *
 * To run a query within a React component, call `useGetPersonalityPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalityPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalityPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetPersonalityPageQuery(baseOptions?: Apollo.QueryHookOptions<IGetPersonalityPageQuery, IGetPersonalityPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPersonalityPageQuery, IGetPersonalityPageQueryVariables>(GetPersonalityPageDocument, options);
      }
export function useGetPersonalityPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPersonalityPageQuery, IGetPersonalityPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPersonalityPageQuery, IGetPersonalityPageQueryVariables>(GetPersonalityPageDocument, options);
        }
export type GetPersonalityPageQueryHookResult = ReturnType<typeof useGetPersonalityPageQuery>;
export type GetPersonalityPageLazyQueryHookResult = ReturnType<typeof useGetPersonalityPageLazyQuery>;
export type GetPersonalityPageQueryResult = Apollo.QueryResult<IGetPersonalityPageQuery, IGetPersonalityPageQueryVariables>;
export const GetPersonalityQuizResultDocument = gql`
    query GetPersonalityQuizResult($id: [ID], $quizId: ID, $culture: String, $imageFormat: ImageCropFormat) {
  personalityQuiz(id: $quizId, culture: $culture) {
    id
    __typename
    url
    name
    resultTitle
    resultSubtitle
  }
  allPersonalityPages(where: {id_any: $id}, culture: $culture) {
    items {
      __typename
      ... on PersonalityPages {
        __typename
        id
        url
        icon {
          url
        }
        title
        subtitle
        introduction
      }
    }
  }
}
    `;

/**
 * __useGetPersonalityQuizResultQuery__
 *
 * To run a query within a React component, call `useGetPersonalityQuizResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalityQuizResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalityQuizResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *      quizId: // value for 'quizId'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetPersonalityQuizResultQuery(baseOptions?: Apollo.QueryHookOptions<IGetPersonalityQuizResultQuery, IGetPersonalityQuizResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPersonalityQuizResultQuery, IGetPersonalityQuizResultQueryVariables>(GetPersonalityQuizResultDocument, options);
      }
export function useGetPersonalityQuizResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPersonalityQuizResultQuery, IGetPersonalityQuizResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPersonalityQuizResultQuery, IGetPersonalityQuizResultQueryVariables>(GetPersonalityQuizResultDocument, options);
        }
export type GetPersonalityQuizResultQueryHookResult = ReturnType<typeof useGetPersonalityQuizResultQuery>;
export type GetPersonalityQuizResultLazyQueryHookResult = ReturnType<typeof useGetPersonalityQuizResultLazyQuery>;
export type GetPersonalityQuizResultQueryResult = Apollo.QueryResult<IGetPersonalityQuizResultQuery, IGetPersonalityQuizResultQueryVariables>;
export const QuizResultByIdDocument = gql`
    query QuizResultById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizPage(id: $id, culture: $culture) {
    id
    __typename
    name
    url
    resultSubtitle
    resultTitle
    ctaLabel
    quizz {
      __typename
      ... on PersonalityQuiz1 {
        id
        questions {
          content {
            __typename
            ... on PersonalityQuizQuestion {
              ...PersonalityQuizQuestionFragment
            }
          }
        }
        children {
          items {
            __typename
            ... on PersonalityPages {
              __typename
              id
              url
              icon {
                url: cropUrl(format: $imageFormat, quality: 50)
              }
              title
              subtitle
              introduction
              linkedTag {
                __typename
                id
                ... on ContentTag {
                  color
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${PersonalityQuizQuestionFragmentFragmentDoc}`;

/**
 * __useQuizResultByIdQuery__
 *
 * To run a query within a React component, call `useQuizResultByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizResultByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizResultByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useQuizResultByIdQuery(baseOptions?: Apollo.QueryHookOptions<IQuizResultByIdQuery, IQuizResultByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IQuizResultByIdQuery, IQuizResultByIdQueryVariables>(QuizResultByIdDocument, options);
      }
export function useQuizResultByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IQuizResultByIdQuery, IQuizResultByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IQuizResultByIdQuery, IQuizResultByIdQueryVariables>(QuizResultByIdDocument, options);
        }
export type QuizResultByIdQueryHookResult = ReturnType<typeof useQuizResultByIdQuery>;
export type QuizResultByIdLazyQueryHookResult = ReturnType<typeof useQuizResultByIdLazyQuery>;
export type QuizResultByIdQueryResult = Apollo.QueryResult<IQuizResultByIdQuery, IQuizResultByIdQueryVariables>;
export const QuizResultByUrlEndDocument = gql`
    query QuizResultByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allQuizPage(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      id
      __typename
      name
      url
      resultSubtitle
      resultTitle
      ctaLabel
      quizz {
        __typename
        ... on PersonalityQuiz1 {
          id
          questions {
            content {
              __typename
              ... on PersonalityQuizQuestion {
                ...PersonalityQuizQuestionFragment
              }
            }
          }
          children {
            items {
              __typename
              ... on PersonalityPages {
                __typename
                id
                url
                icon {
                  url: cropUrl(format: $imageFormat, quality: 50)
                }
                title
                subtitle
                introduction
                linkedTag {
                  __typename
                  id
                  ... on ContentTag {
                    color
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${PersonalityQuizQuestionFragmentFragmentDoc}`;

/**
 * __useQuizResultByUrlEndQuery__
 *
 * To run a query within a React component, call `useQuizResultByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizResultByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizResultByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useQuizResultByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IQuizResultByUrlEndQuery, IQuizResultByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IQuizResultByUrlEndQuery, IQuizResultByUrlEndQueryVariables>(QuizResultByUrlEndDocument, options);
      }
export function useQuizResultByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IQuizResultByUrlEndQuery, IQuizResultByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IQuizResultByUrlEndQuery, IQuizResultByUrlEndQueryVariables>(QuizResultByUrlEndDocument, options);
        }
export type QuizResultByUrlEndQueryHookResult = ReturnType<typeof useQuizResultByUrlEndQuery>;
export type QuizResultByUrlEndLazyQueryHookResult = ReturnType<typeof useQuizResultByUrlEndLazyQuery>;
export type QuizResultByUrlEndQueryResult = Apollo.QueryResult<IQuizResultByUrlEndQuery, IQuizResultByUrlEndQueryVariables>;
export const MethodologyQuizDocument = gql`
    query MethodologyQuiz($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizPage(id: $id, culture: $culture) {
    methodTitle
    methodIntro
    methodCover {
      content {
        __typename
        ... on HeroVideoCover {
          ...HeroVideoCoverFragment
        }
      }
    }
    methodBody {
      content {
        __typename
        ... on Wysiwyg {
          ...WysiwygFragment
        }
        ... on UcImage {
          ...UcImageFragment
        }
      }
    }
    methodHighlightedCourses {
      children {
        items {
          __typename
          ... on Course {
            ...CourseFragment
          }
        }
      }
    }
    personalitiesPush {
      content {
        __typename
        ... on PersonalityPush {
          ...PersonalityPushFragment
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PersonalityPushFragmentFragmentDoc}`;

/**
 * __useMethodologyQuizQuery__
 *
 * To run a query within a React component, call `useMethodologyQuizQuery` and pass it any options that fit your needs.
 * When your component renders, `useMethodologyQuizQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMethodologyQuizQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMethodologyQuizQuery(baseOptions?: Apollo.QueryHookOptions<IMethodologyQuizQuery, IMethodologyQuizQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMethodologyQuizQuery, IMethodologyQuizQueryVariables>(MethodologyQuizDocument, options);
      }
export function useMethodologyQuizLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMethodologyQuizQuery, IMethodologyQuizQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMethodologyQuizQuery, IMethodologyQuizQueryVariables>(MethodologyQuizDocument, options);
        }
export type MethodologyQuizQueryHookResult = ReturnType<typeof useMethodologyQuizQuery>;
export type MethodologyQuizLazyQueryHookResult = ReturnType<typeof useMethodologyQuizLazyQuery>;
export type MethodologyQuizQueryResult = Apollo.QueryResult<IMethodologyQuizQuery, IMethodologyQuizQueryVariables>;
export const MethodologyQuizByUrlEndDocument = gql`
    query MethodologyQuizByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allQuizPage(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      id
      url
      methodTitle
      methodIntro
      methodCover {
        content {
          __typename
          ... on HeroVideoCover {
            ...HeroVideoCoverFragment
          }
        }
      }
      methodBody {
        content {
          __typename
          ... on Wysiwyg {
            ...WysiwygFragment
          }
          ... on UcImage {
            ...UcImageFragment
          }
        }
      }
      methodHighlightedCourses {
        children {
          items {
            __typename
            ... on Course {
              ...CourseFragment
            }
          }
        }
      }
      personalitiesPush {
        content {
          __typename
          ... on PersonalityPush {
            ...PersonalityPushFragment
          }
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PersonalityPushFragmentFragmentDoc}`;

/**
 * __useMethodologyQuizByUrlEndQuery__
 *
 * To run a query within a React component, call `useMethodologyQuizByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useMethodologyQuizByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMethodologyQuizByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMethodologyQuizByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IMethodologyQuizByUrlEndQuery, IMethodologyQuizByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMethodologyQuizByUrlEndQuery, IMethodologyQuizByUrlEndQueryVariables>(MethodologyQuizByUrlEndDocument, options);
      }
export function useMethodologyQuizByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMethodologyQuizByUrlEndQuery, IMethodologyQuizByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMethodologyQuizByUrlEndQuery, IMethodologyQuizByUrlEndQueryVariables>(MethodologyQuizByUrlEndDocument, options);
        }
export type MethodologyQuizByUrlEndQueryHookResult = ReturnType<typeof useMethodologyQuizByUrlEndQuery>;
export type MethodologyQuizByUrlEndLazyQueryHookResult = ReturnType<typeof useMethodologyQuizByUrlEndLazyQuery>;
export type MethodologyQuizByUrlEndQueryResult = Apollo.QueryResult<IMethodologyQuizByUrlEndQuery, IMethodologyQuizByUrlEndQueryVariables>;
export const PersonalityQuizByIdDocument = gql`
    query PersonalityQuizById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  personalityQuiz(id: $id, culture: $culture) {
    ...PersonalityQuizFragment
  }
}
    ${PersonalityQuizFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PersonalityPushFragmentFragmentDoc}`;

/**
 * __usePersonalityQuizByIdQuery__
 *
 * To run a query within a React component, call `usePersonalityQuizByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalityQuizByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalityQuizByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePersonalityQuizByIdQuery(baseOptions?: Apollo.QueryHookOptions<IPersonalityQuizByIdQuery, IPersonalityQuizByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPersonalityQuizByIdQuery, IPersonalityQuizByIdQueryVariables>(PersonalityQuizByIdDocument, options);
      }
export function usePersonalityQuizByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPersonalityQuizByIdQuery, IPersonalityQuizByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPersonalityQuizByIdQuery, IPersonalityQuizByIdQueryVariables>(PersonalityQuizByIdDocument, options);
        }
export type PersonalityQuizByIdQueryHookResult = ReturnType<typeof usePersonalityQuizByIdQuery>;
export type PersonalityQuizByIdLazyQueryHookResult = ReturnType<typeof usePersonalityQuizByIdLazyQuery>;
export type PersonalityQuizByIdQueryResult = Apollo.QueryResult<IPersonalityQuizByIdQuery, IPersonalityQuizByIdQueryVariables>;
export const PersonalityQuizQuestionByIdDocument = gql`
    query PersonalityQuizQuestionById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  personalityQuiz(id: $id, culture: $culture) {
    id
    __typename
    name
    questions {
      content {
        __typename
        ... on PersonalityQuizQuestion {
          ...PersonalityQuizQuestionFragment
        }
      }
    }
  }
}
    ${PersonalityQuizQuestionFragmentFragmentDoc}`;

/**
 * __usePersonalityQuizQuestionByIdQuery__
 *
 * To run a query within a React component, call `usePersonalityQuizQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalityQuizQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalityQuizQuestionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePersonalityQuizQuestionByIdQuery(baseOptions?: Apollo.QueryHookOptions<IPersonalityQuizQuestionByIdQuery, IPersonalityQuizQuestionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPersonalityQuizQuestionByIdQuery, IPersonalityQuizQuestionByIdQueryVariables>(PersonalityQuizQuestionByIdDocument, options);
      }
export function usePersonalityQuizQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPersonalityQuizQuestionByIdQuery, IPersonalityQuizQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPersonalityQuizQuestionByIdQuery, IPersonalityQuizQuestionByIdQueryVariables>(PersonalityQuizQuestionByIdDocument, options);
        }
export type PersonalityQuizQuestionByIdQueryHookResult = ReturnType<typeof usePersonalityQuizQuestionByIdQuery>;
export type PersonalityQuizQuestionByIdLazyQueryHookResult = ReturnType<typeof usePersonalityQuizQuestionByIdLazyQuery>;
export type PersonalityQuizQuestionByIdQueryResult = Apollo.QueryResult<IPersonalityQuizQuestionByIdQuery, IPersonalityQuizQuestionByIdQueryVariables>;
export const QuizPageQuestionByIdDocument = gql`
    query QuizPageQuestionById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizPage(id: $id, culture: $culture) {
    id
    __typename
    name
    quizz {
      __typename
      id
      ... on PersonalityQuiz1 {
        questions {
          content {
            __typename
            ... on PersonalityQuizQuestion {
              ...PersonalityQuizQuestionFragment
            }
          }
        }
      }
    }
  }
}
    ${PersonalityQuizQuestionFragmentFragmentDoc}`;

/**
 * __useQuizPageQuestionByIdQuery__
 *
 * To run a query within a React component, call `useQuizPageQuestionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizPageQuestionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizPageQuestionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useQuizPageQuestionByIdQuery(baseOptions?: Apollo.QueryHookOptions<IQuizPageQuestionByIdQuery, IQuizPageQuestionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IQuizPageQuestionByIdQuery, IQuizPageQuestionByIdQueryVariables>(QuizPageQuestionByIdDocument, options);
      }
export function useQuizPageQuestionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IQuizPageQuestionByIdQuery, IQuizPageQuestionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IQuizPageQuestionByIdQuery, IQuizPageQuestionByIdQueryVariables>(QuizPageQuestionByIdDocument, options);
        }
export type QuizPageQuestionByIdQueryHookResult = ReturnType<typeof useQuizPageQuestionByIdQuery>;
export type QuizPageQuestionByIdLazyQueryHookResult = ReturnType<typeof useQuizPageQuestionByIdLazyQuery>;
export type QuizPageQuestionByIdQueryResult = Apollo.QueryResult<IQuizPageQuestionByIdQuery, IQuizPageQuestionByIdQueryVariables>;
export const QuizPageQuestionByUrlEndDocument = gql`
    query QuizPageQuestionByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allQuizPage(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      id
      url
      __typename
      name
      quizz {
        __typename
        id
        url
        ... on PersonalityQuiz1 {
          questions {
            content {
              __typename
              ... on PersonalityQuizQuestion {
                ...PersonalityQuizQuestionFragment
              }
            }
          }
        }
      }
    }
  }
}
    ${PersonalityQuizQuestionFragmentFragmentDoc}`;

/**
 * __useQuizPageQuestionByUrlEndQuery__
 *
 * To run a query within a React component, call `useQuizPageQuestionByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizPageQuestionByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizPageQuestionByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useQuizPageQuestionByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IQuizPageQuestionByUrlEndQuery, IQuizPageQuestionByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IQuizPageQuestionByUrlEndQuery, IQuizPageQuestionByUrlEndQueryVariables>(QuizPageQuestionByUrlEndDocument, options);
      }
export function useQuizPageQuestionByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IQuizPageQuestionByUrlEndQuery, IQuizPageQuestionByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IQuizPageQuestionByUrlEndQuery, IQuizPageQuestionByUrlEndQueryVariables>(QuizPageQuestionByUrlEndDocument, options);
        }
export type QuizPageQuestionByUrlEndQueryHookResult = ReturnType<typeof useQuizPageQuestionByUrlEndQuery>;
export type QuizPageQuestionByUrlEndLazyQueryHookResult = ReturnType<typeof useQuizPageQuestionByUrlEndLazyQuery>;
export type QuizPageQuestionByUrlEndQueryResult = Apollo.QueryResult<IQuizPageQuestionByUrlEndQuery, IQuizPageQuestionByUrlEndQueryVariables>;
export const QuizPageByIdDocument = gql`
    query QuizPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizPage(id: $id, culture: $culture) {
    ...QuizPageFragment
  }
}
    ${QuizPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PersonalityPushFragmentFragmentDoc}`;

/**
 * __useQuizPageByIdQuery__
 *
 * To run a query within a React component, call `useQuizPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useQuizPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<IQuizPageByIdQuery, IQuizPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IQuizPageByIdQuery, IQuizPageByIdQueryVariables>(QuizPageByIdDocument, options);
      }
export function useQuizPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IQuizPageByIdQuery, IQuizPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IQuizPageByIdQuery, IQuizPageByIdQueryVariables>(QuizPageByIdDocument, options);
        }
export type QuizPageByIdQueryHookResult = ReturnType<typeof useQuizPageByIdQuery>;
export type QuizPageByIdLazyQueryHookResult = ReturnType<typeof useQuizPageByIdLazyQuery>;
export type QuizPageByIdQueryResult = Apollo.QueryResult<IQuizPageByIdQuery, IQuizPageByIdQueryVariables>;
export const CoursesByPersonalityIdsDocument = gql`
    query coursesByPersonalityIds($id: [ID], $culture: String, $imageFormat: ImageCropFormat) {
  allCourse(
    where: {linkedPersonalities_some: {id_any: $id}}
    first: 6
    culture: $culture
  ) {
    items {
      __typename
      id
      url
      name
      title
      trailer
      thumbnail {
        url
      }
      description
      linkedPartners {
        __typename
        ... on Partner {
          ...PartnerFragment
        }
      }
    }
  }
}
    ${PartnerFragmentFragmentDoc}`;

/**
 * __useCoursesByPersonalityIdsQuery__
 *
 * To run a query within a React component, call `useCoursesByPersonalityIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesByPersonalityIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesByPersonalityIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useCoursesByPersonalityIdsQuery(baseOptions?: Apollo.QueryHookOptions<ICoursesByPersonalityIdsQuery, ICoursesByPersonalityIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICoursesByPersonalityIdsQuery, ICoursesByPersonalityIdsQueryVariables>(CoursesByPersonalityIdsDocument, options);
      }
export function useCoursesByPersonalityIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICoursesByPersonalityIdsQuery, ICoursesByPersonalityIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICoursesByPersonalityIdsQuery, ICoursesByPersonalityIdsQueryVariables>(CoursesByPersonalityIdsDocument, options);
        }
export type CoursesByPersonalityIdsQueryHookResult = ReturnType<typeof useCoursesByPersonalityIdsQuery>;
export type CoursesByPersonalityIdsLazyQueryHookResult = ReturnType<typeof useCoursesByPersonalityIdsLazyQuery>;
export type CoursesByPersonalityIdsQueryResult = Apollo.QueryResult<ICoursesByPersonalityIdsQuery, ICoursesByPersonalityIdsQueryVariables>;
export const GetAllUnitProgressionDocument = gql`
    query GetAllUnitProgression($memberDataId: ID) {
  memberDatas(id: $memberDataId) {
    id
    children(where: {contentTypeAlias: "unitProgression"}) {
      items {
        ... on UnitProgression {
          finished
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllUnitProgressionQuery__
 *
 * To run a query within a React component, call `useGetAllUnitProgressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnitProgressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnitProgressionQuery({
 *   variables: {
 *      memberDataId: // value for 'memberDataId'
 *   },
 * });
 */
export function useGetAllUnitProgressionQuery(baseOptions?: Apollo.QueryHookOptions<IGetAllUnitProgressionQuery, IGetAllUnitProgressionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAllUnitProgressionQuery, IGetAllUnitProgressionQueryVariables>(GetAllUnitProgressionDocument, options);
      }
export function useGetAllUnitProgressionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAllUnitProgressionQuery, IGetAllUnitProgressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAllUnitProgressionQuery, IGetAllUnitProgressionQueryVariables>(GetAllUnitProgressionDocument, options);
        }
export type GetAllUnitProgressionQueryHookResult = ReturnType<typeof useGetAllUnitProgressionQuery>;
export type GetAllUnitProgressionLazyQueryHookResult = ReturnType<typeof useGetAllUnitProgressionLazyQuery>;
export type GetAllUnitProgressionQueryResult = Apollo.QueryResult<IGetAllUnitProgressionQuery, IGetAllUnitProgressionQueryVariables>;
export const GetCourseTestProgressionByIdDocument = gql`
    query GetCourseTestProgressionById($testId: String, $memberDataId: ID) {
  memberDatas(id: $memberDataId) {
    id
    children(
      where: {contentTypeAlias: "CourseTestProgression", AND: {name: $testId}}
    ) {
      items {
        id
        testId: name
        ... on CourseTestProgression {
          json
          attempt
          lastAttempt
        }
      }
    }
  }
}
    `;

/**
 * __useGetCourseTestProgressionByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseTestProgressionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseTestProgressionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseTestProgressionByIdQuery({
 *   variables: {
 *      testId: // value for 'testId'
 *      memberDataId: // value for 'memberDataId'
 *   },
 * });
 */
export function useGetCourseTestProgressionByIdQuery(baseOptions?: Apollo.QueryHookOptions<IGetCourseTestProgressionByIdQuery, IGetCourseTestProgressionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCourseTestProgressionByIdQuery, IGetCourseTestProgressionByIdQueryVariables>(GetCourseTestProgressionByIdDocument, options);
      }
export function useGetCourseTestProgressionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCourseTestProgressionByIdQuery, IGetCourseTestProgressionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCourseTestProgressionByIdQuery, IGetCourseTestProgressionByIdQueryVariables>(GetCourseTestProgressionByIdDocument, options);
        }
export type GetCourseTestProgressionByIdQueryHookResult = ReturnType<typeof useGetCourseTestProgressionByIdQuery>;
export type GetCourseTestProgressionByIdLazyQueryHookResult = ReturnType<typeof useGetCourseTestProgressionByIdLazyQuery>;
export type GetCourseTestProgressionByIdQueryResult = Apollo.QueryResult<IGetCourseTestProgressionByIdQuery, IGetCourseTestProgressionByIdQueryVariables>;
export const GetUnitProgressionByIdDocument = gql`
    query GetUnitProgressionById($unitId: String, $memberDataId: ID) {
  memberDatas(id: $memberDataId) {
    id
    children(where: {contentTypeAlias: "unitProgression", AND: {name: $unitId}}) {
      items {
        id
        unitId: name
        ... on UnitProgression {
          json
          finished
        }
        children {
          items {
            __typename
            ... on UnitNuggetAnswer {
              ...UnitNuggetAnswerFragment
            }
            ... on UnitNuggetGapFillAnswer {
              ...UnitNuggetGapFillAnswerFragment
            }
          }
        }
      }
    }
  }
}
    ${UnitNuggetAnswerFragmentFragmentDoc}
${UnitNuggetGapFillAnswerFragmentFragmentDoc}
${UnitNuggetGapFillAnswerItemFragmentFragmentDoc}`;

/**
 * __useGetUnitProgressionByIdQuery__
 *
 * To run a query within a React component, call `useGetUnitProgressionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitProgressionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitProgressionByIdQuery({
 *   variables: {
 *      unitId: // value for 'unitId'
 *      memberDataId: // value for 'memberDataId'
 *   },
 * });
 */
export function useGetUnitProgressionByIdQuery(baseOptions?: Apollo.QueryHookOptions<IGetUnitProgressionByIdQuery, IGetUnitProgressionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUnitProgressionByIdQuery, IGetUnitProgressionByIdQueryVariables>(GetUnitProgressionByIdDocument, options);
      }
export function useGetUnitProgressionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUnitProgressionByIdQuery, IGetUnitProgressionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUnitProgressionByIdQuery, IGetUnitProgressionByIdQueryVariables>(GetUnitProgressionByIdDocument, options);
        }
export type GetUnitProgressionByIdQueryHookResult = ReturnType<typeof useGetUnitProgressionByIdQuery>;
export type GetUnitProgressionByIdLazyQueryHookResult = ReturnType<typeof useGetUnitProgressionByIdLazyQuery>;
export type GetUnitProgressionByIdQueryResult = Apollo.QueryResult<IGetUnitProgressionByIdQuery, IGetUnitProgressionByIdQueryVariables>;
export const LiveEventsPageDocument = gql`
    query LiveEventsPage($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  liveEventsPage(id: $id, culture: $culture) {
    ...LiveEventsPageFragment
  }
}
    ${LiveEventsPageFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useLiveEventsPageQuery__
 *
 * To run a query within a React component, call `useLiveEventsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveEventsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveEventsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useLiveEventsPageQuery(baseOptions?: Apollo.QueryHookOptions<ILiveEventsPageQuery, ILiveEventsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILiveEventsPageQuery, ILiveEventsPageQueryVariables>(LiveEventsPageDocument, options);
      }
export function useLiveEventsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILiveEventsPageQuery, ILiveEventsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILiveEventsPageQuery, ILiveEventsPageQueryVariables>(LiveEventsPageDocument, options);
        }
export type LiveEventsPageQueryHookResult = ReturnType<typeof useLiveEventsPageQuery>;
export type LiveEventsPageLazyQueryHookResult = ReturnType<typeof useLiveEventsPageLazyQuery>;
export type LiveEventsPageQueryResult = Apollo.QueryResult<ILiveEventsPageQuery, ILiveEventsPageQueryVariables>;
export const LiveTvPageDocument = gql`
    query LiveTVPage($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  liveTVPage(id: $id, culture: $culture) {
    ...LiveTVPageFragment
  }
}
    ${LiveTvPageFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useLiveTvPageQuery__
 *
 * To run a query within a React component, call `useLiveTvPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveTvPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveTvPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useLiveTvPageQuery(baseOptions?: Apollo.QueryHookOptions<ILiveTvPageQuery, ILiveTvPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILiveTvPageQuery, ILiveTvPageQueryVariables>(LiveTvPageDocument, options);
      }
export function useLiveTvPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILiveTvPageQuery, ILiveTvPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILiveTvPageQuery, ILiveTvPageQueryVariables>(LiveTvPageDocument, options);
        }
export type LiveTvPageQueryHookResult = ReturnType<typeof useLiveTvPageQuery>;
export type LiveTvPageLazyQueryHookResult = ReturnType<typeof useLiveTvPageLazyQuery>;
export type LiveTvPageQueryResult = Apollo.QueryResult<ILiveTvPageQuery, ILiveTvPageQueryVariables>;
export const MainContentByIdDocument = gql`
    query MainContentById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  content(id: $id, culture: $culture) {
    __typename
    url
    id
    ...MainContentListFragment
  }
}
    ${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useMainContentByIdQuery__
 *
 * To run a query within a React component, call `useMainContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainContentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMainContentByIdQuery(baseOptions?: Apollo.QueryHookOptions<IMainContentByIdQuery, IMainContentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMainContentByIdQuery, IMainContentByIdQueryVariables>(MainContentByIdDocument, options);
      }
export function useMainContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMainContentByIdQuery, IMainContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMainContentByIdQuery, IMainContentByIdQueryVariables>(MainContentByIdDocument, options);
        }
export type MainContentByIdQueryHookResult = ReturnType<typeof useMainContentByIdQuery>;
export type MainContentByIdLazyQueryHookResult = ReturnType<typeof useMainContentByIdLazyQuery>;
export type MainContentByIdQueryResult = Apollo.QueryResult<IMainContentByIdQuery, IMainContentByIdQueryVariables>;
export const AllMemberDownloadedBySourceDocument = gql`
    query AllMemberDownloadedBySource($memberUrl: String, $contentSource: String, $culture: String, $imageFormat: ImageCropFormat) {
  allMemberDownloaded(
    where: {contentSource: $contentSource, url_starts_with: $memberUrl}
    culture: $culture
  ) {
    items {
      __typename
      ... on MemberDownloaded {
        ...MemberDownloadedFragment
      }
    }
  }
}
    ${MemberDownloadedFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useAllMemberDownloadedBySourceQuery__
 *
 * To run a query within a React component, call `useAllMemberDownloadedBySourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMemberDownloadedBySourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMemberDownloadedBySourceQuery({
 *   variables: {
 *      memberUrl: // value for 'memberUrl'
 *      contentSource: // value for 'contentSource'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllMemberDownloadedBySourceQuery(baseOptions?: Apollo.QueryHookOptions<IAllMemberDownloadedBySourceQuery, IAllMemberDownloadedBySourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllMemberDownloadedBySourceQuery, IAllMemberDownloadedBySourceQueryVariables>(AllMemberDownloadedBySourceDocument, options);
      }
export function useAllMemberDownloadedBySourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllMemberDownloadedBySourceQuery, IAllMemberDownloadedBySourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllMemberDownloadedBySourceQuery, IAllMemberDownloadedBySourceQueryVariables>(AllMemberDownloadedBySourceDocument, options);
        }
export type AllMemberDownloadedBySourceQueryHookResult = ReturnType<typeof useAllMemberDownloadedBySourceQuery>;
export type AllMemberDownloadedBySourceLazyQueryHookResult = ReturnType<typeof useAllMemberDownloadedBySourceLazyQuery>;
export type AllMemberDownloadedBySourceQueryResult = Apollo.QueryResult<IAllMemberDownloadedBySourceQuery, IAllMemberDownloadedBySourceQueryVariables>;
export const AllMemberSavedBySourceDocument = gql`
    query AllMemberSavedBySource($memberUrl: String, $contentSource: String, $culture: String, $imageFormat: ImageCropFormat) {
  allMemberSaved(
    where: {contentSource: $contentSource, url_starts_with: $memberUrl}
    culture: $culture
  ) {
    items {
      id
      __typename
      ... on MemberSaved {
        ...MemberSavedFragment
      }
    }
  }
}
    ${MemberSavedFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useAllMemberSavedBySourceQuery__
 *
 * To run a query within a React component, call `useAllMemberSavedBySourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMemberSavedBySourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMemberSavedBySourceQuery({
 *   variables: {
 *      memberUrl: // value for 'memberUrl'
 *      contentSource: // value for 'contentSource'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllMemberSavedBySourceQuery(baseOptions?: Apollo.QueryHookOptions<IAllMemberSavedBySourceQuery, IAllMemberSavedBySourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllMemberSavedBySourceQuery, IAllMemberSavedBySourceQueryVariables>(AllMemberSavedBySourceDocument, options);
      }
export function useAllMemberSavedBySourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllMemberSavedBySourceQuery, IAllMemberSavedBySourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllMemberSavedBySourceQuery, IAllMemberSavedBySourceQueryVariables>(AllMemberSavedBySourceDocument, options);
        }
export type AllMemberSavedBySourceQueryHookResult = ReturnType<typeof useAllMemberSavedBySourceQuery>;
export type AllMemberSavedBySourceLazyQueryHookResult = ReturnType<typeof useAllMemberSavedBySourceLazyQuery>;
export type AllMemberSavedBySourceQueryResult = Apollo.QueryResult<IAllMemberSavedBySourceQuery, IAllMemberSavedBySourceQueryVariables>;
export const MemberDatasByIdDocument = gql`
    query MemberDatasById($id: ID, $culture: String) {
  memberDatas(id: $id, culture: $culture) {
    ...MemberDatasFragment
  }
}
    ${MemberDatasFragmentFragmentDoc}`;

/**
 * __useMemberDatasByIdQuery__
 *
 * To run a query within a React component, call `useMemberDatasByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDatasByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDatasByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useMemberDatasByIdQuery(baseOptions?: Apollo.QueryHookOptions<IMemberDatasByIdQuery, IMemberDatasByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberDatasByIdQuery, IMemberDatasByIdQueryVariables>(MemberDatasByIdDocument, options);
      }
export function useMemberDatasByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberDatasByIdQuery, IMemberDatasByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberDatasByIdQuery, IMemberDatasByIdQueryVariables>(MemberDatasByIdDocument, options);
        }
export type MemberDatasByIdQueryHookResult = ReturnType<typeof useMemberDatasByIdQuery>;
export type MemberDatasByIdLazyQueryHookResult = ReturnType<typeof useMemberDatasByIdLazyQuery>;
export type MemberDatasByIdQueryResult = Apollo.QueryResult<IMemberDatasByIdQuery, IMemberDatasByIdQueryVariables>;
export const MemberDatasDownloadedDocument = gql`
    query MemberDatasDownloaded($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  memberDatas(id: $id, culture: $culture) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "memberDownloaded"}) {
      items {
        id
        __typename
        ... on MemberDownloaded {
          ...MemberDownloadedFragment
        }
      }
    }
  }
}
    ${MemberDownloadedFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useMemberDatasDownloadedQuery__
 *
 * To run a query within a React component, call `useMemberDatasDownloadedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDatasDownloadedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDatasDownloadedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMemberDatasDownloadedQuery(baseOptions?: Apollo.QueryHookOptions<IMemberDatasDownloadedQuery, IMemberDatasDownloadedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberDatasDownloadedQuery, IMemberDatasDownloadedQueryVariables>(MemberDatasDownloadedDocument, options);
      }
export function useMemberDatasDownloadedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberDatasDownloadedQuery, IMemberDatasDownloadedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberDatasDownloadedQuery, IMemberDatasDownloadedQueryVariables>(MemberDatasDownloadedDocument, options);
        }
export type MemberDatasDownloadedQueryHookResult = ReturnType<typeof useMemberDatasDownloadedQuery>;
export type MemberDatasDownloadedLazyQueryHookResult = ReturnType<typeof useMemberDatasDownloadedLazyQuery>;
export type MemberDatasDownloadedQueryResult = Apollo.QueryResult<IMemberDatasDownloadedQuery, IMemberDatasDownloadedQueryVariables>;
export const MemberDatasMessageDocument = gql`
    query MemberDatasMessage($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  memberDatas(id: $id, culture: $culture) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "memberMessage"}) {
      items {
        id
        __typename
        ... on MemberMessage {
          ...MemberMessageFragment
        }
      }
    }
  }
}
    ${MemberMessageFragmentFragmentDoc}`;

/**
 * __useMemberDatasMessageQuery__
 *
 * To run a query within a React component, call `useMemberDatasMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDatasMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDatasMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMemberDatasMessageQuery(baseOptions?: Apollo.QueryHookOptions<IMemberDatasMessageQuery, IMemberDatasMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberDatasMessageQuery, IMemberDatasMessageQueryVariables>(MemberDatasMessageDocument, options);
      }
export function useMemberDatasMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberDatasMessageQuery, IMemberDatasMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberDatasMessageQuery, IMemberDatasMessageQueryVariables>(MemberDatasMessageDocument, options);
        }
export type MemberDatasMessageQueryHookResult = ReturnType<typeof useMemberDatasMessageQuery>;
export type MemberDatasMessageLazyQueryHookResult = ReturnType<typeof useMemberDatasMessageLazyQuery>;
export type MemberDatasMessageQueryResult = Apollo.QueryResult<IMemberDatasMessageQuery, IMemberDatasMessageQueryVariables>;
export const MemberDatasNotifyDocument = gql`
    query MemberDatasNotify($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  memberDatas(id: $id, culture: $culture) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "memberNotify"}) {
      items {
        id
        __typename
        ... on MemberNotify {
          ...MemberNotifyFragment
        }
      }
    }
  }
}
    ${MemberNotifyFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useMemberDatasNotifyQuery__
 *
 * To run a query within a React component, call `useMemberDatasNotifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDatasNotifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDatasNotifyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMemberDatasNotifyQuery(baseOptions?: Apollo.QueryHookOptions<IMemberDatasNotifyQuery, IMemberDatasNotifyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberDatasNotifyQuery, IMemberDatasNotifyQueryVariables>(MemberDatasNotifyDocument, options);
      }
export function useMemberDatasNotifyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberDatasNotifyQuery, IMemberDatasNotifyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberDatasNotifyQuery, IMemberDatasNotifyQueryVariables>(MemberDatasNotifyDocument, options);
        }
export type MemberDatasNotifyQueryHookResult = ReturnType<typeof useMemberDatasNotifyQuery>;
export type MemberDatasNotifyLazyQueryHookResult = ReturnType<typeof useMemberDatasNotifyLazyQuery>;
export type MemberDatasNotifyQueryResult = Apollo.QueryResult<IMemberDatasNotifyQuery, IMemberDatasNotifyQueryVariables>;
export const MemberDatasOpportunityDocument = gql`
    query MemberDatasOpportunity($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  memberDatas(id: $id, culture: $culture) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "memberOpportunity"}) {
      items {
        id
        __typename
        ... on MemberOpportunity {
          ...MemberOpportunityFragment
        }
      }
    }
  }
}
    ${MemberOpportunityFragmentFragmentDoc}
${OpportunityFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${ContentTagFragmentFragmentDoc}`;

/**
 * __useMemberDatasOpportunityQuery__
 *
 * To run a query within a React component, call `useMemberDatasOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDatasOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDatasOpportunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMemberDatasOpportunityQuery(baseOptions?: Apollo.QueryHookOptions<IMemberDatasOpportunityQuery, IMemberDatasOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberDatasOpportunityQuery, IMemberDatasOpportunityQueryVariables>(MemberDatasOpportunityDocument, options);
      }
export function useMemberDatasOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberDatasOpportunityQuery, IMemberDatasOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberDatasOpportunityQuery, IMemberDatasOpportunityQueryVariables>(MemberDatasOpportunityDocument, options);
        }
export type MemberDatasOpportunityQueryHookResult = ReturnType<typeof useMemberDatasOpportunityQuery>;
export type MemberDatasOpportunityLazyQueryHookResult = ReturnType<typeof useMemberDatasOpportunityLazyQuery>;
export type MemberDatasOpportunityQueryResult = Apollo.QueryResult<IMemberDatasOpportunityQuery, IMemberDatasOpportunityQueryVariables>;
export const MemberDatasSavedDocument = gql`
    query MemberDatasSaved($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  memberDatas(id: $id, culture: $culture) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "memberSaved"}) {
      items {
        id
        __typename
        ... on MemberSaved {
          ...MemberSavedFragment
        }
      }
    }
  }
}
    ${MemberSavedFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useMemberDatasSavedQuery__
 *
 * To run a query within a React component, call `useMemberDatasSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDatasSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDatasSavedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMemberDatasSavedQuery(baseOptions?: Apollo.QueryHookOptions<IMemberDatasSavedQuery, IMemberDatasSavedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberDatasSavedQuery, IMemberDatasSavedQueryVariables>(MemberDatasSavedDocument, options);
      }
export function useMemberDatasSavedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberDatasSavedQuery, IMemberDatasSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberDatasSavedQuery, IMemberDatasSavedQueryVariables>(MemberDatasSavedDocument, options);
        }
export type MemberDatasSavedQueryHookResult = ReturnType<typeof useMemberDatasSavedQuery>;
export type MemberDatasSavedLazyQueryHookResult = ReturnType<typeof useMemberDatasSavedLazyQuery>;
export type MemberDatasSavedQueryResult = Apollo.QueryResult<IMemberDatasSavedQuery, IMemberDatasSavedQueryVariables>;
export const MemberDatasSearchDocument = gql`
    query MemberDatasSearch($id: ID, $culture: String) {
  memberDatas(id: $id, culture: $culture) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "memberSearch"}) {
      items {
        id
        __typename
        ... on MemberSearch {
          ...MemberSearchFragment
        }
      }
    }
  }
}
    ${MemberSearchFragmentFragmentDoc}`;

/**
 * __useMemberDatasSearchQuery__
 *
 * To run a query within a React component, call `useMemberDatasSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDatasSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDatasSearchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useMemberDatasSearchQuery(baseOptions?: Apollo.QueryHookOptions<IMemberDatasSearchQuery, IMemberDatasSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberDatasSearchQuery, IMemberDatasSearchQueryVariables>(MemberDatasSearchDocument, options);
      }
export function useMemberDatasSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberDatasSearchQuery, IMemberDatasSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberDatasSearchQuery, IMemberDatasSearchQueryVariables>(MemberDatasSearchDocument, options);
        }
export type MemberDatasSearchQueryHookResult = ReturnType<typeof useMemberDatasSearchQuery>;
export type MemberDatasSearchLazyQueryHookResult = ReturnType<typeof useMemberDatasSearchLazyQuery>;
export type MemberDatasSearchQueryResult = Apollo.QueryResult<IMemberDatasSearchQuery, IMemberDatasSearchQueryVariables>;
export const MemberDatasWatchedDocument = gql`
    query MemberDatasWatched($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  memberDatas(id: $id, culture: $culture) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "memberWatched"}) {
      items {
        id
        __typename
        ... on MemberWatched {
          ...MemberWatchedFragment
        }
      }
    }
  }
}
    ${MemberWatchedFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useMemberDatasWatchedQuery__
 *
 * To run a query within a React component, call `useMemberDatasWatchedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDatasWatchedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDatasWatchedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMemberDatasWatchedQuery(baseOptions?: Apollo.QueryHookOptions<IMemberDatasWatchedQuery, IMemberDatasWatchedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberDatasWatchedQuery, IMemberDatasWatchedQueryVariables>(MemberDatasWatchedDocument, options);
      }
export function useMemberDatasWatchedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberDatasWatchedQuery, IMemberDatasWatchedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberDatasWatchedQuery, IMemberDatasWatchedQueryVariables>(MemberDatasWatchedDocument, options);
        }
export type MemberDatasWatchedQueryHookResult = ReturnType<typeof useMemberDatasWatchedQuery>;
export type MemberDatasWatchedLazyQueryHookResult = ReturnType<typeof useMemberDatasWatchedLazyQuery>;
export type MemberDatasWatchedQueryResult = Apollo.QueryResult<IMemberDatasWatchedQuery, IMemberDatasWatchedQueryVariables>;
export const GetMainContentListByIdDocument = gql`
    query GetMainContentListById($id: [ID], $culture: String, $imageFormat: ImageCropFormat) {
  allContent(where: {id_any: $id}, culture: $culture) {
    items {
      __typename
      id
      ...MainContentListFragment
    }
  }
}
    ${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useGetMainContentListByIdQuery__
 *
 * To run a query within a React component, call `useGetMainContentListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainContentListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainContentListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetMainContentListByIdQuery(baseOptions?: Apollo.QueryHookOptions<IGetMainContentListByIdQuery, IGetMainContentListByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetMainContentListByIdQuery, IGetMainContentListByIdQueryVariables>(GetMainContentListByIdDocument, options);
      }
export function useGetMainContentListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetMainContentListByIdQuery, IGetMainContentListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetMainContentListByIdQuery, IGetMainContentListByIdQueryVariables>(GetMainContentListByIdDocument, options);
        }
export type GetMainContentListByIdQueryHookResult = ReturnType<typeof useGetMainContentListByIdQuery>;
export type GetMainContentListByIdLazyQueryHookResult = ReturnType<typeof useGetMainContentListByIdLazyQuery>;
export type GetMainContentListByIdQueryResult = Apollo.QueryResult<IGetMainContentListByIdQuery, IGetMainContentListByIdQueryVariables>;
export const MemberUnitProgressionDocument = gql`
    query MemberUnitProgression($id: ID, $culture: String) {
  memberDatas(id: $id, culture: $culture) {
    id
    url
    __typename
    children(where: {contentTypeAlias: "unitProgression"}) {
      items {
        id
        __typename
        ... on UnitProgression {
          name
          courseId
          finished
        }
      }
    }
  }
}
    `;

/**
 * __useMemberUnitProgressionQuery__
 *
 * To run a query within a React component, call `useMemberUnitProgressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberUnitProgressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberUnitProgressionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useMemberUnitProgressionQuery(baseOptions?: Apollo.QueryHookOptions<IMemberUnitProgressionQuery, IMemberUnitProgressionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberUnitProgressionQuery, IMemberUnitProgressionQueryVariables>(MemberUnitProgressionDocument, options);
      }
export function useMemberUnitProgressionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberUnitProgressionQuery, IMemberUnitProgressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberUnitProgressionQuery, IMemberUnitProgressionQueryVariables>(MemberUnitProgressionDocument, options);
        }
export type MemberUnitProgressionQueryHookResult = ReturnType<typeof useMemberUnitProgressionQuery>;
export type MemberUnitProgressionLazyQueryHookResult = ReturnType<typeof useMemberUnitProgressionLazyQuery>;
export type MemberUnitProgressionQueryResult = Apollo.QueryResult<IMemberUnitProgressionQuery, IMemberUnitProgressionQueryVariables>;
export const NewsDocument = gql`
    query News($orderBy: [NewsOrderByInput], $url_starts_with: String, $culture: String, $imageFormat: ImageCropFormat) {
  allNews(
    orderBy: $orderBy
    where: {url_starts_with: $url_starts_with}
    culture: $culture
  ) {
    items {
      ...NewsFragment
    }
  }
}
    ${NewsFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useNewsQuery__
 *
 * To run a query within a React component, call `useNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      url_starts_with: // value for 'url_starts_with'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useNewsQuery(baseOptions?: Apollo.QueryHookOptions<INewsQuery, INewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<INewsQuery, INewsQueryVariables>(NewsDocument, options);
      }
export function useNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<INewsQuery, INewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<INewsQuery, INewsQueryVariables>(NewsDocument, options);
        }
export type NewsQueryHookResult = ReturnType<typeof useNewsQuery>;
export type NewsLazyQueryHookResult = ReturnType<typeof useNewsLazyQuery>;
export type NewsQueryResult = Apollo.QueryResult<INewsQuery, INewsQueryVariables>;
export const NewsByUrlDocument = gql`
    query NewsByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  news(url: $url, culture: $culture) {
    ...NewsFragment
  }
}
    ${NewsFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useNewsByUrlQuery__
 *
 * To run a query within a React component, call `useNewsByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useNewsByUrlQuery(baseOptions?: Apollo.QueryHookOptions<INewsByUrlQuery, INewsByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<INewsByUrlQuery, INewsByUrlQueryVariables>(NewsByUrlDocument, options);
      }
export function useNewsByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<INewsByUrlQuery, INewsByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<INewsByUrlQuery, INewsByUrlQueryVariables>(NewsByUrlDocument, options);
        }
export type NewsByUrlQueryHookResult = ReturnType<typeof useNewsByUrlQuery>;
export type NewsByUrlLazyQueryHookResult = ReturnType<typeof useNewsByUrlLazyQuery>;
export type NewsByUrlQueryResult = Apollo.QueryResult<INewsByUrlQuery, INewsByUrlQueryVariables>;
export const NewsByIdDocument = gql`
    query NewsById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  news(id: $id, culture: $culture) {
    ...NewsFragment
  }
}
    ${NewsFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useNewsByIdQuery__
 *
 * To run a query within a React component, call `useNewsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useNewsByIdQuery(baseOptions?: Apollo.QueryHookOptions<INewsByIdQuery, INewsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<INewsByIdQuery, INewsByIdQueryVariables>(NewsByIdDocument, options);
      }
export function useNewsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<INewsByIdQuery, INewsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<INewsByIdQuery, INewsByIdQueryVariables>(NewsByIdDocument, options);
        }
export type NewsByIdQueryHookResult = ReturnType<typeof useNewsByIdQuery>;
export type NewsByIdLazyQueryHookResult = ReturnType<typeof useNewsByIdLazyQuery>;
export type NewsByIdQueryResult = Apollo.QueryResult<INewsByIdQuery, INewsByIdQueryVariables>;
export const NewsByUrlEndUrlDocument = gql`
    query NewsByUrlEndUrl($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allNews(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      ...NewsFragment
    }
  }
}
    ${NewsFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useNewsByUrlEndUrlQuery__
 *
 * To run a query within a React component, call `useNewsByUrlEndUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsByUrlEndUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsByUrlEndUrlQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useNewsByUrlEndUrlQuery(baseOptions?: Apollo.QueryHookOptions<INewsByUrlEndUrlQuery, INewsByUrlEndUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<INewsByUrlEndUrlQuery, INewsByUrlEndUrlQueryVariables>(NewsByUrlEndUrlDocument, options);
      }
export function useNewsByUrlEndUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<INewsByUrlEndUrlQuery, INewsByUrlEndUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<INewsByUrlEndUrlQuery, INewsByUrlEndUrlQueryVariables>(NewsByUrlEndUrlDocument, options);
        }
export type NewsByUrlEndUrlQueryHookResult = ReturnType<typeof useNewsByUrlEndUrlQuery>;
export type NewsByUrlEndUrlLazyQueryHookResult = ReturnType<typeof useNewsByUrlEndUrlLazyQuery>;
export type NewsByUrlEndUrlQueryResult = Apollo.QueryResult<INewsByUrlEndUrlQuery, INewsByUrlEndUrlQueryVariables>;
export const PaywalByIdDocument = gql`
    query PaywalById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  paywall(id: $id, culture: $culture) {
    ...PaywallFragment
  }
}
    ${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}`;

/**
 * __usePaywalByIdQuery__
 *
 * To run a query within a React component, call `usePaywalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaywalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaywalByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePaywalByIdQuery(baseOptions?: Apollo.QueryHookOptions<IPaywalByIdQuery, IPaywalByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPaywalByIdQuery, IPaywalByIdQueryVariables>(PaywalByIdDocument, options);
      }
export function usePaywalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPaywalByIdQuery, IPaywalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPaywalByIdQuery, IPaywalByIdQueryVariables>(PaywalByIdDocument, options);
        }
export type PaywalByIdQueryHookResult = ReturnType<typeof usePaywalByIdQuery>;
export type PaywalByIdLazyQueryHookResult = ReturnType<typeof usePaywalByIdLazyQuery>;
export type PaywalByIdQueryResult = Apollo.QueryResult<IPaywalByIdQuery, IPaywalByIdQueryVariables>;
export const PlayListByUrlDocument = gql`
    query PlayListByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  playlist(url: $url, culture: $culture) {
    ...PlaylistFragment
  }
}
    ${PlaylistFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __usePlayListByUrlQuery__
 *
 * To run a query within a React component, call `usePlayListByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayListByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayListByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePlayListByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IPlayListByUrlQuery, IPlayListByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPlayListByUrlQuery, IPlayListByUrlQueryVariables>(PlayListByUrlDocument, options);
      }
export function usePlayListByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPlayListByUrlQuery, IPlayListByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPlayListByUrlQuery, IPlayListByUrlQueryVariables>(PlayListByUrlDocument, options);
        }
export type PlayListByUrlQueryHookResult = ReturnType<typeof usePlayListByUrlQuery>;
export type PlayListByUrlLazyQueryHookResult = ReturnType<typeof usePlayListByUrlLazyQuery>;
export type PlayListByUrlQueryResult = Apollo.QueryResult<IPlayListByUrlQuery, IPlayListByUrlQueryVariables>;
export const PlayListByIdDocument = gql`
    query PlayListById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  playlist(id: $id, culture: $culture) {
    ...PlaylistFragment
  }
}
    ${PlaylistFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __usePlayListByIdQuery__
 *
 * To run a query within a React component, call `usePlayListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePlayListByIdQuery(baseOptions?: Apollo.QueryHookOptions<IPlayListByIdQuery, IPlayListByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPlayListByIdQuery, IPlayListByIdQueryVariables>(PlayListByIdDocument, options);
      }
export function usePlayListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPlayListByIdQuery, IPlayListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPlayListByIdQuery, IPlayListByIdQueryVariables>(PlayListByIdDocument, options);
        }
export type PlayListByIdQueryHookResult = ReturnType<typeof usePlayListByIdQuery>;
export type PlayListByIdLazyQueryHookResult = ReturnType<typeof usePlayListByIdLazyQuery>;
export type PlayListByIdQueryResult = Apollo.QueryResult<IPlayListByIdQuery, IPlayListByIdQueryVariables>;
export const PodCastDocument = gql`
    query PodCast($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  podcast(url: $url, culture: $culture) {
    ...PodcastFragment
  }
}
    ${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __usePodCastQuery__
 *
 * To run a query within a React component, call `usePodCastQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodCastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodCastQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePodCastQuery(baseOptions?: Apollo.QueryHookOptions<IPodCastQuery, IPodCastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPodCastQuery, IPodCastQueryVariables>(PodCastDocument, options);
      }
export function usePodCastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPodCastQuery, IPodCastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPodCastQuery, IPodCastQueryVariables>(PodCastDocument, options);
        }
export type PodCastQueryHookResult = ReturnType<typeof usePodCastQuery>;
export type PodCastLazyQueryHookResult = ReturnType<typeof usePodCastLazyQuery>;
export type PodCastQueryResult = Apollo.QueryResult<IPodCastQuery, IPodCastQueryVariables>;
export const PodCastByIdDocument = gql`
    query PodCastById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  podcast(id: $id, culture: $culture) {
    ...PodcastFragment
  }
}
    ${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __usePodCastByIdQuery__
 *
 * To run a query within a React component, call `usePodCastByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodCastByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodCastByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePodCastByIdQuery(baseOptions?: Apollo.QueryHookOptions<IPodCastByIdQuery, IPodCastByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPodCastByIdQuery, IPodCastByIdQueryVariables>(PodCastByIdDocument, options);
      }
export function usePodCastByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPodCastByIdQuery, IPodCastByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPodCastByIdQuery, IPodCastByIdQueryVariables>(PodCastByIdDocument, options);
        }
export type PodCastByIdQueryHookResult = ReturnType<typeof usePodCastByIdQuery>;
export type PodCastByIdLazyQueryHookResult = ReturnType<typeof usePodCastByIdLazyQuery>;
export type PodCastByIdQueryResult = Apollo.QueryResult<IPodCastByIdQuery, IPodCastByIdQueryVariables>;
export const PodCastByUrlEndDocument = gql`
    query PodCastByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allPodcast(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      ...PodcastFragment
    }
  }
}
    ${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __usePodCastByUrlEndQuery__
 *
 * To run a query within a React component, call `usePodCastByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodCastByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodCastByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePodCastByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IPodCastByUrlEndQuery, IPodCastByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPodCastByUrlEndQuery, IPodCastByUrlEndQueryVariables>(PodCastByUrlEndDocument, options);
      }
export function usePodCastByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPodCastByUrlEndQuery, IPodCastByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPodCastByUrlEndQuery, IPodCastByUrlEndQueryVariables>(PodCastByUrlEndDocument, options);
        }
export type PodCastByUrlEndQueryHookResult = ReturnType<typeof usePodCastByUrlEndQuery>;
export type PodCastByUrlEndLazyQueryHookResult = ReturnType<typeof usePodCastByUrlEndLazyQuery>;
export type PodCastByUrlEndQueryResult = Apollo.QueryResult<IPodCastByUrlEndQuery, IPodCastByUrlEndQueryVariables>;
export const PodCastItemDocument = gql`
    query PodCastItem($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  podcastItem(url: $url, culture: $culture) {
    ...PodcastItemFragment
  }
}
    ${PodcastItemFragmentFragmentDoc}`;

/**
 * __usePodCastItemQuery__
 *
 * To run a query within a React component, call `usePodCastItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodCastItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodCastItemQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePodCastItemQuery(baseOptions?: Apollo.QueryHookOptions<IPodCastItemQuery, IPodCastItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPodCastItemQuery, IPodCastItemQueryVariables>(PodCastItemDocument, options);
      }
export function usePodCastItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPodCastItemQuery, IPodCastItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPodCastItemQuery, IPodCastItemQueryVariables>(PodCastItemDocument, options);
        }
export type PodCastItemQueryHookResult = ReturnType<typeof usePodCastItemQuery>;
export type PodCastItemLazyQueryHookResult = ReturnType<typeof usePodCastItemLazyQuery>;
export type PodCastItemQueryResult = Apollo.QueryResult<IPodCastItemQuery, IPodCastItemQueryVariables>;
export const PodCastItemByIdDocument = gql`
    query PodCastItemById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  podcastItem(id: $id, culture: $culture) {
    ...PodcastItemFragment
  }
}
    ${PodcastItemFragmentFragmentDoc}`;

/**
 * __usePodCastItemByIdQuery__
 *
 * To run a query within a React component, call `usePodCastItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodCastItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodCastItemByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePodCastItemByIdQuery(baseOptions?: Apollo.QueryHookOptions<IPodCastItemByIdQuery, IPodCastItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPodCastItemByIdQuery, IPodCastItemByIdQueryVariables>(PodCastItemByIdDocument, options);
      }
export function usePodCastItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPodCastItemByIdQuery, IPodCastItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPodCastItemByIdQuery, IPodCastItemByIdQueryVariables>(PodCastItemByIdDocument, options);
        }
export type PodCastItemByIdQueryHookResult = ReturnType<typeof usePodCastItemByIdQuery>;
export type PodCastItemByIdLazyQueryHookResult = ReturnType<typeof usePodCastItemByIdLazyQuery>;
export type PodCastItemByIdQueryResult = Apollo.QueryResult<IPodCastItemByIdQuery, IPodCastItemByIdQueryVariables>;
export const PromoCodeContentDocument = gql`
    query PromoCodeContent($culture: String, $imageFormat: ImageCropFormat) {
  allSettings(culture: $culture) {
    items {
      __typename
      children(where: {contentTypeAlias: "promoCodeFolder"}) {
        items {
          ... on PromoCodeFolder {
            id
            name
            __typename
            title
            description
            footerImage {
              webCover: cropUrl(alias: "webCover", format: $imageFormat, quality: 50)
              mobileCover: cropUrl(alias: "mobileCover", format: $imageFormat, quality: 50)
            }
            thankYouBody
            thankYouTitle
            thankYouCover {
              content {
                ... on HeroVideoCover {
                  ...HeroVideoCoverFragment
                }
              }
            }
            variantTitle
            variantCover {
              webCover: cropUrl(alias: "webCover", format: $imageFormat, quality: 50)
              mobileCover: cropUrl(alias: "mobileCover", format: $imageFormat, quality: 50)
            }
            variantSurtitle
            variantMention
            variantCtaLabel
            variantDescription
            variantHighlightedTitle
            variantHighlightedMention
            subscriptionTitle
            subscriptionDescription
          }
        }
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __usePromoCodeContentQuery__
 *
 * To run a query within a React component, call `usePromoCodeContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoCodeContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoCodeContentQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function usePromoCodeContentQuery(baseOptions?: Apollo.QueryHookOptions<IPromoCodeContentQuery, IPromoCodeContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPromoCodeContentQuery, IPromoCodeContentQueryVariables>(PromoCodeContentDocument, options);
      }
export function usePromoCodeContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPromoCodeContentQuery, IPromoCodeContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPromoCodeContentQuery, IPromoCodeContentQueryVariables>(PromoCodeContentDocument, options);
        }
export type PromoCodeContentQueryHookResult = ReturnType<typeof usePromoCodeContentQuery>;
export type PromoCodeContentLazyQueryHookResult = ReturnType<typeof usePromoCodeContentLazyQuery>;
export type PromoCodeContentQueryResult = Apollo.QueryResult<IPromoCodeContentQuery, IPromoCodeContentQueryVariables>;
export const QuizzSurveyByIdDocument = gql`
    query QuizzSurveyById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizzSurvey(id: $id, culture: $culture) {
    ...QuizzSurveyFragment
  }
}
    ${QuizzSurveyFragmentFragmentDoc}
${UcImageFragmentFragmentDoc}
${UcVideoFragmentFragmentDoc}
${UcAudioFragmentFragmentDoc}
${ChoiceNuggerAnswerFragmentFragmentDoc}`;

/**
 * __useQuizzSurveyByIdQuery__
 *
 * To run a query within a React component, call `useQuizzSurveyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizzSurveyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizzSurveyByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useQuizzSurveyByIdQuery(baseOptions?: Apollo.QueryHookOptions<IQuizzSurveyByIdQuery, IQuizzSurveyByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IQuizzSurveyByIdQuery, IQuizzSurveyByIdQueryVariables>(QuizzSurveyByIdDocument, options);
      }
export function useQuizzSurveyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IQuizzSurveyByIdQuery, IQuizzSurveyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IQuizzSurveyByIdQuery, IQuizzSurveyByIdQueryVariables>(QuizzSurveyByIdDocument, options);
        }
export type QuizzSurveyByIdQueryHookResult = ReturnType<typeof useQuizzSurveyByIdQuery>;
export type QuizzSurveyByIdLazyQueryHookResult = ReturnType<typeof useQuizzSurveyByIdLazyQuery>;
export type QuizzSurveyByIdQueryResult = Apollo.QueryResult<IQuizzSurveyByIdQuery, IQuizzSurveyByIdQueryVariables>;
export const GetQuizzSurveyByDocument = gql`
    query GetQuizzSurveyBy($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizzSurvey(id: $id, culture: $culture) {
    id
    __typename
    shortDescription
    title
    vimeoHlsUrl
    liveEventId: liveEventID
    sourceUrl
    ctaLabel
    url
    thumbnail {
      url: cropUrl(alias: "default", quality: 80, format: $imageFormat)
      bubble: cropUrl(alias: "bubble")
      optiUrl: cropUrl(alias: "default", quality: 80, format: $imageFormat)
    }
    questions {
      __typename
    }
  }
}
    `;

/**
 * __useGetQuizzSurveyByQuery__
 *
 * To run a query within a React component, call `useGetQuizzSurveyByQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuizzSurveyByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuizzSurveyByQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetQuizzSurveyByQuery(baseOptions?: Apollo.QueryHookOptions<IGetQuizzSurveyByQuery, IGetQuizzSurveyByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetQuizzSurveyByQuery, IGetQuizzSurveyByQueryVariables>(GetQuizzSurveyByDocument, options);
      }
export function useGetQuizzSurveyByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetQuizzSurveyByQuery, IGetQuizzSurveyByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetQuizzSurveyByQuery, IGetQuizzSurveyByQueryVariables>(GetQuizzSurveyByDocument, options);
        }
export type GetQuizzSurveyByQueryHookResult = ReturnType<typeof useGetQuizzSurveyByQuery>;
export type GetQuizzSurveyByLazyQueryHookResult = ReturnType<typeof useGetQuizzSurveyByLazyQuery>;
export type GetQuizzSurveyByQueryResult = Apollo.QueryResult<IGetQuizzSurveyByQuery, IGetQuizzSurveyByQueryVariables>;
export const QuizzSurveyCollectionByIdDocument = gql`
    query QuizzSurveyCollectionById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizzSurveyCollection(id: $id, culture: $culture) {
    ...QuizzSurveyCollectionFragment
  }
}
    ${QuizzSurveyCollectionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useQuizzSurveyCollectionByIdQuery__
 *
 * To run a query within a React component, call `useQuizzSurveyCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuizzSurveyCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuizzSurveyCollectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useQuizzSurveyCollectionByIdQuery(baseOptions?: Apollo.QueryHookOptions<IQuizzSurveyCollectionByIdQuery, IQuizzSurveyCollectionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IQuizzSurveyCollectionByIdQuery, IQuizzSurveyCollectionByIdQueryVariables>(QuizzSurveyCollectionByIdDocument, options);
      }
export function useQuizzSurveyCollectionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IQuizzSurveyCollectionByIdQuery, IQuizzSurveyCollectionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IQuizzSurveyCollectionByIdQuery, IQuizzSurveyCollectionByIdQueryVariables>(QuizzSurveyCollectionByIdDocument, options);
        }
export type QuizzSurveyCollectionByIdQueryHookResult = ReturnType<typeof useQuizzSurveyCollectionByIdQuery>;
export type QuizzSurveyCollectionByIdLazyQueryHookResult = ReturnType<typeof useQuizzSurveyCollectionByIdLazyQuery>;
export type QuizzSurveyCollectionByIdQueryResult = Apollo.QueryResult<IQuizzSurveyCollectionByIdQuery, IQuizzSurveyCollectionByIdQueryVariables>;
export const GetSurveyCollectionByIdDocument = gql`
    query GetSurveyCollectionById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  quizzSurveyCollection(id: $id, culture: $culture) {
    id
    shortDescription
    url
    __typename
    title
    subtitle
    questions {
      __typename
      ... on ChoiceNugget {
        id
        __typename
        genericFeedback
        positiveFeedback
        negativeFeedback
        externalId
        question {
          content {
            ... on Wysiwyg {
              __typename
              title
              body
            }
            ... on UcImage {
              ...UcImageFragment
            }
            ... on UcVideo {
              ...UcVideoFragment
            }
            ... on UcAudio {
              ...UcAudioFragment
            }
          }
        }
        options {
          content {
            ... on ChoiceNuggetAnswerGroup {
              answersList {
                content {
                  __typename
                  ... on ChoiceNuggerAnswer {
                    ...ChoiceNuggerAnswerFragment
                  }
                }
              }
            }
            ... on ChoiceNuggerAnswer {
              ...ChoiceNuggerAnswerFragment
            }
          }
        }
      }
    }
  }
}
    ${UcImageFragmentFragmentDoc}
${UcVideoFragmentFragmentDoc}
${UcAudioFragmentFragmentDoc}
${ChoiceNuggerAnswerFragmentFragmentDoc}`;

/**
 * __useGetSurveyCollectionByIdQuery__
 *
 * To run a query within a React component, call `useGetSurveyCollectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyCollectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyCollectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetSurveyCollectionByIdQuery(baseOptions?: Apollo.QueryHookOptions<IGetSurveyCollectionByIdQuery, IGetSurveyCollectionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSurveyCollectionByIdQuery, IGetSurveyCollectionByIdQueryVariables>(GetSurveyCollectionByIdDocument, options);
      }
export function useGetSurveyCollectionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSurveyCollectionByIdQuery, IGetSurveyCollectionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSurveyCollectionByIdQuery, IGetSurveyCollectionByIdQueryVariables>(GetSurveyCollectionByIdDocument, options);
        }
export type GetSurveyCollectionByIdQueryHookResult = ReturnType<typeof useGetSurveyCollectionByIdQuery>;
export type GetSurveyCollectionByIdLazyQueryHookResult = ReturnType<typeof useGetSurveyCollectionByIdLazyQuery>;
export type GetSurveyCollectionByIdQueryResult = Apollo.QueryResult<IGetSurveyCollectionByIdQuery, IGetSurveyCollectionByIdQueryVariables>;
export const RadioByUrlDocument = gql`
    query RadioByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  radio(url: $url, culture: $culture) {
    ...RadioFragment
  }
}
    ${RadioFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useRadioByUrlQuery__
 *
 * To run a query within a React component, call `useRadioByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRadioByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRadioByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useRadioByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IRadioByUrlQuery, IRadioByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRadioByUrlQuery, IRadioByUrlQueryVariables>(RadioByUrlDocument, options);
      }
export function useRadioByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRadioByUrlQuery, IRadioByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRadioByUrlQuery, IRadioByUrlQueryVariables>(RadioByUrlDocument, options);
        }
export type RadioByUrlQueryHookResult = ReturnType<typeof useRadioByUrlQuery>;
export type RadioByUrlLazyQueryHookResult = ReturnType<typeof useRadioByUrlLazyQuery>;
export type RadioByUrlQueryResult = Apollo.QueryResult<IRadioByUrlQuery, IRadioByUrlQueryVariables>;
export const RadioByIdDocument = gql`
    query RadioById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  radio(id: $id, culture: $culture) {
    ...RadioFragment
  }
}
    ${RadioFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useRadioByIdQuery__
 *
 * To run a query within a React component, call `useRadioByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRadioByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRadioByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useRadioByIdQuery(baseOptions?: Apollo.QueryHookOptions<IRadioByIdQuery, IRadioByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRadioByIdQuery, IRadioByIdQueryVariables>(RadioByIdDocument, options);
      }
export function useRadioByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRadioByIdQuery, IRadioByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRadioByIdQuery, IRadioByIdQueryVariables>(RadioByIdDocument, options);
        }
export type RadioByIdQueryHookResult = ReturnType<typeof useRadioByIdQuery>;
export type RadioByIdLazyQueryHookResult = ReturnType<typeof useRadioByIdLazyQuery>;
export type RadioByIdQueryResult = Apollo.QueryResult<IRadioByIdQuery, IRadioByIdQueryVariables>;
export const RedirectCancelUrlSettingDocument = gql`
    query RedirectCancelUrlSetting {
  allSettings {
    items {
      iOSCancelSubUrl
      huaweiCancelSubUrl
      androidCancelSubUrl
    }
  }
}
    `;

/**
 * __useRedirectCancelUrlSettingQuery__
 *
 * To run a query within a React component, call `useRedirectCancelUrlSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectCancelUrlSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectCancelUrlSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useRedirectCancelUrlSettingQuery(baseOptions?: Apollo.QueryHookOptions<IRedirectCancelUrlSettingQuery, IRedirectCancelUrlSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRedirectCancelUrlSettingQuery, IRedirectCancelUrlSettingQueryVariables>(RedirectCancelUrlSettingDocument, options);
      }
export function useRedirectCancelUrlSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRedirectCancelUrlSettingQuery, IRedirectCancelUrlSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRedirectCancelUrlSettingQuery, IRedirectCancelUrlSettingQueryVariables>(RedirectCancelUrlSettingDocument, options);
        }
export type RedirectCancelUrlSettingQueryHookResult = ReturnType<typeof useRedirectCancelUrlSettingQuery>;
export type RedirectCancelUrlSettingLazyQueryHookResult = ReturnType<typeof useRedirectCancelUrlSettingLazyQuery>;
export type RedirectCancelUrlSettingQueryResult = Apollo.QueryResult<IRedirectCancelUrlSettingQuery, IRedirectCancelUrlSettingQueryVariables>;
export const AllRegionDocument = gql`
    query AllRegion($culture: String, $imageFormat: ImageCropFormat) {
  allRegion(culture: $culture) {
    items {
      ...RegionFragment
    }
  }
}
    ${RegionFragmentFragmentDoc}
${LinkIconFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}
${LinkPickerFragmentFragmentDoc}`;

/**
 * __useAllRegionQuery__
 *
 * To run a query within a React component, call `useAllRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRegionQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllRegionQuery(baseOptions?: Apollo.QueryHookOptions<IAllRegionQuery, IAllRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllRegionQuery, IAllRegionQueryVariables>(AllRegionDocument, options);
      }
export function useAllRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllRegionQuery, IAllRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllRegionQuery, IAllRegionQueryVariables>(AllRegionDocument, options);
        }
export type AllRegionQueryHookResult = ReturnType<typeof useAllRegionQuery>;
export type AllRegionLazyQueryHookResult = ReturnType<typeof useAllRegionLazyQuery>;
export type AllRegionQueryResult = Apollo.QueryResult<IAllRegionQuery, IAllRegionQueryVariables>;
export const AllRegionWebDocument = gql`
    query AllRegionWeb($culture: String, $imageFormat: ImageCropFormat) {
  allRegion(culture: $culture) {
    items {
      ...RegionWebFragment
    }
  }
}
    ${RegionWebFragmentFragmentDoc}
${LinkIconFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}
${LinkPickerFragmentFragmentDoc}`;

/**
 * __useAllRegionWebQuery__
 *
 * To run a query within a React component, call `useAllRegionWebQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRegionWebQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRegionWebQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllRegionWebQuery(baseOptions?: Apollo.QueryHookOptions<IAllRegionWebQuery, IAllRegionWebQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllRegionWebQuery, IAllRegionWebQueryVariables>(AllRegionWebDocument, options);
      }
export function useAllRegionWebLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllRegionWebQuery, IAllRegionWebQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllRegionWebQuery, IAllRegionWebQueryVariables>(AllRegionWebDocument, options);
        }
export type AllRegionWebQueryHookResult = ReturnType<typeof useAllRegionWebQuery>;
export type AllRegionWebLazyQueryHookResult = ReturnType<typeof useAllRegionWebLazyQuery>;
export type AllRegionWebQueryResult = Apollo.QueryResult<IAllRegionWebQuery, IAllRegionWebQueryVariables>;
export const RegionDiscoveryByIdDocument = gql`
    query RegionDiscoveryById($id: ID, $culture: String, $cursor: String, $first: Int, $imageFormat: ImageCropFormat) {
  region(id: $id, culture: $culture) {
    __typename
    discovery {
      ... on SectionPage {
        id
        __typename
      }
      ... on Discovery {
        children(first: $first, after: $cursor) {
          __typename
          edges {
            __typename
            cursor
            node {
              __typename
              ... on DiscoverySlide1 {
                ...DiscoverySlide1Fragment
              }
            }
          }
          pageInfo {
            hasPreviousPage
            hasNextPage
            startCursor
            endCursor
          }
        }
      }
    }
  }
}
    ${DiscoverySlide1FragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useRegionDiscoveryByIdQuery__
 *
 * To run a query within a React component, call `useRegionDiscoveryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionDiscoveryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionDiscoveryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useRegionDiscoveryByIdQuery(baseOptions?: Apollo.QueryHookOptions<IRegionDiscoveryByIdQuery, IRegionDiscoveryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRegionDiscoveryByIdQuery, IRegionDiscoveryByIdQueryVariables>(RegionDiscoveryByIdDocument, options);
      }
export function useRegionDiscoveryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRegionDiscoveryByIdQuery, IRegionDiscoveryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRegionDiscoveryByIdQuery, IRegionDiscoveryByIdQueryVariables>(RegionDiscoveryByIdDocument, options);
        }
export type RegionDiscoveryByIdQueryHookResult = ReturnType<typeof useRegionDiscoveryByIdQuery>;
export type RegionDiscoveryByIdLazyQueryHookResult = ReturnType<typeof useRegionDiscoveryByIdLazyQuery>;
export type RegionDiscoveryByIdQueryResult = Apollo.QueryResult<IRegionDiscoveryByIdQuery, IRegionDiscoveryByIdQueryVariables>;
export const RegionDiscoveryByUrlDocument = gql`
    query RegionDiscoveryByUrl($url: String, $culture: String, $cursor: String, $first: Int, $imageFormat: ImageCropFormat) {
  region(url: $url, culture: $culture) {
    __typename
    discovery {
      children(first: $first, after: $cursor) {
        __typename
        edges {
          __typename
          cursor
          node {
            __typename
            ... on DiscoverySlide1 {
              ...DiscoverySlide1Fragment
            }
          }
        }
        pageInfo {
          hasPreviousPage
          hasNextPage
          startCursor
          endCursor
        }
      }
    }
  }
}
    ${DiscoverySlide1FragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useRegionDiscoveryByUrlQuery__
 *
 * To run a query within a React component, call `useRegionDiscoveryByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionDiscoveryByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionDiscoveryByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useRegionDiscoveryByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IRegionDiscoveryByUrlQuery, IRegionDiscoveryByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IRegionDiscoveryByUrlQuery, IRegionDiscoveryByUrlQueryVariables>(RegionDiscoveryByUrlDocument, options);
      }
export function useRegionDiscoveryByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IRegionDiscoveryByUrlQuery, IRegionDiscoveryByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IRegionDiscoveryByUrlQuery, IRegionDiscoveryByUrlQueryVariables>(RegionDiscoveryByUrlDocument, options);
        }
export type RegionDiscoveryByUrlQueryHookResult = ReturnType<typeof useRegionDiscoveryByUrlQuery>;
export type RegionDiscoveryByUrlLazyQueryHookResult = ReturnType<typeof useRegionDiscoveryByUrlLazyQuery>;
export type RegionDiscoveryByUrlQueryResult = Apollo.QueryResult<IRegionDiscoveryByUrlQuery, IRegionDiscoveryByUrlQueryVariables>;
export const SearchLearnDocument = gql`
    query SearchLearn($culture: String, $first: Int, $keyWord: String, $courseCursor: String, $jobCursor: String, $partnerCursor: String, $jobVacancyCursor: String, $jobHubCursor: String, $imageFormat: ImageCropFormat) {
  allCourse(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {description_contains: $keyWord}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $courseCursor
  ) {
    edges {
      cursor
      node {
        title
        id
        url(culture: $culture)
        thumbnail {
          url
        }
        length
        linkedPartners {
          __typename
          ... on Partner {
            logo {
              url
            }
          }
        }
        __typename
        children {
          items {
            __typename
            id
          }
        }
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allJobTraining(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {description_contains: $keyWord}]}
    culture: $culture
    first: $first
    after: $jobCursor
  ) {
    edges {
      cursor
      node {
        __typename
        id
        url
        title
        length
        partners {
          ... on Partner {
            logo {
              url
            }
          }
        }
        cover {
          content {
            ... on HeroVideoCover {
              ...HeroVideoCoverFragment
            }
          }
        }
        courses {
          id
          __typename
        }
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allPartner(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {description_contains: $keyWord}]}
    culture: $culture
    first: $first
    after: $partnerCursor
  ) {
    edges {
      cursor
      node {
        ...PartnerFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allJobHub(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {longDescription_contains: $keyWord}, {shortDescription_contains: $keyWord}]}
    culture: $culture
    first: $first
    after: $jobHubCursor
  ) {
    edges {
      cursor
      node {
        ...JobHubFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allJobVacancy(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {shortDescription_contains: $keyWord}]}
    culture: $culture
    first: $first
    after: $jobVacancyCursor
  ) {
    edges {
      cursor
      node {
        title
        shortDescription
        thumbnail {
          url
        }
        id
        __typename
        url
        partners {
          ... on Partner {
            id
            __typename
            logo {
              url
            }
          }
        }
        link
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${JobHubFragmentFragmentDoc}`;

/**
 * __useSearchLearnQuery__
 *
 * To run a query within a React component, call `useSearchLearnQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLearnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLearnQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      first: // value for 'first'
 *      keyWord: // value for 'keyWord'
 *      courseCursor: // value for 'courseCursor'
 *      jobCursor: // value for 'jobCursor'
 *      partnerCursor: // value for 'partnerCursor'
 *      jobVacancyCursor: // value for 'jobVacancyCursor'
 *      jobHubCursor: // value for 'jobHubCursor'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useSearchLearnQuery(baseOptions?: Apollo.QueryHookOptions<ISearchLearnQuery, ISearchLearnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISearchLearnQuery, ISearchLearnQueryVariables>(SearchLearnDocument, options);
      }
export function useSearchLearnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISearchLearnQuery, ISearchLearnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISearchLearnQuery, ISearchLearnQueryVariables>(SearchLearnDocument, options);
        }
export type SearchLearnQueryHookResult = ReturnType<typeof useSearchLearnQuery>;
export type SearchLearnLazyQueryHookResult = ReturnType<typeof useSearchLearnLazyQuery>;
export type SearchLearnQueryResult = Apollo.QueryResult<ISearchLearnQuery, ISearchLearnQueryVariables>;
export const SearchWatchDocument = gql`
    query SearchWatch($culture: String, $first: Int, $keyWord: String, $vodCursor: String, $collectionCursor: String, $liveEventCursor: String, $newsCursor: String, $channelCursor: String, $imageFormat: ImageCropFormat) {
  allVODItem(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {shortDescription_contains: $keyWord}, {subtitle_contains: $keyWord}, {description_contains: $keyWord}, {musicGenre_some: {name_contains: $keyWord}}, {interests_some: {name_contains: $keyWord}}, {personality_some: [$keyWord]}, {themes_some: {name_contains: $keyWord}}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $vodCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...VODItemFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allCollection(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {shortDescription_contains: $keyWord}, {subtitle_contains: $keyWord}, {description_contains: $keyWord}, {musicGenre_some: {name_contains: $keyWord}}, {interests_some: {name_contains: $keyWord}}, {personality_some: [$keyWord]}, {themes_some: {name_contains: $keyWord}}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $collectionCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...CollectionFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allLiveEvent(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {shortDescription_contains: $keyWord}, {subtitle_contains: $keyWord}, {description_contains: $keyWord}, {musicGenre_some: {name_contains: $keyWord}}, {interests_some: {name_contains: $keyWord}}, {personality_some: [$keyWord]}, {themes_some: {name_contains: $keyWord}}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $liveEventCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...LiveEventFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allNews(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {shortDescription_contains: $keyWord}, {musicGenre_some: {name_contains: $keyWord}}, {interests_some: {name_contains: $keyWord}}, {themes_some: {name_contains: $keyWord}}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $newsCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...NewsFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allChannel(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {shortDescription_contains: $keyWord}, {musicGenre_some: {name_contains: $keyWord}}, {interests_some: {name_contains: $keyWord}}, {themes_some: {name_contains: $keyWord}}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $channelCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...ChannelFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${VodItemFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${CollectionFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}`;

/**
 * __useSearchWatchQuery__
 *
 * To run a query within a React component, call `useSearchWatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWatchQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      first: // value for 'first'
 *      keyWord: // value for 'keyWord'
 *      vodCursor: // value for 'vodCursor'
 *      collectionCursor: // value for 'collectionCursor'
 *      liveEventCursor: // value for 'liveEventCursor'
 *      newsCursor: // value for 'newsCursor'
 *      channelCursor: // value for 'channelCursor'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useSearchWatchQuery(baseOptions?: Apollo.QueryHookOptions<ISearchWatchQuery, ISearchWatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISearchWatchQuery, ISearchWatchQueryVariables>(SearchWatchDocument, options);
      }
export function useSearchWatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISearchWatchQuery, ISearchWatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISearchWatchQuery, ISearchWatchQueryVariables>(SearchWatchDocument, options);
        }
export type SearchWatchQueryHookResult = ReturnType<typeof useSearchWatchQuery>;
export type SearchWatchLazyQueryHookResult = ReturnType<typeof useSearchWatchLazyQuery>;
export type SearchWatchQueryResult = Apollo.QueryResult<ISearchWatchQuery, ISearchWatchQueryVariables>;
export const SearchListenDocument = gql`
    query SearchListen($culture: String, $first: Int, $keyWord: String, $playlistCursor: String, $radioCursor: String, $podcastCursor: String, $podcastItemCursor: String, $imageFormat: ImageCropFormat) {
  allPlaylist(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {subtitle_contains: $keyWord}, {musicGenre_some: {name_contains: $keyWord}}, {interests_some: {name_contains: $keyWord}}, {personality_some: [$keyWord]}, {themes_some: {name_contains: $keyWord}}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $playlistCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...PlaylistFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allRadio(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {descriptionTitle_contains: $keyWord}, {subtitle_contains: $keyWord}, {description_contains: $keyWord}, {musicGenre_some: {name_contains: $keyWord}}, {interests_some: {name_contains: $keyWord}}, {personality_some: [$keyWord]}, {themes_some: {name_contains: $keyWord}}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $radioCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...RadioFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allPodcast(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {shortDescription_contains: $keyWord}, {subtitle_contains: $keyWord}, {description_contains: $keyWord}, {musicGenre_some: {name_contains: $keyWord}}, {interests_some: {name_contains: $keyWord}}, {personality_some: [$keyWord]}, {themes_some: {name_contains: $keyWord}}, {searchTag_some: [$keyWord]}]}
    culture: $culture
    first: $first
    after: $podcastCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...PodcastFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
  allPodcastItem(
    where: {OR: [{name_contains: $keyWord}, {title_contains: $keyWord}, {shortDescription_contains: $keyWord}, {description_contains: $keyWord}]}
    culture: $culture
    first: $first
    after: $podcastItemCursor
  ) {
    edges {
      __typename
      cursor
      node {
        ...PodcastItemFragment
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${PlaylistFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}`;

/**
 * __useSearchListenQuery__
 *
 * To run a query within a React component, call `useSearchListenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchListenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchListenQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      first: // value for 'first'
 *      keyWord: // value for 'keyWord'
 *      playlistCursor: // value for 'playlistCursor'
 *      radioCursor: // value for 'radioCursor'
 *      podcastCursor: // value for 'podcastCursor'
 *      podcastItemCursor: // value for 'podcastItemCursor'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useSearchListenQuery(baseOptions?: Apollo.QueryHookOptions<ISearchListenQuery, ISearchListenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISearchListenQuery, ISearchListenQueryVariables>(SearchListenDocument, options);
      }
export function useSearchListenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISearchListenQuery, ISearchListenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISearchListenQuery, ISearchListenQueryVariables>(SearchListenDocument, options);
        }
export type SearchListenQueryHookResult = ReturnType<typeof useSearchListenQuery>;
export type SearchListenLazyQueryHookResult = ReturnType<typeof useSearchListenLazyQuery>;
export type SearchListenQueryResult = Apollo.QueryResult<ISearchListenQuery, ISearchListenQueryVariables>;
export const SectionPageByUrlDocument = gql`
    query SectionPageByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  sectionPage(url: $url, culture: $culture) {
    ...SectionPageFragment
  }
}
    ${SectionPageFragmentFragmentDoc}
${HeroSlideFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useSectionPageByUrlQuery__
 *
 * To run a query within a React component, call `useSectionPageByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectionPageByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionPageByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useSectionPageByUrlQuery(baseOptions?: Apollo.QueryHookOptions<ISectionPageByUrlQuery, ISectionPageByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISectionPageByUrlQuery, ISectionPageByUrlQueryVariables>(SectionPageByUrlDocument, options);
      }
export function useSectionPageByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISectionPageByUrlQuery, ISectionPageByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISectionPageByUrlQuery, ISectionPageByUrlQueryVariables>(SectionPageByUrlDocument, options);
        }
export type SectionPageByUrlQueryHookResult = ReturnType<typeof useSectionPageByUrlQuery>;
export type SectionPageByUrlLazyQueryHookResult = ReturnType<typeof useSectionPageByUrlLazyQuery>;
export type SectionPageByUrlQueryResult = Apollo.QueryResult<ISectionPageByUrlQuery, ISectionPageByUrlQueryVariables>;
export const SectionPageByIdDocument = gql`
    query SectionPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  sectionPage(id: $id, culture: $culture) {
    ...SectionPageFragment
  }
}
    ${SectionPageFragmentFragmentDoc}
${HeroSlideFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useSectionPageByIdQuery__
 *
 * To run a query within a React component, call `useSectionPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectionPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useSectionPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<ISectionPageByIdQuery, ISectionPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISectionPageByIdQuery, ISectionPageByIdQueryVariables>(SectionPageByIdDocument, options);
      }
export function useSectionPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISectionPageByIdQuery, ISectionPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISectionPageByIdQuery, ISectionPageByIdQueryVariables>(SectionPageByIdDocument, options);
        }
export type SectionPageByIdQueryHookResult = ReturnType<typeof useSectionPageByIdQuery>;
export type SectionPageByIdLazyQueryHookResult = ReturnType<typeof useSectionPageByIdLazyQuery>;
export type SectionPageByIdQueryResult = Apollo.QueryResult<ISectionPageByIdQuery, ISectionPageByIdQueryVariables>;
export const SectionPageContentDocument = gql`
    query SectionPageContent($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  sectionPage(id: $id, culture: $culture) {
    ...SectionPageContentFragment
  }
}
    ${SectionPageContentFragmentFragmentDoc}
${HeroSlideFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${LearnHeroSildeFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${ElementFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${MainContentListFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}
${CategoryPageFragmentFragmentDoc}
${LiveTvPageFragmentFragmentDoc}
${LiveEventsPageFragmentFragmentDoc}
${NewsCategFragmentFragmentDoc}
${WatchCategFragmentFragmentDoc}
${RadioCategFragmentFragmentDoc}
${PodcastCategFragmentFragmentDoc}
${PushFragmentFragmentDoc}
${QuizzSurveyCategoryFragmentFragmentDoc}
${MulticategoriesSliderFragmentFragmentDoc}
${WysiwygFragmentFragmentDoc}
${KeyFiguresFragmentFragmentDoc}
${KeyFigureFragmentFragmentDoc}
${MultiSliderFragmentFragmentDoc}
${TitleSliderFragmentFragmentDoc}
${TextSlide1FragmentFragmentDoc}
${IconSlideFragmentFragmentDoc}
${CtaSlideFragmentFragmentDoc}
${LogoSliderFragmentFragmentDoc}
${LogoLinkFragmentFragmentDoc}
${AccordionsFragmentFragmentDoc}
${FaqItemFragmentFragmentDoc}
${PartnerSliderFragmentFragmentDoc}
${PagecontentSliderFragmentFragmentDoc}
${ContentFragmentFragmentDoc}
${CourseCategoryFragmentFragmentDoc}
${CourseItemsSliderFragmentFragmentDoc}
${QuizItemsSliderFragmentFragmentDoc}`;

/**
 * __useSectionPageContentQuery__
 *
 * To run a query within a React component, call `useSectionPageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectionPageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionPageContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useSectionPageContentQuery(baseOptions?: Apollo.QueryHookOptions<ISectionPageContentQuery, ISectionPageContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISectionPageContentQuery, ISectionPageContentQueryVariables>(SectionPageContentDocument, options);
      }
export function useSectionPageContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISectionPageContentQuery, ISectionPageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISectionPageContentQuery, ISectionPageContentQueryVariables>(SectionPageContentDocument, options);
        }
export type SectionPageContentQueryHookResult = ReturnType<typeof useSectionPageContentQuery>;
export type SectionPageContentLazyQueryHookResult = ReturnType<typeof useSectionPageContentLazyQuery>;
export type SectionPageContentQueryResult = Apollo.QueryResult<ISectionPageContentQuery, ISectionPageContentQueryVariables>;
export const SectionPageTopMenuDocument = gql`
    query SectionPageTopMenu($id: ID, $culture: String) {
  sectionPage(id: $id, culture: $culture) {
    ...SectionPageTopMenuFragment
  }
}
    ${SectionPageTopMenuFragmentFragmentDoc}
${LinkPickerFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}
${ExpandMenuFragmentFragmentDoc}`;

/**
 * __useSectionPageTopMenuQuery__
 *
 * To run a query within a React component, call `useSectionPageTopMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectionPageTopMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectionPageTopMenuQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useSectionPageTopMenuQuery(baseOptions?: Apollo.QueryHookOptions<ISectionPageTopMenuQuery, ISectionPageTopMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISectionPageTopMenuQuery, ISectionPageTopMenuQueryVariables>(SectionPageTopMenuDocument, options);
      }
export function useSectionPageTopMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISectionPageTopMenuQuery, ISectionPageTopMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISectionPageTopMenuQuery, ISectionPageTopMenuQueryVariables>(SectionPageTopMenuDocument, options);
        }
export type SectionPageTopMenuQueryHookResult = ReturnType<typeof useSectionPageTopMenuQuery>;
export type SectionPageTopMenuLazyQueryHookResult = ReturnType<typeof useSectionPageTopMenuLazyQuery>;
export type SectionPageTopMenuQueryResult = Apollo.QueryResult<ISectionPageTopMenuQuery, ISectionPageTopMenuQueryVariables>;
export const ServiceFromByUrlDocument = gql`
    query ServiceFromByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  formPage(url: $url, culture: $culture) {
    __typename
    form
    name
    url
    title
    subtitle
    id
    cover {
      content {
        contentTypeAlias
        ... on HeroVideoCover {
          ...HeroVideoCoverFragment
        }
      }
    }
    children {
      items {
        __typename
        id
        url
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useServiceFromByUrlQuery__
 *
 * To run a query within a React component, call `useServiceFromByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceFromByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceFromByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useServiceFromByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IServiceFromByUrlQuery, IServiceFromByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IServiceFromByUrlQuery, IServiceFromByUrlQueryVariables>(ServiceFromByUrlDocument, options);
      }
export function useServiceFromByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IServiceFromByUrlQuery, IServiceFromByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IServiceFromByUrlQuery, IServiceFromByUrlQueryVariables>(ServiceFromByUrlDocument, options);
        }
export type ServiceFromByUrlQueryHookResult = ReturnType<typeof useServiceFromByUrlQuery>;
export type ServiceFromByUrlLazyQueryHookResult = ReturnType<typeof useServiceFromByUrlLazyQuery>;
export type ServiceFromByUrlQueryResult = Apollo.QueryResult<IServiceFromByUrlQuery, IServiceFromByUrlQueryVariables>;
export const ServiceFromByIdDocument = gql`
    query ServiceFromById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  formPage(id: $id, culture: $culture) {
    __typename
    form
    name
    url
    title
    subtitle
    id
    cover {
      content {
        contentTypeAlias
        ... on HeroVideoCover {
          ...HeroVideoCoverFragment
        }
      }
    }
    children {
      items {
        __typename
        id
        url
      }
    }
  }
}
    ${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useServiceFromByIdQuery__
 *
 * To run a query within a React component, call `useServiceFromByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceFromByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceFromByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useServiceFromByIdQuery(baseOptions?: Apollo.QueryHookOptions<IServiceFromByIdQuery, IServiceFromByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IServiceFromByIdQuery, IServiceFromByIdQueryVariables>(ServiceFromByIdDocument, options);
      }
export function useServiceFromByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IServiceFromByIdQuery, IServiceFromByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IServiceFromByIdQuery, IServiceFromByIdQueryVariables>(ServiceFromByIdDocument, options);
        }
export type ServiceFromByIdQueryHookResult = ReturnType<typeof useServiceFromByIdQuery>;
export type ServiceFromByIdLazyQueryHookResult = ReturnType<typeof useServiceFromByIdLazyQuery>;
export type ServiceFromByIdQueryResult = Apollo.QueryResult<IServiceFromByIdQuery, IServiceFromByIdQueryVariables>;
export const SettingsDocument = gql`
    query Settings($culture: String, $imageFormat: ImageCropFormat) {
  allSettings(first: 1, culture: $culture) {
    items {
      ...SettingsFragment
      passwordValidation {
        content {
          __typename
          ... on ValidationElement {
            label
            regex
            __typename
          }
        }
      }
    }
  }
}
    ${SettingsFragmentFragmentDoc}
${FormPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ValidationElementFragmentFragmentDoc}`;

/**
 * __useSettingsQuery__
 *
 * To run a query within a React component, call `useSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ISettingsQuery, ISettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISettingsQuery, ISettingsQueryVariables>(SettingsDocument, options);
      }
export function useSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISettingsQuery, ISettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISettingsQuery, ISettingsQueryVariables>(SettingsDocument, options);
        }
export type SettingsQueryHookResult = ReturnType<typeof useSettingsQuery>;
export type SettingsLazyQueryHookResult = ReturnType<typeof useSettingsLazyQuery>;
export type SettingsQueryResult = Apollo.QueryResult<ISettingsQuery, ISettingsQueryVariables>;
export const SlideContentDocument = gql`
    query SlideContent($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  content(id: $id, culture: $culture) {
    ...MainContentListFragment
  }
}
    ${MainContentListFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${CollectionFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}
${VodItemFragmentFragmentDoc}
${RadioFragmentFragmentDoc}
${TopTenFragmentFragmentDoc}
${PodcastFragmentFragmentDoc}
${AuthorFragmentFragmentDoc}
${PodcastItemFragmentFragmentDoc}
${ContentEdgeFragmentFragmentDoc}
${PlaylistFragmentFragmentDoc}
${LiveEventFragmentFragmentDoc}
${ChannelFragmentFragmentDoc}
${NewsFragmentFragmentDoc}
${JobTrainingFragmentFragmentDoc}
${PartnerFragmentFragmentDoc}
${PartCourseFragmentFragmentDoc}
${CourseFragmentFragmentDoc}
${QuizzSurveyLiteFragmentFragmentDoc}
${QuizzSurveyCollectionLiteFragmentFragmentDoc}`;

/**
 * __useSlideContentQuery__
 *
 * To run a query within a React component, call `useSlideContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlideContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlideContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useSlideContentQuery(baseOptions?: Apollo.QueryHookOptions<ISlideContentQuery, ISlideContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISlideContentQuery, ISlideContentQueryVariables>(SlideContentDocument, options);
      }
export function useSlideContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISlideContentQuery, ISlideContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISlideContentQuery, ISlideContentQueryVariables>(SlideContentDocument, options);
        }
export type SlideContentQueryHookResult = ReturnType<typeof useSlideContentQuery>;
export type SlideContentLazyQueryHookResult = ReturnType<typeof useSlideContentLazyQuery>;
export type SlideContentQueryResult = Apollo.QueryResult<ISlideContentQuery, ISlideContentQueryVariables>;
export const AllSubscriptionDocument = gql`
    query AllSubscription($culture: String, $imageFormat: ImageCropFormat) {
  allSubscription(culture: $culture) {
    items {
      ... on Subscription {
        ...SubscriptionFragment
      }
    }
  }
}
    ${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useAllSubscriptionQuery__
 *
 * To run a query within a React component, call `useAllSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSubscriptionQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useAllSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<IAllSubscriptionQuery, IAllSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAllSubscriptionQuery, IAllSubscriptionQueryVariables>(AllSubscriptionDocument, options);
      }
export function useAllSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAllSubscriptionQuery, IAllSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAllSubscriptionQuery, IAllSubscriptionQueryVariables>(AllSubscriptionDocument, options);
        }
export type AllSubscriptionQueryHookResult = ReturnType<typeof useAllSubscriptionQuery>;
export type AllSubscriptionLazyQueryHookResult = ReturnType<typeof useAllSubscriptionLazyQuery>;
export type AllSubscriptionQueryResult = Apollo.QueryResult<IAllSubscriptionQuery, IAllSubscriptionQueryVariables>;
export const MemberSubscriptionDocument = gql`
    query MemberSubscription($memberId: String, $imageFormat: ImageCropFormat) {
  allSubscriptionData(where: {name: $memberId}) {
    __typename
    items {
      __typename
      ... on SubscriptionData {
        ...SubscriptionDataFragment
      }
    }
  }
}
    ${SubscriptionDataFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useMemberSubscriptionQuery__
 *
 * To run a query within a React component, call `useMemberSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberSubscriptionQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useMemberSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<IMemberSubscriptionQuery, IMemberSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMemberSubscriptionQuery, IMemberSubscriptionQueryVariables>(MemberSubscriptionDocument, options);
      }
export function useMemberSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMemberSubscriptionQuery, IMemberSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMemberSubscriptionQuery, IMemberSubscriptionQueryVariables>(MemberSubscriptionDocument, options);
        }
export type MemberSubscriptionQueryHookResult = ReturnType<typeof useMemberSubscriptionQuery>;
export type MemberSubscriptionLazyQueryHookResult = ReturnType<typeof useMemberSubscriptionLazyQuery>;
export type MemberSubscriptionQueryResult = Apollo.QueryResult<IMemberSubscriptionQuery, IMemberSubscriptionQueryVariables>;
export const ThankYouPageByIdDocument = gql`
    query ThankYouPageById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  thankYouPage(id: $id, culture: $culture) {
    ...ThankYouPageFragment
  }
}
    ${ThankYouPageFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${ButtonFragmentFragmentDoc}
${InternalLinkFragmentFragmentDoc}
${ContentLinkFragmentFragmentDoc}
${ContentRestrictedCountriesFragmentDoc}
${ExternalLinkFragmentFragmentDoc}`;

/**
 * __useThankYouPageByIdQuery__
 *
 * To run a query within a React component, call `useThankYouPageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useThankYouPageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThankYouPageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useThankYouPageByIdQuery(baseOptions?: Apollo.QueryHookOptions<IThankYouPageByIdQuery, IThankYouPageByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IThankYouPageByIdQuery, IThankYouPageByIdQueryVariables>(ThankYouPageByIdDocument, options);
      }
export function useThankYouPageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IThankYouPageByIdQuery, IThankYouPageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IThankYouPageByIdQuery, IThankYouPageByIdQueryVariables>(ThankYouPageByIdDocument, options);
        }
export type ThankYouPageByIdQueryHookResult = ReturnType<typeof useThankYouPageByIdQuery>;
export type ThankYouPageByIdLazyQueryHookResult = ReturnType<typeof useThankYouPageByIdLazyQuery>;
export type ThankYouPageByIdQueryResult = Apollo.QueryResult<IThankYouPageByIdQuery, IThankYouPageByIdQueryVariables>;
export const TranslationContextDocument = gql`
    query TranslationContext($context: String, $culture: String) {
  allTranslationContext(where: {name: $context}, culture: $culture) {
    items {
      name
      id
      children {
        items {
          ... on TranslationItem {
            ...TranslationItemFragment
          }
        }
      }
    }
  }
}
    ${TranslationItemFragmentFragmentDoc}`;

/**
 * __useTranslationContextQuery__
 *
 * To run a query within a React component, call `useTranslationContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationContextQuery({
 *   variables: {
 *      context: // value for 'context'
 *      culture: // value for 'culture'
 *   },
 * });
 */
export function useTranslationContextQuery(baseOptions?: Apollo.QueryHookOptions<ITranslationContextQuery, ITranslationContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ITranslationContextQuery, ITranslationContextQueryVariables>(TranslationContextDocument, options);
      }
export function useTranslationContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ITranslationContextQuery, ITranslationContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ITranslationContextQuery, ITranslationContextQueryVariables>(TranslationContextDocument, options);
        }
export type TranslationContextQueryHookResult = ReturnType<typeof useTranslationContextQuery>;
export type TranslationContextLazyQueryHookResult = ReturnType<typeof useTranslationContextLazyQuery>;
export type TranslationContextQueryResult = Apollo.QueryResult<ITranslationContextQuery, ITranslationContextQueryVariables>;
export const TranslationContextCheckDocument = gql`
    query TranslationContextCheck($context: String) {
  allTranslationContext(where: {name: $context}) {
    items {
      name
      id
    }
  }
}
    `;

/**
 * __useTranslationContextCheckQuery__
 *
 * To run a query within a React component, call `useTranslationContextCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationContextCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationContextCheckQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useTranslationContextCheckQuery(baseOptions?: Apollo.QueryHookOptions<ITranslationContextCheckQuery, ITranslationContextCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ITranslationContextCheckQuery, ITranslationContextCheckQueryVariables>(TranslationContextCheckDocument, options);
      }
export function useTranslationContextCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ITranslationContextCheckQuery, ITranslationContextCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ITranslationContextCheckQuery, ITranslationContextCheckQueryVariables>(TranslationContextCheckDocument, options);
        }
export type TranslationContextCheckQueryHookResult = ReturnType<typeof useTranslationContextCheckQuery>;
export type TranslationContextCheckLazyQueryHookResult = ReturnType<typeof useTranslationContextCheckLazyQuery>;
export type TranslationContextCheckQueryResult = Apollo.QueryResult<ITranslationContextCheckQuery, ITranslationContextCheckQueryVariables>;
export const TranslationItemByNameDocument = gql`
    query TranslationItemByName($name: String) {
  allTranslationItem(where: {name: $name}) {
    items {
      ...TranslationItemFragment
    }
  }
}
    ${TranslationItemFragmentFragmentDoc}`;

/**
 * __useTranslationItemByNameQuery__
 *
 * To run a query within a React component, call `useTranslationItemByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationItemByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationItemByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTranslationItemByNameQuery(baseOptions?: Apollo.QueryHookOptions<ITranslationItemByNameQuery, ITranslationItemByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ITranslationItemByNameQuery, ITranslationItemByNameQueryVariables>(TranslationItemByNameDocument, options);
      }
export function useTranslationItemByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ITranslationItemByNameQuery, ITranslationItemByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ITranslationItemByNameQuery, ITranslationItemByNameQueryVariables>(TranslationItemByNameDocument, options);
        }
export type TranslationItemByNameQueryHookResult = ReturnType<typeof useTranslationItemByNameQuery>;
export type TranslationItemByNameLazyQueryHookResult = ReturnType<typeof useTranslationItemByNameLazyQuery>;
export type TranslationItemByNameQueryResult = Apollo.QueryResult<ITranslationItemByNameQuery, ITranslationItemByNameQueryVariables>;
export const GetTutorialDocument = gql`
    query GetTutorial($culture: String, $imageFormat: ImageCropFormat) {
  allSettings(first: 1, culture: $culture) {
    items {
      id
      __typename
      tutorialSlides {
        content {
          ... on TutorialSlide {
            ...TutorialSlideFragment
          }
        }
      }
    }
  }
}
    ${TutorialSlideFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}`;

/**
 * __useGetTutorialQuery__
 *
 * To run a query within a React component, call `useGetTutorialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTutorialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTutorialQuery({
 *   variables: {
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useGetTutorialQuery(baseOptions?: Apollo.QueryHookOptions<IGetTutorialQuery, IGetTutorialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetTutorialQuery, IGetTutorialQueryVariables>(GetTutorialDocument, options);
      }
export function useGetTutorialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetTutorialQuery, IGetTutorialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetTutorialQuery, IGetTutorialQueryVariables>(GetTutorialDocument, options);
        }
export type GetTutorialQueryHookResult = ReturnType<typeof useGetTutorialQuery>;
export type GetTutorialLazyQueryHookResult = ReturnType<typeof useGetTutorialLazyQuery>;
export type GetTutorialQueryResult = Apollo.QueryResult<IGetTutorialQuery, IGetTutorialQueryVariables>;
export const VodItemByUrlDocument = gql`
    query VodItemByUrl($url: String, $culture: String, $imageFormat: ImageCropFormat) {
  vODItem(url: $url, culture: $culture) {
    ...VODItemFragment
  }
}
    ${VodItemFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useVodItemByUrlQuery__
 *
 * To run a query within a React component, call `useVodItemByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useVodItemByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVodItemByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useVodItemByUrlQuery(baseOptions?: Apollo.QueryHookOptions<IVodItemByUrlQuery, IVodItemByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IVodItemByUrlQuery, IVodItemByUrlQueryVariables>(VodItemByUrlDocument, options);
      }
export function useVodItemByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IVodItemByUrlQuery, IVodItemByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IVodItemByUrlQuery, IVodItemByUrlQueryVariables>(VodItemByUrlDocument, options);
        }
export type VodItemByUrlQueryHookResult = ReturnType<typeof useVodItemByUrlQuery>;
export type VodItemByUrlLazyQueryHookResult = ReturnType<typeof useVodItemByUrlLazyQuery>;
export type VodItemByUrlQueryResult = Apollo.QueryResult<IVodItemByUrlQuery, IVodItemByUrlQueryVariables>;
export const VodItemByIdDocument = gql`
    query VodItemById($id: ID, $culture: String, $imageFormat: ImageCropFormat) {
  vODItem(id: $id, culture: $culture) {
    ...VODItemFragment
  }
}
    ${VodItemFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useVodItemByIdQuery__
 *
 * To run a query within a React component, call `useVodItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVodItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVodItemByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useVodItemByIdQuery(baseOptions?: Apollo.QueryHookOptions<IVodItemByIdQuery, IVodItemByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IVodItemByIdQuery, IVodItemByIdQueryVariables>(VodItemByIdDocument, options);
      }
export function useVodItemByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IVodItemByIdQuery, IVodItemByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IVodItemByIdQuery, IVodItemByIdQueryVariables>(VodItemByIdDocument, options);
        }
export type VodItemByIdQueryHookResult = ReturnType<typeof useVodItemByIdQuery>;
export type VodItemByIdLazyQueryHookResult = ReturnType<typeof useVodItemByIdLazyQuery>;
export type VodItemByIdQueryResult = Apollo.QueryResult<IVodItemByIdQuery, IVodItemByIdQueryVariables>;
export const VodItemByUrlEndDocument = gql`
    query VodItemByUrlEnd($endUrl: String, $culture: String, $imageFormat: ImageCropFormat) {
  allVODItem(where: {url_ends_with: $endUrl}, culture: $culture, first: 1) {
    items {
      ...VODItemFragment
    }
  }
}
    ${VodItemFragmentFragmentDoc}
${ContentItemsFragmentFragmentDoc}
${HeroVideoCoverFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}
${PaywallFragmentFragmentDoc}
${PaywallPreviewFragmentFragmentDoc}
${AdvantagesListFragmentFragmentDoc}
${AdvantageFragmentFragmentDoc}
${ServicesListFragmentFragmentDoc}
${ServiceFragmentFragmentDoc}
${SubscriptionsListFragmentFragmentDoc}
${ContentTagFragmentFragmentDoc}
${ParentInfoFragmentDoc}`;

/**
 * __useVodItemByUrlEndQuery__
 *
 * To run a query within a React component, call `useVodItemByUrlEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useVodItemByUrlEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVodItemByUrlEndQuery({
 *   variables: {
 *      endUrl: // value for 'endUrl'
 *      culture: // value for 'culture'
 *      imageFormat: // value for 'imageFormat'
 *   },
 * });
 */
export function useVodItemByUrlEndQuery(baseOptions?: Apollo.QueryHookOptions<IVodItemByUrlEndQuery, IVodItemByUrlEndQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IVodItemByUrlEndQuery, IVodItemByUrlEndQueryVariables>(VodItemByUrlEndDocument, options);
      }
export function useVodItemByUrlEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IVodItemByUrlEndQuery, IVodItemByUrlEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IVodItemByUrlEndQuery, IVodItemByUrlEndQueryVariables>(VodItemByUrlEndDocument, options);
        }
export type VodItemByUrlEndQueryHookResult = ReturnType<typeof useVodItemByUrlEndQuery>;
export type VodItemByUrlEndLazyQueryHookResult = ReturnType<typeof useVodItemByUrlEndLazyQuery>;
export type VodItemByUrlEndQueryResult = Apollo.QueryResult<IVodItemByUrlEndQuery, IVodItemByUrlEndQueryVariables>;